webpackJsonp([3,1],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vue_scroll = __webpack_require__(849);
	
	var _vue_scroll2 = _interopRequireDefault(_vue_scroll);
	
	var _vueRouter = __webpack_require__(848);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _App = __webpack_require__(809);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Welcome = __webpack_require__(819);
	
	var _Welcome2 = _interopRequireDefault(_Welcome);
	
	var _NoticeDetail = __webpack_require__(813);
	
	var _NoticeDetail2 = _interopRequireDefault(_NoticeDetail);
	
	var _ArticleDetail = __webpack_require__(810);
	
	var _ArticleDetail2 = _interopRequireDefault(_ArticleDetail);
	
	var _MyNoticeDetail = __webpack_require__(844);
	
	var _MyNoticeDetail2 = _interopRequireDefault(_MyNoticeDetail);
	
	var _QaNoticeDetail = __webpack_require__(845);
	
	var _QaNoticeDetail2 = _interopRequireDefault(_QaNoticeDetail);
	
	var _vueConfig = __webpack_require__(766);
	
	var _vueConfig2 = _interopRequireDefault(_vueConfig);
	
	var _Result = __webpack_require__(816);
	
	var _Result2 = _interopRequireDefault(_Result);
	
	var _Search = __webpack_require__(817);
	
	var _Search2 = _interopRequireDefault(_Search);
	
	var _AdvSearch = __webpack_require__(814);
	
	var _AdvSearch2 = _interopRequireDefault(_AdvSearch);
	
	var _Limit = __webpack_require__(815);
	
	var _Limit2 = _interopRequireDefault(_Limit);
	
	var _MyArticleDetail = __webpack_require__(811);
	
	var _MyArticleDetail2 = _interopRequireDefault(_MyArticleDetail);
	
	var _eventMessage = __webpack_require__(841);
	
	var _eventMessage2 = _interopRequireDefault(_eventMessage);
	
	var _newMessage = __webpack_require__(843);
	
	var _newMessage2 = _interopRequireDefault(_newMessage);
	
	var _MySubscribe = __webpack_require__(812);
	
	var _MySubscribe2 = _interopRequireDefault(_MySubscribe);
	
	var _finance = __webpack_require__(842);
	
	var _finance2 = _interopRequireDefault(_finance);
	
	var _StockPledge = __webpack_require__(840);
	
	var _StockPledge2 = _interopRequireDefault(_StockPledge);
	
	var _App3 = __webpack_require__(820);
	
	var _App4 = _interopRequireDefault(_App3);
	
	var _BaseInfo = __webpack_require__(821);
	
	var _BaseInfo2 = _interopRequireDefault(_BaseInfo);
	
	var _GaoGuan = __webpack_require__(825);
	
	var _GaoGuan2 = _interopRequireDefault(_GaoGuan);
	
	var _Invest = __webpack_require__(829);
	
	var _Invest2 = _interopRequireDefault(_Invest);
	
	var _GuDongTop = __webpack_require__(826);
	
	var _GuDongTop2 = _interopRequireDefault(_GuDongTop);
	
	var _ShareChange = __webpack_require__(836);
	
	var _ShareChange2 = _interopRequireDefault(_ShareChange);
	
	var _Product = __webpack_require__(835);
	
	var _Product2 = _interopRequireDefault(_Product);
	
	var _Industry = __webpack_require__(827);
	
	var _Industry2 = _interopRequireDefault(_Industry);
	
	var _Location = __webpack_require__(832);
	
	var _Location2 = _interopRequireDefault(_Location);
	
	var _Customer = __webpack_require__(822);
	
	var _Customer2 = _interopRequireDefault(_Customer);
	
	var _Supplier = __webpack_require__(838);
	
	var _Supplier2 = _interopRequireDefault(_Supplier);
	
	var _StockTops = __webpack_require__(837);
	
	var _StockTops2 = _interopRequireDefault(_StockTops);
	
	var _LargeexChange = __webpack_require__(830);
	
	var _LargeexChange2 = _interopRequireDefault(_LargeexChange);
	
	var _TradeInfo = __webpack_require__(839);
	
	var _TradeInfo2 = _interopRequireDefault(_TradeInfo);
	
	var _Finance = __webpack_require__(823);
	
	var _Finance2 = _interopRequireDefault(_Finance);
	
	var _Fzb = __webpack_require__(824);
	
	var _Fzb2 = _interopRequireDefault(_Fzb);
	
	var _Lrb = __webpack_require__(833);
	
	var _Lrb2 = _interopRequireDefault(_Lrb);
	
	var _Llb = __webpack_require__(831);
	
	var _Llb2 = _interopRequireDefault(_Llb);
	
	var _Performance = __webpack_require__(834);
	
	var _Performance2 = _interopRequireDefault(_Performance);
	
	var _IndustryCompare = __webpack_require__(828);
	
	var _IndustryCompare2 = _interopRequireDefault(_IndustryCompare);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var configs = {
	  host: {
	    download: 'fs.ibdata.cn',
	    batchdownload: 'fs.ibdata.cn:9007',
	    mobile: 'wx.ibdata.cn',
	    bind: 'www.ibdata.cn' },
	  weixin: {
	    appid: 'wxb762b2313cbea358' }
	};
	_vue2.default.use(_vueConfig2.default, configs);
	
	var ajax = $.ajax;
	$.ajax = function (opt) {
	  var fn = {
	    success: function success(data, textStatus, jqXHR) {}
	  };
	  if (opt.success) {
	    fn.success = opt.success;
	  }
	  var def = ajax.call($, opt);
	  console.log(opt);
	  if ('done' in def) {
	    console.log(def);
	    if (opt.url.indexOf('profile') < 0 && opt.url.indexOf('taglist') < 0 && opt.url.indexOf('keywords') < 0) {
	      var done = def.done;
	      def.done = function (func) {
	        function _done(data) {
	          if (data.status === '403') {
	            alert('登录已过期，请重新登录');
	            setTimeout(function () {
	              window.location.reload();
	            }, 1000);
	            return;
	          }
	          if (data.status === '401') {
	            window.location.href = '/#!/limit?typ=1';
	            return;
	          }
	          if (data.status === '402') {
	            window.location.href = '/#!/limit?typ=2';
	            return;
	          }
	          func(data);
	        }
	
	        done.call(def, _done);
	        return def;
	      };
	    }
	  }
	  return def;
	};
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_vue_scroll2.default);
	
	_vue2.default.filter('maxlen', function (value, len) {
	  if (value.length > len) {
	    return value.substr(0, len) + '...';
	  }
	  return value;
	});
	
	_vue2.default.filter('trim', function (value) {
	  return value.trim();
	});
	
	_vue2.default.filter('time', function (t) {
	  if (t) {
	    var a = t.replace('T', ' ');
	    var n = a.substr(0, 16);
	    return n;
	  }
	});
	
	_vue2.default.filter('money', function (z) {
	  if (!z) {
	    return z;
	  } else {
	    var num = z.toString();
	    var normdata = '';
	    if (num.indexOf('.') !== -1) {
	      normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
	        return $1 + ",";
	      });
	    } else {
	      normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function ($0, $1) {
	        return $1 + ",";
	      });
	    }
	    if (normdata.indexOf('.') >= 0) {
	      var arr = normdata.split('.');
	      if (arr[1].length < 2) {
	        return normdata + '0';
	      } else {
	        return normdata.substr(0, normdata.indexOf('.') + 3);
	      }
	    } else {
	      return normdata;
	    }
	  }
	});
	_vue2.default.filter('date', function (value) {
	  var d = value.substr(0, 10);
	  return d;
	});
	_vue2.default.filter('percent', function (num) {
	  if (!num) {
	    return num;
	  } else {
	    num = parseFloat(num);
	    return num.toFixed(2);
	  }
	});
	
	var router = new _vueRouter2.default();
	
	router.map({
	  '/': {
	    name: 'WelcomeView',
	    component: _Welcome2.default
	  },
	  '/notice/detail': {
	    name: 'NoticeDetailView',
	    component: _NoticeDetail2.default
	  },
	  '/article-detail/:id': {
	    name: 'ArticleDetailView',
	    component: _ArticleDetail2.default
	  },
	  '/notice-detail/:id': {
	    name: 'NoticeView',
	    component: _MyNoticeDetail2.default
	  },
	  '/eventmsg/:id': {
	    name: 'EventMessage',
	    component: _eventMessage2.default
	  },
	  '/newmessage': {
	    name: 'NewMessage',
	    component: _newMessage2.default
	  },
	  '/mysubscribe': {
	    name: 'MySubscribe',
	    component: _MySubscribe2.default
	  },
	  '/qaview/:id': {
	    name: 'QaDetailView',
	    component: _QaNoticeDetail2.default
	  },
	  '/search': {
	    name: 'SearchView',
	    component: _Search2.default
	  },
	  '/result': {
	    name: 'ResultView',
	    component: _Result2.default
	  },
	  '/advsearch': {
	    name: 'AdvSearchView',
	    component: _AdvSearch2.default
	  },
	  '/limit': {
	    name: 'LimitView',
	    component: _Limit2.default
	  },
	  '/myarticle/:id': {
	    name: 'MyArticleDetailView',
	    component: _MyArticleDetail2.default
	  },
	  '/financedetail': {
	    name: 'FinanceDetail',
	    component: _finance2.default
	  },
	  '/stockpledge': {
	    name: 'StockPledgeView',
	    component: _StockPledge2.default
	  },
	  '/company': {
	    name: 'companyApp',
	    component: _App4.default,
	    subRoutes: {
	      '/': {
	        name: 'companyBaseInfo',
	        component: _BaseInfo2.default
	      },
	      '/gaoguan': {
	        name: 'companyGaoGuan',
	        component: _GaoGuan2.default
	      },
	      '/invest': {
	        name: 'companyInvest',
	        component: _Invest2.default
	      },
	      '/topten': {
	        name: 'companyTopTenGuDong',
	        component: _GuDongTop2.default
	      },
	      '/sharechange': {
	        name: 'companyShareChange',
	        component: _ShareChange2.default
	      },
	      '/mainproduct': {
	        name: 'companyMainProduct',
	        component: _Product2.default
	      },
	      '/mainindustry': {
	        name: 'companyMainIndustry',
	        component: _Industry2.default
	      },
	      '/mainlocation': {
	        name: 'companyMainLocation',
	        component: _Location2.default
	      },
	      '/customer': {
	        name: 'companyCustomer',
	        component: _Customer2.default
	      },
	      '/supplier': {
	        name: 'companySupplier',
	        component: _Supplier2.default
	      },
	      '/stocktops': {
	        name: 'companyStockTop',
	        component: _StockTops2.default
	      },
	      '/largeexchange': {
	        name: 'companyLargeexChange',
	        component: _LargeexChange2.default
	      },
	      '/tradeinfo': {
	        name: 'companyTradeInfo',
	        component: _TradeInfo2.default
	      },
	      '/finance': {
	        name: 'companyFiance',
	        component: _Finance2.default
	      },
	      '/fzb': {
	        name: 'companyFzb',
	        component: _Fzb2.default
	      },
	      '/lrb': {
	        name: 'companyLrb',
	        component: _Lrb2.default
	      },
	      '/llb': {
	        name: 'companyLlb',
	        component: _Llb2.default
	      },
	      '/performance': {
	        name: 'companyPerformance',
	        component: _Performance2.default
	      },
	      '/industryCompare': {
	        name: 'companyIndustryCompare',
	        component: _IndustryCompare2.default
	      }
	    }
	  }
	});
	
	router.start(_App2.default, 'app');

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.confirm = undefined;
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.apiUrl = apiUrl;
	exports.alert = alert;
	exports.dateFormat = dateFormat;
	exports.isEmptyObj = isEmptyObj;
	exports.downloadURL = downloadURL;
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _Alert = __webpack_require__(846);
	
	var _Alert2 = _interopRequireDefault(_Alert);
	
	var _Confirm = __webpack_require__(847);
	
	var _Confirm2 = _interopRequireDefault(_Confirm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function apiUrl(url) {
	  return '/api' + url;
	}
	
	function alert(msg) {
	  var AlertIns = _vue2.default.extend(_Alert2.default);
	  var alert = new AlertIns({
	    el: document.createElement('div'),
	    data: function data() {
	      return {
	        message: msg,
	        showflag: true
	      };
	    },
	
	    methods: {
	      close: function close() {
	        alert.$remove();
	      }
	    }
	  });
	  alert.$appendTo(document.body);
	}
	
	function confirm(msg, _ok) {
	  var ConfirmIns = _vue2.default.extend(_Confirm2.default);
	  var ins = new ConfirmIns({
	    el: document.createElement('div'),
	    data: function data() {
	      return {
	        message: msg,
	        showflag: true
	      };
	    },
	
	    methods: {
	      ok: function ok() {
	        if (typeof _ok === 'function') {
	          _ok();
	          ins.$remove();
	        }
	      },
	      cancel: function cancel() {
	        ins.$remove();
	      }
	    }
	  });
	  ins.$appendTo(document.body);
	}
	
	exports.confirm = confirm;
	function dateFormat(date, format) {
	  var o = {
	    'M+': date.getMonth() + 1,
	    'd+': date.getDate(),
	    'h+': date.getHours(),
	    'm+': date.getMinutes(),
	    's+': date.getSeconds(),
	    'q+': Math.floor((date.getMonth() + 3) / 3),
	    'S': date.getMilliseconds()
	  };
	  if (/(y+)/.test(format)) {
	    format = format.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
	  }
	  for (var k in o) {
	    if (new RegExp('(' + k + ')').test(format)) {
	      format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
	    }
	  }
	  return format;
	}
	
	function isEmptyObj(obj) {
	  if ((0, _keys2.default)(obj).length > 0) {
	    return false;
	  }
	  return true;
	}
	
	function downloadURL(url, name) {
	  var link = document.createElement("a");
	  link.download = name;
	  link.href = url;
	  document.body.appendChild(link);
	  link.click();
	  document.body.removeChild(link);
	}

/***/ },
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _VipDialog = __webpack_require__(818);
	
	var _VipDialog2 = _interopRequireDefault(_VipDialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      currentuser: null,
	      shareUsername: '',
	      uid: null,
	      xnName: null,
	      company: null,
	      position: null,
	      headUrl: null,
	      showUserInfo: false
	    };
	  },
	
	  methods: {
	    getProfile: function getProfile(share) {
	      var _this = this;
	
	      var shared = void 0;
	      if (share != 'weixin') {
	        shared = share.share;
	        console.log(share);
	        if (!share.showuserinfo || share.showuserinfo == 0) {
	          this.showUserInfo = false;
	        } else {
	          this.showUserInfo = true;
	        }
	      } else {
	        shared = share;
	      }
	      console.log('分享出去的信息');
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/profile'),
	        method: 'post',
	        dataType: 'json',
	        async: false
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this.currentuser = response.data;
	          if (share != 'weixin') {
	            console.log('获取用户信息');
	            _this.uid = share.uid;
	            _this.userInfo(_this.uid);
	          }
	          _this.shareUsername = response.data.username;
	          _this.currentRegtyp = response.data.regtyp;
	          if (response.data.regtyp === 4) {
	            _this.showTipGoBind();
	          }
	        }
	        if (response.status === 403 && shared === 'weixin') {
	          var appid = _this.$config.weixin.appid;
	          var redirectUri = encodeURIComponent(window.location.href);
	          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
	        }
	      }).fail(function (response) {
	        console.log('请求失败');
	      });
	    },
	
	    userInfo: function userInfo(id) {
	      var _this2 = this;
	
	      var query = {};
	      query.uid = id;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/userinfo'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        var info = response.data;
	        _this2.company = info.company;
	        _this2.position = info.title;
	        _this2.headUrl = info.headimgurl;
	        if (info.realname) {
	          _this2.xnName = info.realname;
	          return false;
	        } else if (info.wx_nickname) {
	          _this2.xnName = info.wx_nickname;
	          return false;
	        }
	      });
	    },
	    logout: function logout() {
	      var _this3 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/logout'),
	        method: 'post',
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this3.$route.router.go('/login');
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    checkAction: function checkAction(code) {
	      if (this.currentuser) {
	        var flag = false;
	        for (var i = 0; i < this.currentuser.actions.length; i++) {
	          if (this.currentuser.actions[i] == code) {
	            flag = true;
	            break;
	          }
	        }
	        return flag;
	      } else {
	        return true;
	      }
	    },
	    checkPrivilege: function checkPrivilege(code, message) {
	      if (!this.checkAction(code)) {
	        var Ins = _vue2.default.extend(_VipDialog2.default);
	        var ins = new Ins({
	          el: document.createElement('div'),
	          data: function data() {
	            return {
	              message: message,
	              showflag: true,
	              currentuser: this.currentuser
	            };
	          },
	
	          methods: {
	            close: function close(event) {
	              ins.$remove();
	            }
	          }
	        });
	        ins.$appendTo(document.body);
	        return false;
	      } else {
	        return true;
	      }
	    }
	  }
	};

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(106);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_companyMix2.default],
	  data: function data() {
	    return {
	      params: {},
	      wxcode: '',
	      tcode: '',
	      stype: '',
	      fulltitle: '',
	      diysharedesc: '' };
	  },
	
	  methods: {
	    wxlogin: function wxlogin(wxcode) {
	      var _this = this;
	
	      var query = { 'code': wxcode };
	      console.log("wxlogin登陆上传的query");
	      console.log(query);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/wxlogin'),
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          console.log('微信登陆');
	          console.log('window.location:' + window.location);
	          console.log(window.location.hash);
	
	          console.log('window.location.hash.split(?code=)[0]:输出hash的split');
	          console.log(window.location.hash.split('?code=')[0]);
	          console.log('window.location.hash.split(&companycode=)[1]输出companycode的split');
	          console.log(window.location.hash.split('&companycode=')[1]);
	          if (window.location.hash.indexOf('#!/company') >= 0) {
	            window.location.href = window.location.origin + '/' + window.location.hash.split('?code=')[0] + '?companycode=' + window.location.hash.split('&companycode=')[1];
	          } else {
	            var _location = window.location;
	            window.location.href = _location.origin + '/#!' + _location.href.split('#!')[1];
	            _this.showguide = true;
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getwxsign: function getwxsign() {
	      var _this2 = this;
	
	      var query = {};
	      query.url = window.location.href.split('#')[0];
	      console.log('微信签名query的url');
	      console.log(query.url);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/getwxsign'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          var data = response.data;
	          console.log(123131);
	          console.log(_this2.currentuser);
	
	          wx.config({
	            debug: false,
	            appId: _this2.$config.weixin.appid,
	            timestamp: data.timestamp,
	            nonceStr: data.nonceStr,
	            signature: data.signature,
	            jsApiList: ['checkJsApi', 'onMenuShareAppMessage', 'onMenuShareTimeline']
	          });
	          console.log('>> 微信签名 ok~');
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getNoticeShareDesc: function getNoticeShareDesc(stype, id) {
	      console.log('>获取描述');
	
	      var desc = '';
	      if (id === '' || id === undefined) {
	        desc = '你可以点击查看详情...';
	        return desc;
	      }
	
	      if (stype === '1' || stype === '2' || stype === '3') {
	        console.log('A股新三板');
	
	        var _desc = '';
	        var nodeName = '';
	        if (document.getElementById(id)) {
	          nodeName = document.getElementById(id).nodeName;
	          if (nodeName === 'P') {
	            _desc = document.getElementById(id).innerText;
	          }
	          if (nodeName === 'DIV') {
	            var div = document.getElementById(id);
	            var firstNode = div.firstElementChild;
	            if (firstNode.nodeName === 'P') {
	              _desc = firstNode.innerText;
	            }
	
	            if (firstNode.nodeName === 'TABLE') {
	              var idChildNode = document.getElementById(id).childNodes;
	              for (var i = 0; i < idChildNode.length; i++) {
	                if (idChildNode[i].nodeName === 'P') {
	                  _desc = idChildNode[i].innerHTML;
	                }
	              }
	            }
	          }
	        }
	
	        if (_desc !== '') {
	          if (_desc.length > 50) {
	            desc = _desc.replace(/(^\s*)|(\s*$)/g, '').substr(0, 49) + '...';
	          } else {
	            desc = _desc.replace(/(^\s*)|(\s*$)/g, '');
	          }
	        } else {
	          desc = '你可以点击查看详情...';
	        }
	
	        if (desc === '') {
	          desc = '你可以点击查看详情...';
	        }
	      }
	
	      if (stype === '5') {
	        console.log('问题库');
	
	        var que = '';
	        var _nodeName = '';
	        if (document.getElementById(id)) {
	          _nodeName = document.getElementById(id).nodeName;
	          if (_nodeName === 'P') {
	            que = document.getElementById(id).innerHTML;
	          }
	          if (_nodeName === 'TD') {
	            var td = document.getElementById(id);
	
	            var qCont = td.lastElementChild;
	            var queEle = qCont.firstElementChild;
	            var queText = queEle.innerText;
	            que = queText;
	          }
	        }
	
	        if (que !== '') {
	          if (que.length > 50) {
	            desc = que.replace(/(^\s*)|(\s*$)/g, '').substr(0, 49) + '...';
	          } else {
	            desc = que.replace(/(^\s*)|(\s*$)/g, '');
	          }
	        } else {
	          desc = '你可以点击查看详情...';
	        }
	
	        if (desc === '') {
	          desc = '你可以点击查看详情...';
	        }
	      }
	      console.log(desc);
	      return desc;
	    },
	    shareNotice: function shareNotice(stype, id, fulltitle, desc) {
	      var title = fulltitle;
	      var shareId = id.toString();
	      var shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	      var href = window.location.href;
	      var shareLink = '';
	
	      href = this.changeUrlArg(href, 'uid', this.uid);
	      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
	
	      if (id != 'undefined') {
	        console.log('tcode:' + id);
	      }
	      shareLink = href;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    },
	    getResultShareDesc: function getResultShareDesc() {
	      console.log('分享描述');
	      var sharetitle = '你的朋友' + this.shareUsername + '通过IBDATA给你分享了一份他的独家数据！';
	      return sharetitle;
	    },
	    getResultShareTitle: function getResultShareTitle() {
	      var desc = '';
	      if (this.keywords.length > 0) {
	        if (!this.diysharedesc) {
	          var stype = this.stype;
	          if (stype === 1) {
	            this.stypename = 'A股';
	          } else if (stype === 2) {
	            this.stypename = '新三板';
	          } else if (stype === 3) {
	            this.stypename = '债券';
	          } else if (stype === 4) {
	            this.stypename = '知识库';
	          } else if (stype === 5) {
	            this.stypename = '问题库';
	          } else if (stype === 6) {
	            this.stypename = '港股';
	          } else if (stype === 7) {
	            this.stypename = '法院公告';
	          } else if (stype === 8) {
	            this.stypename = '裁判文书';
	          } else if (stype === 9) {
	            this.stypename = '政府公告';
	          } else {
	            this.stypename = stype;
	          }
	          desc = this.stypename + '-' + this.keywords;
	        } else {
	          desc = this.diysharedesc;
	        }
	      } else {
	        if (this.diysharedesc) {
	          desc = this.diysharedesc;
	        } else {
	          desc = document.title;
	        }
	      }
	      return desc;
	    },
	    shareResult: function shareResult(fulltitle, desc) {
	      var title = fulltitle;
	      var shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	      var href = window.location.href;
	      var shareLink = '';
	
	      href = this.changeUrlArg(href, 'uid', this.uid);
	      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
	      shareLink = href;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    },
	    shareSearch: function shareSearch(fulltitle, desc) {
	      var title = fulltitle;
	      var shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	      var href = window.location.href;
	      var shareLink = '';
	
	      if (href.indexOf('uid') > 0 && href.indexOf('ruid') > 0 && href.indexOf('sid') > 0) {
	        href = this.changeUrlArg(href, 'uid', this.uid);
	        href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
	        if (window.location.href.indexOf('search?ai=') > 0) {
	          console.log('go  result');
	          shareLink = href.split('search?')[0] + 'result?' + href.split('search?')[1];
	        }
	        if (window.location.href.indexOf('search=true') > 0) {
	          shareLink = href;
	        }
	        console.log('no sharelink');
	        console.log(shareLink);
	      } else {
	        var ts = this.getTimeStamp();
	        this.params.ts = ts;
	        href = href + '&uid=' + this.uid + '&ruid=0' + '&plat=mobile' + '&ts=' + ts;
	        if (window.location.href.indexOf('search=true') > 0) {
	          shareLink = this.getShareLink(href, 'search');
	        }
	        if (window.location.href.indexOf('search?ai=') > 0) {
	          console.log('go  result');
	          shareLink = this.getShareLink(href, 'result');
	        }
	      }
	      console.log('>>> shareLink');
	      console.log(shareLink);
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    },
	    shareStatus: function shareStatus(sid, status) {
	      if (!sid) {
	        return false;
	      }
	
	      var query = {};
	      query.sid = sid;
	      query.status = status;
	      console.log('shareStatus');
	      console.log(query);
	      if (sid != 'undefined') {
	        _jquery2.default.ajax({
	          url: (0, _helper.apiUrl)('/V1.0.0/user/updshare'),
	          method: 'post',
	          dataType: 'json',
	          data: (0, _stringify2.default)(query),
	          async: false
	        }).done(function (response) {
	          if (response.status === 0) {
	            console.log(response);
	            console.log('share--status');
	          } else {
	            console.log(response.description);
	          }
	        }).fail(function (response) {
	          console.log(response);
	        });
	      }
	    },
	    wxSDKConfig: function wxSDKConfig(title, imgUrl, link, desc) {
	      var shareTitle = title || '';
	      var shareImgLink = imgUrl || '';
	      var shareLink = link || '';
	      var shareDesc = desc || '';
	
	      console.log('wxSDKConfig');
	      console.log(shareTitle);
	      console.log(shareImgLink);
	      console.log(shareLink);
	      console.log(shareDesc);
	
	      var that = this;
	
	      wx.ready(function () {
	        wx.checkJsApi({
	          jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'],
	          success: function success(res) {
	            console.log((0, _stringify2.default)(res));
	          }
	        });
	
	        wx.onMenuShareAppMessage({
	          title: shareTitle,
	          desc: shareDesc,
	          link: shareLink,
	          imgUrl: shareImgLink,
	
	          trigger: function trigger(res) {
	            console.log('用户点击发送给朋友');
	          },
	          success: function success() {
	            console.log('分享给朋友——成功！');
	            console.log(title);
	            console.log(desc);
	            console.log(shareImgLink);
	            console.log(shareLink);
	            that.shareStatus(that.params.sid, 1);
	          },
	          cancel: function cancel() {
	            console.log('分享给朋友——取消！');
	          },
	          fail: function fail(res) {
	            console.log((0, _stringify2.default)(res));
	            that.shareStatus(that.params.sid, 3);
	          }
	        });
	
	        wx.onMenuShareTimeline({
	          title: shareTitle,
	          link: shareLink,
	          imgUrl: shareImgLink,
	          trigger: function trigger(res) {
	            console.log('分享到朋友圈');
	          },
	          success: function success() {
	            console.log('分享到朋友圈——成功！');
	            console.log(shareImgLink);
	            that.shareStatus(that.params.sid, 1);
	          },
	          cancel: function cancel() {
	            console.log('分享到朋友圈——取消！');
	          },
	          fail: function fail(res) {
	            console.log((0, _stringify2.default)(res));
	            that.shareStatus(that.params.sid, 3);
	          }
	        });
	      });
	
	      wx.error(function (res) {
	        console.log((0, _stringify2.default)(res));
	      });
	    },
	    changeMetaTitle: function changeMetaTitle(title) {
	      document.title = title;
	    },
	    getAllId: function getAllId(allId) {
	      return allId;
	    },
	    innerWindow: function innerWindow(id) {
	      var el = document.getElementById(id);
	      if (el === null) {
	        return false;
	      }
	
	      var rect = el.getBoundingClientRect();
	      var boxTop = 0;
	      var boxHeight = window.innerHeight;
	      var flag = rect.top >= boxTop && rect.bottom - boxTop <= boxHeight || rect.top >= boxTop && rect.top - boxTop < boxHeight && rect.bottom - boxTop > boxHeight || rect.top <= boxTop && rect.bottom - boxTop >= boxHeight;
	
	      return flag;
	    },
	    getInnerWindowId: function getInnerWindowId(arr) {
	      var len = arr.length;
	      var aimId = '';
	
	      for (var i = 0; i < len; ++i) {
	        if (this.innerWindow(arr[i])) {
	          aimId = arr[i];
	          break;
	        }
	      }
	
	      return aimId;
	    },
	    shareFinanceDetail: function shareFinanceDetail(fulltitle, desc) {
	      var title = fulltitle;
	      var shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	      var href = window.location.href;
	      var shareLink = '';
	
	      href = this.changeUrlArg(href, 'uid', this.uid);
	      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
	      shareLink = href;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    },
	    shareDhyCbjd: function shareDhyCbjd(fulltitle, desc) {
	
	      var title = void 0,
	          shareImgLink = void 0,
	          shareLink = void 0,
	          href = void 0;
	
	      title = fulltitle;
	      shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	
	      href = window.location.href;
	      href = this.changeUrlArg(href, 'uid', this.uid);
	      href = this.changeUrlArg(href, 'ruid', this.params.uidUrl);
	      shareLink = href;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    },
	
	    shareCompany: function shareCompany(title, desc) {
	      console.log('-------------------------');
	      console.log(title);
	      console.log(desc);
	      console.log(this.queryParam);
	      console.log(this.currentuser);
	      console.log('-------------------------');
	
	      var shareImgLink = void 0,
	          shareLink = void 0,
	          href = void 0;
	      shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	      href = window.location.href;
	      href = this.changeUrlArg(href, 'uid', this.currentuser.uid);
	      href = this.changeUrlArg(href, 'ruid', this.queryParam.uid);
	      shareLink = href;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    }
	
	  }
	};

/***/ },
/* 12 */,
/* 13 */,
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    var _pageshowConditions;
	
	    return {
	      startdate: '',
	      enddate: '',
	      suggestNum: -1,
	      queue: [],
	      suggestagain: true,
	      suggestions: [],
	      oldsuggestValue: '',
	      suggTyp: { 1: 'a', 2: 'n3b', 6: 'h' },
	      showInd: false,
	      showPla: false,
	      havelabels: false,
	      showMylabels: 1,
	      showType: true,
	      showQaType: true,
	      showPlate: true,
	      showRegion: true,
	      showSecurityCompany: true,
	      showIndustry: true,
	      pageshowConditions: (_pageshowConditions = {
	        'type': {},
	        'qaType': {},
	        'plate': {},
	        'region': {},
	        'securityCompany': {},
	        'industry': {
	          'A农，林，牧，渔业': [],
	          'B采矿业': [],
	          'C制造业': [],
	          'D电力、热力、燃气及水生产和供应业': [],
	          'E建筑业': [],
	          'F批发和零售业': [], 'G交通运输、仓储和邮政业': [], 'H住宿和餐饮业': [], 'I信息传输、软件和信息技术服务业': [], 'J金融业': [], 'K房地产业': [], 'L租赁和商务服务业': [], 'M科学研究和技术服务业': [], 'N水利、环境和公共设施管理业': [], 'O居民服务、修理和其他服务业': [], 'P教育': [], 'Q卫生和社会工作': [], 'R文化、体育和娱乐业': [] }
	      }, (0, _defineProperty3.default)(_pageshowConditions, 'plate', { 'SZZB': '', 'SZZXB': '', 'SZCYB': '', 'SHZB': '', '挂牌公司': [], 'N3BTS': '' }), (0, _defineProperty3.default)(_pageshowConditions, 'labels', {}), _pageshowConditions),
	      conditions: {
	        'type': {},
	        'qaType': {},
	        'plate': {},
	        'layer': {},
	        'region': {},
	        'industry': {},
	        'industrysecond': {},
	        'securityCompany': {},
	        'labels': {}
	      },
	      anoConditions: {
	        'type': {},
	        'qaType': {},
	        'plate': {},
	        'layer': {},
	        'region': {},
	        'industry': {},
	        'industrysecond': {},
	        'securityCompany': {},
	        'labels': {}
	      },
	      showChildFlag: {
	        'plate': false,
	        'industry': false
	      }
	    };
	  },
	
	  watch: {
	    'ttype': function ttype(val, oldVal) {
	      this.ttype_name = this.ttypeMap[val];
	    },
	    'datetype': function datetype(val, oldVal) {
	      if (val === 1) {
	        this.datetype_name = '一个月';
	      }
	      if (val === 2) {
	        this.datetype_name = '一个季度';
	      }
	      if (val === 3) {
	        this.datetype_name = '半年';
	      }
	      if (val === 4) {
	        this.datetype_name = '去年';
	      }
	      if (val === 5) {
	        this.datetype_name = '今年';
	      }
	      if (val === 6) {
	        this.datetype_name = '一年';
	      }
	      if (val === 7) {
	        this.datetype_name = '两年';
	      }
	      if (val === 8) {
	        this.datetype_name = '三年';
	      }
	      if (val === 9) {
	        this.datetype_name = '五年';
	      }
	      if (val === 10) {
	        this.datetype_name = '十年';
	      }
	      if (val === 98) {
	        this.datetype_name = '全部';
	      }
	      if (val === 99) {
	        this.datetype_name = '自定义';
	      }
	    }
	  },
	  methods: {
	    changeDateType: function changeDateType(val) {
	      var now = new Date();
	      this.datetype = val;
	      if (val === 1) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 30 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 2) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 90 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 3) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 180 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 4) {
	        this.startdate = (0, _moment2.default)().add(-1, 'Y').format('YYYY-01-01');
	        this.enddate = (0, _moment2.default)().add(-1, 'Y').format('YYYY-12-31');
	      }
	      if (val === 5) {
	        this.startdate = (0, _moment2.default)().format('YYYY-01-01');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 6) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 365 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 7) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 2 * 365 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 8) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 3 * 365 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 9) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 5 * 365 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 10) {
	        this.startdate = (0, _helper.dateFormat)(new Date(now.getTime() - 10 * 365 * 86400 * 1000), 'yyyy-MM-dd');
	        this.enddate = (0, _helper.dateFormat)(now, 'yyyy-MM-dd');
	      }
	      if (val === 98) {
	        this.startdate = '';
	        this.enddate = '';
	      }
	    },
	
	    arrowkey: function arrowkey(e) {
	      console.log(e);
	
	      if (this.suggestions.length > 0 && (e.keyCode === 38 || e.keyCode === 40)) {
	        e.preventDefault();
	        if (e.keyCode === 38) {
	          var lis = (0, _jquery2.default)('.company-menu li');
	          console.log((0, _jquery2.default)('.company-menu li'));
	          var num = 0;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(lis), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var i = _step.value;
	
	              if (!(0, _jquery2.default)(i).is(":focus")) {
	                num = num + 1;
	              } else {
	                if (num === 0) {
	
	                  (0, _jquery2.default)('.company-menu li')[this.suggestions.length - 1].focus();
	                } else {
	
	                  (0, _jquery2.default)('.company-menu li')[num - 1].focus();
	                }
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (num === lis.length) {
	
	            (0, _jquery2.default)('.company-menu li')[this.suggestions.length - 1].focus();
	          }
	        }
	        if (e.keyCode === 40) {
	          var _lis = (0, _jquery2.default)('.company-menu li');
	          var num = 0;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_lis), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var _i = _step2.value;
	
	              if (!(0, _jquery2.default)(_i).is(":focus")) {
	                num = num + 1;
	              } else {
	                if (num === this.suggestions.length - 1) {
	
	                  (0, _jquery2.default)('.company-menu li')[0].focus();
	                } else {
	
	                  (0, _jquery2.default)('.company-menu li')[num + 1].focus();
	                }
	                break;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          if (num === _lis.length) {
	
	            (0, _jquery2.default)('.company-menu li')[0].focus();
	          }
	        }
	      }
	    },
	    suggest: function suggest(d, e) {
	      if (d.length < 2) {
	        this.oldsuggestValue = d;
	        this.queue = [];
	        this.suggestions = [];
	        this.suggestNum = -1;
	        return false;
	      }
	      if (this.stype === 3) {
	        return false;
	      }
	      if (d && d !== this.oldsuggestValue) {
	        this.oldsuggestValue = d;
	
	        this.suggestagain = false;
	        var value = d.split(' ');
	        if (window.location.href.indexOf('mysecurities') < 0) {
	          var query = { name: [], count: 10, stype: this.suggTyp[this.stype] };
	        } else {
	          var query = { name: [], count: 10 };
	        }
	
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(value), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var i = _step3.value;
	
	            if (i) {
	              query.name.push(i);
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        this.suggestions = [];
	        this.suggestNum = this.suggestNum + 1;
	        this.ajaxSuggest(query, this.suggestNum);
	        console.log(this.queue);
	      }
	    },
	    ajaxSuggest: function ajaxSuggest(query, n) {
	      var _this = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/suggestcompany'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.suggestagain = true;
	
	        if (response.status === 0 && response.data.result[0].length > 0) {
	          _this.queue[n] = response.data.result[0];
	          _this.suggestions = _this.queue[_this.queue.length - 1];
	        } else {
	          _this.queue[n] = [];
	          _this.suggestions = _this.queue[_this.queue.length - 1];
	        }
	      }).fail(function (response) {
	        _this.suggestagain = true;
	
	        console.log('请求失败');
	        _this.queue[n] = [];
	        _this.suggestions = _this.queue[_this.queue.length - 1];
	      });
	    },
	
	    addToShow: function addToShow() {
	      this.havelabels = false;
	      for (var ii in this.conditions) {
	        if (!(0, _helper.isEmptyObj)(this.conditions[ii])) {
	          console.log((0, _helper.isEmptyObj)(this.conditions.type));
	          this.havelabels = true;
	          this.showMylabels = 2;
	          break;
	        }
	      }
	      this.showPla = false;
	      var plates = ['SZZB', 'SZZXB', 'SZCYB', 'SHZB', 'N3BTS'];
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(plates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var _i2 = _step4.value;
	
	          this.pageshowConditions['plate'][_i2] = '';
	          if (this.conditions['plate'][_i2]) {
	            this.showPla = true;
	            this.pageshowConditions['plate'][_i2] = this.conditions['plate'][_i2];
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.showInd = false;
	      for (var z in this.pageshowConditions['industry']) {
	        this.pageshowConditions['industry'][z] = [];
	      }
	      if (this.pageshowConditions['industry']['S综合']) {
	        var pageshowConditions = (0, _assign2.default)({}, this.pageshowConditions);
	        delete pageshowConditions['industry']['S综合'];
	        this.pageshowConditions = (0, _assign2.default)({}, pageshowConditions);
	      }
	      this.pageshowConditions['plate']['挂牌公司'] = [];
	      if (!(0, _helper.isEmptyObj)(this.conditions['layer'])) {
	        this.showPla = true;
	        for (var y in this.conditions['layer']) {
	          this.pageshowConditions['plate']['挂牌公司'].push(y);
	        }
	      }
	      if ((0, _keys2.default)(this.conditions['industrysecond']).length > 0) {
	        this.showInd = true;
	        for (var i in this.conditions['industrysecond']) {
	          for (var j in this.pageshowConditions['industry']) {
	            if (j.indexOf(i.substr(0, 1)) >= 0) {
	              var x = i + this.conditions['industrysecond'][i];
	              this.pageshowConditions['industry'][j].push(x);
	            }
	          }
	        }
	      }
	
	      if (this.conditions['industry']['S']) {
	        this.showInd = true;
	        var tmp = {};
	        tmp['S综合'] = [];
	        this.pageshowConditions['industry'] = (0, _assign2.default)({}, this.pageshowConditions['industry'], tmp);
	      }
	    },
	    clearSearch: function clearSearch() {
	      this.parseUrlQuery({});
	      this.addToShow();
	    },
	    changeKyTtype: function changeKyTtype(ky, ttype, ttname) {
	      ky.ttype = ttype;
	      ky.ttname = ttname;
	    },
	    changeKyOp: function changeKyOp(ky, optype, opname) {
	      ky.optype = optype;
	      ky.opname = opname;
	    },
	    getTypeByCat: function getTypeByCat(type) {
	      var types = [];
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(this.typeAll), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var t = _step5.value;
	
	          if (t.category === type) {
	            types.push(t);
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      return types;
	    },
	    rmvCondition: function rmvCondition(type, code) {
	      if (type === 'industrysecond') {
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = (0, _getIterator3.default)(this.industry), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var i = _step6.value;
	
	            if (i.code === code[0]) {
	              i.count--;
	            }
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	              _iterator6.return();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	      }
	      if (type === 'layer') {
	        this.plates[0].count--;
	      }
	      if (type === 'industry') {
	        var _iteratorNormalCompletion7 = true;
	        var _didIteratorError7 = false;
	        var _iteratorError7 = undefined;
	
	        try {
	          for (var _iterator7 = (0, _getIterator3.default)(this.industry), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	            var _i3 = _step7.value;
	
	            if (_i3.code === code) {
	              _i3.count = 0;
	            }
	          }
	        } catch (err) {
	          _didIteratorError7 = true;
	          _iteratorError7 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion7 && _iterator7.return) {
	              _iterator7.return();
	            }
	          } finally {
	            if (_didIteratorError7) {
	              throw _iteratorError7;
	            }
	          }
	        }
	      }
	      if (type === 'N3BGP') {
	        this.plates[0].count = 0;
	      }
	      var conditions = (0, _assign2.default)({}, this.conditions);
	      if (type === 'industrysecond') {
	        delete conditions['industry'][code.substr(0, 1)];
	        delete conditions[type][code];
	        this.conditions = (0, _assign2.default)({}, conditions);
	      } else if (type === 'industry') {
	        delete conditions['industry'][code];
	        for (var item in conditions['industrysecond']) {
	          if (item.indexOf(code) >= 0) {
	            delete conditions['industrysecond'][item];
	          }
	        }
	        this.conditions = (0, _assign2.default)({}, conditions);
	      } else if (type === 'N3BGP') {
	        delete conditions['plate']['N3BGP'];
	        delete conditions['layer']['创新层'];
	        delete conditions['layer']['基础层'];
	        this.conditions = (0, _assign2.default)({}, conditions);
	      } else if (type === 'layer') {
	        delete conditions['plate']['N3BGP'];
	        delete conditions[type][code];
	        this.conditions = (0, _assign2.default)({}, conditions);
	      } else {
	        delete conditions[type][code];
	        this.conditions[type] = (0, _assign2.default)({}, conditions[type]);
	      }
	
	      if (this.searched) {
	        this.go();
	      }
	
	      this.addToShow();
	    },
	    rmvKeywordCondition: function rmvKeywordCondition(idx) {
	      if (this.keywords_condition.length > 1) {
	        this.keywords_condition.splice(idx, 1);
	      } else {
	        this.keywords_condition.$set(idx, { val: '', ttype: 0, ttname: '全部', optype: 1, opname: '包含全部关键词' });
	      }
	    },
	    setNum: function setNum(type, d) {
	      var count = d.count;
	      count = 0;
	      if (type === 'industrysecond') {
	        var arr = [];
	        for (var item in this.conditions['industrysecond']) {
	          arr.push(item);
	        }
	        var _iteratorNormalCompletion8 = true;
	        var _didIteratorError8 = false;
	        var _iteratorError8 = undefined;
	
	        try {
	          for (var _iterator8 = (0, _getIterator3.default)(arr), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	            var i = _step8.value;
	
	            if (i.indexOf(d.code) >= 0) {
	              count++;
	            }
	          }
	        } catch (err) {
	          _didIteratorError8 = true;
	          _iteratorError8 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion8 && _iterator8.return) {
	              _iterator8.return();
	            }
	          } finally {
	            if (_didIteratorError8) {
	              throw _iteratorError8;
	            }
	          }
	        }
	
	        d.count = count;
	      } else {
	        var _arr = [];
	
	        for (var _item in this.conditions['layer']) {
	          _arr.push(_item);
	        }
	        count = _arr.length;
	        d.count = count;
	      }
	    },
	    addCondition: function addCondition(type, obj, d) {
	      if (window.location.href.indexOf('result') >= 0) {
	        if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
	          (0, _helper.alert)('请输入关键词或股票代码');
	          return;
	        }
	      }
	      this.showMylabels = 2;
	      if (type === 'industry') {
	        if (!this.conditions[type][obj.code]) {
	          var tmp = {};
	          tmp[obj.code] = obj.name;
	          this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], tmp);
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = (0, _getIterator3.default)(this.industry), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var item = _step9.value;
	
	              if (item.code === obj.code && item.child.length > 0) {
	                obj.count = item.child.length;
	                var _iteratorNormalCompletion10 = true;
	                var _didIteratorError10 = false;
	                var _iteratorError10 = undefined;
	
	                try {
	                  for (var _iterator10 = (0, _getIterator3.default)(item.child), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                    var i = _step10.value;
	
	                    var secind = {};
	                    secind[i.code] = i.name;
	                    this.conditions['industrysecond'] = (0, _assign2.default)({}, this.conditions['industrysecond'], secind);
	                  }
	                } catch (err) {
	                  _didIteratorError10 = true;
	                  _iteratorError10 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                      _iterator10.return();
	                    }
	                  } finally {
	                    if (_didIteratorError10) {
	                      throw _iteratorError10;
	                    }
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	
	          if (this.searched) {
	            this.go();
	          }
	          console.log(this.conditions);
	        } else {
	          obj.count = 0;
	          var conditions = (0, _assign2.default)({}, this.conditions);
	          delete conditions[type][obj.code];
	          var _iteratorNormalCompletion11 = true;
	          var _didIteratorError11 = false;
	          var _iteratorError11 = undefined;
	
	          try {
	            for (var _iterator11 = (0, _getIterator3.default)(this.industry), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	              var _item2 = _step11.value;
	
	              if (_item2.code === obj.code && _item2.child.length > 0) {
	                var _iteratorNormalCompletion12 = true;
	                var _didIteratorError12 = false;
	                var _iteratorError12 = undefined;
	
	                try {
	                  for (var _iterator12 = (0, _getIterator3.default)(_item2.child), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                    var _i4 = _step12.value;
	
	                    delete conditions['industrysecond'][_i4.code];
	                  }
	                } catch (err) {
	                  _didIteratorError12 = true;
	                  _iteratorError12 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                      _iterator12.return();
	                    }
	                  } finally {
	                    if (_didIteratorError12) {
	                      throw _iteratorError12;
	                    }
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError11 = true;
	            _iteratorError11 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                _iterator11.return();
	              }
	            } finally {
	              if (_didIteratorError11) {
	                throw _iteratorError11;
	              }
	            }
	          }
	
	          this.conditions = (0, _assign2.default)({}, conditions);
	          if (this.searched) {
	            this.go();
	          }
	          console.log(this.conditions);
	        }
	      } else if (type === 'industrysecond') {
	        if (!this.conditions[type][obj.code]) {
	          var _tmp = {};
	          _tmp[obj.code] = obj.name;
	
	          this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], _tmp);
	          var _iteratorNormalCompletion13 = true;
	          var _didIteratorError13 = false;
	          var _iteratorError13 = undefined;
	
	          try {
	            for (var _iterator13 = (0, _getIterator3.default)(this.industry), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	              var _item3 = _step13.value;
	
	              if (_item3.code === obj.code.substr(0, 1)) {
	                var count = 0;
	                var _iteratorNormalCompletion14 = true;
	                var _didIteratorError14 = false;
	                var _iteratorError14 = undefined;
	
	                try {
	                  for (var _iterator14 = (0, _getIterator3.default)(_item3.child), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	                    var _i5 = _step14.value;
	
	                    if (_i5.code in this.conditions[type]) {
	                      count++;
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError14 = true;
	                  _iteratorError14 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                      _iterator14.return();
	                    }
	                  } finally {
	                    if (_didIteratorError14) {
	                      throw _iteratorError14;
	                    }
	                  }
	                }
	
	                if (count === _item3.child.length) {
	                  var _tmp2 = {};
	                  _tmp2[_item3.code] = _item3.name;
	                  this.conditions['industry'] = (0, _assign2.default)({}, this.conditions['industry'], _tmp2);
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError13 = true;
	            _iteratorError13 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion13 && _iterator13.return) {
	                _iterator13.return();
	              }
	            } finally {
	              if (_didIteratorError13) {
	                throw _iteratorError13;
	              }
	            }
	          }
	
	          this.setNum(type, d);
	          if (this.searched) {
	            this.go();
	          }
	        } else {
	          var _conditions = (0, _assign2.default)({}, this.conditions);
	          delete _conditions[type][obj.code];
	          if (_conditions['industry'][obj.code.substr(0, 1)]) {
	            delete _conditions['industry'][obj.code.substr(0, 1)];
	          }
	          this.conditions = (0, _assign2.default)({}, _conditions);
	          this.setNum(type, d);
	          if (this.searched) {
	            this.go();
	          }
	        }
	      } else if (obj.name === '挂牌公司') {
	        if (!this.conditions['plate'][obj.code]) {
	          obj.count = 2;
	          var _tmp3 = {};
	          _tmp3[obj.code] = obj.name;
	          this.conditions['plate'] = (0, _assign2.default)({}, this.conditions['plate'], _tmp3);
	          console.log(this.plates);
	          var _iteratorNormalCompletion15 = true;
	          var _didIteratorError15 = false;
	          var _iteratorError15 = undefined;
	
	          try {
	            for (var _iterator15 = (0, _getIterator3.default)(this.plates[0].child), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	              var _item4 = _step15.value;
	
	              var _secind = {};
	              _secind[_item4.code] = _item4.name;
	              this.conditions['layer'] = (0, _assign2.default)({}, this.conditions['layer'], _secind);
	            }
	          } catch (err) {
	            _didIteratorError15 = true;
	            _iteratorError15 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                _iterator15.return();
	              }
	            } finally {
	              if (_didIteratorError15) {
	                throw _iteratorError15;
	              }
	            }
	          }
	
	          if (this.searched) {
	            this.go();
	          }
	        } else {
	          obj.count = 0;
	          var _conditions2 = (0, _assign2.default)({}, this.conditions);
	          delete _conditions2['plate'][obj.code];
	          var _iteratorNormalCompletion16 = true;
	          var _didIteratorError16 = false;
	          var _iteratorError16 = undefined;
	
	          try {
	            for (var _iterator16 = (0, _getIterator3.default)(this.plates[0].child), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	              var _item5 = _step16.value;
	
	              delete _conditions2['layer'][_item5.code];
	            }
	          } catch (err) {
	            _didIteratorError16 = true;
	            _iteratorError16 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion16 && _iterator16.return) {
	                _iterator16.return();
	              }
	            } finally {
	              if (_didIteratorError16) {
	                throw _iteratorError16;
	              }
	            }
	          }
	
	          this.conditions = (0, _assign2.default)({}, _conditions2);
	          if (this.searched) {
	            this.go();
	          }
	        }
	      } else if (type === 'layer') {
	        if (!this.conditions['layer'][obj.code]) {
	          var _tmp4 = {};
	          _tmp4[obj.code] = obj.name;
	          this.conditions['layer'] = (0, _assign2.default)({}, this.conditions['layer'], _tmp4);
	          var _count = 0;
	          var _iteratorNormalCompletion17 = true;
	          var _didIteratorError17 = false;
	          var _iteratorError17 = undefined;
	
	          try {
	            for (var _iterator17 = (0, _getIterator3.default)(this.plates[0].child), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	              var _item6 = _step17.value;
	
	              if (_item6.code in this.conditions['layer']) {
	                _count++;
	              }
	            }
	          } catch (err) {
	            _didIteratorError17 = true;
	            _iteratorError17 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion17 && _iterator17.return) {
	                _iterator17.return();
	              }
	            } finally {
	              if (_didIteratorError17) {
	                throw _iteratorError17;
	              }
	            }
	          }
	
	          if (_count === 2) {
	            var ano = {};
	            ano[this.plates[0].code] = this.plates[0].name;
	            this.conditions['plate'] = (0, _assign2.default)({}, this.conditions['plate'], ano);
	          }
	          this.setNum(type, d);
	          if (this.searched) {
	            this.go();
	          }
	        } else {
	          var _conditions3 = (0, _assign2.default)({}, this.conditions);
	          delete _conditions3['layer'][obj.code];
	          delete _conditions3['plate']['N3BGP'];
	          this.conditions = (0, _assign2.default)({}, _conditions3);
	          this.setNum(type, d);
	          if (this.searched) {
	            this.go();
	          }
	        }
	      } else {
	        if (!this.conditions[type][obj.code]) {
	          var _tmp5 = {};
	          _tmp5[obj.code] = obj.name;
	          this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], _tmp5);
	          console.log(this.conditions);
	          console.log('22222');
	          console.log((0, _helper.isEmptyObj)(this.conditions.type));
	          if (this.searched) {
	            this.go();
	          }
	        } else {
	          var _conditions4 = (0, _assign2.default)({}, this.conditions);
	          delete _conditions4[type][obj.code];
	          this.conditions[type] = (0, _assign2.default)({}, _conditions4[type]);
	          if (this.searched) {
	            this.go();
	          }
	        }
	      }
	      console.log(this.conditions);
	      this.addToShow();
	    },
	
	    addConditionNew: function addConditionNew(type, obj) {
	      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
	        (0, _helper.alert)('请输入关键词或股票代码');
	        return;
	      }
	      if (!this.conditions[type][obj.code]) {
	        var tmp = {};
	        tmp[obj.code] = obj.name;
	        this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], tmp);
	        if (this.searched) {
	          this.go();
	        }
	      } else {
	        var conditions = this.conditions;
	        delete conditions[type][obj.code];
	        this.conditions = (0, _assign2.default)({}, conditions);
	        if (this.searched) {
	          this.go();
	        }
	      }
	      this.showMylabels = 2;
	      this.addToShow();
	    },
	    validKeywordCondition: function validKeywordCondition() {
	      var _iteratorNormalCompletion18 = true;
	      var _didIteratorError18 = false;
	      var _iteratorError18 = undefined;
	
	      try {
	        for (var _iterator18 = (0, _getIterator3.default)(this.keywords_condition), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	          var kc = _step18.value;
	
	          var t = kc.val.trim();
	          if (t) {
	            return true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError18 = true;
	        _iteratorError18 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion18 && _iterator18.return) {
	            _iterator18.return();
	          }
	        } finally {
	          if (_didIteratorError18) {
	            throw _iteratorError18;
	          }
	        }
	      }
	
	      return false;
	    }
	  }
	};

/***/ },
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      company: {},
	      companycode: '',
	      stype: '',
	      legendCompany: [],
	      showQrcode: false,
	      showsharedialog: false,
	      DiyShareDesc: '',
	      selectedTab: '',
	      dateDropmenu: false,
	      selectedTab2: '',
	      tabList: {
	        'baseinfo': '公司资料',
	        'gudong': '股东',
	        'finance': '财务分析',
	
	        'mainbusiness': '主营业务',
	        'customersandsuppliers': '客户与供应商',
	        'tradinginformation': '交易信息'
	      },
	      tabListH: {
	        'baseinfo': '公司资料',
	        'gudong': '股东',
	        'finance': '财务分析'
	      },
	      queryParam: null
	    };
	  },
	
	  methods: {
	    parseQuery: function parseQuery() {
	      var url = window.location.href;
	    },
	    scrollTop: function scrollTop() {
	      (0, _jquery2.default)('html,body').animate({ scrollTop: 0 }, 'normal');
	    },
	    setSelectTab: function setSelectTab(typ) {
	      this.selectedTab = typ;
	      this.showDropdownMenu = false;
	      this.setSelectTab2(1);
	    },
	    setSelectTab2: function setSelectTab2(typ) {
	      console.log('二级tab this.queryParam');
	      console.log(this.selectedTab);
	      this.selectedTab2 = typ;
	
	      if (this.selectedTab === 'baseinfo') {
	        if (typ == 1) {
	          console.log("路由跳转到基本信息");
	          this.$router.go({ path: '/company', query: this.queryParam });
	        }
	        if (typ === 2) {
	          console.log('跳转到高管');
	          this.$router.go({ path: '/company/gaoguan', query: this.queryParam });
	        }
	      }
	
	      if (this.selectedTab === 'gudong') {
	        if (this.stype != 6) {
	          if (typ == 1) {
	            this.$router.go({ path: '/company/invest', query: this.queryParam });
	          } else if (typ === 2) {
	            this.$router.go({ path: '/company/topten', query: this.queryParam });
	          } else if (typ === 3) {
	            this.$router.go({ path: '/company/sharechange', query: this.queryParam });
	          }
	        } else {
	          this.$router.go({ path: '/company/topten', query: this.queryParam });
	        }
	      }
	
	      if (this.selectedTab === 'finance') {
	        if (this.stype == 6) {
	          if (typ == 1 || typ == 2) {
	            this.$router.go({ path: '/company/fzb', query: this.queryParam });
	          } else if (typ === 3) {
	            this.$router.go({ path: '/company/lrb', query: this.queryParam });
	          } else if (typ === 4) {
	            this.$router.go({ path: '/company/llb', query: this.queryParam });
	          }
	        } else {
	          if (typ == 1) {
	            this.$router.go({ path: '/company/finance', query: this.queryParam });
	          } else if (typ === 2) {
	            this.$router.go({ path: '/company/fzb', query: this.queryParam });
	          } else if (typ === 3) {
	            this.$router.go({ path: '/company/lrb', query: this.queryParam });
	          } else if (typ === 4) {
	            this.$router.go({ path: '/company/llb', query: this.queryParam });
	          } else if (typ === 5) {
	            this.$router.go({ path: '/company/performance', query: this.queryParam });
	          } else if (typ === 6) {
	            this.$router.go({ path: '/company/industryCompare', query: this.queryParam });
	          }
	        }
	      }
	
	      if (this.selectedTab === 'mainbusiness') {
	        if (typ == 1) {
	          this.$router.go({ path: '/company/mainproduct', query: this.queryParam });
	        } else if (typ === 2) {
	          this.$router.go({ path: '/company/mainindustry', query: this.queryParam });
	        } else if (typ === 3) {
	          this.$router.go({ path: '/company/mainlocation', query: this.queryParam });
	        }
	      }
	
	      if (this.selectedTab === 'customersandsuppliers') {
	        if (typ == 1) {
	          this.$router.go({ path: '/company/customer', query: this.queryParam });
	        } else if (typ === 2) {
	          this.$router.go({ path: '/company/supplier', query: this.queryParam });
	        }
	      }
	
	      if (this.selectedTab === 'tradinginformation') {
	        if (typ == 1) {
	          this.$router.go({ path: '/company/tradeinfo', query: this.queryParam });
	        } else if (typ === 2) {
	          this.$router.go({ path: '/company/stocktops', query: this.queryParam });
	        } else if (typ === 3) {
	          this.$router.go({ path: '/company/largeexchange', query: this.queryParam });
	        }
	      }
	    },
	    setSelectedTab: function setSelectedTab() {
	      var url = window.location.href;
	      console.log('---------------------------setSelectedTab companyMix.js组件');
	      console.log(url);
	
	      if (url.indexOf('/company?companycode') > 0 || url.indexOf('/company/?companycode') > 0) {
	        this.selectedTab = 'baseinfo';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('gaoguan') > 0) {
	        this.selectedTab = 'baseinfo';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('invest') > 0) {
	        this.selectedTab = 'gudong';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('topten') > 0) {
	        this.selectedTab = 'gudong';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('sharechange') > 0) {
	        this.selectedTab = 'gudong';
	        this.selectedTab2 = 3;
	        this.setSelectTab2(3);
	      }
	
	      if (url.indexOf('finance') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('/fzb') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('/lrb') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 3;
	        this.setSelectTab2(3);
	      }
	
	      if (url.indexOf('/llb') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 4;
	        this.setSelectTab2(4);
	      }
	
	      if (url.indexOf('/performance') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 5;
	        this.setSelectTab2(5);
	      }
	
	      if (url.indexOf('industryCompare') > 0) {
	        this.selectedTab = 'finance';
	        this.selectedTab2 = 6;
	        this.setSelectTab2(6);
	      }
	
	      if (url.indexOf('mainproduct') > 0) {
	        this.selectedTab = 'mainbusiness';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('mainindustry') > 0) {
	        this.selectedTab = 'mainbusiness';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('mainlocation') > 0) {
	        this.selectedTab = 'mainbusiness';
	        this.selectedTab2 = 3;
	        this.setSelectTab2(3);
	      }
	
	      if (url.indexOf('customer') > 0) {
	        this.selectedTab = 'customersandsuppliers';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('supplier') > 0) {
	        this.selectedTab = 'customersandsuppliers';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('tradeinfo') > 0) {
	        this.selectedTab = 'tradinginformation';
	        this.selectedTab2 = 1;
	        this.setSelectTab2(1);
	      }
	
	      if (url.indexOf('stocktops') > 0) {
	        this.selectedTab = 'tradinginformation';
	        this.selectedTab2 = 2;
	        this.setSelectTab2(2);
	      }
	
	      if (url.indexOf('largeexchange') > 0) {
	        this.selectedTab = 'tradinginformation';
	        this.selectedTab2 = 3;
	        this.setSelectTab2(3);
	      }
	    },
	
	    hideDropmenu: function hideDropmenu(e) {
	      var _con = (0, _jquery2.default)('.menu-lanmu');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.dateDropmenu = false;
	      }
	    },
	
	    companyCompare: function companyCompare(x, n, u, y) {
	      console.log('use conpanyMix function company compare, this contain echarts');
	
	
	      if (!y) {
	        y = 5;
	      }
	      var legend = x;
	      var xAxis = {};
	      var extreme = [];
	      var years = [];
	      var yearMax = [];
	      var maxVal = null;
	      var minVal = null;
	      var unit = '';
	      var yAxis = {
	        'type': 'value',
	        nameRotate: 0.1,
	        axisLabel: {
	          formatter: ''
	        }
	      };
	      var series = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(n), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var k = _step.value;
	
	          yAxis.name = k[0][1];
	          k.shift();
	
	          var arr = [];
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = (0, _getIterator3.default)(k), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var _i3 = _step7.value;
	
	              arr.push(_i3[0]);
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          years.push(arr);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(years), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var _y = _step2.value;
	
	          if (_y.length > 0) {
	            yearMax.push(parseInt(_y[_y.length - 1].replace(/-/g, '')));
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var index = yearMax.indexOf(Math.max.apply(Math, yearMax));
	
	      if (years[index]) {
	        years[index].splice(0, years[index].length - y);
	      }
	      xAxis.data = years[index];
	
	
	      for (var i in n) {
	        var _x = {};
	        _x.name = legend[i];
	        _x.connectNulls = true;
	        _x.type = this.chartType;
	        _x.barMaxWidth = '20';
	        if (years[index] && years[index].length > 0) {
	          _x.data = new Array(years[index].length);
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(n[i]), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var item = _step3.value;
	
	              for (var idx in years[index]) {
	                if (years[index][idx] == item[0] && item[1] !== 0) {
	                  _x.data[idx] = item[1];
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        } else {
	          _x.data = [];
	        }
	        series.push(_x);
	      }
	      if (u[0] == '元') {
	        var UnityUnits = function UnityUnits(x) {
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = (0, _getIterator3.default)(series), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var _item = _step5.value;
	
	              for (var _i in _item.data) {
	                if (_item.data[_i]) {
	                  _item.data[_i] = (_item.data[_i] / x).toFixed(3);
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	        };
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(series), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var o = _step4.value;
	            var _iteratorNormalCompletion6 = true;
	            var _didIteratorError6 = false;
	            var _iteratorError6 = undefined;
	
	            try {
	              for (var _iterator6 = (0, _getIterator3.default)(o.data), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var _i2 = _step6.value;
	
	                if (_i2) {
	                  extreme.push(Math.abs(_i2));
	                }
	              }
	            } catch (err) {
	              _didIteratorError6 = true;
	              _iteratorError6 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                  _iterator6.return();
	                }
	              } finally {
	                if (_didIteratorError6) {
	                  throw _iteratorError6;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	
	        maxVal = Math.max.apply(Math, extreme);
	        minVal = Math.min.apply(Math, extreme);
	        if (maxVal > 100000000 && minVal > 100000000) {
	          unit = '亿元';
	          UnityUnits(100000000);
	        } else if (maxVal > 100000000 && minVal > 10000) {
	          unit = '万元';
	          UnityUnits(10000);
	        } else if (maxVal > 100000000 && minVal > 0) {
	          unit = '万元';
	          UnityUnits(10000);
	        } else if (maxVal > 10000 && minVal > 10000) {
	          unit = '万元';
	          UnityUnits(10000);
	        } else if (maxVal > 10000 && minVal > 0) {
	          unit = '元';
	          UnityUnits(1);
	        } else if (maxVal > 0 && minVal > 0) {
	          unit = '元';
	          UnityUnits(1);
	        }
	        yAxis.axisLabel.formatter = '{value}' + unit;
	      } else {
	        yAxis.axisLabel.formatter = '{value}' + u[0];
	      }
	
	      var that = this;
	      var show = setInterval(function () {
	        if (document.querySelector('.industry-chard')) {
	          var echart = document.querySelector('.industry-chard');
	          var mychart = _echarts2.default.init(echart);
	          var option = {
	            tooltip: {
	              trigger: 'axis',
	              axisPointer: {
	                type: 'shadow' }
	            },
	            toolbox: {
	              show: true,
	              feature: {
	                magicType: {
	                  show: true,
	                  type: ['line', 'bar'],
	                  title: { line: '折线图', bar: '柱图' }
	                }
	              }
	            },
	            legend: {
	              data: legend,
	              width: 500
	            },
	            grid: {
	              left: '3%',
	              right: '6%',
	              bottom: '3%',
	              top: '30%',
	              containLabel: true
	            },
	            xAxis: xAxis,
	            yAxis: [yAxis],
	            graphic: [{
	              type: 'image',
	              left: 20,
	              top: -10,
	              z: -10,
	              bounding: 'raw',
	              origin: [75, 75],
	              style: {
	                image: window.location.origin + '/static/images/analyze_shuiyin2.png',
	                width: 830,
	                height: 250,
	                opacity: 0.4
	              }
	            }],
	            series: series
	          };
	
	          window.clearInterval(show);
	          mychart.setOption(option, true);
	          mychart.on('magictypechanged', function (params) {
	            console.log(params);
	            that.chartType = params.currentType;
	          });
	        }
	      }, 100);
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  },
	  filters: {
	    fomartTab: function fomartTab(param) {
	      for (var key in this.tabList) {
	        if (this.selectedTab === key) {
	          return this.tabList[key];
	        }
	      }
	    },
	
	    two: function two(value) {
	      if (value.toString().indexOf('.') >= 0) {
	        return value.toFixed(2);
	      } else {
	        return value;
	      }
	    },
	    formatMoney: function formatMoney(num) {
	      if (!num) {
	        return num;
	      } else {
	        num = parseFloat(num);
	        return num.toLocaleString('en-US');
	      }
	    },
	    formatStockTyp: function formatStockTyp(param) {
	      if (param == 'szse') {
	        return '深交所';
	      } else if (param == 'shse') {
	        return '上交所';
	      } else {
	        return param;
	      }
	    },
	    formatFloat: function formatFloat(param) {
	      if (!param) {
	        return;
	      }
	
	      param = parseFloat(param);
	      return param.toFixed(2);
	    },
	    nullValue: function nullValue(param) {
	      if (!param || param == '') {
	        return '-';
	      } else {
	        return param;
	      }
	    },
	    toWan: function toWan(param) {
	      if (param) {
	        param = parseFloat(param) / 10000;
	        param = param.toFixed(2);
	        return param.toLocaleString('en-US');
	      } else {
	        return param;
	      }
	    },
	    formatSnjlr: function formatSnjlr(param) {
	      if (!param || param == '') {
	        return '-';
	      }
	
	      param = param.toString();
	      var len = 0;
	      if (param.indexOf('.') !== -1) {
	        if (param.indexOf('-') !== -1) {
	          len = param.split('.')[0].toString().length - 1;
	        } else {
	          len = param.split('.')[0].toString().length;
	        }
	      } else {
	        if (param.indexOf('-') !== -1) {
	          len = param.toString().length - 1;
	        } else {
	          len = param.toString().length;
	        }
	      }
	
	      param = parseFloat(param);
	      if (len > 8) {
	        param = param / 100000000;
	        return param.toFixed(2).toLocaleString('en-US') + '亿';
	      } else if (len >= 5 && len <= 8) {
	        param = param / 10000;
	        return param.toFixed(2).toLocaleString('en-US') + '万元';
	      } else {
	        return param + '元';
	      }
	    },
	    formatDate: function formatDate(param) {
	      if (!param) return;
	
	      param = param.toString();
	
	      var year = param.substr(0, 4);
	      var month = param.substr(4, 2);
	      var day = param.substr(6);
	
	      return year + '-' + month + '-' + day;
	    },
	    cheng100: function cheng100(param) {
	      if (param === 0) {
	        return param;
	      }
	      if (!param) {
	        return;
	      }
	      param = parseFloat(param) * 100;
	      return param.toFixed(2);
	    },
	    fundDate: function fundDate(param) {
	      if (!param) return;
	
	      param = param.toString();
	      var year = param.substr(0, 4);
	      var month = param.substr(4, 2);
	
	      if (parseInt(month) == 3) {
	        return year + '年一季度';
	      } else if (parseInt(month) == 6) {
	        return year + '年半年度';
	      } else if (parseInt(month) == 9) {
	        return year + '年三季度';
	      } else if (parseInt(month) == 12) {
	        return year + '年年度';
	      }
	    },
	    kong: function kong(k) {
	      if (!k || k == 'null') {
	        return '-';
	      } else {
	        return k;
	      }
	    }
	  }
	};

/***/ },
/* 19 */,
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      searched: 0,
	      showTypAll: true,
	      sts: 0,
	      advsearch: 0,
	      cond_type: { 'type': '公告类型', 'labels': '公告标签', 'plate': '板块类型', 'layer': '挂牌公司', 'region': '地区类型', 'securityCompany': '主办劵商', 'industry': '行业类型', 'industrysecond': '行业子类', 'qaType': '问答类型' },
	
	      memory: {},
	
	      stype: 1,
	      ttype: 0,
	      ttype_name: '全部',
	      ttype_dropdown: false,
	      keywords: '',
	      companyCode: '',
	      publishDate: '',
	      datetype: 0,
	      datetype_name: '',
	      ttypeMap: { 0: '全部', 1: '标题', 2: '章节标题', 3: '正文', 4: '问题', 5: '答案', 6: '图片' },
	      optypeMap: { 1: '包含全部关键词', 2: '包含任意关键词', 3: '不含全部关键词' },
	      keywords_condition: [{
	        val: '',
	        ttype: 0,
	        ttname: '全部',
	        optype: 1,
	        opname: '包含全部关键词'
	      }],
	      typeAll: [],
	      types: [],
	      qaTypes: [],
	      plateAll: {},
	      plates: [],
	      regions: [],
	      securityCompany: [],
	      industry: [],
	      showConditionFlag: '',
	
	      showSubTitle: true,
	
	      showModal: false,
	      tagname: '',
	
	      parseVer: '',
	      idxname: '',
	
	      pholder: '002330',
	      showDropdownMenu: '',
	      ai: 0,
	      smartEngine: {
	        open: false,
	        companyInfo: {}
	      },
	      condition_field: {
	        'havelabels': false,
	        'showPla': false,
	        'showInd': false,
	        'companyCode': ''
	      },
	      reportDataList: [],
	      currStypObj: {
	        "1": {},
	        "2": {},
	        "3": {},
	        "4": {},
	        "5": {},
	        "6": {},
	        "7": {},
	        "8": {},
	        "9": {},
	        "10": {},
	        "11": {},
	        "12": {},
	        "13": {},
	        "14": {},
	        "15": {},
	        "17": {},
	        "100": {}
	      },
	      stypesArr: [],
	      stypesTotal: { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '10': 0, '11': 0, '12': 0, '13': 0, '14': 0 },
	      stypesMap: { '1': 'complex_agu', '2': 'complex_n3b', '3': 'complex_bond', '4': 'complex_knowledge', '5': 'complex_qa', '6': 'complex_hk', '10': 'complex_abs', '11': 'complex_yb', '12': 'complex_news', '13': 'complex_reportdata', '14': 'complex_data' },
	      complex_stypes: [{ 'stype': 12, 'name': '新闻' }, { 'stype': 4, 'name': '知识库' }, { 'stype': 13, 'name': '研报数据' }, { 'stype': 11, 'name': '研报' }, { 'stype': 14, 'name': '数据' }, { 'stype': 1, 'name': 'A股' }, { 'stype': 2, 'name': '新三板' }, { 'stype': 5, 'name': '问题库' }, { 'stype': 6, 'name': '港股' }, { 'stype': 3, 'name': '债券' }, { 'stype': 10, 'name': 'ABS' }],
	      complex_agu: null,
	      complex_n3b: null,
	      complex_bond: null,
	      complex_knowledge: null,
	      complex_qa: null,
	      complex_hk: null,
	      complex_abs: null,
	      complex_yb: null,
	      complex_news: null,
	      complex_reportdata: null,
	      complex_data: null,
	      tipGoBind: false,
	      currentRegtyp: '',
	      goBindPageShortLink: '',
	      reportDataTotal: null,
	      reportDataTotalPage: null
	    };
	  },
	
	  watch: {
	    'stype': function stype(val, oldVal) {
	      if (val === 1 || val === 5) {
	        this.pholder = '002330';
	      } else if (val === 2) {
	        this.pholder = '835605';
	      } else if (val === 6) {
	        this.pholder = '08072';
	      } else {
	        this.pholder = '';
	      }
	    }
	  },
	  methods: {
	    getAllDay: function getAllDay(begin, end) {
	      Date.prototype.format = function () {
	        var s = '';
	        var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
	        var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
	
	        s += this.getFullYear() + '-';
	        s += mouth + "-";
	        s += day;
	
	        return s;
	      };
	
	      var allDay = [];
	      var ab = begin.split("-");
	      var ae = end.split("-");
	      var db = new Date();
	
	      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
	
	      var de = new Date();
	      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
	
	      var unixDb = db.getTime();
	      var unixDe = de.getTime();
	      for (var k = unixDb; k <= unixDe;) {
	        allDay.push(new Date(parseInt(k)).format());
	        k = k + 24 * 60 * 60 * 1000;
	      }
	
	      return allDay;
	    },
	    goCompanyInfo: function goCompanyInfo(code) {
	      console.log(code);
	      if ((0, _stringify2.default)(this.smartEngine.companyInfo) == "{}") {
	        this.getCompanyDetail(code);
	      }
	      this.smartEngine.open = true;
	    },
	    getCompanyDetail: function getCompanyDetail(code) {
	      var _this = this;
	
	      var query = {};
	      query.code = code;
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/detail'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.smartEngine.companyInfo = response.data;
	        } else {
	          _this.loading = false;
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    setCompanyCode: function setCompanyCode(i) {
	      var idx = i.indexOf('(');
	      this.companyCode = i.substr(0, idx);
	      this.companyCode = this.companyCode.trim();
	      this.suggestions = [];
	    },
	    addKeywordCondition: function addKeywordCondition() {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.keywords_condition.push({
	        val: '',
	        ttype: 0,
	        ttname: '全部',
	        optype: 1,
	        opname: '包含全部关键词'
	      });
	    },
	    changeStype: function changeStype(val) {
	      console.log(val);
	
	      this.showTypAll = true;
	
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var oldVal = this.stype;
	
	      if (val == 17) {
	        console.log('english');
	        console.log('val == 17');
	        if (!this.checkPrivilege('search/english', '暂无权限english')) {
	          return false;
	        }
	      }
	
	      if (val == 1) {
	        console.log("跳转到A股");
	        console.log('val == 1');
	        if (!this.checkPrivilege('search/a', '暂无权限A')) {
	          return false;
	        }
	        var plateAll = this.plateAll;
	        var plates = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(plateAll['A']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var t = _step.value;
	
	            t.count = 0;
	            plates.push(t);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.plates = plates;
	
	        this.types = this.getTypeByCat('A');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = true;
	        this.showRegion = true;
	        this.showSecurityCompany = false;
	        this.showIndustry = true;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 2) {
	        console.log("跳转到新三板");
	        if (!this.checkPrivilege('search/n3b', '暂无权限')) {
	          return false;
	        }
	        var _plateAll = this.plateAll;
	        var _plates = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(_plateAll['N3B']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _t = _step2.value;
	
	            if (!_t.count) {
	              _t.count = 0;
	            }
	            _plates.push(_t);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.plates = _plates;
	
	        this.types = this.getTypeByCat('N3B');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = true;
	        this.showRegion = true;
	        this.showSecurityCompany = true;
	        this.showIndustry = true;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 3) {
	        console.log("跳转到债券");
	        if (!this.checkPrivilege('search/bond', '暂无权限')) {
	          return false;
	        }
	        this.types = this.getTypeByCat('ChinaBond');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = true;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 5) {
	        console.log("跳转到问题库");
	        if (!this.checkPrivilege('search/qa', '暂无权限')) {
	          return false;
	        }
	        this.showType = false;
	        this.showQaType = true;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = true;
	        this.showSubTitle = false;
	        this.showLabels = false;
	        this.showStage = false;
	        if (this.ttype === 2) {
	          this.ttype = 0;
	        }
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.keywords_condition), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var k = _step3.value;
	
	            if (k.ttype === 2) {
	              this.changeKyTtype(k, 0, '全部');
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      } else {
	        if (this.ttype === 4 || this.ttype === 5) {
	          this.ttype = 0;
	        }
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.keywords_condition), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _k = _step4.value;
	
	            if (_k.ttype === 4 || _k.ttype === 5) {
	              this.changeKyTtype(_k, 0, '全部');
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	
	      if (val === 6) {
	        console.log("跳转到港股");
	        if (!this.checkPrivilege('search/h', '暂无权限')) {
	          return false;
	        }
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val === 11) {
	        if (!this.checkPrivilege('search/report', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到研报");
	        var arr = [4, 5];
	        this.tabChangeCtrl(arr);
	        this.types = this.getTypeByCat('Report');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	      if (val == 17) {
	        if (!this.checkPrivilege('search/english', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到 english");
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val === 4) {
	        if (!this.checkPrivilege('search/weixin', '暂无权限')) {
	          return false;
	        }
	        console.log("知识库");
	        var _arr = [4, 5];
	        this.tabChangeCtrl(_arr);
	        this.types = this.getTypeByCat('Weixin');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 7) {
	        if (!this.checkPrivilege('search/lawnotice', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到法律公告");
	        var _arr2 = [4, 5];
	        this.tabChangeCtrl(_arr2);
	        this.types = this.getTypeByCat('Lawnotice');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 8) {
	        if (!this.checkPrivilege('search/legal', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到裁判文书");
	        var _arr3 = [4, 5];
	        this.tabChangeCtrl(_arr3);
	        this.types = this.getTypeByCat('Legal');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 9) {
	        if (!this.checkPrivilege('search/gov', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到政府公告");
	        var _arr4 = [4, 5];
	        this.tabChangeCtrl(_arr4);
	        this.types = this.getTypeByCat('Gov');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 10) {
	        if (!this.checkPrivilege('search/abs', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到ABS");
	        var _arr5 = [4, 5];
	        this.tabChangeCtrl(_arr5);
	        this.types = this.getTypeByCat('Abs');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 12) {
	        if (!this.checkPrivilege('search/news', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到新闻");
	        var _arr6 = [4, 5];
	        this.tabChangeCtrl(_arr6);
	        console.log(111111111111111);
	        this.types = this.getTypeByCat('News');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 15) {
	        if (!this.checkPrivilege('search/docs', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到我的文档");
	        var _arr7 = [4, 5];
	        this.tabChangeCtrl(_arr7);
	        this.types = this.getTypeByCat('Docs');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 100) {
	        console.log("综合搜索");
	        var _arr8 = [2, 4, 5, 6, 7, 8, 9];
	        this.tabChangeCtrl(_arr8);
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 13) {
	        console.log("研报数据");
	        var _arr9 = [2, 4, 5, 6, 7, 8, 9];
	        this.tabChangeCtrl(_arr9);
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      this.stype = val;
	
	      if (val != 100) {
	        for (var item in this.condition_field) {
	          this.currStypObj[oldVal][item] = this[item];
	        }
	
	        this.currStypObj[oldVal]['conditions'] = this.conditions;
	        this.conditions = { 'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {} };
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = (0, _getIterator3.default)(this.industry), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var i = _step5.value;
	
	            i.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = (0, _getIterator3.default)(this.plates), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var j = _step6.value;
	
	            j.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	              _iterator6.return();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	
	        console.log('node node node');
	        console.log(this.currStypObj);
	        console.log("Obejct.keys 里面参数");
	        console.log(this.currStypObj);
	        console.log(this.currStypObj[val]);
	
	        if ((0, _keys2.default)(this.currStypObj[val]).length > 0) {
	          for (var _item in this.condition_field) {
	            this[_item] = this.currStypObj[val][_item];
	          }
	          console.log('11-11');
	          this.conditions = this.currStypObj[val]['conditions'];
	          console.log('11-22');
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = (0, _getIterator3.default)(this.industry), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var _k2 = _step7.value;
	
	              this.setNum('industrysecond', _k2);
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          console.log('11-33');
	          var _iteratorNormalCompletion8 = true;
	          var _didIteratorError8 = false;
	          var _iteratorError8 = undefined;
	
	          try {
	            for (var _iterator8 = (0, _getIterator3.default)(this.plates), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	              var _t2 = _step8.value;
	
	              this.setNum('layer', _t2);
	            }
	          } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	            } finally {
	              if (_didIteratorError8) {
	                throw _iteratorError8;
	              }
	            }
	          }
	
	          console.log('11-44');
	        } else {
	          console.log(1111);
	          for (var _item2 in this.condition_field) {
	            this[_item2] = this.condition_field[_item2];
	          }
	          this.conditions = { 'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {} };
	          console.log(122222);
	        }
	
	        console.log('conditions');
	        console.log(this.conditions);
	        this.addToShow();
	        if (this.tagclicked) {
	          this.searchByTagAfter(this.tagdata);
	          this.tagclicked = false;
	        }
	      }
	    },
	
	    tabChangeCtrl: function tabChangeCtrl(arr) {
	      if (arr.indexOf(this.ttype) >= 0) {
	        this.ttype = 0;
	      }
	      var _iteratorNormalCompletion9 = true;
	      var _didIteratorError9 = false;
	      var _iteratorError9 = undefined;
	
	      try {
	        for (var _iterator9 = (0, _getIterator3.default)(this.keywords_condition), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	          var k = _step9.value;
	
	          if (arr.indexOf(k.ttype) >= 0) {
	            this.changeKyTtype(k, 0, '全部');
	          }
	        }
	      } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion9 && _iterator9.return) {
	            _iterator9.return();
	          }
	        } finally {
	          if (_didIteratorError9) {
	            throw _iteratorError9;
	          }
	        }
	      }
	    },
	
	    viewUrl: function viewUrl(item) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        if (item.pid) {
	          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	        } else {
	          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	        }
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    qaViewUrl: function qaViewUrl(item) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        return '/#!/qaview/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    getMeta: function getMeta() {
	      var _this2 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/meta'),
	        method: 'post',
	        async: false,
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this2.typeAll = response.types;
	          var plateAll = response.plates;
	          for (var t in plateAll) {
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	              for (var _iterator10 = (0, _getIterator3.default)(plateAll[t]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                var d = _step10.value;
	
	                d.showChild = false;
	                d.count = 0;
	              }
	            } catch (err) {
	              _didIteratorError10 = true;
	              _iteratorError10 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                  _iterator10.return();
	                }
	              } finally {
	                if (_didIteratorError10) {
	                  throw _iteratorError10;
	                }
	              }
	            }
	          }
	          _this2.plateAll = plateAll;
	          var region = response.region;
	          for (var k in region) {
	            var _t3 = region[k];
	            _t3.count = 0;
	            region[k] = _t3;
	          }
	          _this2.regions = region;
	          var industry = response.industry;
	          for (var _k3 in industry) {
	            var _t4 = industry[_k3];
	            _t4.count = 0;
	            _t4.showChild = false;
	            industry[_k3] = _t4;
	          }
	          _this2.industry = industry;
	          var securityCompany = response.securityCompany;
	          for (var _k4 in securityCompany) {
	            var _t5 = securityCompany[_k4];
	            _t5.count = 0;
	            securityCompany[_k4] = _t5;
	          }
	          _this2.securityCompany = securityCompany;
	          _this2.qaTypes = response.qaTypes;
	          _this2.changeStype(_this2.stype);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    hideCondition: function hideCondition() {
	      this.showConditionFlag = '';
	      this.showSort = false;
	      this.ttype_dropdown = false;
	    },
	    indentChild: function indentChild(code) {
	      var len = code.split('.').length - 2;
	    },
	    parseUrlQuery: function parseUrlQuery(query) {
	      if (query.hasOwnProperty('conditions')) {
	        var conditions = query['conditions'].split(',');
	        var _iteratorNormalCompletion11 = true;
	        var _didIteratorError11 = false;
	        var _iteratorError11 = undefined;
	
	        try {
	          for (var _iterator11 = (0, _getIterator3.default)(conditions), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	            var c = _step11.value;
	
	            var carr = c.split('_');
	            if (carr.length === 3) {
	              var type = carr[0];
	              var code = carr[1];
	              var name = carr[2];
	              var tmp = {};
	              tmp[code] = name;
	              this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], tmp);
	            }
	          }
	        } catch (err) {
	          _didIteratorError11 = true;
	          _iteratorError11 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion11 && _iterator11.return) {
	              _iterator11.return();
	            }
	          } finally {
	            if (_didIteratorError11) {
	              throw _iteratorError11;
	            }
	          }
	        }
	      } else {
	        this.conditions = {
	          'type': {},
	          'qaType': {},
	          'plate': {},
	          'layer': {},
	          'region': {},
	          'industry': {},
	          'industrysecond': {},
	          'securityCompany': {},
	          'labels': {}
	        };
	      }
	      if (query.hasOwnProperty('industry')) {
	        var industry = query['industry'].split(',');
	        var _iteratorNormalCompletion12 = true;
	        var _didIteratorError12 = false;
	        var _iteratorError12 = undefined;
	
	        try {
	          for (var _iterator12 = (0, _getIterator3.default)(industry), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	            var _c = _step12.value;
	
	            var arr = _c.split('_');
	            if (arr.length === 2) {
	              var idx = arr[0];
	              var count = arr[1];
	              this.industry[idx].count = parseInt(count);
	            }
	          }
	        } catch (err) {
	          _didIteratorError12 = true;
	          _iteratorError12 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion12 && _iterator12.return) {
	              _iterator12.return();
	            }
	          } finally {
	            if (_didIteratorError12) {
	              throw _iteratorError12;
	            }
	          }
	        }
	      } else {
	        var _iteratorNormalCompletion13 = true;
	        var _didIteratorError13 = false;
	        var _iteratorError13 = undefined;
	
	        try {
	          for (var _iterator13 = (0, _getIterator3.default)(this.industry), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	            var i = _step13.value;
	
	            i.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError13 = true;
	          _iteratorError13 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion13 && _iterator13.return) {
	              _iterator13.return();
	            }
	          } finally {
	            if (_didIteratorError13) {
	              throw _iteratorError13;
	            }
	          }
	        }
	      }
	      if (query.hasOwnProperty('keywords_condition')) {
	        var _conditions = query['keywords_condition'].split(',');
	        var keywordCondition = [];
	        var _iteratorNormalCompletion14 = true;
	        var _didIteratorError14 = false;
	        var _iteratorError14 = undefined;
	
	        try {
	          for (var _iterator14 = (0, _getIterator3.default)(_conditions), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	            var _c2 = _step14.value;
	
	            var _carr = _c2.split('_');
	            var val = _carr[0];
	            var ttype = _carr[1];
	            var optype = _carr[2];
	            var ttname = this.ttypeMap[ttype];
	            var opname = this.optypeMap[optype];
	            keywordCondition.push({
	              val: val,
	              ttype: parseInt(ttype),
	              ttname: ttname,
	              optype: parseInt(optype),
	              opname: opname
	            });
	          }
	        } catch (err) {
	          _didIteratorError14 = true;
	          _iteratorError14 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion14 && _iterator14.return) {
	              _iterator14.return();
	            }
	          } finally {
	            if (_didIteratorError14) {
	              throw _iteratorError14;
	            }
	          }
	        }
	
	        this.keywords_condition = keywordCondition;
	      } else {
	        this.keywords_condition = [{
	          val: '',
	          ttype: 0,
	          ttname: '全部',
	          optype: 1,
	          opname: '包含全部关键词'
	        }];
	      }
	
	      if (this.plates[0].child && this.plates[0].child.length > 0 && query['plate']) {
	        this.plateAll['N3B'][0].count = parseInt(query['plate']);
	        this.plates[0].count = parseInt(query['plate']);
	      } else {
	        this.plateAll['N3B'][0].count = 0;
	        this.plates[0].count = 0;
	      }
	      this.stype = parseInt(query['stype']) || 1;
	      this.ttype = parseInt(query['ttype']) || 0;
	      this.keywords = query['keywords'] || '';
	      this.companyCode = query['companyCode'] || '';
	      this.datetype = parseInt(query['datetype']) || 9;
	      this.startdate = query['startdate'] || '';
	      this.enddate = query['enddate'] || '';
	      if (!this.startdate && !this.enddate) {
	        this.changeDateType(this.datetype);
	      }
	      this.perPage = parseInt(query['perPage']) || 10;
	      this.page = parseInt(query['page']) || 1;
	      this.sort = parseInt(query['sort']) || 1;
	      this.onlyTitle = query['onlyTitle'] || 0;
	      this.parseVer = query['parseVer'] || '';
	      this.idxname = query['idxname'] || '';
	    },
	    showCondition: function showCondition(type) {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.showConditionFlag = type;
	    },
	    genUrlQuery: function genUrlQuery() {
	      var query = {};
	      var conditions = [];
	      var industry = [];
	      var anoConditions = [];
	      if (this.plates[0].count > 0) {
	        var plate = this.plates[0].count;
	        query['plate'] = plate;
	      }
	      for (var item in this.industry) {
	        if (this.industry[item].count !== 0) {
	          industry.push(item + '_' + this.industry[item].count);
	        }
	      }
	      query['industry'] = industry.join(',');
	      for (var type in this.conditions) {
	        for (var code in this.conditions[type]) {
	          conditions.push(type + '_' + code + '_' + this.conditions[type][code]);
	        }
	      }
	      query['conditions'] = conditions.join(',');
	      var keywordCondition = [];
	      var _iteratorNormalCompletion15 = true;
	      var _didIteratorError15 = false;
	      var _iteratorError15 = undefined;
	
	      try {
	        for (var _iterator15 = (0, _getIterator3.default)(this.keywords_condition), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	          var i = _step15.value;
	
	          i.val = this.delPunctuation(i.val);
	          keywordCondition.push(i.val + '_' + i.ttype + '_' + i.optype);
	        }
	      } catch (err) {
	        _didIteratorError15 = true;
	        _iteratorError15 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion15 && _iterator15.return) {
	            _iterator15.return();
	          }
	        } finally {
	          if (_didIteratorError15) {
	            throw _iteratorError15;
	          }
	        }
	      }
	
	      query['keywords_condition'] = keywordCondition.join(',');
	      query['stype'] = this.stype;
	      query['ttype'] = this.ttype;
	      query['keywords'] = this.keywords;
	      query['companyCode'] = this.companyCode;
	      query['datetype'] = this.datetype;
	      query['startdate'] = this.startdate;
	      query['enddate'] = this.enddate;
	      query['perPage'] = this.perPage;
	      query['page'] = this.page;
	      query['sort'] = this.sort;
	      query['onlyTitle'] = this.onlyTitle;
	      query['sts'] = new Date().getTime();
	      query['parseVer'] = this.parseVer;
	      query['idxname'] = this.idxname;
	      query['ai'] = this.ai;
	
	      query['sid'] = this.params.sid;
	      query['ruid'] = this.params.uidUrl;
	      return query;
	    },
	    genQuery: function genQuery() {
	      var query = {};
	      query['conditions'] = this.conditions;
	      query['stype'] = this.stype;
	      query['ttype'] = this.ttype;
	      query['keywords'] = this.delPunctuation(this.keywords);
	      query['companyCode'] = this.companyCode;
	      query['datetype'] = this.datetype;
	      query['startdate'] = this.startdate;
	      query['enddate'] = this.enddate;
	
	      query['keywords_condition'] = this.keywords_condition;
	      query['perPage'] = this.perPage;
	      query['page'] = this.page;
	      query['sort'] = this.sort;
	      query['parseVer'] = this.parseVer;
	      query['idxname'] = this.idxname;
	      query['sid'] = this.sid;
	      query['ruid'] = this.params.uidUrl;
	      if (this.ai === 1) {
	        query['ai'] = 1;
	      }
	      return query;
	    },
	
	    delPunctuation: function delPunctuation(str) {
	      var s = str.replace(/[\ |\~|\!|\-|\_|\=|\[|\]|\，|\、|\‘|\’|\；|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, " ");
	      return s;
	    },
	    hideDropdown: function hideDropdown(e) {
	      console.log(e);
	      var target = (0, _jquery2.default)('.slide-menu');
	      if (!target.is(e.target) && target.has(e.target).length === 0) {
	        (0, _jquery2.default)('.slide-menu').css('display', 'none');
	        this.showDropdownMenu = '';
	      }
	    },
	    switchPage: function switchPage(val) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      if (val === 1) {
	        this.showSearchPage = true;
	        this.showTongjiPage = false;
	        this.showResultPage = false;
	      } else if (val === 2) {
	        this.showSearchPage = false;
	        this.showTongjiPage = false;
	        this.showResultPage = true;
	      } else if (val === 3) {
	        this.showSearchPage = false;
	        this.showTongjiPage = true;
	        this.showResultPage = false;
	        if (this.showStatFilter) {
	          this.showStatAnalyze = false;
	        }
	      }
	    },
	    viewTable: function viewTable(item, tcode, offset) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      console.log(item, tcode, offset);
	      console.log('查看全部表格');
	      var _offset = parseInt(offset) + 1;
	      var _tcode = tcode + '-' + _offset.toString();
	      var url = '';
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        } else {
	          url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    },
	    viewChildTitle: function viewChildTitle(item, tcode) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var _tcode = tcode + '-0';
	      console.log('点击小标题');
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          var url = '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
	          console.log(url);
	          window.location.href = url;
	        } else {
	          var url = '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
	          console.log(url);
	          window.location.href = url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    },
	
	    smartBtn: function smartBtn() {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      if (this.ai === 1) {
	        this.ai = 0;
	      } else {
	        if (!this.checkPrivilege('search/ai', '智能引擎功能火热测试中，暂由VIP用户专享！')) {
	          return false;
	        }
	        this.ai = 1;
	      }
	    },
	    getQueryString: function getQueryString(name) {
	      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	      var r = window.location.search.substr(1).match(reg);
	      if (r != null) return unescape(r[2]);
	      return null;
	    },
	    downloadApp: function downloadApp() {
	      var url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ikw.fse';
	      window.open(url);
	    },
	
	    backHistory: function backHistory() {
	      if (window.history.length > 1) {
	        if (document.cookie.indexOf('embed=1') >= 0) {
	          this.back = true;
	        }
	      }
	    },
	    showTipGoBind: function showTipGoBind() {
	      console.log('showTipGoBind');
	      var that = this;
	      var timer = setTimeout(function () {
	        that.tipGoBind = true;
	        console.log('showTipGoBind');
	      }, 5000);
	    },
	    goBindPage: function goBindPage(x) {
	      console.log('goBindPage');
	      if (x) {
	        var uri = encodeURIComponent(window.location.href);
	        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri;
	      } else {
	        var nowUrl = window.location.href;
	        this.getShortLink(nowUrl);
	        var _uri = encodeURIComponent(this.goBindPageShortLink);
	        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + _uri;
	      }
	    },
	    getShortLink: function getShortLink(url) {
	      var _this3 = this;
	
	      console.log('getshortlink');
	      var query = {};
	      query.uid = parseInt(this.uid);
	      query.url = url;
	      query.plat = 'mobile';
	      query.share = 'weixin';
	      query.action = 'SEARCH';
	      console.log(query);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/sharelink'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query),
	        async: false
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this3.goBindPageShortLink = response.url;
	        } else {
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    },
	    changeUrlArg: function changeUrlArg(url, arg, val) {
	      var pattern = arg + '=([^&]*)';
	      var replaceText = arg + '=' + val;
	      return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText;
	    },
	    fileIcon: function fileIcon(fileext) {
	      if (fileext === 'pdf') {
	        return 'pdf-icon';
	      }
	      if (fileext === 'docx' || fileext === 'doc') {
	        return 'dov-icon';
	      }
	      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
	        return 'html-icon';
	      }
	      if (fileext === 'xls' || fileext === 'xlsx') {
	        return 'xsl-icon';
	      }
	    },
	    complex: function complex() {
	      this.loading = true;
	      this.stypesArr = [];
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = (0, _getIterator3.default)(this.currentuser.actions), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var item = _step16.value;
	
	          if (item == 'search/a') {
	            this.stypesArr.push(1);
	          } else if (item == 'search/n3b') {
	            this.stypesArr.push(2);
	          } else if (item == 'search/bond') {
	            this.stypesArr.push(3);
	          } else if (item == 'search/weixin') {
	            this.stypesArr.push(4);
	          } else if (item == 'search/qa') {
	            this.stypesArr.push(5);
	          } else if (item == 'search/h') {
	            this.stypesArr.push(6);
	          } else if (item == 'search/report') {
	            this.stypesArr.push(11);
	          } else if (item == 'search/news') {
	            this.stypesArr.push(12);
	          } else if (item == 'search/reportdata') {
	            this.stypesArr.push(13);
	          }
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      console.log(this.stypesArr);
	      var len = this.stypesArr.length;
	      var typ = void 0;
	      if (len > 0) {
	        typ = this.stypesArr[len - 1];
	      }
	      var _iteratorNormalCompletion17 = true;
	      var _didIteratorError17 = false;
	      var _iteratorError17 = undefined;
	
	      try {
	        for (var _iterator17 = (0, _getIterator3.default)(this.stypesArr), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	          var _item3 = _step17.value;
	
	          this.complexSearch(_item3, typ);
	        }
	      } catch (err) {
	        _didIteratorError17 = true;
	        _iteratorError17 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion17 && _iterator17.return) {
	            _iterator17.return();
	          }
	        } finally {
	          if (_didIteratorError17) {
	            throw _iteratorError17;
	          }
	        }
	      }
	    },
	    complexSearch: function complexSearch(stype, fag) {
	      var _this4 = this;
	
	      var query = this.genQuery();
	      query.stypes = [stype];
	      query.perPage = 3;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchall'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          if ((0, _keys2.default)(response.data).length > 0) {
	            if (response.data[stype].hasOwnProperty('lists')) {
	              if (stype === 5) {
	                var items = response.data[stype].lists;
	                var _iteratorNormalCompletion18 = true;
	                var _didIteratorError18 = false;
	                var _iteratorError18 = undefined;
	
	                try {
	                  for (var _iterator18 = (0, _getIterator3.default)(items), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	                    var item = _step18.value;
	
	                    if (item.child) {
	                      var _iteratorNormalCompletion19 = true;
	                      var _didIteratorError19 = false;
	                      var _iteratorError19 = undefined;
	
	                      try {
	                        for (var _iterator19 = (0, _getIterator3.default)(item.child), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	                          var child = _step19.value;
	
	                          child.showque = false;
	                          if (child.answers) {
	                            var _iteratorNormalCompletion20 = true;
	                            var _didIteratorError20 = false;
	                            var _iteratorError20 = undefined;
	
	                            try {
	                              for (var _iterator20 = (0, _getIterator3.default)(child.answers), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	                                var ans = _step20.value;
	
	                                ans.showans = false;
	                              }
	                            } catch (err) {
	                              _didIteratorError20 = true;
	                              _iteratorError20 = err;
	                            } finally {
	                              try {
	                                if (!_iteratorNormalCompletion20 && _iterator20.return) {
	                                  _iterator20.return();
	                                }
	                              } finally {
	                                if (_didIteratorError20) {
	                                  throw _iteratorError20;
	                                }
	                              }
	                            }
	                          }
	                        }
	                      } catch (err) {
	                        _didIteratorError19 = true;
	                        _iteratorError19 = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion19 && _iterator19.return) {
	                            _iterator19.return();
	                          }
	                        } finally {
	                          if (_didIteratorError19) {
	                            throw _iteratorError19;
	                          }
	                        }
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError18 = true;
	                  _iteratorError18 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
	                      _iterator18.return();
	                    }
	                  } finally {
	                    if (_didIteratorError18) {
	                      throw _iteratorError18;
	                    }
	                  }
	                }
	
	                _this4[_this4.stypesMap[stype]] = items;
	                _this4.stypesTotal[stype] = response.data[stype].total;
	              } else {
	                _this4.stypesTotal[stype] = response.data[stype].total;
	                _this4[_this4.stypesMap[stype]] = response.data[stype].lists;
	                console.log(_this4.stypesTotal);
	              }
	            }
	          }
	          if (_this4[_this4.stypesMap[fag]]) {
	            _this4.loading = false;
	          }
	        }
	      });
	    },
	
	    viewImg: function viewImg(item, tcode, offset) {
	      console.log(tcode, offset);
	      console.log('查看图片 跳转详情');
	      var _offset = parseInt(offset) + 1;
	      var _tcode = tcode + '-' + _offset.toString();
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          var url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        } else {
	          var _url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = _url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    }
	  }
	};

/***/ },
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      loading: false,
	      searched: 0,
	      showTypAll: true,
	      sts: 0,
	      advsearch: 0,
	      cond_type: { 'type': '公告类型', 'labels': '公告标签', 'plate': '板块类型', 'layer': '挂牌公司', 'region': '地区类型', 'securityCompany': '主办劵商', 'industry': '行业类型', 'industrysecond': '行业子类', 'qaType': '问答类型' },
	
	      memory: {},
	
	      stype: 1,
	      ttype: 0,
	      ttype_name: '全部',
	      ttype_dropdown: false,
	      keywords: '',
	      companyCode: '',
	      publishDate: '',
	      datetype: 0,
	      datetype_name: '',
	      ttypeMap: { 0: '全部', 1: '标题', 2: '章节标题', 3: '正文', 4: '问题', 5: '答案', 6: '图片' },
	      optypeMap: { 1: '包含全部关键词', 2: '包含任意关键词', 3: '不含全部关键词' },
	      keywords_condition: [{
	        val: '',
	        ttype: 0,
	        ttname: '全部',
	        optype: 1,
	        opname: '包含全部关键词'
	      }],
	      typeAll: [],
	      types: [],
	      qaTypes: [],
	      plateAll: {},
	      plates: [],
	      regions: [],
	      securityCompany: [],
	      industry: [],
	      showConditionFlag: '',
	
	      showSubTitle: true,
	
	      showModal: false,
	      tagname: '',
	
	      parseVer: '',
	      idxname: '',
	
	      pholder: '002330',
	      showDropdownMenu: '',
	      ai: 0,
	      smartEngine: {
	        open: false,
	        companyInfo: {}
	      },
	      condition_field: {
	        'havelabels': false,
	        'showPla': false,
	        'showInd': false,
	        'companyCode': ''
	      },
	      reportDataList: [],
	      currStypObj: {
	        "1": {},
	        "2": {},
	        "3": {},
	        "4": {},
	        "5": {},
	        "6": {},
	        "7": {},
	        "8": {},
	        "9": {},
	        "10": {},
	        "11": {},
	        "12": {},
	        "13": {},
	        "14": {},
	        "15": {},
	        "17": {},
	        "100": {}
	      },
	      stypesArr: [],
	      stypesTotal: { '1': 0, '2': 0, '3': 0, '4': 0, '5': 0, '6': 0, '10': 0, '11': 0, '12': 0, '13': 0, '14': 0 },
	      stypesMap: { '1': 'complex_agu', '2': 'complex_n3b', '3': 'complex_bond', '4': 'complex_knowledge', '5': 'complex_qa', '6': 'complex_hk', '10': 'complex_abs', '11': 'complex_yb', '12': 'complex_news', '13': 'complex_reportdata', '14': 'complex_data' },
	      complex_stypes: [{ 'stype': 12, 'name': '新闻' }, { 'stype': 4, 'name': '知识库' }, { 'stype': 13, 'name': '研报数据' }, { 'stype': 11, 'name': '研报' }, { 'stype': 14, 'name': '数据' }, { 'stype': 1, 'name': 'A股' }, { 'stype': 2, 'name': '新三板' }, { 'stype': 5, 'name': '问题库' }, { 'stype': 6, 'name': '港股' }, { 'stype': 3, 'name': '债券' }, { 'stype': 10, 'name': 'ABS' }],
	      complex_agu: null,
	      complex_n3b: null,
	      complex_bond: null,
	      complex_knowledge: null,
	      complex_qa: null,
	      complex_hk: null,
	      complex_abs: null,
	      complex_yb: null,
	      complex_news: null,
	      complex_reportdata: null,
	      complex_data: null,
	      tipGoBind: false,
	      currentRegtyp: '',
	      goBindPageShortLink: '',
	      reportDataTotal: null,
	      reportDataTotalPage: null
	    };
	  },
	
	  watch: {
	    'stype': function stype(val, oldVal) {
	      if (val === 1 || val === 5) {
	        this.pholder = '002330';
	      } else if (val === 2) {
	        this.pholder = '835605';
	      } else if (val === 6) {
	        this.pholder = '08072';
	      } else {
	        this.pholder = '';
	      }
	    }
	  },
	  methods: {
	    getAllDay: function getAllDay(begin, end) {
	      Date.prototype.format = function () {
	        var s = '';
	        var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
	        var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
	
	        s += this.getFullYear() + '-';
	        s += mouth + "-";
	        s += day;
	
	        return s;
	      };
	
	      var allDay = [];
	      var ab = begin.split("-");
	      var ae = end.split("-");
	      var db = new Date();
	
	      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
	
	      var de = new Date();
	      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
	
	      var unixDb = db.getTime();
	      var unixDe = de.getTime();
	      for (var k = unixDb; k <= unixDe;) {
	        allDay.push(new Date(parseInt(k)).format());
	        k = k + 24 * 60 * 60 * 1000;
	      }
	
	      return allDay;
	    },
	    goCompanyInfo: function goCompanyInfo(code) {
	      console.log(code);
	      if ((0, _stringify2.default)(this.smartEngine.companyInfo) == "{}") {
	        this.getCompanyDetail(code);
	      }
	      this.smartEngine.open = true;
	    },
	    getCompanyDetail: function getCompanyDetail(code) {
	      var _this = this;
	
	      var query = {};
	      query.code = code;
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/detail'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.smartEngine.companyInfo = response.data;
	        } else {
	          _this.loading = false;
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    setCompanyCode: function setCompanyCode(i) {
	      var idx = i.indexOf('(');
	      this.companyCode = i.substr(0, idx);
	      this.companyCode = this.companyCode.trim();
	      this.suggestions = [];
	    },
	    addKeywordCondition: function addKeywordCondition() {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.keywords_condition.push({
	        val: '',
	        ttype: 0,
	        ttname: '全部',
	        optype: 1,
	        opname: '包含全部关键词'
	      });
	    },
	    changeStype: function changeStype(val) {
	      console.log(val);
	
	      this.showTypAll = true;
	
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var oldVal = this.stype;
	
	      if (val == 17) {
	        console.log('english');
	        console.log('val == 17');
	        if (!this.checkPrivilege('search/english', '暂无权限english')) {
	          return false;
	        }
	      }
	
	      if (val == 1) {
	        console.log("跳转到A股");
	        console.log('val == 1');
	        if (!this.checkPrivilege('search/a', '暂无权限A')) {
	          return false;
	        }
	        var plateAll = this.plateAll;
	        var plates = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(plateAll['A']), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var t = _step.value;
	
	            t.count = 0;
	            plates.push(t);
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.plates = plates;
	
	        this.types = this.getTypeByCat('A');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = true;
	        this.showRegion = true;
	        this.showSecurityCompany = false;
	        this.showIndustry = true;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 2) {
	        console.log("跳转到新三板");
	        if (!this.checkPrivilege('search/n3b', '暂无权限')) {
	          return false;
	        }
	        var _plateAll = this.plateAll;
	        var _plates = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(_plateAll['N3B']), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var _t = _step2.value;
	
	            if (!_t.count) {
	              _t.count = 0;
	            }
	            _plates.push(_t);
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.plates = _plates;
	
	        this.types = this.getTypeByCat('N3B');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = true;
	        this.showRegion = true;
	        this.showSecurityCompany = true;
	        this.showIndustry = true;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 3) {
	        console.log("跳转到债券");
	        if (!this.checkPrivilege('search/bond', '暂无权限')) {
	          return false;
	        }
	        this.types = this.getTypeByCat('ChinaBond');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = true;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val == 5) {
	        console.log("跳转到问题库");
	        if (!this.checkPrivilege('search/qa', '暂无权限')) {
	          return false;
	        }
	        this.showType = false;
	        this.showQaType = true;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = true;
	        this.showSubTitle = false;
	        this.showLabels = false;
	        this.showStage = false;
	        if (this.ttype === 2) {
	          this.ttype = 0;
	        }
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.keywords_condition), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var k = _step3.value;
	
	            if (k.ttype === 2) {
	              this.changeKyTtype(k, 0, '全部');
	            }
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      } else {
	        if (this.ttype === 4 || this.ttype === 5) {
	          this.ttype = 0;
	        }
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.keywords_condition), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var _k = _step4.value;
	
	            if (_k.ttype === 4 || _k.ttype === 5) {
	              this.changeKyTtype(_k, 0, '全部');
	            }
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	
	      if (val === 6) {
	        console.log("跳转到港股");
	        if (!this.checkPrivilege('search/h', '暂无权限')) {
	          return false;
	        }
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val === 11) {
	        if (!this.checkPrivilege('search/report', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到研报");
	        var arr = [4, 5];
	        this.tabChangeCtrl(arr);
	        this.types = this.getTypeByCat('Report');
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	      if (val == 17) {
	        if (!this.checkPrivilege('search/english', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到 english");
	        this.showType = true;
	        this.showQaType = false;
	        this.showPlate = false;
	        this.showRegion = false;
	        this.showSecurityCompany = false;
	        this.showIndustry = false;
	        this.showSubTitle = true;
	        this.showLabels = false;
	        this.showStage = false;
	      }
	
	      if (val === 4) {
	        if (!this.checkPrivilege('search/weixin', '暂无权限')) {
	          return false;
	        }
	        console.log("知识库");
	        var _arr = [4, 5];
	        this.tabChangeCtrl(_arr);
	        this.types = this.getTypeByCat('Weixin');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 7) {
	        if (!this.checkPrivilege('search/lawnotice', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到法律公告");
	        var _arr2 = [4, 5];
	        this.tabChangeCtrl(_arr2);
	        this.types = this.getTypeByCat('Lawnotice');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 8) {
	        if (!this.checkPrivilege('search/legal', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到裁判文书");
	        var _arr3 = [4, 5];
	        this.tabChangeCtrl(_arr3);
	        this.types = this.getTypeByCat('Legal');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 9) {
	        if (!this.checkPrivilege('search/gov', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到政府公告");
	        var _arr4 = [4, 5];
	        this.tabChangeCtrl(_arr4);
	        this.types = this.getTypeByCat('Gov');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 10) {
	        if (!this.checkPrivilege('search/abs', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到ABS");
	        var _arr5 = [4, 5];
	        this.tabChangeCtrl(_arr5);
	        this.types = this.getTypeByCat('Abs');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 12) {
	        if (!this.checkPrivilege('search/news', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到新闻");
	        var _arr6 = [4, 5];
	        this.tabChangeCtrl(_arr6);
	        console.log(111111111111111);
	        this.types = this.getTypeByCat('News');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      if (val === 15) {
	        if (!this.checkPrivilege('search/docs', '暂无权限')) {
	          return false;
	        }
	        console.log("跳转到我的文档");
	        var _arr7 = [4, 5];
	        this.tabChangeCtrl(_arr7);
	        this.types = this.getTypeByCat('Docs');
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 100) {
	        console.log("综合搜索");
	        var _arr8 = [2, 4, 5, 6, 7, 8, 9];
	        this.tabChangeCtrl(_arr8);
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	      if (val === 13) {
	        console.log("研报数据");
	        var _arr9 = [2, 4, 5, 6, 7, 8, 9];
	        this.tabChangeCtrl(_arr9);
	        this.showTypAll = false;
	        this.showLabels = false;
	        this.showStage = false;
	        this.showSubTitle = false;
	      }
	
	      this.stype = val;
	
	      if (val != 100) {
	        for (var item in this.condition_field) {
	          this.currStypObj[oldVal][item] = this[item];
	        }
	
	        this.currStypObj[oldVal]['conditions'] = this.conditions;
	        this.conditions = { 'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {} };
	
	        var _iteratorNormalCompletion5 = true;
	        var _didIteratorError5 = false;
	        var _iteratorError5 = undefined;
	
	        try {
	          for (var _iterator5 = (0, _getIterator3.default)(this.industry), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	            var i = _step5.value;
	
	            i.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError5 = true;
	          _iteratorError5 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion5 && _iterator5.return) {
	              _iterator5.return();
	            }
	          } finally {
	            if (_didIteratorError5) {
	              throw _iteratorError5;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion6 = true;
	        var _didIteratorError6 = false;
	        var _iteratorError6 = undefined;
	
	        try {
	          for (var _iterator6 = (0, _getIterator3.default)(this.plates), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	            var j = _step6.value;
	
	            j.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError6 = true;
	          _iteratorError6 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	              _iterator6.return();
	            }
	          } finally {
	            if (_didIteratorError6) {
	              throw _iteratorError6;
	            }
	          }
	        }
	
	        console.log('node node node');
	        console.log(this.currStypObj);
	        console.log("Obejct.keys 里面参数");
	        console.log(this.currStypObj);
	        console.log(this.currStypObj[val]);
	
	        if ((0, _keys2.default)(this.currStypObj[val]).length > 0) {
	          for (var _item in this.condition_field) {
	            this[_item] = this.currStypObj[val][_item];
	          }
	          console.log('11-11');
	          this.conditions = this.currStypObj[val]['conditions'];
	          console.log('11-22');
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = (0, _getIterator3.default)(this.industry), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var _k2 = _step7.value;
	
	              this.setNum('industrysecond', _k2);
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          console.log('11-33');
	          var _iteratorNormalCompletion8 = true;
	          var _didIteratorError8 = false;
	          var _iteratorError8 = undefined;
	
	          try {
	            for (var _iterator8 = (0, _getIterator3.default)(this.plates), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	              var _t2 = _step8.value;
	
	              this.setNum('layer', _t2);
	            }
	          } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	            } finally {
	              if (_didIteratorError8) {
	                throw _iteratorError8;
	              }
	            }
	          }
	
	          console.log('11-44');
	        } else {
	          console.log(1111);
	          for (var _item2 in this.condition_field) {
	            this[_item2] = this.condition_field[_item2];
	          }
	          this.conditions = { 'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {} };
	          console.log(122222);
	        }
	
	        console.log('conditions');
	        console.log(this.conditions);
	        this.addToShow();
	        if (this.tagclicked) {
	          this.searchByTagAfter(this.tagdata);
	          this.tagclicked = false;
	        }
	      }
	    },
	
	    tabChangeCtrl: function tabChangeCtrl(arr) {
	      if (arr.indexOf(this.ttype) >= 0) {
	        this.ttype = 0;
	      }
	      var _iteratorNormalCompletion9 = true;
	      var _didIteratorError9 = false;
	      var _iteratorError9 = undefined;
	
	      try {
	        for (var _iterator9 = (0, _getIterator3.default)(this.keywords_condition), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	          var k = _step9.value;
	
	          if (arr.indexOf(k.ttype) >= 0) {
	            this.changeKyTtype(k, 0, '全部');
	          }
	        }
	      } catch (err) {
	        _didIteratorError9 = true;
	        _iteratorError9 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion9 && _iterator9.return) {
	            _iterator9.return();
	          }
	        } finally {
	          if (_didIteratorError9) {
	            throw _iteratorError9;
	          }
	        }
	      }
	    },
	
	    viewUrl: function viewUrl(item) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        if (item.pid) {
	          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	        } else {
	          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	        }
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    qaViewUrl: function qaViewUrl(item) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        return '/#!/qaview/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + this.params.share + '&plat=' + this.params.plat + '&sid=' + this.params.sid + '&ruid=' + this.params.ruid;
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    getMeta: function getMeta() {
	      var _this2 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/meta'),
	        method: 'post',
	        async: false,
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this2.typeAll = response.types;
	          var plateAll = response.plates;
	          for (var t in plateAll) {
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	              for (var _iterator10 = (0, _getIterator3.default)(plateAll[t]), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                var d = _step10.value;
	
	                d.showChild = false;
	                d.count = 0;
	              }
	            } catch (err) {
	              _didIteratorError10 = true;
	              _iteratorError10 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                  _iterator10.return();
	                }
	              } finally {
	                if (_didIteratorError10) {
	                  throw _iteratorError10;
	                }
	              }
	            }
	          }
	          _this2.plateAll = plateAll;
	          var region = response.region;
	          for (var k in region) {
	            var _t3 = region[k];
	            _t3.count = 0;
	            region[k] = _t3;
	          }
	          _this2.regions = region;
	          var industry = response.industry;
	          for (var _k3 in industry) {
	            var _t4 = industry[_k3];
	            _t4.count = 0;
	            _t4.showChild = false;
	            industry[_k3] = _t4;
	          }
	          _this2.industry = industry;
	          var securityCompany = response.securityCompany;
	          for (var _k4 in securityCompany) {
	            var _t5 = securityCompany[_k4];
	            _t5.count = 0;
	            securityCompany[_k4] = _t5;
	          }
	          _this2.securityCompany = securityCompany;
	          _this2.qaTypes = response.qaTypes;
	          _this2.changeStype(_this2.stype);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    hideCondition: function hideCondition() {
	      this.showConditionFlag = '';
	      this.showSort = false;
	      this.ttype_dropdown = false;
	    },
	    indentChild: function indentChild(code) {
	      var len = code.split('.').length - 2;
	    },
	    parseUrlQuery: function parseUrlQuery(query) {
	      if (query.hasOwnProperty('conditions')) {
	        var conditions = query['conditions'].split(',');
	        var _iteratorNormalCompletion11 = true;
	        var _didIteratorError11 = false;
	        var _iteratorError11 = undefined;
	
	        try {
	          for (var _iterator11 = (0, _getIterator3.default)(conditions), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	            var c = _step11.value;
	
	            var carr = c.split('_');
	            if (carr.length === 3) {
	              var type = carr[0];
	              var code = carr[1];
	              var name = carr[2];
	              var tmp = {};
	              tmp[code] = name;
	              this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], tmp);
	            }
	          }
	        } catch (err) {
	          _didIteratorError11 = true;
	          _iteratorError11 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion11 && _iterator11.return) {
	              _iterator11.return();
	            }
	          } finally {
	            if (_didIteratorError11) {
	              throw _iteratorError11;
	            }
	          }
	        }
	      } else {
	        this.conditions = {
	          'type': {},
	          'qaType': {},
	          'plate': {},
	          'layer': {},
	          'region': {},
	          'industry': {},
	          'industrysecond': {},
	          'securityCompany': {},
	          'labels': {}
	        };
	      }
	      if (query.hasOwnProperty('industry')) {
	        var industry = query['industry'].split(',');
	        var _iteratorNormalCompletion12 = true;
	        var _didIteratorError12 = false;
	        var _iteratorError12 = undefined;
	
	        try {
	          for (var _iterator12 = (0, _getIterator3.default)(industry), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	            var _c = _step12.value;
	
	            var arr = _c.split('_');
	            if (arr.length === 2) {
	              var idx = arr[0];
	              var count = arr[1];
	              this.industry[idx].count = parseInt(count);
	            }
	          }
	        } catch (err) {
	          _didIteratorError12 = true;
	          _iteratorError12 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion12 && _iterator12.return) {
	              _iterator12.return();
	            }
	          } finally {
	            if (_didIteratorError12) {
	              throw _iteratorError12;
	            }
	          }
	        }
	      } else {
	        var _iteratorNormalCompletion13 = true;
	        var _didIteratorError13 = false;
	        var _iteratorError13 = undefined;
	
	        try {
	          for (var _iterator13 = (0, _getIterator3.default)(this.industry), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	            var i = _step13.value;
	
	            i.count = 0;
	          }
	        } catch (err) {
	          _didIteratorError13 = true;
	          _iteratorError13 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion13 && _iterator13.return) {
	              _iterator13.return();
	            }
	          } finally {
	            if (_didIteratorError13) {
	              throw _iteratorError13;
	            }
	          }
	        }
	      }
	      if (query.hasOwnProperty('keywords_condition')) {
	        var _conditions = query['keywords_condition'].split(',');
	        var keywordCondition = [];
	        var _iteratorNormalCompletion14 = true;
	        var _didIteratorError14 = false;
	        var _iteratorError14 = undefined;
	
	        try {
	          for (var _iterator14 = (0, _getIterator3.default)(_conditions), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	            var _c2 = _step14.value;
	
	            var _carr = _c2.split('_');
	            var val = _carr[0];
	            var ttype = _carr[1];
	            var optype = _carr[2];
	            var ttname = this.ttypeMap[ttype];
	            var opname = this.optypeMap[optype];
	            keywordCondition.push({
	              val: val,
	              ttype: parseInt(ttype),
	              ttname: ttname,
	              optype: parseInt(optype),
	              opname: opname
	            });
	          }
	        } catch (err) {
	          _didIteratorError14 = true;
	          _iteratorError14 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion14 && _iterator14.return) {
	              _iterator14.return();
	            }
	          } finally {
	            if (_didIteratorError14) {
	              throw _iteratorError14;
	            }
	          }
	        }
	
	        this.keywords_condition = keywordCondition;
	      } else {
	        this.keywords_condition = [{
	          val: '',
	          ttype: 0,
	          ttname: '全部',
	          optype: 1,
	          opname: '包含全部关键词'
	        }];
	      }
	
	      if (this.plates[0].child && this.plates[0].child.length > 0 && query['plate']) {
	        this.plateAll['N3B'][0].count = parseInt(query['plate']);
	        this.plates[0].count = parseInt(query['plate']);
	      } else {
	        this.plateAll['N3B'][0].count = 0;
	        this.plates[0].count = 0;
	      }
	      this.stype = parseInt(query['stype']) || 1;
	      this.ttype = parseInt(query['ttype']) || 0;
	      this.keywords = query['keywords'] || '';
	      this.companyCode = query['companyCode'] || '';
	      this.datetype = parseInt(query['datetype']) || 9;
	      this.startdate = query['startdate'] || '';
	      this.enddate = query['enddate'] || '';
	      if (!this.startdate && !this.enddate) {
	        this.changeDateType(this.datetype);
	      }
	      this.perPage = parseInt(query['perPage']) || 10;
	      this.page = parseInt(query['page']) || 1;
	      this.sort = parseInt(query['sort']) || 1;
	      this.onlyTitle = query['onlyTitle'] || 0;
	      this.parseVer = query['parseVer'] || '';
	      this.idxname = query['idxname'] || '';
	    },
	    showCondition: function showCondition(type) {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.showConditionFlag = type;
	    },
	    genUrlQuery: function genUrlQuery() {
	      var query = {};
	      var conditions = [];
	      var industry = [];
	      var anoConditions = [];
	      if (this.plates[0].count > 0) {
	        var plate = this.plates[0].count;
	        query['plate'] = plate;
	      }
	      for (var item in this.industry) {
	        if (this.industry[item].count !== 0) {
	          industry.push(item + '_' + this.industry[item].count);
	        }
	      }
	      query['industry'] = industry.join(',');
	      for (var type in this.conditions) {
	        for (var code in this.conditions[type]) {
	          conditions.push(type + '_' + code + '_' + this.conditions[type][code]);
	        }
	      }
	      query['conditions'] = conditions.join(',');
	      var keywordCondition = [];
	      var _iteratorNormalCompletion15 = true;
	      var _didIteratorError15 = false;
	      var _iteratorError15 = undefined;
	
	      try {
	        for (var _iterator15 = (0, _getIterator3.default)(this.keywords_condition), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	          var i = _step15.value;
	
	          i.val = this.delPunctuation(i.val);
	          keywordCondition.push(i.val + '_' + i.ttype + '_' + i.optype);
	        }
	      } catch (err) {
	        _didIteratorError15 = true;
	        _iteratorError15 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion15 && _iterator15.return) {
	            _iterator15.return();
	          }
	        } finally {
	          if (_didIteratorError15) {
	            throw _iteratorError15;
	          }
	        }
	      }
	
	      query['keywords_condition'] = keywordCondition.join(',');
	      query['stype'] = this.stype;
	      query['ttype'] = this.ttype;
	      query['keywords'] = this.keywords;
	      query['companyCode'] = this.companyCode;
	      query['datetype'] = this.datetype;
	      query['startdate'] = this.startdate;
	      query['enddate'] = this.enddate;
	      query['perPage'] = this.perPage;
	      query['page'] = this.page;
	      query['sort'] = this.sort;
	      query['onlyTitle'] = this.onlyTitle;
	      query['sts'] = new Date().getTime();
	      query['parseVer'] = this.parseVer;
	      query['idxname'] = this.idxname;
	      query['ai'] = this.ai;
	
	      query['sid'] = this.params.sid;
	      query['ruid'] = this.params.uidUrl;
	      return query;
	    },
	    genQuery: function genQuery() {
	      var query = {};
	      query['conditions'] = this.conditions;
	      query['stype'] = this.stype;
	      query['ttype'] = this.ttype;
	      query['keywords'] = this.delPunctuation(this.keywords);
	      query['companyCode'] = this.companyCode;
	      query['datetype'] = this.datetype;
	      query['startdate'] = this.startdate;
	      query['enddate'] = this.enddate;
	
	      query['keywords_condition'] = this.keywords_condition;
	      query['perPage'] = this.perPage;
	      query['page'] = this.page;
	      query['sort'] = this.sort;
	      query['parseVer'] = this.parseVer;
	      query['idxname'] = this.idxname;
	      query['sid'] = this.sid;
	      query['ruid'] = this.params.uidUrl;
	      if (this.ai === 1) {
	        query['ai'] = 1;
	      }
	      return query;
	    },
	
	    delPunctuation: function delPunctuation(str) {
	      var s = str.replace(/[\ |\~|\!|\-|\_|\=|\[|\]|\，|\、|\‘|\’|\；|\{|\}|\;|\:|\"|\'|\,|\<|\.|\>|\/|\?]/g, " ");
	      return s;
	    },
	    hideDropdown: function hideDropdown(e) {
	      console.log(e);
	      var target = (0, _jquery2.default)('.slide-menu');
	      if (!target.is(e.target) && target.has(e.target).length === 0) {
	        (0, _jquery2.default)('.slide-menu').css('display', 'none');
	        this.showDropdownMenu = '';
	      }
	    },
	    switchPage: function switchPage(val) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      if (val === 1) {
	        this.showSearchPage = true;
	        this.showTongjiPage = false;
	        this.showResultPage = false;
	      } else if (val === 2) {
	        this.showSearchPage = false;
	        this.showTongjiPage = false;
	        this.showResultPage = true;
	      } else if (val === 3) {
	        this.showSearchPage = false;
	        this.showTongjiPage = true;
	        this.showResultPage = false;
	        if (this.showStatFilter) {
	          this.showStatAnalyze = false;
	        }
	      }
	    },
	    viewTable: function viewTable(item, tcode, offset) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      console.log(item, tcode, offset);
	      console.log('查看全部表格');
	      var _offset = parseInt(offset) + 1;
	      var _tcode = tcode + '-' + _offset.toString();
	      var url = '';
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        } else {
	          url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    },
	    viewChildTitle: function viewChildTitle(item, tcode) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var _tcode = tcode + '-0';
	      console.log('点击小标题');
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          var url = '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
	          console.log(url);
	          window.location.href = url;
	        } else {
	          var url = '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + '&ccode=' + _tcode + '&idxname=' + this.idxname;
	          console.log(url);
	          window.location.href = url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    },
	
	    smartBtn: function smartBtn() {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      if (this.ai === 1) {
	        this.ai = 0;
	      } else {
	        if (!this.checkPrivilege('search/ai', '智能引擎功能火热测试中，暂由VIP用户专享！')) {
	          return false;
	        }
	        this.ai = 1;
	      }
	    },
	    getQueryString: function getQueryString(name) {
	      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
	      var r = window.location.search.substr(1).match(reg);
	      if (r != null) return unescape(r[2]);
	      return null;
	    },
	    downloadApp: function downloadApp() {
	      var url = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ikw.fse';
	      window.open(url);
	    },
	
	    backHistory: function backHistory() {
	      if (window.history.length > 1) {
	        if (document.cookie.indexOf('embed=1') >= 0) {
	          this.back = true;
	        }
	      }
	    },
	    showTipGoBind: function showTipGoBind() {
	      console.log('showTipGoBind');
	      var that = this;
	      var timer = setTimeout(function () {
	        that.tipGoBind = true;
	        console.log('showTipGoBind');
	      }, 5000);
	    },
	    goBindPage: function goBindPage(x) {
	      console.log('goBindPage');
	      if (x) {
	        var uri = encodeURIComponent(window.location.href);
	        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri;
	      } else {
	        var nowUrl = window.location.href;
	        this.getShortLink(nowUrl);
	        var _uri = encodeURIComponent(this.goBindPageShortLink);
	        window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + _uri;
	      }
	    },
	    getShortLink: function getShortLink(url) {
	      var _this3 = this;
	
	      console.log('getshortlink');
	      var query = {};
	      query.uid = parseInt(this.uid);
	      query.url = url;
	      query.plat = 'mobile';
	      query.share = 'weixin';
	      query.action = 'SEARCH';
	      console.log(query);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/sharelink'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query),
	        async: false
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this3.goBindPageShortLink = response.url;
	        } else {
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        console.log(response);
	      });
	    },
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    },
	    changeUrlArg: function changeUrlArg(url, arg, val) {
	      var pattern = arg + '=([^&]*)';
	      var replaceText = arg + '=' + val;
	      return url.match(pattern) ? url.replace(eval('/(' + arg + '=)([^&]*)/gi'), replaceText) : url.match('[\?]') ? url + '&' + replaceText : url + '?' + replaceText;
	    },
	    fileIcon: function fileIcon(fileext) {
	      if (fileext === 'pdf') {
	        return 'pdf-icon';
	      }
	      if (fileext === 'docx' || fileext === 'doc') {
	        return 'dov-icon';
	      }
	      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
	        return 'html-icon';
	      }
	      if (fileext === 'xls' || fileext === 'xlsx') {
	        return 'xsl-icon';
	      }
	    },
	    complex: function complex() {
	      this.loading = true;
	      this.stypesArr = [];
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = (0, _getIterator3.default)(this.currentuser.actions), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var item = _step16.value;
	
	          if (item == 'search/a') {
	            this.stypesArr.push(1);
	          } else if (item == 'search/n3b') {
	            this.stypesArr.push(2);
	          } else if (item == 'search/bond') {
	            this.stypesArr.push(3);
	          } else if (item == 'search/weixin') {
	            this.stypesArr.push(4);
	          } else if (item == 'search/qa') {
	            this.stypesArr.push(5);
	          } else if (item == 'search/h') {
	            this.stypesArr.push(6);
	          } else if (item == 'search/report') {
	            this.stypesArr.push(11);
	          } else if (item == 'search/news') {
	            this.stypesArr.push(12);
	          } else if (item == 'search/reportdata') {
	            this.stypesArr.push(13);
	          }
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      console.log(this.stypesArr);
	      var len = this.stypesArr.length;
	      var typ = void 0;
	      if (len > 0) {
	        typ = this.stypesArr[len - 1];
	      }
	      var _iteratorNormalCompletion17 = true;
	      var _didIteratorError17 = false;
	      var _iteratorError17 = undefined;
	
	      try {
	        for (var _iterator17 = (0, _getIterator3.default)(this.stypesArr), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	          var _item3 = _step17.value;
	
	          this.complexSearch(_item3, typ);
	        }
	      } catch (err) {
	        _didIteratorError17 = true;
	        _iteratorError17 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion17 && _iterator17.return) {
	            _iterator17.return();
	          }
	        } finally {
	          if (_didIteratorError17) {
	            throw _iteratorError17;
	          }
	        }
	      }
	    },
	    complexSearch: function complexSearch(stype, fag) {
	      var _this4 = this;
	
	      var query = this.genQuery();
	      query.stypes = [stype];
	      query.perPage = 3;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchall'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          if ((0, _keys2.default)(response.data).length > 0) {
	            if (response.data[stype].hasOwnProperty('lists')) {
	              if (stype === 5) {
	                var items = response.data[stype].lists;
	                var _iteratorNormalCompletion18 = true;
	                var _didIteratorError18 = false;
	                var _iteratorError18 = undefined;
	
	                try {
	                  for (var _iterator18 = (0, _getIterator3.default)(items), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	                    var item = _step18.value;
	
	                    if (item.child) {
	                      var _iteratorNormalCompletion19 = true;
	                      var _didIteratorError19 = false;
	                      var _iteratorError19 = undefined;
	
	                      try {
	                        for (var _iterator19 = (0, _getIterator3.default)(item.child), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	                          var child = _step19.value;
	
	                          child.showque = false;
	                          if (child.answers) {
	                            var _iteratorNormalCompletion20 = true;
	                            var _didIteratorError20 = false;
	                            var _iteratorError20 = undefined;
	
	                            try {
	                              for (var _iterator20 = (0, _getIterator3.default)(child.answers), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	                                var ans = _step20.value;
	
	                                ans.showans = false;
	                              }
	                            } catch (err) {
	                              _didIteratorError20 = true;
	                              _iteratorError20 = err;
	                            } finally {
	                              try {
	                                if (!_iteratorNormalCompletion20 && _iterator20.return) {
	                                  _iterator20.return();
	                                }
	                              } finally {
	                                if (_didIteratorError20) {
	                                  throw _iteratorError20;
	                                }
	                              }
	                            }
	                          }
	                        }
	                      } catch (err) {
	                        _didIteratorError19 = true;
	                        _iteratorError19 = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion19 && _iterator19.return) {
	                            _iterator19.return();
	                          }
	                        } finally {
	                          if (_didIteratorError19) {
	                            throw _iteratorError19;
	                          }
	                        }
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError18 = true;
	                  _iteratorError18 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion18 && _iterator18.return) {
	                      _iterator18.return();
	                    }
	                  } finally {
	                    if (_didIteratorError18) {
	                      throw _iteratorError18;
	                    }
	                  }
	                }
	
	                _this4[_this4.stypesMap[stype]] = items;
	                _this4.stypesTotal[stype] = response.data[stype].total;
	              } else {
	                _this4.stypesTotal[stype] = response.data[stype].total;
	                _this4[_this4.stypesMap[stype]] = response.data[stype].lists;
	                console.log(_this4.stypesTotal);
	              }
	            }
	          }
	          if (_this4[_this4.stypesMap[fag]]) {
	            _this4.loading = false;
	          }
	        }
	      });
	    },
	
	    viewImg: function viewImg(item, tcode, offset) {
	      console.log(tcode, offset);
	      console.log('查看图片 跳转详情');
	      var _offset = parseInt(offset) + 1;
	      var _tcode = tcode + '-' + _offset.toString();
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          var url = window.location.origin + '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = url;
	        } else {
	          var _url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&idxname=' + this.idxname;
	          window.location.href = _url;
	        }
	      } else {
	        (0, _helper.alert)('暂不支持结构化浏览');
	      }
	    }
	  }
	};

/***/ },
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {};
	  },
	
	  methods: {
	    echartBar: function echartBar(n, u, flagstr) {
	      var sameY = false;
	
	      if (u.length > 1 && u[0] === u[1]) {
	        sameY = true;
	      }
	
	      var segments = [];
	      var maxList = [];
	      var minList = [];
	      var legend = [];
	      var colors = ['#5793f3', '#d14a61'];
	      var yAxis = [];
	      var series = [];
	      var arr = [];
	      var datax = [];
	      var danwei = [];
	      var num = n[0].length - 1 > 2 ? 2 : n[0].length - 1;
	      for (var z = 0; z < num; z++) {
	        arr.push([]);
	      }
	      for (var i in n) {
	        if (i == 0) {
	          for (var k in n[i]) {
	            if (k > 0 && k < 3) {
	              legend.push(n[i][k]);
	            }
	          }
	        }
	        if (n.length - 6 >= 0) {
	          if (i > n.length - 6) {
	            datax.push(n[i][0]);
	
	            for (var x in n[i]) {
	              if (x > 0 && x < 3) {
	                var newvalue = parseFloat(n[i][x]);
	
	                arr[x - 1].push(newvalue);
	              }
	            }
	          }
	        } else {
	          if (i > 0) {
	            datax.push(n[i][0]);
	
	            for (var _x in n[i]) {
	              if (_x > 0 && _x < 3) {
	                var newvalue = parseFloat(n[i][_x]);
	
	                arr[_x - 1].push(newvalue);
	              }
	            }
	          }
	        }
	      }
	      function UnityUnits(x) {
	        for (var _i in arr[0]) {
	          arr[0][_i] = (arr[0][_i] / x).toFixed(2);
	        }
	        for (var j in arr[1]) {
	          arr[1][j] = (arr[1][j] / x).toFixed(2);
	        }
	      }
	
	      if (sameY) {
	        var max1 = Math.max.apply(Math, arr[0]);
	        var min1 = Math.min.apply(Math, arr[0]);
	        var max2 = Math.max.apply(Math, arr[1]);
	        var min2 = Math.min.apply(Math, arr[1]);
	        var biggest = Math.abs(max1) > Math.abs(min1) ? Math.abs(max1) : Math.abs(min1);
	        var biggest2 = Math.abs(max2) > Math.abs(min2) ? Math.abs(max2) : Math.abs(min2);
	        if (biggest > 100000000 && biggest2 > 100000000) {
	          UnityUnits(100000000);
	          danwei.push('亿' + u[0]);
	        } else if (biggest > 100000000 && biggest2 > 10000) {
	          UnityUnits(100000000);
	          danwei.push('亿' + u[0]);
	        } else if (biggest > 100000000 && biggest2 >= 0) {
	          UnityUnits(10000);
	          danwei.push('万' + u[0]);
	        } else if (biggest > 10000 && biggest2 > 100000000) {
	          UnityUnits(100000000);
	          danwei.push('亿' + u[0]);
	        } else if (biggest > 10000 && biggest2 > 10000) {
	          UnityUnits(10000);
	          danwei.push('万' + u[0]);
	        } else if (biggest > 10000 && biggest2 >= 0) {
	          UnityUnits(10000);
	          danwei.push('万' + u[0]);
	        } else if (biggest >= 0 && biggest2 > 100000000) {
	          UnityUnits(10000);
	          danwei.push('万' + u[0]);
	        } else if (biggest >= 0 && biggest2 > 10000) {
	          UnityUnits(10000);
	          danwei.push('万' + u[0]);
	        } else if (biggest >= 0 && biggest2 >= 0) {
	          UnityUnits(1);
	          danwei.push(u[0]);
	        }
	      } else {
	        for (var _n in arr) {
	          var min = Math.min.apply(Math, arr[_n]);
	          var max = Math.max.apply(Math, arr[_n]);
	
	
	          if (min >= 0) {
	            if (max > 100000000) {
	              var _x2 = parseInt((max / 100000000).toFixed(2)[0]);
	              var m = Math.floor((max / 100000000).toFixed(2));
	              maxList.push((_x2 + 1) * Math.pow(10, m.toString().length - 1));
	              minList.push(0);
	              for (var _i2 in arr[_n]) {
	                arr[_n][_i2] = (arr[_n][_i2] / 100000000).toFixed(2);
	              }
	              danwei.push('亿' + u[_n]);
	            } else if (max > 10000) {
	              var _x3 = parseInt((max / 10000).toFixed(2)[0]);
	              var _m = Math.floor((max / 10000).toFixed(2));
	              maxList.push((_x3 + 1) * Math.pow(10, _m.toString().length - 1));
	              minList.push(0);
	              for (var _i3 in arr[_n]) {
	                arr[_n][_i3] = (arr[_n][_i3] / 10000).toFixed(2);
	              }
	              danwei.push('万' + u[_n]);
	            } else {
	              var _x4 = parseInt(max.toFixed(2)[0]);
	              var _m2 = Math.floor(max.toFixed(2));
	              maxList.push((_x4 + 1) * Math.pow(10, _m2.toString().length - 1));
	              minList.push(0);
	              danwei.push(u[_n]);
	            }
	          } else if (max <= 0) {
	            if (Math.abs(min) > 100000000) {
	              var _x5 = parseInt((Math.abs(min) / 100000000).toFixed(2)[0]);
	              var _m3 = Math.floor((Math.abs(min) / 100000000).toFixed(2));
	              minList.push((_x5 + 1) * Math.pow(10, _m3.toString().length - 1));
	              maxList.push(0);
	              for (var _i4 in arr[_n]) {
	                arr[_n][_i4] = (arr[_n][_i4] / 100000000).toFixed(2);
	              }
	              danwei.push('亿' + u[_n]);
	            } else if (Math.abs(min) > 10000) {
	              var _x6 = parseInt((Math.abs(min) / 10000).toFixed(2)[0]);
	              var _m4 = Math.floor((Math.abs(min) / 10000).toFixed(2));
	              minList.push((_x6 + 1) * Math.pow(10, _m4.toString().length - 1));
	              maxList.push(0);
	              for (var _i5 in arr[_n]) {
	                arr[_n][_i5] = (arr[_n][_i5] / 10000).toFixed(2);
	              }
	              danwei.push('万' + u[_n]);
	            } else {
	              var _x7 = parseInt(Math.abs(min).toFixed(2)[0]);
	              var _m5 = Math.floor(Math.abs(min).toFixed(2));
	              minList.push((_x7 + 1) * Math.pow(10, _m5.toString().length - 1));
	              maxList.push(0);
	              danwei.push(u[_n]);
	            }
	          } else {
	            if (max > 100000000 || Math.abs(min) > 100000000) {
	              var _x8 = parseInt((max / 100000000).toFixed(2)[0]);
	              var _m6 = Math.floor((max / 100000000).toFixed(2));
	              maxList.push((_x8 + 1) * Math.pow(10, _m6.toString().length - 1));
	              var y = parseInt((Math.abs(min) / 100000000).toFixed(2)[0]);
	              var _k = Math.floor((Math.abs(min) / 100000000).toFixed(2));
	              minList.push((y + 1) * Math.pow(10, _k.toString().length - 1));
	              for (var _i6 in arr[_n]) {
	                arr[_n][_i6] = (arr[_n][_i6] / 100000000).toFixed(2);
	              }
	              danwei.push('亿' + u[_n]);
	            } else if (max > 10000 || Math.abs(min) > 10000) {
	              var _x9 = parseInt((max / 10000).toFixed(2)[0]);
	              var _m7 = Math.floor((max / 10000).toFixed(2));
	              maxList.push((_x9 + 1) * Math.pow(10, _m7.toString().length - 1));
	              var _y = parseInt((Math.abs(min) / 10000).toFixed(2)[0]);
	              var _k2 = Math.floor((Math.abs(min) / 10000).toFixed(2));
	              minList.push((_y + 1) * Math.pow(10, _k2.toString().length - 1));
	              for (var _i7 in arr[_n]) {
	                arr[_n][_i7] = (arr[_n][_i7] / 10000).toFixed(2);
	              }
	              danwei.push('万' + u[_n]);
	            } else {
	              var _x10 = parseInt(max.toFixed(2)[0]);
	              var _m8 = Math.floor(max.toFixed(2));
	              maxList.push((_x10 + 1) * Math.pow(10, _m8.toString().length - 1));
	              var _y2 = parseInt(Math.abs(min).toFixed(2)[0]);
	              var _k3 = Math.floor(Math.abs(min).toFixed(2));
	              minList.push((_y2 + 1) * Math.pow(10, _k3.toString().length - 1));
	              danwei.push(u[_n]);
	            }
	          }
	        }
	
	        console.log(minList);
	        if (minList.length > 1) {
	          if (minList[0] == 0 && minList[1] == 0) {
	            segments.push(maxList[0] / 5);
	            segments.push(maxList[1] / 5);
	          } else if (maxList[0] == 0 && maxList[1] == 0) {
	            segments.push(minList[0] / 5);
	            segments.push(minList[1] / 5);
	          } else if (minList[0] == 0 && maxList[1] == 0) {
	            minList[0] = maxList[0];
	            maxList[1] = minList[1];
	            segments.push(maxList[0] / 2);
	            segments.push(maxList[1] / 2);
	          } else if (maxList[0] == 0 && minList[1] == 0) {
	            maxList[0] = minList[0];
	            minList[1] = maxList[1];
	            segments.push(maxList[0] / 2);
	            segments.push(maxList[1] / 2);
	          } else if (minList[0] > 0 && minList[1] == 0) {
	            if (minList[0].toString().length > maxList[0].toString().length) {
	              maxList[0] = Math.pow(10, minList[0].toString().length - 1);
	            } else if (maxList[0].toString().length > minList[0].toString().length) {
	              minList[0] = Math.pow(10, maxList[0].toString().length - 1);
	            }
	            if (maxList[0] == minList[0]) {
	              var segment = 2;
	              segments.push(maxList[0] / 2);
	            } else {
	              if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
	                parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	                parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	              }
	              var segment = maxList[0] / this.maxDivisor(maxList[0], minList[0]);
	              segments.push(maxList[0] / segment);
	            }
	            if (maxList[1] % segment) {
	              maxList[1] = (Math.floor(maxList[1] / segment) + 1) * segment;
	            }
	            minList[1] = minList[0] * maxList[1] / maxList[0];
	            segments.push(maxList[1] / segment);
	          } else if (minList[0] > 0 && maxList[1] == 0) {
	            if (minList[0].toString().length > maxList[0].toString().length) {
	              maxList[0] = Math.pow(10, minList[0].toString().length - 1);
	            } else if (maxList[0].toString().length > minList[0].toString().length) {
	              minList[0] = Math.pow(10, maxList[0].toString().length - 1);
	            }
	            if (maxList[0] == minList[0]) {
	              var segment = 2;
	              segments.push(maxList[0] / 2);
	            } else {
	              if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
	                parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	                parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	              }
	              var segment = minList[0] / this.maxDivisor(maxList[0], minList[0]);
	              segments.push(minList[0] / segment);
	            }
	            if (minList[1] % segment) {
	              minList[1] = (Math.floor(minList[1] / segment) + 1) * segment;
	            }
	            maxList[1] = maxList[0] * minList[1] / minList[0];
	            segments.push(minList[1] / segment);
	          } else if (minList[1] > 0 && minList[0] == 0) {
	            if (minList[1].toString().length > maxList[1].toString().length) {
	              maxList[1] = Math.pow(10, minList[1].toString().length - 1);
	            } else if (maxList[1].toString().length > minList[1].toString().length) {
	              minList[1] = Math.pow(10, maxList[1].toString().length - 1);
	            }
	            if (maxList[1] == minList[1]) {
	              var segment = 2;
	            } else {
	              if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
	                parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	                parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	              }
	              var segment = maxList[1] / this.maxDivisor(maxList[1], minList[1]);
	            }
	            if (maxList[0] % segment) {
	              maxList[0] = (Math.floor(maxList[0] / segment) + 1) * segment;
	            }
	            minList[0] = minList[1] * maxList[0] / maxList[1];
	            segments.push(maxList[0] / segment);
	            segments.push(maxList[1] / segment);
	          } else if (minList[1] > 0 && maxList[0] == 0) {
	            if (minList[1].toString().length > maxList[1].toString().length) {
	              maxList[1] = Math.pow(10, minList[1].toString().length - 1);
	            } else if (maxList[1].toString().length > minList[1].toString().length) {
	              minList[1] = Math.pow(10, maxList[1].toString().length - 1);
	            }
	            if (maxList[1] == minList[1]) {
	              var segment = 2;
	            } else {
	              if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
	                parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	                parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	              }
	              var segment = minList[1] / this.maxDivisor(maxList[1], minList[1]);
	            }
	            if (minList[0] % segment) {
	              minList[0] = (Math.floor(minList[0] / segment) + 1) * segment;
	            }
	            maxList[0] = minList[0] * maxList[1] / minList[1];
	            segments.push(minList[0] / segment);
	            segments.push(minList[1] / segment);
	          } else if (maxList[0] > 0 && maxList[1] > 0 && minList[0] > 0 && minList[1] > 0) {
	            if (maxList[0] > maxList[1] && minList[0] > minList[1]) {
	              if (minList[0].toString().length > maxList[0].toString().length) {
	                maxList[0] = Math.pow(10, minList[0].toString().length - 1);
	              } else if (maxList[0].toString().length > minList[0].toString().length) {
	                minList[0] = Math.pow(10, maxList[0].toString().length - 1);
	              }
	              if (minList[1].toString().length > maxList[1].toString().length) {
	                maxList[1] = Math.pow(10, minList[1].toString().length - 1);
	              } else if (maxList[1].toString().length > minList[1].toString().length) {
	                minList[1] = Math.pow(10, maxList[1].toString().length - 1);
	              }
	              if (maxList[0] == minList[0]) {
	                maxList[1] > minList[1] ? minList[1] = maxList[1] : maxList[1] = minList[1];
	                var segment = 2;
	                segments.push(maxList[0] / 2);
	                segments.push(maxList[1] / 2);
	              } else {
	                if (this.maxDivisor(maxList[0], minList[0]).toString()[0] == '1') {
	                  parseInt(maxList[0].toString()[0]) % 2 ? maxList[0] = maxList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	                  parseInt(minList[0].toString()[0]) % 2 ? minList[0] = minList[0] + this.maxDivisor(maxList[0], minList[0]) : null;
	                }
	                var flag = false;
	
	                flag = maxList[0] / maxList[1] < minList[0] / minList[1] ? true : false;
	                if (flag) {
	                  var segment = maxList[0] / this.maxDivisor(maxList[0], minList[0]);
	                  segments.push(maxList[0] / segment);
	                  if (maxList[1] % segment) {
	                    maxList[1] = (Math.floor(maxList[1] / segment) + 1) * segment;
	                  }
	                  minList[1] = minList[0] * maxList[1] / maxList[0];
	                  segments.push(maxList[1] / segment);
	                } else {
	                  var segment = minList[0] / this.maxDivisor(maxList[0], minList[0]);
	                  segments.push(minList[0] / segment);
	                  if (minList[1] % segment) {
	                    minList[1] = (Math.floor(minList[1] / segment) + 1) * segment;
	                  }
	                  maxList[1] = maxList[0] * minList[1] / minList[0];
	                  segments.push(minList[1] / segment);
	                }
	              }
	            } else if (maxList[0] < maxList[1] && minList[0] < minList[1]) {
	              if (minList[0].toString().length > maxList[0].toString().length) {
	                maxList[0] = Math.pow(10, minList[0].toString().length - 1);
	              } else if (maxList[0].toString().length > minList[0].toString().length) {
	                minList[0] = Math.pow(10, maxList[0].toString().length - 1);
	              }
	              if (minList[1].toString().length > maxList[1].toString().length) {
	                maxList[1] = Math.pow(10, minList[1].toString().length - 1);
	              } else if (maxList[1].toString().length > minList[1].toString().length) {
	                minList[1] = Math.pow(10, maxList[1].toString().length - 1);
	              }
	
	              if (maxList[1] == minList[1]) {
	                maxList[0] > minList[0] ? minList[0] = maxList[0] : maxList[0] = minList[0];
	                var segment = 2;
	                segments.push(maxList[0] / 2);
	                segments.push(maxList[1] / 2);
	              } else {
	                if (this.maxDivisor(maxList[1], minList[1]).toString()[0] == '1') {
	                  parseInt(maxList[1].toString()[0]) % 2 ? maxList[1] = maxList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	                  parseInt(minList[1].toString()[0]) % 2 ? minList[1] = minList[1] + this.maxDivisor(maxList[1], minList[1]) : null;
	                }
	                var _flag = false;
	
	                _flag = maxList[1] / maxList[0] < minList[1] / minList[0] ? true : false;
	                if (_flag) {
	                  var segment = maxList[1] / this.maxDivisor(maxList[1], minList[1]);
	                  if (maxList[0] % segment) {
	                    maxList[0] = (Math.floor(maxList[0] / segment) + 1) * segment;
	                  }
	                  minList[0] = minList[1] * maxList[0] / maxList[1];
	                  segments.push(maxList[0] / segment);
	                  segments.push(maxList[1] / segment);
	                } else {
	                  var segment = minList[1] / this.maxDivisor(maxList[1], minList[1]);
	
	                  if (minList[0] % segment) {
	                    minList[0] = (Math.floor(minList[0] / segment) + 1) * segment;
	                  }
	
	                  maxList[0] = maxList[1] * minList[0] / minList[1];
	                  segments.push(minList[0] / segment);
	                  segments.push(minList[1] / segment);
	                }
	              }
	            } else {
	              minList[0] > minList[1] ? minList[1] = minList[0] : minList[0] = minList[1];
	              maxList[0] > maxList[1] ? maxList[1] = maxList[0] : maxList[0] = maxList[1];
	            }
	          } else {}
	        }
	      }
	
	      for (var idx in legend) {
	        var tmp = {};
	        tmp.name = legend[idx];
	        tmp.type = 'bar';
	        if (!sameY) {
	          tmp.yAxisIndex = idx;
	        }
	
	        tmp.barWidth = '20%';
	        tmp.data = arr[idx];
	        series.push(tmp);
	      }
	      if (sameY) {
	        var tmp2 = {};
	        tmp2.type = 'value';
	        tmp2.position = 'left';
	
	        tmp2.axisLabel = {
	          formatter: '{value} ' + danwei[0]
	        };
	        yAxis.push(tmp2);
	      } else {
	        for (var _idx in legend) {
	          var _tmp = {};
	          _tmp.type = 'value';
	          if (maxList.length > 1) {
	            _tmp.max = maxList[_idx];
	            _tmp.min = minList[_idx] ? -minList[_idx] : 0;
	            _tmp.interval = segments[_idx];
	          }
	          _tmp.name = legend[_idx];
	          _tmp.position = _idx == 0 ? 'left' : 'right';
	          if (_idx > 0) {
	            _tmp.offset = 20 * (_idx - 1);
	          }
	          _tmp.axisLine = {
	            lineStyle: {
	              color: colors[_idx]
	            }
	          };
	          _tmp.axisLabel = {
	            formatter: '{value} ' + danwei[_idx]
	          };
	          yAxis.push(_tmp);
	        }
	      }
	
	      if (flagstr == 'business') {
	        var business = setInterval(function () {
	          if (document.querySelector('.businesschart')) {
	            var echart = document.querySelector('.businesschart');
	            var mychart = _echarts2.default.init(echart);
	            series[1].type = 'line';
	            series[1].connectNulls = true;
	            for (var _i8 in series[1].data) {
	              if (series[1].data[_i8] == 0) {
	                series[1].data[_i8] = null;
	              }
	            }
	            var option = {
	              color: colors,
	              tooltip: {
	                trigger: 'axis',
	                axisPointer: {
	                  type: 'line' }
	              },
	              legend: {
	                data: legend
	              },
	              grid: {
	                left: '1%',
	                right: '4%',
	                bottom: '3%',
	                containLabel: true
	              },
	              xAxis: [{
	                data: datax,
	                axisTick: {
	                  alignWithLabel: true
	                }
	              }],
	              graphic: [{
	                type: 'image',
	                left: 0,
	                top: 10,
	                z: -10,
	                bounding: 'raw',
	                origin: [75, 75],
	                style: {
	                  image: window.location.origin + '/static/images/analyze_shuiyin2.png',
	                  width: 350,
	                  height: 150,
	                  opacity: 0.4
	                }
	              }],
	              yAxis: yAxis,
	              series: series
	            };
	            window.clearInterval(business);
	            mychart.setOption(option, true);
	          }
	        }, 100);
	      }
	
	      if (flagstr == 'gmjlr') {
	        var gmjlr = setInterval(function () {
	          if (document.querySelector('.gmjlrchart')) {
	            var echart = document.querySelector('.gmjlrchart');
	
	            var mychart = _echarts2.default.init(echart);
	            series[1].type = 'line';
	            series[1].connectNulls = true;
	            for (var _i9 in series[1].data) {
	              if (series[1].data[_i9] == 0) {
	                series[1].data[_i9] = null;
	              }
	            }
	            var option = {
	              color: colors,
	              tooltip: {
	                trigger: 'axis',
	                axisPointer: {
	                  type: 'line' }
	              },
	              legend: {
	                data: legend
	              },
	              grid: {
	                left: '1%',
	                right: '4%',
	                bottom: '3%',
	                containLabel: true
	              },
	              xAxis: [{
	                data: datax,
	                axisTick: {
	                  alignWithLabel: true
	                }
	              }],
	              graphic: [{
	                type: 'image',
	                left: 0,
	                top: 10,
	                z: -10,
	                bounding: 'raw',
	                origin: [75, 75],
	                style: {
	                  image: window.location.origin + '/static/images/analyze_shuiyin2.png',
	                  width: 350,
	                  height: 150,
	                  opacity: 0.4
	                }
	              }],
	              yAxis: yAxis,
	              series: series
	            };
	            window.clearInterval(gmjlr);
	            mychart.setOption(option, true);
	          }
	        }, 100);
	      }
	
	      var show = setInterval(function () {
	        if (document.querySelector('.industry-chard')) {
	          var echart = document.querySelector('.industry-chard');
	          var mychart = _echarts2.default.init(echart);
	          var option = {
	            color: colors,
	            tooltip: {
	              trigger: 'axis',
	              axisPointer: {
	                type: 'line' }
	            },
	            legend: {
	              data: legend
	            },
	            grid: {
	              left: '1%',
	              right: '1%',
	              top: '2%',
	              bottom: '3%',
	              containLabel: true
	            },
	            xAxis: [{
	              data: datax,
	              axisTick: {
	                alignWithLabel: true
	              }
	            }],
	            yAxis: yAxis,
	            graphic: [{
	              type: 'image',
	              left: 0,
	              top: 10,
	              z: -10,
	              bounding: 'raw',
	              origin: [75, 75],
	              style: {
	                image: window.location.origin + '/static/images/analyze_shuiyin2.png',
	
	                width: 350,
	                height: 150,
	                opacity: 0.4
	              }
	            }],
	            series: series
	          };
	
	          window.clearInterval(show);
	          mychart.setOption(option, true);
	        }
	      }, 100);
	    },
	    echartLine: function echartLine(data, title, legend, plat, divClass, canvasClass) {
	      this.curRateChart = plat;
	      title = '';
	      legend = legend;
	      var img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	
	      if ((0, _jquery2.default)(canvasClass)) {
	        console.log('has canvasClass');
	        (0, _jquery2.default)(canvasClass).remove();
	      }
	
	      var _class = canvasClass.split('#')[1];
	      (0, _jquery2.default)(divClass).prepend('<div id="' + _class + '" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>');
	
	      var data_x = [];
	      var data_y = [];
	      if (plat == 'company') {
	        data_x = data.dataX;
	        data_y = data.dataY;
	      }
	      if (plat == 'szse' || plat == 'shse') {
	        data_x = data.dataX;
	        data_y.push(data.dataY);
	        data_y.push(data.dataY2);
	      }
	
	      var echart = document.querySelector(canvasClass);
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	      var mychart = _echarts2.default.init(echart);
	
	      var option = {
	        title: {
	          text: title,
	          textStyle: {
	            color: '#1E88E5',
	            fontStyle: 'normal',
	            fontWeight: 'normal',
	            fontSize: 16
	          }
	        },
	        tooltip: {
	          trigger: 'axis',
	          formatter: function formatter(datas) {
	            console.log(datas);
	            var res = "<ul><li>" + datas[0].axisValue + '<li/>';
	            for (var i = datas.length - 1; i >= 0; i--) {
	              var seriesName = _jquery2.default.trim(datas[i].seriesName);
	              if (seriesName && seriesName != '-' && seriesName != '') {
	                if (plat !== 'company') {
	                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[i].color + "'></span>" + datas[i].seriesName + "：" + datas[i].value + ' %' + "<li/>";
	                }
	              }
	              if (plat == 'company') {
	                res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[i].color + "'></span>" + datas[i].value + ' %' + "<li/>";
	              }
	            }
	            res += '</ul>';
	            return res;
	          }
	        },
	        legend: {
	          data: legend,
	          padding: 2
	        },
	        grid: {
	          left: '1%',
	          right: '2%',
	          top: '10%',
	          bottom: '3%',
	          containLabel: true
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: true,
	          data: data_x
	        },
	        yAxis: {
	          type: 'value',
	          min: 0,
	          max: 100,
	          axisLabel: {
	            formatter: '{value} %'
	          }
	        },
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: data_y
	      };
	      mychart.setOption(option);
	    },
	
	    maxDivisor: function maxDivisor(a, b) {
	      for (var i = a; i > 0; i--) {
	        if (a % i == 0) {
	          if (b % i == 0) {
	            return i;
	          }
	        }
	      }
	    },
	    echartLineNumber: function echartLineNumber(data, title, legend, plat, divClass, canvasClass) {
	      this.curRateChart = plat;
	      title = title;
	      legend = legend;
	      var img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	
	      if ((0, _jquery2.default)(canvasClass)) {
	        (0, _jquery2.default)(canvasClass).remove();
	      }
	
	      var _class = canvasClass.split('.')[1];
	      (0, _jquery2.default)(divClass).prepend('<div class="' + _class + '" style="height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px;"></div>');
	
	      var data_x = [];
	      var data_y = [];
	      if (plat == 'company' || plat == 'cumPledge') {
	        data_x = data.dataX;
	        data_y = data.dataY;
	      }
	
	      var echart = document.querySelector(canvasClass);
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	      var mychart = _echarts2.default.init(echart);
	
	      function formatNum(num) {
	        if (!num) {
	          return num;
	        } else {
	          num = parseFloat(num);
	          return num.toFixed(2);
	        }
	      }
	
	      var option = {
	        title: {
	          text: title,
	          textStyle: {
	            color: '#1E88E5',
	
	            fontStyle: 'normal',
	
	            fontWeight: 'normal',
	
	            fontSize: 16
	          }
	        },
	        tooltip: {
	          trigger: 'axis',
	          formatter: function formatter(datas) {
	            if (datas[0].value) {
	              var res = "<ul>";
	              res += "<li>" + datas[0].axisValue + '<li/>';
	              res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color: #536DFE'></span>" + formatNum(datas[0].value) + "（%）<li/>";
	              res += '</ul>';
	              return res;
	            }
	          }
	        },
	        legend: {
	          data: legend
	        },
	        grid: {
	          left: '4%',
	          right: '2%',
	          top: '25%',
	          bottom: '3%',
	          containLabel: true
	        },
	        xAxis: {
	          type: 'category',
	          boundaryGap: false,
	          data: data_x,
	          axisTick: {
	            alignWithLabel: true
	          }
	        },
	        yAxis: {
	          type: 'value',
	          name: '累计质押比例',
	          axisLabel: {
	            formatter: '{value} %'
	          },
	          axisPointer: {
	            snap: true
	          }
	        },
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 0,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: '质押股数',
	          type: 'line',
	          connectNulls: true,
	          data: data_y.data
	        }]
	      };
	      mychart.setOption(option);
	    },
	    getAllDay: function getAllDay(begin, end) {
	      console.log(begin);
	      console.log(end);
	
	      Date.prototype.format = function () {
	        var s = '';
	        var mouth = this.getMonth() + 1 >= 10 ? this.getMonth() + 1 : '0' + (this.getMonth() + 1);
	        var day = this.getDate() >= 10 ? this.getDate() : '0' + this.getDate();
	
	        s += this.getFullYear() + '-';
	        s += mouth + "-";
	        s += day;
	
	        return s;
	      };
	
	      var allDay = [];
	      var ab = begin.split("-");
	      var ae = end.split("-");
	      var db = new Date();
	      db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
	
	      var de = new Date();
	      de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
	
	      var unixDb = db.getTime();
	      var unixDe = de.getTime();
	      for (var k = unixDb; k <= unixDe;) {
	        allDay.push(new Date(parseInt(k)).format());
	        k = k + 24 * 60 * 60 * 1000;
	      }
	
	      return allDay;
	    },
	
	    echartKLine: function echartKLine(data, divClass, canvasClass) {
	      if ((0, _jquery2.default)(canvasClass)) {
	        (0, _jquery2.default)(canvasClass).remove();
	      }
	      var _class = canvasClass.split('.')[1];
	      (0, _jquery2.default)(divClass).prepend('<div class="' + _class + '" style="height:400px;width:100%;margin-bottom:10px;"></div>');
	
	      var echart = document.querySelector(canvasClass);
	      if (!echart) return false;
	
	      function formatMoney(z) {
	        if (!z) {
	          return z;
	        } else {
	          var num = z.toString();
	          var normdata = '';
	          if (num.indexOf('.') !== -1) {
	            normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
	              return $1 + ",";
	            });
	          } else {
	            normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function ($0, $1) {
	              return $1 + ",";
	            });
	          }
	          if (normdata.indexOf('.') >= 0) {
	            var arr = normdata.split('.');
	            if (arr[1].length < 2) {
	              return normdata + '0';
	            } else {
	              return normdata.substr(0, normdata.indexOf('.') + 3);
	            }
	          } else {
	            return normdata;
	          }
	        }
	      }
	
	      var mychart = _echarts2.default.init(echart);
	      var rawData = data.reverse();
	
	      function calculateMA(dayCount, data) {
	        var result = [];
	        for (var i = 0, len = data.length; i < len; i++) {
	          if (i < dayCount) {
	            result.push('-');
	            continue;
	          }
	          var sum = 0;
	          for (var j = 0; j < dayCount; j++) {
	            sum += data[i - j][1];
	          }
	
	          result.push(+(sum / dayCount).toFixed(3));
	        }
	        return result;
	      }
	
	      var dates = rawData.map(function (item) {
	        return item[0];
	      });
	      var volumes = rawData.map(function (item) {
	        return item[5];
	      });
	
	      var data = rawData.map(function (item) {
	        return [+item[1], +item[2], +item[3], +item[4]];
	      });
	
	      var upColor = '#00da3c';
	      var downColor = '#ec0000';
	
	      var option = {
	        backgroundColor: '#ffffff',
	        animation: false,
	        legend: {
	          data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30'],
	          inactiveColor: '#777'
	        },
	        visualMap: {
	          show: false,
	          seriesIndex: 5,
	          dimension: 2,
	          pieces: [{
	            value: 1,
	            color: downColor
	          }, {
	            value: -1,
	            color: upColor
	          }]
	        },
	
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            animation: false,
	            type: 'cross',
	            lineStyle: {
	              color: '#376df4',
	              width: 2,
	              opacity: 1
	            }
	          },
	          formatter: function formatter(param) {
	            console.log(param);
	            var _d = {
	              main: '',
	              MA5: '',
	              MA10: '',
	              MA20: '',
	              MA30: '',
	              Volume: ''
	            };
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(param), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var h = _step.value;
	
	                if (h.seriesName == "日K") {
	                  _d.main = h;
	                } else {
	                  _d[h.seriesName] = h;
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            console.log(_d);
	
	            var str = '';
	            if (_d.main != '') {
	              str = '<ul><li>' + _d.main.name + '</li><hr size=1 style="margin: 3px 0">';
	            } else if (_d.MA5 != '') {
	              str += '<ul><li>' + _d.MA5.name + '</li><hr size=1 style="margin: 3px 0">';
	            } else if (_d.MA10 != '') {
	              str += '<ul><li>' + _d.MA10.name + '</li><hr size=1 style="margin: 3px 0">';
	            } else if (_d.MA20 != '') {
	              str += '<ul><li>' + _d.MA20.name + '</li><hr size=1 style="margin: 3px 0">';
	            } else if (_d.MA30 != '') {
	              str += '<ul><li>' + _d.MA30.name + '</li><hr size=1 style="margin: 3px 0">';
	            } else if (_d.Volume != '') {
	              str += '<ul><li>' + _d.Volume.name + '</li><hr size=1 style="margin: 3px 0">';
	            }
	
	            if (_d.main != '') {
	              str = str + '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.main.color + '"></span>日K:</li>' + '<li>- 开盘价: ' + _d.main.data[1] + '</li>' + '<li>- 收盘价: ' + _d.main.data[2] + '</li>' + '<li>- 最低价: ' + _d.main.data[3] + '</li>' + '<li>- 最高价: ' + _d.main.data[4] + '</li>';
	            }
	            if (_d.MA5 != '') {
	              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA5.color + '"></span>' + 'MA5: ' + _d.MA5.value + '</li>';
	            }
	            if (_d.MA10 != '') {
	              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA10.color + '"></span>' + 'MA10: ' + _d.MA10.value + '</li>';
	            }
	            if (_d.MA20 != '') {
	              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA20.color + '"></span>' + 'MA20: ' + _d.MA20.value + '</li>';
	            }
	            if (_d.MA30 != '') {
	              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.MA30.color + '"></span>' + 'MA30: ' + _d.MA30.value + '</li>';
	            }
	            if (_d.Volume != '') {
	              str += '<li><span style="display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:' + _d.Volume.color + '"></span>' + '成交量: ' + formatMoney(_d.Volume.value) + ' (手)</li>';
	            }
	            str += '</ul>';
	            return str;
	          }
	        },
	
	        axisPointer: {
	          link: { xAxisIndex: 'all' },
	          label: {
	            backgroundColor: '#777'
	          }
	        },
	        grid: [{
	          left: '10%',
	          right: '8%',
	          height: '50%'
	        }, {
	          left: '10%',
	          right: '8%',
	          top: '66%',
	          height: '16%'
	        }],
	        xAxis: [{
	          type: 'category',
	          data: dates,
	          scale: true,
	
	          boundaryGap: false,
	
	          axisLine: {
	            lineStyle: {
	              color: '#8392A5' }
	          },
	
	          splitLine: {
	            show: false },
	
	          min: 'dataMin',
	          max: 'dataMax',
	          axisPointer: {
	            z: 100
	          }
	        }, {
	          type: 'category',
	
	          gridIndex: 1,
	          data: dates,
	          scale: true,
	          boundaryGap: false,
	          axisLine: {
	            lineStyle: {
	              color: '#8392A5'
	            }
	          },
	          axisTick: { show: false },
	          splitLine: { show: false },
	          axisLabel: { show: false },
	
	          min: 'dataMin',
	          max: 'dataMax'
	        }],
	        yAxis: [{
	          scale: true,
	          axisLine: {
	            lineStyle: { color: '#8392A5' }
	          },
	          splitLine: { show: false }
	        }, {
	          scale: true,
	          gridIndex: 1,
	
	          axisLabel: { show: false },
	
	          axisLine: { show: false },
	
	          axisTick: { show: false },
	
	          splitLine: { show: false }
	        }],
	
	        dataZoom: [{
	          type: 'inside',
	          xAxisIndex: [0, 1],
	          start: 0,
	          end: 100
	        }, {
	          type: 'slider',
	          show: true,
	          xAxisIndex: [0, 1],
	          top: '90%',
	          textStyle: {
	            color: '#8392A5'
	          },
	          dataBackground: {
	            areaStyle: {
	              color: '#8392A5'
	            },
	            lineStyle: {
	              opacity: 0.8,
	              color: '#8392A5'
	            }
	          },
	          start: 0,
	          end: 100 }],
	        series: [{
	          name: '日K',
	          type: 'candlestick',
	          data: data,
	          itemStyle: {
	            normal: {
	              color: upColor,
	              color0: downColor,
	              borderColor: null,
	              borderColor0: null
	            }
	          }
	        }, {
	          name: 'MA5',
	          type: 'line',
	          data: calculateMA(5, data),
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 1
	            }
	          }
	        }, {
	          name: 'MA10',
	          type: 'line',
	          data: calculateMA(10, data),
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 1
	            }
	          }
	        }, {
	          name: 'MA20',
	          type: 'line',
	          data: calculateMA(20, data),
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 1
	            }
	          }
	        }, {
	          name: 'MA30',
	          type: 'line',
	          data: calculateMA(30, data),
	          smooth: true,
	          showSymbol: false,
	          lineStyle: {
	            normal: {
	              width: 1
	            }
	          }
	        }, {
	          name: 'Volume',
	          type: 'bar',
	          xAxisIndex: 1,
	          yAxisIndex: 1,
	          data: volumes
	        }]
	      };
	
	      mychart.setOption(option);
	    }
	  },
	  filters: {}
	};

/***/ },
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _Vue = __webpack_require__(345);
	
	var _Vue2 = _interopRequireDefault(_Vue);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      cpwpage: 1,
	      cpwperPage: 10,
	      cpwtotal: 0,
	      commentList: [],
	      content: '',
	
	      anonym: 0,
	      pid: 0,
	      showComments: false,
	      commentinput: false,
	      showall: false,
	      sendagain: true,
	      fixShow: 2
	    };
	  },
	
	  methods: {
	    zan: function zan(i, e) {
	      var tar = e.target;
	      var $tar = (0, _jquery2.default)(tar);
	      if ($tar.parent().parent().hasClass('reply-operate-been') || $tar.parent().hasClass('reply-operate-been')) {
	        return false;
	      }
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/commentzan'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'id': i })
	      }).done(function (response) {
	        if (response.status === 0) {
	          console.log('success');
	          var tar = e.target;
	          var $tar = (0, _jquery2.default)(tar);
	          if ($tar.parent().hasClass('footer-zan')) {
	            $tar.parent().addClass('reply-operate-been');
	            $tar.next("span").text(parseInt($tar.next("span").text()) + 1);
	            return false;
	          }
	          if ($tar.parent().parent().hasClass('reply-operate-hot')) {
	            $tar.parent().parent().removeClass('reply-operate-hot').addClass('reply-operate-been');
	            $tar.next("span").text(parseInt($tar.next("span").text()) + 1);
	            return false;
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    showALL: function showALL() {
	      this.showall = true;
	    },
	    getCommentcount: function getCommentcount(n, m) {
	      var _this = this;
	
	      var query = { 'md5': m, 'typ': n };
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/commentcount'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this.cpwtotal = response.data;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getCommentList: function getCommentList(p, n, m) {
	      var _this2 = this;
	
	      console.log(m);
	      if (!this.sendagain) {
	        return false;
	      }
	      this.sendagain = false;
	      if (n === 1) {
	        var query = { 'page': p, 'perPage': this.cpwperPage, 'md5': m, 'typ': 1 };
	      }
	      if (n === 2) {
	        var query = { 'page': p, 'perPage': this.cpwperPage, 'md5': m, 'typ': 2 };
	      }
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/commentlist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this2.sendagain = true;
	        if (response.status == 0) {
	          _this2.cpwtotal = response.total;
	          console.log("输出评论总数");
	          console.log(_this2.cpwtotal);
	          if (response.lists.length === 0) {
	            return false;
	          } else {
	            _this2.cpwpage = p;
	          }
	          if (_this2.cpwpage == 1) {
	            _this2.commentList = [];
	
	            var tmp = response.lists;
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(tmp), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var x = _step.value;
	
	                if (x.replys && x.replys.length > 0) {
	                  var a = 2;
	
	                  x.showall = a;
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            _this2.commentList = tmp;
	
	            console.log(_this2.commentList);
	          } else {
	            var _tmp = _this2.commentList.concat(response.lists);
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = (0, _getIterator3.default)(_tmp), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _x = _step2.value;
	
	                if (_x.replys && _x.replys.length > 0) {
	                  _x.showall = 2;
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            _this2.commentList = _tmp;
	          }
	          console.log(_this2.commentList);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.sendagain = true;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    addComment: function addComment(n, m, y, z) {
	      var _this3 = this;
	
	      if (!this.content.trim()) {
	        (0, _helper.alert)('输入内容不能为空');
	        return false;
	      }
	      if (n === 1) {
	        var query = { 'typ': 1, 'md5': m, 'content': this.content, 'anonym': this.anonym, 'stype': y, 'publishdate': z };
	      }
	
	      if (n === 2) {
	        var query = { 'typ': 2, 'md5': m, 'content': this.content, 'anonym': this.anonym };
	      }
	      if (this.pid) {
	        query.pid = this.pid;
	      }
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/addcomment'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          (0, _helper.alert)('评论成功');
	          _this3.showComments = true;
	
	          (0, _jquery2.default)(window).scrollTop(0);
	          _this3.getCommentList(1, n, m);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    }
	  }
	};

/***/ },
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(733)
	__vue_script__ = __webpack_require__(386)
	__vue_template__ = __webpack_require__(783)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _datepicker = __webpack_require__(83);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    'date-picker': _datepicker2.default
	  },
	  data: function data() {
	    return {
	      tagname: '',
	      showModalTag: false,
	      tagdata: {},
	      tagclicked: false,
	      tagLists: [],
	      showtag: false,
	      loading: false,
	      onlyTitle: 0,
	      page: 1,
	      total: 0,
	      perPage: 5,
	      totalPage: 0,
	      detailLists: [],
	      newItems: [],
	      topPage: 0,
	      bottomPage: 0,
	      sort: 1,
	      company: [],
	      showdownBtn: true,
	      related_company: [],
	      related_name: [],
	      items: [],
	      aggTypes: [],
	      aggPlates: [],
	      aggLabels: [],
	      checkedAll: false,
	      checkedCount: 0,
	      showSort: false,
	      showTongji: false,
	      showStatAnalyze: true,
	      showStatFilter: false,
	      showDropdownMenu: '',
	      stypename: '',
	      showSearchPage: false,
	      showTongjiPage: false,
	      showResultPage: true,
	      shownone: false,
	      showDateModal: false,
	      select_type: [],
	      select_qaType: [],
	      select_plate: [],
	      select_layer: [],
	      select_region: [],
	      select_securityCompany: [],
	      select_industry: [],
	      select_industrysecond: [],
	      oldDatetype: 0,
	      oldStartdate: 0,
	      oldEnddate: 0,
	      upanddown: 0,
	      Amplitude: 0,
	      timetyp: 1,
	      smartComInfo: {},
	      prices: {},
	      finance: [],
	      yearfinance: [],
	      hasoneSearch: false,
	      datepicker: {
	        option: {
	          type: 'day',
	          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
	          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	          format: 'YYYY-MM-DD',
	          placeholder: '',
	          inputStyle: {
	            'display': 'inline-block',
	            'width': '100%',
	            'padding': '4px 6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'box-shadow': '0px 0px 0px 0px',
	
	            'background': '#F2F2F2',
	            'color': 'rgb(95, 95, 95)'
	          },
	          color: {
	            header: '#00736a',
	            headerText: '#ffffff'
	          },
	          buttons: {
	            clear: '清空',
	            today: '今天',
	            ok: '确定',
	            cancel: '取消'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true }
	      }
	    };
	  },
	
	  computed: {
	    totalPage: function totalPage() {
	      var totalPage = Math.ceil(this.total / 5);
	      return totalPage;
	    },
	    indexs: function indexs() {
	      var left = 1;
	      var right = this.totalPage;
	      var ar = [];
	      if (this.totalPage >= 11) {
	        if (this.page > 5 && this.page < this.totalPage - 4) {
	          left = this.page - 5;
	          right = this.page + 4;
	        } else {
	          if (this.page <= 5) {
	            left = 1;
	            right = 10;
	          } else {
	            right = this.totalPage;
	            left = this.page - 9;
	          }
	        }
	      }
	      while (left <= right) {
	        ar.push(left);
	        left++;
	      }
	      return ar;
	    }
	  },
	  created: function created() {
	    this.getMeta();
	  },
	  ready: function ready() {
	    this.$nextTick(function () {
	      var innerHeight = window.innerHeight + 'px';
	      (0, _jquery2.default)('.wrapper').css({ 'min-height': innerHeight });
	    });
	  },
	
	  methods: {
	    getTagLists: function getTagLists() {
	      var _this = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/taglist'),
	        method: 'post',
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this.tagLists = response.data;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    searchByTag: function searchByTag(tagid) {
	      var _this2 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/gettag'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'id': tagid })
	      }).done(function (response) {
	        if (response.status === 0) {
	          if (parseInt(response.data['stype']) === _this2.stype) {
	            _this2.searchByTagAfter(response.data);
	          } else {
	            var stype = parseInt(response.data['stype']) || 1;
	            _this2.tagdata = response.data;
	            _this2.tagclicked = true;
	            _this2.changeStype(stype);
	          }
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    searchByTagAfter: function searchByTagAfter(data) {
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.industry), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var i = _step.value;
	
	          i.count = 0;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.plates), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var j = _step2.value;
	
	          j.count = 0;
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.parseTagData(data);
	      if (this.searched) {
	        this.go();
	      } else {
	        for (var key in this.conditions) {
	          if (!(0, _helper.isEmptyObj)(this.conditions[key])) {
	            this.havelabels = true;
	            this.showMylabels = 2;
	            this.addToShow();
	          }
	        }
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(this.industry), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var k = _step3.value;
	
	            this.setNum('industrysecond', k);
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion4 = true;
	        var _didIteratorError4 = false;
	        var _iteratorError4 = undefined;
	
	        try {
	          for (var _iterator4 = (0, _getIterator3.default)(this.plates), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	            var t = _step4.value;
	
	            this.setNum('layer', t);
	          }
	        } catch (err) {
	          _didIteratorError4 = true;
	          _iteratorError4 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion4 && _iterator4.return) {
	              _iterator4.return();
	            }
	          } finally {
	            if (_didIteratorError4) {
	              throw _iteratorError4;
	            }
	          }
	        }
	      }
	    },
	    parseTagData: function parseTagData(data) {
	      for (var key in data['conditions']) {
	        this.conditions[key] = data['conditions'][key];
	      }
	
	      this.ttype = parseInt(data['ttype']) || 0;
	      this.keywords = data['keywords'] || '';
	      this.companyCode = data['companyCode'] || '';
	      this.datetype = parseInt(data['datetype']) || 98;
	      if (this.datetype === 99) {
	        this.startdate = data['startdate'] || '';
	        this.enddate = data['enddate'] || '';
	      } else {
	        this.changeDateType(this.datetype);
	      }
	      this.keywords_condition = data['keywords_condition'];
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(this.keywords_condition), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var i = _step5.value;
	
	          if (!i.hasOwnProperty('opname')) {
	            var j = i;
	            j.opname = this.optypeMap[j.optype];
	            j.ttname = this.ttypeMap[j.ttype];
	            i = j;
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      this.ai = parseInt(data['ai']) || 0;
	      this.perPage = 10;
	      this.page = 1;
	      this.sort = 1;
	    },
	    delTag: function delTag(tagid) {
	      var _this3 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/deltag'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'id': tagid })
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this3.getTagLists();
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    saveTag: function saveTag() {
	      var _this4 = this;
	
	      this.keywords = this.keywords.trim();
	      if (this.keywords === '' && !this.validKeywordCondition() && !this.companyCode) {
	        (0, _helper.alert)('请输入关键词或者股票代码');
	        return;
	      }
	      var data = (0, _stringify2.default)(this.genTagData());
	      var query = { 'name': this.tagname, 'data': data };
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/savetag'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this4.loading = false;
	        if (response.status === 0) {
	          (0, _helper.alert)('保存成功');
	          _this4.showModalTag = false;
	          _this4.tagname = '';
	          _this4.getTagLists();
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    genTagData: function genTagData() {
	      var query = {};
	      query['conditions'] = this.conditions;
	      query['stype'] = this.stype;
	      query['ttype'] = this.ttype;
	      query['keywords'] = this.keywords;
	      query['companyCode'] = this.companyCode;
	      query['datetype'] = this.datetype;
	      query['startdate'] = this.startdate;
	      query['enddate'] = this.enddate;
	      query['keywords_condition'] = this.keywords_condition;
	      query['ai'] = this.ai;
	      return query;
	    },
	    isEmptyObj: function isEmptyObj(obj) {
	      if ((0, _keys2.default)(obj).length > 0) {
	        return false;
	      }
	      return true;
	    },
	    initAnaly: function initAnaly() {
	      this.company = [];
	      this.related_company = [];
	      this.related_name = [];
	      this.aggTypes = [];
	      this.aggPlates = [];
	      this.aggLabels = [];
	    },
	    paging2: function paging2(page) {
	      var _this5 = this;
	
	      var query = this.genQuery();
	      query.page = page;
	      query.perPage = 5;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      var requrl = '';
	      if (this.stype === 1 || this.stype === 2) {
	        requrl = (0, _helper.apiUrl)('/V1.0.0/notice/searchn3b');
	      } else {
	        requrl = (0, _helper.apiUrl)('/V1.0.0/notice/search');
	      }
	      _jquery2.default.ajax({
	        url: requrl,
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this5.loading = false;
	        _this5.analyze();
	        if (response.status === 0) {
	          var items = response.lists;
	          var _iteratorNormalCompletion6 = true;
	          var _didIteratorError6 = false;
	          var _iteratorError6 = undefined;
	
	          try {
	            for (var _iterator6 = (0, _getIterator3.default)(items), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	              var item = _step6.value;
	
	              item.checked = false;
	              if (item.child) {
	                var _iteratorNormalCompletion7 = true;
	                var _didIteratorError7 = false;
	                var _iteratorError7 = undefined;
	
	                try {
	                  for (var _iterator7 = (0, _getIterator3.default)(item.child), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                    var child = _step7.value;
	
	                    child.showque = false;
	                    if (child.answers) {
	                      var _iteratorNormalCompletion8 = true;
	                      var _didIteratorError8 = false;
	                      var _iteratorError8 = undefined;
	
	                      try {
	                        for (var _iterator8 = (0, _getIterator3.default)(child.answers), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                          var ans = _step8.value;
	
	                          ans.showans = false;
	                        }
	                      } catch (err) {
	                        _didIteratorError8 = true;
	                        _iteratorError8 = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                            _iterator8.return();
	                          }
	                        } finally {
	                          if (_didIteratorError8) {
	                            throw _iteratorError8;
	                          }
	                        }
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError7 = true;
	                  _iteratorError7 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                      _iterator7.return();
	                    }
	                  } finally {
	                    if (_didIteratorError7) {
	                      throw _iteratorError7;
	                    }
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError6 = true;
	            _iteratorError6 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                _iterator6.return();
	              }
	            } finally {
	              if (_didIteratorError6) {
	                throw _iteratorError6;
	              }
	            }
	          }
	
	          _this5.newItems = items;
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        _this5.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    reportPage2: function reportPage2(page) {
	      var _this6 = this;
	
	      console.log(page);
	      console.log('打印翻译的页面');
	      var query = this.genQuery();
	      query.page = page;
	      query.perPage = 10;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      query.stypes = [this.stype];
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchall'),
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this6.loading = false;
	        if (response.status === 0) {
	          var items = response.data[_this6.stype].lists;
	          var _iteratorNormalCompletion9 = true;
	          var _didIteratorError9 = false;
	          var _iteratorError9 = undefined;
	
	          try {
	            for (var _iterator9 = (0, _getIterator3.default)(items), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	              var item = _step9.value;
	
	              item.checked = false;
	              if (item.child) {
	                var _iteratorNormalCompletion10 = true;
	                var _didIteratorError10 = false;
	                var _iteratorError10 = undefined;
	
	                try {
	                  for (var _iterator10 = (0, _getIterator3.default)(item.child), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                    var child = _step10.value;
	
	                    child.showque = false;
	                    if (child.answers) {
	                      var _iteratorNormalCompletion11 = true;
	                      var _didIteratorError11 = false;
	                      var _iteratorError11 = undefined;
	
	                      try {
	                        for (var _iterator11 = (0, _getIterator3.default)(child.answers), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	                          var ans = _step11.value;
	
	                          ans.showans = false;
	                        }
	                      } catch (err) {
	                        _didIteratorError11 = true;
	                        _iteratorError11 = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                            _iterator11.return();
	                          }
	                        } finally {
	                          if (_didIteratorError11) {
	                            throw _iteratorError11;
	                          }
	                        }
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError10 = true;
	                  _iteratorError10 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                      _iterator10.return();
	                    }
	                  } finally {
	                    if (_didIteratorError10) {
	                      throw _iteratorError10;
	                    }
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError9 = true;
	            _iteratorError9 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                _iterator9.return();
	              }
	            } finally {
	              if (_didIteratorError9) {
	                throw _iteratorError9;
	              }
	            }
	          }
	
	          _this6.newItems = items;
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        _this6.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    analyze: function analyze() {
	      var _this7 = this;
	
	      var query = this.genQuery();
	      var requrl = '';
	      if (this.stype === 1 || this.stype === 2) {
	        requrl = (0, _helper.apiUrl)('/V1.0.0/notice/analyzen3b');
	      } else {
	        requrl = (0, _helper.apiUrl)('/V1.0.0/notice/analyze');
	      }
	      _jquery2.default.ajax({
	        url: requrl,
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this7.loading = false;
	        if (response.status === 0) {
	          _this7.company = response.agg.company;
	          _this7.related_company = response.agg.related_company;
	          _this7.related_name = response.agg.related_name;
	          if (response.agg.type) {
	            _this7.aggTypes = [];
	            var _iteratorNormalCompletion12 = true;
	            var _didIteratorError12 = false;
	            var _iteratorError12 = undefined;
	
	            try {
	              for (var _iterator12 = (0, _getIterator3.default)(response.agg.type), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                var agg = _step12.value;
	
	                _this7.aggTypes.push({
	                  'code': agg.key,
	                  'name': agg.key,
	                  'count': agg.doc_count });
	              }
	            } catch (err) {
	              _didIteratorError12 = true;
	              _iteratorError12 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                  _iterator12.return();
	                }
	              } finally {
	                if (_didIteratorError12) {
	                  throw _iteratorError12;
	                }
	              }
	            }
	          }
	          if (response.agg.plate) {
	            var aggMap = {};
	            var _iteratorNormalCompletion13 = true;
	            var _didIteratorError13 = false;
	            var _iteratorError13 = undefined;
	
	            try {
	              for (var _iterator13 = (0, _getIterator3.default)(response.agg.plate), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	                var _agg = _step13.value;
	
	                aggMap[_agg.key] = _agg.doc_count;
	              }
	            } catch (err) {
	              _didIteratorError13 = true;
	              _iteratorError13 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion13 && _iterator13.return) {
	                  _iterator13.return();
	                }
	              } finally {
	                if (_didIteratorError13) {
	                  throw _iteratorError13;
	                }
	              }
	            }
	
	            _this7.aggPlates = [];
	            var _iteratorNormalCompletion14 = true;
	            var _didIteratorError14 = false;
	            var _iteratorError14 = undefined;
	
	            try {
	              for (var _iterator14 = (0, _getIterator3.default)(_this7.plates), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	                var t = _step14.value;
	
	                if (aggMap[t.code]) {
	                  _this7.aggPlates.push({ 'code': t.code, 'name': t.name, 'count': aggMap[t.code] });
	                }
	              }
	            } catch (err) {
	              _didIteratorError14 = true;
	              _iteratorError14 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                  _iterator14.return();
	                }
	              } finally {
	                if (_didIteratorError14) {
	                  throw _iteratorError14;
	                }
	              }
	            }
	          }
	          if (response.agg.labels) {
	            _this7.aggLabels = [];
	            var _iteratorNormalCompletion15 = true;
	            var _didIteratorError15 = false;
	            var _iteratorError15 = undefined;
	
	            try {
	              for (var _iterator15 = (0, _getIterator3.default)(response.agg.labels), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	                var _agg2 = _step15.value;
	
	                _this7.aggLabels.push({ 'code': _agg2.key, 'name': _agg2.key, 'count': _agg2.doc_count });
	              }
	            } catch (err) {
	              _didIteratorError15 = true;
	              _iteratorError15 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                  _iterator15.return();
	                }
	              } finally {
	                if (_didIteratorError15) {
	                  throw _iteratorError15;
	                }
	              }
	            }
	          }
	        } else if (response.status === 502) {
	          console.log('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        console.log('请求失败');
	      });
	    },
	    selSort: function selSort(val) {
	      console.log(val);
	      this.sort = val;
	      this.showSort = false;
	      if (this.searched) {
	        this.go();
	      }
	    },
	    sortByDate: function sortByDate(val) {
	      console.log(val);
	      this.changeDateType(val);
	      console.log(this.genUrlQuery());
	      if (this.searched) {
	        this.go();
	      }
	    },
	
	    checkLogin: function checkLogin(item) {
	      console.log(item);
	      console.log('调用checkLogin函数');
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      console.log(item);
	      var url = '';
	      if (item.viewtype === 2) {
	        url = item.sourceurl;
	        window.location.href = url;
	      } else {
	        url = window.location.origin + this.viewUrl(item);
	        console.log(url);
	        window.location.href = url;
	      }
	    },
	    checkLoginQa: function checkLoginQa(item) {
	      console.log('调用checkLoginQa函数');
	
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      console.log(item);
	      console.log(this.qaViewUrl(item));
	      var url = window.location.origin + this.qaViewUrl(item);
	      console.log(url);
	      if (item.viewtype === 2) {
	        window.location.href = item.sourceurl;
	      } else {
	        window.location.href = url;
	      }
	    },
	
	    openAbsAnn: function openAbsAnn(item) {
	      console.log(item);
	      console.log('进入ABS');
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var url = this.absviewUrl(item);
	
	      if (!url) {
	        (0, _helper.alert)('此链接无法打开');
	        return false;
	      }
	      var urlopen = window.location.origin + url;
	      console.log(urlopen);
	      window.location.href = urlopen;
	      if (document.cookie.indexOf('embed=1') < 0) {
	        window.open(url);
	      } else {
	        if (item.viewtype === 2) {
	          window.open(url);
	        } else {
	          window.location.href = url;
	        }
	      }
	    },
	    absviewUrl: function absviewUrl(item) {
	      if (item.viewtype === 1) {
	        if (item.pid) {
	          return '/#!/notice/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&ext=1';
	        } else {
	          return '/#!/notice/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&ext=1';
	        }
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	      if (item.viewtype === 4) {
	        return '/#!/imgview?stype=' + this.stype + '&pdate=' + item.publishDate + '&id=' + item.id + '&ext=1';
	      }
	    },
	    goLogin: function goLogin() {
	      if (this.currentuser) {
	        this.showModal = true;
	      } else {
	        this.$route.router.go({ path: '/login', query: { 'uri': encodeURIComponent(window.location.href) } });
	      }
	    },
	    fileIcon: function fileIcon(fileext) {
	      if (fileext === 'pdf') {
	        return 'pdf-icon';
	      }
	      if (fileext === 'docx' || fileext === 'doc') {
	        return 'dov-icon';
	      }
	      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
	        return 'html-icon';
	      }
	      if (fileext === 'xls' || fileext === 'xlsx') {
	        return 'xsl-icon';
	      }
	    },
	    slideDropdownMenu: function slideDropdownMenu(event) {
	      (0, _jquery2.default)('.sxtj').slideToggle('normal');
	      var el = event.currentTarget;
	      var iconDom = el.lastElementChild;
	      var iconClass = iconDom.getAttribute('class'),
	          class1 = iconClass.split(' ')[0],
	          class2 = iconClass.split(' ')[1];
	      if (class2 === 'close') {
	        var classfr = 'fr';
	        var _class = classfr + ' ' + 'open';
	        iconDom.setAttribute('class', _class);
	        this.setCnzz('[Mobile]-信披搜索', '查看筛选条件', '');
	      }
	      if (class2 === 'open') {
	        var classf3 = 'f3';
	        var _class2 = classf3 + ' ' + 'close';
	        iconDom.setAttribute('class', _class2);
	        this.setCnzz('[Mobile]-信披搜索', '收起筛选条件', '');
	      }
	    },
	
	    slideToggleTag: function slideToggleTag() {
	      (0, _jquery2.default)('.cpwtag').slideToggle('normal');
	    },
	    slideToggle: function slideToggle(param) {
	      if (this.showDropdownMenu === '') {
	        this.showDropdownMenu = param;
	
	        (0, _jquery2.default)('.slide-menu').click(function () {
	          this.showDropdownMenu = '';
	          (0, _jquery2.default)(this).css({ 'display': 'none' });
	        });
	      } else {
	        this.showDropdownMenu = '';
	      }
	    },
	    log: function log(str) {
	      console.log(str);
	    },
	    hideDateModal: function hideDateModal(e) {
	      var _con = (0, _jquery2.default)('#Release-date');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.showDateModal = false;
	      }
	    },
	    slideDropdown: function slideDropdown(param) {
	      if (this.showDropdownMenu === '') {
	        this.showDropdownMenu = param;
	
	        (0, _jquery2.default)('.slide-menu').click(function () {
	          this.showDropdownMenu = '';
	          (0, _jquery2.default)(this).css({ 'display': 'none' });
	        });
	      } else {
	        this.showDropdownMenu = '';
	      }
	    },
	    hideKeywordDropdown: function hideKeywordDropdown() {
	      var el = (0, _jquery2.default)('.date-menu');
	      if (el.hasClass('open')) {
	        el.removeClass('open').addClass('close');
	      }
	    },
	    setSelectCondition: function setSelectCondition(type, date) {
	      console.log(this.conditions);
	      console.log(date);
	      if (type === 'select_type') {
	        this.select_type = (0, _keys2.default)(date);
	      }
	      if (type === 'select_qaType') {
	        this.select_qaType = (0, _keys2.default)(date);
	      }
	      if (type === 'select_plate') {
	        console.log(date);
	        var select_plate = [];
	        for (var key in this.conditions['plate']) {
	          select_plate.push(this.conditions['plate'][key]);
	        }
	        this.select_plate = select_plate;
	        this.select_layer = (0, _keys2.default)(this.conditions['layer']);
	      }
	      if (type === 'select_region') {
	        this.select_region = (0, _keys2.default)(date);
	      }
	      if (type === 'select_securityCompany') {
	        this.select_securityCompany = (0, _keys2.default)(date);
	      }
	      if (type === 'select_industry') {
	        console.log(date);
	        var select_industry = [];
	        var select_industrysecond = [];
	        for (var _key in this.conditions['industry']) {
	          select_industry.push(this.conditions['industry'][_key]);
	        }
	        for (var item in this.conditions['industrysecond']) {
	          select_industrysecond.push(this.conditions['industrysecond'][item]);
	        }
	        this.select_industry = select_industry;
	        this.select_industrysecond = select_industrysecond;
	      }
	    },
	    confirmDate: function confirmDate() {
	      this.oldDatetype = this.datetype;
	      this.oldStartdate = this.startdate;
	      this.oldEnddate = this.enddate;
	    },
	    cancelDate: function cancelDate() {
	      this.datatype = this.oldDatetype;
	      this.startdate = this.oldStartdate;
	      this.enddate = this.oldEnddate;
	    },
	    slideToggleFilter: function slideToggleFilter(param, event) {
	      var id = '#' + param;
	      var el = event.currentTarget;
	      (0, _jquery2.default)(id).slideToggle('normal');
	
	      var elClass = el.getAttribute('class'),
	          class1 = elClass.split(' ')[0],
	          class2 = elClass.split(' ')[1],
	          class3 = elClass.split(' ')[2],
	          class4 = elClass.split(' ')[3];
	
	      if (class4 === 'close') {
	        var _class = class1 + ' ' + class2 + ' ' + class3 + ' ' + 'open';
	        el.setAttribute('class', _class);
	      }
	      if (class4 === 'open') {
	        var _class3 = class1 + ' ' + class2 + ' ' + class3 + ' ' + 'close';
	        el.setAttribute('class', _class3);
	      }
	    },
	    clearPlate: function clearPlate() {
	      for (var i = 0; i < this.plates.length; ++i) {
	        this.plates[i].count = 0;
	      }
	      this.conditions['plate'] = {};
	      this.conditions['layer'] = {};
	      var plates = ['SZZB', 'SZZXB', 'SZCYB', 'SHZB', 'N3BTS'];
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = (0, _getIterator3.default)(plates), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var _i = _step16.value;
	
	          this.pageshowConditions['plate'][_i] = '';
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      this.pageshowConditions['plate']['挂牌公司'] = [];
	      this.select_plate = [];
	      this.select_layer = [];
	    },
	    clearIndustry: function clearIndustry() {
	      for (var i = 0; i < this.industry.length; ++i) {
	        this.industry[i].count = 0;
	      }
	      this.conditions['industry'] = {};
	      this.conditions['industrysecond'] = {};
	      for (var k in this.pageshowConditions['industry']) {
	        this.pageshowConditions['industry'][k] = [];
	      }
	      this.select_industry = [];
	      this.select_industrysecond = [];
	    },
	    backToHistory: function backToHistory() {
	      window.history.back();
	    }
	  },
	  watch: {
	    'startdate': function startdate() {
	      if (this.datetype_name === '自定义') {
	        this.sortByDate(99);
	      }
	    },
	    'enddate': function enddate() {
	      if (this.datetype_name === '自定义') {
	        this.sortByDate(99);
	      }
	    },
	    'stype': function stype() {
	      var sp = this.stype;
	      if (sp === 1) {
	        this.stypename = 'A股';
	      } else if (sp === 2) {
	        this.stypename = '新三板';
	      } else if (sp === 3) {
	        this.stypename = '债券';
	      } else if (sp === 5) {
	        this.stypename = '问题库';
	      } else if (sp === 6) {
	        this.stypename = '港股';
	      } else {
	        this.stypename = sp;
	      }
	    }
	  },
	  filters: {
	    formatTypeName: function formatTypeName(param) {
	      if (param === 1) {
	        return 'A股';
	      }
	      if (param === 2) {
	        return '新三板';
	      }
	      if (param === 3) {
	        return '债券';
	      }
	      if (param === 4) {
	        return '知识库';
	      }
	      if (param === 5) {
	        return '问题库';
	      }
	      if (param === 6) {
	        return '港股';
	      }
	      if (param === 7) {
	        return '法院公告';
	      }
	      if (param === 8) {
	        return '裁判文书';
	      }
	      if (param === 9) {
	        return '政府公告';
	      }
	      if (param === 10) {
	        return 'ABS';
	      }
	      if (param === 11) {
	        return '研报';
	      }
	      if (param === 12) {
	        return '新闻';
	      }
	      if (param === 15) {
	        return '我的文档';
	      }
	      if (param = 100) {
	        return '综合';
	      }
	      if (param == 13) {
	        return '研报数据';
	      }
	    },
	    formatKeywords: function formatKeywords(param) {
	      if (param.length > 10) {
	        return param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 10) + '...';
	      } else {
	        return param;
	      }
	    },
	    formatNumber: function formatNumber(z) {
	      if (!z) {
	        return z;
	      } else {
	        var num = z.toString();
	        var normdata = '';
	        if (num.indexOf('.') !== -1) {
	          normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
	            return $1 + ",";
	          });
	        } else {
	          normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function ($0, $1) {
	            return $1 + ",";
	          });
	        }
	        if (normdata.indexOf('.') >= 0) {
	          var arr = normdata.split('.');
	          if (arr[1].length < 2) {
	            return normdata + '0';
	          } else {
	            return normdata.substr(0, normdata.indexOf('.') + 3);
	          }
	        } else {
	          return normdata;
	        }
	      }
	    }
	  }
	};

/***/ },
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/loading.accf8cb.gif";

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(347)
	__vue_template__ = __webpack_require__(768)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ function(module, exports) {

	module.exports = "data:image/gif;base64,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"

/***/ },
/* 144 */,
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  data: function data() {
	    return {
	      showmenu: false,
	      showAllTitle: false };
	  },
	
	  methods: {
	    titleIntoView: function titleIntoView(id) {
	      this.toggleMenu();
	      if (!this.showmenu) {
	        this.$nextTick(function () {
	          document.getElementById(id).scrollIntoView();
	        });
	      }
	    },
	    genTitleTree: function genTitleTree(titles) {
	      this.titles = titles;
	    },
	    showTitleChild: function showTitleChild(title) {
	      var code = title.code;
	      title.showchild = !title.showchild;
	      var rgxp = new RegExp('^' + code + '\.\\d+$', 'g');
	      if (!title.showchild) {
	        rgxp = new RegExp('^' + code + '(\.\\d+)+$', 'g');
	      }
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.titles), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var t = _step.value;
	
	          if (t.code && t.code.match(rgxp)) {
	            t.isshow = title.showchild;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    },
	    toggleMenu: function toggleMenu() {
	      console.log('toggleMenu');
	      if (this.showmenu) {
	        this.showmenu = false;
	      } else {
	        this.showmenu = true;
	      }
	    },
	    toggleTitle: function toggleTitle() {
	      console.log('toggleTitle');
	
	      var title = this.detail.fulltitle;
	      var titltLen = title.length;
	      console.log(titltLen);
	      if (titltLen <= 33) {
	        return;
	      } else {
	        if (!this.showAllTitle) {
	          console.log('打开');
	          var newTitle = this.detail.fulltitle;
	          (0, _jquery2.default)('#detail-title').html(newTitle);
	          this.showAllTitle = true;
	
	          (0, _jquery2.default)('.toggle-icon').removeClass('toggle-down-arrow').addClass('toggle-up-arrow');
	        } else {
	          console.log('关闭');
	          var _newTitle = this.detail.fulltitle.replace(/(^\s*)|(\s*$)/g, '').substr(0, 20) + '...';
	          (0, _jquery2.default)('#detail-title').html(_newTitle);
	          this.showAllTitle = false;
	
	          (0, _jquery2.default)('.toggle-icon').removeClass('toggle-up-arrow').addClass('toggle-down-arrow');
	        }
	      }
	    },
	    hideNewUserGuide: function hideNewUserGuide() {
	      this.showguide = false;
	    }
	  },
	  filters: {
	    formatTitle: function formatTitle(param) {
	      if (param !== undefined) {
	        if (param.length > 20) {
	          param = param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 20) + '...';
	          return param;
	        } else {
	          return param;
	        }
	      }
	    }
	  }
	};

/***/ },
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA1OTczNzY4MjQ1IiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjMxMDciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTI5OC42NjY2NjcgNDI2LjY2NjY2N2wyMTMuMzMzMzMzIDIxMy4zMzMzMzMgMjEzLjMzMzMzMy0yMTMuMzMzMzMzeiIgcC1pZD0iMzEwOCIgZmlsbD0iIzUxNTE1MSI+PC9wYXRoPjwvc3ZnPg=="

/***/ },
/* 341 */
/***/ function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/PjwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+PHN2ZyB0PSIxNTA1OTczNjg1ODQyIiBjbGFzcz0iaWNvbiIgc3R5bGU9IiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9IjIzNjkiIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiPjxkZWZzPjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+PC9zdHlsZT48L2RlZnM+PHBhdGggZD0iTTQwNS4zMzMzMzMgNzI1LjMzMzMzM0w2MTguNjY2NjY3IDUxMiA0MDUuMzMzMzMzMDAwMDAwMSAyOTguNjY2NjY2OTk5OTk5OVoiIHAtaWQ9IjIzNzAiIGZpbGw9IiM1MTUxNTEiPjwvcGF0aD48L3N2Zz4="

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/new-user-guide.5a93918.png";

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/two-codes.5f9747b.png";

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(356)
	__vue_template__ = __webpack_require__(772)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 345 */,
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NewArticle',
	  data: function data() {
	    return {
	      name: '',
	      id: {},
	      articleInfo: {},
	      addtime: ''
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var _this = this;
	
	      var to = _ref.to;
	
	      this.id.id = to.params.id;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/article/detail'),
	        method: 'post',
	        data: (0, _stringify2.default)(this.id),
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this.articleInfo = response.data;
	          var addtime = response.data.addtime.split('T')[0];
	          _this.addtime = addtime;
	          _this.changeMetaTitle(response.data.title);
	        } else {
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	        console.log(response.status);
	      });
	    }
	  },
	  methods: {
	    changeMetaTitle: function changeMetaTitle(title) {
	      document.title = title;
	    }
	  }
	};

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: ['bigimgobj'],
	  mixins: [_userMix2.default],
	
	  methods: {
	    tpCollect: function tpCollect(item) {
	      console.log(item);
	      var query = {};
	      query.typ = 3;
	      query.imgid = item.imgid;
	      query.companycode = item.companycode;
	      query.companyname = item.companyname;
	      query.md5 = item.md5;
	      query.publishdate = item.publishdate;
	
	      query.stype = item.stype;
	      query.title = item.title;
	
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/collect'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          (0, _helper.alert)('收藏成功');
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    }
	  }
	};

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'MyArticleDetailView',
	  mixins: [_userMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      name: '',
	      id: {},
	      articleInfo: {},
	      addtime: '',
	      showPublisherCode: false
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var _this = this;
	
	      var to = _ref.to;
	
	      console.log(to);
	      this.id.id = to.params.id;
	      var uid = to.query.uid;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/artdetail'),
	        method: 'post',
	        data: (0, _stringify2.default)(this.id),
	        dataType: 'json'
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this.articleInfo = response.data;
	          _this.addtime = response.data.publishdate.split('T')[0];
	          _this.changeMetaTitle(response.data.title);
	          _this.getwxsign();
	          _this.userInfo(uid);
	
	          var desc = '';
	          if (response.data.subhead) {
	            if (response.data.subhead.length > 0) {
	              desc = response.data.subhead;
	            }
	          } else {
	            if (response.data.brief) {
	              if (response.data.brief.length > 0) {
	                desc = response.data.brief;
	              }
	            }
	          }
	          console.log(desc);
	          _this.shareArticle(response.data.title, response.data.imgurl, desc);
	        }
	      }).fail(function (response) {
	        console.log(response.status);
	        console.log(response.description);
	      });
	    }
	  },
	  ready: function ready() {
	    this.$nextTick(function () {
	      (0, _jquery2.default)(document).on('click', '.mobile-page-content img', function (event) {
	        var imgArray = [];
	        var curImageSrc = (0, _jquery2.default)(this).attr('src');
	        if (curImageSrc.indexOf('http://') < 0) {
	          curImageSrc = window.location.origin + '/' + (0, _jquery2.default)(this).attr('src');
	        }
	        console.log(curImageSrc);
	
	        var oParent = (0, _jquery2.default)(this).parent();
	        if (curImageSrc && !oParent.attr('href')) {
	          (0, _jquery2.default)('.mobile-page-content img').each(function (index, el) {
	            var itemSrc = (0, _jquery2.default)(this).attr('src');
	            if (itemSrc.indexOf('http://') < 0) {
	              itemSrc = window.location.origin + '/' + itemSrc;
	            }
	            imgArray.push(itemSrc);
	          });
	          console.log(imgArray);
	          wx.previewImage({
	            current: curImageSrc,
	            urls: imgArray
	          });
	        }
	      });
	    });
	  },
	
	  methods: {
	    hideDialog: function hideDialog(e) {
	      console.log(e);
	      var target = (0, _jquery2.default)('.binding-content');
	      if (!target.is(e.target) && target.has(e.target).length === 0) {
	        this.showPublisherCode = false;
	      }
	    },
	    shareArticle: function shareArticle(fulltitle, imgurl, desc) {
	      var title = fulltitle;
	      var shareLink = window.location.href;
	      var shareImgLink = window.location.origin + '/' + imgurl;
	
	      this.wxSDKConfig(title, shareImgLink, shareLink, desc);
	    }
	  }
	};

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(7);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default, _SearchMix2.default, _comSearchMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      subscribeList: [],
	      loading: true
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      document.title = '我的订阅';
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile('weixin');
	        }
	      }
	      if (this.currentuser) {
	        this.getProfile('weixin');
	        if (this.currentuser.regtyp == 4) {
	          this.goBindPage(1);
	          return false;
	        }
	        if (this.currentuser.mp == 0 || !this.currentuser.weixin) {
	
	          var appid = this.$config.weixin.appid;
	          this.currentuser = null;
	          var redirectUri = encodeURIComponent(window.location.href);
	          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
	
	          return false;
	        }
	        if (!this.checkPrivilege('user/event', '暂无权限')) {
	          return false;
	        }
	        this.getAllsubscribe();
	      }
	    }
	  },
	  methods: {
	    getAllsubscribe: function getAllsubscribe() {
	      var _this = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/eventlist'),
	        method: 'post',
	        dataType: 'json'
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status == 0) {
	          _this.subscribeList = [];
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var item = _step.value;
	
	              _this.subscribeList.push(item);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    goMessagePage: function goMessagePage(item) {
	      this.$route.router.go({ path: '/newmessage', query: { 'name': item.name, 'id': item.id } });
	    },
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    }
	  }
	};

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _pdfjsDist = __webpack_require__(761);
	
	var _pdfjsDist2 = _interopRequireDefault(_pdfjsDist);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _jquery3 = __webpack_require__(759);
	
	var _jquery4 = _interopRequireDefault(_jquery3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default],
	  data: function data() {
	    return {
	      id: null,
	      stype: null,
	      pdate: null,
	      m: '',
	      page_count: 0,
	      page: 0,
	      startx: 0,
	      starty: 0,
	      endx: 0,
	      endy: 0,
	      fingers: 0,
	      v: 0,
	      distance: 0,
	      pdfPath: null,
	      scrollWidth: 0,
	      currentX: 0,
	      show: false,
	      pid: 0,
	      sessionid: ''
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var _this = this;
	
	      var to = _ref.to;
	
	      document.title = '公告';
	      this.id = to.query.k || '';
	      this.stype = to.query.t || null;
	      this.pdate = to.query.pdate || '';
	      this.sessionid = to.query.sessionid || '';
	
	      console.log(_jquery2.default.cookie());
	      console.log(to);
	      if (this.sessionid) {
	        _jquery2.default.cookie('sessionid', this.sessionid);
	        this.getProfileNew();
	      } else {
	        this.getProfile('weixin');
	      }
	      if (to.query.pid) {
	        var query = { 'id': this.id, 'stype': this.stype, 'pdate': this.pdate, 'pid': to.query.pid };
	      } else {
	        var query = { 'id': this.id, 'stype': this.stype, 'pdate': this.pdate };
	      }
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/noticemeta'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          var pdfPath = response.data.viewurl;
	          var num = pdfPath.indexOf('file');
	          _this.pdfPath = '/pdf/' + pdfPath.substr(num);
	          console.log(_this.pdfPath);
	          _pdfjsDist2.default.PDFJS.cMapUrl = './static/';
	          _pdfjsDist2.default.PDFJS.cMapPacked = true;
	          _this.pdfjsLibDoc = _pdfjsDist2.default.getDocument(_this.pdfPath);
	          _this.v = (0, _jquery2.default)(window).width() / 1000 * 100;
	
	          _this.scrollWidth = parseInt((0, _jquery2.default)(document).width()) * 0.7;
	          _this.page = 1;
	          _this.renderP(_this.page);
	        } else if (response.status === 403) {
	          (0, _helper.alert)('请先登录！');
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    }
	  },
	  ready: function ready() {
	    (0, _jquery2.default)("meta[name='viewport']").attr('content', 'width=device-width, initial-scale=1.0, user-scalable=no');
	    document.getElementById('theCanvas').addEventListener('touchstart', this.touchstart);
	    document.getElementById('theCanvas').addEventListener('touchend', this.touchend);
	    document.getElementById('theCanvas').addEventListener('touchmove', this.touchmove);
	    document.getElementById('theCanvas').addEventListener('touchcancel', this.touchend);
	    document.getElementById('scroll_Thumb').addEventListener('touchmove', this.scroll);
	    document.getElementById('scroll_Thumb').addEventListener('touchend', this.go);
	  },
	
	  watch: {
	    'page': function page(newval, oldval) {
	      var per = this.scrollWidth / parseInt((0, _jquery2.default)('.page_count').text());
	      (0, _jquery2.default)("#scroll_Thumb").css("margin-left", this.page * per + "px");
	      (0, _jquery2.default)("#scroll_Track").css("width", this.page * per + 2 + "px");
	    }
	  },
	  methods: {
	    getProfileNew: function getProfileNew(share) {
	      var _this2 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/profile'),
	        method: 'post',
	        dataType: 'json',
	        async: false
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this2.currentuser = response.data;
	          _this2.uid = response.data.uid;
	          _this2.shareUsername = response.data.username;
	        }
	        if (response.status === 403 && share === 'weixin') {
	          var appid = _this2.$config.weixin.appid;
	          var redirectUri = encodeURIComponent(window.location.href);
	          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
	        }
	      }).fail(function (response) {
	        console.log('请求失败');
	      });
	    },
	
	    viewUrl: function viewUrl(item) {
	      if (item.viewtype === 1) {
	        return '/#!/notice/' + this.id + '?stype=' + this.stype + '&pdate=' + this.pdate + '&idxname=' + '';
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	      if (item.viewtype === 4) {
	        return '/#!/imgview?stype=' + this.stype + '&pdate=' + this.pdate + '&id=' + this.id;
	      }
	    },
	    scroll: function scroll(e) {
	      this.currentX = e.touches[0].clientX - parseInt((0, _jquery2.default)(document).width()) * 0.15;
	
	      var per = this.scrollWidth / parseInt((0, _jquery2.default)('.page_count').text());
	      if (this.currentX >= per && this.currentX <= this.scrollWidth) {
	        this.page = Math.floor(this.currentX / per);
	        (0, _jquery2.default)("#scroll_Thumb").css("margin-left", this.page * per + "px");
	        (0, _jquery2.default)("#scroll_Track").css("width", this.page * per + 2 + "px");
	      } else if (this.currentX > this.scrollWidth) {
	        this.page = parseInt((0, _jquery2.default)('.page_count').text());
	      } else if (this.currentX < per) {
	        this.page = 1;
	      }
	    },
	    go: function go() {
	      this.renderP(this.page);
	    },
	    renderP: function renderP(n) {
	      this.pdfjsLibDoc.promise.then(function (pdfDocument) {
	        (0, _jquery2.default)('.page_count').text(pdfDocument.numPages);
	        var v = (0, _jquery2.default)(window).width() / 1000 * 100;
	        (0, _jquery2.default)('#theCanvas').css('zoom', v + '%');
	        return pdfDocument.getPage(n).then(function (pdfPage) {
	          var a;
	          if (pdfPage.view[2] > 1000) {
	            a = 1000 / pdfPage.view[2];
	          } else {
	            a = 1000 / pdfPage.view[2];
	          }
	          var viewport = pdfPage.getViewport(a);
	          console.log(viewport);
	          var canvas = document.getElementById('theCanvas');
	
	
	          canvas.width = 1000;
	
	          console.log(canvas.width);
	
	          canvas.height = viewport.height;
	
	          console.log(canvas.height);
	          var ctx = canvas.getContext('2d');
	          var renderTask = pdfPage.render({
	            canvasContext: ctx,
	            viewport: viewport
	          });
	          (0, _jquery2.default)('.loading_gif').css('display', 'none');
	
	          return renderTask.promise;
	        }).then(function () {
	          (0, _jquery2.default)('.prev').css('display', 'inline-block');
	          (0, _jquery2.default)('.next').css('display', 'inline-block');
	
	          if (n === 1) {
	            var per = parseInt((0, _jquery2.default)(document).width()) * 0.7 / parseInt((0, _jquery2.default)('.page_count').text());
	            (0, _jquery2.default)("#scroll_Thumb").css("margin-left", n * per + "px");
	            (0, _jquery2.default)("#scroll_Track").css("width", n * per + 2 + "px");
	          }
	        });
	      });
	    },
	
	    prev: function prev() {
	      this.show = true;
	      if (this.page === 1) {
	        return;
	      } else {
	        this.page = this.page - 1;
	        (0, _jquery2.default)('.prev').css('display', 'none');
	        (0, _jquery2.default)('.next').css('display', 'none');
	        this.renderP(this.page);
	      }
	    },
	    next: function next() {
	      this.show = true;
	      var pagecount = parseInt((0, _jquery2.default)('.page_count').text());
	
	      if (this.page === pagecount) {
	        return;
	      } else {
	        this.page = this.page + 1;
	
	        (0, _jquery2.default)('.prev').css('display', 'none');
	        (0, _jquery2.default)('.next').css('display', 'none');
	        this.renderP(this.page);
	      }
	    },
	    touchstart: function touchstart(e) {
	      if (e.touches.length === 2) {
	        this.fingers = 2;
	
	        var x = Math.abs(e.touches[0].clientX - e.touches[1].clientX);
	        var y = Math.abs(e.touches[0].clientY - e.touches[1].clientY);
	        var distance = Math.pow(x * x + y * y, 0.5);
	
	        this.distance = distance;
	        this.x1 = (e.touches[0].clientX + e.touches[1].clientX) / 2;
	        this.y1 = (e.touches[0].clientY + e.touches[1].clientY) / 2;
	      }
	      if (e.touches.length === 1) {
	        this.fingers = 1;
	        if ((0, _jquery2.default)('.page_count').text()) {
	          this.show = !this.show;
	        }
	
	        this.startx = e.touches[0].clientX;
	        this.starty = e.touches[0].clientY;
	        console.log('sx:' + this.startx + '   ' + 'sy' + this.starty);
	      }
	    },
	    touchmove: function touchmove(e) {
	      if (e.touches.length === 2) {
	        var x = Math.abs(e.touches[0].clientX - e.touches[1].clientX);
	        var y = Math.abs(e.touches[0].clientY - e.touches[1].clientY);
	        var distance = Math.pow(x * x + y * y, 0.5);
	        var rate = distance - this.distance;
	        this.v = this.v + rate / 4;
	        if (this.v < (0, _jquery2.default)(window).width() / 1000 * 100) {
	          (0, _jquery2.default)('#theCanvas').css('zoom', (0, _jquery2.default)(window).width() / 1000 * 100 + '%');
	        } else {
	          (0, _jquery2.default)('#theCanvas').css('zoom', this.v + '%');
	        }
	
	        this.distance = distance;
	      }
	    },
	    touchend: function touchend(e) {
	
	      console.log((0, _jquery2.default)('#theCanvas').css('zoom'));
	      console.log((0, _jquery2.default)(window).width() / 1000);
	      if (this.fingers === 1) {
	        if ((0, _jquery2.default)('#theCanvas').css('zoom') === new Number((0, _jquery2.default)(window).width() / 1000).toString()) {
	          console.log(e.changedTouches);
	          if (e.changedTouches[0].clientX - this.startx > 50) {
	            this.prev();
	          }
	          if (e.changedTouches[0].clientX - this.startx < -50) {
	            this.next();
	          }
	        }
	      }
	    }
	  }
	};

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _helper = __webpack_require__(7);
	
	var _datepicker = __webpack_require__(83);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _searchResMix = __webpack_require__(84);
	
	var _searchResMix2 = _interopRequireDefault(_searchResMix);
	
	var _BigImg = __webpack_require__(105);
	
	var _BigImg2 = _interopRequireDefault(_BigImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'AdvSearchView',
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default, _commentMix2.default, _comSearchMix2.default, _searchResMix2.default],
	  components: {
	    'bigimg': _BigImg2.default,
	    'date-picker': _datepicker2.default
	  },
	  data: function data() {
	    return {
	      bigImgObj: { 'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': '' },
	      gglxList: {},
	      ggbqList: {},
	      advdownloading: false,
	      tab1: 1,
	      tab2: 1,
	      tab3: 1,
	      searched: false,
	      companysearched: false,
	      sd: '',
	      cpage: 1,
	      ctotal: 0,
	      ctotal1: 0,
	      cperPage: 10,
	      curcond: null,
	      stype: 1,
	      condition: [],
	      querycond: [],
	      showCondition: false,
	      showCustom: false,
	      customCols: [{ 'name': '证劵简称', 'col': 'shortName', 'show': true }, { 'name': '证劵代码', 'col': 'companyCode', 'show': true }, { 'name': '法人', 'col': 'legalRepresentative', 'show': true }, { 'name': '所属地域', 'col': 'area', 'show': true }, { 'name': '行业', 'col': 'industry', 'show': true }, { 'name': '成立日期', 'col': 'founddate', 'show': true }, { 'name': '注册资本(万元)', 'col': 'regmoney', 'show': true, 'format': 'money' }, { 'name': '营业总收入(元)', 'col': 'businessincometotal', 'show': true, 'format': 'money' }, { 'name': '营业收入(元)', 'col': 'businessincome', 'show': true, 'format': 'money' }, { 'name': '净利润(元)', 'col': 'retainedprofit', 'show': true, 'format': 'money' }, { 'name': '企业类型', 'col': 'companytyp', 'show': false }, { 'name': '统一社会信用代码/注册号', 'col': 'regcode', 'show': false }, { 'name': '注册地址', 'col': 'address', 'show': false }],
	      items: [],
	      companylist: [],
	      companyitems: [],
	      datepicker: {
	        option: {
	          type: 'day',
	          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
	          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	          format: 'YYYY-MM-DD',
	          placeholder: '',
	          inputStyle: {
	            'display': 'inline-block',
	            'width': '110px',
	            'padding': '4px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'border': '1px solid rgb(198, 216, 232)',
	            'box-shadow': '0 0 0 0 rgba(0, 0, 0, 0.2)',
	            'border-radius': '4px',
	            'color': '#5F5F5F'
	          },
	          color: {
	            header: '#00736a',
	            headerText: '#ffffff'
	          },
	          buttons: {
	            clear: '清空',
	            today: '今天',
	            ok: '确定',
	            cancel: '取消'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true }
	      },
	      meta: [],
	      crumbs: [],
	      lvl1: [],
	      lvl2: [],
	      lvl3: [],
	      metaMap: {},
	      uniqMap: {},
	      showModal: false,
	      tagname: '',
	      showTag: false,
	      tags: [],
	      tags1: [],
	      tags2: [],
	      tags3: [],
	      samples: [{ 'typ': 1, 'condition': [{ 'name': '搜索范围', 'code': 'ssfw', 'type': 'Select', 'op': 1, 'child': [{ 'name': '章节', 'code': 'zjbt', 'type': 'Select', 'op': 1, 'child': [{ 'name': '章节标题', 'code': 'jzjbt', 'type': 'String', 'op': 1, 'value': '主营业务', 'child': [] }, { 'name': '章节正文', 'code': 'zjzw', 'type': 'String', 'op': 1, 'value': '大数据', 'child': [] }] }] }], 'stype': 2, 'perPage': 10, 'page': 1, 'sort': 1 }, { 'typ': 2, 'condition': [{ 'name': '搜索范围', 'code': 'ssfw', 'type': 'Select', 'op': 1, 'child': [{ 'name': '章节', 'code': 'zjbt', 'type': 'Select', 'op': 1, 'child': [{ 'name': '章节标题', 'code': 'jzjbt', 'type': 'String', 'op': 1, 'value': '主营业务', 'child': [] }, { 'name': '章节正文', 'code': 'zjzw', 'type': 'String', 'op': 1, 'value': '大数据', 'child': [] }] }] }, { 'name': '公司', 'code': 'company', 'type': 'Select', 'op': 1, 'child': [{ 'name': '财务数据', 'code': 'cwsj', 'type': 'Select', 'op': 1, 'child': [{ 'name': '财报指标', 'code': 'cwzb', 'type': 'Select', 'op': 1, 'child': [{ 'name': '营业总收入', 'code': 'yyzsr', 'type': 'Finance', 'op': 1, 'range': 2, 'value': '50,000,000', 'value1': '', 'year': '2016', 'quarter': '年报', 'child': [] }, { 'name': '净利润', 'code': 'jlr', 'type': 'Finance', 'op': 1, 'range': 2, 'value': '5,000,000', 'value1': '', 'year': '2016', 'quarter': '年报', 'child': [] }] }] }] }], 'stype': 2, 'perPage': 10, 'page': 1, 'sort': 1 }],
	      exportfilepath: '',
	      searchCondition: [],
	      newSearchCondition: [],
	
	      loading: 0,
	      onlyTitle: 0,
	      page: 1,
	      total: 0,
	      perPage: 10,
	      totalPage: 0,
	      detailLists: [],
	      topPage: 0,
	      bottomPage: 0,
	      newItems: [],
	      sort: 1,
	      company: [],
	      showdownBtn: true,
	      related_company: [],
	      related_name: [],
	      aggTypes: [],
	      aggPlates: [],
	      aggLabels: [],
	      checkedAll: false,
	      checkedCount: 0,
	      showSort: false,
	      showDropdownMenu: '',
	      showSearchPage: false,
	      showTongjiPage: false,
	      showResultPage: true,
	      showStatAnalyze: true,
	      showStatFilter: false,
	      uidUrl: '',
	      share: '',
	      plat: '',
	      sid: '',
	      diysharedesc: '',
	      currentCompanyDetail: {},
	      showCompanyDetailWrap: false,
	      scrollTopPos: null,
	      params: {},
	
	      dataMap: { '年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31' },
	      upanddown: 0,
	      Amplitude: 0,
	      timetyp: 1,
	      smartComInfo: {},
	      finance: [],
	      yearfinance: [],
	      ssfw: {},
	      gs: {} };
	  },
	  ready: function ready() {
	    this.$nextTick(function () {
	      var innerHeight = window.innerHeight + 'px';
	      (0, _jquery2.default)('.wrapper').css({ 'min-height': innerHeight });
	    });
	  },
	
	  route: {
	    data: function data(_ref) {
	      var _this = this;
	
	      var to = _ref.to;
	
	      console.log(to);
	      console.log('进入Advearch');
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query);
	        }
	      }
	      if (this.currentuser) {
	        _jquery2.default.ajax({
	          url: (0, _helper.apiUrl)('/V1.0.0/notice/advmeta'),
	          method: 'post',
	          dataType: 'json'
	        }).done(function (response) {
	          if (response.status === 0) {
	            _this.meta = response.result.condition;
	            _this.getMetaMap(_this.meta);
	            _this.initCond();
	            _this.parseUrlQuery(to.query);
	          }
	        }).fail(function (response) {
	          (0, _helper.alert)('请求失败');
	        });
	
	        this.upanddown = 0;
	        this.Amplitude = 0;
	        this.switchPage(2);
	        var urlQuery = to.query;
	        this.params.uidUrl = urlQuery.uid;
	        this.params.share = urlQuery.share;
	        this.params.plat = urlQuery.plat;
	        this.params.ts = urlQuery.ts;
	        this.params.desc = urlQuery.desc;
	        this.params.sid = urlQuery.sid;
	        this.params.ruid = urlQuery.ruid;
	        this.uidUrl = urlQuery.uid;
	        this.share = urlQuery.share;
	        this.plat = urlQuery.plat;
	        this.sid = urlQuery.sid;
	        this.page = urlQuery._page;
	        this.diysharedesc = urlQuery.desc;
	        this.gettags();
	        this.commentList = [];
	        this.commentinput = false;
	        this.showComments = false;
	        this.getCommentcount(2, this.sid);
	
	        jQuery(window).unbind();
	        (0, _jquery2.default)(window).unbind();
	        var that = this;
	        (0, _jquery2.default)(window).scroll(function (e) {
	          if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height() && that.showComments) {
	            var page = that.cpwpage + 1;
	
	            if (page <= Math.ceil(that.cpwtotal / 10)) {
	              that.getCommentList(page, 2, that.sid);
	            }
	          }
	          var scrollTop = (0, _jquery2.default)(this).scrollTop();
	          var scrollHeight = (0, _jquery2.default)(document).height();
	          var windowHeight = (0, _jquery2.default)(this).height();
	          if (that.tab1 === 1) {
	            if (scrollTop == 0) {
	              console.log('current topPage: ' + that.topPage);
	              var top_page = parseInt(that.topPage) - 1;
	              console.log('loading page: ' + top_page);
	              console.log('totalPage: ' + that.totalPage);
	              if (that.topPage > 1) {
	                that.page = that.topPage;
	                that.topPage--;
	                that.paging(that.topPage);
	                var newDetailLists = that.newItems.concat(that.detailLists);
	                that.detailLists = newDetailLists;
	                that.$nextTick(function () {
	                  var resultList10 = (0, _jquery2.default)('.search-result-list')[9];
	                  var offsetTop = resultList10.offsetTop;
	                  var offsetHeight = resultList10.offsetHeight;
	                  var newOffsetTop = offsetTop + offsetHeight;
	                  (0, _jquery2.default)(window).scrollTop(newOffsetTop);
	                });
	              }
	            }
	
	            if (scrollTop + windowHeight >= scrollHeight) {
	              console.log('current bottomPage: ' + that.bottomPage);
	              console.log('loading page: ' + that.bottomPage + 1);
	              console.log('totalPage: ' + that.totalPage);
	              if (that.bottomPage < that.totalPage) {
	                that.page = that.bottomPage;
	                that.bottomPage++;
	                that.paging(that.bottomPage);
	                var _newDetailLists = that.detailLists.concat(that.newItems);
	                that.detailLists = _newDetailLists;
	              }
	            }
	          }
	          if (that.tab1 === 2) {
	            if (scrollTop == 0) {
	              that.topPage = 1;
	            }
	
	            if (scrollTop + windowHeight >= scrollHeight) {
	              console.log('cpage: ' + that.cpage);
	              console.log('loading next page: ' + that.cpage + 1);
	              console.log('totalPage: ' + that.totalPage);
	              if (that.cpage < that.totalPage) {
	                var cpage = that.cpage + 1;
	                that.gocompany(cpage);
	              }
	              if (that.cpage === that.totalPage) {
	                (0, _jquery2.default)(this).unbind(e);
	              }
	            }
	          }
	        });
	        this.$nextTick(function () {
	          var wxsharedesc = this.getShareDesc();
	          var wxsharetitle = this.getShareTitle();
	          this.shareResult(wxsharetitle, wxsharedesc);
	
	          if (this.params.desc && this.params.desc != '') {
	            document.title = this.params.desc;
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    setBigImgObj: function setBigImgObj(item, article) {
	      this.bigImgObj.imghead = item.imghead;
	      this.bigImgObj.imgfoot = item.imgfoot;
	      this.bigImgObj.imgurl = item.imgurl;
	      this.bigImgObj.imgid = item.imgid;
	
	      this.bigImgObj.companycode = article.companyCode;
	      this.bigImgObj.companyname = article.companyName;
	      this.bigImgObj.md5 = article.id;
	      this.bigImgObj.publishdate = article.publishDate;
	
	      this.bigImgObj.stype = this.stype;
	      this.bigImgObj.title = article.title;
	
	      this.bigImgObj.show = true;
	    },
	    loadcomment: function loadcomment() {
	      if (this.commentList.length == 0) {
	        this.getCommentList(1, 2, this.sid);
	      }
	    },
	    backToHistory: function backToHistory() {
	      window.history.back();
	    },
	    slideToggle: function slideToggle(param) {
	      if (this.showDropdownMenu === '') {
	        this.showDropdownMenu = param;
	
	        (0, _jquery2.default)('.slide-menu').click(function () {
	          this.showDropdownMenu = '';
	          (0, _jquery2.default)(this).css({ 'display': 'none' });
	        });
	      } else {
	        this.showDropdownMenu = '';
	      }
	    },
	    slideDropdownMenu: function slideDropdownMenu(event) {
	      (0, _jquery2.default)('.Screen-criteria-box').slideToggle('normal');
	      var el = event.currentTarget;
	      var iconDom = el.lastElementChild;
	      var iconClass = iconDom.getAttribute('class'),
	          class1 = iconClass.split(' ')[0],
	          class2 = iconClass.split(' ')[1];
	      if (class2 === 'close') {
	        var _class = class1 + ' ' + 'open';
	        iconDom.setAttribute('class', _class);
	      }
	      if (class2 === 'open') {
	        var _class2 = class1 + ' ' + 'close';
	        iconDom.setAttribute('class', _class2);
	      }
	    },
	    checkLogin: function checkLogin(item) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var url = '';
	      if (item.viewtype === 2) {
	        url = item.sourceurl;
	        window.location.href = url;
	      } else {
	        url = window.location.origin + this.viewUrl(item, this.params);
	        window.location.href = url;
	      }
	    },
	
	    checkLoginQa: function checkLoginQa(item) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      var url = window.location.origin + this.qaViewUrl(item, this.params);
	      if (item.viewtype === 2) {
	        window.location.href = item.sourceurl;
	      } else {
	        window.location.href = url;
	      }
	    },
	    hideKeywordDropdown: function hideKeywordDropdown() {
	      var el = (0, _jquery2.default)('.date-menu');
	      if (el.hasClass('open')) {
	        el.removeClass('open').addClass('close');
	      }
	    },
	
	    addConditionNew: function addConditionNew(type, obj) {
	      if (!this.conditions[type][obj.code]) {
	        var tmp = {};
	        tmp[obj.code] = obj.name;
	        this.conditions[type] = (0, _assign2.default)({}, this.conditions[type], tmp);
	        if (this.searched) {
	          this.go();
	        }
	      } else {
	        var conditions = this.conditions;
	        delete conditions[type][obj.code];
	        this.conditions = (0, _assign2.default)({}, conditions);
	        if (this.searched) {
	          this.go();
	        }
	      }
	      this.showMylabels = 2;
	      this.addToShow();
	    },
	    paging: function paging(page) {
	      var _this2 = this;
	
	      var query = this.genQuery();
	      query.page = page;
	      query.perPage = this.perPage;
	      query.uid = parseInt(this.uidUrl);
	      query.share = this.share;
	      query.plat = this.plat;
	      query.sid = this.sid;
	      query.ruid = this.params.ruid;
	      var reqUrl = '';
	      if (this.stype === 2) {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearchn3b');
	      } else {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearch');
	      }
	      _jquery2.default.ajax({
	        url: reqUrl,
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this2.loading = false;
	        _this2.analyze();
	        if (response.status === 0) {
	          var items = response.lists;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(items), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var item = _step.value;
	
	              item.checked = false;
	              if (item.child) {
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                  for (var _iterator2 = (0, _getIterator3.default)(item.child), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var child = _step2.value;
	
	                    child.showque = false;
	                    if (child.answers) {
	                      var _iteratorNormalCompletion3 = true;
	                      var _didIteratorError3 = false;
	                      var _iteratorError3 = undefined;
	
	                      try {
	                        for (var _iterator3 = (0, _getIterator3.default)(child.answers), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                          var ans = _step3.value;
	
	                          ans.showans = false;
	                        }
	                      } catch (err) {
	                        _didIteratorError3 = true;
	                        _iteratorError3 = err;
	                      } finally {
	                        try {
	                          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                            _iterator3.return();
	                          }
	                        } finally {
	                          if (_didIteratorError3) {
	                            throw _iteratorError3;
	                          }
	                        }
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError2 = true;
	                  _iteratorError2 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                      _iterator2.return();
	                    }
	                  } finally {
	                    if (_didIteratorError2) {
	                      throw _iteratorError2;
	                    }
	                  }
	                }
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this2.newItems = items;
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    search: function search() {
	      var _this3 = this;
	
	      this.getList();
	      console.log("1594");
	      var query = this.genQuery();
	      console.log(query);
	      if (query.ai === 1) {
	        if (this.checkAction('search/ai')) {
	          query.ai = 1;
	        } else {
	          query.ai = 0;
	        }
	      }
	      query.perPage = this.perPage;
	      query.uid = parseInt(this.uidUrl);
	      query.share = this.share;
	      query.plat = this.plat;
	      query.sid = this.sid;
	      query.ruid = this.params.ruid;
	
	      var page = query.page;
	      this.topPage = page;
	      this.bottomPage = page;
	      this.page = page;
	
	      var reqUrl = '';
	      if (this.stype === 2) {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearchn3b');
	      } else {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearch');
	      }
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: reqUrl,
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this3.loading = false;
	        _this3.searched = true;
	        _this3.finance = [];
	        _this3.yearfinance = [];
	        if (_this3.tab1 === 2) {
	          _this3.companysearched = true;
	        }
	        if (response.status === 0) {
	          _this3.sd = response.sd;
	          _this3.exportfilepath = response.url;
	          if (_this3.tab1 === 1) {
	            _this3.initAnaly();
	            var items = response.lists;
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	              for (var _iterator4 = (0, _getIterator3.default)(items), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var item = _step4.value;
	
	                item.checked = false;
	                if (item.child) {
	                  var _iteratorNormalCompletion5 = true;
	                  var _didIteratorError5 = false;
	                  var _iteratorError5 = undefined;
	
	                  try {
	                    for (var _iterator5 = (0, _getIterator3.default)(item.child), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                      var child = _step5.value;
	
	                      child.showque = false;
	                      if (child.answers) {
	                        var _iteratorNormalCompletion6 = true;
	                        var _didIteratorError6 = false;
	                        var _iteratorError6 = undefined;
	
	                        try {
	                          for (var _iterator6 = (0, _getIterator3.default)(child.answers), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                            var ans = _step6.value;
	
	                            ans.showans = false;
	                          }
	                        } catch (err) {
	                          _didIteratorError6 = true;
	                          _iteratorError6 = err;
	                        } finally {
	                          try {
	                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                              _iterator6.return();
	                            }
	                          } finally {
	                            if (_didIteratorError6) {
	                              throw _iteratorError6;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError5 = true;
	                    _iteratorError5 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                      }
	                    } finally {
	                      if (_didIteratorError5) {
	                        throw _iteratorError5;
	                      }
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError4 = true;
	              _iteratorError4 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                  _iterator4.return();
	                }
	              } finally {
	                if (_didIteratorError4) {
	                  throw _iteratorError4;
	                }
	              }
	            }
	
	            _this3.items = items;
	            _this3.detailLists = items;
	            _this3.total = response.total;
	            _this3.totalPage = Math.ceil(_this3.total / 5);
	            _this3.analyze();
	          }
	          if (_this3.tab1 === 2) {
	            var _items = response.lists;
	            _this3.companylist = _items;
	            _this3.ctotal = response.total;
	            _this3.ctotal1 = _items.length;
	            _this3.gocompany(1);
	          }
	
	          _this3.smartComInfo = response.company || {};
	          if (_this3.smartComInfo.finance && _this3.smartComInfo.finance.length > 0) {
	            var a = [' '];
	            for (var k in _this3.smartComInfo.finance[0]) {
	              if (k !== 'plate' && k !== 'reportdate' && k !== 'reportdatestr') {
	                a.push(k);
	              }
	            }
	            _this3.finance.push(a);
	            _this3.yearfinance.push(a);
	            var _iteratorNormalCompletion7 = true;
	            var _didIteratorError7 = false;
	            var _iteratorError7 = undefined;
	
	            try {
	              for (var _iterator7 = (0, _getIterator3.default)(_this3.smartComInfo.finance), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                var _item = _step7.value;
	
	                var arr = [];
	                if (_item.plate === 'A') {
	                  for (var i in _item) {
	                    if (i !== 'plate' && i !== 'reportdatestr') {
	                      arr.push(_item[i]);
	                    }
	                  }
	                  _this3.finance.push(arr);
	                } else {
	                  for (var _i in _item) {
	                    if (_i !== 'plate' && _i !== 'reportdate') {
	                      arr.push(_item[_i]);
	                    }
	                  }
	                  _this3.finance.push(arr);
	                }
	              }
	            } catch (err) {
	              _didIteratorError7 = true;
	              _iteratorError7 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                  _iterator7.return();
	                }
	              } finally {
	                if (_didIteratorError7) {
	                  throw _iteratorError7;
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion8 = true;
	            var _didIteratorError8 = false;
	            var _iteratorError8 = undefined;
	
	            try {
	              for (var _iterator8 = (0, _getIterator3.default)(_this3.finance), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                var _i2 = _step8.value;
	
	                if (_this3.smartComInfo.type === 'A') {
	                  if (_i2[0] && _i2[0].indexOf('-12-') > 0) {
	                    _this3.yearfinance.push(_i2);
	                  }
	                } else {
	                  if (_i2[0] && _i2[0].indexOf('年报') > 0) {
	                    _this3.yearfinance.push(_i2);
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError8 = true;
	              _iteratorError8 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                  _iterator8.return();
	                }
	              } finally {
	                if (_didIteratorError8) {
	                  throw _iteratorError8;
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion9 = true;
	            var _didIteratorError9 = false;
	            var _iteratorError9 = undefined;
	
	            try {
	              for (var _iterator9 = (0, _getIterator3.default)(_this3.finance), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                var _i3 = _step9.value;
	
	                if (_i3[0].indexOf('年') >= 0) {
	                  _i3[0] = _i3[0].substr(0, 4) + _this3.dataMap[_i3[0].substr(4)];
	                }
	              }
	            } catch (err) {
	              _didIteratorError9 = true;
	              _iteratorError9 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                  _iterator9.return();
	                }
	              } finally {
	                if (_didIteratorError9) {
	                  throw _iteratorError9;
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	              for (var _iterator10 = (0, _getIterator3.default)(_this3.yearfinance), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                var _i4 = _step10.value;
	
	                if (_i4[0].indexOf('年') >= 0) {
	                  _i4[0] = _i4[0].substr(0, 4) + _this3.dataMap[_i4[0].substr(4)];
	                }
	              }
	            } catch (err) {
	              _didIteratorError10 = true;
	              _iteratorError10 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                  _iterator10.return();
	                }
	              } finally {
	                if (_didIteratorError10) {
	                  throw _iteratorError10;
	                }
	              }
	            }
	
	            _this3.finance.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	            _this3.yearfinance.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	          } else {
	            _this3.finance = [];
	            _this3.yearfinance = [];
	          }
	          _this3.prices = _this3.smartComInfo.price || {};
	          if (_this3.prices.trade && _this3.prices.settlement) {
	            _this3.upanddown = (_this3.prices.trade - _this3.prices.settlement).toFixed(2);
	            if (_this3.upanddown > 0 || _this3.upanddown == 0) {
	              _this3.upanddown = '+' + _this3.upanddown;
	            }
	            _this3.Amplitude = ((_this3.prices.trade - _this3.prices.settlement) / _this3.prices.settlement * 100).toFixed(2);
	            if (_this3.Amplitude > 0) {
	              _this3.Amplitude = '+' + _this3.Amplitude;
	            }
	          }
	          _this3.searched = _this3.stype;
	
	          if (_this3.page !== 1) {
	            _this3.$nextTick(function () {
	              (0, _jquery2.default)(window).scrollTop(23);
	            });
	          }
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this3.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    selSort: function selSort(val) {
	      this.sort = val;
	      this.showSort = false;
	      if (this.searched) {
	        this.go();
	      }
	    },
	    shareResult: function shareResult(fulltitle, desc) {
	      var _this4 = this;
	
	      var title = fulltitle;
	
	      var query = {};
	      query.url = window.location.href.split('#')[0];
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/getwxsign'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          var data = response.data;
	
	          wx.config({
	            debug: false,
	            appId: _this4.$config.weixin.appid,
	            timestamp: data.timestamp,
	            nonceStr: data.nonceStr,
	            signature: data.signature,
	            jsApiList: ['checkJsApi', 'onMenuShareAppMessage', 'onMenuShareTimeline']
	          });
	          var href = window.location.href;
	          href = _this4.changeUrlArg(href, 'uid', _this4.uid);
	          href = _this4.changeUrlArg(href, 'ruid', _this4.params.uidUrl);
	          var shareLink = href;
	          var shareImgLink = window.location.origin + '/static/images/wx-share-logo.jpg';
	          var that = _this4;
	
	          wx.ready(function () {
	            wx.checkJsApi({
	              jsApiList: ['onMenuShareAppMessage', 'onMenuShareTimeline'],
	              success: function success(res) {
	                console.log((0, _stringify2.default)(res));
	              }
	            });
	
	            wx.onMenuShareAppMessage({
	              title: title,
	              desc: desc,
	              link: shareLink,
	              imgUrl: shareImgLink,
	              trigger: function trigger(res) {
	                console.log('用户点击发送给朋友');
	              },
	              success: function success(res) {
	                console.log('分享给朋友——成功！');
	                that.shareStatus(that.params.sid, 1);
	              },
	              cancel: function cancel(res) {
	                console.log('分享给朋友——取消！');
	              },
	              fail: function fail(res) {
	                console.log((0, _stringify2.default)(res));
	                that.shareStatus(that.params.sid, 3);
	              }
	            });
	
	            wx.onMenuShareTimeline({
	              title: title,
	              link: shareLink,
	              imgUrl: shareImgLink,
	              trigger: function trigger(res) {
	                console.log('用户点击发送给朋友圈');
	              },
	              success: function success(res) {
	                console.log('分享到朋友圈——成功！');
	                that.shareStatus(that.params.sid, 1);
	              },
	              cancel: function cancel(res) {
	                console.log('分享到朋友圈——取消！');
	              },
	              fail: function fail(res) {
	                console.log((0, _stringify2.default)(res));
	                that.shareStatus(that.params.sid, 3);
	              }
	            });
	          });
	
	          wx.error(function (res) {
	            console.log((0, _stringify2.default)(res));
	          });
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getShareTitle: function getShareTitle() {
	      var desc = '';
	      if (this.diysharedesc === '') {
	        desc = '深度搜索是一种强力搜索模式，它允许用户创建多维度的复合搜索条件，从而支持强大的信息定位能力，实现更为精准的搜索效果。通过深度搜索，用户可以构建起接近自然语言的复杂查询，并且在瞬间获得精准的搜索结果。';
	      } else {
	        desc = this.diysharedesc;
	      }
	      return desc;
	    },
	    getShareDesc: function getShareDesc() {
	      var sharetitle = '你的朋友' + this.shareUsername + '通过IBDATA给你分享了一份他的独家数据！';
	      return sharetitle;
	    },
	    goBindPage: function goBindPage() {
	      var nowUrl = window.location.href + '&desc=' + this.diysharedesc;
	      this.getShortLink(nowUrl);
	      var uri = encodeURIComponent(this.goBindPageShortLink);
	      window.location.href = 'http://' + this.$config.host.bind + '/#!/wechatlogin' + '?uri=' + uri;
	    },
	    goCompanyDetail: function goCompanyDetail(item) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.scrollTopPos = (0, _jquery2.default)(window).scrollTop();
	      console.log(this.scrollTopPos);
	      this.currentCompanyDetail = item;
	      this.showCompanyDetailWrap = true;
	      (0, _jquery2.default)(window).scrollTop(0);
	    },
	    hideCompanyDetail: function hideCompanyDetail() {
	      this.showCompanyDetailWrap = false;
	      this.currentCompanyDetail = {};
	      var pos = this.scrollTopPos;
	      var timer = setTimeout(function () {
	        (0, _jquery2.default)(window).scrollTop(pos);
	      }, 100);
	    },
	    gocompany: function gocompany(page) {
	      this.cpage = page || 1;
	      this.cpage = this.cpage > this.totalPage ? this.totalPage : this.cpage;
	      var begin = this.cperPage * (this.cpage - 1);
	      var newitems = this.companyitems.concat(this.companylist.slice(begin, begin + this.cperPage));
	      this.companyitems = newitems;
	      console.log(this.companyitems);
	    },
	
	    onlyTitleGet: function onlyTitleGet() {
	      this.onlyTitle = !this.onlyTitle;
	    },
	    dropdown: function dropdown(e) {
	      var tar = (0, _jquery2.default)('.tag-button');
	      if (!tar.is(e.target) && tar.has(e.target).length === 0) {
	        this.tab3 = 0;
	      }
	    },
	    downOne: function downOne(item, i) {
	      (0, _jquery2.default)('.advDow_' + i).css('display', 'none');
	      (0, _jquery2.default)('#advDow_' + i).css('display', 'block');
	      var a = this.downloadUrl(item);
	      window.location.href = a;
	      setTimeout(function () {
	        (0, _jquery2.default)('.advDow_' + i).css('display', 'block');
	        (0, _jquery2.default)('#advDow_' + i).css('display', 'none');
	      }, 1000);
	    },
	    initAnaly: function initAnaly() {
	      this.company = [];
	      this.related_company = [];
	      this.related_name = [];
	      this.aggTypes = [];
	      this.aggPlates = [];
	      this.aggLabels = [];
	    },
	    getMetaMap: function getMetaMap(conditions) {
	      var _iteratorNormalCompletion11 = true;
	      var _didIteratorError11 = false;
	      var _iteratorError11 = undefined;
	
	      try {
	        for (var _iterator11 = (0, _getIterator3.default)(conditions), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	          var d = _step11.value;
	
	          this.metaMap[d.code] = d;
	          if (d.hasOwnProperty('child')) {
	            if (d.child.length > 0) {
	              this.getMetaMap(d.child);
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError11 = true;
	        _iteratorError11 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion11 && _iterator11.return) {
	            _iterator11.return();
	          }
	        } finally {
	          if (_didIteratorError11) {
	            throw _iteratorError11;
	          }
	        }
	      }
	    },
	    getCrumbs: function getCrumbs(conditions, parent) {
	      var _iteratorNormalCompletion12 = true;
	      var _didIteratorError12 = false;
	      var _iteratorError12 = undefined;
	
	      try {
	        for (var _iterator12 = (0, _getIterator3.default)(conditions), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	          var d = _step12.value;
	
	          d.parent = parent || null;
	          var code = d.code;
	          if (code) {
	            var metad = this.metaMap[code];
	            if (metad.uniq === 1) {
	              this.uniqMap[code] = 1;
	            }
	          }
	          if (d.parent) {
	            var pcode = d.parent.code;
	            if (this.metaMap.hasOwnProperty(pcode)) {
	              if (d.multi && pcode !== 'industry' && d.parent.parent) {
	                var ppcode = d.parent.parent.code;
	                d.ref = this.metaMap[ppcode].child;
	              } else {
	                d.ref = this.metaMap[pcode].child;
	              }
	            }
	          }
	          if (d.hasOwnProperty('child')) {
	            if (d.child.length > 0) {
	              this.getCrumbs(d.child, d);
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError12 = true;
	        _iteratorError12 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion12 && _iterator12.return) {
	            _iterator12.return();
	          }
	        } finally {
	          if (_didIteratorError12) {
	            throw _iteratorError12;
	          }
	        }
	      }
	
	      this.condition = conditions;
	    },
	
	    common: function common(condition) {
	      this.ai = condition.ai;
	      this.searchCondition = condition.condition;
	      var searchCondition = condition.condition;
	      var ssfw = {
	        all: [],
	        ggbt: [],
	        zw: [],
	        zj: {
	          zjzw: [],
	          zjbt: []
	        }
	      };
	      var gs = {
	        jbxx: {
	          gsmc: [],
	          region: [],
	          zczb: [],
	          gssz: [],
	          ssrq: [],
	          industry: [],
	          zyyw: [],
	          companycode: [],
	          zcdz: [] },
	        cwsj: {
	          cwzb: {
	            yspj: [],
	            yszk: [],
	            ch: [],
	            ldzc: [],
	            zzc: [],
	            ldfz: [],
	            fzze: [],
	            sszb: [],
	            gdqyhj: [],
	            yyzsr: [],
	            yysr: [],
	            yycb: [],
	            jlr: [],
	            jbmgsy: [],
	            xsmgsy: [] },
	          gjbl: {
	            zcfzl: [],
	            ldbl: [],
	            sdbl: [],
	            mlv: [],
	            jlv: [],
	            jzcsyl: [],
	            ckzzl: [],
	            mgjzc: [],
	            mgjyxjllje: [] } }
	      };
	      var _iteratorNormalCompletion13 = true;
	      var _didIteratorError13 = false;
	      var _iteratorError13 = undefined;
	
	      try {
	        for (var _iterator13 = (0, _getIterator3.default)(searchCondition), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	          var sc = _step13.value;
	
	          if (sc.code === 'ssfw') {
	            var _iteratorNormalCompletion14 = true;
	            var _didIteratorError14 = false;
	            var _iteratorError14 = undefined;
	
	            try {
	              for (var _iterator14 = (0, _getIterator3.default)(sc.child), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	                var c = _step14.value;
	
	                if (c.code === 'all') {
	                  ssfw.all.push(c);
	                } else if (c.code === 'ggbt') {
	                  ssfw.ggbt.push(c);
	                } else if (c.code === 'zw') {
	                  ssfw.zw.push(c);
	                } else if (c.name === '章节') {
	                  var _iteratorNormalCompletion15 = true;
	                  var _didIteratorError15 = false;
	                  var _iteratorError15 = undefined;
	
	                  try {
	                    for (var _iterator15 = (0, _getIterator3.default)(c.child), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	                      var i = _step15.value;
	
	                      if (i.code === 'zjzw') {
	                        ssfw.zj.zjzw.push(i);
	                      }
	                      if (i.code === 'jzjbt') {
	                        ssfw.zj.zjbt.push(i);
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError15 = true;
	                    _iteratorError15 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                        _iterator15.return();
	                      }
	                    } finally {
	                      if (_didIteratorError15) {
	                        throw _iteratorError15;
	                      }
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError14 = true;
	              _iteratorError14 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion14 && _iterator14.return) {
	                  _iterator14.return();
	                }
	              } finally {
	                if (_didIteratorError14) {
	                  throw _iteratorError14;
	                }
	              }
	            }
	          }
	          if (sc.code === 'company') {
	            var _iteratorNormalCompletion16 = true;
	            var _didIteratorError16 = false;
	            var _iteratorError16 = undefined;
	
	            try {
	              for (var _iterator16 = (0, _getIterator3.default)(sc.child), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	                var c = _step16.value;
	
	                if (c.code === 'jbxx') {
	                  console.log('jbxx');
	                  var _iteratorNormalCompletion17 = true;
	                  var _didIteratorError17 = false;
	                  var _iteratorError17 = undefined;
	
	                  try {
	                    for (var _iterator17 = (0, _getIterator3.default)(c.child), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	                      var item = _step17.value;
	
	                      if (item.code === 'gsmc') {
	                        gs.jbxx.gsmc.push(item);
	                      } else if (item.code === 'region') {
	                        gs.jbxx.region.push(item);
	                      } else if (item.code === 'zczb') {
	                        gs.jbxx.zczb.push(item);
	                      } else if (item.code === 'gssz') {
	                        gs.jbxx.gssz.push(item);
	                      } else if (item.code === 'ssrq') {
	                        gs.jbxx.ssrq.push(item);
	                      } else if (item.code === 'industry') {
	                        gs.jbxx.industry.push(item);
	                      } else if (item.code === 'zyyw') {
	                        gs.jbxx.zyyw.push(item);
	                      } else if (item.code === 'companycode') {
	                        gs.jbxx.companycode.push(item);
	                      } else if (item.code === 'zcdz') {
	                        gs.jbxx.zcdz.push(item);
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError17 = true;
	                    _iteratorError17 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion17 && _iterator17.return) {
	                        _iterator17.return();
	                      }
	                    } finally {
	                      if (_didIteratorError17) {
	                        throw _iteratorError17;
	                      }
	                    }
	                  }
	                }
	                if (c.code === 'cwsj') {
	                  console.log('财务数据');
	                  console.log(c);
	                  var _iteratorNormalCompletion18 = true;
	                  var _didIteratorError18 = false;
	                  var _iteratorError18 = undefined;
	
	                  try {
	                    for (var _iterator18 = (0, _getIterator3.default)(c.child), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	                      var item = _step18.value;
	
	                      if (item.code === 'cwzb') {
	                        console.log('cwzb');
	                        var _iteratorNormalCompletion19 = true;
	                        var _didIteratorError19 = false;
	                        var _iteratorError19 = undefined;
	
	                        try {
	                          for (var _iterator19 = (0, _getIterator3.default)(item.child), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	                            var i = _step19.value;
	
	                            if (i.code === 'yspj') {
	                              gs.cwsj.cwzb.yspj.push(i);
	                            } else if (i.code === 'yszk') {
	                              gs.cwsj.cwzb.yszk.push(i);
	                            } else if (i.code === 'ch') {
	                              gs.cwsj.cwzb.ch.push(i);
	                            } else if (i.code === 'ldzc') {
	                              gs.cwsj.cwzb.ldzc.push(i);
	                            } else if (i.code === 'zzc') {
	                              gs.cwsj.cwzb.zzc.push(i);
	                            } else if (i.code === 'ldfz') {
	                              gs.cwsj.cwzb.ldfz.push(i);
	                            } else if (i.code === 'fzze') {
	                              gs.cwsj.cwzb.fzze.push(i);
	                            } else if (i.code === 'sszb') {
	                              gs.cwsj.cwzb.sszb.push(i);
	                            } else if (i.code === 'gdqyhj') {
	                              gs.cwsj.cwzb.gdqyhj.push(i);
	                            } else if (i.code === 'yyzsr') {
	                              gs.cwsj.cwzb.yyzsr.push(i);
	                            } else if (i.code === 'yysr') {
	                              gs.cwsj.cwzb.yysr.push(i);
	                            } else if (i.code === 'yycb') {
	                              gs.cwsj.cwzb.yycb.push(i);
	                            } else if (i.code === 'jlr') {
	                              gs.cwsj.cwzb.jlr.push(i);
	                            } else if (i.code === 'jbmgsy') {
	                              gs.cwsj.cwzb.jbmgsy.push(i);
	                            } else if (i.code === 'xsmgsy') {
	                              gs.cwsj.cwzb.xsmgsy.push(i);
	                            }
	                          }
	                        } catch (err) {
	                          _didIteratorError19 = true;
	                          _iteratorError19 = err;
	                        } finally {
	                          try {
	                            if (!_iteratorNormalCompletion19 && _iterator19.return) {
	                              _iterator19.return();
	                            }
	                          } finally {
	                            if (_didIteratorError19) {
	                              throw _iteratorError19;
	                            }
	                          }
	                        }
	                      }
	                      if (item.code === 'gjbl') {
	                        console.log('gjbl');
	                        var _iteratorNormalCompletion20 = true;
	                        var _didIteratorError20 = false;
	                        var _iteratorError20 = undefined;
	
	                        try {
	                          for (var _iterator20 = (0, _getIterator3.default)(item.child), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	                            var i = _step20.value;
	
	                            if (i.code === 'zcfzl') {
	                              gs.cwsj.gjbl.zcfzl.push(i);
	                            } else if (i.code === 'ldbl') {
	                              gs.cwsj.gjbl.ldbl.push(i);
	                            } else if (i.code === 'sdbl') {
	                              gs.cwsj.gjbl.sdbl.push(i);
	                            } else if (i.code === 'mlv') {
	                              gs.cwsj.gjbl.mlv.push(i);
	                            } else if (i.code === 'jlv') {
	                              gs.cwsj.gjbl.jlv.push(i);
	                            } else if (i.code === 'jzcsyl') {
	                              gs.cwsj.gjbl.jzcsyl.push(i);
	                            } else if (i.code === 'ckzzl') {
	                              gs.cwsj.gjbl.ckzzl.push(i);
	                            } else if (i.code === 'mgjzc') {
	                              gs.cwsj.gjbl.mgjzc.push(i);
	                            } else if (i.code === 'mgjyxjllje') {
	                              gs.cwsj.gjbl.mgjyxjllje.push(i);
	                            }
	                          }
	                        } catch (err) {
	                          _didIteratorError20 = true;
	                          _iteratorError20 = err;
	                        } finally {
	                          try {
	                            if (!_iteratorNormalCompletion20 && _iterator20.return) {
	                              _iterator20.return();
	                            }
	                          } finally {
	                            if (_didIteratorError20) {
	                              throw _iteratorError20;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError18 = true;
	                    _iteratorError18 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion18 && _iterator18.return) {
	                        _iterator18.return();
	                      }
	                    } finally {
	                      if (_didIteratorError18) {
	                        throw _iteratorError18;
	                      }
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError16 = true;
	              _iteratorError16 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion16 && _iterator16.return) {
	                  _iterator16.return();
	                }
	              } finally {
	                if (_didIteratorError16) {
	                  throw _iteratorError16;
	                }
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError13 = true;
	        _iteratorError13 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion13 && _iterator13.return) {
	            _iterator13.return();
	          }
	        } finally {
	          if (_didIteratorError13) {
	            throw _iteratorError13;
	          }
	        }
	      }
	
	      this.ssfw = ssfw;
	      this.gs = gs;
	      console.log(ssfw);
	      console.log(gs);
	      this.tab1 = condition.typ;
	      this.sort = condition.sort;
	      this.stype = condition.stype;
	      if (this.tab1 === 1) {
	        this.page = condition.page;
	        this.perPage = condition.perPage;
	      }
	      if (this.tab1 === 2) {
	        this.cpage = condition.page;
	        this.cperPage = condition.perPage;
	      }
	      this.getCrumbs(condition.condition);
	      this.search();
	    },
	
	    parseUrlQuery: function parseUrlQuery(query) {
	      var _this5 = this;
	
	      if (query.hasOwnProperty('sd')) {
	        _jquery2.default.ajax({
	          url: (0, _helper.apiUrl)('/V1.0.0/notice/getcond'),
	          method: 'post',
	          dataType: 'json',
	          async: false,
	          data: (0, _stringify2.default)({ 'sd': query['sd'] })
	        }).done(function (response) {
	          if (response.status === 0) {
	            var condition = response.condition;
	            _this5.common(condition);
	          }
	        }).fail(function (response) {
	          (0, _helper.alert)('请求失败');
	        });
	      }
	    },
	    customShow: function customShow() {
	      this.showCustom = true;
	    },
	    initCond: function initCond(cond) {
	      this.lvl1 = [];
	      this.lvl2 = [];
	      this.lvl3 = [];
	      this.crumbs = [];
	      this.curcond = cond || null;
	      var i = 0;
	      var lvl1 = [];
	      if (cond) {
	        lvl1 = cond.ref;
	      } else {
	        lvl1 = this.meta;
	      }
	      var _iteratorNormalCompletion21 = true;
	      var _didIteratorError21 = false;
	      var _iteratorError21 = undefined;
	
	      try {
	        for (var _iterator21 = (0, _getIterator3.default)(lvl1), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
	          var d = _step21.value;
	
	          if (d.hasOwnProperty('stype')) {
	            if (d.stype !== this.stype) {
	              continue;
	            }
	          }
	          if (d.uniq === 1) {
	            if (this.uniqMap.hasOwnProperty(d.code)) {
	              continue;
	            }
	          }
	          var t = {};
	          (0, _assign2.default)(t, d, { 'selected': false });
	          this.lvl1.push(t);
	          i++;
	        }
	      } catch (err) {
	        _didIteratorError21 = true;
	        _iteratorError21 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion21 && _iterator21.return) {
	            _iterator21.return();
	          }
	        } finally {
	          if (_didIteratorError21) {
	            throw _iteratorError21;
	          }
	        }
	      }
	    },
	    addCond: function addCond(cond) {
	      this.showCondition = true;
	      this.initCond(cond);
	    },
	    selectCond: function selectCond(cond) {
	      if (!cond.industry) {
	        var _iteratorNormalCompletion22 = true;
	        var _didIteratorError22 = false;
	        var _iteratorError22 = undefined;
	
	        try {
	          for (var _iterator22 = (0, _getIterator3.default)(this.lvl2), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
	            var d = _step22.value;
	
	            if (d.selected) {
	              d.selected = false;
	              this.crumbs.splice(-1, 1);
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError22 = true;
	          _iteratorError22 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion22 && _iterator22.return) {
	              _iterator22.return();
	            }
	          } finally {
	            if (_didIteratorError22) {
	              throw _iteratorError22;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion23 = true;
	        var _didIteratorError23 = false;
	        var _iteratorError23 = undefined;
	
	        try {
	          for (var _iterator23 = (0, _getIterator3.default)(this.lvl1), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
	            var _d = _step23.value;
	
	            if (_d.selected) {
	              _d.selected = false;
	              this.crumbs.splice(-1, 1);
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError23 = true;
	          _iteratorError23 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion23 && _iterator23.return) {
	              _iterator23.return();
	            }
	          } finally {
	            if (_didIteratorError23) {
	              throw _iteratorError23;
	            }
	          }
	        }
	
	        cond.selected = true;
	        var crumb = { 'name': cond.name, 'code': cond.code, 'type': cond.type, 'ref': this.lvl1, 'op': 1, 'stype': cond.stype, 'unit': cond.unit, 'uniq': cond.uniq };
	        if (cond.type === 'Date' || cond.type === 'Money') {
	          crumb['range'] = 1;
	          crumb['value'] = '';
	          crumb['value1'] = '';
	        }
	        if (cond.type === 'Finance') {
	          crumb['year'] = '2016';
	          crumb['quarter'] = '年报';
	          crumb['range'] = 1;
	          crumb['value'] = '';
	          crumb['value1'] = '';
	        }
	        this.crumbs.push(crumb);
	      }
	      if (cond.hasOwnProperty('child') && cond.child.length > 0) {
	        this.lvl2 = [];
	        var _iteratorNormalCompletion24 = true;
	        var _didIteratorError24 = false;
	        var _iteratorError24 = undefined;
	
	        try {
	          for (var _iterator24 = (0, _getIterator3.default)(cond.child), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
	            var _d2 = _step24.value;
	
	            if (_d2.hasOwnProperty('stype')) {
	              if (_d2.stype !== this.stype) {
	                continue;
	              }
	            }
	            var t = {};
	            if (cond.code === 'industry') {
	              (0, _assign2.default)(t, _d2, { 'selected': false, 'industry': true });
	            } else {
	              (0, _assign2.default)(t, _d2, { 'selected': false });
	            }
	            this.lvl2.push(t);
	          }
	        } catch (err) {
	          _didIteratorError24 = true;
	          _iteratorError24 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion24 && _iterator24.return) {
	              _iterator24.return();
	            }
	          } finally {
	            if (_didIteratorError24) {
	              throw _iteratorError24;
	            }
	          }
	        }
	      } else {
	        this.lvl2 = [];
	        var crumbs = [];
	        var _iteratorNormalCompletion25 = true;
	        var _didIteratorError25 = false;
	        var _iteratorError25 = undefined;
	
	        try {
	          for (var _iterator25 = (0, _getIterator3.default)(this.crumbs), _step25; !(_iteratorNormalCompletion25 = (_step25 = _iterator25.next()).done); _iteratorNormalCompletion25 = true) {
	            var c = _step25.value;
	
	            crumbs.push((0, _assign2.default)({}, c, { 'child': [] }));
	          }
	        } catch (err) {
	          _didIteratorError25 = true;
	          _iteratorError25 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion25 && _iterator25.return) {
	              _iterator25.return();
	            }
	          } finally {
	            if (_didIteratorError25) {
	              throw _iteratorError25;
	            }
	          }
	        }
	
	        this.crumbs = crumbs;
	        var i = 0;
	        var len = this.crumbs.length;
	        var _iteratorNormalCompletion26 = true;
	        var _didIteratorError26 = false;
	        var _iteratorError26 = undefined;
	
	        try {
	          for (var _iterator26 = (0, _getIterator3.default)(this.crumbs), _step26; !(_iteratorNormalCompletion26 = (_step26 = _iterator26.next()).done); _iteratorNormalCompletion26 = true) {
	            var _c = _step26.value;
	
	            if (_c.uniq === 1) {
	              this.uniqMap[_c.code] = 1;
	            }
	            if (i + 1 < len) {
	              this.crumbs[i + 1].parent = _c;
	              _c.child.push(this.crumbs[i + 1]);
	            }
	            i++;
	          }
	        } catch (err) {
	          _didIteratorError26 = true;
	          _iteratorError26 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion26 && _iterator26.return) {
	              _iterator26.return();
	            }
	          } finally {
	            if (_didIteratorError26) {
	              throw _iteratorError26;
	            }
	          }
	        }
	
	        if (!this.curcond) {
	          this.condition.push(this.crumbs[0]);
	        } else {
	          this.crumbs[0].parent = this.curcond.parent;
	          this.curcond.parent.child.push(this.crumbs[0]);
	        }
	        this.showCondition = false;
	      }
	    },
	    selectChildCond: function selectChildCond(cond) {
	      if (!cond.industry) {
	        var _iteratorNormalCompletion27 = true;
	        var _didIteratorError27 = false;
	        var _iteratorError27 = undefined;
	
	        try {
	          for (var _iterator27 = (0, _getIterator3.default)(this.lvl2), _step27; !(_iteratorNormalCompletion27 = (_step27 = _iterator27.next()).done); _iteratorNormalCompletion27 = true) {
	            var d = _step27.value;
	
	            if (d.selected) {
	              d.selected = false;
	              this.crumbs.splice(-1, 1);
	              break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError27 = true;
	          _iteratorError27 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion27 && _iterator27.return) {
	              _iterator27.return();
	            }
	          } finally {
	            if (_didIteratorError27) {
	              throw _iteratorError27;
	            }
	          }
	        }
	
	        cond.selected = true;
	        var crumb = { 'name': cond.name, 'code': cond.code, 'type': cond.type, 'ref': this.lvl2, 'op': 1, 'stype': cond.stype, 'unit': cond.unit, 'uniq': cond.uniq };
	        if (cond.type === 'Date' || cond.type === 'Money') {
	          crumb['range'] = 1;
	          crumb['value'] = '';
	          crumb['value1'] = '';
	        }
	        if (cond.type === 'Finance') {
	          crumb['year'] = '2016';
	          crumb['quarter'] = '年报';
	          crumb['range'] = 1;
	          crumb['value'] = '';
	          crumb['value1'] = '';
	        }
	        this.crumbs.push(crumb);
	      }
	      if (cond.hasOwnProperty('child') && cond.child.length > 0) {
	        this.lvl1 = this.lvl2;
	        this.lvl2 = [];
	        var _iteratorNormalCompletion28 = true;
	        var _didIteratorError28 = false;
	        var _iteratorError28 = undefined;
	
	        try {
	          for (var _iterator28 = (0, _getIterator3.default)(cond.child), _step28; !(_iteratorNormalCompletion28 = (_step28 = _iterator28.next()).done); _iteratorNormalCompletion28 = true) {
	            var _d3 = _step28.value;
	
	            if (_d3.hasOwnProperty('stype')) {
	              if (_d3.stype !== this.stype) {
	                continue;
	              }
	              if (_d3.uniq === 1) {
	                if (this.uniqMap.hasOwnProperty(_d3.code)) {
	                  continue;
	                }
	              }
	            }
	            var t = {};
	            if (cond.code === 'industry') {
	              (0, _assign2.default)(t, _d3, { 'selected': false, 'industry': true });
	            } else {
	              (0, _assign2.default)(t, _d3, { 'selected': false });
	            }
	            this.lvl2.push(t);
	          }
	        } catch (err) {
	          _didIteratorError28 = true;
	          _iteratorError28 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion28 && _iterator28.return) {
	              _iterator28.return();
	            }
	          } finally {
	            if (_didIteratorError28) {
	              throw _iteratorError28;
	            }
	          }
	        }
	      } else {
	        var crumbs = [];
	        var _iteratorNormalCompletion29 = true;
	        var _didIteratorError29 = false;
	        var _iteratorError29 = undefined;
	
	        try {
	          for (var _iterator29 = (0, _getIterator3.default)(this.crumbs), _step29; !(_iteratorNormalCompletion29 = (_step29 = _iterator29.next()).done); _iteratorNormalCompletion29 = true) {
	            var c = _step29.value;
	
	            crumbs.push((0, _assign2.default)({}, c, { 'child': [] }));
	          }
	        } catch (err) {
	          _didIteratorError29 = true;
	          _iteratorError29 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion29 && _iterator29.return) {
	              _iterator29.return();
	            }
	          } finally {
	            if (_didIteratorError29) {
	              throw _iteratorError29;
	            }
	          }
	        }
	
	        this.crumbs = crumbs;
	        var i = 0;
	        var len = this.crumbs.length;
	        var _iteratorNormalCompletion30 = true;
	        var _didIteratorError30 = false;
	        var _iteratorError30 = undefined;
	
	        try {
	          for (var _iterator30 = (0, _getIterator3.default)(this.crumbs), _step30; !(_iteratorNormalCompletion30 = (_step30 = _iterator30.next()).done); _iteratorNormalCompletion30 = true) {
	            var _c2 = _step30.value;
	
	            if (_c2.uniq === 1) {
	              this.uniqMap[_c2.code] = 1;
	            }
	            if (i + 1 < len) {
	              this.crumbs[i + 1].parent = _c2;
	              _c2.child.push(this.crumbs[i + 1]);
	            }
	            i++;
	          }
	        } catch (err) {
	          _didIteratorError30 = true;
	          _iteratorError30 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion30 && _iterator30.return) {
	              _iterator30.return();
	            }
	          } finally {
	            if (_didIteratorError30) {
	              throw _iteratorError30;
	            }
	          }
	        }
	
	        if (!this.curcond) {
	          this.condition.push(this.crumbs[0]);
	        } else {
	          this.crumbs[0].parent = this.curcond.parent;
	          this.curcond.parent.child.push(this.crumbs[0]);
	        }
	        this.showCondition = false;
	      }
	    },
	    companyDetail: function companyDetail(d) {
	      console.log(d["companyCode"]);
	
	      if (this.stype === 3) {
	        (0, _helper.alert)('no!');
	        return false;
	      }
	
	      window.open('/#!/companyInfo/' + '?code=' + d['companyCode'] + '&stype=' + this.stype);
	    },
	    selectThirdCond: function selectThirdCond(cond) {
	      cond.selected = true;
	      var _iteratorNormalCompletion31 = true;
	      var _didIteratorError31 = false;
	      var _iteratorError31 = undefined;
	
	      try {
	        for (var _iterator31 = (0, _getIterator3.default)(this.lvl3), _step31; !(_iteratorNormalCompletion31 = (_step31 = _iterator31.next()).done); _iteratorNormalCompletion31 = true) {
	          var d = _step31.value;
	
	          if (d.code === cond.code) {
	            return false;
	          }
	        }
	      } catch (err) {
	        _didIteratorError31 = true;
	        _iteratorError31 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion31 && _iterator31.return) {
	            _iterator31.return();
	          }
	        } finally {
	          if (_didIteratorError31) {
	            throw _iteratorError31;
	          }
	        }
	      }
	
	      this.lvl3.push(cond);
	    },
	    rmvThirdCond: function rmvThirdCond(idx) {
	      var _iteratorNormalCompletion32 = true;
	      var _didIteratorError32 = false;
	      var _iteratorError32 = undefined;
	
	      try {
	        for (var _iterator32 = (0, _getIterator3.default)(this.lvl2), _step32; !(_iteratorNormalCompletion32 = (_step32 = _iterator32.next()).done); _iteratorNormalCompletion32 = true) {
	          var d = _step32.value;
	
	          if (d.code === this.lvl3[idx].code) {
	            d.selected = false;
	            break;
	          }
	        }
	      } catch (err) {
	        _didIteratorError32 = true;
	        _iteratorError32 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion32 && _iterator32.return) {
	            _iterator32.return();
	          }
	        } finally {
	          if (_didIteratorError32) {
	            throw _iteratorError32;
	          }
	        }
	      }
	
	      this.lvl3.splice(idx, 1);
	    },
	    confirmThirdCond: function confirmThirdCond() {
	      if (this.curcond && this.curcond.multi) {
	        var indus = this.curcond.value;
	        var selected = {};
	        var _iteratorNormalCompletion33 = true;
	        var _didIteratorError33 = false;
	        var _iteratorError33 = undefined;
	
	        try {
	          for (var _iterator33 = (0, _getIterator3.default)(indus), _step33; !(_iteratorNormalCompletion33 = (_step33 = _iterator33.next()).done); _iteratorNormalCompletion33 = true) {
	            var _d4 = _step33.value;
	
	            selected[_d4.code] = 1;
	          }
	        } catch (err) {
	          _didIteratorError33 = true;
	          _iteratorError33 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion33 && _iterator33.return) {
	              _iterator33.return();
	            }
	          } finally {
	            if (_didIteratorError33) {
	              throw _iteratorError33;
	            }
	          }
	        }
	
	        var _iteratorNormalCompletion34 = true;
	        var _didIteratorError34 = false;
	        var _iteratorError34 = undefined;
	
	        try {
	          for (var _iterator34 = (0, _getIterator3.default)(this.lvl3), _step34; !(_iteratorNormalCompletion34 = (_step34 = _iterator34.next()).done); _iteratorNormalCompletion34 = true) {
	            var d = _step34.value;
	
	            if (!selected.hasOwnProperty(d.code)) {
	              this.curcond.value.push({ 'name': d.name, 'code': d.code });
	            }
	          }
	        } catch (err) {
	          _didIteratorError34 = true;
	          _iteratorError34 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion34 && _iterator34.return) {
	              _iterator34.return();
	            }
	          } finally {
	            if (_didIteratorError34) {
	              throw _iteratorError34;
	            }
	          }
	        }
	
	        this.showCondition = false;
	        return;
	      }
	      var crumb = { 'multi': 1, 'type': 'Value', 'op': 2, 'value': [], 'ref': this.lvl1 };
	      var _iteratorNormalCompletion35 = true;
	      var _didIteratorError35 = false;
	      var _iteratorError35 = undefined;
	
	      try {
	        for (var _iterator35 = (0, _getIterator3.default)(this.lvl3), _step35; !(_iteratorNormalCompletion35 = (_step35 = _iterator35.next()).done); _iteratorNormalCompletion35 = true) {
	          var _d5 = _step35.value;
	
	          crumb['value'].push({ 'name': _d5.name, 'code': _d5.code });
	        }
	      } catch (err) {
	        _didIteratorError35 = true;
	        _iteratorError35 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion35 && _iterator35.return) {
	            _iterator35.return();
	          }
	        } finally {
	          if (_didIteratorError35) {
	            throw _iteratorError35;
	          }
	        }
	      }
	
	      this.crumbs.push(crumb);
	      var crumbs = [];
	      var _iteratorNormalCompletion36 = true;
	      var _didIteratorError36 = false;
	      var _iteratorError36 = undefined;
	
	      try {
	        for (var _iterator36 = (0, _getIterator3.default)(this.crumbs), _step36; !(_iteratorNormalCompletion36 = (_step36 = _iterator36.next()).done); _iteratorNormalCompletion36 = true) {
	          var c = _step36.value;
	
	          crumbs.push((0, _assign2.default)({}, c, { 'child': [] }));
	        }
	      } catch (err) {
	        _didIteratorError36 = true;
	        _iteratorError36 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion36 && _iterator36.return) {
	            _iterator36.return();
	          }
	        } finally {
	          if (_didIteratorError36) {
	            throw _iteratorError36;
	          }
	        }
	      }
	
	      this.crumbs = crumbs;
	      var i = 0;
	      var len = this.crumbs.length;
	      var _iteratorNormalCompletion37 = true;
	      var _didIteratorError37 = false;
	      var _iteratorError37 = undefined;
	
	      try {
	        for (var _iterator37 = (0, _getIterator3.default)(this.crumbs), _step37; !(_iteratorNormalCompletion37 = (_step37 = _iterator37.next()).done); _iteratorNormalCompletion37 = true) {
	          var _c3 = _step37.value;
	
	          if (_c3.uniq === 1) {
	            this.uniqMap[_c3.code] = 1;
	          }
	          if (i + 1 < len) {
	            this.crumbs[i + 1].parent = _c3;
	            _c3.child.push(this.crumbs[i + 1]);
	          }
	          i++;
	        }
	      } catch (err) {
	        _didIteratorError37 = true;
	        _iteratorError37 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion37 && _iterator37.return) {
	            _iterator37.return();
	          }
	        } finally {
	          if (_didIteratorError37) {
	            throw _iteratorError37;
	          }
	        }
	      }
	
	      if (!this.curcond) {
	        this.condition.push(this.crumbs[0]);
	      } else {
	        this.crumbs[0].parent = this.curcond.parent;
	        this.curcond.parent.child.push(this.crumbs[0]);
	      }
	      this.showCondition = false;
	    },
	    addCondition: function addCondition(type, obj) {
	      if (type === 'gglx' && this.gglxList[obj.code]) {
	        var _iteratorNormalCompletion38 = true;
	        var _didIteratorError38 = false;
	        var _iteratorError38 = undefined;
	
	        try {
	          for (var _iterator38 = (0, _getIterator3.default)(this.condition), _step38; !(_iteratorNormalCompletion38 = (_step38 = _iterator38.next()).done); _iteratorNormalCompletion38 = true) {
	            var item = _step38.value;
	            var _iteratorNormalCompletion39 = true;
	            var _didIteratorError39 = false;
	            var _iteratorError39 = undefined;
	
	            try {
	              for (var _iterator39 = (0, _getIterator3.default)(item.child), _step39; !(_iteratorNormalCompletion39 = (_step39 = _iterator39.next()).done); _iteratorNormalCompletion39 = true) {
	                var i = _step39.value;
	
	                for (var j in i.value) {
	                  if (i.value[j].code === obj.code) {
	                    i.value.splice(j, 1);
	                    if (i.value.length === 0) {
	                      var _idx = i.parent.child.indexOf(i);
	                      this.delChild(i.parent.child, _idx);
	                    }
	                    break;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError39 = true;
	              _iteratorError39 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion39 && _iterator39.return) {
	                  _iterator39.return();
	                }
	              } finally {
	                if (_didIteratorError39) {
	                  throw _iteratorError39;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError38 = true;
	          _iteratorError38 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion38 && _iterator38.return) {
	              _iterator38.return();
	            }
	          } finally {
	            if (_didIteratorError38) {
	              throw _iteratorError38;
	            }
	          }
	        }
	
	        return false;
	      }
	      if (type === 'ggbq' && this.ggbqList[obj.code]) {
	        var _iteratorNormalCompletion40 = true;
	        var _didIteratorError40 = false;
	        var _iteratorError40 = undefined;
	
	        try {
	          for (var _iterator40 = (0, _getIterator3.default)(this.condition), _step40; !(_iteratorNormalCompletion40 = (_step40 = _iterator40.next()).done); _iteratorNormalCompletion40 = true) {
	            var _item2 = _step40.value;
	            var _iteratorNormalCompletion41 = true;
	            var _didIteratorError41 = false;
	            var _iteratorError41 = undefined;
	
	            try {
	              for (var _iterator41 = (0, _getIterator3.default)(_item2.child), _step41; !(_iteratorNormalCompletion41 = (_step41 = _iterator41.next()).done); _iteratorNormalCompletion41 = true) {
	                var _i5 = _step41.value;
	
	                for (var _j in _i5.value) {
	                  if (_i5.value[_j].code === obj.code) {
	                    _i5.value.splice(_j, 1);
	                    if (_i5.value.length === 0) {
	                      var _idx2 = _i5.parent.child.indexOf(_i5);
	                      this.delChild(_i5.parent.child, _idx2);
	                    }
	                    break;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError41 = true;
	              _iteratorError41 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion41 && _iterator41.return) {
	                  _iterator41.return();
	                }
	              } finally {
	                if (_didIteratorError41) {
	                  throw _iteratorError41;
	                }
	              }
	            }
	          }
	        } catch (err) {
	          _didIteratorError40 = true;
	          _iteratorError40 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion40 && _iterator40.return) {
	              _iterator40.return();
	            }
	          } finally {
	            if (_didIteratorError40) {
	              throw _iteratorError40;
	            }
	          }
	        }
	
	        return false;
	      }
	      var idx = 0;
	      var _iteratorNormalCompletion42 = true;
	      var _didIteratorError42 = false;
	      var _iteratorError42 = undefined;
	
	      try {
	        for (var _iterator42 = (0, _getIterator3.default)(this.condition), _step42; !(_iteratorNormalCompletion42 = (_step42 = _iterator42.next()).done); _iteratorNormalCompletion42 = true) {
	          var d = _step42.value;
	
	          if (d.code === type) {
	            this.condition.splice(idx, 1);
	            break;
	          }
	          idx++;
	        }
	      } catch (err) {
	        _didIteratorError42 = true;
	        _iteratorError42 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion42 && _iterator42.return) {
	            _iterator42.return();
	          }
	        } finally {
	          if (_didIteratorError42) {
	            throw _iteratorError42;
	          }
	        }
	      }
	
	      console.log(obj);
	      console.log(this.condition);
	      this.initCond();
	      this.selectCond(this.metaMap[type]);
	      this.selectThirdCond(this.metaMap[obj.code]);
	      this.confirmThirdCond();
	      if (this.searched) {
	        this.go();
	      }
	    },
	    delChild: function delChild(arr, idx) {
	      if (idx < 0) {
	        idx = 0;
	      }
	      var code = arr[idx].code;
	      if (this.uniqMap.hasOwnProperty(code)) {
	        delete this.uniqMap[code];
	      }
	      arr.splice(idx, 1);
	    },
	    backCond: function backCond() {
	      if (this.crumbs.length > 1) {
	        this.crumbs.splice(-1, 1);
	        if (this.crumbs.length > 1) {
	          this.lvl1 = this.crumbs.slice(-2)[0].ref;
	          this.lvl2 = this.crumbs.slice(-1)[0].ref;
	        } else {
	          this.lvl2 = this.lvl1;
	          this.lvl1 = this.crumbs.slice(-1)[0].ref;
	        }
	      }
	    },
	    showOp: function showOp(event) {
	      var el = (0, _jquery2.default)(event.target);
	      el.next().show();
	    },
	    selOp: function selOp(event, val) {
	      var el = (0, _jquery2.default)(event.target);
	      this.op = val;
	      el.parent().parent().parent().hide();
	    },
	    selStype: function selStype(event, val) {
	      var el = (0, _jquery2.default)(event.target);
	      this.stype = val;
	      var len = this.condition.length;
	      for (var i = 0; i < len; i++) {
	        var d = this.condition[i];
	        if (d.stype && d.stype !== this.stype) {
	          this.condition.splice(i, 1);
	        }
	      }
	      el.parent().parent().parent().hide();
	    },
	    itemChecked: function itemChecked(idx) {
	      var checked = !this.items[idx].checked;
	      this.items[idx].checked = checked;
	      if (checked) {
	        this.checkedCount++;
	      } else {
	        this.checkedCount--;
	      }
	    },
	    itemCheckAll: function itemCheckAll() {
	      var checked = !this.checkedAll;
	      var _iteratorNormalCompletion43 = true;
	      var _didIteratorError43 = false;
	      var _iteratorError43 = undefined;
	
	      try {
	        for (var _iterator43 = (0, _getIterator3.default)(this.items), _step43; !(_iteratorNormalCompletion43 = (_step43 = _iterator43.next()).done); _iteratorNormalCompletion43 = true) {
	          var item = _step43.value;
	
	          item.checked = checked;
	        }
	      } catch (err) {
	        _didIteratorError43 = true;
	        _iteratorError43 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion43 && _iterator43.return) {
	            _iterator43.return();
	          }
	        } finally {
	          if (_didIteratorError43) {
	            throw _iteratorError43;
	          }
	        }
	      }
	
	      this.checkedAll = checked;
	      if (checked) {
	        this.checkedCount = this.items.length;
	      } else {
	        this.checkedCount = 0;
	      }
	    },
	    clearChecked: function clearChecked() {
	      this.checkedAll = true;
	      this.itemCheckAll();
	    },
	    go: function go(page) {
	      this.page = page || 1;
	      this.clearChecked();
	      this.search();
	    },
	    clear: function clear() {
	      this.condition = [];
	      this.crumbs = [];
	      this.uniqMap = {};
	    },
	    analyze: function analyze() {
	      var _this6 = this;
	
	      var query = this.genQuery();
	      var reqUrl = '';
	      if (this.stype === 2) {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advanalyzen3b');
	      } else {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advanalyze');
	      }
	      _jquery2.default.ajax({
	        url: reqUrl,
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this6.company = response.agg.company;
	          _this6.related_company = response.agg.related_company;
	          _this6.related_name = response.agg.related_name;
	          if (response.agg.type) {
	            _this6.aggTypes = [];
	            var _iteratorNormalCompletion44 = true;
	            var _didIteratorError44 = false;
	            var _iteratorError44 = undefined;
	
	            try {
	              for (var _iterator44 = (0, _getIterator3.default)(response.agg.type), _step44; !(_iteratorNormalCompletion44 = (_step44 = _iterator44.next()).done); _iteratorNormalCompletion44 = true) {
	                var agg = _step44.value;
	
	                _this6.aggTypes.push({ 'code': agg.key, 'name': agg.key, 'count': agg.doc_count });
	              }
	            } catch (err) {
	              _didIteratorError44 = true;
	              _iteratorError44 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion44 && _iterator44.return) {
	                  _iterator44.return();
	                }
	              } finally {
	                if (_didIteratorError44) {
	                  throw _iteratorError44;
	                }
	              }
	            }
	          }
	          if (response.agg.labels) {
	            _this6.aggLabels = [];
	            var _iteratorNormalCompletion45 = true;
	            var _didIteratorError45 = false;
	            var _iteratorError45 = undefined;
	
	            try {
	              for (var _iterator45 = (0, _getIterator3.default)(response.agg.labels), _step45; !(_iteratorNormalCompletion45 = (_step45 = _iterator45.next()).done); _iteratorNormalCompletion45 = true) {
	                var _agg = _step45.value;
	
	                _this6.aggLabels.push({ 'code': _agg.key, 'name': _agg.key, 'count': _agg.doc_count });
	              }
	            } catch (err) {
	              _didIteratorError45 = true;
	              _iteratorError45 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion45 && _iterator45.return) {
	                  _iterator45.return();
	                }
	              } finally {
	                if (_didIteratorError45) {
	                  throw _iteratorError45;
	                }
	              }
	            }
	          }
	        } else if (response.status === 502) {
	          console.log('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        console.log('请求失败');
	      });
	    },
	    getList: function getList() {
	      this.gglxList = {};
	      this.ggbqList = {};
	      var _iteratorNormalCompletion46 = true;
	      var _didIteratorError46 = false;
	      var _iteratorError46 = undefined;
	
	      try {
	        for (var _iterator46 = (0, _getIterator3.default)(this.condition), _step46; !(_iteratorNormalCompletion46 = (_step46 = _iterator46.next()).done); _iteratorNormalCompletion46 = true) {
	          var item = _step46.value;
	
	          if (item.code && item.code === 'gglx') {
	            var _iteratorNormalCompletion47 = true;
	            var _didIteratorError47 = false;
	            var _iteratorError47 = undefined;
	
	            try {
	              for (var _iterator47 = (0, _getIterator3.default)(item.child), _step47; !(_iteratorNormalCompletion47 = (_step47 = _iterator47.next()).done); _iteratorNormalCompletion47 = true) {
	                var i = _step47.value;
	                var _iteratorNormalCompletion48 = true;
	                var _didIteratorError48 = false;
	                var _iteratorError48 = undefined;
	
	                try {
	                  for (var _iterator48 = (0, _getIterator3.default)(i.value), _step48; !(_iteratorNormalCompletion48 = (_step48 = _iterator48.next()).done); _iteratorNormalCompletion48 = true) {
	                    var j = _step48.value;
	
	                    var tmp = {};
	                    tmp[j.code] = j.name;
	                    this.gglxList = (0, _assign2.default)({}, this.gglxList, tmp);
	                  }
	                } catch (err) {
	                  _didIteratorError48 = true;
	                  _iteratorError48 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion48 && _iterator48.return) {
	                      _iterator48.return();
	                    }
	                  } finally {
	                    if (_didIteratorError48) {
	                      throw _iteratorError48;
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError47 = true;
	              _iteratorError47 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion47 && _iterator47.return) {
	                  _iterator47.return();
	                }
	              } finally {
	                if (_didIteratorError47) {
	                  throw _iteratorError47;
	                }
	              }
	            }
	          }
	          if (item.code && item.code === 'ggbq') {
	            var _iteratorNormalCompletion49 = true;
	            var _didIteratorError49 = false;
	            var _iteratorError49 = undefined;
	
	            try {
	              for (var _iterator49 = (0, _getIterator3.default)(item.child), _step49; !(_iteratorNormalCompletion49 = (_step49 = _iterator49.next()).done); _iteratorNormalCompletion49 = true) {
	                var _i6 = _step49.value;
	                var _iteratorNormalCompletion50 = true;
	                var _didIteratorError50 = false;
	                var _iteratorError50 = undefined;
	
	                try {
	                  for (var _iterator50 = (0, _getIterator3.default)(_i6.value), _step50; !(_iteratorNormalCompletion50 = (_step50 = _iterator50.next()).done); _iteratorNormalCompletion50 = true) {
	                    var _j2 = _step50.value;
	
	                    var _tmp = {};
	                    _tmp[_j2.code] = _j2.name;
	                    this.ggbqList = (0, _assign2.default)({}, this.ggbqList, _tmp);
	                  }
	                } catch (err) {
	                  _didIteratorError50 = true;
	                  _iteratorError50 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion50 && _iterator50.return) {
	                      _iterator50.return();
	                    }
	                  } finally {
	                    if (_didIteratorError50) {
	                      throw _iteratorError50;
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError49 = true;
	              _iteratorError49 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion49 && _iterator49.return) {
	                  _iterator49.return();
	                }
	              } finally {
	                if (_didIteratorError49) {
	                  throw _iteratorError49;
	                }
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError46 = true;
	        _iteratorError46 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion46 && _iterator46.return) {
	            _iterator46.return();
	          }
	        } finally {
	          if (_didIteratorError46) {
	            throw _iteratorError46;
	          }
	        }
	      }
	    },
	    genQuery: function genQuery() {
	      var query = {};
	      this.querycond = [];
	      this.genCondition(this.querycond, this.condition);
	      query['typ'] = this.tab1;
	      query['condition'] = this.querycond;
	      query['stype'] = this.stype;
	      if (this.tab1 === 1) {
	        query['perPage'] = this.perPage;
	        query['page'] = this.page;
	      }
	      if (this.tab1 === 2) {
	        query['perPage'] = this.cperPage;
	        query['page'] = this.cpage;
	      }
	      query['sort'] = this.sort;
	      if (this.ai === 1) {
	        query['ai'] = this.ai;
	      }
	      return query;
	    },
	    genCondition: function genCondition(querycond, cond) {
	      var _iteratorNormalCompletion51 = true;
	      var _didIteratorError51 = false;
	      var _iteratorError51 = undefined;
	
	      try {
	        for (var _iterator51 = (0, _getIterator3.default)(cond), _step51; !(_iteratorNormalCompletion51 = (_step51 = _iterator51.next()).done); _iteratorNormalCompletion51 = true) {
	          var d = _step51.value;
	
	          var newcond = { 'name': d.name, 'code': d.code, 'type': d.type, 'op': d.op };
	          if (d.hasOwnProperty('range')) {
	            newcond['range'] = d.range;
	          }
	          if (d.hasOwnProperty('value')) {
	            newcond['value'] = d.value;
	          }
	          if (d.hasOwnProperty('value1')) {
	            newcond['value1'] = d.value1;
	          }
	          if (d.hasOwnProperty('year')) {
	            newcond['year'] = d.year;
	          }
	          if (d.hasOwnProperty('quarter')) {
	            newcond['quarter'] = d.quarter;
	          }
	          if (d.hasOwnProperty('multi')) {
	            newcond['multi'] = d.multi;
	          }
	          newcond['child'] = [];
	          if (d.child.length > 0) {
	            this.genCondition(newcond.child, d.child);
	          }
	          querycond.push(newcond);
	        }
	      } catch (err) {
	        _didIteratorError51 = true;
	        _iteratorError51 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion51 && _iterator51.return) {
	            _iterator51.return();
	          }
	        } finally {
	          if (_didIteratorError51) {
	            throw _iteratorError51;
	          }
	        }
	      }
	    },
	    gettags: function gettags() {
	      var _this7 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/taglist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'scope': 2 })
	      }).done(function (response) {
	        if (response.status === 0) {
	          var tags = response.data;
	          var _iteratorNormalCompletion52 = true;
	          var _didIteratorError52 = false;
	          var _iteratorError52 = undefined;
	
	          try {
	            for (var _iterator52 = (0, _getIterator3.default)(tags), _step52; !(_iteratorNormalCompletion52 = (_step52 = _iterator52.next()).done); _iteratorNormalCompletion52 = true) {
	              var d = _step52.value;
	
	              d.showDel = false;
	            }
	          } catch (err) {
	            _didIteratorError52 = true;
	            _iteratorError52 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion52 && _iterator52.return) {
	                _iterator52.return();
	              }
	            } finally {
	              if (_didIteratorError52) {
	                throw _iteratorError52;
	              }
	            }
	          }
	
	          _this7.tags = tags;
	          _this7.tags1 = [];
	          _this7.tags2 = [];
	          _this7.tags3 = [];
	          var _iteratorNormalCompletion53 = true;
	          var _didIteratorError53 = false;
	          var _iteratorError53 = undefined;
	
	          try {
	            for (var _iterator53 = (0, _getIterator3.default)(_this7.tags), _step53; !(_iteratorNormalCompletion53 = (_step53 = _iterator53.next()).done); _iteratorNormalCompletion53 = true) {
	              var _d6 = _step53.value;
	
	              if (_d6.cat === 1) {
	                _this7.tags1.push(_d6);
	              }
	              if (_d6.cat === 2) {
	                _this7.tags2.push(_d6);
	              }
	              if (_d6.cat === 3) {
	                _this7.tags3.push(_d6);
	              }
	            }
	          } catch (err) {
	            _didIteratorError53 = true;
	            _iteratorError53 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion53 && _iterator53.return) {
	                _iterator53.return();
	              }
	            } finally {
	              if (_didIteratorError53) {
	                throw _iteratorError53;
	              }
	            }
	          }
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    saveTag: function saveTag() {
	      var _this8 = this;
	
	      var data = (0, _stringify2.default)(this.genQuery());
	      var query = { 'name': this.tagname, 'data': data, 'typ': this.stype, 'cat': this.tab1, 'scope': 2 };
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/savetag'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this8.loading = false;
	        if (response.status === 0) {
	          (0, _helper.alert)('保存成功');
	          _this8.showModalTag = false;
	          _this8.tagname = '';
	          _this8.gettags();
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    searchByTag: function searchByTag(tagid) {
	      var _this9 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/gettag'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'id': tagid })
	      }).done(function (response) {
	        if (response.status === 0) {
	          console.log('2333');
	          _this9.showTag = false;
	          var condition = response.data;
	          _this9.tab1 = condition.typ;
	          _this9.stype = condition.stype;
	          _this9.sort = condition.sort;
	          if (_this9.tab1 === 1) {
	            _this9.page = condition.page;
	            _this9.perPage = condition.perPage;
	          }
	          if (_this9.tab1 === 2) {
	            _this9.companyitems = [];
	            _this9.cpage = condition.page;
	            _this9.cperPage = condition.perPage;
	          }
	
	          _this9.common(condition);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    delTag: function delTag(tagid) {
	      var that = this;
	      (0, _helper.confirm)('确定删除此标签?', function () {
	        _jquery2.default.ajax({
	          url: (0, _helper.apiUrl)('/V1.0.0/user/deltag'),
	          method: 'post',
	          dataType: 'json',
	          data: (0, _stringify2.default)({ 'id': tagid })
	        }).done(function (response) {
	          if (response.status === 0) {
	            that.gettags();
	          }
	        }).fail(function (response) {
	          (0, _helper.alert)('请求失败');
	        });
	      });
	    },
	    indentChild: function indentChild(code) {
	      var len = code.split('.').length - 2;
	      return { 'padding-left': len * 10 + 'px' };
	    },
	    hideDropDown: function hideDropDown(event) {
	      if (event.target.className !== 'fz1') {
	        (0, _jquery2.default)('.fz2').hide();
	      }
	      return false;
	    },
	    batchDownload: function batchDownload() {
	      var _this10 = this;
	
	      this.advdownloading = true;
	      var query = { 'paths': [] };
	      var _iteratorNormalCompletion54 = true;
	      var _didIteratorError54 = false;
	      var _iteratorError54 = undefined;
	
	      try {
	        for (var _iterator54 = (0, _getIterator3.default)(this.items), _step54; !(_iteratorNormalCompletion54 = (_step54 = _iterator54.next()).done); _iteratorNormalCompletion54 = true) {
	          var item = _step54.value;
	
	          if (item.checked) {
	            query['paths'].push({ 'filename': item.filename, 'title': item.title });
	          }
	        }
	      } catch (err) {
	        _didIteratorError54 = true;
	        _iteratorError54 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion54 && _iterator54.return) {
	            _iterator54.return();
	          }
	        } finally {
	          if (_didIteratorError54) {
	            throw _iteratorError54;
	          }
	        }
	      }
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/file/batch'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this10.advdownloading = false;
	        if (response.status === 0) {
	          var zipfile = response.zipfile;
	          downloadURL('http://114.215.71.108:9010/' + zipfile);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this10.advdownloading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    searchSample: function searchSample(id) {
	      var idx = id - 1;
	      var condition = this.samples[idx];
	      this.tab1 = condition.typ;
	      this.stype = condition.stype;
	      this.sort = condition.sort;
	      if (this.tab1 === 1) {
	        this.page = condition.page;
	        this.perPage = condition.perPage;
	      }
	      if (this.tab1 === 2) {
	        this.cpage = condition.page;
	        this.cperPage = condition.perPage;
	      }
	      this.getCrumbs(condition.condition);
	      this.search();
	    },
	    addChildCond: function addChildCond(cond) {
	      this.curcond = cond;
	      this.showCondition = true;
	      this.lvl1 = [];
	      this.lvl2 = [];
	      this.lvl3 = [];
	      this.crumbs = [];
	      var i = 0;
	      var lvl2 = [];
	      var pcode = cond.parent.code;
	      if (this.metaMap.hasOwnProperty(pcode)) {
	        lvl2 = this.metaMap[pcode].child;
	        var _iteratorNormalCompletion55 = true;
	        var _didIteratorError55 = false;
	        var _iteratorError55 = undefined;
	
	        try {
	          for (var _iterator55 = (0, _getIterator3.default)(lvl2), _step55; !(_iteratorNormalCompletion55 = (_step55 = _iterator55.next()).done); _iteratorNormalCompletion55 = true) {
	            var d = _step55.value;
	
	            if (d.hasOwnProperty('stype')) {
	              if (d.stype !== this.stype) {
	                continue;
	              }
	            }
	            if (d.uniq === 1) {
	              if (this.uniqMap.hasOwnProperty(d.code)) {
	                continue;
	              }
	            }
	            var t = {};
	            (0, _assign2.default)(t, d, { 'selected': false });
	            this.lvl2.push(t);
	            i++;
	          }
	        } catch (err) {
	          _didIteratorError55 = true;
	          _iteratorError55 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion55 && _iterator55.return) {
	              _iterator55.return();
	            }
	          } finally {
	            if (_didIteratorError55) {
	              throw _iteratorError55;
	            }
	          }
	        }
	      }
	    },
	    downloadUrl: function downloadUrl(item) {
	      return 'http://114.215.71.108:9005/file/download?path=' + item.filename + '&title=' + item.title;
	    },
	
	    goview: function goview(item) {
	      var url = this.viewUrl(item);
	      if (document.cookie.indexOf('embed=1') < 0) {
	        window.open(url);
	      } else {
	        if (this.stype === 2) {
	          window.location.href = url;
	        } else {
	          window.open(url);
	        }
	      }
	    },
	    fileIcon: function fileIcon(fileext) {
	      if (fileext === 'pdf') {
	        return 'pdf-icon';
	      }
	      if (fileext === 'docx' || fileext === 'doc') {
	        return 'dov-icon';
	      }
	      if (fileext === 'html' || fileext === 'htm' || fileext === 'shtml') {
	        return 'html-icon';
	      }
	      if (fileext === 'xls' || fileext === 'xlsx') {
	        return 'xsl-icon';
	      }
	    },
	    exportFile: function exportFile() {
	      var _this11 = this;
	
	      var query = this.genQuery();
	      query.export = 1;
	      var reqUrl = '';
	      if (this.stype === 2) {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearchn3b');
	      } else {
	        reqUrl = (0, _helper.apiUrl)('/V1.0.0/notice/advsearch');
	      }
	      _jquery2.default.ajax({
	        url: reqUrl,
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          var exportfilepath = response.url;
	
	          _this11.downloadEFile(exportfilepath);
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this11.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    downloadEFile: function downloadEFile(url, name) {
	      var link = document.createElement("a");
	      link.download = name;
	      link.href = url;
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    },
	
	    viewUrl: function viewUrl(item, params) {
	      console.log(params);
	      if (item.viewtype === 1) {
	        var tcode = '';
	        if (item.pid) {
	          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid;
	        } else {
	          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid;
	        }
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    qaViewUrl: function qaViewUrl(item, params) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        return '/#!/qaview/' + item.id + '?stype=' + this.stype + '&tcode=' + tcode + '&pdate=' + item.publishDate + '&idxname=' + this.idxname + '&uid=' + this.params.uidUrl + '&share=' + params.share + '&plat=' + params.plat + '&sid=' + params.sid + '&ruid=' + this.params.ruid;
	      }
	      if (item.viewtype === 2) {
	        return item.viewurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    },
	    isEmpty: function isEmpty(obj) {
	      for (var i in obj) {
	        if (obj[i].length !== 0) {
	          console.log('false');
	          return false;
	        }
	      }
	      console.log('true');
	      return true;
	    }
	  },
	  computed: {
	    totalPage: function totalPage() {
	      if (this.tab1 === 1) {
	        var totalPage = Math.ceil(this.total / this.perPage);
	        return totalPage > 20 ? 20 : totalPage;
	      }
	      if (this.tab1 === 2) {
	        var _totalPage = Math.ceil(this.ctotal1 / this.cperPage);
	        return _totalPage;
	      }
	    },
	    indexs: function indexs() {
	      var page = this.page;
	      if (this.tab1 === 2) {
	        page = this.cpage;
	      }
	      var left = 1;
	      var right = this.totalPage;
	      var ar = [];
	      if (this.totalPage >= 11) {
	        if (page > 5 && page < this.totalPage - 4) {
	          left = page - 5;
	          right = page + 4;
	        } else {
	          if (page <= 5) {
	            left = 1;
	            right = 10;
	          } else {
	            right = this.totalPage;
	            left = page - 9;
	          }
	        }
	      }
	      while (left <= right) {
	        ar.push(left);
	        left++;
	      }
	      return ar;
	    }
	  },
	  watch: {
	    'condition': {
	      handler: function handler(val, oldVal) {
	        this.getList();
	      },
	      deep: true
	    }
	  },
	  filters: {
	    'opname': function opname(val) {
	      if (val === 1) {
	        return '含所有';
	      }
	      if (val === 2) {
	        return '含任意';
	      }
	      if (val === 3) {
	        return '不含';
	      }
	      return '包含全部';
	    },
	    'stypename': function stypename(val) {
	      if (val === 1) {
	        return 'A股';
	      }
	      if (val === 2) {
	        return '新三板';
	      }
	      if (val === 3) {
	        return '债券';
	      }
	      return 'A股';
	    },
	    'sortname': function sortname(val) {
	      if (val === 1) {
	        return '按相关性排序';
	      }
	      if (val === 2) {
	        return '按时间排序';
	      }
	      return '按相关性排序';
	    },
	    formatTypeName: function formatTypeName(param) {
	      if (param === 1) {
	        return 'A股';
	      }
	      if (param === 2) {
	        return '新三板';
	      }
	      if (param === 3) {
	        return '债券';
	      }
	      if (param === 5) {
	        return '问题库';
	      }
	      if (param === 6) {
	        return '港股';
	      }
	    },
	    formatKeywords: function formatKeywords(param) {
	      if (param.length > 10) {
	        return param.replace(/(^\s*)|(\s*$)/g, '').substr(0, 10) + '...';
	      } else {
	        return param;
	      }
	    },
	    formatSSFW: function formatSSFW(param) {
	      if (param === 1) {
	        return '含所有';
	      }
	      if (param === 3) {
	        return '不含';
	      }
	      if (param === 2) {
	        return '含任意';
	      }
	    },
	    formatCompanyBaseInfo: function formatCompanyBaseInfo(param) {
	      if (param.name === '注册资本') {
	        if (param.range === 1) {
	          return '小于';
	        }
	        if (param.range === 2) {
	          return '大于';
	        }
	        if (param.range === 3) {
	          return '在之间';
	        }
	      } else if (param.name === '成立日期') {
	        if (param.op === 1) {
	          return '早于';
	        }
	        if (param.op === 2) {
	          return '晚于';
	        }
	        if (param.op === 3) {
	          return '在期间';
	        }
	      } else if (param.name === '地区' || param.name === '行业类型') {
	        if (param.child[0].op === 1) {
	          return '含所有';
	        }
	        if (param.child[0].op === 2) {
	          return '含任意';
	        }
	        if (param.child[0].op === 3) {
	          return '不含';
	        }
	      } else {
	        if (param.op === 1) {
	          return '含所有';
	        }
	        if (param.op === 2) {
	          return '含任意';
	        }
	        if (param.op === 3) {
	          return '不含';
	        }
	      }
	    },
	    formatRangeToName: function formatRangeToName(param) {
	      if (param === 1) {
	        return '小于';
	      }
	      if (param === 2) {
	        return '大于';
	      }
	      if (param === 3) {
	        return '在之间';
	      }
	    },
	    formatNumber: function formatNumber(z) {
	      if (!z) {
	        return z;
	      } else {
	        var num = z.toString();
	        var normdata = '';
	        if (num.indexOf('.') !== -1) {
	          normdata = num.replace(/(\d)(?=(\d{3})+\.)/g, function ($0, $1) {
	            return $1 + ",";
	          });
	        } else {
	          normdata = num.replace(/(\d)(?=(\d{3})+\b)/g, function ($0, $1) {
	            return $1 + ",";
	          });
	        }
	        if (normdata.indexOf('.') >= 0) {
	          var arr = normdata.split('.');
	          if (arr[1].length < 2) {
	            return normdata + '0';
	          } else {
	            return normdata.substr(0, normdata.indexOf('.') + 3);
	          }
	        } else {
	          return normdata;
	        }
	      }
	    },
	    formatTab1: function formatTab1(param) {
	      if (param === 1) {
	        return '公告';
	      }
	      if (param === 2) {
	        return '公司';
	      }
	    }
	  }
	};

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'LimitView',
	  mixins: [_userMix2.default],
	  data: function data() {
	    return {
	      nopermission: false,
	      countMax: false
	    };
	  },
	  ready: function ready() {
	    this.$nextTick(function () {
	      var innerHeight = window.innerHeight + 'px';
	      $('.wrapper').css({ 'min-height': innerHeight });
	      $('.knowledge-list').css({ 'min-height': innerHeight });
	      console.log($('.wrapper'));
	      console.log(innerHeight);
	    });
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      this.nopermission = false;
	      this.countMax = false;
	
	      if (to.query.typ === '1') {
	        this.nopermission = true;
	      }
	      if (to.query.typ === '2') {
	        this.countMax = true;
	      }
	    }
	  }
	};

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _searchResMix = __webpack_require__(84);
	
	var _searchResMix2 = _interopRequireDefault(_searchResMix);
	
	var _BigImg = __webpack_require__(105);
	
	var _BigImg2 = _interopRequireDefault(_BigImg);
	
	var _resultFrag = __webpack_require__(344);
	
	var _resultFrag2 = _interopRequireDefault(_resultFrag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'ResultView',
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default, _commentMix2.default, _comSearchMix2.default, _searchResMix2.default],
	  components: {
	    'bigimg': _BigImg2.default,
	    'resfrag': _resultFrag2.default
	  },
	  data: function data() {
	    return {
	      params: {},
	      bigImgObj: { 'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': '' },
	      bottomTip: false,
	      stypesArr: [],
	      reportTotalPage: null
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      this.reportDataList = [];
	      console.log(to.query.stype);
	      console.log(to.query.uid);
	      console.log('Result2组件');
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        console.log('进入！this.currentuser');
	        console.log(this.wxcode);
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          console.log('进入getProfile');
	          console.log(to.query.share);
	          this.getProfile(to.query);
	        }
	      }
	
	      if (this.currentuser) {
	        console.log('进入this.currentuser');
	        console.log(this.currentuser);
	        console.log(to.query);
	        this.params.uidUrl = to.query.uid;
	        this.params.share = to.query.share;
	        this.params.plat = to.query.plat;
	        this.params.ts = to.query.ts;
	
	        var descs = window.location.href.split('&');
	        console.log(descs);
	        for (var i = 0, len = descs.length; i < len; i++) {
	          var str = descs[i];
	          if (str.indexOf('desc=') == 0) {
	            this.params.desc = decodeURIComponent(str.split('=')[1]);
	            break;
	          }
	        }
	        console.log(to.query);
	        this.params.sid = to.query.sid;
	        this.params.ruid = to.query.ruid;
	        this.diysharedesc = to.query.desc;
	        this.stype = to.query.stype;
	        if (this.checkAction('search/ai')) {
	          if (to.query.ai == '1') {
	            this.ai = 1;
	          }
	        } else {
	          this.ai = 0;
	        }
	
	        this.clearSearch();
	        this.datetype = 9;
	        this.changeStype(parseInt(to.query['stype']));
	        console.log('stype end');
	        var query = this.parseUrlQuery(to.query);
	        this.$data = (0, _assign2.default)({}, this.$data, query);
	        this.addToShow();
	        if (!this.isEmptyObj(this.conditions['industrysecond'])) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(this.industry), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var d = _step.value;
	
	              this.setNum('industrysecond', d);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        }
	        if (!this.isEmptyObj(this.conditions['layer'])) {
	          this.setNum('plate', this.plates[0]);
	        }
	
	        console.log('>>>>>>>>>>>>>>> search()');
	        this.search();
	
	        this.commentList = [];
	        this.commentinput = false;
	        this.showComments = false;
	        this.getCommentcount(2, this.params.sid);
	
	        jQuery(window).unbind();
	        (0, _jquery2.default)(window).unbind();
	        var that = this;
	
	        if (this.stype != 100) {
	          (0, _jquery2.default)(window).scroll(function () {
	            if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height() && that.showComments) {
	              var page = that.cpwpage + 1;
	              if (page <= Math.ceil(that.cpwtotal / 10)) {
	                that.getCommentList(page, 2, that.params.sid);
	              }
	            }
	            var dom = document.documentElement;
	            var scrollTop = (0, _jquery2.default)(this).scrollTop();
	            var scrollHeight = (0, _jquery2.default)(document).height();
	            var windowHeight = (0, _jquery2.default)(this).height();
	
	            if (scrollTop === 0) {
	              var top_page = parseInt(that.topPage) - 1;
	
	              if (that.topPage > 1) {
	                that.page = that.topPage;
	                that.topPage--;
	                if (that.stype == 13) {
	                  console.log('g㢃大大大萨达撒多撒多');
	                  that.reportPage2(that.bottompage);
	                  var newReportData = that.reportDataList.concat(that.newItems);
	                  that.reportDataList = newReportData;
	                } else {
	                  that.paging2(that.topPage);
	                  var newDetailLists = that.newItems.concat(that.detailLists);
	                  that.detailLists = newDetailLists;
	                }
	
	                that.$nextTick(function () {
	                  var resultList10 = (0, _jquery2.default)('.search-result-list')[4];
	                  var offsetTop = resultList10.offsetTop;
	                  var offsetHeight = resultList10.offsetHeight;
	                  var newOffsetTop = offsetTop + offsetHeight;
	                  (0, _jquery2.default)(window).scrollTop(newOffsetTop);
	                });
	              }
	            }
	
	            if (scrollTop + windowHeight >= scrollHeight) {
	              console.log('滚动到底部');
	              var next_page = parseInt(that.bottomPage) + 1;
	              var totals = void 0;
	              if (that.stype == 13) {
	                totals = that.reportTotalPage;
	              } else {
	                totals = that.totalPage;
	              }
	              if (that.bottomPage < totals) {
	                that.page = that.bottomPage;
	                that.bottomPage++;
	                if (that.stype == 13) {
	                  console.log(that.bottomPage);
	                  console.log('xxxxxg㢃大大大萨达撒多撒多');
	                  that.reportPage2(that.bottomPage);
	                  var _newReportData = that.reportDataList.concat(that.newItems);
	                  that.reportDataList = _newReportData;
	                } else {
	                  that.paging2(that.bottomPage);
	                  var _newDetailLists = that.detailLists.concat(that.newItems);
	                  that.detailLists = _newDetailLists;
	                }
	              } else {
	                that.bottomTip = true;
	                setTimeout(function () {
	                  dom.scrollTop = scrollHeight - windowHeight - 40;
	                }, 800);
	              }
	            }
	          });
	        }
	        this.getTagLists();
	
	        this.$nextTick(function () {
	          var that = this;
	          var wxsharedesc = that.getResultShareDesc();
	          var wxsharetitle = that.getResultShareTitle();
	          that.getwxsign();
	
	          that.shareResult(wxsharetitle, wxsharedesc);
	          if (this.params.desc && this.params.desc != '') {
	            document.title = this.params.desc;
	          } else {
	            document.title = 'IBDATA:智能投研第一品牌';
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    setBigImgObj: function setBigImgObj(item, article) {
	      this.bigImgObj.imghead = item.imghead;
	      this.bigImgObj.imgfoot = item.imgfoot;
	      this.bigImgObj.imgurl = item.imgurl;
	      this.bigImgObj.imgid = item.imgid;
	
	      this.bigImgObj.companycode = article.companyCode;
	      this.bigImgObj.companyname = article.companyName;
	      this.bigImgObj.md5 = article.id;
	      this.bigImgObj.publishdate = article.publishDate;
	
	      this.bigImgObj.stype = this.stype;
	      this.bigImgObj.title = article.title;
	
	      this.bigImgObj.show = true;
	    },
	
	    loadcomment: function loadcomment() {
	      if (this.commentList.length == 0) {
	        this.getCommentList(1, 2, this.params.sid);
	      }
	    },
	    go: function go(page) {
	      this.page = page || 1;
	      var query = this.genUrlQuery();
	      query.ruid = this.params.uidUrl;
	      query.uid = this.uid;
	      this.$route.router.go({ path: '/result', query: query });
	    },
	    search: function search() {
	      var _this = this;
	
	      console.log('进入search搜索信息');
	      console.log(this.stype);
	      this.loading = true;
	      var keywords = this.keywords.trim();
	      this.companyCode = this.companyCode.trim();
	      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
	        (0, _helper.alert)('请输入关键词或股票代码');
	        return;
	      }
	
	      this.finance = [];
	      this.yearfinance = [];
	      this.smartEngine.open = false;
	      this.smartEngine.companyInfo = {};
	
	      var query = this.genQuery();
	      query.perPage = 5;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      query.ruid = this.params.ruid;
	      var page = query.page;
	      this.topPage = page;
	      this.bottomPage = page;
	      this.page = page;
	      this.initAnaly();
	      var requrl = '';
	      if (this.stype == 100) {
	        console.log(this.page);
	        console.log(this.loading);
	        this.complex();
	      } else if (this.stype == 13) {
	        this.reportData(this.stype);
	      } else {
	        if (this.stype === 1 || this.stype === 2) {
	          requrl = (0, _helper.apiUrl)('/V1.0.0/notice/searchn3b');
	        } else {
	          console.log('进入search接口信息页面');
	          console.log(this.stype);
	          requrl = (0, _helper.apiUrl)('/V1.0.0/notice/search');
	        }
	        _jquery2.default.ajax({
	          url: requrl,
	          method: 'post',
	          dataType: 'json',
	          data: (0, _stringify2.default)(query)
	        }).done(function (response) {
	          _this.loading = false;
	          _this.analyze();
	          if (response.status === 0) {
	            var items = response.lists;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = (0, _getIterator3.default)(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _item = _step2.value;
	
	                _item.checked = false;
	                if (_item.child) {
	                  var _iteratorNormalCompletion5 = true;
	                  var _didIteratorError5 = false;
	                  var _iteratorError5 = undefined;
	
	                  try {
	                    for (var _iterator5 = (0, _getIterator3.default)(_item.child), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                      var child = _step5.value;
	
	                      child.showque = false;
	                      if (child.answers) {
	                        var _iteratorNormalCompletion6 = true;
	                        var _didIteratorError6 = false;
	                        var _iteratorError6 = undefined;
	
	                        try {
	                          for (var _iterator6 = (0, _getIterator3.default)(child.answers), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                            var ans = _step6.value;
	
	                            ans.showans = false;
	                          }
	                        } catch (err) {
	                          _didIteratorError6 = true;
	                          _iteratorError6 = err;
	                        } finally {
	                          try {
	                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                              _iterator6.return();
	                            }
	                          } finally {
	                            if (_didIteratorError6) {
	                              throw _iteratorError6;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError5 = true;
	                    _iteratorError5 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                      }
	                    } finally {
	                      if (_didIteratorError5) {
	                        throw _iteratorError5;
	                      }
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            _this.items = items;
	            _this.detailLists = items;
	            _this.total = response.total;
	            var totalPage = Math.ceil(_this.total / _this.perPage);
	            _this.totalPage = totalPage;
	            _this.searched = _this.stype;
	            if (response.company) {
	              _this.smartComInfo = response.company[0] || {};
	              if (_this.smartComInfo.finance && _this.smartComInfo.finance.length > 0) {
	                var a = [' '];
	                for (var k in _this.smartComInfo.finance[0]) {
	                  if (k !== 'plate' && k !== 'reportdate' && k !== 'reportdatestr') {
	                    a.push(k);
	                  }
	                }
	                _this.finance.push(a);
	                _this.yearfinance.push(a);
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                  for (var _iterator3 = (0, _getIterator3.default)(_this.smartComInfo.finance), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var item = _step3.value;
	
	                    var arr = [];
	                    if (item.plate === 'A') {
	                      for (var i in item) {
	                        if (i !== 'plate' && i !== 'reportdatestr') {
	                          arr.push(item[i]);
	                        }
	                      }
	                      _this.finance.push(arr);
	                    } else {
	                      for (var _i in item) {
	                        if (_i !== 'plate' && _i !== 'reportdate') {
	                          arr.push(item[_i]);
	                        }
	                      }
	                      _this.finance.push(arr);
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError3 = true;
	                  _iteratorError3 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                      _iterator3.return();
	                    }
	                  } finally {
	                    if (_didIteratorError3) {
	                      throw _iteratorError3;
	                    }
	                  }
	                }
	
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                  for (var _iterator4 = (0, _getIterator3.default)(_this.finance), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _i2 = _step4.value;
	
	                    if (_this.smartComInfo.type === 'A') {
	                      if (_i2[0] && _i2[0].indexOf('-12-') > 0) {
	                        _this.yearfinance.push(_i2);
	                      }
	                    } else {
	                      if (_i2[0] && _i2[0].indexOf('年报') > 0) {
	                        _this.yearfinance.push(_i2);
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError4 = true;
	                  _iteratorError4 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                      _iterator4.return();
	                    }
	                  } finally {
	                    if (_didIteratorError4) {
	                      throw _iteratorError4;
	                    }
	                  }
	                }
	
	                _this.finance.sort(function (a, b) {
	                  return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	                });
	                _this.yearfinance.sort(function (a, b) {
	                  return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	                });
	              } else {
	                _this.finance = [];
	                _this.yearfinance = [];
	              }
	              _this.prices = _this.smartComInfo.price || {};
	              if (_this.prices.trade && _this.prices.settlement) {
	                _this.upanddown = (_this.prices.trade - _this.prices.settlement).toFixed(2);
	                if (_this.upanddown > 0 || _this.upanddown == 0) {
	                  _this.upanddown = '+' + _this.upanddown;
	                }
	                _this.Amplitude = ((_this.prices.trade - _this.prices.settlement) / _this.prices.settlement * 100).toFixed(2);
	                if (_this.Amplitude > 0) {
	                  _this.Amplitude = '+' + _this.Amplitude;
	                }
	              }
	            } else {
	              _this.smartComInfo = {};
	            }
	
	            if (_this.page !== 1) {
	              _this.$nextTick(function () {
	                (0, _jquery2.default)(window).scrollTop(23);
	              });
	            }
	          } else if (response.status === 502) {
	            (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	          }
	        }).fail(function (response) {
	          _this.loading = false;
	          (0, _helper.alert)('请求失败');
	        });
	      }
	    },
	    mySearch: function mySearch() {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	
	      var keywords = this.keywords.trim();
	      this.companyCode = this.companyCode.trim();
	      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !keywords) {
	        (0, _helper.alert)('请输入关键词或股票代码');
	        return;
	      }
	      this.switchPage(2);
	      this.page = 1;
	      var query = this.genUrlQuery();
	      query.ai = this.ai;
	      query.uid = this.params.uidUrl;
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	      query.sid = this.params.sid;
	      console.log(query);
	      this.$route.router.go({ path: '/result', query: query });
	    },
	    slideDropdown2: function slideDropdown2(e) {
	      var el = e.currentTarget;
	      var nextNode = el.nextElementSibling;
	      var elClass = nextNode.getAttribute('class'),
	          class1 = elClass.split(' ')[0],
	          class2 = elClass.split(' ')[1];
	      (0, _jquery2.default)('.date-menu').each(function () {
	        if ((0, _jquery2.default)(this).hasClass('open')) {
	          (0, _jquery2.default)(this).removeClass('open').addClass('close');
	        }
	      });
	
	      if (class2 === 'close') {
	        var _class = class1 + ' ' + 'open';
	        nextNode.setAttribute('class', _class);
	      }
	      if (class2 === 'open') {
	        var _class2 = class1 + ' ' + 'close';
	        nextNode.setAttribute('class', _class2);
	      }
	    },
	    alertDateModal: function alertDateModal() {
	      this.showDateModal = true;
	      this.oldDatetype = this.datatype;
	      this.oldStartdate = this.startdate;
	      this.oldEnddate = this.enddate;
	    },
	    searchMore: function searchMore(stype) {
	      this.loading = true;
	      this.changeStype(stype);
	      this.mySearch();
	    },
	    reportData: function reportData(stype) {
	      var _this2 = this;
	
	      var query = this.genQuery();
	      query.stypes = [stype];
	      query.perPage = 10;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchall'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this2.loading = false;
	        if (response.status == 0) {
	          _this2.reportDataList = response.data[stype].lists;
	          _this2.reportDataTotal = response.data[stype].total;
	          _this2.reportTotalPage = Math.ceil(_this2.reportDataTotal / 10);
	          console.log(_this2.reportTotalPage);
	          console.log('打印totalpage的页面');
	          _this2.bottompage = 1;
	          _this2.$nextTick(function () {
	            document.documentElement.scrollTop = 0;
	          });
	        }
	      });
	    }
	  }
	};

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _searchResMix = __webpack_require__(84);
	
	var _searchResMix2 = _interopRequireDefault(_searchResMix);
	
	var _BigImg = __webpack_require__(105);
	
	var _BigImg2 = _interopRequireDefault(_BigImg);
	
	var _resultFrag = __webpack_require__(344);
	
	var _resultFrag2 = _interopRequireDefault(_resultFrag);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'SearchView',
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default, _commentMix2.default, _comSearchMix2.default, _searchResMix2.default],
	  components: {
	    'bigimg': _BigImg2.default,
	    'resfrag': _resultFrag2.default
	  },
	  data: function data() {
	    return {
	      bigImgObj: { 'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': '' },
	      reportTotalPage: null
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      console.log(to.query);
	      console.log("进入search组件页面");
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	          console.log('登陆微信');
	        } else {
	          this.getProfile(to.query.share);
	          console.log('登陆失败');
	        }
	      }
	      if (this.currentuser) {
	        document.title = 'IBDATA:智能投研第一品牌';
	
	        if (to.query.search) {
	          this.switchPage(1);
	          this.datetype = 6;
	          this.changeDateType(6);
	
	          if (to.query.uid) {
	            this.params.uidUrl = to.query.uid;
	          }
	          if (to.query.share) {
	            this.params.share = to.query.share;
	          }
	          if (to.query.plat) {
	            this.params.plat = to.query.plat;
	          }
	          if (to.query.sid) {
	            this.params.sid = to.query.sid;
	          }
	          if (to.query.ruid) {
	            this.params.ruid = to.query.ruid;
	          }
	          if (to.query.ts) {
	            this.params.ts = to.query.ts;
	          }
	          if (this.checkAction('search/ai')) {
	            this.ai = 1;
	          } else {
	            this.ai = 0;
	          }
	
	          this.$nextTick(function () {
	            var that = this;
	            var wxsharedesc = that.getResultShareDesc();
	            var wxsharetitle = that.getResultShareTitle();
	            that.getwxsign();
	            that.shareSearch(wxsharetitle, wxsharedesc);
	          });
	        } else {
	          this.getTagLists();
	          this.params.uidUrl = to.query.uid;
	          this.params.share = to.query.share;
	          this.params.plat = to.query.plat;
	          this.params.ts = to.query.ts;
	
	          var descs = window.location.href.split('&');
	          for (var i = 0, len = descs.length; i < len; i++) {
	            var str = descs[i];
	            if (str.indexOf('desc=') == 0) {
	              this.params.desc = decodeURIComponent(str.split('=')[1]);
	              break;
	            }
	          }
	
	
	          this.params.sid = to.query.sid;
	          this.params.ruid = to.query.ruid;
	          this.diysharedesc = to.query.desc;
	          this.stype = to.query.stype;
	          if (this.checkAction('search/ai')) {
	            if (to.query.ai == '1') {
	              this.ai = 1;
	            }
	          } else {
	            this.ai = 0;
	          }
	          this.clearSearch();
	          this.datetype = 9;
	          this.changeStype(parseInt(to.query['stype']));
	          var query = this.parseUrlQuery(to.query);
	          this.$data = (0, _assign2.default)({}, this.$data, query);
	          this.addToShow();
	          if (!this.isEmptyObj(this.conditions['industrysecond'])) {
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(this.industry), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var d = _step.value;
	
	                this.setNum('industrysecond', d);
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	          }
	          if (!this.isEmptyObj(this.conditions['layer'])) {
	            this.setNum('plate', this.plates[0]);
	          }
	          this.search();
	
	          jQuery(window).unbind();
	          (0, _jquery2.default)(window).unbind();
	          var that = this;
	          if (this.stype != 100) {
	            (0, _jquery2.default)(window).scroll(function () {
	              var scrollTop = (0, _jquery2.default)(this).scrollTop();
	              var scrollHeight = (0, _jquery2.default)(document).height();
	              var windowHeight = (0, _jquery2.default)(this).height();
	
	              if (scrollTop === 0) {
	                var top_page = parseInt(that.topPage) - 1;
	                if (that.topPage > 1) {
	                  that.page = that.topPage;
	                  that.topPage--;
	                  if (that.stype == 13) {
	                    console.log('g㢃大大大萨达撒多撒多');
	                    that.reportPage2(that.bottompage);
	                    var newReportData = that.reportDataList.concat(that.newItems);
	                    that.reportDataList = newReportData;
	                  } else {
	                    that.paging2(that.topPage);
	                    var newDetailLists = that.newItems.concat(that.detailLists);
	                    that.detailLists = newDetailLists;
	                  }
	                  that.$nextTick(function () {
	                    var resultList10 = (0, _jquery2.default)('.search-result-list')[4];
	                    var offsetTop = resultList10.offsetTop;
	                    var offsetHeight = resultList10.offsetHeight;
	                    var newOffsetTop = offsetTop + offsetHeight;
	                    (0, _jquery2.default)(window).scrollTop(newOffsetTop);
	                  });
	                }
	              }
	
	              if (scrollTop + windowHeight >= scrollHeight) {
	                console.log('滚动到底部');
	                var next_page = parseInt(that.bottomPage) + 1;
	                var totals = void 0;
	                if (that.stype == 13) {
	                  totals = that.reportTotalPage;
	                } else {
	                  totals = that.totalpage;
	                }
	                console.log(that.stype, that.bottomPage, totals);
	                if (that.bottomPage < totals) {
	                  that.page = that.bottomPage;
	                  that.bottomPage++;
	                  if (that.stype == 13) {
	                    console.log(that.bottomPage);
	                    console.log('xxxxxg㢃大大大萨达撒多撒多');
	                    that.reportPage2(that.bottomPage);
	                    var _newReportData = that.reportDataList.concat(that.newItems);
	                    that.reportDataList = _newReportData;
	                  } else {
	                    that.paging2(that.bottomPage);
	                    var _newDetailLists = that.detailLists.concat(that.newItems);
	                    that.detailLists = _newDetailLists;
	                  }
	                } else {
	                  that.bottomTip = true;
	                  setTimeout(function () {
	                    dom.scrollTop = scrollHeight - windowHeight - 40;
	                  }, 800);
	                }
	              }
	            });
	          }
	          this.$nextTick(function () {
	            var that = this;
	            var wxsharedesc = that.getResultShareDesc();
	            var wxsharetitle = that.getResultShareTitle();
	            that.getwxsign();
	            that.shareSearch(wxsharetitle, wxsharedesc);
	
	            if (this.params.desc && this.params.desc != '') {
	              document.title = this.params.desc;
	            }
	          });
	        }
	      }
	    }
	  },
	  methods: {
	    setBigImgObj: function setBigImgObj(item, article) {
	      this.bigImgObj.imghead = item.imghead;
	      this.bigImgObj.imgfoot = item.imgfoot;
	      this.bigImgObj.imgurl = item.imgurl;
	      this.bigImgObj.imgid = item.imgid;
	
	      this.bigImgObj.companycode = article.companyCode;
	      this.bigImgObj.companyname = article.companyName;
	      this.bigImgObj.md5 = article.id;
	      this.bigImgObj.publishdate = article.publishDate;
	
	      this.bigImgObj.stype = this.stype;
	      this.bigImgObj.title = article.title;
	
	      this.bigImgObj.show = true;
	    },
	    getTimeStamp: function getTimeStamp() {
	      return new Date().getTime();
	    },
	    switchPage: function switchPage(val) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        if (window.location.href.indexOf('search?search=true') > 0) {
	          this.showSearchPage = true;
	          this.showTongjiPage = false;
	          this.showResultPage = false;
	        }
	        return;
	      }
	      if (val === 1) {
	        this.showSearchPage = true;
	        this.showTongjiPage = false;
	        this.showResultPage = false;
	      } else if (val === 2) {
	        this.showSearchPage = false;
	        this.showTongjiPage = false;
	        this.showResultPage = true;
	      } else if (val === 3) {
	        this.showSearchPage = false;
	        this.showTongjiPage = true;
	        this.showResultPage = false;
	        if (this.showStatFilter) {
	          this.showStatAnalyze = false;
	        }
	      }
	    },
	    go: function go(page) {
	      this.page = page || 1;
	      var query = this.genUrlQuery();
	      query.ruid = this.params.uidUrl;
	      query.uid = this.uid;
	      this.$route.router.go({ path: '/search', query: query });
	    },
	    search: function search() {
	      var _this = this;
	
	      this.loading = true;
	      var keywords = this.keywords.trim();
	      this.companyCode = this.companyCode.trim();
	      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !this.keywords) {
	        (0, _helper.alert)('请输入关键词或股票代码');
	        return;
	      }
	
	      this.finance = [];
	      this.yearfinance = [];
	      this.smartEngine.open = false;
	      this.smartEngine.companyInfo = {};
	
	      var query = this.genQuery();
	      query.perPage = 5;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      query.ruid = this.params.ruid;
	
	      var page = query.page;
	      this.topPage = page;
	      this.bottomPage = page;
	      this.page = page;
	      this.initAnaly();
	
	      var requrl = '';
	      if (this.stype == 100) {
	        console.log(this.loading);
	        this.complex();
	      } else if (this.stype == 13) {
	        this.reportData(this.stype);
	      } else {
	        if (this.stype === 1 || this.stype === 2) {
	          requrl = (0, _helper.apiUrl)('/V1.0.0/notice/searchn3b');
	        } else {
	          console.log('进入search接口信息页面');
	          console.log(this.stype);
	          requrl = (0, _helper.apiUrl)('/V1.0.0/notice/search');
	        }
	
	        _jquery2.default.ajax({
	          url: requrl,
	          method: 'post',
	          dataType: 'json',
	          data: (0, _stringify2.default)(query)
	        }).done(function (response) {
	          _this.loading = false;
	          _this.analyze();
	          if (response.status === 0) {
	            var items = response.lists;
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = (0, _getIterator3.default)(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var _item = _step2.value;
	
	                _item.checked = false;
	                if (_item.child) {
	                  var _iteratorNormalCompletion5 = true;
	                  var _didIteratorError5 = false;
	                  var _iteratorError5 = undefined;
	
	                  try {
	                    for (var _iterator5 = (0, _getIterator3.default)(_item.child), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                      var child = _step5.value;
	
	                      child.showque = false;
	                      if (child.answers) {
	                        var _iteratorNormalCompletion6 = true;
	                        var _didIteratorError6 = false;
	                        var _iteratorError6 = undefined;
	
	                        try {
	                          for (var _iterator6 = (0, _getIterator3.default)(child.answers), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                            var ans = _step6.value;
	
	                            ans.showans = false;
	                          }
	                        } catch (err) {
	                          _didIteratorError6 = true;
	                          _iteratorError6 = err;
	                        } finally {
	                          try {
	                            if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                              _iterator6.return();
	                            }
	                          } finally {
	                            if (_didIteratorError6) {
	                              throw _iteratorError6;
	                            }
	                          }
	                        }
	                      }
	                    }
	                  } catch (err) {
	                    _didIteratorError5 = true;
	                    _iteratorError5 = err;
	                  } finally {
	                    try {
	                      if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                        _iterator5.return();
	                      }
	                    } finally {
	                      if (_didIteratorError5) {
	                        throw _iteratorError5;
	                      }
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            _this.items = items;
	            _this.detailLists = items;
	            _this.total = response.total;
	            var totalPage = Math.ceil(_this.total / _this.perPage);
	            _this.totalPage = totalPage;
	            _this.searched = _this.stype;
	            if (response.company) {
	              _this.smartComInfo = response.company[0] || {};
	              if (_this.smartComInfo.finance && _this.smartComInfo.finance.length > 0) {
	                var a = [' '];
	                for (var k in _this.smartComInfo.finance[0]) {
	                  if (k !== 'plate' && k !== 'reportdate' && k !== 'reportdatestr') {
	                    a.push(k);
	                  }
	                }
	                _this.finance.push(a);
	                _this.yearfinance.push(a);
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                  for (var _iterator3 = (0, _getIterator3.default)(_this.smartComInfo.finance), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var item = _step3.value;
	
	                    var arr = [];
	                    if (item.plate === 'A') {
	                      for (var i in item) {
	                        if (i !== 'plate' && i !== 'reportdatestr') {
	                          arr.push(item[i]);
	                        }
	                      }
	                      _this.finance.push(arr);
	                    } else {
	                      for (var _i in item) {
	                        if (_i !== 'plate' && _i !== 'reportdate') {
	                          arr.push(item[_i]);
	                        }
	                      }
	                      _this.finance.push(arr);
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError3 = true;
	                  _iteratorError3 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                      _iterator3.return();
	                    }
	                  } finally {
	                    if (_didIteratorError3) {
	                      throw _iteratorError3;
	                    }
	                  }
	                }
	
	                var _iteratorNormalCompletion4 = true;
	                var _didIteratorError4 = false;
	                var _iteratorError4 = undefined;
	
	                try {
	                  for (var _iterator4 = (0, _getIterator3.default)(_this.finance), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                    var _i2 = _step4.value;
	
	                    if (_this.smartComInfo.type === 'A') {
	                      if (_i2[0] && _i2[0].indexOf('-12-') > 0) {
	                        _this.yearfinance.push(_i2);
	                      }
	                    } else {
	                      if (_i2[0] && _i2[0].indexOf('年报') > 0) {
	                        _this.yearfinance.push(_i2);
	                      }
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError4 = true;
	                  _iteratorError4 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                      _iterator4.return();
	                    }
	                  } finally {
	                    if (_didIteratorError4) {
	                      throw _iteratorError4;
	                    }
	                  }
	                }
	
	                _this.finance.sort(function (a, b) {
	                  return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	                });
	                _this.yearfinance.sort(function (a, b) {
	                  return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	                });
	              } else {
	                _this.finance = [];
	                _this.yearfinance = [];
	              }
	              _this.prices = _this.smartComInfo.price || {};
	              if (_this.prices.trade && _this.prices.settlement) {
	                _this.upanddown = (_this.prices.trade - _this.prices.settlement).toFixed(2);
	                if (_this.upanddown > 0 || _this.upanddown == 0) {
	                  _this.upanddown = '+' + _this.upanddown;
	                }
	                _this.Amplitude = ((_this.prices.trade - _this.prices.settlement) / _this.prices.settlement * 100).toFixed(2);
	                if (_this.Amplitude > 0) {
	                  _this.Amplitude = '+' + _this.Amplitude;
	                }
	              }
	            } else {
	              _this.smartComInfo = {};
	            }
	
	            if (_this.page !== 1) {
	              _this.$nextTick(function () {
	                (0, _jquery2.default)(window).scrollTop(23);
	              });
	            }
	          } else if (response.status === 502) {
	            (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	          }
	        }).fail(function (response) {
	          _this.loading = false;
	          (0, _helper.alert)('请求失败');
	        });
	      }
	    },
	    mySearch: function mySearch() {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	
	
	      var keywords = this.keywords.trim();
	      this.companyCode = this.companyCode.trim();
	      if (!this.companyCode && this.stype !== 4 && !this.validKeywordCondition() && !keywords) {
	        (0, _helper.alert)('请输入关键词或股票代码!');
	        return;
	      }
	      this.hasoneSearch = true;
	      this.switchPage(2);
	      this.page = 1;
	      var query = this.genUrlQuery();
	      query.ai = this.ai;
	      query.uid = this.params.uidUrl;
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	      query.sid = this.params.sid;
	
	      this.$route.router.go({ path: '/search', query: query });
	    },
	    slideDropdown2: function slideDropdown2(e) {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	
	      var el = e.currentTarget;
	      var nextNode = el.nextElementSibling;
	      var elClass = nextNode.getAttribute('class'),
	          class1 = elClass.split(' ')[0],
	          class2 = elClass.split(' ')[1];
	      (0, _jquery2.default)('.date-menu').each(function () {
	        if ((0, _jquery2.default)(this).hasClass('open')) {
	          (0, _jquery2.default)(this).removeClass('open').addClass('close');
	        }
	      });
	
	      if (class2 === 'close') {
	        var _class = class1 + ' ' + 'open';
	        nextNode.setAttribute('class', _class);
	      }
	      if (class2 === 'open') {
	        var _class2 = class1 + ' ' + 'close';
	        nextNode.setAttribute('class', _class2);
	      }
	    },
	    alertDateModal: function alertDateModal() {
	      if (this.currentRegtyp == 4) {
	        this.tipGoBind = true;
	        return;
	      }
	      this.showDateModal = true;
	      this.oldDatetype = this.datatype;
	      this.oldStartdate = this.startdate;
	      this.oldEnddate = this.enddate;
	    },
	    getShareLink: function getShareLink(href, typ) {
	      var url = href;
	      var sharelink = '';
	
	      if (typ == 'result') {
	        sharelink = url.split('search?')[0] + 'result?' + url.split('search?')[1];
	      }
	      if (typ == 'search') {
	        sharelink = url;
	      }
	
	      var query = {};
	      query.uid = this.uid;
	      query.url = sharelink;
	      query.plat = 'mobile';
	      query.share = 'weixin';
	      query.action = 'SEARCH';
	
	      var _sharelink = '';
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/sharelink'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query),
	        async: false
	      }).done(function (response) {
	        if (response.status === 0) {
	          _sharelink = response.url;
	        }
	      }).fail(function (response) {});
	      return _sharelink;
	    },
	    searchMore: function searchMore(stype) {
	      this.loading = true;
	      this.changeStype(stype);
	      this.mySearch();
	    },
	    reportData: function reportData(stype) {
	      var _this2 = this;
	
	      var query = this.genQuery();
	      query.stypes = [stype];
	      query.perPage = 10;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchall'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this2.loading = false;
	        if (response.status == 0) {
	          _this2.reportDataList = response.data[stype].lists;
	          _this2.reportDataTotal = response.data[stype].total;
	          _this2.reportTotalPage = Math.ceil(_this2.reportDataTotal / 10);
	          console.log(_this2.reportTotalPage);
	          console.log('打印totalpage的页面');
	          _this2.bottompage = 1;
	          _this2.$nextTick(function () {
	            document.documentElement.scrollTop = 0;
	          });
	        }
	      });
	    }
	  }
	};

/***/ },
/* 355 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'VipDialogView'
	};

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _searchResMix = __webpack_require__(84);
	
	var _searchResMix2 = _interopRequireDefault(_searchResMix);
	
	var _BigImg = __webpack_require__(105);
	
	var _BigImg2 = _interopRequireDefault(_BigImg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default, _commentMix2.default, _comSearchMix2.default, _searchResMix2.default],
	  components: {
	    'bigimg': _BigImg2.default
	  },
	  props: {
	    currentuser: {
	      default: {},
	      type: Object
	    },
	    stype: {
	      default: 1,
	      type: Number
	    },
	    items: {
	      default: [],
	      type: Array
	    },
	    onlytitle: {
	      default: 0,
	      type: Number
	    }
	  },
	  data: function data() {
	    return {
	      showratingLogic: false,
	      showriskWarning: false,
	      showsummary: false,
	      showviewPoint: false,
	      currentNoticeDetail: null,
	      defaultFilter: null,
	      defaultProperty: null,
	      simplepage: 1,
	      simpletotalpage: 0,
	      showsimpleNotice: false,
	      simpletotal: 0,
	      simpleNotice: [],
	      loading: false,
	      bigImgObj: { 'show': false, 'imghead': '', 'imgfoot': '', 'imgurl': '' },
	      rightMap: { 'type': '研报类型', 'company': '相关公司', 'tbcompany': '图表提到的公司', 'tblabel': '相关指标', 'tbsource': '数据来源', 'tbproduct': '相关产品', 'authors': '相关分析师', 'broker': '研究机构', 'SWHYIndustry': '相关行业', 'docrating': '相关评级', 'docratingChange': '评级变化' }
	    };
	  },
	
	  created: function created() {
	    console.log(this.onlytitle);
	    console.log(this.stype);
	    console.log(this.items);
	  },
	  computed: {
	    simpleindexs: function simpleindexs() {
	      var left = 1;
	      var right = this.simpletotalpage;
	      var ar = [];
	      if (this.simpletotalpage >= 11) {
	        if (this.simplepage > 5 && this.simplepage < this.simpletotalpage - 4) {
	          left = this.simplepage - 5;
	          right = this.simplepage + 4;
	        } else {
	          if (this.simplepage <= 5) {
	            left = 1;
	            right = 10;
	          } else {
	            right = this.simpletotalpage;
	            left = this.simplepage - 9;
	          }
	        }
	      }
	      while (left <= right) {
	        ar.push(left);
	        left++;
	      }
	      return ar;
	    }
	  },
	  methods: {
	    goABS: function goABS(k) {
	      var url = '/#!/abs?norname=' + k;
	      window.open(url);
	    },
	
	    simpleSearch: function simpleSearch(property, arg) {
	      var _this = this;
	
	      if (this.stype !== 11 && this.stype !== 13) {
	        return false;
	      }
	      this.defaultFilter = arg;
	      this.defaultProperty = property;
	      var query = { 'conditions': { 'type': {}, 'qaType': {}, 'plate': {}, 'layer': {}, 'region': {}, 'industry': {}, 'industrysecond': {}, 'securityCompany': {}, 'labels': {}, 'stage': {}, 'tbcompany': {}, 'company': {}, 'tblabel': {}, 'tbsource': {}, 'tbproduct': {}, 'authors': {}, 'broker': {}, 'SWHYIndustry': {}, 'docrating': {}, 'docratingChange': {} }, 'stype': 11, 'ttype': 0, 'keywords': '', 'companyCode': '', 'datetype': 98, 'startdate': '', 'enddate': '', 'keywords_condition': [{ 'val': '', 'ttype': 0, 'ttname': '全部', 'optype': 1, 'opname': '包含全部关键词' }], 'perPage': 10, 'page': this.simplepage, 'sort': 1 };
	
	      query.conditions[property][arg] = arg;
	
	      console.log(query);
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/search'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.simpleNotice = response.lists;
	          _this.simpletotalpage = response.totalPage;
	
	          _this.simpletotal = response.total;
	          _this.showsimpleNotice = true;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    exportTable: function exportTable(item, tcode, offset, ext) {
	      var _this2 = this;
	
	      if (!this.checkPrivilege('search/exporttable', '暂无权限')) {
	        return false;
	      }
	      console.log(item);
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/checkaction'),
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)({ 'action': 'search/exporttable' })
	      }).done(function (response) {
	        if (response.status == 0) {
	          var _offset = parseInt(offset) + 1;
	          var tcode1 = '';
	          if (tcode === '1') {
	            tcode1 = 'undefined';
	          } else {
	            tcode1 = tcode;
	          }
	          var _tcode = tcode1 + '-' + _offset.toString();
	          if (ext) {
	            var url = 'http://' + _this2.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + _this2.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&ext=1';
	          } else {
	            var url = 'http://' + _this2.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + _this2.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode;
	          }
	          _this2.downloadFile(url);
	          console.log(url);
	        } else if (response.status == 300) {
	          var that = _this2;
	          confirm(response.description, function () {
	            var _offset = parseInt(offset) + 1;
	            var tcode1 = '';
	            if (tcode === '1') {
	              tcode1 = 'undefined';
	            } else {
	              tcode1 = tcode;
	            }
	            var _tcode = tcode1 + '-' + _offset.toString();
	            if (ext) {
	              var url = 'http://' + that.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + that.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode + '&ext=1';
	            } else {
	              var url = 'http://' + that.$config.host.download + '/V1.0.0/notice/exporttable?id=' + item.id + '&pid=' + item.pid + '&stype=' + that.stype + '&pdate=' + item.publishDate + '&tcode=' + _tcode;
	            }
	            that.downloadFile(url);
	            console.log(url);
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	        return false;
	      });
	    },
	    downloadFile: function downloadFile(url, name) {
	      var link = document.createElement('a');
	      link.download = name;
	      link.href = url;
	      document.body.appendChild(link);
	      link.click();
	      document.body.removeChild(link);
	    },
	
	    setBigImgObj: function setBigImgObj(item, article) {
	      console.log(item);
	      console.log(article);
	      this.bigImgObj.imghead = item.imghead;
	      this.bigImgObj.imgfoot = item.imgfoot;
	      this.bigImgObj.imgurl = item.imgurl;
	      this.bigImgObj.imgid = item.imgid;
	
	      this.bigImgObj.companycode = article.companyCode;
	      this.bigImgObj.companyname = article.companyName;
	      this.bigImgObj.md5 = article.id;
	      this.bigImgObj.publishdate = article.publishDate;
	
	      this.bigImgObj.stype = this.stype;
	      this.bigImgObj.title = article.title;
	
	      this.bigImgObj.show = true;
	      this.bigImgObj.modal = 1;
	      var bigimgo = (0, _assign2.default)(this.bigImgObj);
	    },
	    checkLoginBefD: function checkLoginBefD(item, x) {
	
	      if (!this.checkPrivilege('search/download', '暂无权限')) {
	        return false;
	      }
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/checkaction'),
	        method: 'post',
	        dataType: 'json',
	        async: false,
	        data: (0, _stringify2.default)({ 'action': 'search/download' })
	      }).done(function (response) {
	        if (response.status == 300) {
	          confirm(response.description, function () {
	            (0, _jquery2.default)('#download_' + x).css('display', 'block');
	            (0, _jquery2.default)('.download_' + x).css('display', 'none');
	            var url = item.downloadurl;
	            if (document.cookie.indexOf('embed=1') < 0) {
	              window.open(url);
	            } else {
	              window.location.href = url;
	            }
	            setTimeout(function () {
	              (0, _jquery2.default)('#download_' + x).css('display', 'none');
	              (0, _jquery2.default)('.download_' + x).css('display', 'block');
	            }, 1500);
	          });
	        } else if (response.status == 0) {
	          (0, _jquery2.default)('#download_' + x).css('display', 'block');
	          (0, _jquery2.default)('.download_' + x).css('display', 'none');
	          var url = item.downloadurl;
	          if (document.cookie.indexOf('embed=1') < 0) {
	            window.open(url);
	          } else {
	            window.location.href = url;
	          }
	          setTimeout(function () {
	            (0, _jquery2.default)('#download_' + x).css('display', 'none');
	            (0, _jquery2.default)('.download_' + x).css('display', 'block');
	          }, 1500);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	        return false;
	      });
	    },
	
	    nationstatdatalist: function nationstatdatalist(item) {
	      var _this3 = this;
	
	      this.loading = true;
	
	      var newWin = window.open();
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/nationstatdatalist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ did: item.zb_detail_id })
	      }).done(function (response) {
	        _this3.loading = false;
	        if (response.status === 0) {
	          var data = response.data;
	          data.sort(function (a, b) {
	            return parseInt(a.data_time.replace(/-/g, '')) - parseInt(b.data_time.replace(/-/g, ''));
	          });
	
	          data.forEach(function (x) {
	            if (x.data) {
	              x.data = Math.round(x.data * 1000) / 1000;
	            }
	            return x;
	          });
	          var obj = {};
	          obj.frequency = item.zb_frequency;
	          obj.unit = item.zb_norm_unit;
	          obj.name = item.zb_type_name + "-" + item.zb_reg_name;
	          obj.starttime = data[0].data_time;
	          obj.endtime = data[data.length - 1].data_time;
	
	          window.localStorage.chartData = (0, _stringify2.default)(data);
	          window.localStorage.chartType = 'line';
	          window.localStorage.chartDetail = (0, _stringify2.default)(obj);
	
	          newWin.location.href = '/#!/complex?chartStatus=1';
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this3.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    }
	  }
	
	};

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'WelcomeView',
	  data: function data() {
	    return {};
	  },
	  created: function created() {
	    document.addEventListener('DOMContentLoaded', function (e) {
	      document.getElementsByTagName('html')[0].style.fontSize = window.innerWidth * (28 / 480) + 'px';
	    }, false);
	    var Slider = function Slider(container, options) {
	
	      "use strict";
	
	
	      if (!container) return;
	      var options = options || {},
	          currentIndex = 0,
	          cls = options.activeControllerCls,
	          delay = options.delay,
	          isAuto = options.auto,
	          controller = options.controller,
	          event = options.event,
	          interval,
	          slidesWrapper = container.children().first(),
	          slides = slidesWrapper.children(),
	          length = slides.length,
	          childWidth = container.width(),
	          totalWidth = childWidth * slides.length;
	
	      function init() {
	        var controlItem = controller.children();
	        mode();
	        if (event == 'hover') {
	          (0, _jquery2.default)(controlItem).mouseover(function () {
	            stop();
	            var index = (0, _jquery2.default)(this).index();
	            play(index, options.mode);
	          }).mouseout(function () {
	            console.log("出了图片范围");
	            isAuto && autoPlay();
	          });
	        } else {
	          controlItem.click(function () {
	            stop();
	            var index = (0, _jquery2.default)(this).index();
	
	            play(index, options.mode);
	            isAuto && autoPlay();
	          });
	        }
	        isAuto && autoPlay();
	      }
	
	      function mode() {
	        var wrapper = container.children().first();
	
	        options.mode == 'slide' ? wrapper.width(totalWidth) : wrapper.children().css({
	          'position': 'absolute',
	          'left': 0,
	          'top': 0
	        }).first().siblings().hide();
	      }
	
	      function autoPlay() {
	        interval = setInterval(function () {
	          triggerPlay(currentIndex);
	        }, options.time);
	      }
	
	      function triggerPlay(cIndex) {
	        var index;
	
	        cIndex == length - 1 ? index = 0 : index = cIndex + 1;
	        play(index, options.mode);
	      }
	
	      function play(index, mode) {
	        slidesWrapper.stop(true, true);
	        slides.stop(true, true);
	
	        mode == 'slide' ? function () {
	          if (index > currentIndex) {
	            slidesWrapper.animate({
	              left: '-=' + Math.abs(index - currentIndex) * childWidth + 'px'
	            }, delay);
	          } else if (index < currentIndex) {
	            slidesWrapper.animate({
	              left: '+=' + Math.abs(index - currentIndex) * childWidth + 'px'
	            }, delay);
	          } else {
	            return;
	          }
	        }() : function () {
	          if (slidesWrapper.children(':visible').index() == index) return;
	          slidesWrapper.children().fadeOut(delay).eq(index).fadeIn(delay);
	        }();
	
	        try {
	          controller.children('.' + cls).removeClass(cls);
	          controller.children().eq(index).addClass(cls);
	        } catch (e) {}
	
	        currentIndex = index;
	
	        options.exchangeEnd && typeof options.exchangeEnd == 'function' && options.exchangeEnd.call(this, currentIndex);
	      }
	
	      function stop() {
	        clearInterval(interval);
	      }
	
	      function _prev() {
	        stop();
	
	        currentIndex == 0 ? triggerPlay(length - 2) : triggerPlay(currentIndex - 2);
	
	        isAuto && autoPlay();
	      }
	
	      function _next() {
	        stop();
	
	        currentIndex == length - 1 ? triggerPlay(-1) : triggerPlay(currentIndex);
	
	        isAuto && autoPlay();
	      }
	
	      init();
	
	      return {
	        prev: function prev() {
	          _prev();
	        },
	        next: function next() {
	          _next();
	        }
	      };
	    };
	    (0, _jquery2.default)(function () {
	      var bannerSlider = new Slider((0, _jquery2.default)('#banner_tabs'), {
	        time: 1500,
	        delay: 400,
	        event: 'hover',
	        auto: true,
	        mode: 'fade',
	        controller: (0, _jquery2.default)('#bannerCtrl'),
	        activeControllerCls: 'active'
	      });
	
	      var height = (0, _jquery2.default)(document).height();
	      (0, _jquery2.default)('#gonow').click(function () {
	        (0, _jquery2.default)(".cover").css("height", height + "px");
	        (0, _jquery2.default)('.alertPage').css("display", "block");
	      });
	      (0, _jquery2.default)(".cover").click(function () {
	        (0, _jquery2.default)('.cover').css("height", "0");
	        (0, _jquery2.default)('.alertPage').css("display", "none");
	      });
	    });
	  }
	};

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      company: {}
	    };
	  },
	  ready: function ready() {
	    var _this = this;
	
	    this.$nextTick(function () {
	      _this.divMinHeight('.wrapper');
	    });
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      console.log("App.vue to detail");
	      console.log("初始化接收公司代码");
	      console.log(to.query.companycode);
	      console.log(to);
	      this.queryParam = to.query;
	      this.companycode = to.query.companycode;
	      this.stype = to.query.stype;
	      if (this.stype == 6) {
	        this.tabList = this.tabListH;
	      }
	
	      this.detail();
	
	      this.setSelectedTab();
	    }
	  },
	  methods: {
	    detail: function detail() {
	      var _this2 = this;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/detail'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)({ 'code': this.companycode })
	      }).done(function (response) {
	        _this2.loading = false;
	        if (response.status === 0) {
	          _this2.company = response.data;
	        } else {
	          console.log(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    toggleDropdown: function toggleDropdown() {
	      this.showDropdownMenu = this.showDropdownMenu ? false : true;
	    },
	
	    divMinHeight: function divMinHeight(className) {
	      this.$nextTick(function () {
	        (0, _jquery2.default)(className).css({ 'min-height': (0, _jquery2.default)(window).height() });
	      });
	    }
	  }
	};

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'CompanyBaseInfo',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  props: ['companyDetail'],
	  data: function data() {
	    return {};
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      console.log("第一步");
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        console.log();
	        console.log("wxcode:" + this.wxcode);
	        if (this.wxcode) {
	          console.log('weixin denglu success');
	          this.wxlogin(this.wxcode);
	        } else {
	          console.log("this.wxcode is null,login fail");
	          this.getProfile(to.query.share);
	        }
	      }
	      console.log("第二步");
	      console.log(this.currentuser);
	      if (this.currentuser) {
	        console.log('打印toquerystype');
	        console.log(to);
	        console.log(to.query.stype);
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.detail();
	      }
	    }
	  },
	  methods: {
	    detail: function detail() {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      console.log("baseInfo");
	      console.log(query);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/detail'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	
	          _this.company = response.data;
	          console.log(_this.company);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    }
	  }
	};

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      customerList: [],
	      customerListFilter: [],
	      customerPerPage: 10,
	      customerTotalPage: 0,
	      curCustomerDate: '',
	      allCustomerDate: [],
	      customerSort: {
	        xse: 0,
	        xszb: 0,
	        pm: 0
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getCustomer();
	      }
	    }
	  },
	  methods: {
	    getCustomer: function getCustomer() {
	      var _this2 = this;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/customerlist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	          _this2.customerList = response.data;
	          _this2.customerListFilter = response.data;
	          _this2.customerTotalPage = Math.ceil(response.data.length / _this2.customerPerPage);
	
	          if (response.data.length > 0) {
	            var tmp = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(_this2.customerListFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var h = _step.value;
	
	                if (!tmp[h.reportdatestr]) {
	                  tmp[h.reportdatestr] = true;
	                  _this2.allCustomerDate.push(h.reportdatestr);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            _this2.curCustomerDate = _this2.allCustomerDate[0];
	            _this2.customerFilter();
	            _this2.sortCustomer('money');
	          }
	
	          _this2.loading = false;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    customerFilter: function customerFilter() {
	      if (this.customerListFilter.length == 0) {
	        return;
	      }
	
	      this.loading = true;
	      if (this.curCustomerDate && this.curCustomerDate != '') {
	        var newArr = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.customerListFilter), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var h = _step2.value;
	
	            if (this.curCustomerDate == h.reportdatestr) {
	              newArr.push(h);
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.customerList = newArr;
	      }
	
	      if (this.customerSort.xse == 1) {
	        this.customerSort.xse = 2;
	        this.sortCustomer('money');
	      } else if (this.customerSort.xse == 2) {
	        this.customerSort.xse = 1;
	        this.sortCustomer('money');
	      }
	
	      if (this.customerSort.xszb == 1) {
	        this.customerSort.xszb = 2;
	        this.sortCustomer('ratio');
	      } else if (this.customerSort.xszb == 2) {
	        this.customerSort.xszb = 1;
	        this.sortCustomer('ratio');
	      }
	
	      if (this.customerSort.pm == 1) {
	        this.customerSort.pm = 2;
	        this.sortCustomer('rank');
	      } else if (this.customerSort.pm == 2) {
	        this.customerSort.pm = 1;
	        this.sortCustomer('rank');
	      }
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    sortCustomer: function sortCustomer(type) {
	      if (!type) {
	        return;
	      }
	
	      var _this = this;
	      function changeIcon(key) {
	        for (var k in _this.customerSort) {
	          if (k == key) {
	            if (_this.customerSort[k] == 1) {
	              _this.customerSort[k] = 2;
	            } else {
	              _this.customerSort[k] = 1;
	            }
	          } else {
	            _this.customerSort[k] = 0;
	          }
	        }
	      }
	
	      var resource = this.customerList;
	
	      if (type == 'money') {
	        if (this.customerSort.xse == 0 || this.customerSort.xse == 2) {
	          changeIcon('xse');
	          resource.sort(function (a, b) {
	            return parseFloat(b.money) - parseFloat(a.money);
	          });
	        } else if (this.customerSort.xse == 1) {
	          changeIcon('xse');
	          resource.sort(function (a, b) {
	            return parseFloat(a.money) - parseFloat(b.money);
	          });
	        }
	      }
	
	      if (type == 'ratio') {
	        if (this.customerSort.xszb == 0 || this.customerSort.xszb == 2) {
	          changeIcon('xszb');
	          resource.sort(function (a, b) {
	            return parseFloat(b.ratio) - parseFloat(a.ratio);
	          });
	        } else if (this.customerSort.xszb == 1) {
	          changeIcon('xszb');
	          resource.sort(function (a, b) {
	            return parseFloat(a.ratio) - parseFloat(b.ratio);
	          });
	        }
	      }
	
	      if (type == 'rank') {
	        if (this.customerSort.pm == 0 || this.customerSort.pm == 2) {
	          changeIcon('pm');
	          resource.sort(function (a, b) {
	            return parseFloat(b.rank) - parseFloat(a.rank);
	          });
	        } else if (this.customerSort.pm == 1) {
	          changeIcon('pm');
	          resource.sort(function (a, b) {
	            return parseFloat(a.rank) - parseFloat(b.rank);
	          });
	        }
	      }
	      this.customerList = resource;
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      reporting: true,
	      curDateType: '',
	      yearList: [],
	      legendCompany: [],
	      finance: [],
	      zhnl: [['基本每股收益(元)', 'basicearningspershare'], ['每股净资产', 'mgjzc'], ['净资产收益率(%)', 'jzcsyl'], ['流动比率(%)', 'ldbl'], ['速动比率(%)', 'sdbl'], ['应收账款周转率(%)', 'yszkzzl'], ['资产负债率(%)', 'zcfzl'], ['净利率(%)', 'jlv'], ['毛利率(%)', 'mlv'], ['存货周转率(%)', 'ckzzl'], ['稀释每股收益(元)', 'dilutedearningspershare'], ['营业总收入(元)', 'businessincometotal'], ['营业总成本(元)', 'operatingcoststotal'], ['营业成本(元)', 'operatingcosts'], ['营业利润(元)', 'operatingprofit'], ['利润总额(元)', 'totalprofits'], ['所得税(元)', 'incometax'], ['净利润(元)', 'retainedprofit'], ['归属于母公司股东的净利润(元)', 'retainedprofitowner'], ['每股经营活动产生的现金流量净额', 'mgjyxjllje']],
	
	      zhnlGroup: {
	        'basicearningspershare': [3, '投资与收益'],
	        'ldbl': [4, '偿债能力'],
	        'jlv': [2, '盈利能力'],
	        'ckzzl': [1, '经营能力'],
	        'dilutedearningspershare': [10, '其他指标']
	      },
	      dataMap: { '年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31' },
	      defaultName: '基本每股收益(元)',
	      defaultWord: 'basicearningspershare',
	      companyCodes: [],
	      anofinance: [],
	      anoyearfinance: []
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getFinance();
	      }
	    }
	  },
	  methods: {
	    getFinance: function getFinance() {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/finance'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          if ((0, _keys2.default)(response.data).length) {
	
	            var arr = [];
	
	            for (var k in response.data) {
	              if (k.indexOf('年') >= 0) {
	                var n = k.substr(0, 4) + _this.dataMap[k.substr(4)];
	                arr.push([n, response.data[k]]);
	              } else {
	                arr.push([k, response.data[k]]);
	              }
	            }
	            arr.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	
	            if (arr.length > 6) {
	              var i = void 0;
	              for (i = 0; i < 6; i++) {
	                _this.finance.push(arr[i]);
	              }
	            } else {
	              _this.finance = arr;
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _i = _step.value;
	
	                if (_i[0].indexOf('-12-') >= 0) {
	                  _this.yearList.push(_i);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            if (_this.yearList.length > 5) {
	              _this.yearList = _this.yearList.slice(0, 5);
	            }
	
	            _this.reporting = true;
	            _this.curDateType = _this.finance[0][0];
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    var _gbfzb;
	
	    return {
	      reporting: true,
	      curDateType: '',
	      yearList: [],
	      finance: [],
	      fzb: {
	        '货币资金(元)': 'capital',
	        '应收票据(元)': 'billreceivable',
	        '应收账款(元)': 'receivables',
	        '预付款项(元)': 'prepayment',
	        '其他应收款(元)': 'otherreceivables',
	        '存货(元)': 'inventory',
	        '其他流动资产(元)': 'otherliquidasset',
	        '流动资产合计(元)': 'liquidasset',
	        '固定资产(元)': 'fixedassets',
	        '在建工程(元)': 'constructioninprocess',
	        '无形资产(元)': 'intangibleassets',
	        '递延所得税资产(元)': 'deferredtaxasset',
	        '其他非流动资产(元)': 'otherilliquidasset',
	        '非流动资产合计(元)': 'illiquidasset',
	        '资产总计(元)': 'assettotal',
	        '短期借款(元)': 'shorttermborrowing',
	        '应付账款(元)': 'accountspayable',
	        '预收款项(元)': 'depositreceived',
	        '应付职工薪酬(元)': 'payrollpayable',
	        '应交税费(元)': 'taxesandduespayable',
	        '其他应付款(元)': 'otherpayables',
	        '流动负债合计(元)': 'currentliability',
	        '长期借款(元)': 'longtermborrowing',
	        '非流动负债合计(元)': 'noncurrentliabilities',
	        '负债合计(元)': 'liabilities',
	        '实收资本(或股本)(元)': 'paidincapital',
	        '资本公积(元)': 'capitalreserves',
	        '盈余公积(元)': 'surplusreserves',
	        '未分配利润(元)': 'undistributedprofits',
	        '归属于母公司股东权益合计(元)': 'totalownersequityparent',
	        '少数股东权益(元)': 'minorityinterests',
	        '股东权益合计(元)': 'ownersequity',
	        '负债和股东权益合计(元)': 'liabilitiesownersequity'
	      },
	      gbfzb: (_gbfzb = {
	        '其他储备(元)': 'otherspecialreserves',
	        '可收回本期税项(元)': 'taxrecoverable',
	        '可供出售金融资产(非流动)(元)': 'financialasset_illiquid',
	        '流动资产其他项目(元)': 'liquidasset',
	        '衍生金融负债(非流动)(元)': 'derivativefinancialliabilities_illiquid',
	        '留存收益(元)': 'retainedincome',
	        '总资产减流动负债(元)': 'assetsminuscurrentliability',
	        '流动负债其他项目(元)': 'currentliability',
	        '以公允价值计量且其变动计入当期损益的金融负债(非流动)(元)': 'financialliabilities_illiquid',
	        '负债及股东权益合计(元)': 'liabilitiesownersequity',
	        '商誉及无形资产(元)': 'goodwillintangibleassets',
	        '受限制存款及现金(元)': 'restricteddeposits',
	        '以公允价值计量且其变动计入当期损益的金融资产(流动)(元)': 'financialasset',
	        '持有至到期投资(非流动)(元)': 'heldtomaturityinvestment_illiquid',
	        '非流动负债其他项目(元)': 'noncurrentliabilities',
	        '递延收入(非流动)(元)': 'deferredincome_illiquid',
	        '归属于母公司股东权益(元)': 'totalownersequityparent',
	        '其他应付款项及应计费用(元)': 'otherpayables',
	        '净利率（%）': 'jlv',
	        '融资租赁负债(非流动)(元)': 'financeleaseliabilities_illiquid',
	        '长期借款(元)': 'longtermborrowing',
	        '流动资产周转率(次)': 'ldzczzl',
	        '拟派股息(元)': 'proposeddividend',
	        '融资租赁负债(流动)(元)': 'financeleaseliabilities',
	        '递延税项负债(元)': 'deferredtaxliabilities',
	        '归母净利润同比增长率(%)': 'gmjlrtbzzl',
	        '流动资产净值(元)': 'liquidassetnet',
	        '储备(元)': 'specialreserves',
	        '现金比率(%)': 'xjbl',
	        '总资产周转率(次)': 'zzczzl',
	        '每股经营活动产生的现金流量净额（元/股）': 'mgjyxjllje',
	        '土地使用权(元)': 'landuse',
	        '于联营和合营公司投资(元)': 'investmentjointcompany',
	        '每股公积金(元)': 'mggjj',
	        '非流动资产其他项目(元)': 'illiquidasset',
	        '总资产同比增长率(%)': 'zzctbzzl',
	        '持有至到期投资(流动)(元)': 'heldtomaturityinvestment',
	        '净资产收益率（%）': 'jzcsyl',
	        '净利润同比增长率(%)': 'jlrtbzzl',
	        '流动比率（倍）': 'ldbl',
	        '股东权益合计(元)': 'ownersequity',
	        '衍生金融资产(流动)(元)': 'derivativefinancialassets'
	      }, (0, _defineProperty3.default)(_gbfzb, '\u53EF\u4F9B\u51FA\u552E\u91D1\u878D\u8D44\u4EA7(\u975E\u6D41\u52A8)(\u5143)', 'sellablefinancialasset_illiquid'), (0, _defineProperty3.default)(_gbfzb, '应收关联公司款项(元)', 'relatereceivables'), (0, _defineProperty3.default)(_gbfzb, '应付股息及利息(元)', 'dividendpayable'), (0, _defineProperty3.default)(_gbfzb, '\u6D41\u52A8\u8D1F\u503A\u5176\u4ED6\u9879\u76EE(\u5143)', 'othercurrentliability'), (0, _defineProperty3.default)(_gbfzb, '\u878D\u8D44\u79DF\u8D41\u8D1F\u503A(\u6D41\u52A8)(\u5143)', 'liabilities'), (0, _defineProperty3.default)(_gbfzb, '\u975E\u6D41\u52A8\u8D1F\u503A\u5176\u4ED6\u9879\u76EE(\u5143)', 'othernoncurrentliabilities'), (0, _defineProperty3.default)(_gbfzb, '营业收入同比增长率(%)', 'yysrtbzzl'), (0, _defineProperty3.default)(_gbfzb, '比率计算状态', 'bl_status'), (0, _defineProperty3.default)(_gbfzb, '衍生金融负债(流动)(元)', 'derivativefinancialliabilities'), (0, _defineProperty3.default)(_gbfzb, '归属于母公司股东权益其他项目(元)', 'otherownersequityparent'), (0, _defineProperty3.default)(_gbfzb, '递延税项资产(元)', 'deferredtaxasset'), (0, _defineProperty3.default)(_gbfzb, '存货周转率（次）', 'ckzzl'), (0, _defineProperty3.default)(_gbfzb, '扣非每股收益(元)', 'kfmgsy'), (0, _defineProperty3.default)(_gbfzb, '预付款项、按金及其他应收款项(非流动)(元)', 'prepayment_illiquid'), (0, _defineProperty3.default)(_gbfzb, '以公允价值计量且其变动计入当期损益的金融负债(流动)(元)', 'financialliabilities'), (0, _defineProperty3.default)(_gbfzb, '速动比率（倍）', 'sdbl'), (0, _defineProperty3.default)(_gbfzb, '资产总额(元)', 'assettotal'), (0, _defineProperty3.default)(_gbfzb, '股东权益周转率(次)', 'gdqyzzl'), (0, _defineProperty3.default)(_gbfzb, '递延收入(流动)(元)', 'deferredincome'), (0, _defineProperty3.default)(_gbfzb, '可供出售金融资产(流动)(元)', 'sellablefinancialasset'), (0, _defineProperty3.default)(_gbfzb, '毛利率（%）', 'mlv'), (0, _defineProperty3.default)(_gbfzb, '股本(元)', 'paidincapital'), (0, _defineProperty3.default)(_gbfzb, '\u975E\u6D41\u52A8\u8D44\u4EA7\u5176\u4ED6\u9879\u76EE(\u5143)', 'otherilliquidasset'), (0, _defineProperty3.default)(_gbfzb, '经营现金流/营业收入', 'jyxjlyysr'), (0, _defineProperty3.default)(_gbfzb, '应收账款及票据(元)', 'receivables'), (0, _defineProperty3.default)(_gbfzb, '产权比率(%)', 'cqbl'), (0, _defineProperty3.default)(_gbfzb, '于附属公司投资(元)', 'investmentchildcompany'), (0, _defineProperty3.default)(_gbfzb, '物业、厂房及设备(元)', 'equipment'), (0, _defineProperty3.default)(_gbfzb, '存货(元)', 'inventory'), (0, _defineProperty3.default)(_gbfzb, '每股未分配利润(元)', 'mgwfplr'), (0, _defineProperty3.default)(_gbfzb, '其中:股本溢价(元)', 'stockpremium'), (0, _defineProperty3.default)(_gbfzb, '预付款项、按金及其他应收款项(流动)(元)', 'prepayment'), (0, _defineProperty3.default)(_gbfzb, '衍生金融资产(非流动)(元)', 'derivativefinancialassets_illiquid'), (0, _defineProperty3.default)(_gbfzb, '\u6D41\u52A8\u8D44\u4EA7\u5176\u4ED6\u9879\u76EE(\u5143)', 'otherliquidasset'), (0, _defineProperty3.default)(_gbfzb, '预收款/营业收入', 'yskyysr'), (0, _defineProperty3.default)(_gbfzb, '\u5546\u8A89\u53CA\u65E0\u5F62\u8D44\u4EA7(\u5143)', 'intangibleassets'), (0, _defineProperty3.default)(_gbfzb, '扣非净利润同比增长率(%)', 'kfjlrtbzzl'), (0, _defineProperty3.default)(_gbfzb, '非控股权益(元)', 'noncontrolinterests'), (0, _defineProperty3.default)(_gbfzb, '应收账款周转率（次）', 'yszkzzl'), _gbfzb),
	
	      dataMap: { '年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31' }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (to.query.stype == 6) {
	        this.fzb = this.gbfzb;
	      }
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getFinance();
	      }
	    }
	  },
	  methods: {
	    getFinance: function getFinance() {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/finance'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	
	          if ((0, _keys2.default)(response.data).length) {
	
	            var arr = [];
	            for (var k in response.data) {
	              if (k.indexOf('年') >= 0) {
	                var n = k.substr(0, 4) + _this.dataMap[k.substr(4)];
	                arr.push([n, response.data[k]]);
	              } else {
	                arr.push([k, response.data[k]]);
	              }
	            }
	
	            arr.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	            if (arr.length > 6) {
	              for (var i = 0; i < 6; i++) {
	                _this.finance.push(arr[i]);
	              }
	            } else {
	              _this.finance = arr;
	            }
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _i = _step.value;
	
	                if (_i[0].indexOf('-12-') >= 0) {
	                  _this.yearList.push(_i);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            if (_this.yearList.length > 5) {
	              _this.yearList = _this.yearList.slice(0, 5);
	            }
	
	            _this.reporting = true;
	            _this.curDateType = _this.finance[0][0];
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'GaoGuan',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      gaoguan: [],
	      originData: [],
	      allDateTyps: [],
	      curDateTyp: '',
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      notice: {
	        lists: [],
	        page: 1,
	        perPage: 10,
	        total: 0,
	        totalPage: 0,
	        pageInfo: {}
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！成功跳转到公司高管信息页面';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getGaoguan();
	        this.getRelationNotice();
	      }
	    }
	  },
	  methods: {
	    getGaoguan: function getGaoguan() {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/executivehist'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        if (response.status === 0) {
	          _this.gaoguan = response.data;
	          _this.originData = response.data;
	          _this.total = response.data.length;
	          _this.totalPage = Math.ceil(_this.total / _this.perPage);
	
	          _this.gaoguan.sort(function (a, b) {
	            return Date.parse(b.updtime) - Date.parse(a.updtime);
	          });
	
	          var tmp = {};
	          var year = '';
	          var month = '';
	          var str = '';
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var h = _step.value;
	
	              str = '';
	              year = '';
	              month = '';
	
	              year = h.updtime.split('-')[0];
	              month = parseInt(h.updtime.split('-')[1]);
	
	              if (month >= 4 && month < 7) {
	                str = year + '年一季报';
	              } else if (month >= 7 && month < 10) {
	                str = year + '年半年报';
	              } else if (month >= 10 && month < 12) {
	                str = year + '年三季报';
	              } else if (month == 12 || month >= 1 && month < 4) {
	                str = year - 1 + '年年报';
	              }
	
	              if (!tmp[str]) {
	                tmp[str] = true;
	                _this.allDateTyps.push(str);
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this.curDateTyp = _this.allDateTyps[0];
	          _this.tableFilter();
	          _this.loading = false;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    tableFilter: function tableFilter() {
	      var startdate = '';
	      var enddate = '';
	
	      var year = parseInt(this.curDateTyp.split('年')[0]);
	      if (this.curDateTyp.indexOf('一') > 0) {
	        startdate = year + '-' + '04-01';
	        enddate = year + '-' + '06-31';
	      } else if (this.curDateTyp.indexOf('半') > 0) {
	        startdate = year + '-' + '07-01';
	        enddate = year + '-' + '09-31';
	      } else if (this.curDateTyp.indexOf('三') > 0) {
	        startdate = year + '-' + '10-01';
	        enddate = year + '-' + '12-31';
	      } else if (this.curDateTyp.indexOf('年年') > 0) {
	        startdate = year + 1 + '-' + '01-01';
	        enddate = year + 1 + '-' + '03-31';
	      }
	
	      var arr = [];
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(this.originData), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var h = _step2.value;
	
	          if (h.updtime >= startdate && h.updtime <= enddate) {
	            arr.push(h);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      this.gaoguan = arr;
	      this.page = 1;
	      this.total = this.gaoguan.length;
	      this.totalPage = Math.ceil(this.total / this.perPage);
	      console.log(this.gaoguan.length);
	    },
	
	    getRelationNotice: function getRelationNotice() {
	      var _this2 = this;
	
	      this.loading = true;
	      this.notice.pageInfo.page = this.notice.page;
	      this.notice.pageInfo.perPage = this.notice.perPage;
	      this.notice.pageInfo.code = this.companycode;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/executivenotice'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(this.notice.pageInfo)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	          _this2.notice.lists = response.data.lists;
	          _this2.notice.total = response.data.total;
	          _this2.notice.totalPage = Math.ceil(response.data.total / _this2.notice.perPage);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    goNotice: function goNotice(item) {
	      var query = {};
	      query.pdate = item.publishDate;
	      query.k = item.id;
	      query.t = 1;
	
	      this.$route.router.go({ path: '/notice/detail', query: query });
	    }
	  }
	};

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      holders: [],
	      relations: [],
	      history: {
	        lists: [],
	        originLists: [],
	        dateTypes: [],
	        dateTyp: '',
	        page: 1,
	        perPage: 10,
	        total: 0,
	        totalPage: 0
	      },
	      sort: '',
	      desc: '',
	      dropdownMenu: false
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        console.log('909090');
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          console.log('profile');
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getGuDong();
	        this.getHistory();
	      }
	    }
	  },
	  methods: {
	    getGuDong: function getGuDong() {
	      var _this = this;
	
	      this.loading = false;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/gudong'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.holders = response.data.holders;
	          _this.holders.sort(function (a, b) {
	            return b.quantity - a.quantity;
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getHistory: function getHistory() {
	      var _this2 = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/gudonghist'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	          var formatDate = function formatDate(date) {
	            var y = date.split('-')[0];
	            var m = date.split('-')[1];
	            var d = date.split('-')[2];
	
	            if (m == '03') {
	              return y + '年一季报';
	            } else if (m == '06') {
	              return y + '年半年报';
	            } else if (m == '09') {
	              return y + '年三季报';
	            } else if (m == '12') {
	              return y + '年年报';
	            }
	          };
	
	          _this2.history.lists = response.data;
	          _this2.history.originLists = response.data;
	          _this2.history.total = response.data.length;
	          _this2.history.totalPage = Math.ceil(_this2.history.total / _this2.history.perPage);
	
	          var tmp = {};
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(_this2.history.lists), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var h = _step.value;
	
	              if (!h.changeqty) {
	                h.changeqty = 0;
	              }
	
	              if (!tmp[h.date]) {
	                tmp[h.date] = true;
	                _this2.history.dateTypes.push({ 'date': h.date, 'datestr': formatDate(h.date) });
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (_this2.history.dateTypes.length > 0) {
	            _this2.history.dateTypes.sort(function (a, b) {
	              return Date.parse(b.date) - Date.parse(a.date);
	            });
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    historyTableSort: function historyTableSort(type) {
	      this.sort = type;
	
	      if (type == 'date') {
	        if (this.desc == '' || this.desc == 2) {
	          this.desc = 1;
	          this.history.lists.sort(function (a, b) {
	            return Date.parse(b.date) - Date.parse(a.date);
	          });
	        } else if (this.desc == 1) {
	          this.desc = 2;
	          this.history.lists.sort(function (a, b) {
	            return Date.parse(a.date) - Date.parse(b.date);
	          });
	        }
	      }
	
	      if (type == 'ratio') {
	        if (this.desc == '' || this.desc == 2) {
	          this.desc = 1;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(b.ratio) - parseFloat(a.ratio);
	          });
	        } else if (this.desc == 1) {
	          this.desc = 2;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(a.ratio) - parseFloat(b.ratio);
	          });
	        }
	      }
	
	      if (type == 'changeqty') {
	        if (this.desc == '' || this.desc == 2) {
	          this.desc = 1;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(b.changeqty) - parseFloat(a.changeqty);
	          });
	        } else if (this.desc == 1) {
	          this.desc = 2;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(a.changeqty) - parseFloat(b.changeqty);
	          });
	        }
	      }
	
	      if (type == 'quantity') {
	        if (this.desc == '' || this.desc == 2) {
	          this.desc = 1;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(b.quantity) - parseFloat(a.quantity);
	          });
	        } else if (this.desc == 1) {
	          this.desc = 2;
	          this.history.lists.sort(function (a, b) {
	            return parseFloat(a.quantity) - parseFloat(b.quantity);
	          });
	        }
	      }
	    },
	
	    filterHistory: function filterHistory(h) {
	      this.loading = true;
	      this.dropdownMenu = false;
	      var arr = [];
	      if (h) {
	        this.history.dateTyp = h.datestr;
	
	        var resource = this.history.originLists;
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(resource), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var item = _step2.value;
	
	            if (item.date == h.date) {
	              arr.push(item);
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	      } else {
	        this.history.dateTyp = '';
	        arr = this.history.originLists;
	      }
	
	      this.history.lists = arr;
	      this.history.page = 1;
	      this.history.total = arr.length;
	
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    showDropdown: function showDropdown() {
	      this.dropdownMenu = this.dropdownMenu ? false : true;
	    },
	    hideDropmenu: function hideDropmenu(e) {
	      var _con = (0, _jquery2.default)('.keyword-down-c');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.dropdownMenu = false;
	      }
	    }
	  }
	};

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      originData: [],
	      industryList: [],
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      beutifulData: '',
	      beutifulDate: [],
	      allDateTyp: [],
	      curDateTyp: 'ALL',
	      yysr_rows: 0,
	      yycb_rows: 0,
	      yylr_rows: 0,
	      showYysr: false,
	      showYycb: false,
	      showYylr: false
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getIndustry();
	      }
	    }
	  },
	  filters: {
	    nullValue: function nullValue(param) {
	      if (!param || param == '') {
	        return '-';
	      } else {
	        return param;
	      }
	    }
	  },
	  watch: {
	    'industryList': function industryList(curVal, oldVal) {
	      this.showYysr = false;
	      this.showYycb = false;
	      this.showYylr = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.industryList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var h = _step.value;
	
	          if (h.yysr) {
	            this.showYysr = true;
	          }
	          if (h.yycb) {
	            this.showYycb = true;
	          }
	          if (h.yylr) {
	            this.showYylr = true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  },
	  methods: {
	    getIndustry: function getIndustry() {
	      var _this = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/mainindustrylist'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.industryList = response.data;
	          _this.originData = response.data;
	          _this.total = response.data.length;
	          _this.totalPage = Math.ceil(_this.total / _this.perPage);
	
	          _this.industryList.sort(function (a, b) {
	            return Date.parse(b.updtime) - Date.parse(a.updtime);
	          });
	
	          var tmp = {};
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_this.industryList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var h = _step2.value;
	
	              if (!tmp[h.reportdatestr]) {
	                tmp[h.reportdatestr] = true;
	                _this.allDateTyp.push(h.reportdatestr);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          _this.curDateTyp = _this.allDateTyp[0];
	          _this.filter();
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    filter: function filter() {
	
	      this.loading = true;
	
	      var arr = [];
	      var date = this.curDateTyp;
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.originData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var h = _step3.value;
	
	          if (h.reportdatestr === date) {
	            arr.push(h);
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.industryList = arr;
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      originData: [],
	      industryList: [],
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      beutifulData: '',
	      beutifulDate: [],
	      allDateTyp: [],
	      curDateTyp: 'ALL',
	      yysr_rows: 0,
	      yycb_rows: 0,
	      yylr_rows: 0,
	
	      company: {},
	      tab: 1,
	      financeindustry: [],
	      finance: [],
	      financeDate: [],
	      companyname: '',
	      gzbj: {
	        data: {},
	        dataTable: [],
	        sort: '',
	        desc: '',
	        showChart: ''
	      },
	      czxbj: {
	        dates: [],
	        industry: [],
	        my: [],
	        dataTable: [],
	        sort: '',
	        desc: '',
	        showChart: '' },
	      ylbj: {
	        dates: [],
	        industry: [],
	        my: [],
	        dataTable: [],
	        sort: '',
	        desc: '',
	        showChart: ''
	      },
	      zcbj: {
	        dates: [],
	        industry: [],
	        my: [],
	        dataTable: [],
	        sort: '',
	        desc: '',
	        showChart: ''
	      },
	      xjbj: {
	        dates: [],
	        industry: [],
	        my: [],
	        dataTable: [],
	        sort: '',
	        desc: '',
	        showChart: ''
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.routerStart();
	      }
	    }
	  },
	  filters: {
	    two: function two(value) {
	      if (!value) {
	        return;
	      } else if (value.toString().indexOf('.') >= 0) {
	        return value.toFixed(2);
	      } else {
	        return value;
	      }
	    }
	  },
	  methods: {
	    routerStart: function routerStart() {
	      this.detail();
	      this.changeDateType(9);
	
	      this.getFinance();
	      this.getAssessmentIndustry('per', 1);
	    },
	
	    detail: function detail() {
	      var _this = this;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/detail'),
	        method: 'post',
	        async: false,
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'code': this.companycode })
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.company = response.data;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getFinance: function getFinance() {
	      var _this2 = this;
	
	      this.loading = true;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/finance'),
	        method: 'post',
	        dataType: 'json',
	        async: false,
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        if (response.status === 0) {
	          _this2.loading = false;
	          if ((0, _keys2.default)(response.data).length) {
	
	            var sd = _this2.startdate;
	            var ed = _this2.enddate;
	            var resource = response.data;
	
	            for (var key in resource) {
	              if (key >= sd && key <= ed) {
	                resource[key]['date'] = key;
	                _this2.finance.push(resource[key]);
	              }
	            }
	
	            if (_this2.finance.length > 0) {
	              _this2.finance.sort(function (a, b) {
	                return Date.parse(a.date) - Date.parse(b.date);
	              });
	
	              var _iteratorNormalCompletion = true;
	              var _didIteratorError = false;
	              var _iteratorError = undefined;
	
	              try {
	                for (var _iterator = (0, _getIterator3.default)(_this2.finance), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                  var h = _step.value;
	
	                  _this2.financeDate.push(h.date);
	                }
	              } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion && _iterator.return) {
	                    _iterator.return();
	                  }
	                } finally {
	                  if (_didIteratorError) {
	                    throw _iteratorError;
	                  }
	                }
	              }
	            }
	          }
	        } else {
	          _this2.loading = false;
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getFinanceIndustry: function getFinanceIndustry(typ, sort, desc) {
	      var _this3 = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.typ = typ;
	      query.sort = sort;
	      query.desc = parseInt(desc);
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/financeindustry'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this3.loading = false;
	
	        if (response.status === 0) {
	          var isContain = function isContain(item, arr, shortname) {
	            if (!item || !arr || arr.length == 0) {
	              return;
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	              for (var _iterator2 = (0, _getIterator3.default)(arr), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                var h = _step2.value;
	
	                if (h.code && item.code) {
	                  if (h.code == item.code) {
	                    return true;
	                  }
	                } else {
	                  if (h.name == shortname) {
	                    return true;
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError2 = true;
	              _iteratorError2 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                  _iterator2.return();
	                }
	              } finally {
	                if (_didIteratorError2) {
	                  throw _iteratorError2;
	                }
	              }
	            }
	
	            return false;
	          };
	
	          var sd = _this3.startdate;
	          var ed = _this3.enddate;
	
	          if (typ === 2) {
	            _this3.czxbj.dates = [];
	            _this3.czxbj.industry = [];
	            _this3.czxbj.my = [];
	            _this3.czxbj.dataTable = [];
	            _this3.czxbj.sort = '';
	            _this3.czxbj.desc = '';
	            _this3.czxbj.showChart = '';
	
	            _this3.czxbj.sort = sort;
	            _this3.czxbj.desc = desc;
	
	            var len = 0;
	            var industry_yysr_sum = 0;
	            var industry_jlr_sum = 0;
	            var row_hyjz = {
	              name: '行业均值',
	              yysrtbzzl: 0,
	              jlrtbzzl: 0
	            };
	
	            var res = response.data.industry;
	            res.sort(function (a, b) {
	              return Date.parse(a.date) - Date.parse(b.date);
	            });
	            console.log(res);
	
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	              for (var _iterator3 = (0, _getIterator3.default)(response.data.industry), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                var h = _step3.value;
	
	                if (h.date >= sd && h.date <= ed) {
	                  len++;
	                  _this3.czxbj.dates.push(h.date);
	                  _this3.czxbj.industry.push(h);
	                  industry_yysr_sum += h.yysrtbzzl;
	                  industry_jlr_sum += h.jlrtbzzl;
	                }
	              }
	            } catch (err) {
	              _didIteratorError3 = true;
	              _iteratorError3 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                  _iterator3.return();
	                }
	              } finally {
	                if (_didIteratorError3) {
	                  throw _iteratorError3;
	                }
	              }
	            }
	
	            _this3.czxbj.dates.sort(function (a, b) {
	              return Date.parse(a) - Date.parse(b);
	            });
	            _this3.czxbj.industry.sort(function (a, b) {
	              return Date.parse(a.date) - Date.parse(b.date);
	            });
	
	            if (_this3.czxbj.dates.length == 0) {
	              _this3.czxbj.dates = _this3.financeDate;
	            }
	
	            row_hyjz.yysrtbzzl = industry_yysr_sum / len;
	            row_hyjz.jlrtbzzl = industry_jlr_sum / len;
	
	            var _iteratorNormalCompletion4 = true;
	            var _didIteratorError4 = false;
	            var _iteratorError4 = undefined;
	
	            try {
	              for (var _iterator4 = (0, _getIterator3.default)(_this3.finance), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	                var _h = _step4.value;
	
	                _this3.czxbj.my.push(_h);
	              }
	            } catch (err) {
	              _didIteratorError4 = true;
	              _iteratorError4 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion4 && _iterator4.return) {
	                  _iterator4.return();
	                }
	              } finally {
	                if (_didIteratorError4) {
	                  throw _iteratorError4;
	                }
	              }
	            }
	
	            var my = response.data.my;
	            var ranks = response.data.ranks;
	            my.code = _this3.company.code;
	            my.name = _this3.company.shortname;
	
	            ranks.unshift(row_hyjz);
	            ranks.unshift(my);
	            _this3.czxbj.dataTable = ranks;
	
	            var echart = void 0,
	                echart2 = void 0,
	                timer = void 0,
	                timer2 = void 0,
	                that = _this3;
	
	            _this3.$nextTick(function () {
	              timer = setInterval(function () {
	                echart = document.querySelector('.chart-canvas');
	
	                if (echart) {
	                  console.log('echart');
	                  clearInterval(timer);
	                  that.echartCZXBJ('yysrtbzzl');
	                }
	              }, 1000);
	
	              timer2 = setInterval(function () {
	                echart2 = document.querySelector('.chart-canvas2');
	
	                if (echart2) {
	                  console.log('echart2');
	                  clearInterval(timer2);
	                  that.echartCZXBJ('jlrtbzzl');
	                }
	              }, 1000);
	            });
	          }
	
	          if (typ === 3) {
	            _this3.ylbj.dates = [];
	            _this3.ylbj.industry = [];
	            _this3.ylbj.my = [];
	            _this3.ylbj.dataTable = [];
	            _this3.ylbj.sort = '';
	            _this3.ylbj.desc = '';
	            _this3.ylbj.showChart = '';
	
	            _this3.ylbj.sort = sort;
	            _this3.ylbj.desc = desc;
	            _this3.ylbj.showChart = sort;
	
	            var _len = 0;
	            var industry_jzcsyl_sum = 0;
	            var industry_jbmg_sum = 0;
	            var _row_hyjz = {
	              rank: null,
	              name: '行业平均',
	              jzcsyl: 0,
	              basicearningspershare: 0
	            };
	
	            var _iteratorNormalCompletion5 = true;
	            var _didIteratorError5 = false;
	            var _iteratorError5 = undefined;
	
	            try {
	              for (var _iterator5 = (0, _getIterator3.default)(response.data.industry), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	                var _h2 = _step5.value;
	
	                if (_h2.date >= sd && _h2.date <= ed) {
	                  _len++;
	                  _this3.ylbj.dates.push(_h2.date);
	                  _this3.ylbj.industry.push(_h2);
	                  industry_jzcsyl_sum += _h2.jzcsyl;
	                  industry_jbmg_sum += _h2.basicearningspershare;
	                }
	              }
	            } catch (err) {
	              _didIteratorError5 = true;
	              _iteratorError5 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                  _iterator5.return();
	                }
	              } finally {
	                if (_didIteratorError5) {
	                  throw _iteratorError5;
	                }
	              }
	            }
	
	            _this3.ylbj.dates.sort(function (a, b) {
	              return Date.parse(a) - Date.parse(b);
	            });
	            _this3.ylbj.industry.sort(function (a, b) {
	              return Date.parse(a.date) - Date.parse(b.date);
	            });
	
	            if (_this3.ylbj.dates.length == 0) {
	              _this3.ylbj.dates = _this3.financeDate;
	            }
	
	            _row_hyjz.jzcsyl = industry_jzcsyl_sum / _len;
	            _row_hyjz.basicearningspershare = industry_jbmg_sum / _len;
	
	            var _iteratorNormalCompletion6 = true;
	            var _didIteratorError6 = false;
	            var _iteratorError6 = undefined;
	
	            try {
	              for (var _iterator6 = (0, _getIterator3.default)(_this3.finance), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	                var _h3 = _step6.value;
	
	                _this3.ylbj.my.push(_h3);
	              }
	            } catch (err) {
	              _didIteratorError6 = true;
	              _iteratorError6 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion6 && _iterator6.return) {
	                  _iterator6.return();
	                }
	              } finally {
	                if (_didIteratorError6) {
	                  throw _iteratorError6;
	                }
	              }
	            }
	
	            var _my = response.data.my;
	            var _ranks = response.data.ranks;
	            if (!isContain(_my, _ranks, _this3.company.shortname)) {
	              _my.code = _this3.company.code;
	              _my.name = _this3.company.shortname;
	              _ranks.push(_my);
	            }
	
	            _ranks.sort(function (a, b) {
	              return a.rank - b.rank;
	            });
	            _ranks.push(_row_hyjz);
	            _this3.ylbj.dataTable = _ranks;
	
	            var _echart = void 0,
	                _echart2 = void 0,
	                _timer = void 0,
	                _timer2 = void 0,
	                _that = _this3;
	
	            _this3.$nextTick(function () {
	
	              _timer = setInterval(function () {
	                _echart = document.querySelector('.chart-canvas');
	
	                if (_echart) {
	                  console.log('echart');
	                  clearInterval(_timer);
	                  _that.echartYLBJ('jzcsyl');
	                }
	              }, 1000);
	
	              _timer2 = setInterval(function () {
	                _echart2 = document.querySelector('.chart-canvas2');
	
	                if (_echart2) {
	                  console.log('echart2');
	                  clearInterval(_timer2);
	                  _that.echartYLBJ('basicearningspershare');
	                }
	              }, 1000);
	            });
	          }
	
	          if (typ === 4) {
	            _this3.zcbj.dates = [];
	            _this3.zcbj.industry = [];
	            _this3.zcbj.my = [];
	            _this3.zcbj.dataTable = [];
	            _this3.zcbj.sort = '';
	            _this3.zcbj.desc = '';
	            _this3.zcbj.showChart = '';
	
	            _this3.zcbj.sort = sort;
	            _this3.zcbj.desc = desc;
	            _this3.zcbj.showChart = sort;
	
	            var _len2 = 0;
	            var industry_assettotal_sum = 0;
	            var industry_zcfzl_sum = 0;
	            var _row_hyjz2 = {
	              rank: null,
	              name: '行业平均',
	              assettotal: 0,
	              zcfzl: 0
	            };
	
	            var _iteratorNormalCompletion7 = true;
	            var _didIteratorError7 = false;
	            var _iteratorError7 = undefined;
	
	            try {
	              for (var _iterator7 = (0, _getIterator3.default)(response.data.industry), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	                var _h4 = _step7.value;
	
	                if (_h4.date >= sd && _h4.date <= ed) {
	                  _len2++;
	                  _this3.zcbj.dates.push(_h4.date);
	                  _this3.zcbj.industry.push(_h4);
	                  industry_assettotal_sum += _h4.assettotal;
	                  industry_zcfzl_sum += _h4.zcfzl;
	                }
	              }
	            } catch (err) {
	              _didIteratorError7 = true;
	              _iteratorError7 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                  _iterator7.return();
	                }
	              } finally {
	                if (_didIteratorError7) {
	                  throw _iteratorError7;
	                }
	              }
	            }
	
	            _this3.zcbj.dates.sort(function (a, b) {
	              return Date.parse(a) - Date.parse(b);
	            });
	            _this3.zcbj.industry.sort(function (a, b) {
	              return Date.parse(a.date) - Date.parse(b.date);
	            });
	
	            if (_this3.zcbj.dates.length == 0) {
	              _this3.zcbj.dates = _this3.financeDate;
	            }
	
	            _row_hyjz2.assettotal = industry_assettotal_sum / _len2;
	            _row_hyjz2.zcfzl = industry_zcfzl_sum / _len2;
	
	            var _iteratorNormalCompletion8 = true;
	            var _didIteratorError8 = false;
	            var _iteratorError8 = undefined;
	
	            try {
	              for (var _iterator8 = (0, _getIterator3.default)(_this3.finance), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                var _h5 = _step8.value;
	
	                _this3.zcbj.my.push(_h5);
	              }
	            } catch (err) {
	              _didIteratorError8 = true;
	              _iteratorError8 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                  _iterator8.return();
	                }
	              } finally {
	                if (_didIteratorError8) {
	                  throw _iteratorError8;
	                }
	              }
	            }
	
	            var _my2 = response.data.my;
	            var _ranks2 = response.data.ranks;
	            if (!isContain(_my2, _ranks2, _this3.company.shortname)) {
	              _my2.code = _this3.company.code;
	              _my2.name = _this3.company.shortname;
	              _ranks2.push(_my2);
	            }
	
	            _ranks2.sort(function (a, b) {
	              return a.rank - b.rank;
	            });
	            _ranks2.push(_row_hyjz2);
	            _this3.zcbj.dataTable = _ranks2;
	
	            var _echart3 = void 0,
	                _echart4 = void 0,
	                _timer3 = void 0,
	                _timer4 = void 0,
	                _that2 = _this3;
	
	            _this3.$nextTick(function () {
	
	              _timer3 = setInterval(function () {
	                _echart3 = document.querySelector('.chart-canvas');
	
	                if (_echart3) {
	                  console.log('echart');
	                  clearInterval(_timer3);
	                  _that2.echartZCBJ('assettotal');
	                }
	              }, 1000);
	
	              _timer4 = setInterval(function () {
	                _echart4 = document.querySelector('.chart-canvas2');
	
	                if (_echart4) {
	                  console.log('echart2');
	                  clearInterval(_timer4);
	                  _that2.echartZCBJ('zcfzl');
	                }
	              }, 1000);
	            });
	          }
	
	          if (typ === 5) {
	            _this3.xjbj.dates = [];
	            _this3.xjbj.industry = [];
	            _this3.xjbj.my = [];
	            _this3.xjbj.dataTable = [];
	            _this3.xjbj.sort = '';
	            _this3.xjbj.desc = '';
	            _this3.xjbj.showChart = '';
	
	            _this3.xjbj.sort = sort;
	            _this3.xjbj.desc = desc;
	            _this3.xjbj.showChart = sort;
	
	            var _len3 = 0;
	            var industry_jyhdxjl_sum = 0;
	            var industry_jbmgxjl_sum = 0;
	            var _row_hyjz3 = {
	              rank: null,
	              name: '行业平均',
	              cashoperatingactivites: 0,
	              basicearningspershare: 0
	            };
	
	            var _iteratorNormalCompletion9 = true;
	            var _didIteratorError9 = false;
	            var _iteratorError9 = undefined;
	
	            try {
	              for (var _iterator9 = (0, _getIterator3.default)(response.data.industry), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                var _h6 = _step9.value;
	
	                if (_h6.date >= sd && _h6.date <= ed) {
	                  _len3++;
	                  _this3.xjbj.dates.push(_h6.date);
	                  _this3.xjbj.industry.push(_h6);
	                  industry_jyhdxjl_sum += _h6.cashoperatingactivites;
	                  industry_jbmgxjl_sum += _h6.basicearningspershare;
	                }
	              }
	            } catch (err) {
	              _didIteratorError9 = true;
	              _iteratorError9 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                  _iterator9.return();
	                }
	              } finally {
	                if (_didIteratorError9) {
	                  throw _iteratorError9;
	                }
	              }
	            }
	
	            _this3.xjbj.dates.sort(function (a, b) {
	              return Date.parse(a) - Date.parse(b);
	            });
	            _this3.xjbj.industry.sort(function (a, b) {
	              return Date.parse(a.date) - Date.parse(b.date);
	            });
	
	            if (_this3.xjbj.dates.length == 0) {
	              _this3.xjbj.dates = _this3.financeDate;
	            }
	
	            _row_hyjz3.cashoperatingactivites = industry_jyhdxjl_sum / _len3;
	            _row_hyjz3.mgjyxjllje = industry_jbmgxjl_sum / _len3;
	
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	              for (var _iterator10 = (0, _getIterator3.default)(_this3.finance), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                var _h7 = _step10.value;
	
	                _this3.xjbj.my.push(_h7);
	              }
	            } catch (err) {
	              _didIteratorError10 = true;
	              _iteratorError10 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                  _iterator10.return();
	                }
	              } finally {
	                if (_didIteratorError10) {
	                  throw _iteratorError10;
	                }
	              }
	            }
	
	            var _my3 = response.data.my;
	            var _ranks3 = response.data.ranks;
	            if (!isContain(_my3, _ranks3, _this3.company.shortname)) {
	              _my3.code = _this3.company.code;
	              _my3.name = _this3.company.shortname;
	              _ranks3.push(_my3);
	            }
	
	            _ranks3.sort(function (a, b) {
	              return a.rank - b.rank;
	            });
	            _ranks3.push(_row_hyjz3);
	            _this3.xjbj.dataTable = _ranks3;
	
	            var _echart5 = void 0,
	                _echart6 = void 0,
	                _timer5 = void 0,
	                _timer6 = void 0,
	                _that3 = _this3;
	
	            _this3.$nextTick(function () {
	
	              _timer5 = setInterval(function () {
	                _echart5 = document.querySelector('.chart-canvas');
	
	                if (_echart5) {
	                  console.log('echart');
	                  clearInterval(_timer5);
	                  _that3.echartXJBJ('cashoperatingactivites');
	                }
	              }, 1000);
	
	              _timer6 = setInterval(function () {
	                _echart6 = document.querySelector('.chart-canvas2');
	
	                if (_echart6) {
	                  console.log('echart2');
	                  clearInterval(_timer6);
	                  _that3.echartXJBJ('mgjyxjllje');
	                }
	              }, 1000);
	            });
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this3.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getAssessmentIndustry: function getAssessmentIndustry(sort, desc) {
	      var _this4 = this;
	
	      this.gzbj.data = {};
	      this.gzbj.dataTable = [];
	      this.gzbj.sort = '';
	      this.gzbj.desc = '';
	
	      this.gzbj.sort = sort;
	      this.gzbj.showChart = sort;
	      this.gzbj.desc = desc;
	
	      var query = {};
	      query.code = this.companycode;
	      query.sort = sort;
	      query.desc = parseInt(desc);
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/assessmentindustry'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this4.loading = false;
	        if (response.status === 0) {
	          var isContain = function isContain(item, arr, shortname) {
	            if (!item || !arr || arr.length == 0) {
	              return;
	            }
	
	            if ((0, _stringify2.default)(item) == '{}' && shortname) {
	              var _iteratorNormalCompletion11 = true;
	              var _didIteratorError11 = false;
	              var _iteratorError11 = undefined;
	
	              try {
	                for (var _iterator11 = (0, _getIterator3.default)(arr), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	                  var h = _step11.value;
	
	                  if (h.name == shortname) {
	                    return true;
	                  }
	                }
	              } catch (err) {
	                _didIteratorError11 = true;
	                _iteratorError11 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                    _iterator11.return();
	                  }
	                } finally {
	                  if (_didIteratorError11) {
	                    throw _iteratorError11;
	                  }
	                }
	              }
	            }
	
	            var _iteratorNormalCompletion12 = true;
	            var _didIteratorError12 = false;
	            var _iteratorError12 = undefined;
	
	            try {
	              for (var _iterator12 = (0, _getIterator3.default)(arr), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                var _h8 = _step12.value;
	
	                if (_h8.code == item.code) {
	                  return true;
	                }
	              }
	            } catch (err) {
	              _didIteratorError12 = true;
	              _iteratorError12 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                  _iterator12.return();
	                }
	              } finally {
	                if (_didIteratorError12) {
	                  throw _iteratorError12;
	                }
	              }
	            }
	
	            return false;
	          };
	
	          _this4.gzbj.data = response.data;
	
	          var my = response.data.my;
	          var ranks = response.data.ranks;
	          if (!isContain(my, ranks, _this4.company.shortname)) {
	            my.name = _this4.company.shortname;
	            ranks.push(my);
	          }
	
	          ranks.sort(function (a, b) {
	            return a.rank - b.rank;
	          });
	
	          var industry = response.data.industry;
	          industry.rank = null;
	          industry.name = '行业均值';
	          ranks.push(industry);
	
	          _this4.gzbj.dataTable = ranks;
	
	          _this4.$nextTick(function () {
	            this.echartGZBJ();
	          });
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    changeTab: function changeTab(type) {
	      if (!type) {
	        return;
	      }
	
	      this.tab = parseInt(type);
	
	      if (this.tab == 1) {
	        this.$nextTick(function () {
	          this.getAssessmentIndustry(this.gzbj.sort, this.gzbj.desc);
	        });
	      } else if (this.tab == 2) {
	        this.$nextTick(function () {
	          this.getFinanceIndustry(2, 'yysrtbzzl', 1);
	        });
	      } else if (this.tab == 3) {
	        this.$nextTick(function () {
	          this.getFinanceIndustry(3, 'jzcsyl', 1);
	        });
	      } else if (this.tab == 4) {
	        this.$nextTick(function () {
	          this.getFinanceIndustry(4, 'assettotal', 1);
	        });
	      } else if (this.tab == 5) {
	        this.$nextTick(function () {
	          this.getFinanceIndustry(5, 'cashoperatingactivites', 1);
	        });
	      }
	    },
	
	    echartGZBJ: function echartGZBJ() {
	      (0, _jquery2.default)('.chart-canvas').remove();
	      (0, _jquery2.default)('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
	
	      var img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	      var echart = document.querySelector('.chart-canvas');
	
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	
	      var _legend = ['行业平均值'];
	      _legend.unshift(this.company.shortname);
	
	      var data_x = ['市盈率', '市净率'];
	      var data_y = [];
	      var data_y2 = [];
	      data_y.push(this.gzbj.data.my.pb);
	      data_y.push(this.gzbj.data.my.per);
	      data_y2.push(this.gzbj.data.industry.pb);
	      data_y2.push(this.gzbj.data.industry.per);
	
	      var mychart = _echarts2.default.init(echart);
	      var option = {
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross',
	            crossStyle: {
	              color: '#999'
	            }
	          }
	        },
	
	        legend: {
	          data: _legend
	        },
	        grid: {
	          left: '1%',
	          right: '0',
	          top: '15%',
	          bottom: '0',
	          containLabel: true
	        },
	        xAxis: [{
	          type: 'category',
	          data: data_x,
	          axisPointer: {
	            type: 'shadow'
	          }
	        }],
	        yAxis: [{
	          type: 'value',
	
	          splitNumber: 8,
	          axisLabel: {
	            formatter: '{value} %'
	          }
	        }],
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: this.company.shortname,
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y
	        }, {
	          name: '行业平均值',
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y2
	        }]
	      };
	      mychart.setOption(option);
	    },
	
	    echartCZXBJ: function echartCZXBJ(type) {
	      var echart = void 0,
	          img_shuiyin = void 0,
	          _legend = void 0,
	          data_x = [],
	          data_y = [],
	          data_y2 = [];
	
	      if (type == 'yysrtbzzl') {
	        (0, _jquery2.default)('.chart-canvas').remove();
	        (0, _jquery2.default)('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas');
	      }
	
	      if (type == 'jlrtbzzl') {
	        (0, _jquery2.default)('.chart-canvas2').remove();
	        (0, _jquery2.default)('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas2');
	      }
	
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	
	      img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	
	      _legend = ['行业平均值'];
	      _legend.unshift(this.company.shortname);
	      data_x = this.czxbj.dates;
	
	      var _iteratorNormalCompletion13 = true;
	      var _didIteratorError13 = false;
	      var _iteratorError13 = undefined;
	
	      try {
	        for (var _iterator13 = (0, _getIterator3.default)(this.czxbj.my), _step13; !(_iteratorNormalCompletion13 = (_step13 = _iterator13.next()).done); _iteratorNormalCompletion13 = true) {
	          var h = _step13.value;
	
	          data_y.push(h[type]);
	        }
	      } catch (err) {
	        _didIteratorError13 = true;
	        _iteratorError13 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion13 && _iterator13.return) {
	            _iterator13.return();
	          }
	        } finally {
	          if (_didIteratorError13) {
	            throw _iteratorError13;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion14 = true;
	      var _didIteratorError14 = false;
	      var _iteratorError14 = undefined;
	
	      try {
	        for (var _iterator14 = (0, _getIterator3.default)(this.czxbj.industry), _step14; !(_iteratorNormalCompletion14 = (_step14 = _iterator14.next()).done); _iteratorNormalCompletion14 = true) {
	          var _h9 = _step14.value;
	
	          data_y2.push(_h9[type]);
	        }
	      } catch (err) {
	        _didIteratorError14 = true;
	        _iteratorError14 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion14 && _iterator14.return) {
	            _iterator14.return();
	          }
	        } finally {
	          if (_didIteratorError14) {
	            throw _iteratorError14;
	          }
	        }
	      }
	
	      function nullVall(param) {
	        if (!param) {
	          return '--';
	        }
	
	        return param;
	      }
	
	      var mychart = _echarts2.default.init(echart);
	      var option = {
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross',
	            crossStyle: {
	              color: '#999'
	            }
	          },
	          formatter: function formatter(datas) {
	            if (datas && datas.length > 0) {
	              var res = '<ul><li>' + datas[0].axisValue + '<li/>';
	
	              var _iteratorNormalCompletion15 = true;
	              var _didIteratorError15 = false;
	              var _iteratorError15 = undefined;
	
	              try {
	                for (var _iterator15 = (0, _getIterator3.default)(datas), _step15; !(_iteratorNormalCompletion15 = (_step15 = _iterator15.next()).done); _iteratorNormalCompletion15 = true) {
	                  var h = _step15.value;
	
	                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall(h.value) + "<li/>";
	                }
	              } catch (err) {
	                _didIteratorError15 = true;
	                _iteratorError15 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion15 && _iterator15.return) {
	                    _iterator15.return();
	                  }
	                } finally {
	                  if (_didIteratorError15) {
	                    throw _iteratorError15;
	                  }
	                }
	              }
	
	              res += '</ul>';
	
	              return res;
	            }
	          }
	        },
	
	        legend: {
	          data: _legend
	        },
	        grid: {
	          left: '1%',
	          right: '0',
	          top: '15%',
	          bottom: '0',
	          containLabel: true
	        },
	        xAxis: [{
	          type: 'category',
	          data: data_x,
	          axisPointer: {
	            type: 'shadow'
	          }
	        }],
	        yAxis: [{
	          type: 'value',
	
	          splitNumber: 8,
	          axisLabel: {
	            formatter: '{value} %'
	          }
	        }],
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: this.company.shortname,
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y
	        }, {
	          name: '行业平均值',
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y2
	        }]
	      };
	
	      mychart.setOption(option);
	    },
	
	    echartYLBJ: function echartYLBJ(type) {
	
	      var echart = void 0,
	          img_shuiyin = void 0,
	          _legend = void 0,
	          _formatter = void 0,
	          data_x = [],
	          data_y = [],
	          data_y2 = [];
	
	      if (type == 'jzcsyl') {
	        (0, _jquery2.default)('.chart-canvas').remove();
	        (0, _jquery2.default)('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas');
	        _formatter = '{value} %';
	      }
	
	      if (type == 'basicearningspershare') {
	        (0, _jquery2.default)('.chart-canvas2').remove();
	        (0, _jquery2.default)('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas2');
	        _formatter = '{value}';
	      }
	
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	
	      _legend = ['行业平均值'];
	
	      _legend.unshift(this.company.shortname);
	      console.log('----------------------------- company: 盈利比较');
	      console.log(this.company);
	      console.log(this.company.shortname);
	      img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	      data_x = this.ylbj.dates;
	
	      var _iteratorNormalCompletion16 = true;
	      var _didIteratorError16 = false;
	      var _iteratorError16 = undefined;
	
	      try {
	        for (var _iterator16 = (0, _getIterator3.default)(this.ylbj.my), _step16; !(_iteratorNormalCompletion16 = (_step16 = _iterator16.next()).done); _iteratorNormalCompletion16 = true) {
	          var h = _step16.value;
	
	          data_y.push(h[type]);
	        }
	      } catch (err) {
	        _didIteratorError16 = true;
	        _iteratorError16 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion16 && _iterator16.return) {
	            _iterator16.return();
	          }
	        } finally {
	          if (_didIteratorError16) {
	            throw _iteratorError16;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion17 = true;
	      var _didIteratorError17 = false;
	      var _iteratorError17 = undefined;
	
	      try {
	        for (var _iterator17 = (0, _getIterator3.default)(this.ylbj.industry), _step17; !(_iteratorNormalCompletion17 = (_step17 = _iterator17.next()).done); _iteratorNormalCompletion17 = true) {
	          var _h10 = _step17.value;
	
	          data_y2.push(_h10[type]);
	        }
	      } catch (err) {
	        _didIteratorError17 = true;
	        _iteratorError17 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion17 && _iterator17.return) {
	            _iterator17.return();
	          }
	        } finally {
	          if (_didIteratorError17) {
	            throw _iteratorError17;
	          }
	        }
	      }
	
	      function nullVall(param) {
	        if (!param) {
	          return '--';
	        }
	
	        return param;
	      }
	
	      console.log(_legend);
	      var mychart = _echarts2.default.init(echart);
	      var option = {
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross',
	            crossStyle: {
	              color: '#999'
	            }
	          },
	          formatter: function formatter(datas) {
	            if (datas && datas.length > 0) {
	              var res = '<ul><li>' + datas[0].axisValue + '<li/>';
	
	              var _iteratorNormalCompletion18 = true;
	              var _didIteratorError18 = false;
	              var _iteratorError18 = undefined;
	
	              try {
	                for (var _iterator18 = (0, _getIterator3.default)(datas), _step18; !(_iteratorNormalCompletion18 = (_step18 = _iterator18.next()).done); _iteratorNormalCompletion18 = true) {
	                  var h = _step18.value;
	
	                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall(h.value) + "<li/>";
	                }
	              } catch (err) {
	                _didIteratorError18 = true;
	                _iteratorError18 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion18 && _iterator18.return) {
	                    _iterator18.return();
	                  }
	                } finally {
	                  if (_didIteratorError18) {
	                    throw _iteratorError18;
	                  }
	                }
	              }
	
	              res += '</ul>';
	
	              return res;
	            }
	          }
	        },
	
	        legend: {
	          data: _legend
	        },
	        grid: {
	          left: '1%',
	          right: '0',
	          top: '15%',
	          bottom: '0',
	          containLabel: true
	        },
	        xAxis: [{
	          type: 'category',
	          data: data_x,
	          axisPointer: {
	            type: 'shadow'
	          }
	        }],
	        yAxis: [{
	          type: 'value',
	
	          axisLabel: {
	            formatter: _formatter
	          }
	        }],
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: this.company.shortname,
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y
	        }, {
	          name: '行业平均值',
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y2
	        }]
	      };
	
	      mychart.setOption(option);
	    },
	
	    echartZCBJ: function echartZCBJ(type) {
	
	      var echart = void 0,
	          img_shuiyin = void 0,
	          _legend = void 0,
	          _formatter = void 0,
	          data_x = [],
	          data_y = [],
	          data_y2 = [];
	
	      if (type == 'assettotal') {
	        (0, _jquery2.default)('.chart-canvas').remove();
	        (0, _jquery2.default)('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas');
	        _formatter = '{value}';
	      }
	      if (type == 'zcfzl') {
	        (0, _jquery2.default)('.chart-canvas2').remove();
	        (0, _jquery2.default)('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas2');
	        _formatter = '{value} %';
	      }
	
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	
	      img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	      _legend = ['行业平均值'];
	      _legend.unshift(this.company.shortname);
	      data_x = this.zcbj.dates;
	
	      var _iteratorNormalCompletion19 = true;
	      var _didIteratorError19 = false;
	      var _iteratorError19 = undefined;
	
	      try {
	        for (var _iterator19 = (0, _getIterator3.default)(this.zcbj.my), _step19; !(_iteratorNormalCompletion19 = (_step19 = _iterator19.next()).done); _iteratorNormalCompletion19 = true) {
	          var h = _step19.value;
	
	          data_y.push(h[type]);
	        }
	      } catch (err) {
	        _didIteratorError19 = true;
	        _iteratorError19 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion19 && _iterator19.return) {
	            _iterator19.return();
	          }
	        } finally {
	          if (_didIteratorError19) {
	            throw _iteratorError19;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion20 = true;
	      var _didIteratorError20 = false;
	      var _iteratorError20 = undefined;
	
	      try {
	        for (var _iterator20 = (0, _getIterator3.default)(this.zcbj.industry), _step20; !(_iteratorNormalCompletion20 = (_step20 = _iterator20.next()).done); _iteratorNormalCompletion20 = true) {
	          var _h11 = _step20.value;
	
	          data_y2.push(_h11[type]);
	        }
	      } catch (err) {
	        _didIteratorError20 = true;
	        _iteratorError20 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion20 && _iterator20.return) {
	            _iterator20.return();
	          }
	        } finally {
	          if (_didIteratorError20) {
	            throw _iteratorError20;
	          }
	        }
	      }
	
	      function nullVall(param) {
	        if (!param) {
	          return '--';
	        }
	
	        return param;
	      }
	
	      var mychart = _echarts2.default.init(echart);
	      var option = {
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross',
	            crossStyle: {
	              color: '#999'
	            }
	          },
	          formatter: function formatter(datas) {
	            if (datas && datas.length > 0) {
	              var res = '<ul><li>' + datas[0].axisValue + '<li/>';
	
	              var _iteratorNormalCompletion21 = true;
	              var _didIteratorError21 = false;
	              var _iteratorError21 = undefined;
	
	              try {
	                for (var _iterator21 = (0, _getIterator3.default)(datas), _step21; !(_iteratorNormalCompletion21 = (_step21 = _iterator21.next()).done); _iteratorNormalCompletion21 = true) {
	                  var h = _step21.value;
	
	                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall(h.value) + "<li/>";
	                }
	              } catch (err) {
	                _didIteratorError21 = true;
	                _iteratorError21 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion21 && _iterator21.return) {
	                    _iterator21.return();
	                  }
	                } finally {
	                  if (_didIteratorError21) {
	                    throw _iteratorError21;
	                  }
	                }
	              }
	
	              res += '</ul>';
	
	              return res;
	            }
	          }
	        },
	
	        legend: {
	          data: _legend
	        },
	        grid: {
	          left: '1%',
	          right: '0',
	          top: '15%',
	          bottom: '0',
	          containLabel: true
	        },
	        xAxis: [{
	          type: 'category',
	          data: data_x,
	          axisPointer: {
	            type: 'shadow'
	          }
	        }],
	        yAxis: [{
	          type: 'value',
	
	          axisLabel: {
	            formatter: _formatter
	          }
	        }],
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: this.company.shortname,
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y
	        }, {
	          name: '行业平均值',
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y2
	        }]
	      };
	
	      mychart.setOption(option);
	    },
	
	    echartXJBJ: function echartXJBJ(type) {
	
	      var echart = void 0,
	          img_shuiyin = void 0,
	          _legend = void 0,
	          data_x = [],
	          data_y = [],
	          data_y2 = [];
	
	      if (type == 'cashoperatingactivites') {
	        (0, _jquery2.default)('.chart-canvas').remove();
	        (0, _jquery2.default)('.echart-wrap').prepend('<div class="chart-canvas" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas');
	      }
	
	      if (type == 'mgjyxjllje') {
	        (0, _jquery2.default)('.chart-canvas2').remove();
	        (0, _jquery2.default)('.echart-wrap2').prepend('<div class="chart-canvas2" style="height:180px;width:100%;"></div>');
	        echart = document.querySelector('.chart-canvas2');
	      }
	
	      if (!echart) {
	        console.log('!!');
	        return false;
	      }
	
	      img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	      _legend = ['行业平均值'];
	      _legend.unshift(this.company.shortname);
	      data_x = this.xjbj.dates;
	
	      var _iteratorNormalCompletion22 = true;
	      var _didIteratorError22 = false;
	      var _iteratorError22 = undefined;
	
	      try {
	        for (var _iterator22 = (0, _getIterator3.default)(this.xjbj.my), _step22; !(_iteratorNormalCompletion22 = (_step22 = _iterator22.next()).done); _iteratorNormalCompletion22 = true) {
	          var h = _step22.value;
	
	          data_y.push(h[type]);
	        }
	      } catch (err) {
	        _didIteratorError22 = true;
	        _iteratorError22 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion22 && _iterator22.return) {
	            _iterator22.return();
	          }
	        } finally {
	          if (_didIteratorError22) {
	            throw _iteratorError22;
	          }
	        }
	      }
	
	      var _iteratorNormalCompletion23 = true;
	      var _didIteratorError23 = false;
	      var _iteratorError23 = undefined;
	
	      try {
	        for (var _iterator23 = (0, _getIterator3.default)(this.xjbj.industry), _step23; !(_iteratorNormalCompletion23 = (_step23 = _iterator23.next()).done); _iteratorNormalCompletion23 = true) {
	          var _h12 = _step23.value;
	
	          data_y2.push(_h12[type]);
	        }
	      } catch (err) {
	        _didIteratorError23 = true;
	        _iteratorError23 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion23 && _iterator23.return) {
	            _iterator23.return();
	          }
	        } finally {
	          if (_didIteratorError23) {
	            throw _iteratorError23;
	          }
	        }
	      }
	
	      function nullVall(param) {
	        if (!param) {
	          return '--';
	        }
	
	        return param;
	      }
	
	      var mychart = _echarts2.default.init(echart);
	      var option = {
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross',
	            crossStyle: {
	              color: '#999'
	            }
	          },
	          formatter: function formatter(datas) {
	            if (datas && datas.length > 0) {
	              var res = '<ul><li>' + datas[0].axisValue + '<li/>';
	
	              var _iteratorNormalCompletion24 = true;
	              var _didIteratorError24 = false;
	              var _iteratorError24 = undefined;
	
	              try {
	                for (var _iterator24 = (0, _getIterator3.default)(datas), _step24; !(_iteratorNormalCompletion24 = (_step24 = _iterator24.next()).done); _iteratorNormalCompletion24 = true) {
	                  var h = _step24.value;
	
	                  res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + h.color + "'></span>" + h.seriesName + "：" + nullVall(h.value) + "<li/>";
	                }
	              } catch (err) {
	                _didIteratorError24 = true;
	                _iteratorError24 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion24 && _iterator24.return) {
	                    _iterator24.return();
	                  }
	                } finally {
	                  if (_didIteratorError24) {
	                    throw _iteratorError24;
	                  }
	                }
	              }
	
	              res += '</ul>';
	
	              return res;
	            }
	          }
	        },
	
	        legend: {
	          data: _legend
	        },
	        grid: {
	          left: '1%',
	          right: '0',
	          top: '15%',
	          bottom: '0',
	          containLabel: true
	        },
	        xAxis: [{
	          type: 'category',
	          data: data_x,
	          axisPointer: {
	            type: 'shadow'
	          }
	        }],
	        yAxis: [{
	          type: 'value',
	
	          axisLabel: {
	            formatter: '{value}'
	          }
	        }],
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: 10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: this.company.shortname,
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y
	        }, {
	          name: '行业平均值',
	          type: 'bar',
	          barMaxWidth: 80,
	          data: data_y2
	        }]
	      };
	
	      mychart.setOption(option);
	    }
	  }
	};

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _methods;
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      fundAllDate: [],
	      curFundDate: '',
	      fundsInvest: [],
	      fundsInvestFilter: [],
	      fundSort: {
	        gpsl: 0 },
	      fundPage: 1,
	      fundPerPage: 10,
	      fundTotalPage: 0
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.changeDateType(7);
	        this.datetype_name = '两年';
	        this.getFoundsInvest();
	      }
	    }
	  },
	  filters: {
	    fundDate: function fundDate(param) {
	      if (!param) return;
	
	      var year = void 0,
	          month = void 0;
	      param = param.toString();
	      year = param.substr(0, 4);
	      month = param.substr(4, 2);
	
	      if (parseInt(month) == 3) {
	        return year + '年一季度';
	      } else if (parseInt(month) == 6) {
	        return year + '年半年度';
	      } else if (parseInt(month) == 9) {
	        return year + '年三季度';
	      } else if (parseInt(month) == 12) {
	        return year + '年年度';
	      }
	    }
	  },
	  methods: (_methods = {
	    page: function page() {
	      this.loading = true;
	      this.scrollTop();
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    fundFilter: function fundFilter() {
	      if (this.fundsInvestFilter.length == 0) {
	        return;
	      }
	
	      this.fundPage = 1;
	
	      if (this.curFundDate && this.curFundDate != '') {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.fundsInvestFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var h = _step.value;
	
	            if (this.curFundDate == h.datadate) {
	              newArr.push(h);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.fundsInvest = newArr;
	      }
	
	      this.fundTotalPage = Math.ceil(this.fundsInvest.length / this.fundPerPage);
	
	      if (this.fundSort.gpsl == 1) {
	        this.fundSort.gpsl = 2;
	        this.sortFundsInvest('quantity');
	      } else if (this.fundSort.gpsl == 2) {
	        this.fundSort.gpsl = 1;
	        this.sortFundsInvest('quantity');
	      }
	
	      setTimeout(function () {
	        this.loading = false;
	      }, 500);
	    },
	    getFoundsInvest: function getFoundsInvest() {
	      var _this = this;
	
	      this.fundAllDate = [];
	
	      var query = {};
	      query.companycode = this.companycode;
	      for (var key in this.fundSort) {
	        this.fundSort[key] = 0;
	      }
	
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/publicfundsinvest'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	
	          _this.fundsInvest = response.data;
	          _this.fundsInvestFilter = response.data;
	          _this.fundTotalPage = Math.ceil(response.data.length / _this.fundPerPage);
	
	          var tmp = {},
	              dateArr = [];
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_this.fundsInvest), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var h = _step2.value;
	
	              if (!tmp[h.datadate]) {
	                tmp[h.datadate] = true;
	                dateArr.push(h.datadate);
	              }
	              if (!h.ratio) {
	                h.ratio = 0;
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          dateArr.sort(function (a, b) {
	            return parseInt(b) - parseInt(a);
	          });
	          _this.fundAllDate = dateArr;
	
	          if (response.data.length > 0) {
	            _this.curFundDate = _this.fundAllDate[0];
	            _this.fundFilter();
	            _this.sortFundsInvest('quantity');
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    sortFundsInvest: function sortFundsInvest(type) {
	      if (!type) {
	        return;
	      }
	
	      var resource = this.fundsInvest;
	
	      if (type == 'quantity') {
	        if (this.fundSort.gpsl == 0 || this.fundSort.gpsl == 2) {
	          resource.sort(function (a, b) {
	            return parseFloat(b.quantity) - parseFloat(a.quantity);
	          });
	        } else if (this.fundSort.gpsl == 1) {
	          resource.sort(function (a, b) {
	            return parseFloat(a.quantity) - parseFloat(b.quantity);
	          });
	        }
	      }
	
	      this.fundsInvest = resource;
	    },
	    fundPaging: function fundPaging(p) {
	      this.fundPage = p || 1;
	    },
	
	    showDateDropmemu: function showDateDropmemu(e) {
	      var target = (0, _jquery2.default)(e.target);
	      if (target.hasClass('dropdown-btn')) {
	        if (target.next().css('display') == 'none') {
	          target.next().css('display', 'block');
	        } else if (target.next().css('display') == 'block') {
	          target.next().css('display', 'none');
	        }
	      } else if (target.hasClass('dropdown-icon')) {
	        if (target.parent('.dropdown-btn').next().css('display') == 'none') {
	          target.parent('.dropdown-btn').next().css('display', 'block');
	        } else if (target.parent('.dropdown-btn').next().css('display') == 'block') {
	          target.parent('.dropdown-btn').next().css('display', 'none');
	        }
	      }
	    },
	
	    divMinHeight: function divMinHeight(className) {
	      this.$nextTick(function () {
	        (0, _jquery2.default)(className).css({ 'min-height': (0, _jquery2.default)(window).height() - 84 });
	      });
	    }
	  }, (0, _defineProperty3.default)(_methods, 'showDateDropmemu', function showDateDropmemu() {
	    this.dateDropmenu = this.dateDropmenu ? false : true;
	  }), (0, _defineProperty3.default)(_methods, 'clickDropmenu', function clickDropmenu() {
	    this.dateDropmenu = false;
	  }), _methods)
	};

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _datepicker = __webpack_require__(83);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  components: {
	    'date-picker': _datepicker2.default
	  },
	  data: function data() {
	    return {
	      largeexchangechart: [],
	      largeexchangechartSored: [],
	      tableSort: {
	        jyrq: 0,
	        cjl: 0,
	        cje: 0
	      },
	      largeexchangeLists: [],
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      datepicker: {
	        option: {
	          type: 'day',
	          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
	          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	          format: 'YYYY-MM-DD',
	          placeholder: '',
	          inputStyle: {
	            'display': 'inline-block',
	            'width': '120px',
	            'padding': '4px 6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'box-shadow': '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
	            'border-radius': '5px',
	            'color': 'rgb(95, 95, 95)'
	          },
	          color: {
	            header: '#00736a',
	            headerText: '#ffffff'
	          },
	          buttons: {
	            clear: '清空',
	            today: '今天',
	            ok: '确定',
	            cancel: '取消'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true }
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	        this.largeexchangechart = [];
	        this.largeexchangechartSored = [];
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.changeDateType(7);
	        this.datetype_name = '两年';
	        this.tableSort.jyrq = 1;
	        this.getLargeexChangeLists();
	        this.getLargeexchangeChart();
	      }
	    }
	  },
	  methods: {
	    reDrawChart: function reDrawChart(type) {
	      var newA = [];
	      var allDays = [];
	
	      if (type == '非全部') {
	        allDays = this.getAllDay(this.startdate, this.enddate);
	      } else if (type == '全部') {
	        var startdate = this.largeexchangechartSored[0].date;
	        var enddate = this.largeexchangechartSored[this.largeexchangechartSored.length - 1].date;
	        allDays = this.getAllDay(startdate, enddate);
	      }
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(allDays), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var d = _step.value;
	
	          if (this.dzjyOriginObj[d]) {
	            newA.push({ date: d, num: this.dzjyOriginObj[d] });
	          } else {
	            newA.push({ date: d, num: null });
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      var dataX = [];
	      var dataY = [];
	      if (type == '非全部') {
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(newA), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var item = _step2.value;
	
	            if (item.date >= this.startdate && item.date <= this.enddate) {
	              dataX.push(item.date);
	              dataY.push(item.num);
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        if (dataX[0] != this.startdate) {
	          dataX.unshift(this.startdate);
	          dataY.unshift(null);
	        }
	        if (dataX[dataX.length - 1] != this.enddate) {
	          dataX.push(this.enddate);
	          dataY.push(null);
	        }
	      } else if (type == '全部') {
	        var _iteratorNormalCompletion3 = true;
	        var _didIteratorError3 = false;
	        var _iteratorError3 = undefined;
	
	        try {
	          for (var _iterator3 = (0, _getIterator3.default)(newA), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	            var _item = _step3.value;
	
	            dataX.push(_item.date);
	            dataY.push(_item.num);
	          }
	        } catch (err) {
	          _didIteratorError3 = true;
	          _iteratorError3 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion3 && _iterator3.return) {
	              _iterator3.return();
	            }
	          } finally {
	            if (_didIteratorError3) {
	              throw _iteratorError3;
	            }
	          }
	        }
	      }
	
	      var that = this;
	      setTimeout(function () {
	        that.$nextTick(function () {
	          that.DzjyChart(dataX, dataY);
	        });
	      }, 2000);
	    },
	
	    getChartData: function getChartData(datas) {
	      if (!datas || datas.length == 0) {
	        return;
	      }
	
	      var lists = [];
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(datas), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var ls = _step4.value;
	
	          lists.push(ls);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      lists.sort(function (a, b) {
	        return Date.parse(a.date) - Date.parse(b.date);
	      });
	
	      var tmp = {};
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(lists), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var item = _step5.value;
	
	          if (!tmp[item.date]) {
	            tmp[item.date] = parseFloat(item.turnover);
	          } else {
	            for (var _key in tmp) {
	              if (_key == item.date) {
	                tmp[_key] = tmp[_key] + parseFloat(item.turnover);
	                break;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	
	      this.dzjyOriginObj = tmp;
	
	      var newA = [];
	      for (var key in tmp) {
	        newA.push({ date: key, num: tmp[key] });
	      }
	      this.largeexchangechartSored = newA;
	
	      this.$nextTick(function () {
	        this.reDrawChart('非全部');
	      });
	    },
	
	    DzjyChart: function DzjyChart(dataX, dataY) {
	      if ((0, _jquery2.default)('#dzjy-chart')) {
	        console.log('nononono');
	        (0, _jquery2.default)('#dzjy-chart').remove();
	        (0, _jquery2.default)('#dzjy-chart-wrap').append('<div id="dzjy-chart" style="width:100%;height:200px"></div>');
	      }
	
	      var img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	
	      var chart = document.getElementById('dzjy-chart');
	      if (!chart) {
	        console.log('!!!');
	        return false;
	      }
	
	      var option = {
	        title: {
	          text: '',
	          x: 'center' },
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross'
	          },
	          formatter: function formatter(datas) {
	            if (!datas[0].value) {
	              return;
	            } else {
	              var res = "<ul><li>" + datas[0].axisValue + '<li/>';
	              res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[0].color + "'></span>" + datas[0].seriesName + "：" + datas[0].value.toLocaleString('en-US') + "<li/>";
	              res += '</ul>';
	              return res;
	            }
	          }
	        },
	
	        grid: {
	          left: '4%',
	          right: '4%',
	          bottom: '4%',
	          top: '15%',
	          containLabel: true },
	        xAxis: {
	          type: 'category',
	          boundaryGap: false,
	          data: dataX,
	          axisTick: {
	            alignWithLabel: true
	          }
	        },
	        yAxis: {
	          type: 'value',
	          name: '交易总额(元)',
	          axisPointer: {
	            snap: true
	          }
	        },
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: -10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 180,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: '交易总额(元)',
	          type: 'line',
	          connectNulls: true,
	
	          data: dataY
	        }]
	      };
	
	      var myChart = _echarts2.default.init(chart);
	
	      myChart.setOption(option);
	    },
	
	    dzjyTableSort: function dzjyTableSort(type) {
	      var resource = this.largeexchangeLists;
	
	      this.tableSort.jyrq = 1;
	      resource.sort(function (a, b) {
	        return Date.parse(b.transaction_date) - Date.parse(a.transaction_date);
	      });
	
	      this.largeexchangeLists = resource;
	    },
	
	    dzjyTableSort2: function dzjyTableSort2(type) {
	      var resource = this.largeexchangeLists;
	
	      this.tableSort.jyrq = 1;
	
	      resource.sort(function (a, b) {
	        return Date.parse(b.transaction_date) - Date.parse(a.transaction_date);
	      });
	
	      this.largeexchangeLists = resource;
	    },
	
	    largeexchangeFilter: function largeexchangeFilter() {
	      var _this = this;
	
	      this.page = 1;
	
	      var query = {};
	      query.code = this.companycode;
	      query.page = this.page;
	      query.perPage = this.perPage;
	
	      if (this.datetype_name != '全部') {
	        query.startdate = _jquery2.default.trim(this.startdate);
	        query.enddate = _jquery2.default.trim(this.enddate);
	        this.reDrawChart('非全部');
	      } else {
	        this.reDrawChart('全部');
	      }
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/largeexchange'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.largeexchangeLists = response.lists;
	          _this.total = response.total;
	          _this.totalPage = Math.ceil(response.total / _this.perPage);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	
	      this.$nextTick(function () {
	        this.tableSort.jyrq = 1;
	        this.dzjyTableSort('transaction_date');
	      });
	    },
	
	    getLargeexChangeLists: function getLargeexChangeLists() {
	      var _this2 = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.page = this.page;
	      query.perPage = this.perPage;
	      if (this.datetype_name != '全部') {
	        query.startdate = _jquery2.default.trim(this.startdate);
	        query.enddate = _jquery2.default.trim(this.enddate);
	      }
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/largeexchange'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	          _this2.largeexchangeLists = response.lists;
	          _this2.total = response.total;
	          _this2.totalPage = Math.ceil(response.total / _this2.perPage);
	
	          var typ = '';
	          if (_this2.tableSort.jyrq === 1 || _this2.tableSort.jyrq === 2) {
	            typ = 'transaction_date';
	            if (_this2.tableSort.jyrq === 1) {
	              _this2.tableSort.jyrq = 2;
	            } else if (_this2.tableSort.jyrq === 2) {
	              _this2.tableSort.jyrq = 1;
	            }
	          } else if (_this2.tableSort.cjl === 1 || _this2.tableSort.cjl === 2) {
	            typ = 'volume';
	            if (_this2.tableSort.cjl === 1) {
	              _this2.tableSort.cjl = 2;
	            } else if (_this2.tableSort.cjl === 2) {
	              _this2.tableSort.cjl = 1;
	            }
	          } else if (_this2.tableSort.cje === 1 || _this2.tableSort.cje === 2) {
	            typ = 'turnover';
	            if (_this2.tableSort.cje === 1) {
	              _this2.tableSort.cje = 2;
	            } else if (_this2.tableSort.cje === 2) {
	              _this2.tableSort.cje = 1;
	            }
	          }
	          if (typ != '') {
	            _this2.dzjyTableSort2(typ);
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getLargeexchangeChart: function getLargeexchangeChart() {
	      var _this3 = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/largeexchangechart'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this3.loading = false;
	        if (response.status === 0) {
	          _this3.largeexchangechart = response.lists;
	          _this3.getChartData(response.lists);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this3.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    var _gbllb;
	
	    return {
	      reporting: true,
	      curDateType: '',
	      yearList: [],
	      finance: [],
	      llb: { '销售商品、提供劳务收到的现金(元)': 'sellingreceived', '收到其他与经营活动有关的现金(元)': 'otherrelatedreceived', '经营活动现金流入小计(元)': 'cashflowoperations', '购买商品、接受劳务支付的现金(元)': 'payincash', '支付给职工以及为职工支付的现金(元)': 'payworkercash', '支付的各项税费(元)': 'taxpayments', '支付其他与经营活动有关的现金(元)': 'payrelatedcash', '经营活动现金流出小计(元)': 'cashoutoperatingactivites', '经营活动产生的现金流量净额(元)': 'cashoperatingactivites', '处置固定资产、无形资产和其他长期资产收回的现金净额(元)': 'cashdisposeassets', '收到其他与投资活动有关的现金(元)': 'cashotherinvestment', '投资活动现金流入小计(元)': 'cashinflowinvestment', '购建固定资产、无形资产和其他长期资产支付的现金(元)': 'payforassets', '投资支付的现金(元)': 'payforinvestment', '取得子公司及其他营业单位支付的现金净额(元)': 'payforrelated', '投资活动现金流出小计(元)': 'cashoutflowinvestment', '投资活动产生的现金流量净额(元)': 'cashflowinvestment', '吸收投资收到的现金(元)': 'cashreceivedinvestors', '子公司吸收少数股东投资收到的现金(元)': 'cashreceivedinvestorssub', '取得借款收到的现金(元)': 'cashreceiveddebts', '收到其他与筹资活动有关的现金(元)': 'cashreceivedotherfinancing', '筹资活动现金流入小计(元)': 'cashinflowfinancing', '偿还债务支付的现金(元)': 'cashrepaymentsborrowed', '分配股利、利润或偿付利息支付的现金(元)': 'cashpaymentsinterests', '支付其他与筹资活动有关的现金(元)': 'payotherfinancing', '筹资活动现金流出小计(元)': 'cashoutflowfinancing', '筹资活动产生的现金流量净额(元)': 'cashflowfinancing', '汇率变动对现金及现金等价物的影响(元)': 'cashexchange', '现金及现金等价物净增加额(元)': 'cashadd', '期初现金及现金等价物余额(元)': 'cashlastbalance', '期末现金及现金等价物余额(元)': 'cashbalance', '净利润(元)': 'retainedprofits', '资产减值准备(元)': 'preparationimpairmentassets', '固定资产和投资性房地产折旧(元)': 'assetsdepreciationtotal', '固定资产折旧、油气资产折耗、生产性生物资产折旧(元)': 'assetsdepreciation', '无形资产摊销(元)': 'amortizationintangibleassets', '长期待摊费用摊销(元)': 'amortisationlongtermprepaidexpenses', '处置固定资产、无形资产和其他长期资产的损失(元)': 'disposalassetsloss', '财务费用(元)': 'financialcost', '投资损失(元)': 'investmentloss', '递延所得税(元)': 'deferredtaxassetstotal', '递延所得税资产减少(元)': 'deferredtaxassets', '存货的减少(元)': 'decreaseinventory', '经营性应收项目的减少(元)': 'decreasebusinessreceivables', '经营性应付项目的增加(元)': 'increasebusinesspay', '其他(元)': 'othercash', '现金的期末余额(元)': 'cashbalancetotal', '现金的期初余额(元)': 'cashlastbalancetotal', '现金及现金等价物的净增加额(元)': 'cashadd2' },
	      gbllb: (_gbllb = {
	        '投资活动产生的现金流量净额其他项目(元)': 'othercashinvestmentnet',
	        '经营活动产生的现金(元)': 'cashbusiness',
	        '出售物业、厂房及设备的亏损(收益)(元)': 'saleofequipment',
	        '预付款项、按金及其他应收款项减少(增加)(元)': 'otherreceivableschange',
	        '已付股息(融资)(元)': 'paiddividend',
	        '购买证券投资所支付的现金(元)': 'cashpaidsecuritiesinvestment',
	        '投资活动产生的现金流量净额(元)': 'cashinvestmentnet',
	        '融资活动产生的现金流量净额其他项目(元)': 'cashfinancingnet',
	        '已收利息及股息(投资)(元)': 'receivedinterestdividends',
	        '存货的减少(增加)(元)': 'inventorychange',
	        '折旧与摊销(元)': 'depreciationamortization',
	        '利息支出(元)': 'interestexpense',
	        '回购股份(元)': 'sharebuyback',
	        '经营活动产生的现金流量净额其他项目(元)': 'othercashoperatingnet',
	        '现金及现金等价物净增加额其他项目(元)': 'cashincreasenet',
	        '预收账款、按金及其他应付款增加(减少)(元)': 'otherpayablechange',
	        '偿还借款(元)': 'repaymentloan',
	        '已收利息(经营)(元)': 'receivedinterestbusiness',
	        '应付帐款增加(减少)(元)': 'payablechange',
	        '出售无形资产及其他资产收到的现金(元)': 'cashreceivedotherassets',
	        '现金及现金等价物的期末余额其他项目(元)': 'othercashbalanceending',
	        '吸收投资所得(元)': 'incomefrominvestment',
	        '购买子公司、联营企业及合营企业支付的现金(元)': 'cashpaidjointcompany'
	      }, (0, _defineProperty3.default)(_gbllb, '\u7ECF\u8425\u6D3B\u52A8\u4EA7\u751F\u7684\u73B0\u91D1\u6D41\u91CF\u51C0\u989D\u5176\u4ED6\u9879\u76EE(\u5143)', 'cashoperatingnet'), (0, _defineProperty3.default)(_gbllb, '\u878D\u8D44\u6D3B\u52A8\u4EA7\u751F\u7684\u73B0\u91D1\u6D41\u91CF\u51C0\u989D\u5176\u4ED6\u9879\u76EE(\u5143)', 'othercashfinancingnet'), (0, _defineProperty3.default)(_gbllb, '发行债券(元)', 'issuebonds'), (0, _defineProperty3.default)(_gbllb, '出售子公司、联营企业及合营企业收到的现金(元)', 'cashreceivedjointcompany'), (0, _defineProperty3.default)(_gbllb, '已付税项(元)', 'taxpaid'), (0, _defineProperty3.default)(_gbllb, '资产减值准备(元)', 'impairmentofassets'), (0, _defineProperty3.default)(_gbllb, '利息收入(元)', 'interestincome'), (0, _defineProperty3.default)(_gbllb, '除税前利润(元)', 'profitbeforetax'), (0, _defineProperty3.default)(_gbllb, '现金及现金等价物的期初余额(元)', 'cashbalanceinitial'), (0, _defineProperty3.default)(_gbllb, '发行费用(元)', 'distributionfee'), (0, _defineProperty3.default)(_gbllb, '发行股份(元)', 'issuedshares'), (0, _defineProperty3.default)(_gbllb, '\u73B0\u91D1\u53CA\u73B0\u91D1\u7B49\u4EF7\u7269\u51C0\u589E\u52A0\u989D\u5176\u4ED6\u9879\u76EE(\u5143)', 'othercashincreasenet'), (0, _defineProperty3.default)(_gbllb, '重估盈余(元)', 'revaluationearnings'), (0, _defineProperty3.default)(_gbllb, '应收帐款减少(增加)(元)', 'receivablechange'), (0, _defineProperty3.default)(_gbllb, '\u51FA\u552E\u7269\u4E1A\u3001\u5382\u623F\u53CA\u8BBE\u5907\u7684\u4E8F\u635F(\u6536\u76CA)(\u5143)', 'equipment'), (0, _defineProperty3.default)(_gbllb, '赎回/偿还债券(元)', 'redemptionbond'), (0, _defineProperty3.default)(_gbllb, '购买无形资产及其他资产支付的现金(元)', 'cashpaidotherassets'), (0, _defineProperty3.default)(_gbllb, '汇率变动对现金及现金等价物的影响(元)', 'casheffectsexchange'), (0, _defineProperty3.default)(_gbllb, '已付利息(融资)(元)', 'paidinterest'), (0, _defineProperty3.default)(_gbllb, '投资亏损(收益)(元)', 'investmentincome'), (0, _defineProperty3.default)(_gbllb, '经营资金变动其他项目(元)', 'otheroperatingchange'), (0, _defineProperty3.default)(_gbllb, '已付利息(经营)(元)', 'payedinterestbusiness'), (0, _defineProperty3.default)(_gbllb, '购买物业、厂房及设备支付的现金(元)', 'cashpaidequipment'), (0, _defineProperty3.default)(_gbllb, '应占联营及合营公司亏损(收益)(元)', 'jointcompanyincome'), (0, _defineProperty3.default)(_gbllb, '新增借款(元)', 'newloans'), (0, _defineProperty3.default)(_gbllb, '\u73B0\u91D1\u53CA\u73B0\u91D1\u7B49\u4EF7\u7269\u7684\u671F\u672B\u4F59\u989D\u5176\u4ED6\u9879\u76EE(\u5143)', 'cashbalanceending'), (0, _defineProperty3.default)(_gbllb, '出售证券投资所收到的现金(元)', 'cashreceivedsecuritiesinvestment'), (0, _defineProperty3.default)(_gbllb, '出售物业、厂房及设备收到的现金(元)', 'cashreceivedequipment'), _gbllb),
	      dataMap: { '年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31' }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (to.query.stype == 6) {
	        this.llb = this.gbllb;
	      }
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getFinance();
	      }
	    }
	  },
	  methods: {
	    getFinance: function getFinance() {
	      var _this = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/finance'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          if ((0, _keys2.default)(response.data).length) {
	
	            var arr = [];
	            for (var k in response.data) {
	              if (k.indexOf('年') >= 0) {
	                var n = k.substr(0, 4) + _this.dataMap[k.substr(4)];
	                arr.push([n, response.data[k]]);
	              } else {
	                arr.push([k, response.data[k]]);
	              }
	            }
	
	            arr.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	            if (arr.length > 6) {
	              for (var i = 0; i < 6; i++) {
	                _this.finance.push(arr[i]);
	              }
	            } else {
	              _this.finance = arr;
	            }
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _i = _step.value;
	
	                if (_i[0].indexOf('-12-') >= 0) {
	                  _this.yearList.push(_i);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            if (_this.yearList.length > 5) {
	              _this.yearList = _this.yearList.slice(0, 5);
	            }
	
	            _this.reporting = true;
	            _this.curDateType = _this.finance[0][0];
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      originData: [],
	      locationList: [],
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      beutifulData: '',
	      beutifulDate: [],
	      allDateTyp: [],
	      curDateTyp: 'ALL',
	      yysr_rows: 0,
	      yycb_rows: 0,
	      yylr_rows: 0,
	      showYysr: false,
	      showYycb: false,
	      showYylr: false
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getLocation();
	      }
	    }
	  },
	  filters: {
	    nullValue: function nullValue(param) {
	      if (!param || param == '') {
	        return '-';
	      } else {
	        return param;
	      }
	    }
	  },
	  watch: {
	    'locationList': function locationList(curVal, oldVal) {
	      this.showYysr = false;
	      this.showYycb = false;
	      this.showYylr = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.locationList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var h = _step.value;
	
	          if (h.yysr) {
	            this.showYysr = true;
	          }
	          if (h.yycb) {
	            this.showYycb = true;
	          }
	          if (h.yylr) {
	            this.showYylr = true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  },
	  methods: {
	    getLocation: function getLocation() {
	      var _this = this;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/mainlocationlist'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.locationList = response.data;
	          _this.originData = response.data;
	          _this.total = response.data.length;
	          _this.totalPage = Math.ceil(_this.total / _this.perPage);
	
	          _this.locationList.sort(function (a, b) {
	            return Date.parse(b.updtime) - Date.parse(a.updtime);
	          });
	
	          var tmp = {};
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_this.locationList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var h = _step2.value;
	
	              if (!tmp[h.reportdatestr]) {
	                tmp[h.reportdatestr] = true;
	                _this.allDateTyp.push(h.reportdatestr);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          _this.curDateTyp = _this.allDateTyp[0];
	          _this.filter();
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    filter: function filter() {
	
	      this.loading = true;
	
	      var arr = [];
	      var date = this.curDateTyp;
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.originData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var h = _step3.value;
	
	          if (h.reportdatestr === date) {
	            arr.push(h);
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.locationList = arr;
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    var _gblrb;
	
	    return {
	      reporting: true,
	      curDateType: '',
	      yearList: [],
	      finance: [],
	      lrb: { '营业总收入(元)': 'businessincometotal', '营业收入(元)': 'businessincome', '营业总成本(元)': 'operatingcoststotal', '营业成本(元)': 'operatingcosts', '营业税金及附加(元)': 'businesstax', '销售费用(元)': 'sellingexpenses', '管理费用(元)': 'handlingexpenses', '财务费用(元)': 'financingcosts', '资产减值损失(元)': 'assetimpairmentloss', '其他经营收益(元)': 'othercomprehensiveincome', '营业利润(元)': 'operatingprofit', '营业外收入(元)': 'nonbusinessincome', '营业外支出(元)': 'nonbusinessexpenditure', '利润总额(元)': 'totalprofits', '所得税(元)': 'incometax', '净利润(元)': 'retainedprofit', '归属于母公司股东的净利润(元)': 'retainedprofitowner', '每股收益(元)': 'earningpershare', '基本每股收益(元)': 'basicearningspershare', '稀释每股收益(元)': 'dilutedearningspershare', '综合收益总额(元)': 'totalcomprehensiveincome', '扣除非经常性损益后的净利润(元)': 'nonrecurrinlossprofit' },
	      gblrb: (_gblrb = {
	        '基本每股收益(元)': 'basiceps',
	        '其他收入(元)': 'otherincome',
	        '出售资产之溢利(元)': 'saleassetsprofit',
	        '重估盈余(元)': 'revaluationsurplus',
	        '应占联营公司溢利(元)': 'alliedcompanyprofit',
	        '影响税前利润的其他项目(元)': 'pretaxprofit',
	        '每股股息(元)': 'dividendsper',
	        '本公司拥有人应占净利润(元)': 'ownerretainedprofits',
	        '所得税(元)': 'incometax',
	        '毛利(计算)(元)': 'grossprofit',
	        '其他支出(元)': 'otherexpenses',
	        '稀释每股收益(元)': 'dilutedeps',
	        '折旧和摊销(元)': 'depreciationamortization',
	        '研发费用(元)': 'developmentfee',
	        '资产减值损失(元)': 'assetsimpairmentloss',
	        '营业收入(计算)(元)': 'businessincome',
	        '股息(元)': 'stockdividend',
	        '影响净利润的其他项目(元)': 'retainedprofits',
	        '销售成本(元)': 'costsales',
	        '非控股权益应占全面收益总额(元)': 'noncontrolcomprehensiveincome',
	        '经营溢利(计算)(元)': 'operatingprofit',
	        '员工薪酬(元)': 'compensation',
	        '销售及分销成本(元)': 'costsalesdistribution',
	        '非控股权益应占净利润(元)': 'noncontrolretainedprofits',
	        '应占合营公司溢利(元)': 'jointcompanyprofit',
	        '其他全面收益(元)': 'othercomprehensiveincome'
	      }, (0, _defineProperty3.default)(_gblrb, '\u5F71\u54CD\u7A0E\u524D\u5229\u6DA6\u7684\u5176\u4ED6\u9879\u76EE(\u5143)', 'otherpretaxprofit'), (0, _defineProperty3.default)(_gblrb, '\u5F71\u54CD\u51C0\u5229\u6DA6\u7684\u5176\u4ED6\u9879\u76EE(\u5143)', 'otherretainedprofits'), (0, _defineProperty3.default)(_gblrb, '\u5176\u4ED6\u5168\u9762\u6536\u76CA(\u5143)', 'comprehensiveincome'), (0, _defineProperty3.default)(_gblrb, '本公司拥有人应占全面收益总额(元)', 'ownercomprehensiveincome'), (0, _defineProperty3.default)(_gblrb, '财务成本(元)', 'financialcosts'), (0, _defineProperty3.default)(_gblrb, '行政开支(元)', 'administrativeexpenses'), _gblrb),
	      dataMap: { '年一季报': '-03-31', '年中报': '-06-30', '年三季报': '-09-30', '年年报': '-12-31' }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (to.query.stype == 6) {
	        this.lrb = this.gblrb;
	      }
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getFinance();
	      }
	    }
	  },
	  methods: {
	    getFinance: function getFinance() {
	      var _this = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/finance'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	
	          if ((0, _keys2.default)(response.data).length) {
	
	            var arr = [];
	            for (var k in response.data) {
	              if (k.indexOf('年') >= 0) {
	                var n = k.substr(0, 4) + _this.dataMap[k.substr(4)];
	                arr.push([n, response.data[k]]);
	              } else {
	                arr.push([k, response.data[k]]);
	              }
	            }
	
	            arr.sort(function (a, b) {
	              return parseInt(b[0].replace(/-/g, '')) - parseInt(a[0].replace(/-/g, ''));
	            });
	            if (arr.length > 6) {
	              for (var i = 0; i < 6; i++) {
	                _this.finance.push(arr[i]);
	              }
	            } else {
	              _this.finance = arr;
	            }
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var _i = _step.value;
	
	                if (_i[0].indexOf('-12-') >= 0) {
	                  _this.yearList.push(_i);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            if (_this.yearList.length > 5) {
	              _this.yearList = _this.yearList.slice(0, 5);
	            }
	
	            _this.reporting = true;
	            _this.curDateType = _this.finance[0][0];
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      hasPerExpess: false,
	      showPerExpress: false,
	      performanceNoticeLists: [],
	      perSort: {
	        type: '',
	        ksrq: 1,
	        jsrq: 1,
	        jllfd: 1,
	        bnjll: 1,
	        snjll: 1,
	        ggrq: 1
	      },
	      sort: '',
	      desc: ''
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getPerformanceNotice();
	      }
	    }
	  },
	  methods: {
	    sortPerformanceTable: function sortPerformanceTable(type) {
	      this.sort = type;
	
	      if (type == 'jllfd') {
	
	        if (this.desc != 2) {
	
	          this.desc = 2;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(b.jlrbdfd) - parseFloat(a.jlrbdfd);
	          });
	        } else {
	
	          this.desc = 1;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(a.jlrbdfd) - parseFloat(b.jlrbdfd);
	          });
	        }
	      } else if (type == 'bnjll') {
	
	        if (this.desc != 1) {
	
	          this.desc = 1;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(b.bntqjlr) - parseFloat(a.bntqjlr);
	          });
	        } else {
	
	          this.desc = 2;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(a.bntqjlr) - parseFloat(b.bntqjlr);
	          });
	        }
	        console.log(this.performanceNoticeLists);
	      } else if (type == 'snjll') {
	
	        if (this.desc != 1) {
	
	          this.desc = 1;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(b.sntqjlr) - parseFloat(a.sntqjlr);
	          });
	        } else {
	
	          this.desc = 2;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return parseFloat(a.sntqjlr) - parseFloat(b.sntqjlr);
	          });
	        }
	      } else if (type == 'ggrq') {
	
	        if (this.desc != 1) {
	
	          this.desc = 1;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return Date.parse(b.publishdate) - Date.parse(a.publishdate);
	          });
	        } else {
	
	          this.desc = 2;
	          this.performanceNoticeLists.sort(function (a, b) {
	            return Date.parse(a.publishdate) - Date.parse(b.publishdate);
	          });
	        }
	      }
	    },
	    noticeType: function noticeType(sdate, edate) {
	      if (!sdate || !edate) return;
	
	      if (edate.indexOf('-') != -1) {
	        var year = edate.split('-')[0] + '年';
	        var month = parseInt(edate.split('-')[1]);
	
	        if (month >= 3 && month < 6) {
	          return year + '一季报';
	        } else if (month >= 6 && month < 9) {
	          return year + '半年报';
	        } else if (month == 12) {
	          return year + '年报';
	        } else if (month >= 9 && month < 12) {
	          return year + '三季报';
	        }
	      }
	    },
	    getPerformanceNotice: function getPerformanceNotice() {
	      var _this = this;
	
	      this.hasPerExpess = false;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/performancenotice'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          var list = response.data;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var item = _step.value;
	
	              if (item.typ == 'express') {
	                _this.hasPerExpess = true;
	
	                item.jlrbdfd = 0;
	
	                item.sntqjlr = item.net_profit_last_year;
	
	                item.bntqjlr = item.retainedprofit;
	                if (item.retainedprofit && item.net_profit_last_year) {
	                  var jllfdreal = Math.round((item.retainedprofit - item.net_profit_last_year) / item.net_profit_last_year * 100, 2);
	                  if (item.retainedprofit - item.net_profit_last_year < 0 && jllfdreal > 0) {
	                    item.jllfdreal = -jllfdreal;
	                  } else if (item.retainedprofit - item.net_profit_last_year > 0 && jllfdreal < 0) {
	                    item.jllfdreal = -jllfdreal;
	                  } else {
	                    item.jllfdreal = jllfdreal;
	                  }
	                } else {
	                  item.jllfdreal = '';
	                }
	              } else if (item.typ == 'notice') {
	                if (item.year_on_year_change == '增长') {
	                  item.jlrbdfd = item.change_ratio_upper;
	                } else if (item.year_on_year_change == '下降') {
	                  item.jlrbdfd = item.change_ratio_lower;
	                } else {
	                  item.jlrbdfd = '-';
	                }
	                item.bntqjlr = item.retainedprofit;
	
	                item.sntqjlr = item.net_profit_last_year_income;
	                if (item.retainedprofit && item.net_profit_last_year_income) {
	                  var _jllfdreal = Math.round((item.retainedprofit - item.net_profit_last_year_income) / item.net_profit_last_year_income * 100, 2);
	                  if (item.retainedprofit - item.net_profit_last_year_income < 0 && _jllfdreal > 0) {
	                    item.jllfdreal = -_jllfdreal;
	                  } else if (item.retainedprofit - item.net_profit_last_year_income > 0 && _jllfdreal < 0) {
	                    item.jllfdreal = -_jllfdreal;
	                  } else {
	                    item.jllfdreal = _jllfdreal;
	                  }
	                } else {
	                  item.jllfdreal = '';
	                }
	              }
	
	              item.bglx = _this.noticeType(item.period_start, item.period_end);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this.performanceNoticeLists = list;
	
	          _this.$nextTick(function () {
	            this.sortPerformanceTable('ggrq');
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    openPerExpress: function openPerExpress() {
	      this.showPerExpress = this.showPerExpress ? false : true;
	      console.log(this.showPerExpress);
	    },
	    isShow: function isShow(num) {
	      if (!num) {
	        return 3;
	      }
	
	      num = parseFloat(num);
	      if (num === 0) {
	        return 3;
	      } else if (num > 0) {
	        return 1;
	      } else if (num < 0) {
	        return 2;
	      }
	    }
	  }
	};

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      originData: [],
	      productList: [],
	      page: 1,
	      perPage: 10,
	      total: 0,
	      totalPage: 0,
	      beutifulData: '',
	      beutifulDate: [],
	      allDateTyp: [],
	      curDateTyp: 'ALL',
	      yysr_rows: 0,
	      yycb_rows: 0,
	      yylr_rows: 0,
	      showYysr: false,
	      showYycb: false,
	      showYylr: false
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getProduct();
	      }
	    }
	  },
	  filters: {
	    nullValue: function nullValue(param) {
	      if (!param || param == '') {
	        return '-';
	      } else {
	        return param;
	      }
	    }
	  },
	  watch: {
	    'productList': function productList(curVal, oldVal) {
	      this.showYysr = false;
	      this.showYycb = false;
	      this.showYylr = false;
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(this.productList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var h = _step.value;
	
	          if (h.yysr) {
	            this.showYysr = true;
	          }
	          if (h.yycb) {
	            this.showYycb = true;
	          }
	          if (h.yylr) {
	            this.showYylr = true;
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  },
	  methods: {
	    getProduct: function getProduct() {
	      var _this = this;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/mainproductlist'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.productList = response.data;
	          _this.originData = response.data;
	          _this.total = response.data.length;
	          _this.totalPage = Math.ceil(_this.total / _this.perPage);
	
	          _this.productList.sort(function (a, b) {
	            return Date.parse(b.updtime) - Date.parse(a.updtime);
	          });
	
	          var tmp = {};
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(_this.productList), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var h = _step2.value;
	
	              if (!tmp[h.reportdatestr]) {
	                tmp[h.reportdatestr] = true;
	                _this.allDateTyp.push(h.reportdatestr);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          _this.curDateTyp = _this.allDateTyp[0];
	          _this.filter();
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    filter: function filter() {
	
	      this.loading = true;
	
	      var arr = [];
	      var date = this.curDateTyp;
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(this.originData), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var h = _step3.value;
	
	          if (h.reportdatestr === date) {
	            arr.push(h);
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      this.productList = arr;
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _datepicker = __webpack_require__(83);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _swiper = __webpack_require__(339);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	__webpack_require__(230);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  components: {
	    'date-picker': _datepicker2.default
	  },
	  data: function data() {
	    return {
	      sharesChangeOriginData: [],
	      sharesChangeLists: [],
	      page: 1,
	      perPage: 10,
	      totalPage: 0,
	      sharesSort: {
	        addtime: 0 },
	      sortedOriginDatas: '',
	      datepicker: {
	        option: {
	          type: 'day',
	          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
	          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	          format: 'YYYY-MM-DD',
	          placeholder: '',
	          inputStyle: {
	            'display': 'inline-block',
	            'width': '120px',
	            'padding': '4px 6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'box-shadow': '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
	            'border-radius': '5px',
	            'color': 'rgb(95, 95, 95)'
	          },
	          color: {
	            header: '#00736a',
	            headerText: '#ffffff'
	          },
	          buttons: {
	            clear: '清空',
	            today: '今天',
	            ok: '确定',
	            cancel: '取消'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true }
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.changeDateType(7);
	        this.datetype_name = '两年';
	        this.page = 1;
	        this.getSharesChangeList();
	      }
	    }
	  },
	  ready: function ready() {
	    var that = this;
	    this.$nextTick(function () {
	
	      var num = 0;
	      var timer = setInterval(function () {
	        num += 3000;
	
	        if (that.sharesChangeLists.length > 0 && num > 10000) {
	          var mySwiper = new _swiper2.default('.swiper-container', {
	            pagination: {
	              el: '.swiper-pagination',
	              type: 'fraction'
	            }
	
	          });
	
	          clearInterval(timer);
	        }
	      }, 3000);
	    });
	  },
	
	  filters: {
	    formatStockTyp: function formatStockTyp(param) {
	      if (param == 'szse') {
	        return '深交所';
	      } else if (param == 'shse') {
	        return '上交所';
	      } else {
	        return param;
	      }
	    }
	  },
	  methods: {
	    getSharesChangeList: function getSharesChangeList() {
	      var _this = this;
	
	      var query = {};
	      query.code = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/shareschange'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	
	        if (response.status === 0) {
	          _this.sharesChangeLists = response.lists;
	          _this.sharesChangeOriginData = response.lists;
	
	
	          var resource = response.lists;
	          resource.sort(function (a, b) {
	            return Date.parse(a.change_date) - Date.parse(b.change_date);
	          });
	          _this.sortedOriginDatas = resource;
	
	          _this.sharesChangeFilter();
	          _this.$nextTick(function () {
	            this.sharesTableSort('addtime');
	          });
	          _this.loading = false;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    sharesChangeFilter: function sharesChangeFilter() {
	      if (this.sharesChangeOriginData.length == 0) {
	        return;
	      }
	
	      this.loading = true;
	      this.page = 1;
	      var startdate = this.startdate;
	      var enddate = this.enddate;
	
	      if (startdate && enddate) {
	        var newArr = [];
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.sharesChangeOriginData), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var h = _step.value;
	
	            if (h.change_date >= startdate && h.change_date <= enddate) {
	              newArr.push(h);
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	
	        this.sharesChangeLists = newArr;
	      } else {
	        this.sharesChangeLists = this.sharesChangeOriginData;
	      }
	
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	
	      this.$nextTick(function () {
	        this.getSharesChartData();
	        if (this.sharesSort.addtime != 0) {
	          this.sharesSort.addtime = this.sharesSort.addtime == 1 ? 2 : 1;
	          this.sharesTableSort('addtime');
	        }
	      });
	    },
	
	    sharesTableSort: function sharesTableSort(type) {
	      (0, _jquery2.default)('td.col').removeClass('col');
	      var resource = this.sharesChangeLists;
	      if (resource.length == 0) {
	        return;
	      }
	
	      if (type == 'addtime') {
	        if (this.sharesSort.addtime == 0 || this.sharesSort.addtime == 2) {
	          this.sharesSort.addtime = 1;
	          resource.sort(function (a, b) {
	            return Date.parse(b.change_date) - Date.parse(a.change_date);
	          });
	        } else if (this.sharesSort.addtime == 1) {
	          this.sharesSort.addtime = 2;
	          resource.reverse();
	        }
	      }
	
	      this.sharesChangeLists = resource;
	    },
	    getSharesChartData: function getSharesChartData() {
	      var resource = this.sortedOriginDatas;
	      var tmp = {};
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(resource), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var d = _step2.value;
	
	          if (!tmp[d.change_date]) {
	            tmp[d.change_date] = parseFloat(d.change_the_number_of_shares);
	          } else {
	            tmp[d.change_date] += parseFloat(d.change_the_number_of_shares);
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	
	      var startdate = this.startdate;
	      var enddate = this.enddate;
	      var allDays = [];
	      var newA = [];
	      if (startdate && enddate) {
	        allDays = this.getAllDay(startdate, enddate);
	      } else {
	        startdate = resource[0].change_date;
	        enddate = resource[resource.length - 1].change_date;
	        allDays = this.getAllDay(startdate, enddate);
	      }
	
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(allDays), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var key = _step3.value;
	
	          if (tmp[key]) {
	            newA.push({ date: key, value: tmp[key] });
	          } else {
	            newA.push({ date: key, value: null });
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	
	      var dataX = [];
	      var dataY = [];
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(newA), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var item = _step4.value;
	
	          dataX.push(item.date);
	          dataY.push(item.value);
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	
	      this.drawSharesChart(dataX, dataY);
	    },
	    drawSharesChart: function drawSharesChart(dataX, dataY) {
	      if ((0, _jquery2.default)('#gqbd-chart')) {
	        (0, _jquery2.default)('#gqbd-chart').remove();
	        (0, _jquery2.default)('#gqbd-chart-wrap').append('<div id="gqbd-chart" style="width:100%;height:180px"></div>');
	      }
	
	      var img_shuiyin = window.location.origin + '/static/images/analyze_shuiyin2.png';
	
	      var chart = document.getElementById('gqbd-chart');
	      if (!chart) {
	        return false;
	      }
	
	      var option = {
	        title: {
	          text: '',
	          x: 'center' },
	        tooltip: {
	          trigger: 'axis',
	          axisPointer: {
	            type: 'cross'
	          },
	          formatter: function formatter(datas) {
	            if (!datas[0].value) {
	              return;
	            } else {
	              var res = "<ul><li>" + datas[0].axisValue + '<li/>';
	              res += "<li style='list-style-type:none;'><span style='display:inline-block;width:9px;height:9px;margin-right:6px;border-radius: 50%;background-color:" + datas[0].color + "'></span>" + datas[0].seriesName + "：" + datas[0].value.toLocaleString('en-US') + "<li/>";
	              res += '</ul>';
	
	              return res;
	            }
	          }
	        },
	
	        grid: {
	          left: '4%',
	          right: '4%',
	          bottom: '4%',
	          top: '15%',
	          containLabel: true },
	        xAxis: {
	          type: 'category',
	          boundaryGap: false,
	          data: dataX,
	          axisTick: {
	            alignWithLabel: true
	          }
	        },
	        yAxis: {
	          type: 'value',
	          name: '变动股数(股)',
	          axisPointer: {
	            snap: true
	          }
	        },
	        graphic: [{
	          type: 'image',
	          left: 0,
	          top: -10,
	          z: -10,
	          bounding: 'raw',
	          origin: [75, 75],
	          style: {
	            image: img_shuiyin,
	            width: 350,
	            height: 150,
	            opacity: 0.4
	          }
	        }],
	        series: [{
	          name: '变动股数',
	          type: 'line',
	          connectNulls: true,
	          data: dataY
	        }]
	      };
	
	      var myChart = _echarts2.default.init(chart);
	
	      myChart.setOption(option);
	    }
	  }
	};

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'StockTop',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      dragonTigerLists: [],
	      dragSort: {
	        jyrq: 0,
	        cjj: 0,
	        spj: 0,
	        drzdf: 0,
	        cje: 0,
	        cjl: 0
	      },
	      buyTop5: [],
	      sellTop5: [],
	      showTopRow: '' };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.dragonTigerLists = [];
	        this.buyTop5 = [];
	        this.sellTop5 = [];
	
	        this.setSelectedTab();
	        this.changeDateType(7);
	        this.datetype_name = '两年';
	        this.getDragonTigerData();
	      }
	    }
	  },
	  methods: {
	    getDragonTigerData: function getDragonTigerData() {
	      var _this2 = this;
	
	      this.showTopRow = '';
	
	      var query = {};
	      query.companycode = this.companycode;
	      for (var key in this.dragSort) {
	        this.dragSort[key] = 0;
	      }
	
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	      this.loading = true;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/stocktops'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	
	          var resource = response.data;
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(resource), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var item = _step.value;
	
	              if (parseInt(item.quantity) !== 0) {
	                item.cjj = item.summoney / item.quantity;
	              } else {
	                item.cjj = null;
	              }
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          _this2.dragonTigerLists = resource;
	
	          _this2.$nextTick(function () {
	            this.sortDragonTigerTable('date');
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    sortDragonTigerTable: function sortDragonTigerTable(type) {
	      if (!type) {
	        return;
	      }
	
	      if (this.showTopRow != '') {
	        (0, _jquery2.default)('.top5-detail-' + this.showTopRow).hide();
	      }
	
	      var _this = this;
	      function changeIcon(key) {
	        for (var k in _this.dragSort) {
	          if (k == key) {
	            if (_this.dragSort[k] == 1) {
	              _this.dragSort[k] = 2;
	            } else {
	              _this.dragSort[k] = 1;
	            }
	          } else {
	            _this.dragSort[k] = 0;
	          }
	        }
	      }
	
	      var resource = this.dragonTigerLists;
	
	      if (type == 'date') {
	        if (this.dragSort.jyrq == 0 || this.dragSort.jyrq == 2) {
	          changeIcon('jyrq');
	          resource.sort(function (a, b) {
	            return Date.parse(b.date) - Date.parse(a.date);
	          });
	        } else if (this.dragSort.jyrq == 1) {
	          changeIcon('jyrq');
	          resource.sort(function (a, b) {
	            return Date.parse(a.date) - Date.parse(b.date);
	          });
	        }
	      }
	
	      if (type == 'cjj') {
	        if (this.dragSort.cjj == 0 || this.dragSort.cjj == 2) {
	          changeIcon('cjj');
	          resource.sort(function (a, b) {
	            return parseFloat(b.cjj) - parseFloat(a.cjj);
	          });
	        } else if (this.dragSort.cjj == 1) {
	          changeIcon('cjj');
	          resource.sort(function (a, b) {
	            return parseFloat(a.cjj) - parseFloat(b.cjj);
	          });
	        }
	      }
	
	      if (type == 'ratio') {
	        if (this.dragSort.drzdf == 0 || this.dragSort.drzdf == 2) {
	          changeIcon('drzdf');
	          resource.sort(function (a, b) {
	            return parseFloat(b.ratio) - parseFloat(a.ratio);
	          });
	        } else if (this.dragSort.drzdf == 1) {
	          changeIcon('drzdf');
	          resource.sort(function (a, b) {
	            return parseFloat(a.ratio) - parseFloat(b.ratio);
	          });
	        }
	      }
	
	      if (type == 'quantity') {
	        if (this.dragSort.cjl == 0 || this.dragSort.cjl == 2) {
	
	          changeIcon('cjl');
	          resource.sort(function (a, b) {
	            return parseFloat(b.quantity) - parseFloat(a.quantity);
	          });
	        } else if (this.dragSort.cjl == 1) {
	
	          changeIcon('cjl');
	          resource.sort(function (a, b) {
	            return parseFloat(a.quantity) - parseFloat(b.quantity);
	          });
	        }
	      }
	
	      if (type == 'summoney') {
	        if (this.dragSort.cje == 0 || this.dragSort.cje == 2) {
	
	          changeIcon('cje');
	          resource.sort(function (a, b) {
	            return parseFloat(b.summoney) - parseFloat(a.summoney);
	          });
	        } else if (this.dragSort.cje == 1) {
	
	          changeIcon('cje');
	          resource.sort(function (a, b) {
	            return parseFloat(a.summoney) - parseFloat(b.summoney);
	          });
	        }
	      }
	      this.dragonTigerLists = resource;
	
	      if (type == 'date') {
	        this.$nextTick(function () {
	          (0, _jquery2.default)('td.col').removeClass('col');
	          (0, _jquery2.default)('td.date').addClass('col');
	        });
	      }
	
	      if (type == 'cjj') {
	        this.$nextTick(function () {
	          (0, _jquery2.default)('td.col').removeClass('col');
	          (0, _jquery2.default)('td.cjj').addClass('col');
	        });
	      }
	      if (type == 'ratio') {
	        this.$nextTick(function () {
	          (0, _jquery2.default)('td.col').removeClass('col');
	          (0, _jquery2.default)('td.ratio').addClass('col');
	        });
	      }
	
	      if (type == 'quantity') {
	        this.$nextTick(function () {
	          (0, _jquery2.default)('td.col').removeClass('col');
	          (0, _jquery2.default)('td.quantity').addClass('col');
	        });
	      }
	
	      if (type == 'summoney') {
	        this.$nextTick(function () {
	          (0, _jquery2.default)('td.col').removeClass('col');
	          (0, _jquery2.default)('td.summoney').addClass('col');
	        });
	      }
	
	      this.$nextTick(function () {
	        if (this.showTopRow != '') {
	          (0, _jquery2.default)('.top5-detail-' + this.showTopRow).show();
	        }
	      });
	    },
	    isShow: function isShow(num) {
	      if (!num) {
	        return 3;
	      }
	
	      num = parseFloat(num);
	      if (num === 0) {
	        return 3;
	      } else if (num > 0) {
	        return 1;
	      } else if (num < 0) {
	        return 2;
	      }
	    },
	    viewStockTop2: function viewStockTop2(date, reason, index) {
	      var _this3 = this;
	
	      if (!date) {
	        return;
	      }
	
	      this.buyTop5 = [];
	      this.sellTop5 = [];
	      this.showTopRow = index;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.date = date;
	      query.reason = reason;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/stocktoptop5'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this3.loading = false;
	        if (response.status === 0) {
	          var resource = response.data;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(resource), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var item = _step2.value;
	
	              if (item.isbuytop5) {
	                item.jmr = item.buy - item.sell;
	                _this3.buyTop5.push(item);
	              }
	              if (item.isselltop5) {
	                item.jmr = item.buy - item.sell;
	                _this3.sellTop5.push(item);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          _this3.$nextTick(function () {
	            (0, _jquery2.default)('.top5-detail').hide();
	            (0, _jquery2.default)('.top5-detail-' + index).show();
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this3.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    hideStockTop: function hideStockTop(index) {
	      (0, _jquery2.default)('.top5-detail-' + index).hide();
	      this.showTopRow = '';
	    },
	    hideFundTop5: function hideFundTop5(e) {
	      var _con = (0, _jquery2.default)('.interval-main');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.showTopFive = false;
	      }
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'InvestView',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      supplierList: [],
	      supplierListFilter: [],
	      supplierPerPage: 10,
	      supplierTotalPage: 0,
	      curSupplierDate: '',
	      allSupplierDate: [],
	      supplierSort: {
	        cge: 0,
	        cgzb: 0,
	        pm: 0
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.getSupplier();
	      }
	    }
	  },
	  methods: {
	    getSupplier: function getSupplier() {
	      var _this2 = this;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/supplierlist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this2.loading = false;
	        if (response.status === 0) {
	          _this2.supplierList = response.data;
	          _this2.supplierListFilter = response.data;
	          _this2.supplierTotalPage = Math.ceil(response.data.length / _this2.supplierPerPage);
	
	          if (response.data.length > 0) {
	            var tmp = {};
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(_this2.supplierListFilter), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var h = _step.value;
	
	                if (!tmp[h.reportdatestr]) {
	                  tmp[h.reportdatestr] = true;
	                  _this2.allSupplierDate.push(h.reportdatestr);
	                }
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            _this2.curSupplierDate = _this2.allSupplierDate[0];
	            _this2.supplierFilter();
	            _this2.sortSupplier('money');
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this2.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    supplierFilter: function supplierFilter() {
	      if (this.supplierListFilter.length == 0) {
	        return;
	      }
	
	      this.loading = true;
	      if (this.curSupplierDate && this.curSupplierDate != '') {
	        var newArr = [];
	        var _iteratorNormalCompletion2 = true;
	        var _didIteratorError2 = false;
	        var _iteratorError2 = undefined;
	
	        try {
	          for (var _iterator2 = (0, _getIterator3.default)(this.supplierListFilter), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	            var h = _step2.value;
	
	            if (this.curSupplierDate == h.reportdatestr) {
	              newArr.push(h);
	            }
	          }
	        } catch (err) {
	          _didIteratorError2 = true;
	          _iteratorError2 = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion2 && _iterator2.return) {
	              _iterator2.return();
	            }
	          } finally {
	            if (_didIteratorError2) {
	              throw _iteratorError2;
	            }
	          }
	        }
	
	        this.supplierList = newArr;
	      }
	
	      if (this.supplierSort.cge == 1) {
	        this.supplierSort.cge = 2;
	        this.sortSupplier('money');
	      } else if (this.supplierSort.cge == 2) {
	        this.supplierSort.cge = 1;
	        this.sortSupplier('money');
	      }
	
	      if (this.supplierSort.cgzb == 1) {
	        this.supplierSort.cgzb = 2;
	        this.sortSupplier('ratio');
	      } else if (this.supplierSort.cgzb == 2) {
	        this.supplierSort.cgzb = 1;
	        this.sortSupplier('ratio');
	      }
	
	      if (this.supplierSort.pm == 1) {
	        this.supplierSort.pm = 2;
	        this.sortSupplier('rank');
	      } else if (this.supplierSort.pm == 2) {
	        this.supplierSort.pm = 1;
	        this.sortSupplier('rank');
	      }
	
	      var that = this;
	      setTimeout(function () {
	        that.loading = false;
	      }, 500);
	    },
	    sortSupplier: function sortSupplier(type) {
	      if (!type) {
	        return;
	      }
	
	      var _this = this;
	      function changeIcon(key) {
	        for (var k in _this.supplierSort) {
	          if (k == key) {
	            if (_this.supplierSort[k] == 1) {
	              _this.supplierSort[k] = 2;
	            } else {
	              _this.supplierSort[k] = 1;
	            }
	          } else {
	            _this.supplierSort[k] = 0;
	          }
	        }
	      }
	
	      var resource = this.supplierList;
	
	      if (type == 'money') {
	        if (this.supplierSort.cge == 0 || this.supplierSort.cge == 2) {
	          changeIcon('cge');
	          resource.sort(function (a, b) {
	            return parseFloat(b.money) - parseFloat(a.money);
	          });
	        } else if (this.supplierSort.cge == 1) {
	          changeIcon('cge');
	          resource.sort(function (a, b) {
	            return parseFloat(a.money) - parseFloat(b.money);
	          });
	        }
	      }
	
	      if (type == 'ratio') {
	        if (this.supplierSort.cgzb == 0 || this.supplierSort.cgzb == 2) {
	          changeIcon('cgzb');
	          resource.sort(function (a, b) {
	            return parseFloat(b.ratio) - parseFloat(a.ratio);
	          });
	        } else if (this.supplierSort.cgzb == 1) {
	          changeIcon('cgzb');
	          resource.sort(function (a, b) {
	            return parseFloat(a.ratio) - parseFloat(b.ratio);
	          });
	        }
	      }
	
	      if (type == 'rank') {
	        if (this.supplierSort.pm == 0 || this.supplierSort.pm == 2) {
	          changeIcon('pm');
	          resource.sort(function (a, b) {
	            return parseFloat(b.rank) - parseFloat(a.rank);
	          });
	        } else if (this.supplierSort.pm == 1) {
	          changeIcon('pm');
	          resource.sort(function (a, b) {
	            return parseFloat(a.rank) - parseFloat(b.rank);
	          });
	        }
	      }
	      this.supplierList = resource;
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _searchMix = __webpack_require__(20);
	
	var _searchMix2 = _interopRequireDefault(_searchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _companyMix = __webpack_require__(18);
	
	var _companyMix2 = _interopRequireDefault(_companyMix);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _datepicker = __webpack_require__(83);
	
	var _datepicker2 = _interopRequireDefault(_datepicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'StockTop',
	  mixins: [_userMix2.default, _searchMix2.default, _comSearchMix2.default, _companyMix2.default, _echartMix2.default, _wxshareMix2.default],
	  components: {
	    'date-picker': _datepicker2.default
	  },
	  data: function data() {
	    return {
	      quotesChangeLists: [],
	      performanceNoticeLists: [],
	      perSort: {
	        type: '',
	        ksrq: 1,
	        jsrq: 1,
	        jllfd: 1,
	        bnjll: 1,
	        snjll: 1,
	        ggrq: 1
	      },
	      datepicker: {
	        option: {
	          type: 'day',
	          week: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
	          month: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
	          format: 'YYYY-MM-DD',
	          placeholder: '',
	          inputStyle: {
	            'display': 'inline-block',
	            'width': '120px',
	            'padding': '4px 6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'box-shadow': '0px 1px 3px 0px rgba(0, 0, 0, 0.2)',
	            'border-radius': '5px',
	            'color': 'rgb(95, 95, 95)'
	          },
	          color: {
	            header: '#00736a',
	            headerText: '#ffffff'
	          },
	          buttons: {
	            clear: '清空',
	            today: '今天',
	            ok: '确定',
	            cancel: '取消'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true }
	      }
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	
	      if (this.currentuser) {
	        this.queryParam = to.query;
	        this.companycode = to.query.companycode;
	        this.stype = to.query.stype;
	
	        var title = decodeURIComponent(to.query.desc);
	        var desc = '你的朋友' + this.currentuser.username + '通过IBDATA给你分享了一份他的独家数据！';
	        document.title = title;
	        this.getwxsign();
	        this.shareCompany(title, desc);
	
	        this.setSelectedTab();
	        this.changeDateType(7);
	        this.datetype_name = '两年';
	        this.getQuotesChangeList();
	      }
	    }
	  },
	  methods: {
	    getQuotesChangeList: function getQuotesChangeList() {
	      var _this = this;
	
	      var query = {};
	      query.companycode = this.companycode;
	      query.stype = parseInt(this.stype);
	      query.startdate = this.startdate;
	      query.enddate = this.enddate;
	      query.uid = parseInt(this.queryParam.uid);
	      query.ruid = parseInt(this.queryParam.ruid);
	      query.share = this.queryParam.share;
	      query.plat = this.queryParam.plat;
	      query.sid = this.queryParam.sid;
	
	      this.loading = true;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/company/historicalquotes'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	
	        _this.loading = false;
	        if (response.status === 0) {
	          _this.quotesChangeLists = response.data;
	
	          if (response.data.length > 0) {
	            var data = response.data;
	            var newD = [];
	            var arr = [];
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var item = _step.value;
	
	                arr = [];
	                arr.push(item.d);
	                arr.push(item.open);
	                arr.push(item.close);
	                arr.push(item.low);
	                arr.push(item.high);
	                arr.push(item.volume);
	
	                newD.push(arr);
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            var divClass = '.gujia-chart-wrap';
	            var canvasClass = '.gujia-chart';
	            _this.echartKLine(newD, divClass, canvasClass);
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    showDateDropmemu: function showDateDropmemu() {
	      this.dateDropmenu = this.dateDropmenu ? false : true;
	    },
	    clickDropmenu: function clickDropmenu() {
	      this.dateDropmenu = false;
	    }
	  }
	};

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _keys = __webpack_require__(31);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _defineProperty2 = __webpack_require__(60);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _helper = __webpack_require__(7);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _echarts = __webpack_require__(33);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _echartMix = __webpack_require__(42);
	
	var _echartMix2 = _interopRequireDefault(_echartMix);
	
	var _swiper = __webpack_require__(339);
	
	var _swiper2 = _interopRequireDefault(_swiper);
	
	__webpack_require__(230);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'StockPledgeView',
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default, _echartMix2.default],
	  data: function data() {
	    var _ref;
	
	    return _ref = {
	      loading: false,
	      underlyingSecur: null,
	      intoPerson: '',
	      company: null,
	      pledgeePerson: '',
	      pledge: null,
	      pledgor: null,
	      stock: null,
	      yearlist: [],
	      businessincome: [],
	      yysrtbzzl: [],
	      retainedprofitowner: [],
	      gmjlrtbzzl: [],
	      companyNoticeInfo: {},
	      pledgorNoticeInfo: {},
	      showcompany: false,
	      showpledgor: false,
	      morelists: [],
	      publicunit: ['元', '%'],
	      plateMap: { 'SZCYB': '深市创业板', 'SZZB': '深市主板', 'SZZXB': '深市中小板', 'SHZB': '上证主板' },
	      lastDate: { 'date': null, 'value': null, 'ratio': null }
	    }, (0, _defineProperty3.default)(_ref, 'loading', false), (0, _defineProperty3.default)(_ref, 'suggestion', []), (0, _defineProperty3.default)(_ref, 'oldsuggestValue', ''), (0, _defineProperty3.default)(_ref, 'history_pledge', []), (0, _defineProperty3.default)(_ref, 'history_lifted', []), (0, _defineProperty3.default)(_ref, 'history_extension', []), (0, _defineProperty3.default)(_ref, 'historySort', {
	      pledge: {
	        st: 0,
	        et: 0,
	        zqr: 0
	      },
	
	      lifted: {
	        st: 0,
	        et: 0,
	        zqr: 0
	      },
	
	      extension: {
	        st: 0,
	        et: 0,
	        zqr: 0
	      }
	    }), (0, _defineProperty3.default)(_ref, 'rate_company', {
	      dataX: [],
	      dataY: []
	    }), (0, _defineProperty3.default)(_ref, 'rate_szse', {
	      dataX: [],
	      dataY: [],
	      dataY2: [],
	      legend: []
	    }), (0, _defineProperty3.default)(_ref, 'rate_shse', {
	      dataX: [],
	      dataY: [],
	      dataY2: [],
	      legend: []
	    }), (0, _defineProperty3.default)(_ref, 'curRateChart', ''), (0, _defineProperty3.default)(_ref, 'mergePledge', []), (0, _defineProperty3.default)(_ref, 'mergePledgeToFiler', []), (0, _defineProperty3.default)(_ref, 'relationsData', []), (0, _defineProperty3.default)(_ref, 'mergePledge_date_typ', 'ALL'), (0, _defineProperty3.default)(_ref, 'originDataByZQR', []), (0, _defineProperty3.default)(_ref, 'originDataByGDMC', []), (0, _defineProperty3.default)(_ref, 'pledge_viewall', false), (0, _defineProperty3.default)(_ref, 'showMergePledgeNum', 5), (0, _defineProperty3.default)(_ref, 'pledge_type', 'ALL'), (0, _defineProperty3.default)(_ref, 'pledgee_type', 'ALL'), (0, _defineProperty3.default)(_ref, 'intoPerson_type', 'ALL'), (0, _defineProperty3.default)(_ref, 'pledgeTypeList', {
	      'ALL': '全  部',
	      'dqrrf': '当前融入方信息',
	      'zyqn': '质押期内信息'
	    }), (0, _defineProperty3.default)(_ref, 'pledgeInfoDropdown', false), (0, _defineProperty3.default)(_ref, 'date_typ', 'ALL'), (0, _defineProperty3.default)(_ref, 'pledgee_date_typ', 'ALL'), (0, _defineProperty3.default)(_ref, 'intoPerson_date_typ', 'ALL'), (0, _defineProperty3.default)(_ref, 'dateTypList', {
	      'ALL': '全 部',
	      'onemonth': '一个月',
	      'threemonth': '三个月',
	      'halfyear': '半年',
	      'oneyear': '一年',
	      'twoyear': '两年',
	      'threeyear': '三年',
	      'fiveyear': '五年',
	      'tenyear': '十年'
	    }), (0, _defineProperty3.default)(_ref, 'showDateDropdown', false), (0, _defineProperty3.default)(_ref, 'pageInfo', {}), (0, _defineProperty3.default)(_ref, 'page', 1), (0, _defineProperty3.default)(_ref, 'perPage', 5), (0, _defineProperty3.default)(_ref, 'total', 0), (0, _defineProperty3.default)(_ref, 'relationnotice', []), (0, _defineProperty3.default)(_ref, 'tab', 1), (0, _defineProperty3.default)(_ref, 'tab1', ''), (0, _defineProperty3.default)(_ref, 'tooltip_pledges', []), (0, _defineProperty3.default)(_ref, 'showTooltipDetail', false), (0, _defineProperty3.default)(_ref, 'financing', {
	      list: [],
	      page: 1,
	      perPage: 5,
	      total: 0,
	      edit: {
	        id: '',
	        company_shortname: '',
	        companycode: '',
	        name_of_shareholder: '',
	        timelimit: '',
	        timelimit_unit: '月',
	        nature: '流通',
	        pledgee_nums: '',
	        restriction_end_date: '',
	        pledgee_ratio: '',
	        financing_amount: '',
	        use: '',
	        repayment_source: '',
	        status: '',
	        stockprice: '' }
	    }), (0, _defineProperty3.default)(_ref, 'sharePriceDropdown', ''), (0, _defineProperty3.default)(_ref, 'dropdown_menu_status', false), (0, _defineProperty3.default)(_ref, 'dropdown_menu_timelimit', false), (0, _defineProperty3.default)(_ref, 'dropdown_menu_list_status', false), (0, _defineProperty3.default)(_ref, 'sharelink', ''), (0, _defineProperty3.default)(_ref, 'curShareId', ''), (0, _defineProperty3.default)(_ref, 'qrcodeBoxID', ''), (0, _defineProperty3.default)(_ref, 'qrcodeID', ''), (0, _defineProperty3.default)(_ref, 'ts', ''), (0, _defineProperty3.default)(_ref, 'suggestDropdownMenu', 0), (0, _defineProperty3.default)(_ref, 'fullscreen', false), (0, _defineProperty3.default)(_ref, 'showUseSuggestionMenu', false), (0, _defineProperty3.default)(_ref, 'cumulative_pledge', []), (0, _defineProperty3.default)(_ref, 'cumPledge_page', 1), (0, _defineProperty3.default)(_ref, 'cumPledge_perPage', 5), (0, _defineProperty3.default)(_ref, 'cumPledge_total', 0), (0, _defineProperty3.default)(_ref, 'cumPledge_totalPage', 0), (0, _defineProperty3.default)(_ref, 'cumpledge_postData', {}), (0, _defineProperty3.default)(_ref, 'cumPledge_echart', {}), (0, _defineProperty3.default)(_ref, 'relationNotice', {
	      lists: [],
	      page: 1,
	      perPage: 5,
	      total: 0,
	      pageTotal: 0,
	      companycode: '',
	      pageInfo: {}
	    }), (0, _defineProperty3.default)(_ref, 'pledgeePaging', {
	      currentpage: 1,
	      totalPage: 0,
	      allpage: []
	    }), (0, _defineProperty3.default)(_ref, 'tipGoBind', false), (0, _defineProperty3.default)(_ref, 'viewMore', {
	      show: false,
	      lists: []
	    }), _ref;
	  },
	  ready: function ready() {
	    (0, _jquery2.default)('.cheight').css('min-height', (0, _jquery2.default)(window).height() - 200);
	    (0, _jquery2.default)('.more-wrapper').css('height', (0, _jquery2.default)(window).height());
	    (0, _jquery2.default)('.more-wrapper .search-result-box').css('height', (0, _jquery2.default)(window).height() - 40);
	
	    this.$nextTick(function () {
	
	      var that = this;
	      var num = 0;
	      var timer = setInterval(function () {
	        num += 3000;
	        if (that.mergePledge.length > 0 && num > 60000) {
	          var mySwiper = new _swiper2.default('.swiper-container', {
	            pagination: {
	              el: '.swiper-pagination',
	              type: 'fraction'
	            }
	          });
	
	          clearInterval(timer);
	        } else if (that.cumulative_pledge.length > 0 && num > 60000) {
	          var mySwiper = new _swiper2.default('.swiper-container', {
	            pagination: {
	              el: '.swiper-pagination',
	              type: 'fraction'
	            }
	          });
	
	          clearInterval(timer);
	        }
	      }, 3000);
	    });
	  },
	  created: function created() {
	    (0, _jquery2.default)('meta')[2].content = 'width=device-width, initial-scale=1';
	  },
	
	  route: {
	    data: function data(_ref2) {
	      var to = _ref2.to;
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query.share);
	        }
	      }
	      if (this.currentuser) {
	        this.params.tab = to.query.tab;
	        this.params.shortname = to.query.shortname;
	        this.params.pledgor = to.query.pledgor;
	        this.params.uidUrl = to.query.uid;
	        this.params.share = to.query.share;
	        this.params.plat = to.query.plat;
	        this.params.ts = to.query.ts;
	        this.params.sid = to.query.sid;
	        this.params.ruid = to.query.ruid;
	
	        var descs = window.location.href.split('&');
	        for (var i = 0, len = descs.length; i < len; i++) {
	          var str = descs[i];
	          if (str.indexOf('desc=') == 0) {
	            this.params.desc = decodeURIComponent(str.split('=')[1]);
	            break;
	          }
	        }
	
	        this.routeStart();
	
	        jQuery(window).unbind();
	        (0, _jquery2.default)(window).unbind();
	        var that = this;
	        (0, _jquery2.default)(window).scroll(function () {
	
	          var scrollTop = (0, _jquery2.default)(this).scrollTop();
	          var scrollHeight = (0, _jquery2.default)(document).height();
	          var windowHeight = (0, _jquery2.default)(this).height();
	
	          if (that.relationNotice.totalPage && that.relationNotice.companycode != '') {
	            if (scrollTop + windowHeight >= scrollHeight) {
	              var next_page = parseInt(that.relationNotice.page) + 1;
	              if (that.relationNotice.page < that.relationNotice.totalPage) {
	                that.relationNotice.page = next_page;
	                that.getRelationNotice(that.relationNotice.companycode);
	              }
	            }
	          }
	        });
	
	        var share_title = '[大黄押] ' + this.params.desc;
	        var share_desc = this.getResultShareDesc();
	        this.changeMetaTitle(share_title);
	        this.getwxsign();
	        this.shareDhyCbjd(share_title, share_desc);
	      }
	    }
	  },
	  filters: {
	    plate: function plate(value) {
	      return this.plateMap[value];
	    },
	    nullVal: function nullVal(value) {
	      if (!value) {
	        return '--';
	      } else if (value == 'zzzz') {
	        return '--';
	      } else {
	        return value;
	      }
	    },
	    formartPledgeType: function formartPledgeType(value) {
	      for (var key in this.pledgeTypeList) {
	        if (key == value) {
	          return this.pledgeTypeList[key];
	        }
	      }
	    },
	    formatDateTyp: function formatDateTyp(param) {
	      for (var code in this.dateTypList) {
	        if (code == param) {
	          return this.dateTypList[code];
	        }
	      }
	    },
	    formatTime: function formatTime(time) {
	      if (!time) {
	        return;
	      }
	      if (time.indexOf('T') > 0) {
	        return time.split('T')[0];
	      } else {
	        return time;
	      }
	    },
	    formatNumber: function formatNumber(num) {
	      num = num / 10000;
	      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
	        return num;
	      }
	      var a = RegExp.$1,
	          b = RegExp.$2,
	          c = RegExp.$3;
	      var re = new RegExp("(\\d)(\\d{3})(,|$)");
	      while (re.test(b)) {
	        b = b.replace(re, "$1,$2$3");
	      }return a + "" + b + "" + c;
	    }
	  },
	  methods: {
	    routeStart: function routeStart() {
	      this.search();
	      this.getMergePledge();
	      if (this.params.pledgor && this.params.pledgor != '') {
	        this.getCumulativePledge();
	      }
	      this.pledgeRate();
	      this.getSupervisionInfo();
	    },
	
	    search: function search() {
	      var _this = this;
	
	      this.pledgeInfoDropdown = false;
	      this.pledge_type = 'ALL';
	      this.relationnotice = [];
	      this.total = 0;
	      this.page = 1;
	
	      this.loading = true;
	      this.history_extension = [];
	      this.history_lifted = [];
	      this.history_pledge = [];
	      this.company = null;
	      this.pledge = null;
	      this.pledgor = null;
	      this.stock = null;
	      this.lastDate = { 'date': null, 'value': null, 'ratio': null };
	      this.businessincome = [];
	      this.yysrtbzzl = [];
	      this.retainedprofitowner = [];
	      this.gmjlrtbzzl = [];
	      this.yearlist = [];
	      this.showcompany = false;
	      this.showpledgor = false;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.pledgor = this.params.pledgor;
	      query.sid = this.params.sid;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	
	      console.log(query);
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/baseinfo'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status == 0) {
	          if (_this.params.pledgor && _this.params.pledgor != '') {
	            _this.getPledgorInfo();
	          }
	          _this.relationNotice.companycode = response.data.company.code;
	          _this.getRelationNotice(response.data.company.code);
	          _this.company = response.data.company;
	          _this.pledge = response.data.pledge;
	          _this.pledgor = response.data.pledgor;
	          _this.stock = response.data.stock;
	
	          if ((0, _keys2.default)(_this.stock.finance).length > 0) {
	            var yearlist = [];
	            var allyear = [];
	            for (var year in _this.stock.finance) {
	              if (year.indexOf('-12-') > 0) {
	                yearlist.push(year);
	              }
	              allyear.push(year);
	            }
	            allyear.sort(function (a, b) {
	              return parseInt(b.replace(/-/g, '')) - parseInt(a.replace(/-/g, ''));
	            });
	
	            _this.lastDate.date = allyear[0];
	            _this.lastDate.value = _this.stock.finance[allyear[0]].retainedprofitowner;
	            _this.lastDate.ratio = _this.stock.finance[allyear[0]].gmjlrtbzzl || '--';
	            yearlist.sort(function (a, b) {
	              return parseInt(b.replace(/-/g, '')) - parseInt(a.replace(/-/g, ''));
	            });
	
	            _this.yearlist = yearlist.slice(0, 5);
	            _this.businessincome = [];
	            _this.yysrtbzzl = [];
	            _this.retainedprofitowner = [];
	            _this.gmjlrtbzzl = [];
	
	            var chartBusiness = [[' ', '营业收入', '营业收入同比增长率']];
	            var chartGMJLR = [[' ', '归母净利润', '归母净利润同比增长率']];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	              for (var _iterator = (0, _getIterator3.default)(_this.yearlist), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                var y = _step.value;
	
	                _this.businessincome.push(_this.stock.finance[y].businessincome ? _this.stock.finance[y].businessincome : '--');
	
	                _this.yysrtbzzl.push(_this.stock.finance[y].yysrtbzzl ? _this.stock.finance[y].yysrtbzzl : '--');
	
	                _this.retainedprofitowner.push(_this.stock.finance[y].retainedprofitowner ? _this.stock.finance[y].retainedprofitowner : '--');
	
	                _this.gmjlrtbzzl.push(_this.stock.finance[y].gmjlrtbzzl ? _this.stock.finance[y].gmjlrtbzzl : '--');
	              }
	            } catch (err) {
	              _didIteratorError = true;
	              _iteratorError = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion && _iterator.return) {
	                  _iterator.return();
	                }
	              } finally {
	                if (_didIteratorError) {
	                  throw _iteratorError;
	                }
	              }
	            }
	
	            for (var i = _this.yearlist.length - 1; i >= 0; i--) {
	              var tmp = [];
	              tmp.push(_this.yearlist[i]);
	              tmp.push(_this.stock.finance[_this.yearlist[i]].businessincome ? _this.stock.finance[_this.yearlist[i]].businessincome : 0);
	              tmp.push(_this.stock.finance[_this.yearlist[i]].yysrtbzzl ? _this.stock.finance[_this.yearlist[i]].yysrtbzzl : 0);
	              chartBusiness.push(tmp);
	              var gm = [];
	              gm.push(_this.yearlist[i]);
	              gm.push(_this.stock.finance[_this.yearlist[i]].retainedprofitowner ? _this.stock.finance[_this.yearlist[i]].retainedprofitowner : 0);
	              gm.push(_this.stock.finance[_this.yearlist[i]].gmjlrtbzzl ? _this.stock.finance[_this.yearlist[i]].gmjlrtbzzl : 0);
	              chartGMJLR.push(gm);
	            }
	
	            _this.$nextTick(function () {
	
	              var that = this;
	              var echart = '';
	              var echart2 = '';
	              var max_time = 0;
	              var timer = setInterval(function () {
	                max_time += 1000;
	                echart = document.querySelector('.businesschart');
	                echart2 = document.querySelector('.gmjlrchart');
	
	                console.log(max_time);
	                if (max_time > 6000) {
	                  clearInterval(timer);
	                  return false;
	                }
	                if (echart && echart2) {
	                  console.log('clear timer');
	                  clearInterval(timer);
	                  that.echartBar(chartBusiness, that.publicunit, 'business');
	                  that.echartBar(chartGMJLR, that.publicunit, 'gmjlr');
	                }
	              }, 1000);
	            });
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getCumulativePledge: function getCumulativePledge() {
	      var _this2 = this;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.pledgor = this.params.pledgor;
	      query.uid = parseInt(this.params.uidUrl);
	      query.ruid = this.params.ruid;
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/cumulative'),
	        type: 'POST',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this2.cumulative_pledge = response.data;
	          _this2.cumPledge_total = response.data.length;
	          _this2.cumPledge_totalPage = Math.ceil(response.data.length / _this2.cumPledge_perPage);
	
	          if (response.data && response.data.length > 0) {
	            var data = response.data;
	            var dataX = [];
	            var dataY = {
	              type: 'line',
	              data: []
	            };
	
	            if (data.length > 1) {
	              var allDate = _this2.getAllDay(data[data.length - 1]['publishdate'], data[0]['publishdate']);
	              allDate.unshift(data[data.length - 1]['publishdate']);
	              console.log(allDate);
	              var newData = [];
	              for (var _i = 0, _len2 = allDate.length; _i < _len2; _i++) {
	                var isHased = false;
	                for (var j = 0, _len3 = data.length; j < _len3; j++) {
	                  if (allDate[_i] == data[j].publishdate) {
	                    newData.push(data[j]);
	                    isHased = true;
	                    break;
	                  }
	                }
	                if (!isHased) {
	                  newData.push({
	                    publishdate: allDate[_i],
	                    cumulative_pledge_proportion_of_total_capital: null
	                  });
	                }
	              }
	              data = newData;
	            }
	
	            var _len = data.length;
	
	            for (var i = 0, _len = data.length; i < _len; i++) {
	              dataX.push(data[i]['publishdate']);
	
	              dataY.data.push(data[i]['cumulative_pledge_proportion_of_shares_held']);
	            }
	            _this2.cumPledge_echart.dataX = dataX;
	            _this2.cumPledge_echart.dataY = dataY;
	          } else if (response.data && response.data.length == 0) {
	            _this2.cumPledge_echart.dataX = [];
	            _this2.cumPledge_echart.dataY = [];
	          }
	
	          console.log(_this2.cumPledge_echart);
	
	          _this2.$nextTick(function () {
	            this.echartLineNumber(this.cumPledge_echart, '', '', 'cumPledge', '.analyze-chart-box3', '.rate-chart3');
	          });
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)(response.description);
	      });
	    },
	
	    getMergePledge: function getMergePledge() {
	      var _this3 = this;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.pledgor = this.params.pledgor;
	      query.sid = this.params.sid;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/pledgeinfo'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          _this3.mergePledge = response.data;
	          _this3.mergePledgeToFiler = response.data;
	          _this3.pledgeePaging.allpage = response.data;
	          _this3.pledgeePaging.totalPage = response.data.length;
	
	          var _data = response.data;
	          if (_data.length > 0) {
	            if (_this3.params.pledgor && _this3.params.pledgor != '') {
	              _this3.filterPledgeInfo('dqrrf');
	            } else {
	              _this3.mergePledge = [];
	              _this3.mergePledgeToFiler = [];
	            }
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    filterPledgeInfo: function filterPledgeInfo(type) {
	
	      var arr = [];
	
	      if (type == 'dqrrf') {
	        var rrfname = '';
	        if (this.pledgor && this.pledgor.holder && this.pledgor.holder.name) {
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(this.mergePledgeToFiler), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var item = _step2.value;
	
	              rrfname = _jquery2.default.trim(item.name_of_shareholder);
	              if (rrfname == this.pledgor.holder.name) {
	                arr.push(item);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	        } else if (this.params.pledgor && this.params.pledgor.length > 0) {
	
	          var intoPerson = _jquery2.default.trim(this.params.pledgor);
	          var _iteratorNormalCompletion3 = true;
	          var _didIteratorError3 = false;
	          var _iteratorError3 = undefined;
	
	          try {
	            for (var _iterator3 = (0, _getIterator3.default)(this.mergePledgeToFiler), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	              var _item = _step3.value;
	
	              rrfname = _jquery2.default.trim(_item.name_of_shareholder);
	              if (rrfname == intoPerson) {
	                arr.push(_item);
	              }
	            }
	          } catch (err) {
	            _didIteratorError3 = true;
	            _iteratorError3 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                _iterator3.return();
	              }
	            } finally {
	              if (_didIteratorError3) {
	                throw _iteratorError3;
	              }
	            }
	          }
	        }
	        this.mergePledge = arr;
	      }
	    },
	    pledgeRate: function pledgeRate() {
	      var _this4 = this;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.pledgor = this.params.pledgor;
	      query.sid = this.params.sid;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/pledgerate'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          if (response.data.company && response.data.company.length > 0) {
	            var company = response.data.company;
	            var dataX = [];
	            var dataY = {
	              type: 'line',
	              data: []
	            };
	
	            for (var i = 0, len = company.length; i < len; i++) {
	              dataX.push(company[i]['date']);
	              dataY.data.push(company[i]['pledge_ratio']);
	            }
	            _this4.rate_company.dataX = dataX;
	            _this4.rate_company.dataY = dataY;
	          } else if (response.data.company && response.data.company.length == 0) {
	            _this4.rate_company.dataX = [];
	            _this4.rate_company.dataY = [];
	          }
	          if (response.data.szse && response.data.szse.length > 0) {
	            var _dataX = [];
	            var _dataY = {
	              name: '限售股平均质押率',
	              type: 'line',
	
	              data: []
	            };
	            var dataY2 = {
	              name: '非限售股平均质押率',
	              type: 'line',
	
	              data: []
	            };
	            var legend = ['限售股平均质押率', '非限售股平均质押率'];
	
	            for (var i = 0, len = response.data.szse.length; i < len; i++) {
	              _dataX.push(response.data.szse[i]['date']);
	              _dataY.data.push(response.data.szse[i]['limited_shares_conditional_pledging_rate']);
	              dataY2.data.push(response.data.szse[i]['unlimited_shares_pledged_rate']);
	            }
	            _this4.rate_szse.dataX = _dataX;
	            _this4.rate_szse.dataY = _dataY;
	            _this4.rate_szse.dataY2 = dataY2;
	            _this4.rate_szse.legend = legend;
	          } else if (response.data.szse && response.data.szse.length == 0) {
	            _this4.rate_szse.dataX = [];
	            _this4.rate_szse.dataY = [];
	            _this4.rate_szse.dataY2 = [];
	            _this4.rate_szse.legend = [];
	          }
	
	          if (response.data.shse && response.data.shse.length > 0) {
	            var _dataX2 = [];
	            var _dataY2 = {
	              name: '限售股平均质押率',
	              type: 'line',
	
	              data: []
	            };
	            var _dataY3 = {
	              name: '非限售股平均质押率',
	              type: 'line',
	
	              data: []
	            };
	            var _legend = ['限售股平均质押率', '非限售股平均质押率'];
	
	            for (var i = 0, len = response.data.shse.length; i < len; i++) {
	              _dataX2.push(response.data.shse[i]['date']);
	              _dataY2.data.push(response.data.shse[i]['limited_shares_conditional_pledging_rate']);
	              _dataY3.data.push(response.data.shse[i]['unlimited_shares_pledged_rate']);
	            }
	            _this4.rate_shse.dataX = _dataX2;
	            _this4.rate_shse.dataY = _dataY2;
	            _this4.rate_shse.dataY2 = _dataY3;
	            _this4.rate_shse.legend = _legend;
	          } else if (response.data.shse && response.data.shse.length == 0) {
	            _this4.rate_shse.dataX = [];
	            _this4.rate_shse.dataY = [];
	            _this4.rate_shse.dataY2 = [];
	            _this4.rate_shse.legend = [];
	          }
	
	          _this4.$nextTick(function () {
	            this.echartLine(this.rate_company, '全场质押比例', '', 'company', '.analyze-chart-box', '#rate-chart');
	            if (response.data.szse && response.data.szse.length > 0) {
	              this.echartLine(this.rate_szse, '深交所平均质押率', this.rate_szse.legend, 'szse', '.analyze-chart-box2', '#rate-chart2');
	            }
	            if (response.data.shse && response.data.shse.length > 0) {
	              this.echartLine(this.rate_shse, '上交所平均质押率', this.rate_shse.legend, 'shse', '.analyze-chart-box2', '#rate-chart2');
	            }
	          });
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getSupervisionInfo: function getSupervisionInfo() {
	      var _this5 = this;
	
	      this.companyNoticeInfo = {};
	      this.showcompany = false;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.sid = this.params.sid;
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.ruid = this.params.ruid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/companynoticeinfo'),
	        method: 'post',
	        dataType: 'json',
	
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this5.companyNoticeInfo = response.data;
	          _this5.showcompany = true;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getRelationNotice: function getRelationNotice(companycode) {
	      var _this6 = this;
	
	      console.log(this.relationNotice.companycode);
	      this.relationNotice.pageInfo.page = this.relationNotice.page;
	      this.relationNotice.pageInfo.perPage = this.relationNotice.perPage;
	      if (companycode) {
	        this.relationNotice.pageInfo.companycode = companycode;
	      } else {
	        this.relationNotice.pageInfo.companycode = this.relationNotice.companycode;
	      }
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/relationnotice'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(this.relationNotice.pageInfo)
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this6.relationNotice.total = response.data.total;
	          _this6.relationNotice.totalPage = Math.ceil(_this6.relationNotice.total / _this6.relationNotice.perPage);
	          _this6.relationNotice.lists = _this6.relationNotice.lists.concat(response.data.lists);
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getPledgorInfo: function getPledgorInfo() {
	      var _this7 = this;
	
	      this.pledgorNoticeInfo = {};
	      this.showpledgor = false;
	
	      var query = {};
	      query.shortname = this.params.shortname;
	      query.pledgor = this.params.pledgor;
	      query.uid = parseInt(this.params.uidUrl);
	      query.ruid = this.params.ruid;
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/pledge/pledgornoticeinfo'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status == 0) {
	          _this7.pledgorNoticeInfo = response.data;
	          _this7.showpledgor = true;
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    relationNoticeDetail: function relationNoticeDetail(h) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	
	      this.setCnzz('[Mobile]-大黄押', '查看重要公告原文', '');
	      var url = window.location.origin + '/#!/notice-detail/' + h.id + '?stype=1&tcode=&pdate=' + h.publishDate + '&idxname=&uid=' + this.uid + '&share=weixin&plat=web&ts=' + this.params.ts + '&ext=&sid=' + this.params.sid;
	
	      window.location.href = url;
	    },
	
	    goNotice: function goNotice(item) {
	      if (this.currentRegtyp === 4) {
	        this.tipGoBind = true;
	        return;
	      }
	
	      var url = this.viewUrl(item);
	      window.location.href = url;
	    },
	    viewUrl: function viewUrl(item) {
	      if (item.id) {
	        return window.location.origin + '/#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishDate + '&tcode=&idxname=&share=weixin&plat=web&ext=' + '&uid=' + this.uid + '&ruid=' + this.params.ruid + '&ts=' + this.params.ts + '&sid=' + this.params.sid;
	      } else {
	        return window.location.origin + '/#!/notice-detail/' + item.md5 + '?stype=1&pdate=' + item.publishdate + '&tcode=&idxname=&share=weixin&plat=web&ext=' + '&uid=' + this.uid + '&ruid=' + this.params.ruid + '&ts=' + this.params.ts + '&sid=' + this.params.sid;;
	      }
	    },
	    viewStockTitle: function viewStockTitle(item, tcode) {
	      var _tcode = tcode + '-0';
	      if (item.id) {
	        var url = window.location.origin + '#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishdate + '&tcode=' + '&ccode=' + _tcode;
	
	        window.location.href = url;
	      }
	    },
	    viewStockTable: function viewStockTable(item, tcode, offset) {
	      var _offset = parseInt(offset) + 1;
	      var _tcode = tcode + '-' + _offset.toString();
	      if (item.id) {
	        var url = window.location.origin + '/#!/notice-detail/' + item.id + '?stype=1&pdate=' + item.publishDate + '&tcode=' + _tcode;
	
	        window.location.href = url;
	      }
	    },
	
	    showlists: function showlists(item) {
	      console.log(item);
	      this.viewMore.show = true;
	      this.viewMore.lists = item;
	      console.log(this.viewMore);
	    },
	
	    getNowTime: function getNowTime() {
	      var myDate = new Date(),
	          year = myDate.getFullYear(),
	          month = myDate.getMonth() + 1,
	          day = myDate.getDate();
	
	      if (month < 10) {
	        month = '0' + month.toString();
	      }
	
	      if (day < 10) {
	        day = '0' + day.toString();
	      }
	      return year + '-' + month + '-' + day + 'T00:00:00';
	    },
	    moreNowday: function moreNowday(time) {
	      var now = this.getNowTime().split('T')[0];
	      now = now.split('-')[0] + now.split('-')[1] + now.split('-')[2];
	      if (time.indexOf('T') > 0) {
	        time = time.split('T')[0];
	      }
	      time = time.split('-')[0] + time.split('-')[1] + time.split('-')[2];
	      if (time > now) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    hidePledgeDropdown: function hidePledgeDropdown(e) {
	      var _con = (0, _jquery2.default)('.dhy-choice-list');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.pledgeInfoDropdown = false;
	      }
	    },
	    hideDateDropmenu: function hideDateDropmenu(e) {
	      var _con = (0, _jquery2.default)('.dhy-filter-date-list');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.showDateDropdown = false;
	      }
	    },
	    hideModelDateDropmenu: function hideModelDateDropmenu(e) {
	      var _con = (0, _jquery2.default)('.abs-Regulatory-Date');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.showDateDropdown = false;
	        this.pledgeInfoDropdown = false;
	      }
	    },
	    showPledgeDropdown: function showPledgeDropdown() {
	      if (this.pledgeInfoDropdown) {
	        this.pledgeInfoDropdown = false;
	      } else {
	        this.pledgeInfoDropdown = true;
	      }
	    },
	
	    showDateDropdownmenu: function showDateDropdownmenu() {
	      if (this.showDateDropdown) {
	        this.showDateDropdown = false;
	      } else {
	        this.showDateDropdown = true;
	      }
	    },
	    hide: function hide() {
	      (0, _jquery2.default)('.company-menu').css('display', 'none');
	      this.suggestion = [];
	      this.addedCPlist = [];
	    },
	
	    checkProperty: function checkProperty(item) {
	      if ((0, _keys2.default)(item).indexOf('ctuishi') >= 0) {
	        return true;
	      } else {
	        return false;
	      }
	    },
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	    },
	
	    unique: function unique(arr) {
	      var tmp = {},
	          ret = [];
	      for (var i = 0, len = arr.length; i < len; i++) {
	        if (!tmp[arr[i]]) {
	          tmp[arr[i]] = true;
	          ret.push(arr[i]);
	        }
	      }
	      return ret;
	    },
	    showDropdown: function showDropdown(type) {
	      console.log(type);
	      if (type == 'status') {
	        if (this.dropdown_menu_status) {
	          this.dropdown_menu_status = false;
	        } else {
	          this.dropdown_menu_status = true;
	        }
	      }
	
	      if (type == 'timelimit') {
	        if (this.dropdown_menu_timelimit) {
	          this.dropdown_menu_timelimit = false;
	        } else {
	          this.dropdown_menu_timelimit = true;
	        }
	      }
	
	      if (type == 'financinglist') {
	        if (this.dropdown_menu_list_status) {
	          this.dropdown_menu_list_status = false;
	        } else {
	          this.dropdown_menu_list_status = true;
	        }
	      }
	    },
	    hideDropdown: function hideDropdown(e) {
	      if (this.dropdown_menu_status) {
	        var _con = (0, _jquery2.default)('.dhy-strte-1');
	
	        if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	          this.dropdown_menu_status = false;
	        }
	      }
	
	      if (this.dropdown_menu_timelimit) {
	        var _con2 = (0, _jquery2.default)('.dhy-strte-2');
	
	        if (!_con2.is(e.target) && _con2.has(e.target).length === 0) {
	          this.dropdown_menu_timelimit = false;
	        }
	      }
	
	      if (this.dropdown_menu_list_status) {
	        var _con3 = (0, _jquery2.default)('.dhy-strte-3');
	
	        if (!_con3.is(e.target) && _con3.has(e.target).length === 0) {
	          this.dropdown_menu_list_status = false;
	        }
	      }
	    },
	    radioClick: function radioClick(e) {
	      var cName = (0, _jquery2.default)(e.target).attr('class');
	      if (cName == 'el-radio-inner' || cName == 'el-radio-original') {
	        var parentNode = (0, _jquery2.default)(e.target).parent('.el-radio-input');
	        if (!parentNode.hasClass('is-checked')) {
	          (0, _jquery2.default)('span.el-radio-input').removeClass('is-checked');
	          parentNode.addClass('is-checked');
	        }
	      }
	    },
	
	    timeStyleChange: function timeStyleChange(nowdate) {
	      var Y = nowdate.getFullYear() + '-';
	      var M = (nowdate.getMonth() + 1 < 10 ? '0' + (nowdate.getMonth() + 1) : nowdate.getMonth() + 1) + '-';
	      var D = nowdate.getDate();
	      console.log(Y + M + D);
	      return Y + M + D;
	    },
	    getNowFormatDate: function getNowFormatDate() {
	      var date = new Date();
	      var seperator1 = "-";
	      var year = date.getFullYear();
	      var month = date.getMonth() + 1;
	      var strDate = date.getDate();
	
	      if (month >= 1 && month <= 9) {
	        month = "0" + month;
	      }
	      if (strDate >= 0 && strDate <= 9) {
	        strDate = "0" + strDate;
	      }
	      var currentdate = year + seperator1 + month + seperator1 + strDate;
	
	      return currentdate;
	    },
	    getDateDiff: function getDateDiff(startDate, endDate) {
	      var startTime = new Date(Date.parse(startDate.replace(/-/g, "/"))).getTime();
	      var endTime = new Date(Date.parse(endDate.replace(/-/g, "/"))).getTime();
	      var dates = Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24);
	
	      return dates;
	    },
	    toWan: function toWan(num) {
	      return num = num > 9999 ? num / 10000 : num;
	    },
	    showSharePriceDropdown: function showSharePriceDropdown() {
	      if (this.financing.edit.companycode == '') {
	        (0, _helper.alert)('请先输入证券代码');
	        return;
	      }
	      var companycode = this.financing.edit.companycode.trim();
	      if (companycode.length != 6) {
	        (0, _helper.alert)('请输入有效证券代码');
	        return;
	      }
	      this.sharePriceDropdown = this.sharePriceDropdown ? false : true;
	    },
	    hideSharePriceDropdown: function hideSharePriceDropdown(e) {
	      var _con = (0, _jquery2.default)('.dhy-gujia-dropdown-menu');
	
	      if (!_con.is(e.target) && _con.has(e.target).length === 0) {
	        this.sharePriceDropdown = false;
	      }
	    },
	
	    decimalCount: function decimalCount(num) {
	      if (!num) {
	        return;
	      }
	
	      if (String(num).indexOf('.') > 0) {
	        var x = String(num).indexOf('.') + 1;
	        var y = String(num).length - x;
	        if (y > 0) {
	          console.log(y);
	          return y;
	        }
	      } else {
	        return 0;
	      }
	    }
	  },
	  computed: {
	    totalPage: function totalPage() {
	      var totalPage = Math.ceil(this.total / this.perPage);
	      return totalPage;
	    },
	    indexs: function indexs() {
	      var left = 1;
	      var right = this.totalPage;
	      var ar = [];
	      if (this.totalPage >= 11) {
	        if (this.page > 5 && this.page < this.totalPage - 4) {
	          left = this.page - 5;
	          right = this.page + 4;
	        } else {
	          if (this.page <= 5) {
	            left = 1;
	            right = 10;
	          } else {
	            right = this.totalPage;
	            left = this.page - 9;
	          }
	        }
	      }
	      while (left <= right) {
	        ar.push(left);
	        left++;
	      }
	      return ar;
	    }
	  }
	};

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(7);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default, _SearchMix2.default, _comSearchMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      eventId: '',
	      page: 0,
	      totalPage: 0,
	      eventMessage: [],
	      stype: 1,
	      loading: 1,
	      sendagain: true
	    };
	  },
	  ready: function ready() {
	    (0, _jquery2.default)(document).bind('scroll', this.scrollEvent);
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      this.eventId = '';
	      this.page = 0;
	      this.totalPage = 0;
	      this.eventMessage = [];
	      this.stype = 1;
	      this.loading = 1;
	      this.sendagain = true;
	
	      document.title = '推送内容';
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile('weixin');
	        }
	      }
	      if (this.currentuser) {
	        this.getProfile('weixin');
	        if (this.currentuser.regtyp == 4) {
	          this.goBindPage(1);
	          return false;
	        }
	        if (this.currentuser.mp == 0 || !this.currentuser.weixin) {
	          var appid = this.$config.weixin.appid;
	          this.currentuser = null;
	          var redirectUri = encodeURIComponent(window.location.href);
	          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
	
	          return false;
	        }
	        if (!this.checkPrivilege('user/event', '暂无权限')) {
	          return false;
	        }
	        this.eventId = to.params.id;
	        console.log(this.eventId);
	        this.getMsg();
	      }
	    }
	  },
	  methods: {
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    },
	
	    scrollEvent: function scrollEvent() {
	      if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height()) {
	        this.getMsg();
	      }
	    },
	
	    getMsg: function getMsg() {
	      var _this = this;
	
	      if (!this.sendagain) {
	        return false;
	      }
	      this.sendagain = false;
	      this.page = this.page + 1;
	      var query = { 'msgid': this.eventId, 'page': this.page, 'perPage': 10 };
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/searchevent'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.sendagain = true;
	        if (response.status == 0) {
	          _this.stype = response.event.stype;
	          _this.totalPage = Math.ceil(response.total / 10);
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(response.lists), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var i = _step.value;
	
	              _this.eventMessage.push(i);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (_this.eventMessage.length == 0) {
	            _this.loading = 3;
	            (0, _jquery2.default)(document).unbind('scroll');
	            return false;
	          }
	          if (_this.eventMessage.length == response.total) {
	            _this.loading = 2;
	            (0, _jquery2.default)(document).unbind('scroll');
	            return false;
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.sendagain = true;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getRelation: function getRelation(index) {
	      if (this.eventMessage[index].relationItems) {
	        this.eventMessage[index].showrelationnotice = !this.eventMessage[index].showrelationnotice;
	      } else {
	        this.showRelation(index);
	      }
	    },
	    showRelation: function showRelation(index) {
	      var _this2 = this;
	
	      var requrl = (0, _helper.apiUrl)('/V1.0.0/notice/relationnotice');
	      var query = { 'id': this.eventMessage[index].id, 'pid': this.eventMessage[index].pid, 'stype': this.stype };
	      _jquery2.default.ajax({
	        url: requrl,
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        if (response.status === 0) {
	          var tmp = _jquery2.default.extend(true, [], _this2.eventMessage);
	          tmp[index].showrelationnotice = true;
	          tmp[index].relationItems = [];
	          var items = response.data.lists;
	          var _iteratorNormalCompletion2 = true;
	          var _didIteratorError2 = false;
	          var _iteratorError2 = undefined;
	
	          try {
	            for (var _iterator2 = (0, _getIterator3.default)(items), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	              var d = _step2.value;
	
	              if (d.id !== tmp[index].id) {
	                tmp[index].relationItems.push(d);
	              }
	            }
	          } catch (err) {
	            _didIteratorError2 = true;
	            _iteratorError2 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                _iterator2.return();
	              }
	            } finally {
	              if (_didIteratorError2) {
	                throw _iteratorError2;
	              }
	            }
	          }
	
	          _this2.eventMessage = tmp;
	          console.log('test');
	        } else if (response.status === 502) {
	          (0, _helper.alert)('很抱歉，请求超时请重新搜索');
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    view: function view(item) {
	      var url = this.viewUrl(item);
	      window.location.href = url;
	    },
	    viewUrl: function viewUrl(item) {
	      if (item.viewtype === 1) {
	        var tcode = '';
	        if (item.pid) {
	          return '/#!/notice-detail/' + item.id + '?pid=' + item.pid + '&stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=';
	        } else {
	          return '/#!/notice-detail/' + item.id + '?stype=' + this.stype + '&pdate=' + item.publishDate + '&idxname=';
	        }
	      }
	      if (item.viewtype === 2) {
	        return item.sourceurl;
	      }
	      if (item.viewtype === 3) {
	        return item.downloadurl;
	      }
	    }
	  }
	};

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'FinanceDetail',
	  mixins: [_userMix2.default, _wxshareMix2.default, _SearchMix2.default],
	  data: function data() {
	    return {
	      name: '',
	      id: {},
	      articleInfo: {},
	      addtime: '',
	      uidUrl: ''
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var _this = this;
	
	      var to = _ref.to;
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile('weixin');
	        }
	      }
	      if (this.currentuser) {
	        this.id.id = to.query.id;
	        this.uidUrl = to.query.uidUrl;
	
	        this.getwxsign();
	        this.loading = true;
	        _jquery2.default.ajax({
	          url: (0, _helper.apiUrl)('/V1.0.0/pledge/financingdetail'),
	          method: 'post',
	          data: (0, _stringify2.default)(this.id),
	          dataType: 'json'
	        }).done(function (response) {
	          _this.loading = false;
	          if (response.status === 0) {
	            _this.articleInfo = response.data;
	            _this.changeMetaTitle(response.data.company.shortname);
	
	            var updtime = response.data.updtime.split('T')[0];
	            var financing_amount = _this.formatMoney(response.data.financing_amount);
	            console.log('financeing_amount');
	            console.log(financing_amount);
	            var title = '融资需求：' + response.data.company.shortname + '（' + updtime + '）';
	            var desc = '融资金额：' + financing_amount + '(万)';
	
	            _this.shareFinanceDetail(title, desc);
	          } else {
	            console.log(response.description);
	          }
	        }).fail(function (response) {
	          _this.loading = false;
	          (0, _helper.alert)('请求失败');
	          console.log(response.status);
	        });
	      }
	    }
	  },
	  methods: {
	    changeMetaTitle: function changeMetaTitle(title) {
	      document.title = title;
	    },
	    formatMoney: function formatMoney(num) {
	      num = num / 10000;
	      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
	        return num;
	      }
	      var a = RegExp.$1,
	          b = RegExp.$2,
	          c = RegExp.$3;
	      var re = new RegExp("(\\d)(\\d{3})(,|$)");
	      while (re.test(b)) {
	        b = b.replace(re, "$1,$2$3");
	      }return a + "" + b + "" + c;
	    }
	  },
	  filters: {
	    formatMoney: function formatMoney(num) {
	      num = num / 10000;
	      if (!/^(\+|-)?(\d+)(\.\d+)?$/.test(num)) {
	        return num;
	      }
	      var a = RegExp.$1,
	          b = RegExp.$2,
	          c = RegExp.$3;
	      var re = new RegExp("(\\d)(\\d{3})(,|$)");
	      while (re.test(b)) {
	        b = b.replace(re, "$1,$2$3");
	      }return a + "" + b + "" + c;
	    },
	    formatTime: function formatTime(time) {
	      if (!time) {
	        return;
	      }
	      if (time.indexOf('T') > 0) {
	        return time.split('T')[0];
	      } else {
	        return time;
	      }
	    },
	
	    nullVal: function nullVal(value) {
	      if (!value) {
	        return '--';
	      } else {
	        return value;
	      }
	    },
	    formatFStauts: function formatFStauts(param) {
	      if (param === '0' || param === 0) {
	        return '新增';
	      } else if (param == '1') {
	        return '已完成';
	      } else if (param == '9') {
	        return '删除';
	      } else if (param == 'ALL') {
	        return '全部';
	      } else {
	        return param;
	      }
	    }
	  }
	};

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _helper = __webpack_require__(7);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	var _comSearchMix = __webpack_require__(14);
	
	var _comSearchMix2 = _interopRequireDefault(_comSearchMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  mixins: [_userMix2.default, _SearchMix2.default, _comSearchMix2.default, _wxshareMix2.default],
	  data: function data() {
	    return {
	      eventid: '',
	      name: '',
	      page: 0,
	      eventmsg: [],
	      loading: 1,
	      sendagain: true
	    };
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      this.eventid = '';
	      this.name = '';
	      this.page = 0;
	      this.eventmsg = [];
	      this.loading = 1;
	      this.sendagain = true;
	      document.title = '通知';
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile('weixin');
	        }
	      }
	      if (this.currentuser) {
	        this.getProfile();
	        if (this.currentuser.regtyp == 4) {
	          this.goBindPage(1);
	          return false;
	        }
	        if (this.currentuser.mp == 0 || !this.currentuser.weixin) {
	          var appid = this.$config.weixin.appid;
	          this.currentuser = null;
	          var redirectUri = encodeURIComponent(window.location.href);
	          window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=' + appid + '&redirect_uri=' + redirectUri + '&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect';
	
	          return false;
	        }
	
	        if (!this.checkPrivilege('user/event', '暂无权限')) {
	          return false;
	        }
	        this.name = to.query.name;
	        this.eventid = to.query.id;
	        this.getMsg();
	      }
	    }
	  },
	  ready: function ready() {
	    (0, _jquery2.default)(document).bind('scroll', this.scrollEvent);
	  },
	
	  methods: {
	    setCnzz: function setCnzz(name, action, label) {
	      window._czc.push(['_trackEvent', name, action, label]);
	      console.log(name + ' : ' + action + ' : ' + label);
	    },
	
	    scrollEvent: function scrollEvent() {
	      if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height()) {
	        this.getMsg();
	      }
	    },
	    getMsg: function getMsg() {
	      var _this = this;
	
	      if (!this.sendagain) {
	        return false;
	      }
	      this.sendagain = false;
	      this.page = this.page + 1;
	      var query = { 'eventid': this.eventid, 'page': this.page, 'perPage': 10 };
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/user/eventmsg'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.sendagain = true;
	
	        if (response.status == 0) {
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(response.lists), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var i = _step.value;
	
	              _this.eventmsg.push(i);
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          if (_this.eventmsg.length == 0) {
	            _this.loading = 3;
	            (0, _jquery2.default)(document).unbind('scroll');
	            return false;
	          }
	          if (_this.eventmsg.length == response.total) {
	            _this.loading = 2;
	            (0, _jquery2.default)(document).unbind('scroll');
	            return false;
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        _this.sendagain = true;
	
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    goEventMessage: function goEventMessage(item) {
	      window.location.href = '/#!/eventmsg/' + item.id;
	    }
	  }
	};

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _set = __webpack_require__(389);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _toConsumableArray2 = __webpack_require__(390);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _noticeMix = __webpack_require__(145);
	
	var _noticeMix2 = _interopRequireDefault(_noticeMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'NoticeView',
	  mixins: [_userMix2.default, _commentMix2.default, _wxshareMix2.default, _noticeMix2.default, _SearchMix2.default],
	  data: function data() {
	    return {
	      md5: '',
	      loading: false,
	      detail: {},
	      newdetail: [],
	      tab1: 0,
	      titles: [],
	      heads: [],
	
	      id: null,
	      pages: 1,
	      topPage: 0,
	      bottomPage: 0,
	      allPageNum: 0,
	      showheadtable: null,
	      allids: [],
	      windowLocation: '',
	      selection: null,
	      range: null,
	      startNode: null,
	      endNode: null,
	      startOffset: 0,
	      endOffset: 0,
	      flag: false,
	      annotationList: {},
	      addAnnotation: false,
	      seeAnnotation: false,
	
	      annotationContent: '',
	      currentAnno: [],
	      editStatus: false,
	      changedContent: '',
	      changedID: '',
	      changedIndex: null,
	      startpos: 0,
	      endpos: 0,
	
	      annObject: [],
	      delflag: false,
	      curAnId: '',
	      savedContent: '',
	      annTyp: null,
	      idstart: '',
	      idend: '',
	      idStartNode: null,
	      idEndNode: null,
	      Annconfig: ['1', '2'],
	      readORchange: false,
	      ModeOPtions: 1,
	      currentIndex: '',
	      showPrevNext: false,
	      categoryMap: { 'A': 'A股', 'N3B': '新三板', 'ChinaBond': '债券', 'weixin': '知识库', 'IRM': '投资者问答' },
	      showNotice: false,
	      annList: []
	    };
	  },
	  ready: function ready() {
	    if (this.hideFooter) {
	      (0, _jquery2.default)('footer.footer').css({ 'display': 'none' });
	    }
	    (0, _jquery2.default)('.wrapper').css('min-height', (0, _jquery2.default)(document).height() - 100);
	    document.getElementById('annotation').addEventListener('click', this.annotation);
	  },
	  created: function created() {
	    (0, _jquery2.default)('meta')[2].content = 'width=device-width, initial-scale=1';
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query);
	        }
	      }
	      if (this.currentuser) {
	        console.log(to.query);
	        console.log('输入打印 to tcode');
	        this.params.id = to.params.id;
	        this.params.stype = to.query.stype;
	        this.params.tcode = to.query.tcode;
	        this.params.pdate = to.query.pdate;
	        this.params.idxname = to.query.idxname;
	        this.params.uidUrl = to.query.uid;
	        this.params.share = to.query.share;
	        this.params.plat = to.query.plat;
	        this.params.ts = to.query.ts;
	        this.params.sid = to.query.sid;
	        this.params.ruid = to.query.ruid;
	        this.params.forceupd = to.query.forceupd;
	
	        var descs = window.location.href.split('&');
	        for (var i = 0, len = descs.length; i < len; i++) {
	          var str = descs[i];
	          if (str.indexOf('desc=') == 0) {
	            this.params.desc = decodeURIComponent(str.split('=')[1]);
	            break;
	          }
	        }
	        if (to.query.ext) {
	          this.params.ext = parseInt(to.query.ext);
	        }
	        if (to.query.pid) {
	          this.params.pid = to.query.pid;
	        }
	        if (to.query.ccode) {
	          this.params.ccode = to.query.ccode;
	        }
	        this.titles = [];
	        this.heads = [];
	        this.getAnn(to.query.shareann);
	
	        var that = this;
	        jQuery(window).bind('scrollstop', function () {
	          console.log('滚动事件结束');
	
	          var _allId = that.getAllId(that.allids);
	          var itemID = that.getInnerWindowId(_allId);
	          var stype = that.params.stype;
	          var title = '';
	          if (!that.params.desc || that.params.desc == '') {
	            title = that.detail.fulltitle;
	          } else {
	            title = that.params.desc;
	          }
	          var desc = that.getNoticeShareDesc(stype, itemID);
	          that.shareNotice(stype, itemID, title, desc);
	        });
	        this.commentList = [];
	        this.commentinput = false;
	        this.showComments = false;
	
	        this.md5 = this.params.id;
	      }
	    }
	  },
	  methods: {
	    loadcomment: function loadcomment() {
	      if (this.commentList.length == 0) {
	        console.log('输出params.id的值');
	        console.log(this.params.id);
	        this.getCommentList(1, 1, this.params.id);
	      }
	    },
	
	    idCompute: function idCompute(c, i, z) {
	      if (!c.title && z == 0) {
	        return c.code + '-' + i;
	      } else {
	        var x = parseInt(i) + 1;
	        return c.code + '-' + x;
	      }
	    },
	    nextAnn: function nextAnn() {
	      for (var i in this.annObject) {
	        if (this.annObject[i].id == this.currentIndex) {
	          if (i == this.annObject.length - 1) {
	            var classname = this.annObject[0].id;
	            var el = document.getElementsByClassName(classname);
	            this.currentIndex = classname;
	            if (el.length > 0) {
	              el[0].scrollIntoView();
	              (0, _jquery2.default)(window).scrollTop((0, _jquery2.default)(window).scrollTop() - 80);
	            }
	            return false;
	          } else {
	            var _classname = this.annObject[parseInt(i) + 1].id;
	            var _el = document.getElementsByClassName(_classname);
	            this.currentIndex = _classname;
	            if (_el.length > 0) {
	              _el[0].scrollIntoView();
	              (0, _jquery2.default)(window).scrollTop((0, _jquery2.default)(window).scrollTop() - 80);
	            }
	            return false;
	          }
	        }
	      }
	    },
	    prevAnn: function prevAnn() {
	      for (var i in this.annObject) {
	        if (this.annObject[i].id == this.currentIndex) {
	          if (i == 0) {
	            var el = document.getElementsByClassName(this.annObject[this.annObject.length - 1].id);
	            this.currentIndex = this.annObject[this.annObject.length - 1].id;
	            el[0].scrollIntoView();
	            (0, _jquery2.default)(window).scrollTop((0, _jquery2.default)(window).scrollTop() - 80);
	            return false;
	          } else {
	            var _el2 = document.getElementsByClassName(this.annObject[parseInt(i) - 1].id);
	            this.currentIndex = this.annObject[parseInt(i) - 1].id;
	            _el2[0].scrollIntoView();
	            (0, _jquery2.default)(window).scrollTop((0, _jquery2.default)(window).scrollTop() - 80);
	            return false;
	          }
	        }
	      }
	    },
	    spread: function spread(e) {
	      var tar = e.target;
	      var $tar = (0, _jquery2.default)(tar);
	
	      $tar.parent().next().css('display', 'inline-block');
	      $tar.parent().css('display', 'none');
	    },
	    retract: function retract(e) {
	      var tar = e.target;
	      var $tar = (0, _jquery2.default)(tar);
	
	      $tar.parent().prev().css('display', 'inline-block');
	      $tar.parent().css('display', 'none');
	    },
	    readMode: function readMode() {
	      function looper() {
	        if ((0, _jquery2.default)('bdo').length > 0) {
	          (0, _jquery2.default)('bdo').each(function () {
	            (0, _jquery2.default)(this).replaceWith((0, _jquery2.default)(this).html());
	          });
	          looper();
	        }
	      }
	      if (this.ModeOPtions == 1) {
	        this.ModeOPtions = 2;
	        looper();
	      } else {
	        this.ModeOPtions = 1;
	        this.drawAnn();
	      }
	    },
	    getAnn: function getAnn(ann) {
	      var _this = this;
	
	      if (ann && ann != 1) {
	        this.showNotice = true;
	      }
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/annotationlist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'fromuid': parseInt(this.params.uidUrl), 'md5': this.params.id })
	      }).done(function (response) {
	        if (response.status == 0) {
	          if (response.data.length === 0) {
	            _this.showNotice = true;
	          }
	          _this.annObject = response.data;
	          if (_this.annObject.length > 0) {
	            _this.currentIndex = _this.annObject[0].id;
	          }
	          _this.getDetail();
	          if (ann == 0) {
	            _this.readMode();
	          } else if (ann == 2) {
	            _this.showNotice = true;
	            _this.drawAnn();
	            console.log(_this.readORchange);
	            console.log(_this.showPrevNext);
	          } else {}
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getTableContent: function getTableContent(table, startL, endL, spos, epos) {
	      var str = '';
	      for (var i in table) {
	        if (i >= startL.x && i <= endL.x) {
	          for (var j in table[i]) {
	            if (i === startL.x && j === startL.y) {
	              str += table[i][j].substring(spos);
	            } else if (i === startL.x && j > startL.y) {
	              str += table[i][j];
	            } else if (i > startL.x && i < endL.x) {
	              str += table[i][j];
	            } else if (i === endL.x && j < endL.y) {
	              str += table[i][j];
	            } else if (i === endL.x && j === endL.y) {
	              str += table[i][j].substring(0, epos + 1);
	            }
	          }
	        }
	      }
	      return str;
	    },
	    drawAnn: function drawAnn() {
	      var _this2 = this;
	
	      var _loop = function _loop(i) {
	        var that = _this2;
	        var time = setInterval(function () {
	          if (document.getElementById(that.annObject[i].start.code) && document.getElementById(that.annObject[i].end.code) && i > 0) {
	            var _startposRecur = function _startposRecur(x, p) {
	              if (x[p] == '\n') {
	                var y = p + 1;
	                return _startposRecur(x, y);
	              } else {
	                return p;
	              }
	            };
	
	            var _endposRecur = function _endposRecur(x, p) {
	              if (x[p] == '\n') {
	                var y = p - 1;
	                return _endposRecur(x, y);
	              } else {
	                return p + 1;
	              }
	            };
	
	            that.startpos = '';
	            that.endpos = '';
	            that.idstart = '';
	            that.idend = '';
	
	            that.idStartHTML(document.getElementById(that.annObject[i].start.code).childNodes);
	            that.idEndHTML(document.getElementById(that.annObject[i].end.code).childNodes);
	
	
	            var spos = _startposRecur(that.idstart, parseInt(that.annObject[i].start.pos));
	            that.getstart(document.getElementById(that.annObject[i].start.code), that.idstart, spos);
	
	            var epos = _endposRecur(that.idend, parseInt(that.annObject[i].end.pos));
	            that.getend(document.getElementById(that.annObject[i].end.code), that.idend, epos);
	
	            that.annotationContent = that.annObject[i].content;
	            that.note(that.annObject[i].id, that.annObject[i].typ, that.annObject[i]);
	            if (i == that.annObject.length - 1) {
	              that.showPrevNext = true;
	            }
	            window.clearInterval(time);
	          } else if (i == 0 && document.getElementById(that.annObject[i].start.code) && document.getElementById(that.annObject[i].end.code)) {
	            var _startposRecur2 = function _startposRecur2(x, p) {
	              if (x[p] == '\n') {
	                var y = p + 1;
	                return _startposRecur2(x, y);
	              } else {
	                return p;
	              }
	            };
	
	            var _endposRecur2 = function _endposRecur2(x, p) {
	              if (x[p] == '\n') {
	                var y = p - 1;
	                return _endposRecur2(x, y);
	              } else {
	                return p + 1;
	              }
	            };
	
	            that.startpos = '';
	            that.endpos = '';
	            that.idstart = '';
	            that.idend = '';
	
	            that.idStartHTML(document.getElementById(that.annObject[i].start.code).childNodes);
	            that.idEndHTML(document.getElementById(that.annObject[i].end.code).childNodes);
	
	
	            var _spos = _startposRecur2(that.idstart, parseInt(that.annObject[i].start.pos));
	            that.getstart(document.getElementById(that.annObject[i].start.code), that.idstart, _spos);
	
	            var _epos = _endposRecur2(that.idend, parseInt(that.annObject[i].end.pos));
	            that.getend(document.getElementById(that.annObject[i].end.code), that.idend, _epos);
	
	            that.annotationContent = that.annObject[i].content;
	            that.note(that.annObject[i].id, that.annObject[i].typ, that.annObject[i]);
	            window.clearInterval(time);
	          }
	        }, 100);
	      };
	
	      for (var i in this.annObject) {
	        _loop(i);
	      }
	    },
	    xxetAnn: function xxetAnn() {
	      var _this3 = this;
	
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/annotationlist'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)({ 'fromuid': parseInt(this.params.uidUrl), 'md5': this.params.id })
	      }).done(function (response) {
	        if (response.status == 0) {
	
	          _this3.annObject = [];
	
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            var _loop2 = function _loop2() {
	              var item = _step.value;
	
	              _this3.startpos = '';
	              _this3.endpos = '';
	              _this3.idstart = '';
	              _this3.idend = '';
	
	              _this3.idStartHTML(document.getElementById(item.start.code).childNodes);
	              _this3.idEndHTML(document.getElementById(item.end.code).childNodes);
	
	              function startposRecur(x, p) {
	                if (x[p] == '\n') {
	                  var y = p + 1;
	                  return startposRecur(x, y);
	                } else {
	                  return p;
	                }
	              }
	              function endposRecur(x, p) {
	                if (x[p] == '\n') {
	                  var y = p - 1;
	                  return endposRecur(x, y);
	                } else {
	                  return p + 1;
	                }
	              }
	
	              var spos = startposRecur(_this3.idstart, parseInt(item.start.pos));
	              _this3.getstart(document.getElementById(item.start.code), _this3.idstart, spos);
	
	              var epos = endposRecur(_this3.idend, parseInt(item.end.pos));
	              _this3.getend(document.getElementById(item.end.code), _this3.idend, epos);
	
	              _this3.annotationContent = item.content;
	              _this3.note(item.id, item.typ, item);
	            };
	
	            for (var _iterator = (0, _getIterator3.default)(response.data), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              _loop2();
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	        } else {
	          (0, _helper.alert)(response.description);
	        }
	      }).fail(function (response) {
	        (0, _helper.alert)('请求失败');
	      });
	    },
	
	    getstart: function getstart(n, t, pos) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(n.childNodes), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	
	          if (item.nodeName == '#text' && item.data.trim()) {
	            if (this.startpos.length >= 0 && this.startpos.length <= pos && this.startpos.length + item.data.length > pos) {
	              this.startNode = item;
	              this.startOffset = pos - this.startpos.length;
	            }
	            this.startpos = this.startpos + item.data;
	          }
	          if (item.nodeName !== '#text') {
	            this.getstart(item, t, pos);
	            if (item.nodeName == 'P') {
	              this.startpos = this.startpos + '\n';
	            }
	            if (item.nodeName == 'TD') {
	              this.startpos = this.startpos + '\t';
	            }
	            if (item.nodeName == 'TR') {
	              this.startpos = this.startpos + '\n';
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    getend: function getend(n, t, pos) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = (0, _getIterator3.default)(n.childNodes), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var item = _step3.value;
	
	
	          if (item.nodeName == '#text' && item.data.trim()) {
	            if (this.endpos.length >= 0 && this.endpos.length < pos && this.endpos.length + item.data.length >= pos) {
	
	              this.endNode = item;
	              this.endOffset = pos - this.endpos.length;
	            }
	
	            this.endpos = this.endpos + item.data;
	          }
	          if (item.nodeName !== '#text') {
	            this.getend(item, t, pos);
	            if (item.nodeName == 'P') {
	              this.endpos = this.endpos + '\n';
	            }
	            if (item.nodeName == 'TD') {
	              this.endpos = this.endpos + '\t';
	            }
	            if (item.nodeName == 'TR') {
	              this.endpos = this.endpos + '\n';
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    },
	    idStartHTML: function idStartHTML(x) {
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = (0, _getIterator3.default)(x), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var item = _step4.value;
	
	          if (item.nodeName == '#text' && item.data.trim()) {
	            this.idstart = this.idstart + item.data;
	          }
	          if (item.nodeName !== '#text' && item.nodeName !== 'T') {
	            this.idStartHTML(item.childNodes);
	
	            if (item.nodeName == 'P') {
	              this.idstart = this.idstart + '\n';
	            }
	            if (item.nodeName == 'TD') {
	              this.idstart = this.idstart + '\t';
	            }
	            if (item.nodeName == 'TR') {
	              this.idstart = this.idstart + '\n';
	            }
	          }
	          if (item.nodeName == 'T') {
	            this.idstart = this.idstart + '<t>' + item.outerText + '</t>';
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    },
	    idEndHTML: function idEndHTML(x) {
	      var _iteratorNormalCompletion5 = true;
	      var _didIteratorError5 = false;
	      var _iteratorError5 = undefined;
	
	      try {
	        for (var _iterator5 = (0, _getIterator3.default)(x), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	          var item = _step5.value;
	
	          if (item.nodeName == '#text' && item.data.trim()) {
	            this.idend = this.idend + item.data;
	          }
	          if (item.nodeName !== '#text' && item.nodeName !== 'T') {
	            this.idEndHTML(item.childNodes);
	            if (item.nodeName == 'P') {
	              this.idend = this.idend + '\n';
	            }
	            if (item.nodeName == 'TD') {
	              this.idend = this.idend + '\t';
	            }
	            if (item.nodeName == 'TR') {
	              this.idend = this.idend + '\n';
	            }
	          }
	          if (item.nodeName == 'T') {
	            this.idend = this.idend + '<t>' + item.outerText + '</t>';
	          }
	        }
	      } catch (err) {
	        _didIteratorError5 = true;
	        _iteratorError5 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion5 && _iterator5.return) {
	            _iterator5.return();
	          }
	        } finally {
	          if (_didIteratorError5) {
	            throw _iteratorError5;
	          }
	        }
	      }
	    },
	    note: function note(x, y, z) {
	      if (this.startNode.data == this.endNode.data && this.startNode.parentNode == this.endNode.parentNode) {
	        var startIndex = 0;
	        var endIndex = 0;
	
	        if (this.annotationContent) {
	          if (x) {
	
	            var range = document.createRange();
	            var newNode = document.createElement("b");
	            range.selectNode(this.endNode);
	            range.surroundContents(newNode);
	
	            var arr = document.getElementsByTagName('b')[0].innerText.split('');
	
	            arr.splice(this.endOffset, 0, '</bdo>');
	            arr.splice(this.startOffset, 0, '<bdo>');
	
	            document.getElementsByTagName('b')[0].innerHTML = arr.join('');
	
	            (0, _jquery2.default)('b').each(function () {
	              (0, _jquery2.default)(this).replaceWith((0, _jquery2.default)(this).html());
	            });
	
	            var bdo = document.getElementsByTagName('bdo');
	
	            for (var i = 0; i < bdo.length; i++) {
	              var item = bdo[i];
	              if (!item.getAttribute('class')) {
	                if (y && y == 1) {
	                  (0, _jquery2.default)(item).addClass('ffyellow');
	                }
	
	                if (y && y == 2) {
	                  item.style.background = this.annotationContent;
	                  if (z.user.uid == this.uid) {
	                    (0, _jquery2.default)(item).addClass('anyellow');
	                  }
	                }
	                (0, _jquery2.default)(item).addClass(x);
	              }
	            }
	            var content = '';
	            for (var j = 0; j < document.getElementsByClassName(x).length; j++) {
	              var item = document.getElementsByClassName(x)[j];
	              content = content + item.innerText;
	            }
	            content = content;
	            if (y && y == 1) {
	              this.annotationContent = this.annotationContent.replace(/\n/g, '<br>');
	            }
	            this.annotationList[x] = [content, this.annotationContent, y, z.user.showname, z.updtime.substring(0, 10), z.user.uid];
	            this.readORchange = true;
	            this.annotationContent = '';
	          }
	        }
	      } else {
	        if (this.annotationContent) {
	          if (x) {
	            var fNode = this.getParent(this.endNode, this.startNode, this.startNode.parentNode);
	
	            this.flag = false;
	            this.traversal(fNode);
	
	            (0, _jquery2.default)('b').each(function () {
	              (0, _jquery2.default)(this).replaceWith((0, _jquery2.default)(this).html());
	            });
	            var bdo = document.getElementsByTagName('bdo');
	
	            for (var i = 0; i < bdo.length; i++) {
	              var item = bdo[i];
	              if (!item.getAttribute('class')) {
	                if (y && y == 1) {
	                  (0, _jquery2.default)(item).addClass('ffyellow');
	                }
	
	                if (y && y == 2) {
	                  item.style.background = this.annotationContent;
	                  if (z.user.uid == this.uid) {
	                    (0, _jquery2.default)(item).addClass('anyellow');
	                  }
	                }
	                (0, _jquery2.default)(item).addClass(x);
	              }
	            }
	            var content = '';
	            for (var j = 0; j < document.getElementsByClassName(x).length; j++) {
	              var item = document.getElementsByClassName(x)[j];
	              content = content + item.innerText;
	            }
	            content = content;
	            if (y && y == 1) {
	              this.annotationContent = this.annotationContent.replace(/\n/g, '<br>');
	            }
	            this.annotationList[x] = [content, this.annotationContent, y, z.user.showname, z.updtime.substring(0, 10), z.user.uid];
	            this.readORchange = true;
	            this.annotationContent = '';
	          }
	        }
	      }
	    },
	    getParent: function getParent(e, s, parent) {
	      var s1 = this.getParentId(s);
	      var e1 = this.getParentId(e);
	      var s2 = this.getParentId(s1.parentNode);
	      var e2 = this.getParentId(e1.parentNode);
	      if (s1 == e1) {
	        return s1;
	      } else if (s2 == e2) {
	        return s2;
	      } else {
	        return document.getElementById('annotation');
	      }
	    },
	    annotation: function annotation(e) {
	      this.currentAnno = [];
	      this.getBdoClass(e.target);
	    },
	
	    getBdoClass: function getBdoClass(p) {
	      if (p.nodeName == 'BDO') {
	
	        var _time = p.className.substring(9);
	
	        if (p.className.indexOf('ffyellow') >= 0 || p.className.indexOf('anyellow') >= 0) {
	          this.seeAnnotation = true;
	          this.currentAnno.push([_time, this.annotationList[p.className.substring(9)][1].substring(3), this.annotationList[p.className.substring(9)][2]]);
	        }
	
	        this.getBdoClass(p.parentNode);
	      }
	    },
	    traversal: function traversal(n) {
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = (0, _getIterator3.default)(n.childNodes), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var item = _step6.value;
	
	          if (item == this.startNode) {
	            if (this.startNode.parentNode.outerHTML.indexOf('<t>') < 0) {
	              var range = document.createRange();
	              var newNode = document.createElement("b");
	              range.selectNode(item);
	              range.surroundContents(newNode);
	              var arr = document.getElementsByTagName('b')[0].innerText.split('');
	
	              arr.splice(arr.length, 0, '</bdo>');
	              arr.splice(this.startOffset, 0, '<bdo>');
	
	              document.getElementsByTagName('b')[0].innerHTML = arr.join('');
	
	              console.log(item);
	            }
	
	            this.flag = true;
	          } else if (item == this.endNode) {
	            if (this.endNode.parentNode.outerHTML.indexOf('<t>') < 0) {
	              var _range = document.createRange();
	              var _newNode = document.createElement("b");
	              _range.selectNode(item);
	              _range.surroundContents(_newNode);
	
	              var arr = document.getElementsByTagName('b')[1].innerText.split('');
	
	              arr.splice(this.endOffset, 0, '</bdo>');
	              arr.splice(0, 0, '<bdo>');
	
	              document.getElementsByTagName('b')[1].innerHTML = arr.join('');
	            }
	            this.flag = false;
	            return false;
	          } else {
	            if (this.flag) {
	              if (item.nodeName == '#text' && item.data.trim()) {
	                var _range2 = document.createRange();
	                var _newNode2 = document.createElement("bdo");
	                _range2.selectNode(item);
	                _range2.surroundContents(_newNode2);
	              } else {
	                this.traversal(item);
	              }
	            } else {
	              if (item.nodeName !== '#text') {
	                this.traversal(item);
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	    },
	    getParentId: function getParentId(n) {
	      if (!n.id) {
	        return this.getParentId(n.parentNode);
	      } else {
	        return n;
	      }
	    },
	
	    backTotext: function backTotext() {
	      this.showNotice = true;
	      this.$nextTick(function () {
	        this.drawAnn();
	      });
	    },
	
	    getDetail: function getDetail() {
	      var _this4 = this;
	
	      this.loading = true;
	      var query = {
	        'id': this.params.id,
	        'stype': this.params.stype,
	        'pdate': this.params.pdate
	      };
	      if (this.params.pid) {
	        query['pid'] = this.params.pid;
	      }
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      query.ruid = this.params.ruid;
	      if (this.params.ext) {
	        query['ext'] = this.params.ext;
	      }
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/noticedetail'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this4.loading = false;
	        if (response.status === 0) {
	          _this4.showheadtable = response.status;
	          _this4.detail = response.data;
	
	          _this4.cpwtotal = _this4.detail.commentcount;
	          _this4.fulltitle = _this4.detail.fulltitle;
	
	          var titles = [];
	          var i = 0;
	          var _iteratorNormalCompletion7 = true;
	          var _didIteratorError7 = false;
	          var _iteratorError7 = undefined;
	
	          try {
	            for (var _iterator7 = (0, _getIterator3.default)(_this4.detail.child), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	              var _child2 = _step7.value;
	
	              var isshow = true;
	              if (_child2.code && _child2.code.split('.').length > 3) {
	                isshow = false;
	              }
	              var haschild = false;
	              var rgxp = new RegExp('^' + _child2.code + '\.\\d+$', 'g');
	              if (_this4.detail.child[i + 1] && _this4.detail.child[i + 1].code && _this4.detail.child[i + 1].code.match(rgxp)) {
	                haschild = true;
	              }
	              var showchild = false;
	              if (_child2.code && _child2.code.split('.').length <= 2) {
	                showchild = true;
	              }
	              titles.push({ 'title': _child2.title, 'code': _child2.code, 'isshow': isshow, 'haschild': haschild, 'showchild': showchild });
	
	              _this4.allids.push(_child2.code + '-0');
	              var _idx = 1;
	              var _iteratorNormalCompletion12 = true;
	              var _didIteratorError12 = false;
	              var _iteratorError12 = undefined;
	
	              try {
	                for (var _iterator12 = (0, _getIterator3.default)(_child2.contents), _step12; !(_iteratorNormalCompletion12 = (_step12 = _iterator12.next()).done); _iteratorNormalCompletion12 = true) {
	                  var c = _step12.value;
	
	                  _this4.allids.push(_child2.code + '-' + _idx);
	                  if (c.htmltag === 'table') {
	                    _this4.heads.push({ 'info': c.info, 'code': _child2.code + '-' + _idx });
	                  }
	                  _idx++;
	                }
	              } catch (err) {
	                _didIteratorError12 = true;
	                _iteratorError12 = err;
	              } finally {
	                try {
	                  if (!_iteratorNormalCompletion12 && _iterator12.return) {
	                    _iterator12.return();
	                  }
	                } finally {
	                  if (_didIteratorError12) {
	                    throw _iteratorError12;
	                  }
	                }
	              }
	
	              i++;
	            }
	          } catch (err) {
	            _didIteratorError7 = true;
	            _iteratorError7 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion7 && _iterator7.return) {
	                _iterator7.return();
	              }
	            } finally {
	              if (_didIteratorError7) {
	                throw _iteratorError7;
	              }
	            }
	          }
	
	          _this4.genTitleTree(titles);
	
	          _this4.$nextTick(function () {
	            this.toggleHeader();
	
	            this.getwxsign();
	            if (!this.params.tcode) {
	              (0, _jquery2.default)(window).scrollTop(0);
	            }
	
	            var _allId = this.getAllId(this.allids);
	            var itemID = this.getInnerWindowId(_allId);
	            var stype = this.params.stype;
	            var title = '';
	            if (!this.params.desc || this.params.desc == '') {
	              title = this.detail.fulltitle;
	            } else {
	              title = this.params.desc;
	            }
	            this.changeMetaTitle(title);
	
	            var desc = this.getNoticeShareDesc(stype, itemID);
	            this.shareNotice(stype, itemID, title, desc);
	
	            if (this.params.ccode) {
	              this.childTitleIntoView(this.params.ccode);
	            }
	          });
	
	          var allPageNum = Math.ceil(_this4.detail.child.length / 5);
	          _this4.allPageNum = allPageNum;
	
	          if (_this4.params.tcode && _this4.params.tcode !== '' && _this4.params.tcode !== 'undefined-1') {
	            console.log(_this4.params.tcode);
	            var id = _this4.params.tcode.split('-')[0];
	            var idx = 0;
	            var pages = 0;
	            var _that = _this4;
	
	            for (var _i = 0; _i < _this4.detail.child.length; ++_i) {
	              if (_this4.detail.child[_i].code === id) {
	                idx = _i;
	                break;
	              }
	            }
	
	            pages = Math.ceil(idx / 5);
	            _this4.pages = pages;
	            _this4.topPage = pages;
	            _this4.bottomPage = pages;
	            console.log(_this4.pages);
	
	            if (_this4.params.tcode) {
	              var tcode = _this4.params.tcode;
	              setTimeout(function () {
	                if (document.getElementById(tcode)) {
	                  console.log(document.getElementById(tcode));
	                  console.log(tcode);
	                  console.log('详情页面子标题定位');
	                  document.getElementById(tcode).scrollIntoView();
	                  var scrollTop = (0, _jquery2.default)(window).scrollTop() - 30;
	                  (0, _jquery2.default)(window).scrollTop(scrollTop);
	                }
	              }, 100);
	            }
	
	            console.log(allPageNum);
	            var timer = setInterval(function () {
	              if (_that.detail.child.length > 5 && _that.topPage > 1) {
	                _that.topPage--;
	              }
	
	              if (_that.detail.child.length > 5 && _that.bottomPage < allPageNum) {
	                _that.bottomPage++;
	              }
	
	              if (_that.detail.child.length < 5) {
	                window.clearInterval(timer);
	              }
	              if (_that.topPage == 1 && _that.bottomPage == allPageNum) {
	                window.clearInterval(timer);
	                console.log('最后一页 渲染完成');
	                console.log(_that.bottomPage);
	                console.log(_that.allPageNum);
	              }
	            }, 100);
	          } else {
	            var _that2 = _this4;
	
	            _that2.topPage = 1;
	            _that2.bottomPage = 1;
	            var _timer = setInterval(function () {
	              if (_that2.detail.child.length > 5 && _that2.bottomPage < allPageNum) {
	                _that2.bottomPage++;
	              } else {
	                window.clearInterval(_timer);
	                console.log('最后一页 渲染完成');
	                console.log(_that2.bottomPage);
	                console.log(_that2.allPageNum);
	              }
	            }, 100);
	          }
	          if (!_this4.showNotice) {
	            var codearr = [];
	            var existarr = [];
	            var _iteratorNormalCompletion8 = true;
	            var _didIteratorError8 = false;
	            var _iteratorError8 = undefined;
	
	            try {
	              for (var _iterator8 = (0, _getIterator3.default)(_this4.detail.child), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	                var child = _step8.value;
	
	                codearr.push(child.code);
	              }
	            } catch (err) {
	              _didIteratorError8 = true;
	              _iteratorError8 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                  _iterator8.return();
	                }
	              } finally {
	                if (_didIteratorError8) {
	                  throw _iteratorError8;
	                }
	              }
	            }
	
	            console.log(codearr);
	            var _iteratorNormalCompletion9 = true;
	            var _didIteratorError9 = false;
	            var _iteratorError9 = undefined;
	
	            try {
	              for (var _iterator9 = (0, _getIterator3.default)(_this4.annObject), _step9; !(_iteratorNormalCompletion9 = (_step9 = _iterator9.next()).done); _iteratorNormalCompletion9 = true) {
	                var item = _step9.value;
	
	                existarr = existarr.concat(codearr.slice(codearr.indexOf(item.start.code.split('-')[0]), codearr.indexOf(item.end.code.split('-')[0]) + 1));
	              }
	            } catch (err) {
	              _didIteratorError9 = true;
	              _iteratorError9 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion9 && _iterator9.return) {
	                  _iterator9.return();
	                }
	              } finally {
	                if (_didIteratorError9) {
	                  throw _iteratorError9;
	                }
	              }
	            }
	
	            existarr = [].concat((0, _toConsumableArray3.default)(new _set2.default(existarr)));
	            console.log(existarr);
	            _this4.newdetail = [];
	            var _iteratorNormalCompletion10 = true;
	            var _didIteratorError10 = false;
	            var _iteratorError10 = undefined;
	
	            try {
	              for (var _iterator10 = (0, _getIterator3.default)(existarr), _step10; !(_iteratorNormalCompletion10 = (_step10 = _iterator10.next()).done); _iteratorNormalCompletion10 = true) {
	                var _item = _step10.value;
	                var _iteratorNormalCompletion11 = true;
	                var _didIteratorError11 = false;
	                var _iteratorError11 = undefined;
	
	                try {
	                  for (var _iterator11 = (0, _getIterator3.default)(_this4.detail.child), _step11; !(_iteratorNormalCompletion11 = (_step11 = _iterator11.next()).done); _iteratorNormalCompletion11 = true) {
	                    var _child = _step11.value;
	
	                    if (_item === _child.code) {
	                      _this4.newdetail.push(_child);
	                    }
	                  }
	                } catch (err) {
	                  _didIteratorError11 = true;
	                  _iteratorError11 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion11 && _iterator11.return) {
	                      _iterator11.return();
	                    }
	                  } finally {
	                    if (_didIteratorError11) {
	                      throw _iteratorError11;
	                    }
	                  }
	                }
	              }
	            } catch (err) {
	              _didIteratorError10 = true;
	              _iteratorError10 = err;
	            } finally {
	              try {
	                if (!_iteratorNormalCompletion10 && _iterator10.return) {
	                  _iterator10.return();
	                }
	              } finally {
	                if (_didIteratorError10) {
	                  throw _iteratorError10;
	                }
	              }
	            }
	
	            console.log(_this4.newdetail);
	            _this4.drawAnn();
	          }
	        }
	      }).fail(function (response) {
	        _this4.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    indentChild: function indentChild(code) {
	      if (code) {
	        var len = code.split('.').length - 1;
	        return { 'padding-left': len * 0.8 + 'rem' };
	      }
	    },
	    childTitleIntoView: function childTitleIntoView(id) {
	      var el = document.getElementById(id);
	      var startTime = new Date().getTime();
	      if (!el) {
	        var interval = setInterval(function () {
	          el = document.getElementById(id);
	          if (el) {
	            el.scrollIntoView();
	            clearInterval(interval);
	            return;
	          }
	          if (new Date().getTime() - startTime > 3000) {
	            clearInterval(interval);
	            return;
	          }
	        }, 100);
	      } else {
	        el.scrollIntoView();
	      }
	    },
	    getrowspan: function getrowspan(rowidx, colidx, mergecells) {
	      var key = rowidx + 1 + '_' + (colidx + 1);
	      if (mergecells[key]) {
	        return mergecells[key]['row'];
	      }
	      return '';
	    },
	    getcolspan: function getcolspan(rowidx, colidx, mergecells) {
	      var key = rowidx + 1 + '_' + (colidx + 1);
	      if (mergecells[key]) {
	        return mergecells[key]['col'];
	      }
	      return '';
	    },
	    toggleHeader: function toggleHeader() {
	      var header = (0, _jquery2.default)('.toolsbar-mune');
	      if (header.length == 0) {
	        header = (0, _jquery2.default)('.toolsbar-mune-1');
	      }
	      var headerH = header.height();
	      headerH = headerH ? headerH : 0;
	      var noticeTitleH = (0, _jquery2.default)('.notice-title').height();
	      var mainCont = (0, _jquery2.default)('.my-container');
	      if (noticeTitleH > 0) {
	        var headerStr = headerH.toString();
	        headerStr = Math.ceil(headerStr / 2) + 6;
	        headerStr = headerStr + 'px';
	        mainCont.css({ 'margin-top': '4.5rem', 'height': '100%' });
	
	        var p = (0, _jquery2.default)(window).scrollTop();
	        var t = p;
	        var that = this;
	        (0, _jquery2.default)(window).off('scroll').on('scroll', function () {
	          if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height() && that.showComments) {
	            var page = that.cpwpage + 1;
	            if (page <= Math.ceil(that.cpwtotal / 10)) {
	              that.getCommentList(page, 1, that.md5);
	            }
	          }
	
	          p = (0, _jquery2.default)(this).scrollTop();
	          if (t <= p) {
	            if (header.hasClass('slideDown')) {
	              header.removeClass('slideDown');
	              header.addClass('slideUp');
	            } else {
	              header.addClass('slideUp');
	            }
	          } else {
	            if (header.hasClass('slideUp')) {
	              header.removeClass('slideUp');
	              header.addClass('slideDown');
	            } else {
	              header.addClass('slideDown');
	            }
	          }
	          t = p;
	        });
	      }
	    },
	    categoryName: function categoryName(category) {
	      if (this.categoryMap[category]) {
	        return this.categoryMap[category];
	      }
	      return '';
	    }
	  },
	  watch: {
	    'tab1': function tab1(newVal, oldVal) {
	      if (newVal === 1) {
	        this.titleKeyword = this.headsKeyword;
	      }
	    },
	    'windowLocation': function windowLocation() {
	      jQuery(window).unbind();
	    }
	  },
	  filters: {
	    'getrowspan': function getrowspan(rowidx, colidx, mergecells) {
	      var key = rowidx + '_' + colidx;
	      if (mergecells[key]) {
	        return mergecells[key]['row'];
	      }
	      return '';
	    },
	    'getcolspan': function getcolspan(rowidx, colidx, mergecells) {
	      var key = rowidx + 1 + '_' + (colidx + 1);
	      if (mergecells[key]) {
	        return mergecells[key]['col'];
	      }
	      return '';
	    }
	  }
	};

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _assign = __webpack_require__(43);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _helper = __webpack_require__(7);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _commentMix = __webpack_require__(59);
	
	var _commentMix2 = _interopRequireDefault(_commentMix);
	
	var _userMix = __webpack_require__(10);
	
	var _userMix2 = _interopRequireDefault(_userMix);
	
	var _wxshareMix = __webpack_require__(11);
	
	var _wxshareMix2 = _interopRequireDefault(_wxshareMix);
	
	var _noticeMix = __webpack_require__(145);
	
	var _noticeMix2 = _interopRequireDefault(_noticeMix);
	
	var _SearchMix = __webpack_require__(30);
	
	var _SearchMix2 = _interopRequireDefault(_SearchMix);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'qaView',
	  mixins: [_userMix2.default, _commentMix2.default, _wxshareMix2.default, _noticeMix2.default, _SearchMix2.default],
	  data: function data() {
	    return {
	      md5: '',
	      detail: {},
	      titles: [],
	      id: null,
	      showmenu: false,
	      loading: false,
	      hideFooter: true,
	
	      pages: 1,
	      topPage: 1,
	      bottomPage: 1,
	      allPageNum: 0,
	      allId: [],
	      shareParams: {
	        allId: []
	      }
	    };
	  },
	  ready: function ready() {
	    if (this.hideFooter) {
	      (0, _jquery2.default)('footer.footer').css({ 'display': 'none' });
	    }
	    (0, _jquery2.default)('.wrapper').css('min-height', (0, _jquery2.default)(window).height() - 100);
	  },
	  created: function created() {
	    (0, _jquery2.default)('meta')[2].content = 'width=device-width, initial-scale=1';
	  },
	
	  route: {
	    data: function data(_ref) {
	      var to = _ref.to;
	
	      if (!this.currentuser) {
	        this.wxcode = this.getQueryString('code');
	        if (this.wxcode) {
	          this.wxlogin(this.wxcode);
	        } else {
	          this.getProfile(to.query);
	        }
	      }
	      if (this.currentuser) {
	        this.params.id = to.params.id;
	        this.params.stype = to.query.stype;
	        this.params.tcode = to.query.tcode;
	        this.params.pdate = to.query.pdate;
	        this.params.idxname = to.query.idxname;
	        this.params.uidUrl = to.query.uid;
	        this.params.share = to.query.share;
	        this.params.plat = to.query.plat;
	        this.params.ts = to.query.ts;
	        this.params.sid = to.query.sid;
	        this.params.ruid = to.query.ruid;
	        this.params.forceupd = to.query.forceupd;
	
	        var descs = window.location.href.split('&');
	        for (var i = 0, len = descs.length; i < len; i++) {
	          var str = descs[i];
	          if (str.indexOf('desc=') == 0) {
	            this.params.desc = decodeURIComponent(str.split('=')[1]);
	            break;
	          }
	        }
	        console.log(this.params.desc);
	
	        this.titles = [];
	        this.getDetail();
	        var that = this;
	        jQuery(window).bind('scrollstop', function () {
	          console.log('滚动事件结束');
	
	          var _allId = [];
	          if (that.shareParams.allId.length === 0) {
	            _allId = that.getAllId(that.shareParams.allId);
	          } else {
	            _allId = that.shareParams.allId;
	          }
	          var itemID = that.getInnerWindowId(_allId);
	          if (itemID.split('-')[1] !== 0) {
	            itemID = itemID.split('-')[0] + '-0';
	          }
	          var stype = that.params.stype;
	
	          var title = '';
	          if (!that.params.desc || that.params.desc == '') {
	            title = that.detail.fulltitle;
	          } else {
	            title = that.params.desc;
	          }
	
	          var desc = that.getNoticeShareDesc(stype, itemID);
	          that.shareNotice(stype, itemID, title, desc);
	        });
	
	        this.commentList = [];
	        this.commentinput = false;
	        this.showComments = false;
	        this.getcommentc;
	        this.md5 = this.params.id;
	      }
	    }
	  },
	  methods: {
	    loadcomment: function loadcomment() {
	      if (this.commentList.length == 0) {
	        this.getCommentList(1, 1, this.params.id);
	      }
	    },
	    getDetail: function getDetail() {
	      var _this = this;
	
	      console.log('getDetail');
	      this.loading = true;
	      var query = {
	        'id': this.params.id,
	        'stype': this.params.stype,
	        'pdate': this.params.pdate
	      };
	      query.uid = parseInt(this.params.uidUrl);
	      query.share = this.params.share;
	      query.plat = this.params.plat;
	      query.sid = this.params.sid;
	      query.ruid = this.params.ruid;
	      _jquery2.default.ajax({
	        url: (0, _helper.apiUrl)('/V1.0.0/notice/noticedetail'),
	        method: 'post',
	        dataType: 'json',
	        data: (0, _stringify2.default)(query)
	      }).done(function (response) {
	        _this.loading = false;
	        if (response.status === 0) {
	          var details = response.data;
	          _this.detail = response.data;
	          _this.cpwtotal = _this.detail.commentcount;
	          _this.fulltitle = _this.detail.fulltitle;
	          var titles = [];
	          var i = 0;
	          console.log(details);
	          var _iteratorNormalCompletion = true;
	          var _didIteratorError = false;
	          var _iteratorError = undefined;
	
	          try {
	            for (var _iterator = (0, _getIterator3.default)(details.child), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	              var child = _step.value;
	
	              var isshow = true;
	              if (child.code && child.code.split('.').length > 3) {
	                isshow = false;
	              }
	              var haschild = false;
	              var rgxp = new RegExp('^' + child.code + '\.\\d+$', 'g');
	              if (details.child[i + 1] && details.child[i + 1].code && details.child[i + 1].code.match(rgxp)) {
	                haschild = true;
	              }
	              var showchild = false;
	              if (child.code && child.code.split('.').length <= 2) {
	                showchild = true;
	              }
	              var _title = '';
	              var tag = '';
	              if (child.title) {
	                _title = child.title;
	                tag = 'ml';
	              }
	              if (child.que) {
	                _title = child.que;
	                tag = 'qa';
	              }
	              var index = _this.getIndex(child, details.child);
	              titles.push({
	                'title': _title,
	                'code': child.code,
	                'isshow': isshow,
	                'haschild': haschild,
	                'showchild': showchild,
	                'index': index,
	                'tag': tag
	              });
	              _this.shareParams.allId.push(child.code + '-0');
	              var _idx = 1;
	              if (child.title && child.content !== '' && child.content !== ' ') {
	                var _iteratorNormalCompletion2 = true;
	                var _didIteratorError2 = false;
	                var _iteratorError2 = undefined;
	
	                try {
	                  for (var _iterator2 = (0, _getIterator3.default)(child.content), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var c = _step2.value;
	
	                    _this.shareParams.allId.push(child.code + '-' + _idx);
	                    _idx++;
	                  }
	                } catch (err) {
	                  _didIteratorError2 = true;
	                  _iteratorError2 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                      _iterator2.return();
	                    }
	                  } finally {
	                    if (_didIteratorError2) {
	                      throw _iteratorError2;
	                    }
	                  }
	                }
	              } else if (child.que) {
	                var _iteratorNormalCompletion3 = true;
	                var _didIteratorError3 = false;
	                var _iteratorError3 = undefined;
	
	                try {
	                  for (var _iterator3 = (0, _getIterator3.default)(child.answers), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var _c = _step3.value;
	
	                    _this.shareParams.allId.push(child.code + '-' + _idx);
	                    _idx++;
	                  }
	                } catch (err) {
	                  _didIteratorError3 = true;
	                  _iteratorError3 = err;
	                } finally {
	                  try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                      _iterator3.return();
	                    }
	                  } finally {
	                    if (_didIteratorError3) {
	                      throw _iteratorError3;
	                    }
	                  }
	                }
	              }
	              i++;
	            }
	          } catch (err) {
	            _didIteratorError = true;
	            _iteratorError = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion && _iterator.return) {
	                _iterator.return();
	              }
	            } finally {
	              if (_didIteratorError) {
	                throw _iteratorError;
	              }
	            }
	          }
	
	          console.log('>>> details.child');
	          console.log(details.child);
	
	          var childs = details.child;
	          var qaChilds = [];
	          var len = childs.length;
	          for (var _i = 0; _i < len; ++_i) {
	            childs[_i].index = _i + 1;
	            if (childs[_i].que) {
	              qaChilds.push(childs[_i]);
	            }
	          }
	          for (var j = 0; j < qaChilds.length; j++) {
	            qaChilds[j] = (0, _assign2.default)({}, qaChilds[j], { 'qaindex': j });
	          }
	
	          for (var _i2 = 0; _i2 < len; ++_i2) {
	            for (var _j = 0; _j < qaChilds.length; ++_j) {
	              if (childs[_i2].que === qaChilds[_j].que) {
	                childs[_i2].qaindex = qaChilds[_j].qaindex;
	                break;
	              }
	            }
	          }
	
	          var allTitle = titles;
	          for (var _i3 = 0; _i3 < allTitle.length; ++_i3) {
	            for (var _j2 = 0; _j2 < qaChilds.length; ++_j2) {
	              if (allTitle[_i3].title === qaChilds[_j2].que) {
	                allTitle[_i3].tqaindex = qaChilds[_j2].qaindex;
	                break;
	              }
	            }
	          }
	          titles = allTitle;
	          _this.detail = details;
	          _this.genTitleTree(titles);
	
	          _this.$nextTick(function () {
	            this.toggleHeader();
	            this.setContMarginTop();
	            this.getwxsign();
	            if (!this.params.tcode) {
	              (0, _jquery2.default)(window).scrollTop(0);
	            }
	
	            var _allId = [];
	            if (this.shareParams.allId.length === 0) {
	              _allId = this.getAllId(this.shareParams.allId);
	            } else {
	              _allId = this.shareParams.allId;
	            }
	
	            var itemID = this.getInnerWindowId(_allId);
	            if (itemID.split('-')[1] !== 0) {
	              itemID = itemID.split('-')[0] + '-0';
	            }
	            var stype = this.params.stype;
	            var title = '';
	            if (!this.params.desc || this.params.desc == '') {
	              title = this.detail.fulltitle;
	            } else {
	              title = this.params.desc;
	            }
	            this.changeMetaTitle(title);
	
	            var desc = this.getNoticeShareDesc(stype, itemID);
	            this.shareNotice(stype, itemID, title, desc);
	          });
	
	          var allPageNum = Math.ceil(_this.detail.child.length / 3);
	          if (_this.params.tcode && _this.params.tcode !== '' && _this.params.tcode !== 'undefined-1') {
	            var id = _this.params.tcode.split('-')[0];
	            var idx = 0;
	            var pages = 0;
	            var that = _this;
	            for (var _i4 = 0; _i4 < _this.detail.child.length; ++_i4) {
	              if (_this.detail.child[_i4].code === id) {
	                idx = _i4;
	                break;
	              }
	            }
	
	            pages = Math.ceil(idx / 3);
	            _this.pages = pages;
	            _this.topPage = pages;
	            _this.bottomPage = pages;
	
	            console.log(allPageNum);
	            if (_this.params.tcode) {
	              var tcode = _this.params.tcode;
	              setTimeout(function () {
	                if (document.getElementById(tcode)) {
	                  document.getElementById(tcode).scrollIntoView();
	                  var scrollTop = (0, _jquery2.default)(window).scrollTop() - 30;
	                  (0, _jquery2.default)(window).scrollTop(scrollTop);
	                }
	              }, 100);
	            }
	
	            var timer = setInterval(function () {
	              if (that.detail.child.length > 3 && that.topPage > 1) {
	                that.topPage--;
	                console.log('top-page:' + that.topPage);
	              }
	
	              if (that.detail.child.length > 3 && that.bottomPage < allPageNum) {
	                that.bottomPage++;
	                console.log('bottom-page:' + that.bottomPage);
	              }
	
	              if (that.detail.child.length < 3) {
	                window.clearInterval(timer);
	              }
	              if (that.topPage == 1 && that.bottomPage == allPageNum) {
	                window.clearInterval(timer);
	                console.log('渲染到最后一页');
	                console.log(that.bottomPage);
	                console.log(that.allPageNum);
	              }
	            }, 100);
	          } else {
	            var _that = _this;
	            _that.topPage = 1;
	            _that.bottomPage = 1;
	            var _timer = setInterval(function () {
	              if (_that.detail.child.length > 3 && _that.bottomPage < allPageNum) {
	                _that.bottomPage++;
	              } else {
	                window.clearInterval(_timer);
	                console.log('渲染到最后一页');
	                console.log(_that.bottomPage);
	                console.log(_that.allPageNum);
	              }
	            }, 100);
	          }
	        }
	      }).fail(function (response) {
	        _this.loading = false;
	        (0, _helper.alert)('请求失败');
	      });
	    },
	    getIndex: function getIndex(item, arr) {
	      for (var i = 0; i < arr.length; ++i) {
	        if (item === arr[i]) {
	          return i;
	        }
	      }
	    },
	    setContMarginTop: function setContMarginTop() {
	      var detailH = (0, _jquery2.default)('#detail-title').height();
	      if (detailH > 0) {
	        var detailTitleH = (0, _jquery2.default)('#detail-title').height();
	        var noticeTitleH = (0, _jquery2.default)('.notice-title').height();
	        var marginTop = '';
	        if ((0, _jquery2.default)('.header-toggle-icon').height()) {
	          noticeTitleH += 8;
	          marginTop = noticeTitleH.toString() + 'px';
	        } else {
	          marginTop = detailTitleH.toString() + 'px';
	        }
	        (0, _jquery2.default)('.my-container').css({ 'marginTop': marginTop });
	      }
	    },
	    toggleHeader: function toggleHeader() {
	      var header = (0, _jquery2.default)('.toolsbar-mune');
	
	      var p = (0, _jquery2.default)(window).scrollTop();
	      var t = p;
	      var that = this;
	      (0, _jquery2.default)(window).off('scroll').on('scroll', function () {
	        if ((0, _jquery2.default)(window).scrollTop() + (0, _jquery2.default)(window).height() >= (0, _jquery2.default)(document).height() && that.showComments) {
	          var page = that.cpwpage + 1;
	          if (page <= Math.ceil(that.cpwtotal / 10)) {
	            that.getCommentList(page, 1, that.md5);
	          }
	        }
	
	        p = (0, _jquery2.default)(this).scrollTop();
	        if (t <= p) {
	          if (header.hasClass('slideDown')) {
	            header.removeClass('slideDown');
	            header.addClass('slideUp');
	          } else {
	            header.addClass('slideUp');
	          }
	        } else {
	          if (header.hasClass('slideUp')) {
	            header.removeClass('slideUp');
	            header.addClass('slideDown');
	          } else {
	            header.addClass('slideDown');
	          }
	        }
	        t = p;
	      });
	    }
	  },
	  filters: {
	    timeFilter: function timeFilter(param) {
	      param = param.split(' ')[0];
	      return param;
	    },
	    formatPhone: function formatPhone(phone) {
	      if (/^1(3|4|5|7|8)\d{9}$/.test(phone)) {
	        if (this.detail.datasrc === 'IRM') {
	          return phone.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
	        } else {
	          return phone;
	        }
	      } else if (/^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/.test(phone)) {
	        var c = phone.split('@');
	
	        var c1 = c[0].substr(3);
	        var xing = '';
	        for (var i = 0; i < c1.length; i++) {
	          xing += '*';
	        }
	        var newemail = c[0].substr(0, 3) + xing + '@' + c[1];
	        return newemail;
	      } else {
	        return phone;
	      }
	    }
	  }
	};

/***/ },
/* 384 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'AlertView'
	
	};

/***/ },
/* 385 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  name: 'ConfirmView'
	
	};

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _stringify = __webpack_require__(8);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _getIterator2 = __webpack_require__(9);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _jquery = __webpack_require__(5);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    required: false,
	    time: {
	      type: String,
	      required: true
	    },
	    showinput: {
	      default: function _default() {
	        return true;
	      }
	    },
	    showcheck: {
	      default: function _default() {
	        return false;
	      }
	    },
	    datetype: {
	      required: true
	    },
	    option: {
	      type: Object,
	      default: function _default() {
	        return {
	          type: 'day',
	          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	          format: 'YYYY-MM-DD',
	          color: {
	            header: '#3f51b5',
	            headerText: '#fff'
	          },
	          inputStyle: {
	            'display': 'inline-block',
	
	            'padding': '0px',
	            'line-height': '22px',
	            'font-size': '14px',
	            'width': '100%',
	            'background': '#F1F1F1',
	
	            'border': 'none',
	            'border-radius': '2px',
	            'color': '#5F5F5F'
	          },
	          placeholder: 'when?',
	          buttons: {
	            ok: 'OK',
	            cancel: 'Cancel'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true
	        };
	      }
	    },
	    limit: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    function hours() {
	      var list = [];
	      var hour = 24;
	      while (hour > 0) {
	        hour--;
	        list.push({
	          checked: false,
	          value: hour < 10 ? '0' + hour : hour
	        });
	      }
	      return list;
	    }
	
	    function mins() {
	      var list = [];
	      var min = 60;
	      while (min > 0) {
	        min--;
	        list.push({
	          checked: false,
	          value: min < 10 ? '0' + min : min
	        });
	      }
	      return list;
	    }
	    return {
	      hours: hours(),
	      mins: mins(),
	      showInfo: {
	        hour: false,
	        day: false,
	        month: false,
	        year: false,
	        check: false
	      },
	      displayInfo: {
	        month: ''
	      },
	      library: {
	        week: this.option.week,
	        month: this.option.month,
	        year: []
	      },
	      checked: {
	        oldtime: '',
	        currentMoment: null,
	        year: '',
	        month: '',
	        day: '',
	        hour: '00',
	        min: '00'
	      },
	      dayList: [],
	      selectedDays: []
	    };
	  },
	
	  watch: {
	    showcheck: function showcheck(val) {
	      if (val) {
	        this.showCheck();
	      } else {
	        this.showInfo.check = false;
	      }
	    }
	  },
	  methods: {
	    pad: function pad(n) {
	      return n < 10 ? '0' + n : n;
	    },
	    nextMonth: function nextMonth(type) {
	      var next = null;
	      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
	      this.showDay(next);
	    },
	    showDay: function showDay(time) {
	      if (time === undefined || !Date.parse(time)) {
	        this.checked.currentMoment = (0, _moment2.default)();
	      } else {
	        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
	      }
	      this.showOne('day');
	
	      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
	      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
	      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
	
	      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
	
	      var days = [];
	      var currentMoment = this.checked.currentMoment;
	      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
	
	      var previousMonth = (0, _moment2.default)(currentMoment);
	      var nextMonth = (0, _moment2.default)(currentMoment);
	      nextMonth.add(1, 'months');
	      previousMonth.subtract(1, 'months');
	
	      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
	      var oldtime = this.checked.oldtime;
	      for (var i = 1; i <= monthDays; ++i) {
	        days.push({
	          value: i,
	          inMonth: true,
	          unavailable: false,
	          checked: false
	        });
	        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime).month() === (0, _moment2.default)(currentMoment).month()) {
	          days[i - 1].checked = true;
	        }
	        this.checkBySelectDays(i, days);
	      }
	
	      if (firstDay === 0) firstDay = 7;
	
	      for (var _i = 0; _i < firstDay - 1; _i++) {
	        var passiveDay = {
	          value: previousMonth.daysInMonth() - _i,
	          inMonth: false,
	          action: 'previous'
	        };
	        days.unshift(passiveDay);
	      }
	
	      if (this.limit.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var li = _step.value;
	
	            switch (li.type) {
	              case 'fromto':
	                days = this.limitFromTo(li, days);
	                break;
	              case 'weekday':
	                days = this.limitWeekDay(li, days);
	                break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	
	      var passiveDaysAtFinal = 42 - days.length;
	      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
	        var _passiveDay = {
	          value: _i2,
	          inMonth: false,
	          action: 'next'
	        };
	        days.push(_passiveDay);
	      }
	      this.dayList = days;
	    },
	    checkBySelectDays: function checkBySelectDays(d, days) {
	      var _this = this;
	
	      this.selectedDays.forEach(function (day) {
	        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
	          days[d - 1].checked = true;
	        }
	      });
	    },
	    limitWeekDay: function limitWeekDay(limit, days) {
	      var _this2 = this;
	
	      days.map(function (day) {
	        var tday = void 0;
	        day.value < 10 ? tday = '0' + day.value : tday = day.value;
	
	        if (limit.available.indexOf(Math.floor((0, _moment2.default)(_this2.checked.year + '-' + _this2.checked.month + '-' + tday).format('d'))) === -1) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    limitFromTo: function limitFromTo(limit, days) {
	      var _this3 = this;
	
	      days.map(function (day) {
	        if (!(0, _moment2.default)(_this3.checked.year + '-' + _this3.checked.month + '-' + _this3.pad(day.value)).isBetween(limit.from, limit.to)) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    checkDay: function checkDay(obj) {
	      this.datetype = 99;
	      if (obj.unavailable || obj.value === '') {
	        return false;
	      }
	
	      if (!obj.inMonth) {
	        this.nextMonth(obj.action);
	      }
	
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        this.dayList.map(function (x) {
	          x.checked = false;
	        });
	        this.checked.day = this.pad(obj.value);
	        obj.checked = true;
	      } else {
	        var day = this.pad(obj.value);
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
	        if (obj.checked === true) {
	          obj.checked = false;
	          this.selectedDays.$remove(ctime);
	        } else {
	          this.selectedDays.push(ctime);
	          obj.checked = true;
	        }
	      }
	
	      switch (this.option.type) {
	        case 'day':
	          this.picked();
	          break;
	        case 'min':
	          this.showOne('hour');
	          break;
	      }
	    },
	    showYear: function showYear() {
	      var year = (0, _moment2.default)(this.checked.currentMoment).year();
	      this.library.year = [];
	      var yearTmp = [];
	      for (var i = year - 100; i < year + 5; ++i) {
	        yearTmp.push(i);
	      }
	      this.library.year = yearTmp;
	
	      this.showOne('year');
	
	      var self = this;
	      this.$nextTick(function () {
	        var listDom = document.getElementById('yearList');
	        listDom.scrollTop = listDom.scrollHeight - 100;
	        self.addYear();
	      });
	    },
	    showOne: function showOne(type) {
	      switch (type) {
	        case 'year':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = true;
	          this.showInfo.month = false;
	          break;
	        case 'month':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = true;
	          break;
	        case 'day':
	          this.showInfo.hour = false;
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        case 'hour':
	          this.showInfo.hour = true;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        default:
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          this.showInfo.hour = false;
	      }
	    },
	    showMonth: function showMonth() {
	      this.showOne('month');
	    },
	    addYear: function addYear() {
	      var self = this;
	      var listDom = document.getElementById('yearList');
	
	      listDom.addEventListener('scroll', function (e) {
	        if (listDom.scrollTop < listDom.scrollHeight - 100) {
	          var len = self.library.year.length;
	          var lastYear = self.library.year[len - 1];
	          self.library.year.push(lastYear + 1);
	        }
	      }, false);
	    },
	    setYear: function setYear(year) {
	      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    setMonth: function setMonth(month) {
	      var mo = this.library.month.indexOf(month) + 1;
	      if (mo < 10) {
	        mo = '0' + '' + mo;
	      }
	      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    showCheck: function showCheck() {
	      if (this.time === '') {
	        this.showDay();
	      } else {
	        if (this.option.type === 'day' || this.option.type === 'min') {
	          this.checked.oldtime = this.time;
	          this.showDay(this.time);
	        } else {
	          this.selectedDays = JSON.parse(this.time);
	          if (this.selectedDays.length) {
	            this.checked.oldtime = this.selectedDays[0];
	            this.showDay(this.selectedDays[0]);
	          } else {
	            this.showDay();
	          }
	        }
	      }
	      this.showcheck = true;
	      this.showInfo.check = true;
	    },
	    setTime: function setTime(type, obj, list) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          item.checked = false;
	          if (item.value === obj.value) {
	            item.checked = true;
	            this.checked[type] = item.value;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    picked: function picked() {
	      this.datetype = 99;
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
	        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
	        this.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
	      } else {
	        this.time = (0, _stringify2.default)(this.selectedDays);
	      }
	      this.showcheck = false;
	      this.showInfo.check = false;
	    },
	    dismiss: function dismiss(evt) {
	      if (evt.target.className === 'datepicker-overlay') {
	        if (this.option.dismissible === undefined || this.option.dismissible) {
	          this.showcheck = false;
	          this.showInfo.check = false;
	        }
	      }
	    },
	    clearinput: function clearinput() {
	      this.datetype = 99;
	      this.time = '';
	      this.showcheck = false;
	      this.showInfo.check = false;
	    },
	    today: function today() {
	      this.datetype = 99;
	      this.checked.year = (0, _moment2.default)().format('YYYY');
	      this.checked.month = (0, _moment2.default)().format('MM');
	      this.checked.day = (0, _moment2.default)().format('DD');
	      this.picked();
	    }
	  }
	};

/***/ },
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 726 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 727 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 728 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 729 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 730 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 731 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 732 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 733 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 734 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 735 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 736 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 737 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 738 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 739 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 740 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 741 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 742 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 743 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 744 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 745 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 746 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 747 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 748 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 749 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 750 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 751 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 752 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 753 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 754 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 755 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 756 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 757 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 758 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 759 */,
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 231,
		"./af.js": 231,
		"./ar": 237,
		"./ar-dz": 232,
		"./ar-dz.js": 232,
		"./ar-ly": 233,
		"./ar-ly.js": 233,
		"./ar-ma": 234,
		"./ar-ma.js": 234,
		"./ar-sa": 235,
		"./ar-sa.js": 235,
		"./ar-tn": 236,
		"./ar-tn.js": 236,
		"./ar.js": 237,
		"./az": 238,
		"./az.js": 238,
		"./be": 239,
		"./be.js": 239,
		"./bg": 240,
		"./bg.js": 240,
		"./bn": 241,
		"./bn.js": 241,
		"./bo": 242,
		"./bo.js": 242,
		"./br": 243,
		"./br.js": 243,
		"./bs": 244,
		"./bs.js": 244,
		"./ca": 245,
		"./ca.js": 245,
		"./cs": 246,
		"./cs.js": 246,
		"./cv": 247,
		"./cv.js": 247,
		"./cy": 248,
		"./cy.js": 248,
		"./da": 249,
		"./da.js": 249,
		"./de": 251,
		"./de-at": 250,
		"./de-at.js": 250,
		"./de.js": 251,
		"./dv": 252,
		"./dv.js": 252,
		"./el": 253,
		"./el.js": 253,
		"./en-au": 254,
		"./en-au.js": 254,
		"./en-ca": 255,
		"./en-ca.js": 255,
		"./en-gb": 256,
		"./en-gb.js": 256,
		"./en-ie": 257,
		"./en-ie.js": 257,
		"./en-nz": 258,
		"./en-nz.js": 258,
		"./eo": 259,
		"./eo.js": 259,
		"./es": 261,
		"./es-do": 260,
		"./es-do.js": 260,
		"./es.js": 261,
		"./et": 262,
		"./et.js": 262,
		"./eu": 263,
		"./eu.js": 263,
		"./fa": 264,
		"./fa.js": 264,
		"./fi": 265,
		"./fi.js": 265,
		"./fo": 266,
		"./fo.js": 266,
		"./fr": 269,
		"./fr-ca": 267,
		"./fr-ca.js": 267,
		"./fr-ch": 268,
		"./fr-ch.js": 268,
		"./fr.js": 269,
		"./fy": 270,
		"./fy.js": 270,
		"./gd": 271,
		"./gd.js": 271,
		"./gl": 272,
		"./gl.js": 272,
		"./he": 273,
		"./he.js": 273,
		"./hi": 274,
		"./hi.js": 274,
		"./hr": 275,
		"./hr.js": 275,
		"./hu": 276,
		"./hu.js": 276,
		"./hy-am": 277,
		"./hy-am.js": 277,
		"./id": 278,
		"./id.js": 278,
		"./is": 279,
		"./is.js": 279,
		"./it": 280,
		"./it.js": 280,
		"./ja": 281,
		"./ja.js": 281,
		"./jv": 282,
		"./jv.js": 282,
		"./ka": 283,
		"./ka.js": 283,
		"./kk": 284,
		"./kk.js": 284,
		"./km": 285,
		"./km.js": 285,
		"./ko": 286,
		"./ko.js": 286,
		"./ky": 287,
		"./ky.js": 287,
		"./lb": 288,
		"./lb.js": 288,
		"./lo": 289,
		"./lo.js": 289,
		"./lt": 290,
		"./lt.js": 290,
		"./lv": 291,
		"./lv.js": 291,
		"./me": 292,
		"./me.js": 292,
		"./mi": 293,
		"./mi.js": 293,
		"./mk": 294,
		"./mk.js": 294,
		"./ml": 295,
		"./ml.js": 295,
		"./mr": 296,
		"./mr.js": 296,
		"./ms": 298,
		"./ms-my": 297,
		"./ms-my.js": 297,
		"./ms.js": 298,
		"./my": 299,
		"./my.js": 299,
		"./nb": 300,
		"./nb.js": 300,
		"./ne": 301,
		"./ne.js": 301,
		"./nl": 303,
		"./nl-be": 302,
		"./nl-be.js": 302,
		"./nl.js": 303,
		"./nn": 304,
		"./nn.js": 304,
		"./pa-in": 305,
		"./pa-in.js": 305,
		"./pl": 306,
		"./pl.js": 306,
		"./pt": 308,
		"./pt-br": 307,
		"./pt-br.js": 307,
		"./pt.js": 308,
		"./ro": 309,
		"./ro.js": 309,
		"./ru": 310,
		"./ru.js": 310,
		"./se": 311,
		"./se.js": 311,
		"./si": 312,
		"./si.js": 312,
		"./sk": 313,
		"./sk.js": 313,
		"./sl": 314,
		"./sl.js": 314,
		"./sq": 315,
		"./sq.js": 315,
		"./sr": 317,
		"./sr-cyrl": 316,
		"./sr-cyrl.js": 316,
		"./sr.js": 317,
		"./ss": 318,
		"./ss.js": 318,
		"./sv": 319,
		"./sv.js": 319,
		"./sw": 320,
		"./sw.js": 320,
		"./ta": 321,
		"./ta.js": 321,
		"./te": 322,
		"./te.js": 322,
		"./tet": 323,
		"./tet.js": 323,
		"./th": 324,
		"./th.js": 324,
		"./tl-ph": 325,
		"./tl-ph.js": 325,
		"./tlh": 326,
		"./tlh.js": 326,
		"./tr": 327,
		"./tr.js": 327,
		"./tzl": 328,
		"./tzl.js": 328,
		"./tzm": 330,
		"./tzm-latn": 329,
		"./tzm-latn.js": 329,
		"./tzm.js": 330,
		"./uk": 331,
		"./uk.js": 331,
		"./uz": 332,
		"./uz.js": 332,
		"./vi": 333,
		"./vi.js": 333,
		"./x-pseudo": 334,
		"./x-pseudo.js": 334,
		"./yo": 335,
		"./yo.js": 335,
		"./zh-cn": 336,
		"./zh-cn.js": 336,
		"./zh-hk": 337,
		"./zh-hk.js": 337,
		"./zh-tw": 338,
		"./zh-tw.js": 338
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 760;


/***/ },
/* 761 */,
/* 762 */,
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/bottom-code.1adb5eb.png";

/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/head-a.2e16aa1.png";

/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/logo.dd5203a.gif";

/***/ },
/* 766 */,
/* 767 */
/***/ function(module, exports) {

	module.exports = "<router-view class=view keep-alive transition transition-mode=out-in> </router-view>";

/***/ },
/* 768 */
/***/ function(module, exports) {

	module.exports = "<div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block;overflow:hidden\" v-if=bigimgobj.show> <div class=index-flex-main> <div class=index-flex-box> <div class=login-close> <a class=delete-icon href=javascript:; @click=\"bigimgobj.show = false\"></a> </div> <div class=intelligent-fsearch1> <div class=fsearch-a> <p class=text-b>{{{bigimgobj.imghead}}}</p> <p class=text-a><img src={{bigimgobj.imgurl}}></p> </div> <p class=text-c>{{{bigimgobj.imgfoot}}}</p> </div> <div class=text-right> <a class=btn-eit href=javascript:; @click=tpCollect(bigimgobj)>收藏</a> </div> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-if=bigimgobj.show></div>";

/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=wrapper style=background:white> <div class=search-header> <div class=search-header-text>我的订阅</div> </div> <div class=\"Push-article-box article-a\"> <div class=Push-article-list v-for=\"item in subscribeList\"> <div class=head-title @click=\"goMessagePage(item), setCnzz('我的订阅', '点击查看我的订阅内容', '')\"> {{item.name}} </div> </div> </div> <div class=ubscribe-news-no v-if=loading> <div class=ubscribe-news-no-cont> <img src=" + __webpack_require__(143) + "> </div> </div> <div class=ubscribe-news-no v-if=\"!loading && subscribeList.length == 0\"> 快到网页端订阅资讯吧 </div> </div>";

/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=container> <div class=loading_gif> <img src=" + __webpack_require__(104) + " class=loading-img> <p style=font-size:14px>数据加载中,请稍等...</p> </div> <canvas id=theCanvas style=background-size:cover;overflow:scroll></canvas> <div class=scrolltext v-show=show>{{page}}/<span class=page_count></span></div> <div id=Main v-show=show> <div class=prev @click=prev style=\"background-image:url('../../static/images/left.png'); background-size:cover\"></div> <div class=next @click=next style=\"background-image:url('../../static/images/right.png');background-size:cover;background-position:-10px 0px\"></div> <div id=scrollBar> <div id=scroll_Track></div> <div id=scroll_Thumb></div> </div> </div> </div>";

/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" :style=\"{display: showflag?'block':'none'}\"> <div class=binding-content @click=close> <div class=knowledge-base-name>{{ message }}</div> <div class=knowledge-tag-head> <img src=" + __webpack_require__(343) + "> <div class=right> <p>抱歉目前您没有此权限 </p> 请扫描左方二维码联系小助手获取权限<br> </div> </div> </div> </div> <div class=\"modal-backdrop fade in\" :style=\"{display: showflag?'block':'none'}\"></div>";

/***/ },
/* 772 */
/***/ function(module, exports) {

	module.exports = "<div class=search-result-list v-for=\"item in items\" track-by=$index> <p class=head> <span class=\"{{ fileIcon(item.fileext) }}\"></span> <a v-if=\"stype!=5&&stype != 10\" style=cursor:pointer @click=\"checkLogin(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')\" class=green>{{{ item.fulltitle }}}</a> <a v-if=\"stype == 10\" style=cursor:pointer @click=\"openAbsAnn(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')\" class=green>{{{ item.fulltitle }}}</a> <a v-if=\"stype==5\" style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')\" class=green>{{{ item.fulltitle }}}</a> </p> <p class=Subtitle> {{ item.publishDate ? item.publishDate: item.uploadTime }} <span class=marginlf-10>{{ item.companyCode }}</span> <span class=marginlf-10 v-if=item.author>作者: {{ item.author }}</span> <span class=marginlf-10 v-if=item.nickname>公众号: {{ item.nickname }}</span> </p> <p class=lien v-if=\"item.content && item.content!='NoContent'\"> {{{ item.content.join('...... ') }}} </p> <template v-if=item.child> <template v-for=\"child in item.child\"> <p class=\"blak font-weight lien child-title\" :style=indentChild(child.code) @click=\"viewChildTitle(item, child.code)\" style=cursor:pointer> {{{ child.title }}} </p> <p class=lien :style=indentChild(child.code) v-if=child.content> {{{ child.content.join('...... ') }}} </p> <template v-if=child.contents> <template v-for=\"c in child.contents\"> <p class=lien :style=indentChild(child.code) v-if=\"c.htmltag=='p'\"> {{{ c.content }}}<br> </p> <template v-if=\"c.htmltag=='table'\"> <div class=table-result-outter> <table cellpadding=0 class=table-result> <tbody> <tr v-for=\"(rowidx, row) in c.table\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\"> <td v-for=\"(colidx, col) in row\" rowspan=\"{{ col.row }}\" colspan=\"{{ col.col }}\" track-by=$index> {{{col.value}}} </td> </tr> </tbody> </table> </div> <div class=table-whole> <a href=javascript:; @click=\"viewTable(item, child.code, c.offset), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')\"> <span class=table-see-icon></span>查看表格全部内容 </a> </div> </template> </template> </template> <div class=intelligent-fsearch-cont v-if=child.imgs> <template v-for=\"c in child.imgs\"> <div class=fsearch-a> <div class=more-img style=cursor:pointer title=点击查看更多 @click=\"setBigImgObj(c, item)\"> <img :src=c.imgurl> </div> <div class=text-a>{{{child.title}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\">{{{c.imghead}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\">{{{c.imgfoot}}}</div> </div> </template> </div> </template> </template> </div> <div v-show=loading class=page-loading style=width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\"> <img src=/static/images/loading.gif width=150 /> </div> </div> <bigimg :bigimgobj=bigImgObj v-if=bigImgObj.show></bigimg>";

/***/ },
/* 773 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=wrapper style=background:white> <div class=search-header> <div class=search-header-text>推送结果</div> </div> <div class=Push-article-setting> 重大事件 </div> <div class=Push-article-box> <div class=Push-article-list v-for=\"(index,item) in eventMessage\"> <div class=head-title @click=\"view(item), setCnzz('我的订阅', '查看公告', '')\" style=font-size:0.8rem> {{item.title}} </div> <div class=head-industry> <span class=\"head-time-category head-category-b\" v-for=\"i in item.labels\">{{i}}</span> </div> <div class=head-time><span class=head-time-fl v-if=item.companyCode>证券代码：{{item.companyCode}}</span> <span class=head-time-fr>{{item.publishDate}}</span></div> <div class=Related-announ v-if=\"item.childcnt && item.childcnt > 0\" @click.stop=getRelation(index)> <h3> 相关公告({{item.childcnt}}) <span class=release-open v-if=!item.showrelationnotice></span> <span class=release-close v-if=item.showrelationnotice></span> </h3> <ul v-if=\"item.showrelationnotice && item.relationItems && item.relationItems.length > 0\"> <li v-for=\"z in item.relationItems\" @click.stop=view(z)> {{z.title}} <span class=head-time-fr>{{z.publishDate}}</span> </li> </ul> <ul v-if=\"item.showrelationnotice && item.relationItems && item.relationItems.length === 0\"> <li style=\"text-align:center;color: silver\"> 无公告数据 </li> </ul> </div> </div> </div> <div class=ubscribe-news-no v-if=\"loading == 1\"> <div class=ubscribe-news-no-cont> <img src=" + __webpack_require__(143) + "> </div> </div> <div class=ubscribe-news-no v-if=\"loading == 2\"> 已全部加载 </div> <div class=ubscribe-news-no v-if=\"loading == 3\"> 暂无消息 </div> </div>";

/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=wrapper style=background:white> <div class=search-header> <div class=search-header-text>新通知</div> </div> <div class=Push-article-setting> 订阅名：{{name}} </div> <div class=\"Push-article-box article-a\"> <div class=Push-article-list v-for=\"item in eventmsg\"> <div class=head-title @click=\"goEventMessage(item),setCnzz('我的订阅', '点击查看该通知下的新消息', '')\"> {{item.name}} <span style=color:red>({{item.content.total}})</span> <span class=head-title-time>{{item.addtime | time}}</span> </div> <div class=ubscribe-news-message style=margin-top:0.15rem> <a>{{item.content.lists[0].title}}</a> </div> </div> </div> <div class=ubscribe-news-no v-if=\"loading == 1\"> <div class=ubscribe-news-no-cont> <img src=" + __webpack_require__(143) + "> </div> </div> <div class=ubscribe-news-no v-if=\"loading == 2\"> 已全部加载 </div> <div class=ubscribe-news-no v-if=\"loading == 3\"> 暂无通知 </div> </div>";

/***/ },
/* 775 */
/***/ function(module, exports) {

	module.exports = "<div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" :style=\"{display: showflag?'block':'none'}\"> <div class=delete-content> <div class=right> <a title=关闭 href=javascript:;><button type=button class=\"dle font16\" @click=cancel()><span class=\"glyphicon glyphicon-remove\"></span></button></a> </div> <div class=delt-cont> <div class=dn> <span class=\"img left\"><img src=/static/images/logo-s.png alt=user></span> <div class=delt-bot> <span class=t> {{ message }} </span> <button type=button class=\"btn btn-del right30\" @click=ok()>确 定</button> <button type=button class=\"btn btn-del right30\" @click=cancel()>取 消</button> </div> </div> </div> </div> </div> <div class=\"modal-backdrop fade in\" :style=\"{display: showflag?'block':'none'}\"></div>";

/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=wrap id=wrap _v-0010b618=\"\"> <div class=wrapper style=\"padding-bottom: 0\" _v-0010b618=\"\"> <div class=knowledge-list _v-0010b618=\"\"> <div class=knowledge-Downloads _v-0010b618=\"\"> <div class=knowledge-Downloads-name v-if=countMax _v-0010b618=\"\"> 抱歉您的（下载量/浏览量）已达（单日/本月/合计）最高次数。<br _v-0010b618=\"\"> </div> <div class=knowledge-Downloads-name v-if=nopermission _v-0010b618=\"\"> 抱歉，暂无权限<br _v-0010b618=\"\"> </div> <p class=QR-code v-if=countMax _v-0010b618=\"\">扫描下方二维码，联系小助手领取更多使用次数。</p> <p class=QR-code v-if=nopermission _v-0010b618=\"\">扫描下方二维码，联系小助手升级VIP用户。</p> <div class=knowledge-tag-head _v-0010b618=\"\"> <img src=" + __webpack_require__(343) + " _v-0010b618=\"\"> </div> </div> </div> </div> </div>";

/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=container _v-09de152a=\"\"> <div v-show=loading class=page-loading style=width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8 _v-09de152a=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-09de152a=\"\"> <img src=/static/images/loading.gif width=150 _v-09de152a=\"\"> </div> </div> <div class=\"page-content ar-detail\" _v-09de152a=\"\"> <div class=media-cont _v-09de152a=\"\"> <div class=media-cont-logo _v-09de152a=\"\"> <img src=" + __webpack_require__(764) + " _v-09de152a=\"\"> </div> <div class=detail-logo _v-09de152a=\"\"> <img src=" + __webpack_require__(765) + " _v-09de152a=\"\"> </div> </div> <div class=detail _v-09de152a=\"\"> <div class=media-cont-title _v-09de152a=\"\"> {{ articleInfo.title }} <div class=media-meta-list _v-09de152a=\"\"> <span class=media-meta-day _v-09de152a=\"\">{{ addtime }}</span> </div> </div> {{{ articleInfo.content }}} <br _v-09de152a=\"\"> <p class=\"font-weight blue\" _v-09de152a=\"\">大家都在用IBDATA，你不用就亏了。想叱咤资本市场，想笑看起起落落，想机会尽在掌握，来IBDATA就对了。</p> <span class=detail-img _v-09de152a=\"\"> <img src=" + __webpack_require__(763) + " _v-09de152a=\"\"> </span> </div> </div> </div>";

/***/ },
/* 778 */
/***/ function(module, exports) {

	module.exports = "<div _v-12fb9336=\"\"> <div class=header _v-12fb9336=\"\"> <span class=logo _v-12fb9336=\"\"></span> <button id=gonow class=header-button _v-12fb9336=\"\">立即体验</button> <span class=header-login _v-12fb9336=\"\">登录</span> </div> <div id=banner_tabs class=flexslider _v-12fb9336=\"\"> <ul class=slides _v-12fb9336=\"\"> <li _v-12fb9336=\"\"> <a title=\"\" href=javascript:; _v-12fb9336=\"\"> <img src=/static/images/app/banner_a-2.png width=100% height=100% _v-12fb9336=\"\"> </a> </li> <li _v-12fb9336=\"\"> <a title=\"\" href=javascript:; _v-12fb9336=\"\"> <img src=/static/images/app/banner_b-2.png width=100% height=100% _v-12fb9336=\"\"> </a> </li> <li _v-12fb9336=\"\"> <a title=\"\" href=javascript:; _v-12fb9336=\"\"> <img src=/static/images/app/banner_c-2.png width=100% height=100% _v-12fb9336=\"\"> </a> </li> </ul> <ol id=bannerCtrl class=\"flex-control-nav flex-control-paging\" _v-12fb9336=\"\"> <li _v-12fb9336=\"\"><a _v-12fb9336=\"\">1</a></li> <li _v-12fb9336=\"\"><a _v-12fb9336=\"\">2</a></li> <li _v-12fb9336=\"\"><a _v-12fb9336=\"\">2</a></li> </ol> </div> <div class=introduction _v-12fb9336=\"\">人工智能和大数据技术驱动的投研首选平台</div> <div class=transit _v-12fb9336=\"\"></div> <div class=search-style _v-12fb9336=\"\"> <span class=search-style-text _v-12fb9336=\"\"></span> <span class=search-style-pic _v-12fb9336=\"\"></span> <ul class=search-style-fixed _v-12fb9336=\"\"> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">提供对A股、新三板、债券等市场的公开信息披露搜索</div> </li> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">提供对证监会、投资者和企业间问答内容的搜索（独家仅有）</div> </li> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">支持对指定公司、行业、公告类型、市场板块的定向搜索</div> </li> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">搜索关键词可按照“和、或、非”的关系任意组合</div> </li> </ul> </div> <div class=transit _v-12fb9336=\"\"></div> <div class=advsearch-style _v-12fb9336=\"\"> <span class=advsearch-style-text _v-12fb9336=\"\"></span> <span class=advsearch-style-pic _v-12fb9336=\"\"></span> <ul class=advsearch-style-fixed _v-12fb9336=\"\"> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">可从行业、注册地址、财务数据等多个维度叠加限制条件，搜索指定公司</div> </li> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">可从公告类型、公告标题、章节标题等多个维度叠加限制条件，搜索指定内容</div> </li> <li _v-12fb9336=\"\"> <div class=triangle-f _v-12fb9336=\"\"><img src=/static/images/app/Triangle.png alt=\"\" _v-12fb9336=\"\"></div> <div class=triangle-text _v-12fb9336=\"\">各种条件可以层层叠加，实现精准搜索效果</div> </li> </ul> <div class=they-all-use _v-12fb9336=\"\"></div> </div> <div class=users _v-12fb9336=\"\"></div> <div class=bottom _v-12fb9336=\"\"></div> <div class=cover _v-12fb9336=\"\"></div> <div class=alertPage _v-12fb9336=\"\"> <div class=alertPage-text _v-12fb9336=\"\">①获取内测邀请码</div> <div class=jieshao _v-12fb9336=\"\">即刻添加尽调小助手的微信，领取邀请码</div> <div class=jieshao _v-12fb9336=\"\">免费体验年费过万的超强金融搜索引擎和智能分析工具</div> <div class=erweima _v-12fb9336=\"\"></div> <div class=alertPage-text _v-12fb9336=\"\">②前往<a href=http://www.ibdata.cn/#!/ _v-12fb9336=\"\">www.ibdata.cn</a>注册</div> </div> </div>";

/***/ },
/* 779 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-1839462b=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-1839462b=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-1839462b=\"\"> <div class=loading-img _v-1839462b=\"\"></div> </div> </div> <div class=search-company-box v-if=!loading _v-1839462b=\"\"> <div class=dhy-details-box _v-1839462b=\"\"> <div class=dhy-list-box _v-1839462b=\"\"> <ul v-if=\"stype != 6\" _v-1839462b=\"\"> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">公司名称</p> <p class=time _v-1839462b=\"\">{{company.name | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">所属地域</p> <p class=time _v-1839462b=\"\">{{company.area | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">英文名称</p> <p class=time _v-1839462b=\"\">{{company.name_en | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">所属行业</p> <p class=time _v-1839462b=\"\">{{company.industry | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">证券简称</p> <p class=time _v-1839462b=\"\">{{company.shortname | kong}}</p></li> <li _v-1839462b=\"\"> <p class=date _v-1839462b=\"\">曾 用 名</p> <p class=time _v-1839462b=\"\"> <a href=javascript:; v-if=\"!company.oldname ||　company.oldname.length==0\" _v-1839462b=\"\"> - </a> <template v-if=\"company.oldname &amp;&amp;　company.oldname.length>0\"> <a href=javascript:; v-for=\"h in company.oldname\" _v-1839462b=\"\"> {{ h.name | kong }}</a> <p _v-1839462b=\"\"></p> </template> </p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">公司网址</p> <p class=time _v-1839462b=\"\">{{company.website | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">董　　秘</p> <p class=time _v-1839462b=\"\">{{company.secretaries | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">法人代表</p> <p class=time _v-1839462b=\"\">{{company.legalRepresentative | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">注册资本</p> <p class=time _v-1839462b=\"\">{{company.regmoney | thousands}}{{company.regmoneyunit}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">电　　话</p> <p class=time _v-1839462b=\"\">{{company.phone | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">传　　真</p> <p class=time _v-1839462b=\"\">{{company.fax | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">邮　　编</p> <p class=time _v-1839462b=\"\">{{company.postcode | kong}}</p></li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">办公地址</p> <p class=time _v-1839462b=\"\">{{company.address | kong}}</p></li> </ul> <ul v-if=\"stype == 6\" _v-1839462b=\"\"> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">公司名称:</div> <div class=time _v-1839462b=\"\"><span _v-1839462b=\"\">{{company.name| kong}}</span></div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">所属地域:</div> <div class=time _v-1839462b=\"\">{{company.area | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">主营业务:</div> <div class=time _v-1839462b=\"\">{{company.business | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">会　　计:</div> <div class=time _v-1839462b=\"\">{{company.accountant | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">律　　师:</div> <div class=time _v-1839462b=\"\">{{company.lawyers | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">银　　行:</div> <div class=time _v-1839462b=\"\">{{company.banks | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">所属行业:</div> <div class=time _v-1839462b=\"\">{{company.industry}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">证券简称:</div> <div class=time _v-1839462b=\"\">{{company.shortname | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">公司网址:</div> <div class=time _v-1839462b=\"\">{{company.web | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\"> email:</div> <div class=time _v-1839462b=\"\">{{company.email | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\"> CEO:</div> <div class=time _v-1839462b=\"\">{{company.ceo | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\"> 董事长:</div> <div class=time _v-1839462b=\"\">{{company.legalRepresentative | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">秘　　书:</div> <div class=time _v-1839462b=\"\">{{company.secretary | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">上市时间:</div> <div class=time _v-1839462b=\"\">{{company.listingDate | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">上市类型:</div> <div class=time _v-1839462b=\"\">{{company.listingcategory | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">状　　态:</div> <div class=time _v-1839462b=\"\">{{company.status | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">登记地点:</div> <div class=time _v-1839462b=\"\">{{company.transferoffice | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">电　　话:</div> <div class=time _v-1839462b=\"\">{{company.phone | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">传　　真:</div> <div class=time _v-1839462b=\"\">{{company.fax | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">邮　　编:</div> <div class=time _v-1839462b=\"\">{{company.postcode | kong}}</div> </li> <li class=list _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">更新时间:</div> <div class=time _v-1839462b=\"\">{{company.updtime | kong}}</div> </li> <li class=\"list list-w\" _v-1839462b=\"\"> <div class=date _v-1839462b=\"\">办公地址:</div> <div class=time _v-1839462b=\"\">{{company.address | kong}}</div> </li> </ul> </div> </div> <div class=pledge-list-box1 v-if=company.businessscope _v-1839462b=\"\"> <ul _v-1839462b=\"\"> <li class=active _v-1839462b=\"\">主营业务</li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">经营范围</p><p class=time _v-1839462b=\"\">{{ company.businessscope }}</p></li> </ul> </div> <div class=pledge-box1 v-if=\"company.biangen.length > 0\" _v-1839462b=\"\"> <h3 class=\"\" _v-1839462b=\"\">发行相关</h3> <div class=pledge-list-box _v-1839462b=\"\"> <ul _v-1839462b=\"\"> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">历史沿革</p> </li> <li _v-1839462b=\"\"><p class=date _v-1839462b=\"\">{{ company.founddate }}</p><p class=time _v-1839462b=\"\">公司成立</p></li> <li v-for=\"i in company.biangen\" _v-1839462b=\"\"> <p class=date _v-1839462b=\"\">{{ i.changedate }}</p> <p class=time _v-1839462b=\"\"> 变更类型：{{i.item}} <template v-if=\"i.changebefore &amp;&amp; i.changeafter &amp;&amp; i.changebefore !== i.changeafter\">，变更内容：由{{i.changebefore}}变为{{i.changeafter}}</template> <template v-if=\"!i.changebefore &amp;&amp; i.changeafter\">，变更内容：变为{{i.changeafter}}</template> </p> </li> </ul> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind :style=\"{'display': tipGoBind ? 'block' : 'none'}\" _v-1839462b=\"\"> <div class=binding-content _v-1839462b=\"\"> <a class=binding-logo _v-1839462b=\"\"></a> <div class=binding-text _v-1839462b=\"\"> 立即绑定IBDATA账号<br _v-1839462b=\"\">成为金融分析高手 </div> <div class=binding-bot _v-1839462b=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-1839462b=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-1839462b=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-1839462b=\"\"></div>";

/***/ },
/* 780 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-18c3ea04=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-18c3ea04=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-18c3ea04=\"\"> <div class=loading-img _v-18c3ea04=\"\"></div> </div> </div> <div class=search-company-box _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <label class=el-radio _v-18c3ea04=\"\"> <span class=\"el-radio-input is-checked\" :class=\"{'is-checked': reporting}\" @click=\"reporting=true, curDateType = finance[0][0]\" _v-18c3ea04=\"\"> <span class=el-radio-inner _v-18c3ea04=\"\"></span> <input class=el-radio-original value=按报告期 type=radio _v-18c3ea04=\"\"> </span> <span class=el-radio-label _v-18c3ea04=\"\">按报告期</span> </label> <label class=el-radio _v-18c3ea04=\"\"> <span class=el-radio-input :class=\"{'is-checked': !reporting}\" @click=\"reporting=false, curDateType = yearList[0][0]\" _v-18c3ea04=\"\"> <span class=el-radio-inner _v-18c3ea04=\"\"></span> <input class=el-radio-original value=按年度 type=radio _v-18c3ea04=\"\"> </span> <span class=el-radio-label _v-18c3ea04=\"\">按年度</span> </label> <div class=Quarterly-Report _v-18c3ea04=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-18c3ea04=\"\"> {{ curDateType }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-18c3ea04=\"\"></span> </div> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; reporting\" _v-18c3ea04=\"\"> <li v-for=\"h in finance\" _v-18c3ea04=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-18c3ea04=\"\">{{ h[0] }}</a> </li> </ul> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; !reporting\" _v-18c3ea04=\"\"> <li v-for=\"h in yearList\" _v-18c3ea04=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-18c3ea04=\"\">{{ h[0] }}</a> </li> </ul> </div> </div> <template v-if=reporting> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">投资与收益</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=0 &amp;&amp; index <=2\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">偿债能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=3 &amp;&amp; index <=6\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">盈利能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=7 &amp;&amp; index <=8\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">经营能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index == 9\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">其他指标</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >= 10\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> </template> <template v-if=!reporting> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">投资与收益</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=0 &amp;&amp; index <=2\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">偿债能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=3 &amp;&amp; index <=6\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">盈利能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >=7 &amp;&amp; index <=8\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">经营能力</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index == 9\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> <div class=pledge-box1 _v-18c3ea04=\"\"> <div class=pledge-box1-top _v-18c3ea04=\"\"> <h3 _v-18c3ea04=\"\">其他指标</h3> </div> <div class=Single-list-main _v-18c3ea04=\"\"> <ul class=Single-list-box _v-18c3ea04=\"\"> <li v-for=\"(index, h) in zhnl\" track-by=$index v-if=\"index >= 10\" _v-18c3ea04=\"\"> <p class=date _v-18c3ea04=\"\">{{ h[0] }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-18c3ea04=\"\"> {{ v[1][ h[1] ] ? v[1][ h[1] ] : '--' | money }} </p> </template> </li> </ul> </div> </div> </template> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-18c3ea04=\"\"> <div class=binding-content _v-18c3ea04=\"\"> <a class=binding-logo _v-18c3ea04=\"\"></a> <div class=binding-text _v-18c3ea04=\"\"> 立即绑定IBDATA账号<br _v-18c3ea04=\"\">成为金融分析高手 </div> <div class=binding-bot _v-18c3ea04=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-18c3ea04=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-18c3ea04=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-18c3ea04=\"\"></div>";

/***/ },
/* 781 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-215d4518=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-215d4518=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-215d4518=\"\"> <div class=loading-img _v-215d4518=\"\"></div> </div> </div> <div class=search-company-box _v-215d4518=\"\"> <div class=pledge-box1 _v-215d4518=\"\"> <div class=pledge-box1 _v-215d4518=\"\"> <div class=Single-list-main v-if=\"dragonTigerLists.length > 0\" _v-215d4518=\"\"> <template v-for=\"(index, h) in dragonTigerLists\" track-by=$index> <ul class=Single-list-box _v-215d4518=\"\"> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">交易日期</p> <p class=time _v-215d4518=\"\">{{ h.date }}</p></li> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">成交均价(元)</p> <p class=time _v-215d4518=\"\">{{ h.cjj | money }}</p></li> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">成交额(万元)</p> <p class=time _v-215d4518=\"\">{{ h.summoney | money }}</p></li> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">成交量(万股)</p> <p class=time _v-215d4518=\"\">{{ h.quantity | money }}</p></li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">上榜原因</p> <p class=time _v-215d4518=\"\">{{ h.reasonstr }} <span class=nowclass _v-215d4518=\"\">（{{ h.ratio}}%）</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">操作</p> <p class=\"time links\" _v-215d4518=\"\"> <a href=javascript:; class=mm-top-five-btn style=\"color: #0b66b7;text-decoration: underline\" v-if=\"showTopRow !== h.id\" @click.top=\"viewStockTop2(h.date, h.reason, h.id)\" _v-215d4518=\"\">查看交易明细</a> <a href=javascript:; class=mm-top-five-btn style=\"color: #0b66b7;text-decoration: underline\" v-if=\"showTopRow === h.id\" @click.top=hideStockTop(h.id) _v-215d4518=\"\">关闭交易明细</a> </p> </li> </ul> <div style=\"display: none\" class=\"top5-detail top5-detail-{{ h.id }}\" _v-215d4518=\"\"> <div class=\"pledge-list-box1 cop-list-box2\" _v-215d4518=\"\"> <template v-for=\"(idx, item) in buyTop5\"> <ul v-if=\"idx == 0\" _v-215d4518=\"\"> <li class=active _v-215d4518=\"\">买入金额最大的前五名</li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">交易营业部名称 </p> <p class=time _v-215d4518=\"\">{{ item.unitname }}</p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">买入金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(item.buy) == 1\" _v-215d4518=\"\">{{ item.buy | money }}</span> <span v-if=\"isShow(item.buy) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">卖出金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-green v-if=\"isShow(item.sell) == 1\" _v-215d4518=\"\">{{ item.sell | money }}</span> <span v-if=\"isShow(item.sell) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">净买入（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(item.jmr) == 1\" _v-215d4518=\"\">{{ item.jmr | money }}</span> <span class=infor-green v-if=\"isShow(item.jmr) == 2\" _v-215d4518=\"\">{{ item.jmr | money }}</span> <span v-if=\"isShow(item.jmr) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> </ul> <ul v-else=\"\" _v-215d4518=\"\"> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">交易营业部名称 </p> <p class=time _v-215d4518=\"\">{{ item.unitname }}</p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">买入金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(item.buy) == 1\" _v-215d4518=\"\">{{ item.buy | money }}</span> <span v-if=\"isShow(item.buy) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">卖出金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-green v-if=\"isShow(item.sell) == 1\" _v-215d4518=\"\">{{ item.sell | money }}</span> <span v-if=\"isShow(item.sell) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">净买入（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(item.jmr) == 1\" _v-215d4518=\"\">{{ item.jmr | money }}</span> <span class=infor-green v-if=\"isShow(item.jmr) == 2\" _v-215d4518=\"\">{{ item.jmr | money }}</span> <span v-if=\"isShow(item.jmr) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> </ul> </template> </div> <div class=\"pledge-list-box1 cop-list-box2\" _v-215d4518=\"\"> <template v-for=\"(idx2, h) in sellTop5\"> <ul v-if=\"idx2 == 0\" _v-215d4518=\"\"> <li class=active _v-215d4518=\"\">卖出金额最大的前五名</li> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">交易营业部名称 </p><p class=time _v-215d4518=\"\">{{ h.unitname }}</p></li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">买入金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(h.buy) == 1\" _v-215d4518=\"\">{{ h.buy | money }}</span> <span v-if=\"isShow(h.buy) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">卖出金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-green v-if=\"isShow(h.sell) == 1\" _v-215d4518=\"\">{{ h.sell | money }}</span> <span v-if=\"isShow(h.sell) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">净买入（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(h.jmr) == 1\" _v-215d4518=\"\">{{ h.jmr | money }}</span> <span class=infor-green v-if=\"isShow(h.jmr) == 2\" _v-215d4518=\"\">{{ h.jmr | money }}</span> <span v-if=\"isShow(h.jmr) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> </ul> <ul v-else=\"\" _v-215d4518=\"\"> <li _v-215d4518=\"\"><p class=date _v-215d4518=\"\">交易营业部名称 </p><p class=time _v-215d4518=\"\">{{ h.unitname }}</p></li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">买入金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(h.buy) == 1\" _v-215d4518=\"\">{{ h.buy | money }}</span> <span v-if=\"isShow(h.buy) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">卖出金额（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-green v-if=\"isShow(h.sell) == 1\" _v-215d4518=\"\">{{ h.sell | money }}</span> <span v-if=\"isShow(h.sell) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> <li _v-215d4518=\"\"> <p class=date _v-215d4518=\"\">净买入（元）</p> <p class=time _v-215d4518=\"\"> <span class=infor-red v-if=\"isShow(h.jmr) == 1\" _v-215d4518=\"\">{{ h.jmr | money }}</span> <span class=infor-green v-if=\"isShow(h.jmr) == 2\" _v-215d4518=\"\">{{ h.jmr | money }}</span> <span v-if=\"isShow(h.jmr) == 3\" _v-215d4518=\"\">0.00</span> </p> </li> </ul> </template> </div> </div> </template> </div> <div class=Single-list-main v-if=\"!dragonTigerLists.length &amp;&amp; !loading\" _v-215d4518=\"\"> <div class=Block-trade-no _v-215d4518=\"\">暂无数据</div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-215d4518=\"\"> <div class=binding-content _v-215d4518=\"\"> <a class=binding-logo _v-215d4518=\"\"></a> <div class=binding-text _v-215d4518=\"\"> 立即绑定IBDATA账号<br _v-215d4518=\"\">成为金融分析高手 </div> <div class=binding-bot _v-215d4518=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-215d4518=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-215d4518=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-215d4518=\"\"></div>";

/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div _v-285f58f4=\"\"> <div class=wrap @click=\"hideDropdown($event), hideKeywordDropdown()\" _v-285f58f4=\"\"> <div class=loading_gif v-show=loading style=\"position: fixed;max-width: 640px\" _v-285f58f4=\"\"> <img src=" + __webpack_require__(104) + " class=loading-img _v-285f58f4=\"\"> <p style=\"font-size:14px;color: #FFFFFF\" _v-285f58f4=\"\">文件较大,请稍等...</p> </div> <div class=wrapper v-show=\"!showCompanyDetailWrap &amp;&amp; !smartEngine.open\" _v-285f58f4=\"\"> <div class=stat-analyze v-show=\"showTongjiPage &amp;&amp; !showSearchPage &amp;&amp; !showResultPage\" _v-285f58f4=\"\"> <div class=search-header _v-285f58f4=\"\"> <div class=search-header-text @click=\"switchPage(2), setCnzz('[Mobile]-深度搜索', '从统计页返回搜索结果页', '')\" _v-285f58f4=\"\"> <span class=arrow-back _v-285f58f4=\"\"></span>统计 </div> </div> <div class=\"search-header-menu statis\" _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li @click=\"showStatAnalyze = true, showStatFilter = false, setCnzz('[Mobile]-深度搜索', '点击分析按钮', '')\" :class=\"{on: showStatAnalyze}\" _v-285f58f4=\"\">分析</li> <li @click=\"showStatAnalyze = false, showStatFilter = true, setCnzz('[Mobile]-深度搜索', '点击筛选按钮', '')\" :class=\"{on: showStatFilter}\" _v-285f58f4=\"\">筛选</li> </ul> </div> <div class=Analysis-list v-show=showStatAnalyze _v-285f58f4=\"\"> <div class=Analysis-list-box v-if=currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">相关的公司</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in company\" _v-285f58f4=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">提到的公司</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in related_company\" _v-285f58f4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">相关人员</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in related_name\" _v-285f58f4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">相关的公司</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in company\" _v-285f58f4=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">提到的公司</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in related_company\" _v-285f58f4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">相关人员</span> <ul _v-285f58f4=\"\"> <li v-for=\"item in related_name\" _v-285f58f4=\"\">{{ item.key }}</li> </ul> </div> </div> <div class=Analysis-list v-show=\"showStatFilter &amp;&amp; searched===stype\" _v-285f58f4=\"\"> <div class=Analysis-list-box v-show=\"aggLabels.length>0\" _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">公告标签</span> <ul _v-285f58f4=\"\"> <li v-for=\"d in aggLabels\" _v-285f58f4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 74%\" _v-285f58f4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['labels'][d.code]}\" _v-285f58f4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('labels', d)\" _v-285f58f4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-285f58f4=\"\"> </span> <span class=el-checkbox-label @click.stop=\"addConditionNew('labels', d)\" _v-285f58f4=\"\">{{d.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-285f58f4=\"\">{{d.count}}</span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggTypes.length>0\" _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">公告类型</span> <ul _v-285f58f4=\"\"> <li v-for=\"type in aggTypes\" _v-285f58f4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 74%\" _v-285f58f4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['type'][type.code]}\" _v-285f58f4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('type', type)\" _v-285f58f4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-285f58f4=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('type', type)\" _v-285f58f4=\"\">{{type.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-285f58f4=\"\"> {{type.count}} </span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggPlates.length>0\" _v-285f58f4=\"\"> <span class=head _v-285f58f4=\"\">板块类型</span> <ul _v-285f58f4=\"\"> <li v-for=\"plate in aggPlates\" _v-285f58f4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 74%\" _v-285f58f4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['plate'][plate.code]}\" _v-285f58f4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('plate', plate)\" _v-285f58f4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-285f58f4=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('plate', plate)\" _v-285f58f4=\"\">{{plate.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-285f58f4=\"\"> {{plate.count}} </span> </li> </ul> </div> </div> </div> <div class=search-conditions v-show=\"!showTongjiPage &amp;&amp; showSearchPage &amp;&amp; !showResultPage\" _v-285f58f4=\"\"> <div class=search-header _v-285f58f4=\"\"> <div class=search-header-text @click.stop=\"switchPage(2),  setCnzz('[Mobile]-深度搜索', '从搜索条件页返回搜索结果页', '')\" _v-285f58f4=\"\"> <span class=arrow-back _v-285f58f4=\"\"></span>搜索条件 </div> <span class=search-header-stics @click=\"showModalTag = true\" _v-285f58f4=\"\">保存标签</span> </div> <div class=cont-wrap _v-285f58f4=\"\"> <div class=Depth-list _v-285f58f4=\"\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 搜索类型 </div> <div class=content _v-285f58f4=\"\"> {{tab1 | formatTab1}} </div> </div> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 板块 </div> <div class=content _v-285f58f4=\"\"> {{stype | stypename}} </div> </div> <template v-for=\"item in searchCondition\"> <template v-if=\"item.name === '板块类型'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 板块类型 </div> <div class=content _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}\" _v-285f58f4=\"\">{{item.child[0].op | opname}}</span> <span v-for=\"c in item.child\" style=\"margin-right: 5px\" _v-285f58f4=\"\"> <span v-for=\"i in c.value\" style=\"margin-right: 5px\" _v-285f58f4=\"\">{{i.name}}</span> </span> </div> </div> </template> <template v-if=\"item.name === '公告标签'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 公告标签 </div> <div class=content _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}\" _v-285f58f4=\"\">{{item.child[0].op | opname}}</span> <span class=right v-for=\"c in item.child\" _v-285f58f4=\"\"> <span v-for=\"i in c.value\" style=\"margin-right: 5px\" _v-285f58f4=\"\">{{i.name}}</span> </span> </div> </div> </template> <template v-if=\"item.name === '发布日期'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 发布日期 </div> <div class=content _v-285f58f4=\"\"> <span v-for=\"c in item.child\" _v-285f58f4=\"\">{{c.name}}</span> </div> </div> </template> <template v-if=\"item.name === '公告类型'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 公告类型 </div> <div class=content _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': item.child[0].op == 3, 'not-c': item.child[0].op == 1, 'not-a': item.child[0].op == 2}\" _v-285f58f4=\"\"> {{item.child[0].op | opname}}</span> <span class=right v-for=\"c in item.child\" _v-285f58f4=\"\"> <span v-for=\"i in c.value\" style=\"margin-right: 5px\" _v-285f58f4=\"\">{{i.name}}</span> </span> </div> </div> </template> <template v-if=\"item.name === '转让类型'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 转让类型 </div> <div class=content _v-285f58f4=\"\"> <span v-for=\"c in item.child\" style=\"margin-right: 5px\" _v-285f58f4=\"\">{{c.name}}</span> </div> </div> </template> <template v-if=\"item.name === '搜索范围'\"> <div class=Depth-list-box _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\">搜索范围</div> <div class=con-search _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li v-if=\"ssfw.zj.zjzw.length !== 0 || ssfw.zj.zjbt.length !== 0\" _v-285f58f4=\"\"> <div class=\"depth-header blue\" _v-285f58f4=\"\">章节</div> <ul class=two _v-285f58f4=\"\"> <li v-if=\"ssfw.zj.zjzw &amp;&amp; ssfw.zj.zjzw.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div></div> <div class=\"depth-header blue\" _v-285f58f4=\"\">章节正文</div> <ul class=two _v-285f58f4=\"\"> <li _v-285f58f4=\"\"> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <template v-for=\"(index, cc) in ssfw.zj.zjzw\"> <li v-if=\"index !== 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': cc.op == 3, 'not-c': cc.op == 1, 'not-a': cc.op == 2}\" _v-285f58f4=\"\">{{cc.op | formatSSFW }}</span>{{cc.value}} </li> </template> </ul> </li> </ul> </li> <li v-if=\"ssfw.zj.zjbt &amp;&amp; ssfw.zj.zjbt.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div></div> <div class=\"depth-header blue\" _v-285f58f4=\"\">章节标题</div> <ul class=two _v-285f58f4=\"\"> <li _v-285f58f4=\"\"> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <template v-for=\"(index, cc) in ssfw.zj.zjbt\"> <li v-if=\"index !== 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"><span :class=\"{'title': true,  'not-b': cc.op == 3, 'not-c': cc.op == 1, 'not-a': cc.op == 2}\" _v-285f58f4=\"\">{{cc.op | formatSSFW }}</span>{{cc.value}}</li> </template> </ul> </li> </ul> </li> </ul> </li> <li v-if=\"ssfw.all &amp;&amp; ssfw.all.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div></div> <div class=\"depth-header blue\" _v-285f58f4=\"\">全部</div> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <template v-for=\"(index, cc) in ssfw.all\"> <li v-if=\"index !== 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"><span :class=\"{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}\" _v-285f58f4=\"\"> {{cc.op | formatSSFW }} </span>{{cc.value}}</li> </template> </ul> </li> <li v-if=\"ssfw.zw &amp;&amp; ssfw.zw.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div></div> <div class=\"depth-header blue\" _v-285f58f4=\"\">正文</div> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <template v-for=\"(index, zw) in ssfw.zw\"> <li v-if=\"index !== 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"><span :class=\"{'title': true,  'not-b': zw.op == 3, 'not-c': zw.op == 1, 'not-a': zw.op == 2}\" _v-285f58f4=\"\"> {{zw.op | formatSSFW }} </span>{{zw.value}}</li> </template> </ul> </li> <li v-if=\"ssfw.ggbt &amp;&amp; ssfw.ggbt.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div></div> <div class=\"depth-header blue\" _v-285f58f4=\"\">公告标题</div> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <template v-for=\"(index, item) in ssfw.ggbt\"> <li v-if=\"index !== 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"><span :class=\"{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}\" _v-285f58f4=\"\"> {{item.op | formatSSFW }} </span>{{item.value}}</li> </template> </ul> </li> </ul> </div> </div> </template> <template v-if=\"item.name === '公司'\"> <template v-if=!isEmpty(gs.jbxx)> <div class=Depth-list-box style=\"width: 91%\" _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 公司基本信息 </div> <div class=con-search style=\"padding-top: 0\" _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li v-for=\"cc in gs.jbxx\" v-if=\"cc.length !== 0\" _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div> </div> <div class=\"depth-header blue\" _v-285f58f4=\"\">{{cc[0].name}}</div> <ul class=two _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <li _v-285f58f4=\"\"> <template v-if=\"cc[0].code === 'industry'\"> <template v-for=\"(index, item) in cc\"> <li v-if=\"index !== 0\" style=\"padding-left: 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div></div></li> <li _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}\" _v-285f58f4=\"\"> {{item.child[0].op | formatSSFW }} </span> <span v-for=\"v in item.child[0].value\" style=\"margin-right: 5px\" _v-285f58f4=\"\"> {{v.name}} </span> </li> </template> </template> <template v-if=\"cc[0].code === 'region'\"> <template v-for=\"(index, item) in cc\"> <li v-if=\"index !== 0\" style=\"padding-left: 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div></div></li> <li _v-285f58f4=\"\"> <span :class=\"{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}\" _v-285f58f4=\"\"> {{item.child[0].op | formatSSFW }} </span> <span v-for=\"v in item.child[0].value\" style=\"margin-right: 5px\" _v-285f58f4=\"\"> {{v.name}} </span> </li> </template> </template> <template v-if=\"cc[0].code !== 'industry' &amp;&amp; cc[0].code !== 'region'\"> <template v-for=\"(index, item) in cc\"> <li v-if=\"index !== 0\" style=\"padding-left: .5rem\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div> </div></li> <li _v-285f58f4=\"\"><span :class=\"{'title': true,  'not-b': item.op == 3, 'not-c': item.op == 1, 'not-a': item.op == 2}\" _v-285f58f4=\"\"> {{item.op | formatSSFW }} </span>{{item.value}}</li> </template> </template> </li> </ul> </li> </ul> </div> </div> </template> <template v-if=\"!isEmpty(gs.cwsj.cwzb) || !isEmpty(gs.cwsj.gjbl)\"> <div class=Depth-list-box style=\"width: 91%\" _v-285f58f4=\"\"> <div class=head _v-285f58f4=\"\"> 公司财务数据 </div> <div class=con-search style=\"padding-top: 0\" _v-285f58f4=\"\"> <ul style=\"width: 93%; margin-left: 10px\" _v-285f58f4=\"\"> <li v-if=!isEmpty(gs.cwsj.cwzb) _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div> </div> <div class=\"depth-header blue\" style=\"font-size: 15px\" _v-285f58f4=\"\">财务指标</div> <ul class=two style=\"margin-left: 10px\" _v-285f58f4=\"\"> <li v-for=\"c in gs.cwsj.cwzb\" _v-285f58f4=\"\"> <template v-for=\"(index, item) in c\"> <div class=mline-two _v-285f58f4=\"\"></div> <div class=depth-header _v-285f58f4=\"\">{{item.name}}</div> <ul class=two style=\"width: 97%\" _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <li _v-285f58f4=\"\"> </li><li v-if=\"index !== 0\" style=\"padding-left: 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div></div></li> <li _v-285f58f4=\"\"> <span class=\"title not-c\" _v-285f58f4=\"\"> {{item.year}} </span> <span class=\"title not-a\" _v-285f58f4=\"\"> {{item.quarter}} </span> <span class=\"title not-a\" _v-285f58f4=\"\"> {{item.range | formatRangeToName}} </span> <template v-if=\"item.range !== 3\"> <span _v-285f58f4=\"\">{{item.value}}</span> <span _v-285f58f4=\"\">（元）</span> </template> <template v-if=\"item.range === 3\"> <span _v-285f58f4=\"\">{{item.value}} ~ {{item.value1}}</span> <span _v-285f58f4=\"\">（元）</span> </template> </li> </ul> </template> </li> </ul> </li> <li v-if=!isEmpty(gs.cwsj.gjbl) _v-285f58f4=\"\"> <div class=l _v-285f58f4=\"\"><div class=mline-one _v-285f58f4=\"\"></div> </div> <div class=\"depth-header blue\" style=\"font-size: 15px\" _v-285f58f4=\"\">关键比率</div> <ul class=two style=\"margin-left: 10px\" _v-285f58f4=\"\"> <li v-for=\"c in gs.cwsj.gjbl\" v-if=\"c.length !== 0\" _v-285f58f4=\"\"> <div class=mline-two _v-285f58f4=\"\"></div> <div class=depth-header _v-285f58f4=\"\">{{c[0].name}}</div> <ul class=two style=\"width: 97%\" _v-285f58f4=\"\"> <div class=line _v-285f58f4=\"\"> <div class=line-a _v-285f58f4=\"\"> <div class=mline-a1 _v-285f58f4=\"\"></div> </div> <div class=mline-a2 _v-285f58f4=\"\"></div> </div> <li _v-285f58f4=\"\"> <template v-for=\"(index, item) in c\"> <li v-if=\"index !== 0\" style=\"padding-left: 0\" _v-285f58f4=\"\"><div class=l _v-285f58f4=\"\"> <div class=mline-a3 _v-285f58f4=\"\"></div></div></li> <li _v-285f58f4=\"\"> <span class=\"title not-c\" _v-285f58f4=\"\"> {{item.year}} </span> <span class=\"title not-a\" _v-285f58f4=\"\"> {{item.quarter}} </span> <span class=\"title not-a\" _v-285f58f4=\"\"> {{item.range | formatRangeToName}} </span> <template v-if=\"item.range !== 3\"> <span _v-285f58f4=\"\">{{item.value}}</span> <span v-if=\"item.name === '资产负债率' || item.name === '毛利率' || item.name === '净利率' || item.name === '净资产收益率'\" _v-285f58f4=\"\">（%）</span> <span v-if=\"item.name === '流动比率' || item.name === '速动比率' \" _v-285f58f4=\"\">（倍）</span> <span v-if=\"item.name === '存货周转率'\" _v-285f58f4=\"\">（次）</span> <span v-if=\"item.name === '每股净资产'\" _v-285f58f4=\"\">（元）</span> <span v-if=\"item.name === '每股经营活动产生的现金流量净额'\" _v-285f58f4=\"\">（元/股）</span> </template> <template v-if=\"item.range === 3\"> <span _v-285f58f4=\"\">{{item.value}} ~ {{item.value1}}</span> <span v-if=\"item.name === '资产负债率' || item.name === '毛利率' || item.name === '净利率' || item.name === '净资产收益率'\" _v-285f58f4=\"\">（%）</span> <span v-if=\"item.name === '流动比率' || item.name === '速动比率' \" _v-285f58f4=\"\">（倍）</span> <span v-if=\"item.name === '存货周转率'\" _v-285f58f4=\"\">（次）</span> <span v-if=\"item.name === '每股净资产'\" _v-285f58f4=\"\">（元）</span> <span v-if=\"item.name === '每股净资产'\" _v-285f58f4=\"\">（元）</span> <span v-if=\"item.name === '每股经营活动产生的现金流量净额'\" _v-285f58f4=\"\">（元/股）</span> </template> </li> </template> </li> </ul> </li> </ul> </li> </ul> </div> </div> </template> </template> </template> </div> </div> </div> <div class=my-container v-show=showComments style=\"top: 0px;position:static;background-color:white\" _v-285f58f4=\"\"> <div class=comment-detail _v-285f58f4=\"\"> <div class=comment-title _v-285f58f4=\"\"> <p class=comment-all _v-285f58f4=\"\">全部评论</p> <p class=comment-sort _v-285f58f4=\"\">{{cpwtotal}}条评论</p> </div> <div class=comment v-for=\"item in commentList\" _v-285f58f4=\"\"> <div class=common-avatar _v-285f58f4=\"\"> <img src=/static/images/user.png width=100% height=100% _v-285f58f4=\"\"> </div> <div class=comment-block _v-285f58f4=\"\"> <p class=comment-user _v-285f58f4=\"\"> <span class=comment-username v-if=item.user _v-285f58f4=\"\"> {{item.user.username}} </span> <span class=comment-username v-else=\"\" _v-285f58f4=\"\"> 匿名用户 </span> <span class=footer-zan _v-285f58f4=\"\"> <i class=c-share-icon @click.stop=\"zan(item.id, $event)\" _v-285f58f4=\"\"></i><span class=u-num _v-285f58f4=\"\">{{item.zan_cnt}}</span></span> </p> <div class=comment-content _v-285f58f4=\"\">{{item.content}} </div> <div class=comment-operate _v-285f58f4=\"\"> <span class=\"J_Vote comment-operate-item comment-operate-up\" _v-285f58f4=\"\">{{item.updtime | date}}</span> <span class=\"J_Reply comment-operate-item\" _v-285f58f4=\"\"> <a href=javascript:; @click=\"commentinput = true, pid = item.id, content = ''\" _v-285f58f4=\"\">回复</a> </span> </div> <div class=\"comment-reply-ctn comment-reply-item\" _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li v-for=\"i in item.replys\" track-by=$index v-if=\"$index < item.showall\" _v-285f58f4=\"\"> <p class=comment-text _v-285f58f4=\"\"> <span class=c-username v-if=i.user _v-285f58f4=\"\"> {{i.user.username}} </span> <span class=c-username v-else=\"\" _v-285f58f4=\"\">匿名用户</span> {{i.content}} </p> <div class=\"reply-operate reply-operate-hot\" _v-285f58f4=\"\"> <span class=\"J_Vote reply-operate-item reply-up\" _v-285f58f4=\"\"><i class=c-share-icon @click.stop=\"zan(i.id, $event)\" _v-285f58f4=\"\"></i><span _v-285f58f4=\"\">{{i.zan_cnt}}</span></span> <span class=\"J_Reply reply-operate-item\" _v-285f58f4=\"\"></span> <span _v-285f58f4=\"\">{{i.updtime | date}}</span> </div> </li> <li class=\"view-more hidden\" v-if=\"item.replys.length > 2 &amp;&amp; item.showall !== 8\" _v-285f58f4=\"\"> <a class=\"btn-block text-center btn-comment-expand\" @click=\"item.showall = 8\" _v-285f58f4=\"\">查看全部<span class=nume _v-285f58f4=\"\">{{item.replys.length}}</span>条回复 </a> </li> </ul> </div> </div> </div> </div> <div class=comment-more _v-285f58f4=\"\"> <a href=javascript:; v-if=\"commentList.length !== cpwtotal\" _v-285f58f4=\"\">加载更多评论中...</a> <a href=javascript:; v-if=\"commentList.length == cpwtotal &amp;&amp; cpwtotal !== 0\" _v-285f58f4=\"\">评论已全部加载</a> </div> <div class=comment-no v-if=\"cpwtotal == 0\" _v-285f58f4=\"\"> 暂无评论，快来添加一个吧！ </div> <div class=comment-no _v-285f58f4=\"\"></div> </div> <div class=result-container id=result-container v-show=\"!showTongjiPage &amp;&amp; !showSearchPage &amp;&amp; showResultPage &amp;&amp; !showComments\" _v-285f58f4=\"\"> <template v-if=\"topPage == 1\"> <div class=search-header _v-285f58f4=\"\"> <div class=search-header-text _v-285f58f4=\"\"> <span _v-285f58f4=\"\">{{stype | formatTypeName}}</span> </div> <span class=search-header-stics v-if=\"tab1 === 1\" @click=\"switchPage(3), showStatAnalyze = true,  setCnzz('[Mobile]-深度搜索', '进入统计页', '')\" _v-285f58f4=\"\">统计</span> <span class=search-header-stics @click=\"showModalTag = true\" _v-285f58f4=\"\">保存标签</span> </div> <div class=screen-menu v-if=\"tab1 == 1\" _v-285f58f4=\"\"> <div class=Depth-date _v-285f58f4=\"\"> <div @click.stop=\"slideToggle('sort')\" _v-285f58f4=\"\"> {{ sort==1?'按相关性排序':'按时间排序' }} <span class=close-bot _v-285f58f4=\"\"></span> </div> <ul class=date-menu v-show=\"showDropdownMenu == 'sort'\" @click=hideDropdown _v-285f58f4=\"\"> <li _v-285f58f4=\"\"><a href=javascript:; @click=\"selSort(1),  setCnzz('[Mobile]-深度搜索', '点击按相关性排序按钮', '')\" _v-285f58f4=\"\">按相关性排序</a></li> <li _v-285f58f4=\"\"><a href=javascript:; @click=\"selSort(2), setCnzz('[Mobile]-深度搜索', '点击按时间排序按钮', '')\" _v-285f58f4=\"\">按时间排序</a></li> </ul> </div> </div> <div class=Screen-criteria v-if=\"tags1.length > 0 &amp;&amp; tab1 == 1\" _v-285f58f4=\"\"> <div class=Screen-criteria-head @click=\"showtag = !showtag, slideToggleTag()\" _v-285f58f4=\"\"> <span class=fl _v-285f58f4=\"\">我的标签</span> <span class=fr v-if=showtag _v-285f58f4=\"\"></span> <span class=f3 v-if=!showtag _v-285f58f4=\"\"></span> </div> <div class=\"Screen-criteria-box cpwtag\" style=display:none _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li v-for=\"item in tags1\" @click=\"searchByTag(item.id), showtag = false, slideToggleTag()\" _v-285f58f4=\"\"> <span class=notice-left _v-285f58f4=\"\">{{item.name}}</span> <span class=notice-right @click.stop=delTag(item.id) _v-285f58f4=\"\"></span> </li> </ul> </div> </div> <div class=Screen-criteria v-if=\"tags2.length > 0 &amp;&amp; tab1 == 2\" _v-285f58f4=\"\"> <div class=Screen-criteria-head @click=\"showtag = !showtag, slideToggleTag()\" _v-285f58f4=\"\"> <span class=fl _v-285f58f4=\"\">我的标签</span> <span class=fr v-if=showtag _v-285f58f4=\"\"></span> <span class=f3 v-if=!showtag _v-285f58f4=\"\"></span> </div> <div class=\"Screen-criteria-box cpwtag\" style=display:none _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <li v-for=\"item in tags2\" @click=\"searchByTag(item.id), showtag = false, slideToggleTag()\" _v-285f58f4=\"\"> <span class=notice-left _v-285f58f4=\"\">{{item.name}}</span> <span class=notice-right @click.stop=delTag(item.id) _v-285f58f4=\"\"></span> </li> </ul> </div> </div> <div class=search-criteria @click.stop=\"switchPage(1), setCnzz('[Mobile]-深度搜索', '查看搜索条件', '')\" _v-285f58f4=\"\"> <span class=fl _v-285f58f4=\"\">搜索条件</span> <span class=fr _v-285f58f4=\"\"></span> </div> <template v-if=\"havelabels &amp;&amp; tab1 === 1\"> <div class=Screen-criteria _v-285f58f4=\"\"> <div class=Screen-criteria-head @click.stop=slideDropdownMenu($event) _v-285f58f4=\"\"> <span class=fl _v-285f58f4=\"\">筛选条件</span> <span class=\"fr close\" _v-285f58f4=\"\"></span> </div> <div class=Screen-criteria-box style=\"display: none\" _v-285f58f4=\"\"> <ul _v-285f58f4=\"\"> <template v-for=\"(type, obj) in conditions\"> <li v-if=\"!isEmptyObj(obj) &amp;&amp; type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\" _v-285f58f4=\"\"> <span class=selected-icon _v-285f58f4=\"\"></span> <a class=blue _v-285f58f4=\"\">{{ cond_type[type] }}</a> </li> <template v-for=\"(code, name) in obj\" v-if=\"type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\"> <li _v-285f58f4=\"\"> <a class=text-a _v-285f58f4=\"\">{{ name }} </a> <span aria-hidden=true class=\"search-icon small-delete\" @click=\"rmvCondition(type, code)\" _v-285f58f4=\"\"></span> </li> </template> </template> <li v-if=showPla _v-285f58f4=\"\"> <span class=selected-icon _v-285f58f4=\"\"></span> <a class=blue _v-285f58f4=\"\">{{cond_type['plate']}}</a> </li> <li v-for=\"(idx, item) in pageshowConditions['plate']\" v-if=\"idx !== '挂牌公司' &amp;&amp; item\" _v-285f58f4=\"\"> <a class=text-a _v-285f58f4=\"\">{{item}}</a> <span aria-hidden=true class=\"search-icon small-delete\" @click=\"rmvCondition('plate', idx)\" _v-285f58f4=\"\"></span> </li> <li class=active v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\" _v-285f58f4=\"\"> <span class=selected-icon _v-285f58f4=\"\"></span> <a class=text-b _v-285f58f4=\"\">挂牌公司</a> <span aria-hidden=true class=\"search-icon small-delete\" @click=\"rmvCondition('N3BGP', 'N3BGP')\" _v-285f58f4=\"\"></span> </li> <li v-for=\"i in pageshowConditions['plate']['挂牌公司']\" v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\" _v-285f58f4=\"\"> <a class=text-a _v-285f58f4=\"\">{{i}}</a> <span aria-hidden=true class=\"search-icon small-delete\" @click=\"rmvCondition('layer', i)\" _v-285f58f4=\"\"></span> </li> <li v-if=showInd _v-285f58f4=\"\"> <span class=selected-icon _v-285f58f4=\"\"></span> <a class=blue _v-285f58f4=\"\">{{cond_type['industry']}}</a> </li> <template v-for=\"(type, obj) in pageshowConditions['industry']\" v-if=\"obj.length > 0 || type == 'S综合'\"> <li class=active _v-285f58f4=\"\"> <span class=selected-icon _v-285f58f4=\"\"></span> <a class=text-b _v-285f58f4=\"\">{{type}}</a> <span class=\"search-icon small-delete\" @click=\"rmvCondition('industry', type.substr(0,1))\" _v-285f58f4=\"\"></span> </li> <li v-for=\"item in obj\" v-if=\"obj.length !== industry\" _v-285f58f4=\"\"> <a class=text-a _v-285f58f4=\"\">{{item}}</a> <span class=\"search-icon small-delete\" @click=\"rmvCondition('industrysecond', item.substr(0, 3))\" _v-285f58f4=\"\"></span> </li> </template> </ul> </div> </div> </template> <div class=intelligent-search-main _v-285f58f4=\"\"> <div class=intelligent-search v-if=\"smartComInfo.shortname &amp;&amp; smartComInfo.code\" _v-285f58f4=\"\"> <div class=intelligent-heading style=cursor:pointer _v-285f58f4=\"\"> <span class=big-h @click=\"goCompanyInfo(smartComInfo.code), setCnzz('信披搜索', '进入公司详情', '')\" _v-285f58f4=\"\">{{smartComInfo.shortname}}【{{smartComInfo.code}}】</span> </div> <div class=op-stockdynamic v-if=smartComInfo.price _v-285f58f4=\"\"> <div class=op-stockdynamic-top :class=\"{'plus': upanddown.indexOf('+') === 0, 'reduce': upanddown.indexOf('-') === 0}\" _v-285f58f4=\"\"> <span class=op-cur-num _v-285f58f4=\"\">{{prices.trade}}元</span> <span class=op-cur-info _v-285f58f4=\"\">{{upanddown}}({{Amplitude}}%)</span> </div> <div class=op-stockdynamic-bot _v-285f58f4=\"\"> <ul class=op-clear _v-285f58f4=\"\"> <li _v-285f58f4=\"\">昨收：{{prices.settlement}}</li> <li _v-285f58f4=\"\">今开：{{prices.open}}</li> <li _v-285f58f4=\"\">最高：{{prices.high}}</li> <li _v-285f58f4=\"\">最低：{{prices.low}}</li> </ul> <ul class=op-clear _v-285f58f4=\"\"> <li _v-285f58f4=\"\">成交量：<template v-if=\"prices.volume < 1000000\">{{prices.volume}}手</template> <template v-if=\"prices.volume > 1000000 || prices.volume == 1000000\">{{(prices.volume/ 1000000).toFixed(2) | thousands}}万手</template></li> <li _v-285f58f4=\"\">成交额：{{(prices.amount/ 100000000).toFixed(2) | thousands}}亿元</li> <li _v-285f58f4=\"\">总市值：{{(prices.mktcap/10000).toFixed(2) | thousands}}亿元</li> <li _v-285f58f4=\"\">流通市值：{{(prices.nmc/10000).toFixed(2) | thousands}}亿元</li> </ul> <ul class=op-clear _v-285f58f4=\"\"> <li _v-285f58f4=\"\">换手率：{{prices.turnoverratio.toFixed(2)}}%</li> <li _v-285f58f4=\"\">市净率：{{prices.pb.toFixed(2)}}</li> <li _v-285f58f4=\"\">振 幅：{{prices.changepercent.toFixed(2)}}%</li> <li _v-285f58f4=\"\">市盈率：{{prices.per.toFixed(2)}}</li> </ul> </div> </div> </div> <div class=intelligent-search v-if=\"smartComInfo.finance &amp;&amp; smartComInfo.finance.length > 0\" _v-285f58f4=\"\"> <div class=intelligent-heading _v-285f58f4=\"\"> {{smartComInfo.shortname}}【{{smartComInfo.code}}】财务信息 </div> <div class=table-result-outter _v-285f58f4=\"\"> <ul class=personnel _v-285f58f4=\"\"> <li :class=\"{'active': timetyp === 1}\" @click=\"timetyp = 1, setCnzz('[Mobile]深度搜索', '智能引擎——切换为按季度', '')\" _v-285f58f4=\"\">按季度</li> <li :class=\"{'active': timetyp === 2}\" @click=\"timetyp = 2, setCnzz('[MObile]深度搜索', '智能引擎——切换为按年度', '')\" _v-285f58f4=\"\">按年度</li> </ul> <div style=\"margin-bottom: 20px\" _v-285f58f4=\"\"> <table class=table-result cellpadding=0 _v-285f58f4=\"\"> <tbody v-if=\"timetyp === 1\" _v-285f58f4=\"\"> <tr class=title _v-285f58f4=\"\"> <td _v-285f58f4=\"\">日期</td> <td _v-285f58f4=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in finance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-285f58f4=\"\"> <td v-for=\"(k,i) in item\" _v-285f58f4=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i['营业收入'] | thousands}}</template> </td> </tr> </tbody> <tbody v-if=\"timetyp === 2\" _v-285f58f4=\"\"> <tr class=title _v-285f58f4=\"\"> <td _v-285f58f4=\"\">日期</td> <td _v-285f58f4=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in yearfinance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-285f58f4=\"\"> <td v-for=\"(k,i) in item\" _v-285f58f4=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i['营业收入'] | thousands}}</template> </td> </tr> </tbody> </table> </div> </div> </div> </div> </template> <div class=search-result-box _v-285f58f4=\"\"> <template v-if=\"tab1 === 1\"> <div class=anwer-cont v-show=\"searched==stype &amp;&amp; items.length==0\" _v-285f58f4=\"\"> <div class=no _v-285f58f4=\"\">很抱歉，没有找到相关的结果!</div> </div> </template> <template v-if=\"tab1 === 2\"> <div class=anwer-cont v-show=\"searched==stype &amp;&amp; companylist.length==0 &amp;&amp; !loading\" _v-285f58f4=\"\"> <div class=no _v-285f58f4=\"\">很抱歉，没有找到相关的结果!</div> </div> </template> <div class=more_top v-show=\"!loading &amp;&amp; topPage !== 1 &amp;&amp; total !== 0\" style=\"margin-bottom: -0.4rem\" _v-285f58f4=\"\"> <i class=\"pull_icon_top loading\" _v-285f58f4=\"\"></i> <span style=\"font-size: 15px\" _v-285f58f4=\"\">加载中...</span> </div> <div v-show=\"tab1 === 1 &amp;&amp; searched==stype &amp;&amp; detailLists.length>0\" id=my-result-wrap _v-285f58f4=\"\"> <template v-if=\"stype!=5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-285f58f4=\"\"> <p class=head _v-285f58f4=\"\"> <span class=\"{{ fileIcon(item.fileext) }}\" _v-285f58f4=\"\"></span> <a v-if=\"stype!=5\" style=cursor:pointer @click=\"checkLogin(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')\" class=green _v-285f58f4=\"\">{{{ item.fulltitle }}}</a> <a v-if=\"stype==5\" style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')\" class=green _v-285f58f4=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-285f58f4=\"\"> {{ item.publishDate ? item.publishDate: item.uploadTime }} <span class=marginlf-10 _v-285f58f4=\"\">{{ item.companyCode }}</span> <span class=marginlf-10 v-if=item.author _v-285f58f4=\"\">作者: {{ item.author }}</span> <span class=marginlf-10 v-if=item.nickname _v-285f58f4=\"\">公众号: {{ item.nickname }}</span> </p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent' &amp;&amp; onlyTitle == 0\" _v-285f58f4=\"\"> {{{ item.content.join('...... ') }}} </p> <template v-if=\"item.child &amp;&amp; onlyTitle == 0\"> <template v-for=\"child in item.child\"> <p class=\"blak font-weight lien\" @click=\"viewChildTitle(item, child.code)\" style=cursor:pointer _v-285f58f4=\"\"> {{{ child.title }}} </p> <p class=lien v-if=child.content _v-285f58f4=\"\"> {{{ child.content.join('...... ') }}} </p> <template v-if=child.contents> <template v-for=\"c in child.contents\"> <p class=lien v-if=\"c.htmltag=='p'\" _v-285f58f4=\"\"> {{{ c.content }}}<br _v-285f58f4=\"\"> </p> <template v-if=\"c.htmltag=='table'\"> <div class=table-result-outter _v-285f58f4=\"\"> <table cellpadding=0 class=table-result _v-285f58f4=\"\"> <tbody _v-285f58f4=\"\"> <tr v-for=\"(rowidx, row) in c.table\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-285f58f4=\"\"> <td v-for=\"(colidx, col) in row\" rowspan=\"{{ col.row }}\" colspan=\"{{ col.col }}\" track-by=$index _v-285f58f4=\"\"> {{{col.value}}} </td> </tr> </tbody> </table> </div> <div class=table-whole _v-285f58f4=\"\"> <a href=javascript:; @click=\"viewTable(item, child.code, c.offset), setCnzz('[Mobile]-深度搜索', '查看表格全部内容', '')\" _v-285f58f4=\"\"> <span class=table-see-icon _v-285f58f4=\"\"></span>查看表格全部内容 </a> </div> </template> </template> </template> <div class=intelligent-fsearch-cont v-if=child.imgs _v-285f58f4=\"\"> <template v-for=\"c in child.imgs\"> <div class=fsearch-a _v-285f58f4=\"\"> <div class=more-img style=cursor:pointer title=点击查看更多 @click=\"setBigImgObj(c, item)\" _v-285f58f4=\"\"> <img :src=c.imgurl _v-285f58f4=\"\"> </div> <div class=text-a _v-285f58f4=\"\">{{{child.title}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-285f58f4=\"\">{{{c.imghead}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-285f58f4=\"\">{{{c.imgfoot}}}</div> </div> </template> </div> </template> </template> </div> </template> <template v-if=\"stype==5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-285f58f4=\"\"> <p class=head _v-285f58f4=\"\"> <a class=green style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-深度搜索', '查看公告详情', '')\" _v-285f58f4=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-285f58f4=\"\">{{ item.publishDate ? item.publishDate: item.uploadTime }}</p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent'\" _v-285f58f4=\"\">{{{ item.content.join('...... ') }}}</p> <template v-if=item.child> <template v-for=\"child in item.child\"> <div v-if=child.content class=\"rb odd res-qa-title-wrap\" style=\"overflow: hidden\" _v-285f58f4=\"\"> <div class=res-qa-item-l _v-285f58f4=\"\"> </div> <div style=\"float: left\" class=res-qa-item-r _v-285f58f4=\"\"> <p class=\"blak font-weight lien\" _v-285f58f4=\"\">{{{ child.title }}}</p> <p class=lien v-if=child.content _v-285f58f4=\"\"> {{{ child.content.join('...... ') }}} </p> </div> </div> <div v-if=child.que class=\"rb odd res-qa-middle-wrap\" _v-285f58f4=\"\"> <div class=res-qa-item-l _v-285f58f4=\"\"> <div class=ques-l _v-285f58f4=\"\"><span class=\"qicon ques_1\" style=\"margin: 0.1rem 5px 2px 0px\" _v-285f58f4=\"\"></span></div> </div> <div class=res-qa-item-r _v-285f58f4=\"\"> <p class=lien v-if=!child.showque _v-285f58f4=\"\"> {{{ child.shortque?child.shortque:child.que | maxlen 100 }}} <span class=\"qust-more blue\" @click=\"child.showque=true\" v-if=\"child.que.length>100\" _v-285f58f4=\"\"> 展开更多<span class=triangle-bottom _v-285f58f4=\"\"></span></span> </p> <p class=lien v-if=child.showque _v-285f58f4=\"\"> {{{ child.que }}} <span class=\"qust-stop red\" @click=\"child.showque=false\" _v-285f58f4=\"\"> 收起<span class=triangle-head _v-285f58f4=\"\"></span></span> </p> <div class=quest-blue _v-285f58f4=\"\"> <li v-for=\"t in child.tag\" _v-285f58f4=\"\"><a href=javascript:; _v-285f58f4=\"\">{{ t }}</a></li> </div> </div> </div> <div v-if=child.answers v-for=\"ans in child.answers\" class=res-qa-ans-wrap _v-285f58f4=\"\"> <div class=res-qa-item-l _v-285f58f4=\"\"> <div class=ques-l _v-285f58f4=\"\"> <span class=\"qicon ques_2\" style=\"margin: 0.12rem 5px 2px 0px\" _v-285f58f4=\"\"></span> </div> </div> <div class=res-qa-item-r _v-285f58f4=\"\"> <p class=quest-p _v-285f58f4=\"\"> <span class=font-weight v-if=\"trim(ans.rername) !== ''\" _v-285f58f4=\"\">【{{ ans.rertitle }}: {{ ans.rername }}】</span> <span class=ques-lt v-if=!ans.showans _v-285f58f4=\"\"> {{{ ans.shortans?ans.shortans:ans.ans | maxlen 100 }}}</span> <span class=ques-lt v-show=ans.showans _v-285f58f4=\"\"> {{{ ans.ans }}}</span> <span class=\"qust-more blue\" v-if=\"!ans.showans &amp;&amp; ans.ans.length>100\" @click=\"ans.showans=true\" _v-285f58f4=\"\"> 展开更多<span class=triangle-bottom _v-285f58f4=\"\"></span> </span> <span class=\"qust-stop red\" v-if=ans.showans @click=\"ans.showans=false\" _v-285f58f4=\"\"> 收起<span class=triangle-head _v-285f58f4=\"\"></span></span> </p> </div> </div> </template> </template> </div> </template> </div> <div v-if=\"tab1 === 2\" class=search-company-box _v-285f58f4=\"\"> <div class=search-company-main v-for=\"company in companyitems\" track-by=$index _v-285f58f4=\"\"> <h3 class=head @click.stop=\"goCompanyDetail(company), setCnzz('[Mobile]-深度搜索', '查看公司详情', '')\" _v-285f58f4=\"\">{{company.shortName}}({{company.companyCode}})</h3> <div class=search-company-list _v-285f58f4=\"\"> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">法人</span> <span class=mar _v-285f58f4=\"\">{{company.legalRepresentative}}</span></p> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">成立日期</span> <span class=mar _v-285f58f4=\"\">{{company.founddate}}</span> <span class=title _v-285f58f4=\"\">所属地域</span> <span class=mar _v-285f58f4=\"\">{{company.area}}</span></p> </div> <div class=\"search-company-list last-child\" _v-285f58f4=\"\"> <p _v-285f58f4=\"\"> <span class=title _v-285f58f4=\"\">行业</span> <span class=mar _v-285f58f4=\"\">{{company.industry}}</span> </p> <p _v-285f58f4=\"\"> <span class=title _v-285f58f4=\"\">营业收入</span> <span class=mar v-if=company.businessincome _v-285f58f4=\"\">{{company.businessincome | formatNumber}}</span> <span class=mar v-if=!company.businessincome style=\"margin: 0 .5rem\" _v-285f58f4=\"\">-</span> <span _v-285f58f4=\"\">(元)</span> </p> <p _v-285f58f4=\"\"> <span class=title _v-285f58f4=\"\">净利润</span> <span class=mar v-if=company.retainedprofit _v-285f58f4=\"\">{{company.retainedprofit | formatNumber}}</span> <span class=mar v-if=!company.retainedprofit style=\"margin: 0 .5rem\" _v-285f58f4=\"\">-</span> <span _v-285f58f4=\"\">(元)</span> </p> </div> </div> </div> <template v-if=\"tab1 === 1\"> <div class=more v-show=\"!loading &amp;&amp; bottomPage < totalPage &amp;&amp; total !== 0\" style=\"margin-top: -8px\" _v-285f58f4=\"\"> <i class=\"pull_icon loading\" _v-285f58f4=\"\"></i> <span style=\"font-size: 15px\" _v-285f58f4=\"\">加载中...</span> </div> </template> <template v-if=\"tab1 === 2\"> <div class=more v-show=\"!loading &amp;&amp; cpage < totalPage &amp;&amp; ctotal1 !== 0\" style=\"margin-top: -8px\" _v-285f58f4=\"\"> <i class=\"pull_icon loading\" _v-285f58f4=\"\"></i> <span style=\"font-size: 15px\" _v-285f58f4=\"\">加载中...</span> </div> </template> </div> </div> </div> <div class=wrapper v-show=\"tab1 == 2 &amp;&amp; showCompanyDetailWrap\" _v-285f58f4=\"\"> <div class=company-details-title _v-285f58f4=\"\"> <span class=cancle-btn @click.stop=\"hideCompanyDetail(), setCnzz('[Mobile]-深度搜索', '收起公司详情', '')\" _v-285f58f4=\"\"></span> <span class=\"menu-options blue\" style=\"font-size: 16px\" _v-285f58f4=\"\">{{currentCompanyDetail.shortName}}({{currentCompanyDetail.companyCode}})</span> </div> <div class=company-details-head _v-285f58f4=\"\"> <div class=search-company-list _v-285f58f4=\"\"> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">法人</span> <span class=mar _v-285f58f4=\"\">{{currentCompanyDetail.legalRepresentative}}</span></p> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">成立日期</span> <span class=mar _v-285f58f4=\"\">{{currentCompanyDetail.founddate}}</span> <span class=title _v-285f58f4=\"\">所属地域</span> <span class=mar _v-285f58f4=\"\">{{currentCompanyDetail.area}}</span></p> </div> <div class=\"search-company-list last-child\" _v-285f58f4=\"\"> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">行业</span> <span class=mar _v-285f58f4=\"\">{{currentCompanyDetail.industry}}</span></p> <p _v-285f58f4=\"\"> <span class=title _v-285f58f4=\"\">营业收入</span> <span class=mar v-if=currentCompanyDetail.businessincome _v-285f58f4=\"\">{{currentCompanyDetail.businessincome | formatNumber}}</span> <span class=mar v-if=!currentCompanyDetail.businessincome style=\"margin: 0 .5rem\" _v-285f58f4=\"\">-</span> <span _v-285f58f4=\"\">(元)</span> </p> <p _v-285f58f4=\"\"> <span class=title _v-285f58f4=\"\">净利润</span> <span class=mar v-if=currentCompanyDetail.retainedprofit _v-285f58f4=\"\">{{currentCompanyDetail.retainedprofit | formatNumber}}</span> <span class=mar v-if=!currentCompanyDetail.retainedprofit style=\"margin: 0 .5rem\" _v-285f58f4=\"\">-</span> <span _v-285f58f4=\"\">(元)</span> </p> </div> </div> <div class=company-details-box _v-285f58f4=\"\"> <ul class=one-row-box _v-285f58f4=\"\"> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 公司名 </p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.companyName}} </p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 统一社会信用代码 </p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.regcode}} </p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\">注册资本</p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.regmoney | formatNumber}}（万元） </p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 曾用名 </p> <p class=time v-if=\"currentCompanyDetail.companyNames &amp;&amp; currentCompanyDetail.companyNames.length == 0\" _v-285f58f4=\"\"> 暂无曾用名 </p> <p class=time _v-285f58f4=\"\"> </p><ul style=\"margin: 0rem 0.25rem;font-size: 0.7rem;color: rgba(0,0,0,0.54)\" _v-285f58f4=\"\"> <li v-for=\"cname in currentCompanyDetail.companyNames\" _v-285f58f4=\"\">{{cname.name}}</li> </ul> <p _v-285f58f4=\"\"></p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 注册地址 </p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.address}} </p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 企业类型 </p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.companytyp}} </p> </li> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 经营范围 </p> <p class=time _v-285f58f4=\"\"> {{currentCompanyDetail.businessscope}} </p> </li> </ul> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-if=showModalTag _v-285f58f4=\"\"> <div class=comment-content-tag _v-285f58f4=\"\"> <div class=login-close @click=\"showModalTag = false\" _v-285f58f4=\"\"> <a class=delete-icon _v-285f58f4=\"\"></a> </div> <div class=comment-reply _v-285f58f4=\"\"> <input class=input-search-c type=text placeholder=输入标签名称 v-model=tagname _v-285f58f4=\"\"> <a class=btn-Publish @click=saveTag() _v-285f58f4=\"\">确定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-if=showModalTag _v-285f58f4=\"\"></div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=\"tipGoBind &amp;&amp; !loading\" _v-285f58f4=\"\"> <div class=binding-content _v-285f58f4=\"\"> <a class=binding-logo _v-285f58f4=\"\"></a> <div class=binding-text _v-285f58f4=\"\"> 立即绑定IBDATA账号<br _v-285f58f4=\"\">成为金融分析高手 </div> <div class=binding-bot _v-285f58f4=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-285f58f4=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-285f58f4=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-285f58f4=\"\"></div> <div class=wrapper v-show=smartEngine.open _v-285f58f4=\"\"> <div class=company-details-title _v-285f58f4=\"\"> <span class=cancle-btn @click.stop=\"smartEngine.open = false, setCnzz('[Mobile]信披搜索', '收起公司详情', '')\" _v-285f58f4=\"\"></span> <span class=\"menu-options blue\" style=\"font-size: 16px\" _v-285f58f4=\"\">{{smartEngine.companyInfo.shortname}}({{smartEngine.companyInfo.code}})</span> </div> <div class=company-details-head _v-285f58f4=\"\"> <div class=search-company-list _v-285f58f4=\"\"> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">法人</span> <span class=mar _v-285f58f4=\"\">{{smartEngine.companyInfo.legalRepresentative}}</span></p> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">成立日期</span> <span class=mar _v-285f58f4=\"\">{{smartEngine.companyInfo.founddate}}</span> <span class=title _v-285f58f4=\"\">所属地域</span> <span class=mar _v-285f58f4=\"\">{{smartEngine.companyInfo.area}}</span></p> </div> <div class=\"search-company-list last-child\" _v-285f58f4=\"\"> <p _v-285f58f4=\"\"><span class=title _v-285f58f4=\"\">行业</span> <span class=mar _v-285f58f4=\"\">{{smartEngine.companyInfo.industry}}</span></p> </div> </div> <div class=company-details-box _v-285f58f4=\"\"> <ul class=one-row-box _v-285f58f4=\"\"> <li _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 公司名称 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.name}} </p> </li> <li v-if=smartEngine.companyInfo.name_en _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 英文名称 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.name_en}} </p> </li> <li v-if=smartEngine.companyInfo.regcode _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 统一社会信用代码 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.regcode}} </p> </li> <li v-if=smartEngine.companyInfo.regmoney _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\">注册资本</p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.regmoney | formatNumber}}（万元） </p> </li> <li v-if=smartEngine.companyInfo.secretaries _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 董 秘 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.secretaries}} </p> </li> <li v-if=smartEngine.companyInfo.address _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 注册地址 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.address}} </p> </li> <li v-if=smartEngine.companyInfo.website _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 公司网址 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.website}} </p> </li> <li v-if=smartEngine.companyInfo.phone _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 电 话 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.phone}} </p> </li> <li v-if=smartEngine.companyInfo.fax _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 传 真 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.fax}} </p> </li> <li v-if=smartEngine.companyInfo.postcode _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 邮 编 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.postcode}} </p> </li> <li v-if=smartEngine.companyInfo.companytyp _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 企业类型 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.companytyp}} </p> </li> <li v-if=smartEngine.companyInfo.businessscope _v-285f58f4=\"\"> <p class=date _v-285f58f4=\"\"> 经营范围 </p> <p class=time _v-285f58f4=\"\"> {{smartEngine.companyInfo.businessscope}} </p> </li> </ul> </div> </div> </div> <div class=footer-comment style=bottom:0px v-if=!showCompanyDetailWrap _v-285f58f4=\"\"> <span class=footer-text _v-285f58f4=\"\"><a href=javascript:; @click=\"commentinput = true, content= '',pid = 0\" _v-285f58f4=\"\"><i class=comment-icon _v-285f58f4=\"\"></i>评论一下</a></span> <span class=footer-zan v-show=!showComments _v-285f58f4=\"\"> <a href=javascript:; @click=\"showComments = true, loadcomment()\" _v-285f58f4=\"\"><span class=qinp _v-285f58f4=\"\"><i _v-285f58f4=\"\"></i>{{cpwtotal}}</span></a> </span> <span class=footer-zan v-show=showComments _v-285f58f4=\"\"> <a href=javascript:; @click=\"showComments = false\" _v-285f58f4=\"\"><span class=text _v-285f58f4=\"\"><i _v-285f58f4=\"\"></i>返回搜索</span></a> </span> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-show=commentinput @click.self=\"commentinput = false\" _v-285f58f4=\"\"> <div class=comment-content-tag _v-285f58f4=\"\"> <div class=login-close _v-285f58f4=\"\"> <a class=delete-icon href=javascript:; @click=\"commentinput = false\" _v-285f58f4=\"\"></a> </div> <div class=comment-reply _v-285f58f4=\"\"> <textarea cols=\"\" rows=2 class=input-a placeholder=输入发表内容 v-model=content _v-285f58f4=\"\"></textarea> <span class=anonymous @click=\"anonym == 1 ? anonym = 0:anonym = 1\" _v-285f58f4=\"\"> <label class=\"el-checkbox mar\" _v-285f58f4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked':anonym === 1}\" _v-285f58f4=\"\"><span class=el-checkbox-inner _v-285f58f4=\"\"></span> </span> <span class=el-checkbox-label _v-285f58f4=\"\">匿名评论</span> </label> </span> <a class=btn-Publish href=javascript:; @click=\"commentinput = false,addComment(2, sid)\" _v-285f58f4=\"\">发表</a> </div> </div> </div> <div v-if=commentinput class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div _v-285f58f4=\"\"></div> <div v-if=commentinput class=\"modal-backdrop fade in\" _v-285f58f4=\"\"></div> <bigimg :bigimgobj=bigImgObj _v-285f58f4=\"\"></bigimg> </div>";

/***/ },
/* 783 */
/***/ function(module, exports) {

	module.exports = "<div class=cov-vue-date _v-2a48d0d1=\"\"> <div class=datepickbox v-if=showinput _v-2a48d0d1=\"\"> <input type=text readonly=\"\" title=\"input date\" class=cov-datepicker placeholder={{option.placeholder}} v-model=time :required=required @click=showCheck :style=option.inputStyle _v-2a48d0d1=\"\"> </div> <div class=datepicker-overlay v-if=showInfo.check @click=dismiss($event) v-bind:style=\"{'background' : option.overlayOpacity? 'rgba(0,0,0,'+option.overlayOpacity+')' : 'rgba(0,0,0,0.5)'}\" _v-2a48d0d1=\"\"> <div class=cov-date-body :style=\"{'background-color': option.color ? option.color.header : '#3f51b5'}\" _v-2a48d0d1=\"\"> <div class=cov-date-monthly _v-2a48d0d1=\"\"> <div class=cov-date-previous @click=\"nextMonth('pre')\" _v-2a48d0d1=\"\">«</div> <div class=cov-date-caption :style=\"{'color': option.color ? option.color.headerText : '#fff'}\" _v-2a48d0d1=\"\"> <span @click=showYear _v-2a48d0d1=\"\"><small _v-2a48d0d1=\"\">{{checked.year}}</small></span> <span @click=showMonth _v-2a48d0d1=\"\">{{displayInfo.month}}</span> </div> <div class=cov-date-next @click=\"nextMonth('next')\" _v-2a48d0d1=\"\">»</div> </div> <div class=cov-date-box v-if=showInfo.day _v-2a48d0d1=\"\"> <div class=cov-picker-box _v-2a48d0d1=\"\"> <div class=week _v-2a48d0d1=\"\"> <ul _v-2a48d0d1=\"\"> <li v-for=\"weekie in library.week\" _v-2a48d0d1=\"\">{{weekie}}</li> </ul> </div> <div class=day v-for=\"day in dayList\" track-by=$index @click=checkDay(day) :class=\"{'checked':day.checked,'unavailable':day.unavailable,'passive-day': !(day.inMonth)}\" _v-2a48d0d1=\"\">{{day.value}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.year _v-2a48d0d1=\"\"> <div class=\"cov-picker-box date-list\" id=yearList _v-2a48d0d1=\"\"> <div class=date-item v-for=\"yearItem in library.year\" track-by=$index @click=setYear(yearItem) _v-2a48d0d1=\"\">{{yearItem}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.month _v-2a48d0d1=\"\"> <div class=\"cov-picker-box date-list\" _v-2a48d0d1=\"\"> <div class=date-item v-for=\"monthItem in library.month\" track-by=$index @click=setMonth(monthItem) _v-2a48d0d1=\"\">{{monthItem}}</div> </div> </div> <div class=\"cov-date-box list-box\" v-if=showInfo.hour _v-2a48d0d1=\"\"> <div class=\"cov-picker-box date-list\" _v-2a48d0d1=\"\"> <div class=watch-box _v-2a48d0d1=\"\"> <div class=hour-box _v-2a48d0d1=\"\"> <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-2a48d0d1=\"\"></div> <ul _v-2a48d0d1=\"\"> <li class=hour-item v-for=\"hitem in hours\" @click=\"setTime('hour', hitem, hours)\" :class=\"{'active':hitem.checked}\" _v-2a48d0d1=\"\">{{hitem.value}}</li> </ul> </div> <div class=min-box _v-2a48d0d1=\"\"> <div class=\"mui-pciker-rule mui-pciker-rule-ft\" _v-2a48d0d1=\"\"></div> <div class=min-item v-for=\"mitem in mins\" @click=\"setTime('min',mitem, mins)\" :class=\"{'active':mitem.checked}\" _v-2a48d0d1=\"\">{{mitem.value}}</div> </div> </div> </div> </div> <div class=button-box _v-2a48d0d1=\"\"> <span @click=today _v-2a48d0d1=\"\">{{option.buttons? option.buttons.today : 'Today' }}</span> <span @click=picked _v-2a48d0d1=\"\">{{option.buttons? option.buttons.ok : 'Ok'}}</span> </div> </div> </div> </div>";

/***/ },
/* 784 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-2e91db50=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-2e91db50=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-2e91db50=\"\"> <div class=loading-img _v-2e91db50=\"\"></div> </div> </div> <div class=search-company-box _v-2e91db50=\"\"> <div class=pledge-box1 _v-2e91db50=\"\"> <div class=pledge-box1-top _v-2e91db50=\"\"> <div class=Quarterly-Report style=\"float: left\" v-if=\"allSupplierDate.length > 0\" _v-2e91db50=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-2e91db50=\"\"> {{ curSupplierDate }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-2e91db50=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-2e91db50=\"\"> <li v-for=\"h in allSupplierDate\" _v-2e91db50=\"\"> <a href=javascript:; v-if=\"curSupplierDate != h\" @click=\"clickDropmenu(), curSupplierDate = h, supplierFilter()\" _v-2e91db50=\"\">{{ h }}</a> </li> </ul> </div> <div class=Single-list-main v-if=\"supplierList.length > 0\" _v-2e91db50=\"\"> <ul class=Single-list-box v-for=\"(index, h) in supplierList\" track-by=$index _v-2e91db50=\"\"> <li class=list-w _v-2e91db50=\"\"> <p class=date _v-2e91db50=\"\">客户名称</p> <p class=time _v-2e91db50=\"\">{{ h.name }}</p></li> <li class=list-w _v-2e91db50=\"\"> <p class=date _v-2e91db50=\"\">销售额</p> <p class=time _v-2e91db50=\"\">{{ h.money | money }}</p> </li> <li class=list-w _v-2e91db50=\"\"> <p class=date _v-2e91db50=\"\">销售占比</p> <p class=time _v-2e91db50=\"\">{{ h.ratio }}</p> </li> <li class=list-w _v-2e91db50=\"\"> <p class=date _v-2e91db50=\"\">排名</p> <p class=time _v-2e91db50=\"\">{{ h.rank }}</p> </li> </ul> </div> <div class=Single-list-main v-if=\"!supplierList.length &amp;&amp; !loading\" _v-2e91db50=\"\"> <div class=Block-trade-no _v-2e91db50=\"\">暂无数据</div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-2e91db50=\"\"> <div class=binding-content _v-2e91db50=\"\"> <a class=binding-logo _v-2e91db50=\"\"></a> <div class=binding-text _v-2e91db50=\"\"> 立即绑定IBDATA账号<br _v-2e91db50=\"\">成为金融分析高手 </div> <div class=binding-bot _v-2e91db50=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-2e91db50=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-2e91db50=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-2e91db50=\"\"></div>";

/***/ },
/* 785 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-2f09016a=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-2f09016a=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-2f09016a=\"\"> <div class=loading-img _v-2f09016a=\"\"></div> </div> </div> <div class=search-company-box _v-2f09016a=\"\"> <div class=pledge-box1 _v-2f09016a=\"\"> <div class=pledge-box1-top _v-2f09016a=\"\"> <div class=Quarterly-Report style=\"float: left\" v-if=\"allDateTyp.length > 0\" _v-2f09016a=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-2f09016a=\"\"> <template v-if=\"curDateTyp == 'ALL'\">全部</template> <template v-if=\"curDateTyp != 'ALL'\">{{ curDateTyp }}</template> <span class=close-bot @click.stop=showDateDropmemu($event) _v-2f09016a=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-2f09016a=\"\"> <li v-for=\"h in allDateTyp\" _v-2f09016a=\"\"> <a href=javascript:; v-if=\"curDateTyp != h\" @click=\"clickDropmenu(), curDateTyp = h, filter()\" _v-2f09016a=\"\">{{ h }}</a> </li> </ul> </div> </div> <div class=pledge-box1 v-if=\"industryList.length > 0\" _v-2f09016a=\"\"> <template v-if=showYysr> <div class=pledge-box1-top _v-2f09016a=\"\"> <h3 _v-2f09016a=\"\">营业收入(元)</h3> </div> <div class=Single-list-main _v-2f09016a=\"\"> <ul class=Single-list-box _v-2f09016a=\"\"> <template v-for=\"h in industryList\" track-by=$index> <li v-if=h.yysr _v-2f09016a=\"\"> <p class=date _v-2f09016a=\"\">{{ h.name }}</p> <p class=time _v-2f09016a=\"\">{{ h.yysr | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYycb> <div class=pledge-box1-top _v-2f09016a=\"\"> <h3 _v-2f09016a=\"\">营业成本(元)</h3> </div> <div class=Single-list-main _v-2f09016a=\"\"> <ul class=Single-list-box _v-2f09016a=\"\"> <template v-for=\"h in industryList\" track-by=$index> <li v-if=h.yycb _v-2f09016a=\"\"> <p class=date _v-2f09016a=\"\">{{ h.name }}</p> <p class=time _v-2f09016a=\"\">{{ h.yycb | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYylr> <div class=pledge-box1-top _v-2f09016a=\"\"> <h3 _v-2f09016a=\"\">营业利润(元)</h3> </div> <div class=Single-list-main _v-2f09016a=\"\"> <ul class=Single-list-box _v-2f09016a=\"\"> <template v-for=\"h in industryList\" track-by=$index> <li v-if=h.yylr _v-2f09016a=\"\"> <p class=date _v-2f09016a=\"\">{{ h.name }}</p> <p class=time _v-2f09016a=\"\">{{ h.yylr | money }}</p> </li> </template> </ul> </div> </template> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-2f09016a=\"\"> <div class=binding-content _v-2f09016a=\"\"> <a class=binding-logo _v-2f09016a=\"\"></a> <div class=binding-text _v-2f09016a=\"\"> 立即绑定IBDATA账号<br _v-2f09016a=\"\">成为金融分析高手 </div> <div class=binding-bot _v-2f09016a=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-2f09016a=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-2f09016a=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-2f09016a=\"\"></div>";

/***/ },
/* 786 */
/***/ function(module, exports) {

	module.exports = "<div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-33019eea=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-33019eea=\"\"> <div class=loading-img _v-33019eea=\"\"></div> </div> </div> <div class=wrapper v-show=!viewMore.show _v-33019eea=\"\"> <div class=search-header _v-33019eea=\"\"> <div class=search-header-text _v-33019eea=\"\"> 初步尽调信息</div> </div> <div class=search-company-box _v-33019eea=\"\"> <div class=dhy-details-box style=margin-top:0.5rem v-if=\"company &amp;&amp; !loading\" _v-33019eea=\"\"> <div class=dhy-list-box _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">证券简称</p><p class=time _v-33019eea=\"\">{{ company.shortname }}</p></li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">证券代码</p><p class=time _v-33019eea=\"\">{{ company.code }}</p></li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">公司全称</p><p class=time _v-33019eea=\"\">{{ company.companyname }}</p></li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">所属交易所、板块</p><p class=time _v-33019eea=\"\">{{ company.plate | plate }}</p></li> </ul> </div> </div> <div class=dhy-details-box v-if=\"pledgor &amp;&amp; !loading\" _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\">融入方基本信息</h3> <div class=dhy-list-box _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股东名称</p> <p class=time v-if=pledgor.holder _v-33019eea=\"\">{{pledgor.holder.name}}</p> <p class=time v-else=\"\" _v-33019eea=\"\">{{intoPerson}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股东性质</p> <p class=time v-if=pledgor.holder.holdertyp _v-33019eea=\"\">{{pledgor.holder.holdertyp}}</p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持股数量（万股）</p> <p class=time v-if=pledgor.holder.quantity _v-33019eea=\"\">{{pledgor.holder.quantity / 10000 | money}}</p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">持股比例</p> <p class=time v-if=pledgor.holder.ratio _v-33019eea=\"\">{{ parseFloat(pledgor.holder.ratio) }}%</p> <p v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持有有限售条件的股份数量(万股)</p> <p class=time v-if=pledgor.holder.limitedquantity _v-33019eea=\"\">{{pledgor.holder.limitedquantity/ 10000 | money}}</p> <p v-else=\"\" _v-33019eea=\"\">--</p> </li> <li v-if=pledgor.executive.job _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">董监高</p> <p class=time _v-33019eea=\"\">{{pledgor.executive.job}}</p> </li> </ul> </div> </div> <div class=pledge-list-box1 v-if=\"showpledgor &amp;&amp; !loading\" _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">融入方近三年监管及处罚信息</li> <li class=title _v-33019eea=\"\">证监会</li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">行政处罚</p> <p class=time v-if=\"pledgorNoticeInfo.xzcf.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.xzcf.lists[0]), setCnzz('查看公告', '点击查看行政处罚公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.xzcf.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.xzcf.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.xzcf.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.xzcf.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">立案调查</p> <p class=time v-if=\"pledgorNoticeInfo.ladc.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.ladc.lists[0]), setCnzz('查看公告', '点击查看立案调查公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.ladc.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.ladc.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.ladc.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.ladc.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管措施</p> <p class=time v-if=\"pledgorNoticeInfo.jgcszjh.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.jgcszjh.lists[0]), setCnzz('查看公告', '点击查看监管措施公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.jgcszjh.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.jgcszjh.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.jgcszjh.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.jgcszjh.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">市场禁入</p> <p class=time v-if=\"pledgorNoticeInfo.scjr.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.scjr.lists[0]), setCnzz('查看公告', '点击查看市场禁入公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.scjr.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.scjr.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.scjr.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.scjr.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li class=title _v-33019eea=\"\">交易所</li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管问询</p> <p class=time v-if=\"pledgorNoticeInfo.jgwx.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.jgwx.lists[0]), setCnzz('查看公告', '点击查看监管问询公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.jgwx.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.jgwx.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.jgwx.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.jgwx.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管措施</p> <p class=time v-if=\"pledgorNoticeInfo.jgcs.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(pledgorNoticeInfo.jgcs.lists[0]), setCnzz('查看公告', '点击查看监管措施公告', '')\" _v-33019eea=\"\">{{pledgorNoticeInfo.jgcs.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{pledgorNoticeInfo.jgcs.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"pledgorNoticeInfo.jgcs.total > 1\" @click.self=\"showlists(pledgorNoticeInfo.jgcs.lists), setCnzz('查看更多', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> </ul> </div> <div class=dhy-details-box v-if=\"pledge.notice &amp;&amp; !loading\" _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\">融入方最新质押信息</h3> <div class=search-result-list v-if=pledge.notice _v-33019eea=\"\"> <p class=head _v-33019eea=\"\"> <span class=xsl-icon _v-33019eea=\"\"></span> <a href=javascript:; @click=goNotice(pledge.notice) _v-33019eea=\"\">{{ pledge.notice.title }}</a> </p> <p class=Subtitle _v-33019eea=\"\"> <span class=fl _v-33019eea=\"\">证券代码：2520008</span> <span class=fr _v-33019eea=\"\">{{ pledge.notice.publishDate}}</span> </p> <template v-if=pledge.notice.child v-for=\"child in pledge.notice.child\"> <p class=\"blak font-weight lien child-title\" :style=indentChild(child.code) @click=\"viewStockTitle(pledge.notice, child.code)\" _v-33019eea=\"\"> {{{ child.title }}} </p> <p class=lien :style=indentChild(child.code) v-if=child.content _v-33019eea=\"\"> {{{ child.content.join('...... ') }}} </p> <template v-for=\"c in child.contents\" v-if=child.contents> <p class=lien :style=indentChild(child.code) v-if=\"c.htmltag=='p'\" _v-33019eea=\"\"> {{{ c.content }}}<br _v-33019eea=\"\"> </p> <template v-if=\"c.htmltag=='table'\"> <div class=table-result-main _v-33019eea=\"\"> <table cellpadding=0 class=table-result-dhy _v-33019eea=\"\"> <tbody _v-33019eea=\"\"> <tr v-for=\"(rowidx, row) in c.table\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-33019eea=\"\"> <td v-for=\"(colidx, col) in row\" rowspan=\"{{ col.row }}\" colspan=\"{{ col.col }}\" track-by=$index _v-33019eea=\"\"> {{{col.value}}} </td> </tr> </tbody> </table> </div> <div class=table-whole _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <a href=javascript:; @click=\"viewStockTable(pledge.notice, child.code, c.offset)\" _v-33019eea=\"\"> <span class=\"search-icon small-table\" _v-33019eea=\"\"></span>查看表格全部内容 </a> </li> </ul> </div> </template> </template> </template> </div> </div> <div class=\"dhy-details-box lszy-box\" _v-33019eea=\"\"> <h3 class=\"\" v-show=\"mergePledge.length>0\" _v-33019eea=\"\">历史质押信息</h3> <div class=swiper-container _v-33019eea=\"\"> <div class=swiper-wrapper _v-33019eea=\"\"> <div class=\"pledge-list-box swiper-slide\" v-for=\"(index, h) in mergePledge\" track-by=$index _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股东名称</p> <p class=time _v-33019eea=\"\">{{ h.name_of_shareholder | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">是否为第一大股东及一致行动人</p> <p class=time _v-33019eea=\"\">{{ h.whether_the_largest_shareholder_and_concerted_action | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股数(股)</p> <p class=time _v-33019eea=\"\">{{ h.pledge_nums | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股份性质</p> <p class=time _v-33019eea=\"\">{{ h.pledge_of_shares_in_nature | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">开始日期</p> <p class=time _v-33019eea=\"\">{{ h.pledge_start_date | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">结束日期</p><p class=time _v-33019eea=\"\">{{ h.pledge_due_date | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">延期后结束日期</p> <p class=time _v-33019eea=\"\">{{ h.after_the_expiration_of_the_pledge_due_date | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">解除日期</p><p class=time _v-33019eea=\"\">{{h.release_pledge_date | nullVal}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">本次质押占其所持股份比例(%)</p> <p class=time _v-33019eea=\"\">{{ h.the_pledge_of_its_shareholding_ratio | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">用途</p> <p class=time _v-33019eea=\"\">{{ h.use | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">质权人</p> <p class=time _v-33019eea=\"\">{{ h.pledgee | nullVal }}</p> </li> </ul> </div> </div> <div class=swiper-pagination _v-33019eea=\"\"></div> </div> </div> <div class=\"dhy-details-box ljzy-box\" _v-33019eea=\"\"> <h3 class=\"\" v-show=\"cumulative_pledge.length > 0\" _v-33019eea=\"\">累计质押</h3> <div class=swiper-container _v-33019eea=\"\"> <div class=swiper-wrapper _v-33019eea=\"\"> <div class=\"pledge-list-box swiper-slide\" v-for=\"(index, h) in cumulative_pledge\" track-by=$index _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">股东名称</p> <p class=time _v-33019eea=\"\">{{ h.holder_name | nullVal}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">公司总股本</p> <p class=time _v-33019eea=\"\">{{ h.company_share_capital | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">累计质押数</p> <p class=time _v-33019eea=\"\">{{ h.cumulative_pledge | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">累计质押数占总股本</p> <p class=time _v-33019eea=\"\">{{ h.cumulative_pledge_proportion_of_total_capital | percent | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">累计质押数占持有股</p> <p class=time _v-33019eea=\"\">{{ h.cumulative_pledge_proportion_of_shares_held | percent | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">累计质押非限售股</p> <p class=time _v-33019eea=\"\">{{ h.cumulative_pledge_unlimited_selling_shares | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">累计质押限售股</p> <p class=time _v-33019eea=\"\">{{ h.cumulative_pledge_limited_selling_shares | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持有股数</p> <p class=time _v-33019eea=\"\">{{ h.shares_held | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持有股数占总股本</p> <p class=time _v-33019eea=\"\">{{ h.shares_held_proportion_of_total_capital | percent | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持有非限售股数</p> <p class=time _v-33019eea=\"\">{{ h.shares_held_unlimited_selling | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">持有限售股数</p> <p class=time _v-33019eea=\"\">{{ h.shares_held_limited_selling | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">直接持股数</p> <p class=time _v-33019eea=\"\">{{ h.shares_held_directly | money | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">直接持股数占总股本</p> <p class=time _v-33019eea=\"\">{{ h.shares_held_directly_proportion_of_total_capital | percent | nullVal }}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">发布日期</p> <p class=time _v-33019eea=\"\">{{ h.publishdate | nullVal }}</p> </li> </ul> </div> </div> <div class=swiper-pagination _v-33019eea=\"\"></div> </div> </div> <div class=rate-chart-wrap v-if=\"cumulative_pledge.length > 0\" _v-33019eea=\"\"> <div class=analyze-chart-box3 style=\"width: 100%\" _v-33019eea=\"\"> <div class=rate-chart3 style=\"height:150px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px\" _v-33019eea=\"\"></div> </div> </div> <div class=pledge-box1 v-if=pledge _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\"> 全市场质押情况 <span style=\"color: #333\" _v-33019eea=\"\">（截止 {{pledge.rate.updtime.slice(0,10)}}）</span> </h3> <div class=pledge-list-box1 _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">证券代码</p> <p class=time _v-33019eea=\"\">{{pledge.rate.stock_code}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">证券简称</p> <p class=time _v-33019eea=\"\">{{pledge.rate.securities_abbreviation}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">质押笔数(笔)</p> <p class=time _v-33019eea=\"\">{{pledge.rate.pledge_count}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">无限售股份质押数量(万)</p> <p class=time _v-33019eea=\"\">{{pledge.rate.unlimited_number_of_shares_pledged | money}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">有限售股份质押数量(万)</p> <p class=time _v-33019eea=\"\">{{pledge.rate.limited_number_of_shares_pledged_shares | money}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">A股总股本(万)</p> <p class=time _v-33019eea=\"\">{{pledge.rate.total_share_capital | money}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">质押比例（%）</p> <p class=time _v-33019eea=\"\">{{parseFloat(pledge.rate.pledge_ratio)}}</p> </li> </ul> </div> </div> <div class=rate-chart-wrap v-show=\"rate_company.dataX.length>0\" _v-33019eea=\"\"> <p class=a-text _v-33019eea=\"\">全场质押比例</p> <div class=analyze-chart-box style=\"width: 100%\" _v-33019eea=\"\"> <div id=rate-chart style=\"height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px\" _v-33019eea=\"\"></div> </div> </div> <div class=rate-chart-wrap v-show=\"rate_szse.dataX.length>0 || rate_shse.dataX.length>0\" _v-33019eea=\"\"> <p class=a-text v-show=\"rate_shse.dataX.length>0\" _v-33019eea=\"\">上交所平均质押率</p> <p class=a-text v-show=\"rate_szse.dataX.length>0\" _v-33019eea=\"\">深交所平均质押率</p> <div class=analyze-chart-box2 style=\"width: 100%\" _v-33019eea=\"\"> <div id=rate-chart2 style=\"height:180px;width:100%;border:1px solid rgb(232, 238, 245);margin-bottom:10px\" _v-33019eea=\"\"></div> </div> </div> <div class=dhy-details-box v-if=\"showcompany || stock\" _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\">标的证券基本情况</h3> <div class=pledge-list-box _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li _v-33019eea=\"\"> <p class=date v-if=!checkProperty(stock.risk) _v-33019eea=\"\">ST</p> <p class=date v-if=checkProperty(stock.risk) _v-33019eea=\"\">存在退市风险</p> <template v-if=!checkProperty(stock.risk)> <p class=time v-if=stock.risk.qita _v-33019eea=\"\">是</p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </template> <template v-if=checkProperty(stock.risk)> <p class=time v-if=stock.risk.ctuishi _v-33019eea=\"\">是</p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </template> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">*ST</p> <p class=time v-if=stock.risk.tuishi _v-33019eea=\"\">--</p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">暂停上市</p> <p class=time v-if=stock.risk.zanting _v-33019eea=\"\"> <a class=info-Underline @click=\"goNotice(stock.risk.zanting), setCnzz('查看公告', '点击查看暂停上市公告', '')\" _v-33019eea=\"\">{{stock.risk.zanting.title}}</a> <span class=External-date _v-33019eea=\"\">{{stock.risk.zanting.publishdate}}</span> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">退市整理期</p> <p class=time v-if=stock.risk.zhengli _v-33019eea=\"\"> <a class=info-Underline @click=\"goNotice(stock.risk.zhengli), setCnzz('查看公告', '点击查看退市整理期公告', '')\" _v-33019eea=\"\">{{stock.risk.zhengli.title}}</a> <span class=External-date _v-33019eea=\"\">{{stock.risk.zhengli.publishdate}}</span> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">摘帽未满一年</p> <p class=time v-if=stock.risk.zhaimao _v-33019eea=\"\"> <a class=info-Underline @click=\"goNotice(stock.risk.zhaimao), setCnzz('查看公告', '点击查看摘帽未满一年公告', '')\" _v-33019eea=\"\">{{stock.risk.zhaimao.title}}</a> <span class=External-date _v-33019eea=\"\">{{stock.risk.zhaimao.publishdate}}</span> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">恢复上市未满一年</p> <p class=time v-if=stock.risk.huifu _v-33019eea=\"\"> <a class=info-Underline @click=\"goNotice(stock.risk.huifu), setCnzz('查看公告', '点击查看恢复上市未满一年公告', '')\" _v-33019eea=\"\">{{stock.risk.huifu.title}}</a> <span class=External-date _v-33019eea=\"\">{{stock.risk.huifu.publishdate}}</span> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> </ul> </div> </div> <div class=dhy-details-box _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\">标的公司业绩</h3> </div> <div class=pledge-list-box3 _v-33019eea=\"\"> <div class=title _v-33019eea=\"\">近五年营业收入</div> <ul v-for=\"(index, item) in yearlist\" track-by=$index _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">{{ item }}</li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">营业收入(元)</p><p class=time _v-33019eea=\"\">{{ businessincome[index] | money }}</p></li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">营业收入同比增长率(%)</p><p class=time _v-33019eea=\"\">{{ yysrtbzzl[index] }}</p></li> </ul> </div> <div class=rate-chart-wrap _v-33019eea=\"\"> <div class=\"businesschart standard-chart\" v-if=\"yearlist.length > 0\" style=height:180px;width:100%;float:left _v-33019eea=\"\"></div> </div> <div class=pledge-list-box3 _v-33019eea=\"\"> <div class=title _v-33019eea=\"\">近五年归母净利润</div> <ul v-for=\"(index, item) in yearlist\" track-by=$index _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">{{ item }}</li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">归母净利润(元)</p><p class=time _v-33019eea=\"\">{{ retainedprofitowner[index] | money }}</p></li> <li _v-33019eea=\"\"><p class=date _v-33019eea=\"\">归母净利润同比增长率(%)</p><p class=time _v-33019eea=\"\">{{ gmjlrtbzzl[index] }}</p></li> </ul> </div> <div class=rate-chart-wrap _v-33019eea=\"\"> <div class=\"gmjlrchart standard-chart\" v-if=\"yearlist.length > 0\" style=height:180px;width:100%;float:left _v-33019eea=\"\"></div> </div> <div class=pledge-list-box v-if=lastDate.date _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">最近一期归母净利润</li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">最近报告期</p> <p class=time _v-33019eea=\"\">{{lastDate.date}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">归母净利润(元)</p> <p class=time _v-33019eea=\"\">{{lastDate.value | money}}</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">归母净利润同比增长率(%)</p> <p class=time _v-33019eea=\"\">{{lastDate.ratio}}</p> </li> </ul> </div> <div class=pledge-list-box1 v-if=showcompany _v-33019eea=\"\"> <ul _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">标的公司近三年监管及处罚信息</li> <li class=title _v-33019eea=\"\">证监会</li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">行政处罚</p> <p class=time v-if=\"companyNoticeInfo.xzcf.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.xzcf.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看行政处罚公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.xzcf.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.xzcf.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.xzcf.total > 1\" @click.self=\"showlists(companyNoticeInfo.xzcf.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">立案调查</p> <p class=time v-if=\"companyNoticeInfo.ladc.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.ladc.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看立案调查公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.ladc.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.ladc.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.ladc.total > 1\" @click.self=\"showlists(companyNoticeInfo.ladc.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管措施</p> <p class=time v-if=\"companyNoticeInfo.jgcszjh.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.jgcszjh.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管措施公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.jgcszjh.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.jgcszjh.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.jgcszjh.total > 1\" @click.self=\"showlists(companyNoticeInfo.jgcszjh.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">市场禁入</p> <p class=time v-if=\"companyNoticeInfo.scjr.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.scjr.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看市场禁入公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.scjr.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.srjc.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.scjr.total > 1\" @click.self=\"showlists(companyNoticeInfo.scjr.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li class=title _v-33019eea=\"\">交易所</li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管问询</p> <p class=time v-if=\"companyNoticeInfo.jgwx.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.jgwx.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管问询公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.jgwx.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.jgwx.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.jgwx.total > 1\" @click.self=\"showlists(companyNoticeInfo.jgwx.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> <li _v-33019eea=\"\"> <p class=date _v-33019eea=\"\">监管措施</p> <p class=time v-if=\"companyNoticeInfo.jgcs.total > 0\" _v-33019eea=\"\"> <a class=info-Underline @click.self=\"goNotice(companyNoticeInfo.jgcs.lists[0]), setCnzz('[Mobile]-大黄押', '点击查看监管措施公告', '')\" _v-33019eea=\"\">{{companyNoticeInfo.jgcs.lists[0].title}}</a> <span class=External-date _v-33019eea=\"\">{{companyNoticeInfo.jgcs.lists[0].publishDate}}</span> <a class=more-right style=cursor:pointer v-if=\"companyNoticeInfo.jgcs.total > 1\" @click.self=\"showlists(companyNoticeInfo.jgcs.lists), setCnzz('[Mobile]-大黄押', '点击查看更多', '')\" _v-33019eea=\"\">更多&gt;</a> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> </ul> <ul _v-33019eea=\"\"> <li class=active _v-33019eea=\"\">标的证券是否存在司法冻结</li> <li _v-33019eea=\"\"> <p class=time v-if=stock.risk.dongjie _v-33019eea=\"\"> <a class=info-Underline @click=\"goNotice(stock.risk.dongjie), setCnzz('[Mobile]-大黄押', '点击查看司法冻结公告', '')\" _v-33019eea=\"\">{{stock.risk.dongjie.title}}</a> <span class=External-date _v-33019eea=\"\">{{stock.risk.dongjie.publishdate}}</span> </p> <p class=time v-else=\"\" _v-33019eea=\"\">--</p> </li> </ul> </div> </div> <div class=\"search-result-box important-goga\" v-if=\"relationNotice.lists.length>0\" _v-33019eea=\"\"> <h3 class=\"\" _v-33019eea=\"\">重要公告</h3> <div class=search-result-list v-for=\"notice in relationNotice.lists\" _v-33019eea=\"\"> <p class=head _v-33019eea=\"\"> <span class=\"{{ fileIcon(notice.fileext) }}\" _v-33019eea=\"\"></span> <a href=javascript:; @click=relationNoticeDetail(notice) _v-33019eea=\"\">{{ notice.title }}</a> </p> <p class=Subtitle _v-33019eea=\"\"> <span class=fr _v-33019eea=\"\">{{ notice.publishDate }}</span> </p> </div> <div class=more v-show=\"!loading &amp;&amp; relationNotice.page < relationNotice.totalPage &amp;&amp; relationNotice.total !== 0\" style=\"margin-top: -8px\" _v-33019eea=\"\"> <i class=\"pull_icon loading\" _v-33019eea=\"\"></i> <span style=\"font-size: 15px\" _v-33019eea=\"\">加载中...</span> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" :style=\"{'display': tipGoBind ? 'block' : 'none'}\" _v-33019eea=\"\"> <div class=binding-content _v-33019eea=\"\"> <a class=binding-logo _v-33019eea=\"\"></a> <div class=binding-text _v-33019eea=\"\"> 立即绑定IBDATA账号<br _v-33019eea=\"\">成为金融分析高手 </div> <div class=binding-bot _v-33019eea=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-33019eea=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-33019eea=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" :style=\"{'display': tipGoBind ? 'block' : 'none'}\" _v-33019eea=\"\"></div> </div> <div class=\"wrapper more-wrapper\" v-show=viewMore.show _v-33019eea=\"\"> <div class=company-details-title _v-33019eea=\"\"> <span class=cancle-btn @click=\"viewMore.show=false, viewMore.lists=[]\" _v-33019eea=\"\"></span> </div> <div class=\"search-result-box important-more\" _v-33019eea=\"\"> <div class=search-result-list v-for=\"item in viewMore.lists\" _v-33019eea=\"\"> <p class=head _v-33019eea=\"\"> <a href=javascript:; @click=\"goNotice(item), setCnzz('[mobile]-大黄押', '点击查看更多列表中的公告', '')\" _v-33019eea=\"\">{{ item.title }}</a> </p> <p class=Subtitle _v-33019eea=\"\"> <span class=fr _v-33019eea=\"\">{{ item.publishDate }}</span> </p> </div> </div> </div>";

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div _v-3f858c3f=\"\"> <div class=wrap id=wrap @click=\"hideDropdown($event), hideKeywordDropdown()\" _v-3f858c3f=\"\"> <div class=loading_gif v-show=loading style=\"position: fixed; max-width:640px\" _v-3f858c3f=\"\"> <img src=" + __webpack_require__(104) + " class=loading-img _v-3f858c3f=\"\"> <p style=\"font-size:14px; color: #FFFFFF\" _v-3f858c3f=\"\">数据加载中,请稍等...</p> </div> <div class=wrapper v-show=\"currentuser &amp;&amp; !smartEngine.open\" _v-3f858c3f=\"\"> <div class=stat-analyze v-show=\"!showResultPage &amp;&amp; !showSearchPage &amp;&amp; showTongjiPage\" _v-3f858c3f=\"\"> <div class=search-header _v-3f858c3f=\"\"> <div class=search-header-text @click=\"switchPage(2), setCnzz('[Mobile]-信披搜索页', '从统计页返回搜索结果页', '')\" _v-3f858c3f=\"\"> <span class=arrow-back _v-3f858c3f=\"\"></span>统计 </div> </div> <div class=\"search-header-menu statis\" _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <li @click=\"showStatAnalyze = true, showStatFilter = false, setCnzz('[Mobile]-信披搜索页', '点击分析按钮', '')\" :class=\"{on: showStatAnalyze}\" _v-3f858c3f=\"\">分析</li> <li @click=\"showStatAnalyze = false, showStatFilter = true, setCnzz('[Mobile]-信披搜索页', '点击筛选按钮', '')\" :class=\"{on: showStatFilter}\" _v-3f858c3f=\"\">筛选</li> </ul> </div> <div class=Analysis-list v-show=showStatAnalyze _v-3f858c3f=\"\"> <div class=Analysis-list-box v-if=currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">相关的公司</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in company\" _v-3f858c3f=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">提到的公司</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in related_company\" _v-3f858c3f=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">相关人员</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in related_name\" _v-3f858c3f=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">相关的公司</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in company\" _v-3f858c3f=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">提到的公司</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in related_company\" _v-3f858c3f=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">相关人员</span> <ul _v-3f858c3f=\"\"> <li v-for=\"item in related_name\" _v-3f858c3f=\"\">{{ item.key }}</li> </ul> </div> </div> <div class=Analysis-list v-show=\"showStatFilter &amp;&amp; searched===stype\" _v-3f858c3f=\"\"> <div class=Analysis-list-box v-show=\"aggLabels.length>0\" _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">公告标签</span> <ul _v-3f858c3f=\"\"> <li v-for=\"d in aggLabels\" _v-3f858c3f=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-3f858c3f=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['labels'][d.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('labels', d), setCnzz('[Mobile]-信披搜索页', '点击标签筛选', '')\" _v-3f858c3f=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-3f858c3f=\"\"> </span> <span class=el-checkbox-label @click.stop=\"addConditionNew('labels', d), setCnzz('[Mobile]-信披搜索页', '点击标签筛选', '')\" _v-3f858c3f=\"\">{{d.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-3f858c3f=\"\">{{d.count}}</span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggTypes.length>0\" _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">公告类型</span> <ul _v-3f858c3f=\"\"> <li v-for=\"type in aggTypes\" _v-3f858c3f=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-3f858c3f=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['type'][type.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('type', type), setCnzz('[Mobile]-信披搜索页', '点击公告类型筛选', '')\" _v-3f858c3f=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-3f858c3f=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('type', type), setCnzz('[Mobile]-信披搜索页', '点击公告类型筛选', '')\" _v-3f858c3f=\"\">{{type.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-3f858c3f=\"\"> {{type.count}} </span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggPlates.length>0\" _v-3f858c3f=\"\"> <span class=head _v-3f858c3f=\"\">板块类型</span> <ul _v-3f858c3f=\"\"> <li v-for=\"plate in aggPlates\" _v-3f858c3f=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-3f858c3f=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['plate'][plate.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('plate', plate),setCnzz('[Mobile]-信披搜索页', '点击板块类型筛选', '')\" _v-3f858c3f=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-3f858c3f=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('plate', plate),setCnzz('[Mobile]-信披搜索页', '点击板块类型筛选', '')\" _v-3f858c3f=\"\">{{plate.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-3f858c3f=\"\"> {{plate.count}} </span> </li> </ul> </div> </div> </div> <div class=search-conditions v-show=\"!showResultPage &amp;&amp; showSearchPage &amp;&amp; !showTongjiPage\" _v-3f858c3f=\"\"> <div class=search-header v-if=hasoneSearch _v-3f858c3f=\"\"> <div class=search-header-text @click.stop=\"switchPage(2), setCnzz('[Mobile]-信披搜索页', '从搜索条件页返回搜索结果页', '')\" _v-3f858c3f=\"\"> <span class=arrow-back _v-3f858c3f=\"\"></span>搜索条件 </div> <span class=search-header-stics @click=\"showModalTag = true\" _v-3f858c3f=\"\">保存标签</span> </div> <div class=\"search-header-menu search-tab-scroll\" _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <li :class=\"{activeTyp: stype == 100 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(100), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">综合</a> </li> <li :class=\"{activeTyp: stype == 1 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(1), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">A股</a> </li> <li :class=\"{activeTyp: stype == 2 }\" style=margin-top:-2px;width:9% _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(2), setCnzz('[Mobile]-信披搜索', '点击新三板按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">新三板</a> </li> <li :class=\"{activeTyp: stype == 3 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(3), setCnzz('[Mobile]-信披搜索', '点击债券按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">债券</a> </li> <li :class=\"{activeTyp: stype == 4 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(4), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">知识库</a> </li> <li :class=\"{activeTyp: stype == 5 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(5), setCnzz('[Mobile]-信披搜索', '点击问题库按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">问题库</a> </li> <li :class=\"{activeTyp: stype == 6 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(6), setCnzz('[Mobile]-信披搜索', '点击港股按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">港股</a> </li> <li :class=\"{activeTyp: stype == 10 }\" _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(10), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">ABS</a> </li> <li :class=\"{activeTyp: stype == 11 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(11), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">研报</a> </li> <li :class=\"{activeTyp: stype == 12 }\" style=margin-top:-2px _v-3f858c3f=\"\"> <a href=javascript:; v-on:click=\"changeStype(12), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-3f858c3f=\"\">新闻</a> </li> </ul> </div> <div class=search-input-share _v-3f858c3f=\"\"> <div class=\"fl search-type\" _v-3f858c3f=\"\"> <div class=\"search-input btn-group\" _v-3f858c3f=\"\"> <div @click.stop=slideDropdown2($event) _v-3f858c3f=\"\"> {{ ttype_name }} <span class=close-bot _v-3f858c3f=\"\"></span> </div> <ul class=\"date-menu close\" _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"ttype!=0\" @click=\"ttype=0\" _v-3f858c3f=\"\">全部</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"ttype!=1\" @click=\"ttype=1\" _v-3f858c3f=\"\">标题</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"ttype!=2 &amp;&amp; showSubTitle\" @click=\"ttype=2\" _v-3f858c3f=\"\">章节标题</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"ttype!=3\" @click=\"ttype=3\" _v-3f858c3f=\"\">正文</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"stype == 5 &amp;&amp; ttype!=4\" @click=\"ttype=4\" _v-3f858c3f=\"\">问题</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"stype == 5 &amp;&amp; ttype!=5\" @click=\"ttype=5\" _v-3f858c3f=\"\">答案</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; v-show=\"stype == 11 &amp;&amp; ttype!=6\" @click=\"ttype=6\" _v-3f858c3f=\"\">图片</a></li> </ul> </div> <input class=input-search-a type=text placeholder=\"\" value=\"\" v-model=keywords _v-3f858c3f=\"\"> </div> <div class=fr _v-3f858c3f=\"\"><a class=search-bot @click=\"mySearch(), setCnzz('[Mobile]-信披搜索', '点击搜索按钮', '')\" _v-3f858c3f=\"\"></a></div> </div> <div class=search-input-engine _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" _v-3f858c3f=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': ai === 1}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner @click.stop=\"smartBtn(), setCnzz('[Mobile]-信披搜索页', '点击智能引擎按钮', '')\" _v-3f858c3f=\"\"></span> <input type=checkbox name=type class=el-checkbox-original _v-3f858c3f=\"\"> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">智能引擎</span> </label> </div> <div class=Key-word _v-3f858c3f=\"\"> <h3 class=\"\" _v-3f858c3f=\"\">关键词</h3> <ul _v-3f858c3f=\"\"> <li v-for=\"ky in keywords_condition\" track-by=$index _v-3f858c3f=\"\"> <div class=Key-word-box _v-3f858c3f=\"\"> <div class=screen-menu _v-3f858c3f=\"\"> <div class=\"release-date btn-group\" _v-3f858c3f=\"\"> <div @click.stop=slideDropdown2($event) _v-3f858c3f=\"\"> {{ ky.ttname }} <span class=close-bot _v-3f858c3f=\"\"></span> </div> <ul class=\"date-menu close\" style=\"left: -0.5rem; width: 7rem\" _v-3f858c3f=\"\"> <li v-show=\"ky.ttype!=0\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 0, '全部')\" _v-3f858c3f=\"\">全部</a></li> <li v-show=\"ky.ttype!=1\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 1, '标题')\" _v-3f858c3f=\"\">标题</a></li> <li v-show=\"ky.ttype!=2 &amp;&amp; showSubTitle\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 2, '章节标题')\" _v-3f858c3f=\"\">章节标题</a></li> <li v-show=\"ky.ttype!=3\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 3, '正文')\" _v-3f858c3f=\"\">正文</a></li> <li v-show=\"stype == 5 &amp;&amp; ky.ttype!=4\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 4, '问题')\" _v-3f858c3f=\"\">问题</a></li> <li v-show=\"stype == 5 &amp;&amp; ky.ttype!=5\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 5, '答案')\" _v-3f858c3f=\"\">答案</a></li> </ul> </div> <span class=release-line _v-3f858c3f=\"\"></span> <div class=\"release-date btn-group\" _v-3f858c3f=\"\"> <div @click.stop=slideDropdown2($event) _v-3f858c3f=\"\"> {{ ky.opname }} <span class=close-bot _v-3f858c3f=\"\"></span> </div> <ul class=\"date-menu close\" style=\"left: -0.4rem; width: 7rem\" _v-3f858c3f=\"\"> <li v-show=\"ky.optype!=1\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 1, '包含全部关键词')\" _v-3f858c3f=\"\">包含全部关键词</a></li> <li v-show=\"ky.optype!=2\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 2, '包含任意关键词')\" _v-3f858c3f=\"\">包含任意关键词</a></li> <li v-show=\"ky.optype!=3\" _v-3f858c3f=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 3, '不含全部关键词')\" _v-3f858c3f=\"\">不含全部关键词</a></li> </ul> </div> </div> <span class=text-box style=\"width: 94%; margin-left: 8px\" _v-3f858c3f=\"\"> <input autocomplete=off maxlength=255 v-model=\"ky['val']\" placeholder=多个词以空格隔开 class=input-search-b name=wd id=kw _v-3f858c3f=\"\"> </span> <div class=text-btn _v-3f858c3f=\"\"> <a href=javascript:; class=btn-add @click=\"addKeywordCondition(), setCnzz('[Mobile]-信披搜索页', '点击添加关键词按钮', '')\" v-if=\"$index === 0\" _v-3f858c3f=\"\">添加</a> <a href=javascript:; class=btn-delete @click=\"rmvKeywordCondition($index), setCnzz('[Mobile]-信披搜索页', '点击删除关键词按钮', '')\" v-if=\"$index > 0\" _v-3f858c3f=\"\">删除</a> </div> </div> </li> </ul> </div> <div class=Announ-list _v-3f858c3f=\"\"> <h3 class=\"\" _v-3f858c3f=\"\">公告信息</h3> <div class=Announ-list-box _v-3f858c3f=\"\"> <span class=text-box _v-3f858c3f=\"\"> <input type=text class=input-search-b placeholder={{pholder}} v-model=companyCode @keyup=\"suggest(companyCode, $event)\" style=\"border: none;width: 100%\" _v-3f858c3f=\"\"> <ul class=company-menu v-if=\"suggestions.length > 0\" tabindex=-1 _v-3f858c3f=\"\"> <li v-for=\"i in suggestions\" @click=\"companyCode = i[0], oldsuggestValue = i[0], queue = [], suggestNum = -1, suggestions = []\" tabindex=-1 _v-3f858c3f=\"\"> <span class=left _v-3f858c3f=\"\">{{i[2]}}</span><span class=right _v-3f858c3f=\"\">{{i[0]}}</span> </li> </ul> </span> <div @click=alertDateModal _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\">发布日期</p> <p class=time _v-3f858c3f=\"\"> <span class=l _v-3f858c3f=\"\">{{startdate}}</span> 至 <span class=r _v-3f858c3f=\"\">{{enddate}}</span> </p> </div> </div> </div> <div v-show=showDateModal _v-3f858c3f=\"\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=Release-date id=Release-date _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 发布日期 </p> <div class=\"home-nav-app btn-group\" _v-3f858c3f=\"\"> <div @click.stop=\"slideDropdown('post_time')\" _v-3f858c3f=\"\"> <span class=select-name _v-3f858c3f=\"\">{{ datetype_name }}</span> <span class=arrow-img _v-3f858c3f=\"\"> <img src=" + __webpack_require__(340) + " alt=\"\" v-show=\"showDropdownMenu !== ''\" _v-3f858c3f=\"\"> <img src=" + __webpack_require__(341) + " alt=\"\" v-show=\"showDropdownMenu == ''\" _v-3f858c3f=\"\"> </span> </div> <ul class=\"lanmu slide-menu date-slide-menu\" v-show=\"showDropdownMenu == 'post_time'\" _v-3f858c3f=\"\"> <li @click=\"changeDateType(1), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">一个月</a></li> <li @click=\"changeDateType(2), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">一个季度</a></li> <li @click=\"changeDateType(3), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">半年</a></li> <li @click=\"changeDateType(4), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">去年</a></li> <li @click=\"changeDateType(5), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">今年</a></li> <li @click=\"changeDateType(6), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">一年</a></li> <li @click=\"changeDateType(7), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">两年</a></li> <li @click=\"changeDateType(8), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">三年</a></li> <li @click=\"changeDateType(9), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">五年</a></li> <li @click=\"changeDateType(10), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">十年</a></li> <li @click=\"changeDateType(98), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">全部</a></li> <li @click=\"changeDateType(99), setCnzz('[Mobile]-信披搜索页', '定义搜索时间范围', '')\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">自定义</a></li> </ul> </div> <p class=time _v-3f858c3f=\"\"> <span class=l style=\"overflow: hidden\" _v-3f858c3f=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-3f858c3f=\"\"></date-picker> </span> 至 <span class=r style=\"overflow: hidden\" _v-3f858c3f=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-3f858c3f=\"\"></date-picker> </span> </p> <p class=btn-confim _v-3f858c3f=\"\"> <a class=btn-cancel @click.stop=\"showDateModal = false, cancelDate(), setCnzz('[Mobile]-信披搜索页', '点击取消按钮', '')\" _v-3f858c3f=\"\">取消</a> <a class=btn-Determine @click.stop=\"showDateModal = false, confirmDate(), setCnzz('[Mobile]-信披搜索页', '点击确定按钮', '')\" _v-3f858c3f=\"\">确定</a> </p> </div> </div> <div class=\"modal-backdrop fade in\" @click.stop=\"showDateModal = false\" _v-3f858c3f=\"\"></div> </div> <div class=Announ-list v-if=showTypAll _v-3f858c3f=\"\"> <h3 class=\"\" _v-3f858c3f=\"\">筛选条件</h3> <div class=Announ-list-box _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <template v-if=showType> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 公告类型 </p> <p class=time @click.stop=\"showCondition('type'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['type'])\" _v-3f858c3f=\"\">全部</span> <span v-for=\"(code, name) in conditions['type']\" style=\"margin-right: 8px\" _v-3f858c3f=\"\">{{name}}</span> </p> </li> </template> <template v-if=showQaType> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 问题类型 </p> <p class=time @click.stop=\"showCondition('qaType'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['qaType'])\" _v-3f858c3f=\"\">全部</span> <span v-for=\"(code, name) in conditions['qaType']\" style=\"margin-right: 8px\" _v-3f858c3f=\"\">{{name}}</span> </p> </li> </template> <template v-if=showPlate> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 板块类型 </p> <p class=time @click.stop=\"showCondition('plate'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['plate']) &amp;&amp; isEmptyObj(conditions['layer'])\" _v-3f858c3f=\"\">全部</span> <template v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">挂牌公司</span> <span v-for=\"c in pageshowConditions['plate']['挂牌公司']\" style=\"margin-right: 8px\" _v-3f858c3f=\"\">{{c}}</span> </template> <template v-if=\"pageshowConditions['plate']['N3BTS'] !== ''\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">两网及退市公司</span> </template> <template v-if=\"pageshowConditions['plate']['SHZB'] !== ''\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">上证主板</span> </template> <template v-if=\"pageshowConditions['plate']['SZCYB'] !== ''\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">创业板</span> </template> <template v-if=\"pageshowConditions['plate']['SZZB'] !== ''\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">深市主板</span> </template> <template v-if=\"pageshowConditions['plate']['SZZXB'] !== ''\"> <span style=\"margin-right: 8px\" _v-3f858c3f=\"\">中小板</span> </template> </p> </li> </template> <template v-if=showRegion> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 地区类型 </p> <p class=time @click.stop=\"showCondition('region'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['region'])\" _v-3f858c3f=\"\">全部</span> <span v-for=\"(code, name) in conditions['region']\" style=\"margin-right: 8px\" _v-3f858c3f=\"\">{{name}}</span> </p> </li> </template> <template v-if=showSecurityCompany> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 主板券商 </p> <p class=time @click.stop=\"showCondition('securityCompany'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['securityCompany'])\" _v-3f858c3f=\"\">全部</span> <span v-for=\"(code, name) in conditions['securityCompany']\" style=\"margin-right: 8px\" _v-3f858c3f=\"\">{{name}}</span> </p> </li> </template> <template v-if=showIndustry> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 行业分类 </p> <p class=time @click.stop=\"showCondition('industry'), setCnzz('[Mobile]-信披搜索页', '选择筛选条件', '')\" _v-3f858c3f=\"\"> <span v-if=\"isEmptyObj(conditions['industry']) &amp;&amp; isEmptyObj(conditions['industrysecond'])\" _v-3f858c3f=\"\">全部</span> <template v-for=\"(type, obj) in pageshowConditions['industry']\"> <template v-if=\"obj.length > 0 || type == '综合'\"> <span class=text-b _v-3f858c3f=\"\">{{type}}</span> <template v-for=\"item in obj\" v-if=\"obj.length !== industry\"> {{item}} </template> </template> </template> </p> </li> </template> </ul> </div> </div> <template v-if=\"showConditionFlag=='type'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">公告类型</span> <span class=menu-head-empty @click=\"conditions['type'] = {}, select_type = [], setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_type', conditions['type']), setCnzz('[Mobile]-信披搜索页', '点击确定按钮', '')\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box _v-3f858c3f=\"\"> <li v-for=\"type in types\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('type', type), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['type'][type.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{type.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='qaType'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">问题类型</span> <span class=menu-head-empty @click=\"this.conditions['qaType'] = {}, select_qaType = [], setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_qaType', conditions['qaType'])\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box _v-3f858c3f=\"\"> <li v-for=\"type in qaTypes\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('qaType', type), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['qaType'][type.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{type.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='plate'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">板块类型</span> <span class=menu-head-empty @click=\"clearPlate(), setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_plate', conditions['plate'])\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box v-show=!showChildFlag.plate _v-3f858c3f=\"\"> <li v-for=\"d in plates\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio v-if=d.child _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['plate'][d.code]}\" @click.stop=\"addCondition('plate', d)\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" @click.stop=\"addCondition('plate', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> {{d.name}} <template v-if=\"d.count > 0 &amp;&amp; !conditions['plate']['N3BGP']\" style=color:#3270ad> <span style=color:#1E88E5 v-if=\"conditions['plate'] !== {}\" _v-3f858c3f=\"\">({{ d.count }})</span> </template> </span> <span class=\"qicon ques_5 mop close\" @click.stop=\"slideToggleFilter(d.code, $event)\" _v-3f858c3f=\"\"></span> </label> <template v-if=d.child> <ul class=second id={{d.code}} style=\"display: none\" _v-3f858c3f=\"\"> <li v-for=\"child in d.child\" _v-3f858c3f=\"\"> <a href=javascript:; _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('layer', child, d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['layer'][child.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{child.name}}</span> </label> </a> </li> </ul> </template> </a> <a href=javascript:; class=dio v-else=\"\" _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('plate', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['plate'][d.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='region'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">地区类型</span> <span class=menu-head-empty @click=\"this.conditions['region'] = {}, select_region = [], setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_region', conditions['region'])\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box _v-3f858c3f=\"\"> <li v-for=\"d in regions\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('region', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['region'][d.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='securityCompany'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">主板类型</span> <span class=menu-head-empty @click=\"this.conditions['securityCompany'] = {}, select_securityCompany = [], setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_securityCompany', conditions['securityCompany'])\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box _v-3f858c3f=\"\"> <li v-for=\"d in securityCompany\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('securityCompany', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['securityCompany'][d.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='industry'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-3f858c3f=\"\"> <div class=toolsbar _v-3f858c3f=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-3f858c3f=\"\"></span> <span class=menu-options _v-3f858c3f=\"\">行业分类</span> <span class=menu-head-empty @click=\"clearIndustry(), setCnzz('[Mobile]-信披搜索页', '点击清空筛选条件按钮', '')\" _v-3f858c3f=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_industry', conditions['industry'])\" _v-3f858c3f=\"\">确定</span> </div> <div class=menu-cont _v-3f858c3f=\"\"> <ul class=one-row-box v-show=!showChildFlag.industry _v-3f858c3f=\"\"> <li v-for=\"d in industry\" _v-3f858c3f=\"\"> <a href=javascript:; class=dio v-if=\"d.child.length>0\" _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industry'][d.code]}\" @click.stop=\"addCondition('industry', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" @click.stop=\"addCondition('industry', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> {{d.code}} {{d.name}} <template v-if=\"d.count > 0 &amp;&amp; !conditions['industry'][d.code]\"> <span style=color:#1E88E5 _v-3f858c3f=\"\">({{d.count}})</span> </template> </span> <span class=\"qicon ques_5 mop close\" @click.stop=\"slideToggleFilter(d.id, $event)\" _v-3f858c3f=\"\"></span> </label> <template v-if=\"d.child.length>0\"> <ul class=second id={{d.id}} style=\"display: none\" _v-3f858c3f=\"\"> <li v-for=\"child in d.child\" _v-3f858c3f=\"\"> <a href=javascript:; _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('industrysecond', child, d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industrysecond'][child.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{child.code}} {{child.name | maxlen 10}}</span> </label> </a> </li> </ul> </template> </a> <a href=javascript:; class=dio v-else=d.child _v-3f858c3f=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('industry', d), setCnzz('[Mobile]-信披搜索页', '点击筛选条件', '')\" _v-3f858c3f=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industry'][d.code]}\" _v-3f858c3f=\"\"> <span class=el-checkbox-inner _v-3f858c3f=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-3f858c3f=\"\">{{d.code}} {{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> </div> <div class=my-container v-show=showComments style=\"top: 0px;position:static;background-color:white\" _v-3f858c3f=\"\"> <div class=comment-detail _v-3f858c3f=\"\"> <div class=comment-title _v-3f858c3f=\"\"> <p class=comment-all _v-3f858c3f=\"\">全部评论</p> <p class=comment-sort _v-3f858c3f=\"\">{{cpwtotal}}条评论</p> </div> <div class=comment v-for=\"item in commentList\" _v-3f858c3f=\"\"> <div class=common-avatar _v-3f858c3f=\"\"> <img src=/static/images/user.png width=100% height=100% _v-3f858c3f=\"\"> </div> <div class=comment-block _v-3f858c3f=\"\"> <p class=comment-user _v-3f858c3f=\"\"> <span class=comment-username v-if=item.user _v-3f858c3f=\"\"> {{item.user.username}} </span> <span class=comment-username v-else=\"\" _v-3f858c3f=\"\"> 匿名用户 </span> <span class=footer-zan _v-3f858c3f=\"\"> <i class=c-share-icon @click.stop=\"zan(item.id, $event)\" _v-3f858c3f=\"\"></i> <span class=u-num _v-3f858c3f=\"\">{{item.zan_cnt}}</span> </span> </p> <div class=comment-content _v-3f858c3f=\"\">{{item.content}} </div> <div class=comment-operate _v-3f858c3f=\"\"> <span class=\"J_Vote comment-operate-item comment-operate-up\" _v-3f858c3f=\"\">{{item.updtime | date}}</span> <span class=\"J_Reply comment-operate-item\" _v-3f858c3f=\"\"> <a href=javascript:; @click=\"commentinput = true, pid = item.id, content = ''\" _v-3f858c3f=\"\">回复</a> </span> </div> <div class=\"comment-reply-ctn comment-reply-item\" _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <li v-for=\"i in item.replys\" track-by=$index v-if=\"$index < item.showall\" _v-3f858c3f=\"\"> <p class=comment-text _v-3f858c3f=\"\"> <span class=c-username v-if=i.user _v-3f858c3f=\"\"> {{i.user.username}} </span> <span class=c-username v-else=\"\" _v-3f858c3f=\"\">匿名用户</span> {{i.content}} </p> <div class=\"reply-operate reply-operate-hot\" _v-3f858c3f=\"\"> <span class=\"J_Vote reply-operate-item reply-up\" _v-3f858c3f=\"\"><i class=c-share-icon @click.stop=\"zan(i.id, $event)\" _v-3f858c3f=\"\"></i><span _v-3f858c3f=\"\">{{i.zan_cnt}}</span></span> <span class=\"J_Reply reply-operate-item\" _v-3f858c3f=\"\"></span> <span _v-3f858c3f=\"\">{{i.updtime | date}}</span> </div> </li> <li class=\"view-more hidden\" v-if=\"item.replys.length > 2 &amp;&amp; item.showall !== 8\" _v-3f858c3f=\"\"> <a class=\"btn-block text-center btn-comment-expand\" @click=\"item.showall = 8\" _v-3f858c3f=\"\">查看全部<span class=nume _v-3f858c3f=\"\">{{item.replys.length}}</span>条回复 </a> </li> </ul> </div> </div> </div> </div> <div class=comment-more _v-3f858c3f=\"\"> <a href=javascript:; v-if=\"commentList.length !== cpwtotal\" _v-3f858c3f=\"\">加载更多评论中...</a> <a href=javascript:; v-if=\"commentList.length == cpwtotal &amp;&amp; cpwtotal !== 0\" _v-3f858c3f=\"\">评论已全部加载</a> </div> <div class=comment-no v-if=\"cpwtotal == 0\" _v-3f858c3f=\"\"> 暂无评论，快来添加一个吧！ </div> <div class=comment-no _v-3f858c3f=\"\"></div> </div> <div class=result-container id=result-container v-show=\"showResultPage &amp;&amp; !showSearchPage &amp;&amp; !showTongjiPage &amp;&amp; !showComments\" _v-3f858c3f=\"\"> <template v-if=\"topPage === 1\"> <div class=search-header _v-3f858c3f=\"\"> <div class=search-header-text _v-3f858c3f=\"\"> <span v-if=\"stype != 13\" _v-3f858c3f=\"\">{{stype | formatTypeName}}</span> <span v-if=\"stype == 13\" _v-3f858c3f=\"\">研报数据</span> <span _v-3f858c3f=\"\">·</span> <span _v-3f858c3f=\"\">{{keywords | formatKeywords}}</span> </div> <span class=search-header-stics @click=\"switchPage(3), showStatAnalyze = true, setCnzz('[Mobile]-信披搜索页', '进入统计页', '')\" _v-3f858c3f=\"\">统计</span> <span class=search-header-stics @click=\"showModalTag = true\" _v-3f858c3f=\"\">保存标签</span> </div> <div class=screen-menu _v-3f858c3f=\"\"> <div class=release-date _v-3f858c3f=\"\"> <div @click.stop=\"slideToggle('date')\" _v-3f858c3f=\"\"> {{ datetype_name }} <span class=close-bot _v-3f858c3f=\"\"></span> </div> <div class=slide-menu v-show=\"showDropdownMenu == 'date'\" _v-3f858c3f=\"\"> <ul class=date-menu @click=\"hideDropdown(), setCnzz('[Mobile]-信披搜索页', '点击日期筛选下拉框', '')\" _v-3f858c3f=\"\"> <li @click=sortByDate(1) _v-3f858c3f=\"\">一个月</li> <li @click=sortByDate(2) _v-3f858c3f=\"\">一个季度</li> <li @click=sortByDate(3) _v-3f858c3f=\"\">半年</li> <li @click=sortByDate(4) _v-3f858c3f=\"\">去年</li> <li @click=sortByDate(5) _v-3f858c3f=\"\">今年</li> <li @click=sortByDate(6) _v-3f858c3f=\"\">一年</li> <li @click=sortByDate(7) _v-3f858c3f=\"\">两年</li> <li @click=sortByDate(8) _v-3f858c3f=\"\">三年</li> <li @click=sortByDate(9) _v-3f858c3f=\"\">五年</li> <li @click=sortByDate(10) _v-3f858c3f=\"\">十年</li> <li @click=sortByDate(98) _v-3f858c3f=\"\">全部</li> <li @click=sortByDate(99) _v-3f858c3f=\"\">自定义</li> </ul> </div> </div> <span class=release-line _v-3f858c3f=\"\"></span> <div class=release-date _v-3f858c3f=\"\"> <div @click.stop=\"slideToggle('sort')\" _v-3f858c3f=\"\"> {{ sort==1?'按相关性排序':'按时间排序' }} <span class=close-bot _v-3f858c3f=\"\"></span> </div> <ul class=date-menu v-show=\"showDropdownMenu == 'sort'\" @click=hideDropdown _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\"><a href=javascript:; @click=\"selSort(1), setCnzz('[Mobile]-信披搜索页', '点击按相关性排序按钮', '')\" _v-3f858c3f=\"\">按相关性排序</a></li> <li _v-3f858c3f=\"\"><a href=javascript:; @click=\"selSort(2),  setCnzz('[Mobile]-信披搜索页', '点击按时间排序按钮', '')\" _v-3f858c3f=\"\">按时间排序</a></li> </ul> </div> </div> <div class=search-date-custom v-show=\"datetype_name !== '全部'\" _v-3f858c3f=\"\"> <p class=time _v-3f858c3f=\"\"> <span class=l _v-3f858c3f=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-3f858c3f=\"\"></date-picker> </span>~ <span class=r _v-3f858c3f=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-3f858c3f=\"\"></date-picker> </span> </p> </div> <div class=Screen-criteria v-if=\"tagLists.length > 0\" _v-3f858c3f=\"\"> <div class=Screen-criteria-head @click=\"showtag = !showtag, slideToggleTag()\" _v-3f858c3f=\"\"> <span class=fl _v-3f858c3f=\"\">我的标签</span> <span class=fr v-if=showtag _v-3f858c3f=\"\"></span> <span class=f3 v-if=!showtag _v-3f858c3f=\"\"></span> </div> <div class=\"Screen-criteria-box cpwtag\" style=display:none _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <li v-for=\"item in tagLists\" @click=\"searchByTag(item.id), showtag = false, slideToggleTag()\" _v-3f858c3f=\"\"> <span class=notice-left _v-3f858c3f=\"\">{{item.name}}</span> <span class=notice-right @click.stop=delTag(item.id) _v-3f858c3f=\"\"></span> </li> </ul> </div> </div> <div class=search-criteria @click=\"switchPage(1), setCnzz('[Mobile]-信披搜索页', '查看搜索条件', '')\" _v-3f858c3f=\"\"> <span class=fl _v-3f858c3f=\"\">搜索条件</span> <span class=fr _v-3f858c3f=\"\"></span> </div> <template v-if=havelabels> <div class=Screen-criteria _v-3f858c3f=\"\"> <div class=Screen-criteria-head @click.stop=slideDropdownMenu($event) _v-3f858c3f=\"\"> <span class=fl _v-3f858c3f=\"\">筛选条件</span> <span class=\"fr close\" _v-3f858c3f=\"\"></span> </div> <div class=\"Screen-criteria-box sxtj\" style=\"display: none\" _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <template v-for=\"(type, obj) in conditions\"> <li v-if=\"!isEmptyObj(obj) &amp;&amp; type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\" _v-3f858c3f=\"\"> <span class=selected-icon _v-3f858c3f=\"\"></span> <a class=blue _v-3f858c3f=\"\">{{ cond_type[type] }}</a> </li> <template v-for=\"(code, name) in obj\"> <template v-if=\"type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\"> <li _v-3f858c3f=\"\"> <span class=notice-left _v-3f858c3f=\"\">{{ name }} </span> <span aria-hidden=true class=notice-right @click=\"rmvCondition(type, code), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </li> </template> </template> </template> <li v-if=showPla _v-3f858c3f=\"\"> <span class=selected-icon _v-3f858c3f=\"\"></span> <a class=blue _v-3f858c3f=\"\">{{cond_type['plate']}}</a> </li> <li v-for=\"(idx, item) in pageshowConditions['plate']\" _v-3f858c3f=\"\"> <template v-if=\"idx !== '挂牌公司' &amp;&amp; item\"> <span class=notice-left _v-3f858c3f=\"\">{{item}}</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('plate', idx), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </template> </li> <li class=active v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\" _v-3f858c3f=\"\"> <span class=selected-icon _v-3f858c3f=\"\"></span> <span class=notice-left _v-3f858c3f=\"\">挂牌公司</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('N3BGP', 'N3BGP'), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </li> <li v-for=\"i in pageshowConditions['plate']['挂牌公司']\" _v-3f858c3f=\"\"> <template v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\"> <span class=notice-left _v-3f858c3f=\"\">{{i}}</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('layer', i), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </template> </li> <li v-if=showInd _v-3f858c3f=\"\"> <span class=selected-icon _v-3f858c3f=\"\"></span> <a class=blue _v-3f858c3f=\"\">{{cond_type['industry']}}</a> </li> <template v-for=\"(type, obj) in pageshowConditions['industry']\"> <template v-if=\"obj.length > 0 || type == '综合'\"> <li class=active _v-3f858c3f=\"\"> <span class=selected-icon _v-3f858c3f=\"\"></span> <span class=notice-left _v-3f858c3f=\"\">{{type}}</span> <span class=notice-right @click=\"rmvCondition('industry', type.substr(0,1)), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </li> <li v-for=\"item in obj\" v-if=\"obj.length !== industry\" _v-3f858c3f=\"\"> <span class=notice _v-3f858c3f=\"\">{{item}}</span> <span class=notice-right @click=\"rmvCondition('industrysecond', item.substr(0, 3)), this.setCnzz('[Mobile]-信披搜索页', '删除指定筛选条件', '')\" _v-3f858c3f=\"\"></span> </li> </template> </template> </ul> </div> </div> </template> <div class=intelligent-search-main _v-3f858c3f=\"\"> <div class=intelligent-search v-if=\"smartComInfo.shortname &amp;&amp; smartComInfo.code\" _v-3f858c3f=\"\"> <div class=intelligent-heading style=cursor:pointer _v-3f858c3f=\"\"> <span class=big-h @click=goCompanyInfo(smartComInfo.code) _v-3f858c3f=\"\">{{smartComInfo.shortname}}【{{smartComInfo.code}}】</span> </div> <div class=op-stockdynamic v-if=smartComInfo.price _v-3f858c3f=\"\"> <div class=op-stockdynamic-top :class=\"{'plus': upanddown.indexOf('+') === 0, 'reduce': upanddown.indexOf('-') === 0}\" _v-3f858c3f=\"\"> <span class=op-cur-num _v-3f858c3f=\"\">{{prices.trade}}元</span> <span class=op-cur-info _v-3f858c3f=\"\">{{upanddown}}({{Amplitude}}%)</span> </div> <div class=op-stockdynamic-bot _v-3f858c3f=\"\"> <ul _v-3f858c3f=\"\"> <ul class=op-clear _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\">昨收：{{prices.settlement}}</li> <li _v-3f858c3f=\"\">今开：{{prices.open}}</li> <li _v-3f858c3f=\"\">最高：{{prices.high}}</li> <li _v-3f858c3f=\"\">最低：{{prices.low}}</li> </ul> <ul class=op-clear _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\">成交量：<template v-if=\"prices.volume < 10000000\">{{prices.volume}}手</template> <template v-if=\"prices.volume > 10000000 || prices.volume == 10000000\">{{(prices.volume/ 1000000).toFixed(2) | thousands}}万手</template></li> <li _v-3f858c3f=\"\">成交额：{{(prices.amount/ 100000000).toFixed(2) | thousands}}亿</li> <li _v-3f858c3f=\"\">总市值：{{(prices.mktcap/10000).toFixed(2) | thousands}}亿</li> <li _v-3f858c3f=\"\">流通市值：{{(prices.nmc/10000).toFixed(2) | thousands}}亿</li> </ul> <ul class=op-clear _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\">换手率：{{prices.turnoverratio.toFixed(2)}}%</li> <li _v-3f858c3f=\"\">市净率：{{prices.pb.toFixed(2)}}</li> <li _v-3f858c3f=\"\">振 幅：{{prices.changepercent.toFixed(2)}}%</li> <li _v-3f858c3f=\"\">市盈率：{{prices.per.toFixed(2)}}</li> </ul> </ul> </div> </div> </div> <div class=intelligent-search v-if=\"smartComInfo.finance &amp;&amp; smartComInfo.finance.length > 0\" _v-3f858c3f=\"\"> <div class=intelligent-heading _v-3f858c3f=\"\"> {{smartComInfo.shortname}}【{{smartComInfo.code}}】财务信息 </div> <div class=table-result-outter _v-3f858c3f=\"\"> <ul class=personnel _v-3f858c3f=\"\"> <li :class=\"{'active': timetyp === 1}\" @click=\"timetyp = 1\" _v-3f858c3f=\"\">按季度</li> <li :class=\"{'active': timetyp === 2}\" @click=\"timetyp = 2\" _v-3f858c3f=\"\">按年度</li> </ul> <div style=\"margin-bottom: 20px\" _v-3f858c3f=\"\"> <table class=table-result cellpadding=0 _v-3f858c3f=\"\"> <tbody v-if=\"timetyp === 1\" _v-3f858c3f=\"\"> <tr class=title _v-3f858c3f=\"\"> <td _v-3f858c3f=\"\">按报告期</td> <td _v-3f858c3f=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in finance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-3f858c3f=\"\"> <td v-for=\"(k,i) in item\" _v-3f858c3f=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i[smartComInfo.financeCols[0].name] | thousands}}</template> </td> </tr> </tbody> <tbody v-if=\"timetyp === 2\" _v-3f858c3f=\"\"> <tr class=title _v-3f858c3f=\"\"> <td _v-3f858c3f=\"\">按报告期</td> <td _v-3f858c3f=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in yearfinance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-3f858c3f=\"\"> <td v-for=\"(k,i) in item\" _v-3f858c3f=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i[smartComInfo.financeCols[0].name] | thousands}}</template> </td> </tr> </tbody> </table> </div> </div> </div> </div> </template> <div v-if=\"stype == 100\" style=margin-bottom:25px _v-3f858c3f=\"\"> <div class=index-colligate-main v-if=complex_hk _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">新闻</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['12']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=12 :items=complex_news :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 12,searchMore(12)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_knowledge _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">知识库</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['4']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=4 :items=complex_knowledge :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 4,searchMore(4)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_yb _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">研报</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['11']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=11 :items=complex_yb :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 11,searchMore(11)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_agu _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">A股</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['1']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=1 :items=complex_agu :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 1,searchMore(1)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_n3b _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">新三板</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['2']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=2 :items=complex_n3b :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 2,searchMore(2)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_qa _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">问题库</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['5']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=5 :items=complex_qa :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 5,searchMore(5)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_hk _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">港股</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['6']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=6 :items=complex_hk :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 6,searchMore(6)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_bond _v-3f858c3f=\"\"> <div class=index_box _v-3f858c3f=\"\"> <div class=intelligent-search-notice _v-3f858c3f=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-3f858c3f=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-3f858c3f=\"\">债券</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-3f858c3f=\"\"> <span class=count-wrapper _v-3f858c3f=\"\">共有<span class=blue style=cursor:pointer _v-3f858c3f=\"\">{{stypesTotal['3']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-3f858c3f=\"\"> <resfrag :currentuser=currentuser :stype=3 :items=complex_bond :onlytitle=parseInt(onlyTitle) _v-3f858c3f=\"\"></resfrag> <div class=compre-more _v-3f858c3f=\"\"> <a href=javascript:; @click=\"stype = 3,searchMore(3)\" _v-3f858c3f=\"\">查看更多</a> </div> </div> </div> </div> </div> </div> <div class=search-result-box _v-3f858c3f=\"\"> <div class=anwer-cont v-show=\"searched==stype &amp;&amp; items.length==0\" _v-3f858c3f=\"\"> <div class=no _v-3f858c3f=\"\">很抱歉，没有找到相关的结果!</div> </div> <div class=more_top v-show=\"!loading &amp;&amp; topPage !== 1 &amp;&amp; total !== 0\" style=\"margin-bottom: -0.4rem\" _v-3f858c3f=\"\"> <i class=\"pull_icon_top loading\" _v-3f858c3f=\"\"></i> <span style=\"font-size: 15px\" _v-3f858c3f=\"\">加载中...</span> </div> <div v-show=\"searched==stype &amp;&amp; detailLists.length>0\" id=my-result-wrap _v-3f858c3f=\"\"> <template v-if=\"stype!=5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-3f858c3f=\"\"> <p class=head _v-3f858c3f=\"\"> <span class=\"{{ fileIcon(item.fileext) }}\" _v-3f858c3f=\"\"></span> <a v-if=\"stype!=5&amp;&amp;stype!=10\" style=cursor:pointer @click=\"checkLogin(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')\" class=green _v-3f858c3f=\"\">{{{ item.fulltitle }}}</a> <a v-if=\"stype == 10\" style=cursor:pointer @click=\"openAbsAnn(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')\" class=green _v-3f858c3f=\"\">{{{ item.fulltitle }}}</a> <a v-if=\"stype==5\" style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')\" class=green _v-3f858c3f=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-3f858c3f=\"\"> {{ item.publishDate ? item.publishDate: item.uploadTime }} <span class=marginlf-10 _v-3f858c3f=\"\">{{ item.companyCode }}</span> <span class=marginlf-10 v-if=item.author _v-3f858c3f=\"\">作者: {{ item.author }}</span> <span class=marginlf-10 v-if=item.nickname _v-3f858c3f=\"\">公众号: {{ item.nickname }}</span> </p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent' &amp;&amp; onlyTitle == 0\" _v-3f858c3f=\"\"> {{{ item.content.join('...... ') }}} </p> <template v-if=\"item.child &amp;&amp; onlyTitle == 0\" v-for=\"child in item.child\"> <p class=\"blak font-weight lien child-title\" :style=indentChild(child.code) @click=\"viewChildTitle(item, child.code)\" style=cursor:pointer _v-3f858c3f=\"\"> {{{ child.title }}} </p> <p class=lien :style=indentChild(child.code) v-if=child.content _v-3f858c3f=\"\"> {{{ child.content.join('...... ') }}} </p> <template v-if=child.contents> <template v-for=\"c in child.contents\"> <p class=lien :style=indentChild(child.code) v-if=\"c.htmltag=='p'\" _v-3f858c3f=\"\"> {{{ c.content }}}<br _v-3f858c3f=\"\"> </p> <template v-if=\"c.htmltag=='table'\"> <div class=table-result-outter _v-3f858c3f=\"\"> <table cellpadding=0 class=table-result _v-3f858c3f=\"\"> <tbody _v-3f858c3f=\"\"> <tr v-for=\"(rowidx, row) in c.table\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-3f858c3f=\"\"> <td v-for=\"(colidx, col) in row\" rowspan=\"{{ col.row }}\" colspan=\"{{ col.col }}\" track-by=$index _v-3f858c3f=\"\"> {{{col.value}}} </td> </tr> </tbody> </table> </div> <div class=table-whole _v-3f858c3f=\"\"> <a href=javascript:; @click=\"viewTable(item, child.code, c.offset), setCnzz('[Mobile]-信披搜索页', '查看表格全部内容', '')\" _v-3f858c3f=\"\"> <span class=table-see-icon _v-3f858c3f=\"\"></span>查看表格全部内容 </a> </div> </template> </template> </template> <div class=intelligent-fsearch-cont v-if=child.imgs _v-3f858c3f=\"\"> <template v-for=\"c in child.imgs\"> <div class=fsearch-a _v-3f858c3f=\"\"> <div class=more-img style=cursor:pointer title=点击查看更多 @click=\"setBigImgObj(c, item)\" _v-3f858c3f=\"\"> <img :src=c.imgurl _v-3f858c3f=\"\"> </div> <div class=text-a _v-3f858c3f=\"\">{{{child.title}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-3f858c3f=\"\">{{{c.imghead}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-3f858c3f=\"\">{{{c.imgfoot}}}</div> </div> </template> </div> </template> </div> </template> <template v-if=\"stype==5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-3f858c3f=\"\"> <p class=head _v-3f858c3f=\"\"> <a class=green style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-信披搜索页', '查看表格全部内容', '')\" _v-3f858c3f=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-3f858c3f=\"\">{{ item.publishDate ? item.publishDate: item.uploadTime }}</p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent'\" _v-3f858c3f=\"\">{{{ item.content.join('...... ') }}}</p> <template v-if=item.child> <template v-for=\"child in item.child\"> <div v-if=child.content class=\"rb odd res-qa-title-wrap\" style=\"overflow: hidden\" _v-3f858c3f=\"\"> <p class=\"blak font-weight lien\" _v-3f858c3f=\"\">{{{ child.title }}}</p> <p class=lien v-if=child.content _v-3f858c3f=\"\"> {{{ child.content.join('...... ') }}} </p> </div> <div v-if=child.que class=\"rb odd res-qa-middle-wrap\" _v-3f858c3f=\"\"> <div class=res-qa-item-l _v-3f858c3f=\"\"> <div class=ques-l _v-3f858c3f=\"\"><span class=\"qicon ques_1\" style=\"margin: 0.1rem 5px 2px 0px\" _v-3f858c3f=\"\"></span></div> </div> <div class=res-qa-item-r style=\"width: 91%\" _v-3f858c3f=\"\"> <p class=lien v-if=!child.showque _v-3f858c3f=\"\"> {{{ child.shortque?child.shortque:child.que | maxlen 100 }}} <span class=\"qust-more blue\" @click=\"child.showque=true\" v-if=\"child.que.length>100\" _v-3f858c3f=\"\"> 展开更多<span class=triangle-bottom _v-3f858c3f=\"\"></span></span> </p> <p class=lien v-if=child.showque _v-3f858c3f=\"\"> {{{ child.que }}} <span class=\"qust-stop red\" @click=\"child.showque=false\" _v-3f858c3f=\"\"> 收起<span class=triangle-head _v-3f858c3f=\"\"></span></span> </p> <div class=quest-blue _v-3f858c3f=\"\"> <li v-for=\"t in child.tag\" _v-3f858c3f=\"\"><a href=javascript:; _v-3f858c3f=\"\">{{ t }}</a></li> </div> </div> </div> <div v-if=child.answers v-for=\"ans in child.answers\" class=res-qa-ans-wrap _v-3f858c3f=\"\"> <div class=res-qa-item-l _v-3f858c3f=\"\"> <div class=ques-l _v-3f858c3f=\"\"> <span class=\"qicon ques_2\" style=\"margin: 0.12rem 5px 2px 0px\" _v-3f858c3f=\"\"></span> </div> </div> <div class=res-qa-item-r style=\"width: 91%\" _v-3f858c3f=\"\"> <p class=quest-p _v-3f858c3f=\"\"> <span class=font-weight v-if=\"trim(ans.rername) !== ''\" _v-3f858c3f=\"\">【{{ ans.rertitle }}: {{ ans.rername }}】</span> <span class=ques-lt v-if=!ans.showans _v-3f858c3f=\"\"> {{{ ans.shortans?ans.shortans:ans.ans | maxlen 100 }}}</span> <span class=ques-lt v-show=ans.showans _v-3f858c3f=\"\"> {{{ ans.ans }}}</span> <span class=\"qust-more blue\" v-if=\"!ans.showans &amp;&amp; ans.ans.length>100\" @click=\"ans.showans=true\" _v-3f858c3f=\"\"> 展开更多<span class=triangle-bottom _v-3f858c3f=\"\"></span> </span> <span class=\"qust-stop red\" v-if=ans.showans @click=\"ans.showans=false\" _v-3f858c3f=\"\"> 收起<span class=triangle-head _v-3f858c3f=\"\"></span></span> </p> </div> </div> </template> </template> </div> </template> </div> <div class=more v-show=\"!loading &amp;&amp; bottomPage < totalPage &amp;&amp; total !== 0 &amp;&amp; searched === stype\" style=\"margin-top: -8px\" _v-3f858c3f=\"\"> <i class=\"pull_icon loading\" _v-3f858c3f=\"\"></i> <span style=\"font-size: 15px\" _v-3f858c3f=\"\">加载中...</span> </div> <div class=more v-show=\"bottomPage == totalPage &amp;&amp; total !== 0 &amp;&amp; searched === stype\" style=\"margin-top: -8px\" _v-3f858c3f=\"\"> <span style=\"font-size: 15px\" _v-3f858c3f=\"\">已加载全部内容</span> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-3f858c3f=\"\"> <div class=binding-content _v-3f858c3f=\"\"> <a class=binding-logo _v-3f858c3f=\"\"></a> <div class=binding-text _v-3f858c3f=\"\"> 立即绑定IBDATA账号<br _v-3f858c3f=\"\">成为金融分析高手 </div> <div class=binding-bot _v-3f858c3f=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false, setCnzz('[Mobile]信披搜索页', '点击暂不绑定按钮', '')\" _v-3f858c3f=\"\">暂不绑定</a> <a class=binding-btn @click=\"goBindPage(), setCnzz('[Mobile]信披搜索页', '点击立即绑定按钮', '')\" _v-3f858c3f=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-3f858c3f=\"\"></div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-if=showModalTag _v-3f858c3f=\"\"> <div class=comment-content-tag _v-3f858c3f=\"\"> <div class=login-close @click=\"showModalTag = false\" _v-3f858c3f=\"\"> <a class=delete-icon _v-3f858c3f=\"\"></a> </div> <div class=comment-reply _v-3f858c3f=\"\"> <input class=input-search-c type=text placeholder=输入标签名称 v-model=tagname _v-3f858c3f=\"\"> <a class=btn-Publish @click=saveTag() _v-3f858c3f=\"\">确定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-if=showModalTag _v-3f858c3f=\"\"></div> <div class=wrapper v-show=smartEngine.open _v-3f858c3f=\"\"> <div class=company-details-title _v-3f858c3f=\"\"> <span class=cancle-btn @click.stop=\"smartEngine.open = false, setCnzz('[Mobile]信披搜索页', '收起公司详情', '')\" _v-3f858c3f=\"\"></span> <span class=\"menu-options blue\" style=\"font-size: 16px\" _v-3f858c3f=\"\">{{smartEngine.companyInfo.shortname}}({{smartComInfo.code}})</span> </div> <div class=company-details-head _v-3f858c3f=\"\"> <div class=search-company-list _v-3f858c3f=\"\"> <p _v-3f858c3f=\"\"><span class=title _v-3f858c3f=\"\">法人</span> <span class=mar _v-3f858c3f=\"\">{{smartEngine.companyInfo.legalRepresentative}}</span></p> <p _v-3f858c3f=\"\"><span class=title _v-3f858c3f=\"\">成立日期</span> <span class=mar _v-3f858c3f=\"\">{{smartEngine.companyInfo.founddate}}</span> <span class=title _v-3f858c3f=\"\">所属地域</span> <span class=mar _v-3f858c3f=\"\">{{smartEngine.companyInfo.area}}</span></p> </div> <div class=\"search-company-list last-child\" _v-3f858c3f=\"\"> <p _v-3f858c3f=\"\"><span class=title _v-3f858c3f=\"\">行业</span> <span class=mar _v-3f858c3f=\"\">{{smartEngine.companyInfo.industry}}</span></p> </div> </div> <div class=company-details-box _v-3f858c3f=\"\"> <ul class=one-row-box _v-3f858c3f=\"\"> <li _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 公司名称 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.name}} </p> </li> <li v-if=smartEngine.companyInfo.name_en _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 英文名称 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.name_en}} </p> </li> <li v-if=smartEngine.companyInfo.regcode _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 统一社会信用代码 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.regcode}} </p> </li> <li v-if=smartEngine.companyInfo.regmoney _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\">注册资本</p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.regmoney | formatNumber}}（万元） </p> </li> <li v-if=smartEngine.companyInfo.secretaries _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 董 秘 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.secretaries}} </p> </li> <li v-if=smartEngine.companyInfo.address _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 注册地址 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.address}} </p> </li> <li v-if=smartEngine.companyInfo.website _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 公司网址 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.website}} </p> </li> <li v-if=smartEngine.companyInfo.phone _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 电 话 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.phone}} </p> </li> <li v-if=smartEngine.companyInfo.fax _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 传 真 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.fax}} </p> </li> <li v-if=smartEngine.companyInfo.postcode _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 邮 编 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.postcode}} </p> </li> <li v-if=smartEngine.companyInfo.companytyp _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 企业类型 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.companytyp}} </p> </li> <li v-if=smartEngine.companyInfo.businessscope _v-3f858c3f=\"\"> <p class=date _v-3f858c3f=\"\"> 经营范围 </p> <p class=time _v-3f858c3f=\"\"> {{smartEngine.companyInfo.businessscope}} </p> </li> </ul> </div> </div> </div> <div v-if=commentinput class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div _v-3f858c3f=\"\"></div> <div v-if=commentinput class=\"modal-backdrop fade in\" _v-3f858c3f=\"\"></div> <bigimg :bigimgobj=bigImgObj _v-3f858c3f=\"\"></bigimg> </div>";

/***/ },
/* 788 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-42f9eb58=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-42f9eb58=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-42f9eb58=\"\"> <div class=loading-img _v-42f9eb58=\"\"></div> </div> </div> <div class=search-company-box _v-42f9eb58=\"\"> <div class=pledge-box1-top _v-42f9eb58=\"\"> <label class=\"el-checkbox mar\" v-if=hasPerExpess _v-42f9eb58=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': showPerExpress}\" @click.stop.prevent=openPerExpress($event) _v-42f9eb58=\"\"> <span class=el-checkbox-inner @click.stop.prevent=openPerExpress($event) _v-42f9eb58=\"\"></span> <input type=checkbox name=type class=el-checkbox-original _v-42f9eb58=\"\"> </span> <span class=el-checkbox-label _v-42f9eb58=\"\">业绩快报详情</span> </label> </div> <div class=pledge-box1 _v-42f9eb58=\"\"> <div class=pledge-box1 _v-42f9eb58=\"\"> <div class=Single-list-main v-if=\"performanceNoticeLists.length > 0\" _v-42f9eb58=\"\"> <template v-for=\"(index, h) in performanceNoticeLists\" track-by=$index> <ul class=Single-list-box _v-42f9eb58=\"\"> <li _v-42f9eb58=\"\"><p class=date _v-42f9eb58=\"\">公告日期</p> <p class=time _v-42f9eb58=\"\">{{ h.publishdate }}</p></li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">定期报告</p> <p class=time _v-42f9eb58=\"\">{{ h.bglx }} ({{ parseInt(h.period_start.split('-')[1])}} ~ {{parseInt(h.period_end.split('-')[1])}} 月)</p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">摘要</p> <p class=time _v-42f9eb58=\"\"> <template v-if=\"h.net_profit_reporting_period_income_lower &amp;&amp; h.net_profit_reporting_period_income_upper &amp;&amp; h.change_ratio_lower &amp;&amp; h.change_ratio_upper\"> 净利润{{ h.net_profit_reporting_period_income_lower | toWan | money }}万元 至{{ h.net_profit_reporting_period_income_upper | toWan | money}}万元, <template v-if=\"h.year_on_year_change == '增长'\"> 增长幅度为{{ h.change_ratio_lower | formatFloat }}% 至{{ h.change_ratio_upper | formatFloat}}% </template> <template v-if=\"h.year_on_year_change == '下降'\"> 下降幅度为{{ h.change_ratio_upper | formatFloat }}% 至{{ h.change_ratio_lower | formatFloat}}% </template> </template> <template v-if=\"h.net_profit_reporting_period_income_lower &amp;&amp; h.net_profit_reporting_period_income_upper &amp;&amp; !h.change_ratio_lower &amp;&amp; !h.change_ratio_upper\"> 净利润{{ h.net_profit_reporting_period_income_lower | toWan | money }}万元至{{ h.net_profit_reporting_period_income_upper | toWan | money}}万元 </template> <template v-if=\"!h.net_profit_reporting_period_income_lower &amp;&amp; !h.net_profit_reporting_period_income_upper &amp;&amp; h.change_ratio_lower &amp;&amp; h.change_ratio_upper\"> <template v-if=\"h.year_on_year_change == '增长'\"> 增长幅度为{{ h.change_ratio_lower | formatFloat }}% 至{{ h.change_ratio_upper | formatFloat}}% </template> <template v-if=\"h.year_on_year_change == '下降'\"> 下降幅度为{{ h.change_ratio_upper | formatFloat }}% 至{{ h.change_ratio_lower | formatFloat}}% </template> </template> <template v-if=\"!h.net_profit_reporting_period_income_lower &amp;&amp; !h.net_profit_reporting_period_income_upper &amp;&amp; !h.change_ratio_lower &amp;&amp; !h.change_ratio_upper\"> <span v-if=h.operating_profit_reporting_period _v-42f9eb58=\"\"> 本期营业收入： {{ h.total_operating_income_reporting_period | toWan | money }}(万元)、 </span> <span v-if=h.net_profit_reporting_period _v-42f9eb58=\"\"> 本期净利润： {{ h.net_profit_reporting_period | toWan | money }}(万元) </span> </template> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">净利润预计变动幅度(%)</p> <p class=time _v-42f9eb58=\"\"> <template v-if=\"h.typ == 'notice'\"> <span class=c-rise v-if=\"h.year_on_year_change == '增长'\" _v-42f9eb58=\"\"> {{h.change_ratio_upper | formatFloat | nullValue }} </span> <span class=c-fall v-if=\"h.year_on_year_change == '下降'\" _v-42f9eb58=\"\"> {{h.change_ratio_lower | formatFloat | nullValue }} </span> <span v-if=!h.year_on_year_change _v-42f9eb58=\"\">-</span> </template> <template v-if=\"h.typ == 'express'\"> <span class=c-rise v-if=\"isShow(h.net_profit_change_ratio) == 1\" _v-42f9eb58=\"\"> {{ h.net_profit_change_ratio | formatFloat | nullValue }} </span> <span class=c-fall v-if=\"isShow(h.net_profit_change_ratio) == 2\" _v-42f9eb58=\"\"> {{ h.net_profit_change_ratio | formatFloat | nullValue }} </span> <span v-if=\"isShow(h.net_profit_change_ratio) == 3\" _v-42f9eb58=\"\">-</span> </template> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">净利润实际变动幅度(%)</p> <p class=\"time c-fall\" _v-42f9eb58=\"\"> <span v-if=\"h.jllfdreal!=''\" :class=\"{'c-rise': h.jllfdreal>=0, 'c-fall': h.jllfdreal<0}\" _v-42f9eb58=\"\">{{ h.jllfdreal }}</span> <span v-else=\"\" _v-42f9eb58=\"\">-</span> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">本期净利润(元)</p> <p class=\"time c-rise\" _v-42f9eb58=\"\"> <span :class=\"{'c-rise': h.retainedprofit>=0, 'c-fall': h.retainedprofit<0}\" _v-42f9eb58=\"\">{{ h.retainedprofit | formatSnjlr }}</span> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">上年同期净利润(元)</p> <p class=time _v-42f9eb58=\"\"> <template v-if=\"h.typ == 'notice'\"> <span class=c-rise v-if=\"isShow(h.net_profit_last_year_income) == 1\" _v-42f9eb58=\"\">{{ h.net_profit_last_year_income | formatSnjlr }} </span> <span class=c-fall v-if=\"isShow(h.net_profit_last_year_income) == 2\" _v-42f9eb58=\"\"> {{ h.net_profit_last_year_income | formatSnjlr }} </span> <span v-if=\"isShow(h.net_profit_last_year_income) == 3\" _v-42f9eb58=\"\">-</span> </template> <template v-if=\"h.typ == 'express'\"> <span class=c-rise v-if=\"isShow(h.net_profit_last_year) == 1\" _v-42f9eb58=\"\"> {{ h.net_profit_last_year | formatSnjlr }} </span> <span class=c-fall v-if=\"isShow(h.net_profit_last_year) == 2\" _v-42f9eb58=\"\"> {{ h.net_profit_last_year | formatSnjlr }} </span> <span v-if=\"isShow(h.net_profit_last_year) == 3\" _v-42f9eb58=\"\"> - </span> </template> </p> </li> </ul> <div class=Express-box v-if=\"h.typ == 'express' &amp;&amp; showPerExpress\" _v-42f9eb58=\"\"> <ul class=Express-news _v-42f9eb58=\"\"> <li class=active _v-42f9eb58=\"\">营业收入</li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">营业收入（万元）</p> <p class=time _v-42f9eb58=\"\"> {{ h.total_operating_income_reporting_period | toWan | money }} <span v-if=\"h.total_operating_income_reporting_period &amp;&amp; h.total_operating_income_reporting_period!=''\" _v-42f9eb58=\"\">(万元)</span> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">同比增长（%）</p> <p class=time _v-42f9eb58=\"\"> {{h.total_operating_income_last_year | toWan | money}} <span v-if=\"h.total_operating_income_last_year &amp;&amp; h.total_operating_income_last_year!=''\" _v-42f9eb58=\"\">(万元)</span> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">净利润（万元）</p> <p class=time _v-42f9eb58=\"\"> <span class=c-rise v-if=\"isShow(h.total_operating_income_change_ratio) == 1\" _v-42f9eb58=\"\">{{h.total_operating_income_change_ratio}}</span> <span class=c-fall v-if=\"isShow(h.total_operating_income_change_ratio) == 2\" _v-42f9eb58=\"\">{{h.total_operating_income_change_ratio}}</span> <span v-if=\"isShow() == \" _v-42f9eb58=\"\">-</span> </p> </li> <li class=active _v-42f9eb58=\"\">净利润</li> <li _v-42f9eb58=\"\"><p class=date _v-42f9eb58=\"\">去年同期（万元）</p> <p class=time _v-42f9eb58=\"\"> {{h.net_profit_reporting_period | toWan | money}} <span v-if=\"h.net_profit_reporting_period &amp;&amp; h.net_profit_reporting_period!=''\" _v-42f9eb58=\"\">(万元)</span> </p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">同比增长（%）</p> <p class=\"time c-fall\" _v-42f9eb58=\"\"> {{h.net_profit_last_year | toWan | money}} <span v-if=\"h.net_profit_last_year &amp;&amp; h.net_profit_last_year!=''\" _v-42f9eb58=\"\">(万元)</span> </p> </li> </ul> <ul class=Express-news _v-42f9eb58=\"\"> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">每股收益（元）</p> <p class=time _v-42f9eb58=\"\">{{ h.basic_earnings_per_share_reporting_period | nullValue }}</p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">每股净资产（元）</p> <p class=time _v-42f9eb58=\"\">{{ h.net_assets_per_share_reporting_period | nullValue }}</p> </li> <li _v-42f9eb58=\"\"> <p class=date _v-42f9eb58=\"\">净资产收益率（%）</p> <p class=time _v-42f9eb58=\"\">{{ h.weighted_average_return_on_net_assets_reporting_period | nullValue }}</p> </li> </ul> </div> </template> </div> <div class=Single-list-main v-if=\"performanceNoticeLists.length == 0\" _v-42f9eb58=\"\"> <div class=Block-trade-no _v-42f9eb58=\"\">暂无数据</div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-42f9eb58=\"\"> <div class=binding-content _v-42f9eb58=\"\"> <a class=binding-logo _v-42f9eb58=\"\"></a> <div class=binding-text _v-42f9eb58=\"\"> 立即绑定IBDATA账号<br _v-42f9eb58=\"\">成为金融分析高手 </div> <div class=binding-bot _v-42f9eb58=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-42f9eb58=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-42f9eb58=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-42f9eb58=\"\"></div>";

/***/ },
/* 789 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-44632dfe=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-44632dfe=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-44632dfe=\"\"> <div class=loading-img _v-44632dfe=\"\"></div> </div> </div> <div class=search-company-box _v-44632dfe=\"\"> <div class=Quarterly-Report v-if=\"fundAllDate.length > 0\" _v-44632dfe=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-44632dfe=\"\"> {{ curFundDate | fundDate }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-44632dfe=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-44632dfe=\"\"> <li v-for=\"h in fundAllDate\" _v-44632dfe=\"\"> <a href=javascript:; v-if=\"curFundDate != h\" @click=\"clickDropmenu(), curFundDate = h, fundFilter()\" _v-44632dfe=\"\">{{ h | fundDate}}</a> </li> </ul> </div> <div class=Single-list-main v-if=fundsInvest.length _v-44632dfe=\"\"> <ul class=Single-list-box v-for=\"(index, h) in fundsInvest\" track-by=$index v-show=\"index >= ((fundPage-1)*10) &amp;&amp; index < (fundPage*10)\" _v-44632dfe=\"\"> <li class=list-w _v-44632dfe=\"\"><p class=date _v-44632dfe=\"\">基金名称</p><p class=time _v-44632dfe=\"\">{{ h.fundname }}</p></li> <li _v-44632dfe=\"\"><p class=date _v-44632dfe=\"\">基金代码</p><p class=time _v-44632dfe=\"\">{{ h.fundcode }}</p></li> <li _v-44632dfe=\"\"><p class=date _v-44632dfe=\"\">股票数量(股)</p><p class=time _v-44632dfe=\"\">{{ h.quantity | money }}</p></li> <li _v-44632dfe=\"\"> <p class=date _v-44632dfe=\"\">同比变化</p> <p class=time _v-44632dfe=\"\"> <span v-if=h.quantity_last :class=\"{'c-fall': h.quantity_tb<0, 'c-rise': h.quantity_tb>=0}\" _v-44632dfe=\"\">{{ h.quantity_tb }}%</span> <span v-else=\"\" _v-44632dfe=\"\">新增</span> </p> </li> <li _v-44632dfe=\"\"> <p class=date _v-44632dfe=\"\">环比变化</p> <p class=time _v-44632dfe=\"\"> <span v-if=h.quantity_hb_last :class=\"{'c-fall': h.quantity_hb<0, 'c-rise': h.quantity_hb>=0}\" _v-44632dfe=\"\">{{ h.quantity_hb }}%</span> <span v-else=\"\" _v-44632dfe=\"\">新增</span> </p> </li> <li _v-44632dfe=\"\"><p class=date _v-44632dfe=\"\">股票价值(元)</p><p class=time _v-44632dfe=\"\">{{ h.value | money }}</p></li> <li _v-44632dfe=\"\"><p class=date _v-44632dfe=\"\">股票价值占比(%)</p><p class=time _v-44632dfe=\"\">{{ h.ratio | cheng100 }}</p></li> </ul> </div> <div class=cop-pledge-page v-if=fundsInvest.length _v-44632dfe=\"\"> <span class=Previous-page v-if=\"fundPage > 1\" @click=\"fundPage--, page()\" _v-44632dfe=\"\">上一页</span> <span class=menu-page _v-44632dfe=\"\"><span style=\"color: #3270ad\" _v-44632dfe=\"\">{{ fundPage }}</span>/{{ fundTotalPage }} </span> <span class=lower-page v-if=\"fundPage < fundTotalPage\" @click=\"fundPage++, page()\" _v-44632dfe=\"\">下一页</span> </div> <div class=Single-list-main v-if=\"!fundsInvest.length &amp;&amp; !loading\" _v-44632dfe=\"\"> <div class=Block-trade-no _v-44632dfe=\"\">暂无数据</div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-44632dfe=\"\"> <div class=binding-content _v-44632dfe=\"\"> <a class=binding-logo _v-44632dfe=\"\"></a> <div class=binding-text _v-44632dfe=\"\"> 立即绑定IBDATA账号<br _v-44632dfe=\"\">成为金融分析高手 </div> <div class=binding-bot _v-44632dfe=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-44632dfe=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-44632dfe=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-44632dfe=\"\"></div>";

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div _v-4b02931c=\"\"> <div class=wrapper style=\"background-color: white\" _v-4b02931c=\"\"> <img src=/static/images/wx-share-logo.jpg id=notice-share-logo alt=\"\" style=width:0px;height:0px _v-4b02931c=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-4b02931c=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-4b02931c=\"\"> <div class=loading-img _v-4b02931c=\"\"></div> </div> </div> <div class=new-user-guide v-show=\"loading === false &amp;&amp; showguide === true\" @click=hideNewUserGuide _v-4b02931c=\"\"> <div class=guide-menu @click=hideNewUserGuide _v-4b02931c=\"\"></div> <div class=guide-img _v-4b02931c=\"\"> <img src=" + __webpack_require__(342) + " alt=\"\" _v-4b02931c=\"\"> </div> </div> <div id=mulu v-show=showmenu _v-4b02931c=\"\"> <div class=toolsbar-mune-2 style=\"max-width: 640px\" _v-4b02931c=\"\"> <div class=toggle-menu-wrap-2 @click=toggleMenu _v-4b02931c=\"\"> <span class=cancle-btn _v-4b02931c=\"\"></span> </div> <div class=header-menu-wrap-2 _v-4b02931c=\"\"> <span class=\"options clicked header-menu\" style=\"height: 40px; line-height: 40px\" _v-4b02931c=\"\">目录</span> </div> </div> <div class=notice-menu _v-4b02931c=\"\"> <div class=bottom-color style=\"max-width: 640px\" _v-4b02931c=\"\"> <div class=left-side-page _v-4b02931c=\"\"> <div class=catalog-cont _v-4b02931c=\"\"> <ul _v-4b02931c=\"\"> <li v-for=\"c in titles\" :style=indentChild(c.code) v-show=c.isshow _v-4b02931c=\"\"> <template v-if=\"c.code &amp;&amp; c.code.split('.').length<=7\"> <a href=javascript:; :class=\"{'expand': c.code.split('.').length<=2}\" _v-4b02931c=\"\"> <span @click=showTitleChild(c) :class=\"{'open-caret-right': c.code.split('.').length<=2, 'close-caret-right': c.code.split('.').length>2}\" v-if=\"c.haschild &amp;&amp; !c.showchild\" _v-4b02931c=\"\"> </span> <span @click=showTitleChild(c) :class=\"{'open-caret': c.code.split('.').length<=2, 'close-caret': c.code.split('.').length>2}\" v-if=\"c.haschild  &amp;&amp; c.showchild\" _v-4b02931c=\"\"> </span> <span class=no-caret v-if=!c.haschild _v-4b02931c=\"\"></span> <span class=caret-pad @click=\"titleIntoView(c.code + '-0')\" v-html=c.title _v-4b02931c=\"\"></span> </a> </template> </li> </ul> </div> </div> </div> </div> </div> <div _v-4b02931c=\"\"></div> <div id=main-content v-show=!showComments _v-4b02931c=\"\"> <div class=beta_record v-if=showUserInfo _v-4b02931c=\"\"> <div class=photo_img _v-4b02931c=\"\"><img :src=headUrl _v-4b02931c=\"\"></div> <div class=wx_content _v-4b02931c=\"\"> <p class=p1 _v-4b02931c=\"\">{{xnName}}邀您阅读</p> <p class=p2 _v-4b02931c=\"\">{{company}} | {{position}}</p> </div> </div> <div :class=\"[ showUserInfo ? 'toolsbar-mune':'toolsbar-mune-1']\" @click=toggleTitle v-show=!showmenu _v-4b02931c=\"\"> <div class=toggle-menu-wrap @click=toggleMenu v-if=showNotice _v-4b02931c=\"\"> <span class=sidebar-btn _v-4b02931c=\"\"></span> </div> <div class=toggle-menu-wrap @click=backTotext() v-if=\"!showNotice &amp;&amp; (showPrevNext || annObject.length === 1)\" _v-4b02931c=\"\"> <a class=footer-btn style=position:relative;top:2px;right:0 _v-4b02931c=\"\">返回</a> </div> <div class=\"notice-title blue\" _v-4b02931c=\"\"><strong id=detail-title _v-4b02931c=\"\">{{ detail.fulltitle | formatTitle }}</strong></div> <div class=header-toggle-icon style=\"width: 100%; height: 20px\" v-if=\"detail.fulltitle.length > 33\" _v-4b02931c=\"\"> <div class=\"toggle-icon toggle-down-arrow\" _v-4b02931c=\"\"></div> </div> </div> <div :class=\"[showUserInfo ? 'my-container-1' : 'my-container-3']\" style=\"\" id=annotation v-if=showNotice _v-4b02931c=\"\"> <div class=notice-content id=cont _v-4b02931c=\"\"> <table class=table-title v-show=\"!loading &amp;&amp; showheadtable === 0 &amp;&amp; (topPage == 1 || topPage == 0)\" style=\"width: 94% !important;margin: 0 auto;margin-top: 10px\" _v-4b02931c=\"\"> <tbody _v-4b02931c=\"\"> <tr _v-4b02931c=\"\"> <td colspan=4 _v-4b02931c=\"\">{{ detail.fulltitle }}</td> </tr> <tr _v-4b02931c=\"\"> <td class=blue _v-4b02931c=\"\">板块类型</td> <td _v-4b02931c=\"\"> {{ categoryName(detail.category) }} </td> <td class=blue _v-4b02931c=\"\">发布日期</td> <td _v-4b02931c=\"\"> {{ detail.publishDate }} </td> </tr> <tr _v-4b02931c=\"\"> <td class=blue _v-4b02931c=\"\">证券简称</td> <td _v-4b02931c=\"\"> {{ detail.company }} </td> <td class=blue _v-4b02931c=\"\">证券代码</td> <td _v-4b02931c=\"\">{{detail.companyCode}}</td> </tr> </tbody> </table> <template v-for=\"(z,c) in detail.child\" track-by=$index v-show=\"$index <= (bottomPage*5 - 1) &amp;&amp; $index >= (topPage-1)*5-1\"> <p class=title-a id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length === 2\" _v-4b02931c=\"\">{{c.title}}</p> <p class=title-b id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length === 3\" _v-4b02931c=\"\">{{c.title}}</p> <p class=title-b-2 id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length > 3\" _v-4b02931c=\"\">{{c.title}}</p> <template v-for=\"(key,d) in c.contents\"> <template v-if=\"d.htmltag=='p'\"> <div :id=idCompute(c,$index,z) style=\"width: 94%;margin: 0 auto\" _v-4b02931c=\"\"> <p class=title-c v-for=\"content in d.content.split('\\n')\" track-by=$index _v-4b02931c=\"\">{{content}}</p> </div> </template> <template v-if=\"d.htmltag=='img'\"> <div :id=\"idCompute(c, $index, z)\" _v-4b02931c=\"\"> <p class=title-c style=\"padding-left: 20px; text-indent: 2em\" _v-4b02931c=\"\">{{d.imghead}}</p> <img style=\"padding-left: 20px; text-indent: 2em\" src={{d.imgurl}} _v-4b02931c=\"\"> <p class=title-c style=\"padding-left: 20px; text-indent: 2em\" _v-4b02931c=\"\">{{d.imgfoot}}</p> </div> </template> <div class=table-tory-outter v-if=\"d.htmltag=='table'\" :id=idCompute(c,$index,z) style=\"width: 94%;margin: 0 auto; margin-top: 10px\" _v-4b02931c=\"\"> <table cellpadding=0 class=table-tory _v-4b02931c=\"\"> <tbody _v-4b02931c=\"\"> <tr v-for=\"(rowidx, row) in d.content.split('\\n')\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-4b02931c=\"\"> <td v-for=\"(colidx, col) in row.split('\\t')\" :id=\"idCompute(c, key, z) + '-' + rowidx + '-' + colidx\" rowspan=\"{{ getrowspan(rowidx, colidx, d.mergecells) }}\" colspan=\"{{ getcolspan(rowidx, colidx, d.mergecells) }}\" track-by=$index _v-4b02931c=\"\"> {{col}} </td> </tr> </tbody> </table> <p class=table-info style=\"display: none\" _v-4b02931c=\"\">{{d.info}}</p> </div> </template> </template> <div class=code-a v-if=\"!loading &amp;&amp; bottomPage==allPageNum\" _v-4b02931c=\"\"><img src=/static/images/code-a.jpg _v-4b02931c=\"\"></div> <div class=code-b v-if=\"!loading &amp;&amp; bottomPage==allPageNum\" _v-4b02931c=\"\"><img src=/static/images/code-b.jpg _v-4b02931c=\"\"></div> </div> </div> <div class=my-container style=\"top: 3px\" id=annotation v-if=!showNotice _v-4b02931c=\"\"> <div class=notice-content id=cont _v-4b02931c=\"\"> <template v-for=\"(z,c) in newdetail\" track-by=$index> <p class=title-a id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length === 2\" _v-4b02931c=\"\">{{c.title}}</p> <p class=title-b id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length === 3\" _v-4b02931c=\"\">{{c.title}}</p> <p class=title-b-2 id={{c.code}}-0 :style=indentChild(c.code) v-if=\"c.title &amp;&amp; c.code.split('.').length > 3\" _v-4b02931c=\"\">{{c.title}}</p> <template v-for=\"(key,d) in c.contents\"> <template v-if=\"d.htmltag=='p'\"> <div :id=idCompute(c,$index,z) style=\"width: 94%;margin: 0 auto\" _v-4b02931c=\"\"> <p class=title-c v-for=\"content in d.content.split('\\n')\" track-by=$index _v-4b02931c=\"\">{{content}}</p> </div> </template> <template v-if=\"d.htmltag=='img'\"> <div :id=\"idCompute(c, $index, z)\" _v-4b02931c=\"\"> <p class=title-c style=\"padding-left: 20px; text-indent: 2em\" _v-4b02931c=\"\">{{d.imghead}}</p> <img style=\"padding-left: 20px; text-indent: 2em\" src={{d.imgurl}} _v-4b02931c=\"\"> <p class=title-c style=\"padding-left: 20px; text-indent: 2em\" _v-4b02931c=\"\">{{d.imgfoot}}</p> </div> </template> <div class=table-tory-outter v-if=\"d.htmltag=='table'\" :id=idCompute(c,$index,z) style=\"width: 94%;margin: 0 auto; margin-top: 10px\" _v-4b02931c=\"\"> <table cellpadding=0 class=table-tory _v-4b02931c=\"\"> <tbody _v-4b02931c=\"\"> <tr v-for=\"(rowidx, row) in d.content.split('\\n')\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-4b02931c=\"\"> <td v-for=\"(colidx, col) in row.split('\\t')\" :id=\"idCompute(c, key, z) + '-' + rowidx + '-' + colidx\" rowspan=\"{{ getrowspan(rowidx, colidx, d.mergecells) }}\" colspan=\"{{ getcolspan(rowidx, colidx, d.mergecells) }}\" track-by=$index _v-4b02931c=\"\"> {{col}} </td> </tr> </tbody> </table> <p class=table-info style=\"display: none\" _v-4b02931c=\"\">{{d.info}}</p> </div> </template> </template> </div> </div> </div> <div class=my-container v-show=showComments _v-4b02931c=\"\"> <div class=comment-detail _v-4b02931c=\"\"> <div class=comment-title _v-4b02931c=\"\"> <p class=comment-all _v-4b02931c=\"\">全部评论</p> <p class=comment-sort _v-4b02931c=\"\">{{cpwtotal}}条评论</p> </div> <div class=comment v-for=\"item in commentList\" _v-4b02931c=\"\"> <div class=common-avatar _v-4b02931c=\"\"> <img src=/static/images/user.png width=100% height=100% _v-4b02931c=\"\"> </div> <div class=comment-block _v-4b02931c=\"\"> <p class=comment-user _v-4b02931c=\"\"> <span class=comment-username v-if=item.user _v-4b02931c=\"\"> {{item.user.username}} </span> <span class=comment-username v-else=\"\" _v-4b02931c=\"\"> 匿名用户 </span> <span class=footer-zan _v-4b02931c=\"\"> <i class=c-share-icon @click.stop=\"zan(item.id, $event)\" _v-4b02931c=\"\"></i><span class=u-num _v-4b02931c=\"\">{{item.zan_cnt}}</span></span> </p> <div class=comment-content _v-4b02931c=\"\">{{item.content}} </div> <div class=comment-operate _v-4b02931c=\"\"> <span class=\"J_Vote comment-operate-item comment-operate-up\" _v-4b02931c=\"\">{{item.updtime | date}}</span> <span class=\"J_Reply comment-operate-item\" _v-4b02931c=\"\"> <a href=javascript:; @click=\"commentinput = true, pid = item.id, content = ''\" _v-4b02931c=\"\">回复</a> </span> </div> <div class=\"comment-reply-ctn comment-reply-item\" _v-4b02931c=\"\"> <ul _v-4b02931c=\"\"> <li v-for=\"i in item.replys\" track-by=$index v-if=\"$index < item.showall\" _v-4b02931c=\"\"> <p class=comment-text _v-4b02931c=\"\"> <span class=c-username v-if=i.user _v-4b02931c=\"\"> {{i.user.username}} </span> <span class=c-username v-else=\"\" _v-4b02931c=\"\">匿名用户</span> {{i.content}} </p> <div class=\"reply-operate reply-operate-hot\" _v-4b02931c=\"\"> <span class=\"J_Vote reply-operate-item reply-up\" _v-4b02931c=\"\"><i class=c-share-icon @click.stop=\"zan(i.id, $event)\" _v-4b02931c=\"\"></i><span _v-4b02931c=\"\">{{i.zan_cnt}}</span></span> <span class=\"J_Reply reply-operate-item\" _v-4b02931c=\"\"></span> <span _v-4b02931c=\"\">{{i.updtime | date}}</span> </div> </li> <li class=\"view-more hidden\" v-if=\"item.replys.length > 2 &amp;&amp; item.showall !== 8\" _v-4b02931c=\"\"> <a class=\"btn-block text-center btn-comment-expand\" @click=\"item.showall = 8\" _v-4b02931c=\"\">查看全部<span class=nume _v-4b02931c=\"\">{{item.replys.length}}</span>条回复 </a> </li> </ul> </div> </div> </div> </div> <div class=comment-more _v-4b02931c=\"\"> <a href=javascript:; v-if=\"commentList.length !== cpwtotal\" _v-4b02931c=\"\">加载更多评论中...</a> <a href=javascript:; v-if=\"commentList.length == cpwtotal &amp;&amp; cpwtotal !== 0\" _v-4b02931c=\"\">评论已全部加载</a> </div> <div class=comment-no v-if=\"cpwtotal == 0\" _v-4b02931c=\"\"> 暂无评论，快来添加一个吧！ </div> <div class=comment-no _v-4b02931c=\"\"></div> </div> <div class=footer-comment v-show=showNotice _v-4b02931c=\"\"> <span class=footer-text _v-4b02931c=\"\"> <a href=javascript:; @click=\"commentinput = true, content= '',pid = 0\" _v-4b02931c=\"\"> <i class=comment-icon _v-4b02931c=\"\"></i>评论一下</a> </span> <span class=footer-open v-if=\"readORchange &amp;&amp; showPrevNext\" _v-4b02931c=\"\"> <span class=Shield-notes-btn v-if=\"ModeOPtions == 1\" @click=readMode() _v-4b02931c=\"\">屏蔽注解</span> <span class=notes-btn v-if=\"ModeOPtions == 2\" @click=readMode() _v-4b02931c=\"\">展开注解</span> </span> <span class=footer-top @click=prevAnn() v-if=\"showPrevNext &amp;&amp; readORchange &amp;&amp; ModeOPtions == 1\" _v-4b02931c=\"\"> <i class=t-one-icon _v-4b02931c=\"\"></i> </span> <span class=footer-bot @click=nextAnn() v-if=\"showPrevNext &amp;&amp; readORchange &amp;&amp; ModeOPtions == 1\" _v-4b02931c=\"\"> <i class=t-next-icon _v-4b02931c=\"\"></i> </span> <span class=footer-zan v-show=!showComments _v-4b02931c=\"\"> <a href=javascript:; @click=\"showComments = true, showPrevNext = false,loadcomment()\" _v-4b02931c=\"\"> <span class=qinp _v-4b02931c=\"\"><i _v-4b02931c=\"\"></i>{{cpwtotal}}</span> </a> </span> <span class=footer-zan v-show=showComments _v-4b02931c=\"\"> <a href=javascript:; @click=\"showComments = false, showPrevNext = true\" _v-4b02931c=\"\"> <span class=text _v-4b02931c=\"\"><i _v-4b02931c=\"\"></i>返回原文</span> </a> </span> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-show=commentinput @click.self=\"commentinput = false\" _v-4b02931c=\"\"> <div class=comment-content _v-4b02931c=\"\"> <div class=comment-content-tag _v-4b02931c=\"\"> <div class=login-close _v-4b02931c=\"\"> <a class=delete-icon href=javascript:; @click=\"commentinput = false\" _v-4b02931c=\"\"></a> </div> <div class=comment-reply _v-4b02931c=\"\"> <textarea cols=\"\" rows=2 class=input-a placeholder=输入发表内容 v-model=content _v-4b02931c=\"\"></textarea> <span class=anonymous @click=\"anonym == 1 ? anonym = 0:anonym = 1\" _v-4b02931c=\"\"> <label class=\"el-checkbox mar\" _v-4b02931c=\"\"> <span class=el-checkbox-input :class=\"{'is-checked':anonym === 1}\" _v-4b02931c=\"\"> <span class=el-checkbox-inner _v-4b02931c=\"\"></span> </span> <span class=el-checkbox-label _v-4b02931c=\"\">匿名评论</span> </label> </span> <a class=btn-Publish href=javascript:; @click=\"commentinput = false,addComment(1, md5, params.stype, detail.publishDate)\" _v-4b02931c=\"\">发表</a> </div> </div> </div> </div> <div v-if=commentinput class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div _v-4b02931c=\"\"></div> <div v-if=commentinput class=\"modal-backdrop fade in\" _v-4b02931c=\"\"></div> <div class=footer-app _v-4b02931c=\"\"> <a class=footer-logo-ios _v-4b02931c=\"\"></a> <span class=footer-text _v-4b02931c=\"\">IBDATA<br _v-4b02931c=\"\">人工智能和大数据驱动的投研首选平台</span> <a class=footer-btn @click=downloadApp _v-4b02931c=\"\">下载应用</a> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-4b02931c=\"\"> <div class=binding-content _v-4b02931c=\"\"> <a class=binding-logo _v-4b02931c=\"\"></a> <div class=binding-text _v-4b02931c=\"\"> 立即绑定IBDATA账号<br _v-4b02931c=\"\">成为金融分析高手 </div> <div class=binding-bot _v-4b02931c=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-4b02931c=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-4b02931c=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-4b02931c=\"\"></div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-if=seeAnnotation _v-4b02931c=\"\"> <div class=subscribe-tag _v-4b02931c=\"\"> <div class=zhushi-tag-cont _v-4b02931c=\"\"> <div class=login-close _v-4b02931c=\"\"> <a class=delete-icon href=javascript:; @click=\"seeAnnotation = false, editStatus = false\" _v-4b02931c=\"\"></a> </div> <div class=Notes-content _v-4b02931c=\"\"> <div v-for=\"(key,item) in currentAnno\" v-if=!editStatus _v-4b02931c=\"\"> <div class=Notes-user _v-4b02931c=\"\"> <span class=Notes-username _v-4b02931c=\"\"> {{annotationList[item[0]][3] }}</span><span class=Notes-time _v-4b02931c=\"\">{{annotationList[item[0]][4] }}</span> </div> <div class=subscribe-name v-if=\"annotationList[item[0]][2] == 1 &amp;&amp; annotationList[item[0]][0].length < 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0]}}</span> </span> </div> <div class=subscribe-name v-if=\"annotationList[item[0]][2] == 1 &amp;&amp; annotationList[item[0]][0].length >= 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0].substring(0, 80)}}...</span> </span> <span class=Notes-more @click.self=spread($event) _v-4b02931c=\"\">展开<span class=Notes-triangle-b _v-4b02931c=\"\"></span></span> </div> <div class=subscribe-name style=display:none v-if=\"annotationList[item[0]][2] == 1 &amp;&amp; annotationList[item[0]][0].length >= 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0]}}</span> </span> <span class=Notes-more @click.self=retract($event) _v-4b02931c=\"\">收起<span class=Notes-triangle-a _v-4b02931c=\"\"></span></span> </div> <div class=subscribe-name :class=\"{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}\" v-if=\"annotationList[item[0]][2] == 2 &amp;&amp;annotationList[item[0]][0].length < 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0]}}</span> </span> </div> <div class=subscribe-name :class=\"{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}\" v-if=\"annotationList[item[0]][2] == 2 &amp;&amp;annotationList[item[0]][0].length >= 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0].substring(0, 80)}}...</span> </span> <span class=Notes-more @click.self=spread($event) _v-4b02931c=\"\">展开<span class=Notes-triangle-b _v-4b02931c=\"\"></span></span> </div> <div class=subscribe-name style=display:none :class=\"{'name-a': annotationList[item[0]][1] == '#a5c5ff','name-c': annotationList[item[0]][1] == '#feb75e'}\" v-if=\"annotationList[item[0]][2] == 2 &amp;&amp;annotationList[item[0]][0].length >= 80\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">引用：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{annotationList[item[0]][0]}}</span> </span> <span class=Notes-more @click.self=retract($event) _v-4b02931c=\"\">收起<span class=Notes-triangle-a _v-4b02931c=\"\"></span></span> </div> <div class=\"box-content box-login Notes-content-a\" _v-4b02931c=\"\"> <div class=Notes-list _v-4b02931c=\"\"> <div class=Notes-content-a v-if=\"annotationList[item[0]][2] == 1\" _v-4b02931c=\"\"> <span class=left _v-4b02931c=\"\"> <span class=Notes-content-left _v-4b02931c=\"\">点评：</span> <span class=Notes-content-right _v-4b02931c=\"\">{{{annotationList[item[0]][1]}}}</span> </span> </div> </div> </div> </div> <div class=box-textarea-block v-if=editStatus _v-4b02931c=\"\"> <textarea class=\"box-textarea J_Textarea\" id=J_Textarea placeholder=\"\" v-model=currentAnno[changedIndex][1] _v-4b02931c=\"\"></textarea> </div> <div class=box-info v-if=editStatus _v-4b02931c=\"\"> <a class=\"box-commentBtn box-commentBtn--no J_PostBtn\" @click=\"editStatus = false\" _v-4b02931c=\"\"> 取消编辑</a> <a class=\"box-commentBtn box-commentBtn--able J_PostBtn\" @click=\"save(currentAnno[changedIndex][0], changedIndex)\" _v-4b02931c=\"\"> 保存</a> </div> </div> </div> </div> </div> <div class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div v-if=seeAnnotation _v-4b02931c=\"\"></div> <div class=\"modal-backdrop fade in\" v-if=seeAnnotation _v-4b02931c=\"\"></div> </div>";

/***/ },
/* 791 */
/***/ function(module, exports) {

	module.exports = "<div class=wrapper @click=hideDropmenu($event) _v-53975fc5=\"\"> <div class=company-top _v-53975fc5=\"\"> <div class=search-header _v-53975fc5=\"\"> <div class=search-header-text _v-53975fc5=\"\">{{ company.shortname }}({{ companycode }})</div> <div class=Quarterly-menu _v-53975fc5=\"\"> <div class=head-title @click.top=toggleDropdown _v-53975fc5=\"\"> {{ selectTab | fomartTab }} <span class=close-bot _v-53975fc5=\"\"></span> </div> <ul class=menu-lanmu v-if=showDropdownMenu _v-53975fc5=\"\"> <li v-for=\"(key, val) in tabList\" _v-53975fc5=\"\"> <a href=javascript:; v-if=\"key !== selectTab\" @click.stop=setSelectTab(key) _v-53975fc5=\"\">{{ val }}</a> </li> </ul> </div> </div> <div class=cop-header-menu style=\"overflow-x: scroll; overflow-y: hidden\" v-if=\"stype != 6\" _v-53975fc5=\"\"> <ul v-if=\"selectedTab === 'baseinfo'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">基本信息</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">高管</li> </ul> <ul v-if=\"selectedTab === 'gudong'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">机构持仓</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">十大股东</li> <li :class=\"{ 'on': selectedTab2 == 3 }\" @click=setSelectTab2(3) _v-53975fc5=\"\">重要股东股权变动</li> </ul> <ul v-if=\"selectedTab === 'finance'\" style=\"display: inline-flex\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">公司综合能力指标</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">负债表</li> <li :class=\"{ 'on': selectedTab2 == 3 }\" @click=setSelectTab2(3) _v-53975fc5=\"\">利润表</li> <li :class=\"{ 'on': selectedTab2 == 4 }\" @click=setSelectTab2(4) _v-53975fc5=\"\">流量表</li> <li :class=\"{ 'on': selectedTab2 == 5 }\" @click=setSelectTab2(5) _v-53975fc5=\"\">业绩预告</li> <li :class=\"{ 'on': selectedTab2 == 6 }\" @click=setSelectTab2(6) _v-53975fc5=\"\">行业对比</li> </ul> <ul v-if=\"selectedTab === 'mainbusiness'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">按产品</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">按行业</li> <li :class=\"{ 'on': selectedTab2 == 3 }\" @click=setSelectTab2(3) _v-53975fc5=\"\">按地域</li> </ul> <ul v-if=\"selectedTab === 'customersandsuppliers'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">客户信息</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">供应商信息</li> </ul> <ul v-if=\"selectedTab === 'tradinginformation'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">交易行情</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">龙虎榜</li> <li :class=\"{ 'on': selectedTab2 == 3 }\" @click=setSelectTab2(3) _v-53975fc5=\"\">大宗交易</li> </ul> </div> <div class=cop-header-menu style=\"overflow-x: scroll; overflow-y: hidden\" v-if=\"stype == 6\" _v-53975fc5=\"\"> <ul v-if=\"selectedTab === 'baseinfo'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 1 }\" @click=setSelectTab2(1) _v-53975fc5=\"\">基本信息</li> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">高管</li> </ul> <ul v-if=\"selectedTab === 'gudong'\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">十大股东</li> </ul> <ul v-if=\"selectedTab === 'finance'\" style=\"display: inline-flex\" _v-53975fc5=\"\"> <li :class=\"{ 'on': selectedTab2 == 2 }\" @click=setSelectTab2(2) _v-53975fc5=\"\">负债表</li> <li :class=\"{ 'on': selectedTab2 == 3 }\" @click=setSelectTab2(3) _v-53975fc5=\"\">利润表</li> <li :class=\"{ 'on': selectedTab2 == 4 }\" @click=setSelectTab2(4) _v-53975fc5=\"\">流量表</li> </ul> </div> </div> <router-view _v-53975fc5=\"\"></router-view> </div>";

/***/ },
/* 792 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-5cfdd634=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-5cfdd634=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-5cfdd634=\"\"> <div class=loading-img _v-5cfdd634=\"\"></div> </div> </div> <div class=search-company-box _v-5cfdd634=\"\"> <div class=Quarterly-Report v-if=\"allDateTyps.length > 0\" _v-5cfdd634=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-5cfdd634=\"\"> {{ curDateTyp }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-5cfdd634=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-5cfdd634=\"\"> <li v-for=\"h in allDateTyps\" _v-5cfdd634=\"\"> <a href=javascript:; v-if=\"curDateTyp != h\" @click=\"clickDropmenu(), curDateTyp = h, tableFilter()\" _v-5cfdd634=\"\">{{ h }}</a> </li> </ul> </div> <div class=dhy-details-box v-if=\"gaoguan.length > 0\" _v-5cfdd634=\"\"> <h3 class=\"\" _v-5cfdd634=\"\">高管介绍</h3> <div class=cop-list-main _v-5cfdd634=\"\"> <ul class=cop-list-box v-for=\"(index, h) in gaoguan\" track-by=$index v-show=\"index >= ((page-1)*10) &amp;&amp; index < (page*10)\" _v-5cfdd634=\"\"> <li _v-5cfdd634=\"\"><p class=date _v-5cfdd634=\"\">姓名</p> <p class=time _v-5cfdd634=\"\">{{ h.name }}</p></li> <li _v-5cfdd634=\"\"><p class=date _v-5cfdd634=\"\">年龄</p> <p class=time _v-5cfdd634=\"\">{{ h.age }}</p></li> <li _v-5cfdd634=\"\"><p class=date _v-5cfdd634=\"\">性别</p> <p class=time _v-5cfdd634=\"\">{{ h.gender }}</p></li> <li _v-5cfdd634=\"\"><p class=date _v-5cfdd634=\"\">职务</p> <p class=time _v-5cfdd634=\"\">{{ h.job }}</p></li> <li _v-5cfdd634=\"\"><p class=date _v-5cfdd634=\"\">持股数</p> <p class=time _v-5cfdd634=\"\">{{ h.holdshare }}</p></li> </ul> </div> <div class=cop-pledge-page _v-5cfdd634=\"\"> <span class=Previous-page v-if=\"page > 1\" @click=page-- _v-5cfdd634=\"\">上一页</span> <span class=menu-page _v-5cfdd634=\"\"><span style=\"color: #3270ad\" _v-5cfdd634=\"\">{{ page }}</span>/{{ totalPage }} </span> <span class=lower-page v-if=\"page < totalPage\" @click=page++ _v-5cfdd634=\"\">下一页</span> </div> </div> </div> <div class=\"search-result-box announ-zy\" v-if=\"notice.lists.length > 0\" _v-5cfdd634=\"\"> <h3 class=\"\" _v-5cfdd634=\"\">相关公告</h3> <div class=search-result-list v-for=\"h in notice.lists\" _v-5cfdd634=\"\"> <p class=head _v-5cfdd634=\"\"> <span class=dov-icon _v-5cfdd634=\"\"></span><a href=javascript:; @click=goNotice(h) _v-5cfdd634=\"\">{{ h.title }}</a> </p> <p class=Subtitle _v-5cfdd634=\"\"><span class=fl _v-5cfdd634=\"\">证券代码：{{ companycode }}</span><span class=fr _v-5cfdd634=\"\">{{ h.publishDate }}</span></p> </div> <div class=cop-pledge-page _v-5cfdd634=\"\"> <span class=Previous-page v-if=\"notice.page > 1\" @click=\"notice.page--, getRelationNotice()\" _v-5cfdd634=\"\">上一页</span> <span class=menu-page _v-5cfdd634=\"\"><span style=\"color: #3270ad\" _v-5cfdd634=\"\">{{ notice.page }}</span>/ {{ notice.totalPage }} </span> <span class=lower-page v-if=\"notice.page < notice.totalPage\" @click=\"notice.page++, getRelationNotice()\" _v-5cfdd634=\"\">下一页</span> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-5cfdd634=\"\"> <div class=binding-content _v-5cfdd634=\"\"> <a class=binding-logo _v-5cfdd634=\"\"></a> <div class=binding-text _v-5cfdd634=\"\"> 立即绑定IBDATA账号<br _v-5cfdd634=\"\">成为金融分析高手 </div> <div class=binding-bot _v-5cfdd634=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-5cfdd634=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-5cfdd634=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-5cfdd634=\"\"></div>";

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div class=wrapper style=\"background-color: white\" _v-65456900=\"\"> <img src=/static/images/wx-share-logo.jpg alt=\"\" style=\"width:0px; height:0px\" _v-65456900=\"\"> <div v-show=loading class=page-loading style=width:100%;height:100%;position:fixed;top:0;background:#000000;z-index:10000;opacity:0.8;max-width:640px _v-65456900=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-65456900=\"\"> <div class=loading-img _v-65456900=\"\"></div> </div> </div> <div class=new-user-guide v-show=\"loading === false &amp;&amp; showguide === true\" @click=hideNewUserGuide _v-65456900=\"\"> <div class=guide-menu @click=hideNewUserGuide _v-65456900=\"\"></div> <div class=guide-img _v-65456900=\"\"> <img src=" + __webpack_require__(342) + " alt=\"\" _v-65456900=\"\"> </div> </div> <div id=mulu v-show=showmenu _v-65456900=\"\"> <div class=toolsbar-mune _v-65456900=\"\"> <div class=toggle-menu-wrap @click=toggleMenu _v-65456900=\"\"> <span class=cancle-btn _v-65456900=\"\"></span> </div> <div class=header-menu-wrap _v-65456900=\"\"> <span class=\"options clicked header-menu\" style=\"height: 40px\" _v-65456900=\"\">目录</span> </div> </div> <div class=notice-menu _v-65456900=\"\"> <div class=bottom-color style=\"max-width: 640px\" _v-65456900=\"\"> <div class=left-side-page _v-65456900=\"\"> <div class=catalog-cont _v-65456900=\"\"> <ul _v-65456900=\"\"> <template v-for=\"c in titles\"> <li v-if=\"c.code &amp;&amp; c.code.split('.').length<=7\" :style=indentChild(c.code) v-show=\"c.isshow &amp;&amp; c.title !== ''\" id=title_{{c.code}} _v-65456900=\"\"> <a href=javascript:; :class=\"{'expand': c.code.split('.').length<=2}\" _v-65456900=\"\"> <span @click=showTitleChild(c) :class=\"{'open-caret-right': c.code.split('.').length<=2, 'close-caret-right': c.code.split('.').length>2}\" v-if=\"c.haschild &amp;&amp; !c.showchild\" _v-65456900=\"\"></span> <span @click=showTitleChild(c) :class=\"{'open-caret': c.code.split('.').length<=2, 'close-caret': c.code.split('.').length>2}\" v-if=\"c.haschild  &amp;&amp; c.showchild\" _v-65456900=\"\"></span> <span class=no-caret v-if=!c.haschild _v-65456900=\"\"></span> <span class=caret-pad @click=\"titleIntoView(c.code + '-0')\" _v-65456900=\"\"> <span class=title-xuhao v-if=\"detail.datasrc === 'IRM'\" _v-65456900=\"\"> <span v-if=\"c.tqaindex >= 0\" _v-65456900=\"\"> {{ c.tqaindex + 1 }}、 </span> </span> {{{ c.title }}} </span> </a> </li> </template> </ul> </div> </div> </div> </div> </div> <div class=toolsbar-mune @click=toggleTitle v-show=!showmenu _v-65456900=\"\"> <div class=toggle-menu-wrap @click=toggleMenu _v-65456900=\"\"> <span class=sidebar-btn _v-65456900=\"\"></span> </div> <div class=\"notice-title blue\" _v-65456900=\"\"><strong id=detail-title _v-65456900=\"\">{{ detail.fulltitle | formatTitle }}</strong></div> <div class=header-toggle-icon v-if=\"detail.fulltitle.length > 33\" _v-65456900=\"\"> <div class=\"toggle-icon toggle-down-arrow\" _v-65456900=\"\"></div> </div> </div> <div class=\"my-container qa-cont\" v-show=\"!showmenu &amp;&amp; !showComments\" _v-65456900=\"\"> <div class=\"article-content notice-content qa-notice-content\" _v-65456900=\"\"> <div class=company-statement v-if=\"topPage == 1 || topPage == 0\" _v-65456900=\"\"> <div class=article-detail _v-65456900=\"\"> <template v-if=\"detail.content !== ''\"> <p v-for=\"content in detail.content.split('\\n')\" style=\"width: 100%; margin: 0 auto; margin-left: 3px; margin-right: 0\" id=0-{{$index}} _v-65456900=\"\">{{ content }}</p> </template> </div> </div> <template v-for=\"c in detail.child\" track-by=$index v-show=\"$index <= (bottomPage*3-1) &amp;&amp; $index > (topPage-1)*3-1\"> <template v-if=c.title> <p class=title-a id={{c.code}}-0 :style=indentChild(c.code) v-if=c.title _v-65456900=\"\"> {{ c.title }} </p> <template v-if=\"c.content &amp;&amp; c.content !== '' &amp;&amp; c.content !== ' ' &amp;&amp; c.content !== '无'\"> <p v-for=\"con in c.content.split('\\n')\" style=\"width: 94%; margin: 0 auto; text-indent: 20px\" id={{c.code}}-{{$index}} class=tttt _v-65456900=\"\"> {{ con }} </p> </template> </template> <table class=catalog-qa v-if=c.que _v-65456900=\"\"> <tbody style=\"width: 100%\" _v-65456900=\"\"> <tr style=\"display: block\" _v-65456900=\"\"> <td class=qa-left-w style=\"width: 1.68rem; font-size: 14px; color: #0D65D8\" _v-65456900=\"\"> <template v-if=\"detail.datasrc === 'IRM'\"> <span style=\"float: right; padding: 0;text-align: right\" _v-65456900=\"\"> {{c.qaindex + 1}}、 </span> </template> <template v-if=\"detail.datasrc !== 'IRM'\"> <span class=\"catalog-icon cata-qa-q\" _v-65456900=\"\"></span> </template> </td> <td id={{c.code}}-0 _v-65456900=\"\"> <template v-if=\"detail.datasrc === 'IRM'\"> <span class=\"catalog-icon cata-qa-q\" style=\"margin: 0.18rem 5px 2px 0px\" _v-65456900=\"\"></span> </template> <span class=catalog-qa-date style=\"margin-right: 0\" v-if=\"c.qer || c.time\" _v-65456900=\"\">(</span> <span class=catalog-qa-date v-if=c.qer _v-65456900=\"\">{{ c.qer | formatPhone }}:</span> <span class=catalog-qa-date v-if=c.time style=\"margin-right: 0\" _v-65456900=\"\">{{ c.time | timeFilter }}</span> <span class=catalog-qa-date v-if=\"c.qer || c.time\" _v-65456900=\"\">)</span> <div class=catalog-q-cont style=\"margin-right: 6px\" _v-65456900=\"\"> <span class=catalog-qa-blue style=\"display: inline-block\" _v-65456900=\"\"> {{ c.que }} </span> <template v-for=\"t in c.tag\"> <span class=catalog-q-tag v-if=\"t !== ''\" _v-65456900=\"\"> {{ t }} </span> </template> </div> </td> </tr> <tr v-for=\"d in c.answers\" style=\"display: block\" _v-65456900=\"\"> <template v-if=\"detail.datasrc === 'IRM' &amp;&amp; d.ans !== ''\"> <td v-if=\"detail.datasrc === 'IRM'\" style=\"width: 1.68rem; text-align: right; color: #0D65D8\" _v-65456900=\"\"></td> </template> <template v-if=\"detail.datasrc !== 'IRM'\"> <td style=\"width: 31px\" _v-65456900=\"\"> <span class=\"catalog-icon cata-qa-a\" _v-65456900=\"\"></span> </td> </template> <td v-if=\"d.ans !== ''\" id={{c.code}}-{{$index+1}} _v-65456900=\"\"> <template v-if=\"detail.datasrc === 'IRM'\"> <span class=\"catalog-icon cata-qa-a\" style=\"margin: 0.18rem 5px 2px 0px\" _v-65456900=\"\"></span> </template> <span class=catalog-qa-date style=\"margin-right: 0\" v-if=\"d.time || $.trim(d.rername) !== ''\" _v-65456900=\"\">(</span> <span class=catalog-qa-date v-if=\"d.rername &amp;&amp; d.rername !== ' '\" _v-65456900=\"\">{{d.rername | formatPhone}}:</span> <span class=catalog-qa-date v-if=d.time style=\"margin-right: 0px\" _v-65456900=\"\">{{d.time | timeFilter}}</span> <span class=catalog-qa-date v-if=\"d.time || $.trim(d.rername) !== ''\" _v-65456900=\"\">)</span> <div class=catalog-q-cont style=\"display: inline-block; margin-right: 6px\" _v-65456900=\"\"> <span v-for=\"content in d.ans.split('\\n')\" _v-65456900=\"\"> <span _v-65456900=\"\">{{content}}</span> <br style=\"content: '';margin: 12px 0\" _v-65456900=\"\"> </span> </div> </td> </tr> </tbody> </table> </template> </div> </div> <div class=my-container v-show=showComments _v-65456900=\"\"> <div class=comment-detail _v-65456900=\"\"> <div class=comment-title _v-65456900=\"\"> <p class=comment-all _v-65456900=\"\">全部评论</p> <p class=comment-sort _v-65456900=\"\">{{cpwtotal}}条评论</p> </div> <div class=comment v-for=\"item in commentList\" _v-65456900=\"\"> <div class=common-avatar _v-65456900=\"\"> <img src=/static/images/user.png width=100% height=100% _v-65456900=\"\"> </div> <div class=comment-block _v-65456900=\"\"> <p class=comment-user _v-65456900=\"\"> <span class=comment-username v-if=item.user _v-65456900=\"\"> {{item.user.username}} </span> <span class=comment-username v-else=\"\" _v-65456900=\"\"> 匿名用户 </span> <span class=footer-zan _v-65456900=\"\"> <i class=c-share-icon @click.stop=\"zan(item.id, $event)\" _v-65456900=\"\"></i><span class=u-num _v-65456900=\"\">{{item.zan_cnt}}</span></span> </p> <div class=comment-content _v-65456900=\"\">{{item.content}} </div> <div class=comment-operate _v-65456900=\"\"> <span class=\"J_Vote comment-operate-item comment-operate-up\" _v-65456900=\"\">{{item.updtime | date}}</span> <span class=\"J_Reply comment-operate-item\" _v-65456900=\"\"> <a href=javascript:; @click=\"commentinput = true, pid = item.id, content = ''\" _v-65456900=\"\">回复</a> </span> </div> <div class=\"comment-reply-ctn comment-reply-item\" _v-65456900=\"\"> <ul _v-65456900=\"\"> <li v-for=\"i in item.replys\" track-by=$index v-if=\"$index < item.showall\" _v-65456900=\"\"> <p class=comment-text _v-65456900=\"\"> <span class=c-username v-if=i.user _v-65456900=\"\"> {{i.user.username}} </span> <span class=c-username v-else=\"\" _v-65456900=\"\">匿名用户</span> {{i.content}} </p> <div class=\"reply-operate reply-operate-hot\" _v-65456900=\"\"> <span class=\"J_Vote reply-operate-item reply-up\" _v-65456900=\"\"><i class=c-share-icon @click.stop=\"zan(i.id, $event)\" _v-65456900=\"\"></i><span _v-65456900=\"\">{{i.zan_cnt}}</span></span> <span class=\"J_Reply reply-operate-item\" _v-65456900=\"\"></span> <span _v-65456900=\"\">{{i.updtime | date}}</span> </div> </li> <li class=\"view-more hidden\" v-if=\"item.replys.length > 2 &amp;&amp; item.showall !== 8\" _v-65456900=\"\"> <a class=\"btn-block text-center btn-comment-expand\" @click=\"item.showall = 8\" _v-65456900=\"\">查看全部<span class=nume _v-65456900=\"\">{{item.replys.length}}</span>条回复 </a> </li> </ul> </div> </div> </div> </div> <div class=comment-more _v-65456900=\"\"> <a href=javascript:; v-if=\"commentList.length !== cpwtotal\" _v-65456900=\"\">加载更多评论中...</a> <a href=javascript:; v-if=\"commentList.length == cpwtotal &amp;&amp; cpwtotal !== 0\" _v-65456900=\"\">评论已全部加载</a> </div> <div class=comment-no v-if=\"cpwtotal == 0\" _v-65456900=\"\"> 暂无评论，快来添加一个吧！ </div> <div class=comment-no _v-65456900=\"\"></div> </div> <div class=footer-comment _v-65456900=\"\"> <span class=footer-text _v-65456900=\"\"><a href=javascript:; @click=\"commentinput = true, content= '',pid = 0\" _v-65456900=\"\"><i class=comment-icon _v-65456900=\"\"></i>评论一下</a></span> <span class=footer-zan v-show=!showComments _v-65456900=\"\"> <a href=javascript:; @click=\"showComments = true,loadcomment()\" _v-65456900=\"\"><span class=qinp _v-65456900=\"\"><i _v-65456900=\"\"></i>{{cpwtotal}}</span></a> </span> <span class=footer-zan v-show=showComments _v-65456900=\"\"> <a href=javascript:; @click=\"showComments = false\" _v-65456900=\"\"><span class=text _v-65456900=\"\"><i _v-65456900=\"\"></i>返回原文</span></a> </span> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-show=commentinput @click.self=\"commentinput = false\" _v-65456900=\"\"> <div class=comment-content _v-65456900=\"\"> <div class=comment-content-tag _v-65456900=\"\"> <div class=login-close _v-65456900=\"\"> <a class=delete-icon href=javascript:; @click=\"commentinput = false\" _v-65456900=\"\"></a> </div> <div class=comment-reply _v-65456900=\"\"> <textarea cols=\"\" rows=2 class=input-a placeholder=输入发表内容 v-model=content _v-65456900=\"\"></textarea> <span class=anonymous @click=\"anonym == 1 ? anonym = 0:anonym = 1\" _v-65456900=\"\"> <label class=\"el-checkbox mar\" _v-65456900=\"\"> <span class=el-checkbox-input :class=\"{'is-checked':anonym === 1}\" _v-65456900=\"\"><span class=el-checkbox-inner _v-65456900=\"\"></span> </span> <span class=el-checkbox-label _v-65456900=\"\">匿名评论</span> </label> </span> <a class=btn-Publish href=javascript:; @click=\"commentinput = false,addComment(1, md5, params.stype, detail.publishDate)\" _v-65456900=\"\">发表</a> </div> </div> </div> </div> <div v-if=commentinput class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div _v-65456900=\"\"></div> <div v-if=commentinput class=\"modal-backdrop fade in\" _v-65456900=\"\"></div> <div class=footer-app _v-65456900=\"\"> <a class=footer-logo-ios _v-65456900=\"\"></a> <span class=footer-text _v-65456900=\"\">IBDATA<br _v-65456900=\"\">人工智能和大数据驱动的投研首选平台</span> <a class=footer-btn @click=downloadApp _v-65456900=\"\">下载应用</a> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-65456900=\"\"> <div class=binding-content _v-65456900=\"\"> <a class=binding-logo _v-65456900=\"\"></a> <div class=binding-text _v-65456900=\"\"> 立即绑定IBDATA账号<br _v-65456900=\"\">成为金融分析高手 </div> <div class=binding-bot _v-65456900=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-65456900=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-65456900=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-65456900=\"\"></div> </div>";

/***/ },
/* 794 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-65dd3aa2=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-65dd3aa2=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-65dd3aa2=\"\"> <div class=loading-img _v-65dd3aa2=\"\"></div> </div> </div> <div class=search-company-box _v-65dd3aa2=\"\"> <div class=pledge-box1 _v-65dd3aa2=\"\"> <div class=pledge-box1-top _v-65dd3aa2=\"\"> <div class=Quarterly-Report style=\"float: left\" _v-65dd3aa2=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-65dd3aa2=\"\"> {{ datetype_name }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-65dd3aa2=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-65dd3aa2=\"\"> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(1)\" _v-65dd3aa2=\"\">一个月</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(2)\" _v-65dd3aa2=\"\">一个季度</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(3)\" _v-65dd3aa2=\"\">半年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(4)\" _v-65dd3aa2=\"\">去年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(5)\" _v-65dd3aa2=\"\">今年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(6)\" _v-65dd3aa2=\"\">一年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(7)\" _v-65dd3aa2=\"\">两年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(8)\" _v-65dd3aa2=\"\">三年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(9)\" _v-65dd3aa2=\"\">五年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(10)\" _v-65dd3aa2=\"\">十年</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(98)\" _v-65dd3aa2=\"\">全部</a></li> <li _v-65dd3aa2=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(99)\" _v-65dd3aa2=\"\">自定义</a></li> </ul> </div> <a class=cop-search-bot href=javascript:; @click=largeexchangeFilter _v-65dd3aa2=\"\">查询</a> <div class=cop-date v-if=\"datetype == 99\" _v-65dd3aa2=\"\"> <p class=time _v-65dd3aa2=\"\"> <span class=l _v-65dd3aa2=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-65dd3aa2=\"\"></date-picker> </span> 至 <span class=r _v-65dd3aa2=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-65dd3aa2=\"\"></date-picker> </span> </p> </div> </div> <div class=pledge-box1 v-if=\"largeexchangeLists.length>0\" _v-65dd3aa2=\"\"> <div class=Single-list-main _v-65dd3aa2=\"\"> <ul class=Single-list-box v-for=\"h in largeexchangeLists\" track-by=$index _v-65dd3aa2=\"\"> <li _v-65dd3aa2=\"\"><p class=date _v-65dd3aa2=\"\">交易日期</p><p class=time _v-65dd3aa2=\"\">{{ h.transaction_date }}</p></li> <li _v-65dd3aa2=\"\"><p class=date _v-65dd3aa2=\"\">成交量(股) </p><p class=time _v-65dd3aa2=\"\">{{ h.volume | money }}</p></li> <li _v-65dd3aa2=\"\"><p class=date _v-65dd3aa2=\"\">成交额(元)</p><p class=time _v-65dd3aa2=\"\">{{ h.turnover | money }}</p></li> <li _v-65dd3aa2=\"\"><p class=date _v-65dd3aa2=\"\">买方营业部</p><p class=time _v-65dd3aa2=\"\">{{ h.buy_sales_department }}</p></li> <li _v-65dd3aa2=\"\"><p class=date _v-65dd3aa2=\"\">卖方营业部</p><p class=time _v-65dd3aa2=\"\">{{ h.sell_sales_department }}</p></li> </ul> </div> </div> <div class=cop-pledge-page v-if=\"largeexchangeLists.length > 0\" _v-65dd3aa2=\"\"> <template v-if=\"page > 1\"> <span class=Previous-page @click=\"page--, getLargeexChangeLists()\" _v-65dd3aa2=\"\">上一页</span> </template> <span class=menu-page _v-65dd3aa2=\"\"><span style=\"color: #3270ad\" _v-65dd3aa2=\"\">{{ page }}</span>/{{ totalPage }} </span> <template v-if=\"page < totalPage\"> <span class=lower-page @click=\"page++, getLargeexChangeLists()\" _v-65dd3aa2=\"\">下一页</span> </template> </div> <div class=Single-list-main v-if=\"!largeexchangeLists.length>0 &amp;&amp; !loading\" _v-65dd3aa2=\"\"> <div class=Block-trade-no _v-65dd3aa2=\"\">暂无数据</div> </div> <div v-if=\"largeexchangeLists.length > 0\" _v-65dd3aa2=\"\"> <h3 class=title _v-65dd3aa2=\"\">大宗交易趋势图</h3> <div class=cop-chart _v-65dd3aa2=\"\"> <div class=relation-chart id=dzjy-chart-wrap _v-65dd3aa2=\"\"> <div id=dzjy-chart style=\"width:100%; height:200px\" _v-65dd3aa2=\"\"></div> </div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-65dd3aa2=\"\"> <div class=binding-content _v-65dd3aa2=\"\"> <a class=binding-logo _v-65dd3aa2=\"\"></a> <div class=binding-text _v-65dd3aa2=\"\"> 立即绑定IBDATA账号<br _v-65dd3aa2=\"\">成为金融分析高手 </div> <div class=binding-bot _v-65dd3aa2=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-65dd3aa2=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-65dd3aa2=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-65dd3aa2=\"\"></div>";

/***/ },
/* 795 */
/***/ function(module, exports) {

	module.exports = "<div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" :style=\"{display: showflag?'block':'none'}\" _v-6a9c1537=\"\"> <div class=delete-content _v-6a9c1537=\"\"> <div class=right _v-6a9c1537=\"\"> <a title=关闭 href=javascript:; _v-6a9c1537=\"\"> <button type=button class=\"dle dle-btn font16\" @click=close() _v-6a9c1537=\"\"> <span class=remove-icon-box _v-6a9c1537=\"\"></span> </button> </a> </div> <div class=delt-cont _v-6a9c1537=\"\"> <div class=dn _v-6a9c1537=\"\"> <span class=\"img left\" _v-6a9c1537=\"\"><img src=/static/images/logo-s.png alt=user _v-6a9c1537=\"\"></span> <div class=delt-bot _v-6a9c1537=\"\"> <span class=t _v-6a9c1537=\"\"> {{ message }} </span> <button type=button class=\"btn btn-del right30\" @click=close() _v-6a9c1537=\"\">确 定</button> </div> </div> </div> </div> </div> <div class=\"modal-backdrop fade in\" :style=\"{display: showflag?'block':'none'}\" _v-6a9c1537=\"\"></div>";

/***/ },
/* 796 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-6c61b532=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-6c61b532=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-6c61b532=\"\"> <div class=loading-img _v-6c61b532=\"\"></div> </div> </div> <div class=search-company-box _v-6c61b532=\"\"> <div class=pledge-box1-top _v-6c61b532=\"\"> <label class=el-radio _v-6c61b532=\"\"> <span class=\"el-radio-input is-checked\" :class=\"{'is-checked': reporting}\" @click=\"reporting=true, curDateType = finance[0][0]\" _v-6c61b532=\"\"> <span class=el-radio-inner _v-6c61b532=\"\"></span> <input class=el-radio-original value=按报告期 type=radio _v-6c61b532=\"\"> </span> <span class=el-radio-label _v-6c61b532=\"\">按报告期</span> </label> <label class=el-radio _v-6c61b532=\"\"> <span class=el-radio-input :class=\"{'is-checked': !reporting}\" @click=\"reporting=false, curDateType = yearList[0][0]\" _v-6c61b532=\"\"> <span class=el-radio-inner _v-6c61b532=\"\"></span> <input class=el-radio-original value=按年度 type=radio _v-6c61b532=\"\"> </span> <span class=el-radio-label _v-6c61b532=\"\">按年度</span> </label> <div class=Quarterly-Report _v-6c61b532=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-6c61b532=\"\"> {{ curDateType }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-6c61b532=\"\"></span> </div> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; reporting\" _v-6c61b532=\"\"> <li v-for=\"h in finance\" _v-6c61b532=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-6c61b532=\"\">{{ h[0] }}</a> </li> </ul> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; !reporting\" _v-6c61b532=\"\"> <li v-for=\"h in yearList\" _v-6c61b532=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-6c61b532=\"\">{{ h[0] }}</a> </li> </ul> </div> </div> <div class=Single-list-main v-if=reporting _v-6c61b532=\"\"> <ul class=Single-list-box _v-6c61b532=\"\"> <li v-for=\"(key, val) in fzb\" track-by=$index _v-6c61b532=\"\"> <p class=date _v-6c61b532=\"\">{{ key }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-6c61b532=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> <div class=Single-list-main v-if=!reporting _v-6c61b532=\"\"> <ul class=Single-list-box _v-6c61b532=\"\"> <li v-for=\"(key, val) in fzb\" track-by=$index _v-6c61b532=\"\"> <p class=date _v-6c61b532=\"\">{{ key }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-6c61b532=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-6c61b532=\"\"> <div class=binding-content _v-6c61b532=\"\"> <a class=binding-logo _v-6c61b532=\"\"></a> <div class=binding-text _v-6c61b532=\"\"> 立即绑定IBDATA账号<br _v-6c61b532=\"\">成为金融分析高手 </div> <div class=binding-bot _v-6c61b532=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-6c61b532=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-6c61b532=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-6c61b532=\"\"></div>";

/***/ },
/* 797 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-6da39bc1=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-6da39bc1=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-6da39bc1=\"\"> <div class=loading-img _v-6da39bc1=\"\"></div> </div> </div> <div class=search-company-box _v-6da39bc1=\"\"> <div class=pledge-box1 _v-6da39bc1=\"\"> <div class=pledge-box1-top _v-6da39bc1=\"\"> <div class=Quarterly-Report style=\"float: left\" v-if=\"allDateTyp.length > 0\" _v-6da39bc1=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-6da39bc1=\"\"> <template v-if=\"curDateTyp == 'ALL'\">全部</template> <template v-if=\"curDateTyp != 'ALL'\">{{ curDateTyp }}</template> <span class=close-bot @click.stop=showDateDropmemu($event) _v-6da39bc1=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-6da39bc1=\"\"> <li v-for=\"h in allDateTyp\" _v-6da39bc1=\"\"> <a href=javascript:; v-if=\"curDateTyp != h\" @click=\"clickDropmenu(), curDateTyp = h, filter()\" _v-6da39bc1=\"\">{{ h }}</a> </li> </ul> </div> </div> <div class=pledge-box1 v-if=\"locationList.length > 0\" _v-6da39bc1=\"\"> <template v-if=showYysr> <div class=pledge-box1-top _v-6da39bc1=\"\"> <h3 _v-6da39bc1=\"\">营业收入(元)</h3> </div> <div class=Single-list-main _v-6da39bc1=\"\"> <ul class=Single-list-box _v-6da39bc1=\"\"> <template v-for=\"h in locationList\" track-by=$index> <li v-if=h.yysr _v-6da39bc1=\"\"> <p class=date _v-6da39bc1=\"\">{{ h.name }}</p> <p class=time _v-6da39bc1=\"\">{{ h.yysr | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYycb> <div class=pledge-box1-top _v-6da39bc1=\"\"> <h3 _v-6da39bc1=\"\">营业成本(元)</h3> </div> <div class=Single-list-main _v-6da39bc1=\"\"> <ul class=Single-list-box _v-6da39bc1=\"\"> <template v-for=\"h in locationList\" track-by=$index> <li v-if=h.yycb _v-6da39bc1=\"\"> <p class=date _v-6da39bc1=\"\">{{ h.name }}</p> <p class=time _v-6da39bc1=\"\">{{ h.yycb | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYylr> <div class=pledge-box1-top _v-6da39bc1=\"\"> <h3 _v-6da39bc1=\"\">营业利润(元)</h3> </div> <div class=Single-list-main _v-6da39bc1=\"\"> <ul class=Single-list-box _v-6da39bc1=\"\"> <template v-for=\"h in locationList\" track-by=$index> <li v-if=h.yylr _v-6da39bc1=\"\"> <p class=date _v-6da39bc1=\"\">{{ h.name }}</p> <p class=time _v-6da39bc1=\"\">{{ h.yylr | money }}</p> </li> </template> </ul> </div> </template> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-6da39bc1=\"\"> <div class=binding-content _v-6da39bc1=\"\"> <a class=binding-logo _v-6da39bc1=\"\"></a> <div class=binding-text _v-6da39bc1=\"\"> 立即绑定IBDATA账号<br _v-6da39bc1=\"\">成为金融分析高手 </div> <div class=binding-bot _v-6da39bc1=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-6da39bc1=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-6da39bc1=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-6da39bc1=\"\"></div>";

/***/ },
/* 798 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-6e80e4e6=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-6e80e4e6=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-6e80e4e6=\"\"> <div class=loading-img _v-6e80e4e6=\"\"></div> </div> </div> <div class=search-company-box _v-6e80e4e6=\"\"> <div class=pledge-box1-top v-if=\"holders.length > 0\" _v-6e80e4e6=\"\"> <h3 _v-6e80e4e6=\"\">{{ holders[0].date }}</h3> </div> <div class=Single-list-main v-if=\"holders.length > 0\" _v-6e80e4e6=\"\"> <ul class=Single-list-box v-for=\"item in holders\" _v-6e80e4e6=\"\"> <li class=list-w _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">机构或基金名称</p> <p class=time _v-6e80e4e6=\"\">{{ item.name }}</p> </li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">持有数量</p> <p class=time _v-6e80e4e6=\"\">{{ item.quantity | money }}</p> </li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">持股变化</p> <p class=time _v-6e80e4e6=\"\">{{ item.quantity | money }}</p> </li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">占流通股比例(%)</p> <p class=time _v-6e80e4e6=\"\">{{ parseFloat(item.ratio) }}</p> </li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">实际增减持(%)</p> <p class=time _v-6e80e4e6=\"\">{{item.changeqty / item.quantity * 100 | two | kong}}<template v-if=\"item.quantity &amp;&amp; item.changeqty\">%</template></p> </li> </ul> </div> <div class=pledge-box1 _v-6e80e4e6=\"\"> <div class=product-head _v-6e80e4e6=\"\"> <span class=text _v-6e80e4e6=\"\">公司股东历史</span> <div class=Quarterly-Report v-if=history.dataTypes.length _v-6e80e4e6=\"\"> <div class=head-title @click=showDropdown _v-6e80e4e6=\"\"> <template v-if=\"history.dateTyp == ''\">全 部</template> <template v-else=\"\">{{ history.dateTyp }}</template> <span class=close-bot _v-6e80e4e6=\"\"></span> </div> <ul class=menu-lanmu :style=\"{'display': dropdownMenu ? 'block' : 'none'}\" _v-6e80e4e6=\"\"> <li v-if=\"history.dateTyp != ''\" @click=filterHistory(h) _v-6e80e4e6=\"\"> <a href=javascript:: _v-6e80e4e6=\"\">全 部</a> </li> <template v-for=\"h in history.dateTypes\" track-by=$index> <li v-if=\"history.dateTyp != h.datestr\" @click=filterHistory(h) _v-6e80e4e6=\"\"> <a href=javascript:: _v-6e80e4e6=\"\">{{ h.datestr }}</a> </li> </template> </ul> </div> </div> <div class=Single-list-main v-if=history.lists.length _v-6e80e4e6=\"\"> <ul class=Single-list-box v-for=\"(index, h) in history.lists\" track-by=$index v-show=\"index >= ((history.page-1)*10) &amp;&amp; index < (history.page*10)\" _v-6e80e4e6=\"\"> <li class=list-w _v-6e80e4e6=\"\"><p class=date _v-6e80e4e6=\"\">机构或基金名称</p><p class=time _v-6e80e4e6=\"\">{{ h.name }}</p></li> <li _v-6e80e4e6=\"\"><p class=date _v-6e80e4e6=\"\">持有数量</p><p class=time _v-6e80e4e6=\"\">{{ h.quantity | money }}</p></li> <li _v-6e80e4e6=\"\"><p class=date _v-6e80e4e6=\"\">持股变化</p><p class=time _v-6e80e4e6=\"\">{{h.changeqty | money | nullVal}}</p></li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">占流通股比例(%)</p> <p class=time _v-6e80e4e6=\"\">{{parseFloat(h.ratio)}}</p> </li> <li _v-6e80e4e6=\"\"> <p class=date _v-6e80e4e6=\"\">实际增减持(%)</p> <p class=time _v-6e80e4e6=\"\"> {{h.changeqty / h.quantity * 100 | two | kong}} <template v-if=\"h.quantity &amp;&amp; h.changeqty\">%</template> </p> </li> <li _v-6e80e4e6=\"\"><p class=date _v-6e80e4e6=\"\">公告日期</p><p class=time _v-6e80e4e6=\"\">{{ h.date }}</p></li> </ul> </div> <div class=cop-pledge-page v-if=history.lists.length _v-6e80e4e6=\"\"> <span class=Previous-page v-if=\"history.page > 1\" @click=history.page-- _v-6e80e4e6=\"\">上一页</span> <span class=menu-page _v-6e80e4e6=\"\"><span style=\"color: #3270ad\" _v-6e80e4e6=\"\">{{ history.page }}</span>/{{ history.totalPage }} </span> <span class=lower-page v-if=\"history.page < history.totalPage\" @click=history.page++ _v-6e80e4e6=\"\">下一页</span> </div> <div class=Single-list-main v-if=\"!history.lists.length &amp;&amp; !loading\" _v-6e80e4e6=\"\"> <div class=Block-trade-no _v-6e80e4e6=\"\">暂无数据</div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-6e80e4e6=\"\"> <div class=binding-content _v-6e80e4e6=\"\"> <a class=binding-logo _v-6e80e4e6=\"\"></a> <div class=binding-text _v-6e80e4e6=\"\"> 立即绑定IBDATA账号<br _v-6e80e4e6=\"\">成为金融分析高手 </div> <div class=binding-bot _v-6e80e4e6=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-6e80e4e6=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-6e80e4e6=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-6e80e4e6=\"\"></div>";

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = "<div _v-9d36f8a4=\"\"> <div class=wrap id=wrap @click=\"hideDropdown($event), hideKeywordDropdown()\" _v-9d36f8a4=\"\"> <div class=loading_gif v-show=loading style=\"position: fixed; max-width:640px\" _v-9d36f8a4=\"\"> <img src=" + __webpack_require__(104) + " class=loading-img _v-9d36f8a4=\"\"> <p style=\"font-size:14px; color: #FFFFFF\" _v-9d36f8a4=\"\">数据加载中,请稍等...</p> </div> <div class=wrapper v-show=\"currentuser &amp;&amp; !smartEngine.open\" _v-9d36f8a4=\"\"> <div class=stat-analyze v-show=\"!showResultPage &amp;&amp; !showSearchPage &amp;&amp; showTongjiPage\" _v-9d36f8a4=\"\"> <div class=search-header _v-9d36f8a4=\"\"> <div class=search-header-text @click=\"switchPage(2), setCnzz('[Mobile]-信披搜索', '从统计页返回搜索结果页', '')\" _v-9d36f8a4=\"\"> <span class=arrow-back _v-9d36f8a4=\"\"></span>统计 </div> </div> <div class=\"search-header-menu statis\" _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <li @click=\"showStatAnalyze = true, showStatFilter = false, setCnzz('[Mobile]-信披搜索', '点击分析按钮', '')\" :class=\"{on: showStatAnalyze}\" _v-9d36f8a4=\"\">分析</li> <li @click=\"showStatAnalyze = false, showStatFilter = true, setCnzz('[Mobile]-信披搜索', '点击筛选按钮', '')\" :class=\"{on: showStatFilter}\" _v-9d36f8a4=\"\">筛选</li> </ul> </div> <div class=Analysis-list v-show=showStatAnalyze _v-9d36f8a4=\"\"> <div class=Analysis-list-box v-if=currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">相关的公司</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in company\" _v-9d36f8a4=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">提到的公司</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in related_company\" _v-9d36f8a4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">相关人员</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in related_name\" _v-9d36f8a4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">相关的公司</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in company\" _v-9d36f8a4=\"\"> {{ item.key }} </li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">提到的公司</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in related_company\" _v-9d36f8a4=\"\">{{ item.key }}</li> </ul> </div> <div class=Analysis-list-box v-if=!currentuser _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">相关人员</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in related_name\" _v-9d36f8a4=\"\">{{ item.key }}</li> </ul> </div> </div> <div class=Analysis-list v-show=\"showStatFilter &amp;&amp; searched===stype\" _v-9d36f8a4=\"\"> <div class=Analysis-list-box v-show=\"aggLabels.length>0\" _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">公告标签</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"d in aggLabels\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-9d36f8a4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['labels'][d.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('labels', d)\" _v-9d36f8a4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-9d36f8a4=\"\"> </span> <span class=el-checkbox-label @click.stop=\"addConditionNew('labels', d)\" _v-9d36f8a4=\"\">{{d.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-9d36f8a4=\"\">{{d.count}}</span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggTypes.length>0\" _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">公告类型</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"type in aggTypes\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-9d36f8a4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['type'][type.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('type', type)\" _v-9d36f8a4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-9d36f8a4=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('type', type)\" _v-9d36f8a4=\"\">{{type.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-9d36f8a4=\"\"> {{type.count}} </span> </li> </ul> </div> <div class=Analysis-list-box v-show=\"aggPlates.length>0\" _v-9d36f8a4=\"\"> <span class=head _v-9d36f8a4=\"\">板块类型</span> <ul _v-9d36f8a4=\"\"> <li v-for=\"plate in aggPlates\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox mar\" style=\"width: 75%\" _v-9d36f8a4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': conditions['plate'][plate.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner @click.stop=\"addConditionNew('plate', plate)\" _v-9d36f8a4=\"\"></span> <input name=type class=el-checkbox-original value=全选 type=checkbox _v-9d36f8a4=\"\"></span> <span class=el-checkbox-label @click.stop=\"addConditionNew('plate', plate)\" _v-9d36f8a4=\"\">{{plate.name | maxlen 8}}</span> </label> <span class=\"notice-right blue\" style=\"float: right\" _v-9d36f8a4=\"\"> {{plate.count}} </span> </li> </ul> </div> </div> </div> <div class=search-conditions style=\"padding-bottom: 1.8rem\" v-show=\"!showResultPage &amp;&amp; showSearchPage &amp;&amp; !showTongjiPage\" _v-9d36f8a4=\"\"> <div class=search-header _v-9d36f8a4=\"\"> <div class=search-header-text @click.stop=\"switchPage(2), setCnzz('[Mobile]-信披搜索', '从搜索条件页返回搜索结果页', '')\" _v-9d36f8a4=\"\"> <span class=arrow-back _v-9d36f8a4=\"\"></span>搜索条件 </div> <span class=search-header-stics @click=\"showModalTag = true\" _v-9d36f8a4=\"\">保存标签</span> </div> <div class=\"search-header-menu search-tab-scroll\" _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <li :class=\"{activeTyp: stype == 100 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(100), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">综合</a> </li> <li :class=\"{activeTyp: stype == 1 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(1), setCnzz('[Mobile]-信披搜索', '点击A股按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">A股</a> </li> <li :class=\"{activeTyp: stype == 2 }\" style=margin-top:-2px;width:9% _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(2), setCnzz('[Mobile]-信披搜索', '点击新三板按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">新三板</a> </li> <li :class=\"{activeTyp: stype == 3 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(3), setCnzz('[Mobile]-信披搜索', '点击债券按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">债券</a> </li> <li :class=\"{activeTyp: stype == 4 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(4), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">知识库</a> </li> <li :class=\"{activeTyp: stype == 5 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(5), setCnzz('[Mobile]-信披搜索', '点击问题库按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">问题库</a> </li> <li :class=\"{activeTyp: stype == 6 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(6), setCnzz('[Mobile]-信披搜索', '点击港股按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">港股</a> </li> <li :class=\"{activeTyp: stype == 10 }\" _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(10), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">ABS</a> </li> <li :class=\"{activeTyp: stype == 11 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(11), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">研报</a> </li> <li :class=\"{activeTyp: stype == 12 }\" style=margin-top:-2px _v-9d36f8a4=\"\"> <a href=javascript:; v-on:click=\"changeStype(12), setCnzz('[Mobile]-信披搜索', '点击研报按钮', '')\" style=\"color: #fff\" _v-9d36f8a4=\"\">新闻</a> </li> </ul> </div> <div class=search-input-share _v-9d36f8a4=\"\"> <div class=\"fl search-type\" _v-9d36f8a4=\"\"> <div class=\"search-input btn-group\" _v-9d36f8a4=\"\"> <div @click.stop=slideDropdown2($event) _v-9d36f8a4=\"\"> {{ ttype_name }} <span class=close-bot _v-9d36f8a4=\"\"></span> </div> <ul class=\"date-menu close\" _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"ttype!=0\" @click=\"ttype=0\" _v-9d36f8a4=\"\">全部</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"ttype!=1\" @click=\"ttype=1\" _v-9d36f8a4=\"\">标题</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"ttype!=2 &amp;&amp; showSubTitle\" @click=\"ttype=2\" _v-9d36f8a4=\"\">章节标题</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"ttype!=3\" @click=\"ttype=3\" _v-9d36f8a4=\"\">正文</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"stype == 5 &amp;&amp; ttype!=4\" @click=\"ttype=4\" _v-9d36f8a4=\"\">问题</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"stype == 5 &amp;&amp; ttype!=5\" @click=\"ttype=5\" _v-9d36f8a4=\"\">答案</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; v-show=\"stype == 11 &amp;&amp; ttype!=6\" @click=\"ttype=6\" _v-9d36f8a4=\"\">图片</a></li> </ul> </div> <input class=input-search-a autofocus=autofocus type=text placeholder=\"\" value=\"\" v-model=keywords _v-9d36f8a4=\"\"> </div> <div class=fr _v-9d36f8a4=\"\"><a class=search-bot @click=\"mySearch(), setCnzz('[Mobile]-信披搜索', '点击搜索按钮', '')\" _v-9d36f8a4=\"\"></a></div> </div> <div class=search-input-engine _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" _v-9d36f8a4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked': ai === 1}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner @click.stop=\"smartBtn(), setCnzz('[Mobile]-信披搜索', '点击智能引擎按钮', '')\" _v-9d36f8a4=\"\"></span> <input type=checkbox name=type class=el-checkbox-original _v-9d36f8a4=\"\"> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">智能引擎</span> </label> </div> <div class=Key-word _v-9d36f8a4=\"\"> <h3 class=\"\" _v-9d36f8a4=\"\">关键词</h3> <ul _v-9d36f8a4=\"\"> <li v-for=\"ky in keywords_condition\" track-by=$index _v-9d36f8a4=\"\"> <div class=Key-word-box _v-9d36f8a4=\"\"> <div class=screen-menu _v-9d36f8a4=\"\"> <div class=\"release-date btn-group\" _v-9d36f8a4=\"\"> <div @click.stop=slideDropdown2($event) _v-9d36f8a4=\"\"> {{ ky.ttname }} <span class=close-bot _v-9d36f8a4=\"\"></span> </div> <ul class=\"date-menu close\" style=\"left: -0.5rem; width: 7rem\" _v-9d36f8a4=\"\"> <li v-show=\"ky.ttype!=0\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 0, '全部')\" _v-9d36f8a4=\"\">全部</a></li> <li v-show=\"ky.ttype!=1\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 1, '标题')\" _v-9d36f8a4=\"\">标题</a></li> <li v-show=\"ky.ttype!=2 &amp;&amp; showSubTitle\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 2, '章节标题')\" _v-9d36f8a4=\"\">章节标题</a></li> <li v-show=\"ky.ttype!=3\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 3, '正文')\" _v-9d36f8a4=\"\">正文</a></li> <li v-show=\"stype == 5 &amp;&amp; ky.ttype!=4\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 4, '问题')\" _v-9d36f8a4=\"\">问题</a></li> <li v-show=\"stype == 5 &amp;&amp; ky.ttype!=5\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyTtype(ky, 5, '答案')\" _v-9d36f8a4=\"\">答案</a></li> </ul> </div> <span class=release-line _v-9d36f8a4=\"\"></span> <div class=\"release-date btn-group\" _v-9d36f8a4=\"\"> <div @click.stop=slideDropdown2($event) _v-9d36f8a4=\"\"> {{ ky.opname }} <span class=close-bot _v-9d36f8a4=\"\"></span> </div> <ul class=\"date-menu close\" style=\"left: -0.4rem; width: 7rem\" _v-9d36f8a4=\"\"> <li v-show=\"ky.optype!=1\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 1, '包含全部关键词')\" _v-9d36f8a4=\"\">包含全部关键词</a></li> <li v-show=\"ky.optype!=2\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 2, '包含任意关键词')\" _v-9d36f8a4=\"\">包含任意关键词</a></li> <li v-show=\"ky.optype!=3\" _v-9d36f8a4=\"\"><a href=javascript:; @click=\"changeKyOp(ky, 3, '不含全部关键词')\" _v-9d36f8a4=\"\">不含全部关键词</a></li> </ul> </div> </div> <span class=text-box style=\"width: 94%; margin-left: 8px\" _v-9d36f8a4=\"\"> <input autocomplete=off maxlength=255 v-model=\"ky['val']\" placeholder=多个词以空格隔开 class=input-search-b name=wd id=kw _v-9d36f8a4=\"\"> </span> <div class=text-btn _v-9d36f8a4=\"\"> <a href=javascript:; class=btn-add @click=\"addKeywordCondition(), setCnzz('[Mobile]-信披搜索', '点击添加关键词按钮', '')\" v-if=\"$index === 0\" _v-9d36f8a4=\"\">添加</a> <a href=javascript:; class=btn-delete @click=\"rmvKeywordCondition($index), setCnzz('[Mobile]-信披搜索', '点击删除关键词按钮', '')\" v-if=\"$index > 0\" _v-9d36f8a4=\"\">删除</a> </div> </div> </li> </ul> </div> <div class=Announ-list _v-9d36f8a4=\"\"> <h3 class=\"\" _v-9d36f8a4=\"\">公告信息</h3> <div class=Announ-list-box _v-9d36f8a4=\"\"> <span class=text-box _v-9d36f8a4=\"\"> <input type=text class=input-search-b placeholder={{pholder}} v-model=companyCode @keyup=\"suggest(companyCode, $event)\" style=\"border: none;width: 100%\" _v-9d36f8a4=\"\"> <ul class=company-menu v-if=\"suggestions.length > 0\" tabindex=-1 _v-9d36f8a4=\"\"> <li v-for=\"i in suggestions\" @click=\"companyCode = i[0], oldsuggestValue = i[0], queue = [], suggestNum = -1, suggestions = []\" tabindex=-1 _v-9d36f8a4=\"\"> <span class=left _v-9d36f8a4=\"\">{{i[2]}}</span><span class=right _v-9d36f8a4=\"\">{{i[0]}}</span> </li> </ul> </span> <div @click=alertDateModal _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\">发布日期</p> <p class=time _v-9d36f8a4=\"\"> <span class=l _v-9d36f8a4=\"\">{{startdate}}</span> 至 <span class=r _v-9d36f8a4=\"\">{{enddate}}</span> </p> </div> </div> </div> <div v-show=showDateModal _v-9d36f8a4=\"\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=Release-date id=Release-date _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 发布日期 </p> <div class=\"home-nav-app btn-group\" _v-9d36f8a4=\"\"> <div @click.stop=\"slideDropdown('post_time')\" _v-9d36f8a4=\"\"> <span class=select-name _v-9d36f8a4=\"\">{{ datetype_name }}</span> <span class=arrow-img _v-9d36f8a4=\"\"> <img src=" + __webpack_require__(340) + " alt=\"\" v-show=\"showDropdownMenu !== ''\" _v-9d36f8a4=\"\"> <img src=" + __webpack_require__(341) + " alt=\"\" v-show=\"showDropdownMenu == ''\" _v-9d36f8a4=\"\"> </span> </div> <ul class=\"lanmu slide-menu date-slide-menu\" v-show=\"showDropdownMenu == 'post_time'\" _v-9d36f8a4=\"\"> <li @click=changeDateType(1) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">一个月</a></li> <li @click=changeDateType(2) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">一个季度</a></li> <li @click=changeDateType(3) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">半年</a></li> <li @click=changeDateType(4) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">去年</a></li> <li @click=changeDateType(5) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">今年</a></li> <li @click=changeDateType(6) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">一年</a></li> <li @click=changeDateType(7) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">两年</a></li> <li @click=changeDateType(8) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">三年</a></li> <li @click=changeDateType(9) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">五年</a></li> <li @click=changeDateType(10) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">十年</a></li> <li @click=changeDateType(98) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">全部</a></li> <li @click=changeDateType(99) _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">自定义</a></li> </ul> </div> <p class=time _v-9d36f8a4=\"\"> <span class=l style=\"overflow: hidden\" _v-9d36f8a4=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-9d36f8a4=\"\"></date-picker> </span> 至 <span class=r style=\"overflow: hidden\" _v-9d36f8a4=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-9d36f8a4=\"\"></date-picker> </span> </p> <p class=btn-confim _v-9d36f8a4=\"\"> <a class=btn-cancel @click.stop=\"showDateModal = false, cancelDate()\" _v-9d36f8a4=\"\">取消</a> <a class=btn-Determine @click.stop=\"showDateModal = false, confirmDate()\" _v-9d36f8a4=\"\">确定</a> </p> </div> </div> <div class=\"modal-backdrop fade in\" @click.stop=\"showDateModal = false\" _v-9d36f8a4=\"\"></div> </div> <div class=Announ-list v-if=showTypAll _v-9d36f8a4=\"\"> <h3 class=\"\" _v-9d36f8a4=\"\">筛选条件</h3> <div class=Announ-list-box _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <template v-if=showType> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 公告类型 </p> <p class=time @click.stop=\"showCondition('type')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['type'])\" _v-9d36f8a4=\"\">全部</span> <span v-for=\"(code, name) in conditions['type']\" style=\"margin-right: 8px\" _v-9d36f8a4=\"\">{{name}}</span> </p> </li> </template> <template v-if=showQaType> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 问题类型 </p> <p class=time @click.stop=\"showCondition('qaType')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['qaType'])\" _v-9d36f8a4=\"\">全部</span> <span v-for=\"(code, name) in conditions['qaType']\" style=\"margin-right: 8px\" _v-9d36f8a4=\"\">{{name}}</span> </p> </li> </template> <template v-if=showPlate> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 板块类型 </p> <p class=time @click.stop=\"showCondition('plate')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['plate']) &amp;&amp; isEmptyObj(conditions['layer'])\" _v-9d36f8a4=\"\">全部</span> <template v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">挂牌公司</span> <span v-for=\"c in pageshowConditions['plate']['挂牌公司']\" style=\"margin-right: 8px\" _v-9d36f8a4=\"\">{{c}}</span> </template> <template v-if=\"pageshowConditions['plate']['N3BTS'] !== ''\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">两网及退市公司</span> </template> <template v-if=\"pageshowConditions['plate']['SHZB'] !== ''\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">上证主板</span> </template> <template v-if=\"pageshowConditions['plate']['SZCYB'] !== ''\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">创业板</span> </template> <template v-if=\"pageshowConditions['plate']['SZZB'] !== ''\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">深市主板</span> </template> <template v-if=\"pageshowConditions['plate']['SZZXB'] !== ''\"> <span style=\"margin-right: 8px\" _v-9d36f8a4=\"\">中小板</span> </template> </p> </li> </template> <template v-if=showRegion> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 地区类型 </p> <p class=time @click.stop=\"showCondition('region')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['region'])\" _v-9d36f8a4=\"\">全部</span> <span v-for=\"(code, name) in conditions['region']\" style=\"margin-right: 8px\" _v-9d36f8a4=\"\">{{name}}</span> </p> </li> </template> <template v-if=showSecurityCompany> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 主板券商 </p> <p class=time @click.stop=\"showCondition('securityCompany')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['securityCompany'])\" _v-9d36f8a4=\"\">全部</span> <span v-for=\"(code, name) in conditions['securityCompany']\" style=\"margin-right: 8px\" _v-9d36f8a4=\"\">{{name}}</span> </p> </li> </template> <template v-if=showIndustry> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 行业分类 </p> <p class=time @click.stop=\"showCondition('industry')\" _v-9d36f8a4=\"\"> <span v-if=\"isEmptyObj(conditions['industry']) &amp;&amp; isEmptyObj(conditions['industrysecond'])\" _v-9d36f8a4=\"\">全部</span> <template v-for=\"(type, obj) in pageshowConditions['industry']\"> <template v-if=\"obj.length > 0 || type == 'S综合'\"> <span class=text-b _v-9d36f8a4=\"\">{{type}}</span> <template v-for=\"item in obj\" v-if=\"obj.length !== industry\"> {{item}} </template> </template> </template> </p> </li> </template> </ul> </div> </div> <template v-if=\"showConditionFlag=='type'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">公告类型</span> <span class=menu-head-empty @click=\"this.conditions['type'] = {}, select_type = []\" _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_type', conditions['type'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box _v-9d36f8a4=\"\"> <li v-for=\"type in types\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('type', type)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['type'][type.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{type.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='qaType'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">问题类型</span> <span class=menu-head-empty @click=\"this.conditions['qaType'] = {}, select_qaType = []\" _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_qaType', conditions['qaType'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box _v-9d36f8a4=\"\"> <li v-for=\"type in qaTypes\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('qaType', type)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['qaType'][type.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{type.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='plate'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">板块类型</span> <span class=menu-head-empty @click=clearPlate _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_plate', conditions['plate'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box v-show=!showChildFlag.plate _v-9d36f8a4=\"\"> <li v-for=\"d in plates\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio v-if=d.child _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['plate'][d.code]}\" @click.stop=\"addCondition('plate', d)\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" @click.stop=\"addCondition('plate', d)\" _v-9d36f8a4=\"\"> {{d.name}} <template v-if=\"d.count > 0 &amp;&amp; !conditions['plate']['N3BGP']\" style=color:#3270ad> <span style=color:#1E88E5 v-if=\"conditions['plate'] !== {}\" _v-9d36f8a4=\"\">({{ d.count }})</span> </template> </span> <span class=\"qicon ques_5 mop close\" @click.stop=\"slideToggleFilter(d.code, $event)\" _v-9d36f8a4=\"\"></span> </label> <template v-if=d.child> <ul class=second id={{d.code}} style=\"display: none\" _v-9d36f8a4=\"\"> <li v-for=\"child in d.child\" _v-9d36f8a4=\"\"> <a href=javascript:; _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('layer', child, d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['layer'][child.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{child.name}}</span> </label> </a> </li> </ul> </template> </a> <a href=javascript:; class=dio v-else=\"\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('plate', d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['plate'][d.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='region'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">地区类型</span> <span class=menu-head-empty @click=\"this.conditions['region'] = {}, select_region = []\" _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_region', conditions['region'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box _v-9d36f8a4=\"\"> <li v-for=\"d in regions\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('region', d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['region'][d.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='securityCompany'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">主板类型</span> <span class=menu-head-empty @click=\"this.conditions['securityCompany'] = {}, select_securityCompany = []\" _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_securityCompany', conditions['securityCompany'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box _v-9d36f8a4=\"\"> <li v-for=\"d in securityCompany\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('securityCompany', d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['securityCompany'][d.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> <template v-if=\"showConditionFlag=='industry'\"> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" _v-9d36f8a4=\"\"> <div class=toolsbar _v-9d36f8a4=\"\"> <span class=cancle-btn @click=\"showConditionFlag = ''\" _v-9d36f8a4=\"\"></span> <span class=menu-options _v-9d36f8a4=\"\">行业分类</span> <span class=menu-head-empty @click=clearIndustry _v-9d36f8a4=\"\">清空</span> <span class=menu-head-Determine @click=\"showConditionFlag = '', setSelectCondition('select_industry', conditions['industry'])\" _v-9d36f8a4=\"\">确定</span> </div> <div class=menu-cont _v-9d36f8a4=\"\"> <ul class=one-row-box v-show=!showChildFlag.industry _v-9d36f8a4=\"\"> <li v-for=\"d in industry\" _v-9d36f8a4=\"\"> <a href=javascript:; class=dio v-if=\"d.child.length>0\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industry'][d.code]}\" @click.stop=\"addCondition('industry', d)\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" @click.stop=\"addCondition('industry', d)\" _v-9d36f8a4=\"\"> {{d.code}} {{d.name}} <template v-if=\"d.count > 0 &amp;&amp; !conditions['industry'][d.code]\"> <span style=color:#1E88E5 _v-9d36f8a4=\"\">({{d.count}})</span> </template> </span> <span class=\"qicon ques_5 mop close\" @click.stop=\"slideToggleFilter(d.id, $event)\" _v-9d36f8a4=\"\"></span> </label> <template v-if=\"d.child.length>0\"> <ul class=second id={{d.id}} style=\"display: none\" _v-9d36f8a4=\"\"> <li v-for=\"child in d.child\" _v-9d36f8a4=\"\"> <a href=javascript:; _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('industrysecond', child, d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industrysecond'][child.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{child.code}} {{child.name | maxlen 10}}</span> </label> </a> </li> </ul> </template> </a> <a href=javascript:; class=dio v-else=d.child _v-9d36f8a4=\"\"> <label class=\"el-checkbox el-mar\" @click.stop=\"addCondition('industry', d)\" _v-9d36f8a4=\"\"> <span class=\"el-checkbox-input el-top\" :class=\"{'is-checked': conditions['industry'][d.code]}\" _v-9d36f8a4=\"\"> <span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=\"el-checkbox-label el-text\" _v-9d36f8a4=\"\">{{d.code}} {{d.name}}</span> </label> </a> </li> </ul> </div> </div> </template> </div> <div class=my-container v-show=showComments style=\"top: 0px;position:static;background-color:white\" _v-9d36f8a4=\"\"> <div class=comment-detail _v-9d36f8a4=\"\"> <div class=comment-title _v-9d36f8a4=\"\"> <p class=comment-all _v-9d36f8a4=\"\">全部评论</p> <p class=comment-sort _v-9d36f8a4=\"\">{{cpwtotal}}条评论</p> </div> <div class=comment v-for=\"item in commentList\" _v-9d36f8a4=\"\"> <div class=common-avatar _v-9d36f8a4=\"\"> <img src=/static/images/user.png width=100% height=100% _v-9d36f8a4=\"\"> </div> <div class=comment-block _v-9d36f8a4=\"\"> <p class=comment-user _v-9d36f8a4=\"\"> <span class=comment-username v-if=item.user _v-9d36f8a4=\"\"> {{item.user.username}} </span> <span class=comment-username v-else=\"\" _v-9d36f8a4=\"\"> 匿名用户 </span> <span class=footer-zan _v-9d36f8a4=\"\"> <i class=c-share-icon @click.stop=\"zan(item.id, $event)\" _v-9d36f8a4=\"\"></i><span class=u-num _v-9d36f8a4=\"\">{{item.zan_cnt}}</span></span> </p> <div class=comment-content _v-9d36f8a4=\"\">{{item.content}} </div> <div class=comment-operate _v-9d36f8a4=\"\"> <span class=\"J_Vote comment-operate-item comment-operate-up\" _v-9d36f8a4=\"\">{{item.updtime | date}}</span> <span class=\"J_Reply comment-operate-item\" _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"commentinput = true, pid = item.id, content = ''\" _v-9d36f8a4=\"\">回复</a> </span> </div> <div class=\"comment-reply-ctn comment-reply-item\" _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <li v-for=\"i in item.replys\" track-by=$index v-if=\"$index < item.showall\" _v-9d36f8a4=\"\"> <p class=comment-text _v-9d36f8a4=\"\"> <span class=c-username v-if=i.user _v-9d36f8a4=\"\"> {{i.user.username}} </span> <span class=c-username v-else=\"\" _v-9d36f8a4=\"\">匿名用户</span> {{i.content}} </p> <div class=\"reply-operate reply-operate-hot\" _v-9d36f8a4=\"\"> <span class=\"J_Vote reply-operate-item reply-up\" _v-9d36f8a4=\"\"><i class=c-share-icon @click.stop=\"zan(i.id, $event)\" _v-9d36f8a4=\"\"></i><span _v-9d36f8a4=\"\">{{i.zan_cnt}}</span></span> <span class=\"J_Reply reply-operate-item\" _v-9d36f8a4=\"\"></span> <span _v-9d36f8a4=\"\">{{i.updtime | date}}</span> </div> </li> <li class=\"view-more hidden\" v-if=\"item.replys.length > 2 &amp;&amp; item.showall !== 8\" _v-9d36f8a4=\"\"> <a class=\"btn-block text-center btn-comment-expand\" @click=\"item.showall = 8\" _v-9d36f8a4=\"\">查看全部<span class=nume _v-9d36f8a4=\"\">{{item.replys.length}}</span>条回复 </a> </li> </ul> </div> </div> </div> </div> <div class=comment-more _v-9d36f8a4=\"\"> <a href=javascript:; v-if=\"commentList.length !== cpwtotal\" _v-9d36f8a4=\"\">加载更多评论中...</a> <a href=javascript:; v-if=\"commentList.length == cpwtotal &amp;&amp; cpwtotal !== 0\" _v-9d36f8a4=\"\">评论已全部加载</a> </div> <div class=comment-no v-if=\"cpwtotal == 0\" _v-9d36f8a4=\"\"> 暂无评论，快来添加一个吧！ </div> <div class=comment-no _v-9d36f8a4=\"\"></div> </div> <div class=result-container id=result-container v-if=\"showResultPage &amp;&amp; !showSearchPage &amp;&amp; !showTongjiPage &amp;&amp; !showComments\" _v-9d36f8a4=\"\"> <template v-if=\"topPage === 1\"> <div class=search-header _v-9d36f8a4=\"\"> <div class=search-header-text _v-9d36f8a4=\"\"> <span v-if=\"stype != 13\" _v-9d36f8a4=\"\">{{stype | formatTypeName}}</span> <span v-if=\"stype == 13\" _v-9d36f8a4=\"\">研报数据</span> <span _v-9d36f8a4=\"\">·</span> <span _v-9d36f8a4=\"\">{{keywords | formatKeywords}}</span> </div> <span class=search-header-stics @click=\"switchPage(3), showStatAnalyze = true, setCnzz('[Mobile]-信披搜索', '进入统计页', '')\" _v-9d36f8a4=\"\">统计</span> <span class=search-header-stics @click=\"showModalTag = true\" _v-9d36f8a4=\"\">保存标签</span> </div> <div class=screen-menu _v-9d36f8a4=\"\"> <div class=release-date _v-9d36f8a4=\"\"> <div @click.stop=\"slideToggle('date')\" _v-9d36f8a4=\"\"> {{ datetype_name }} <span class=close-bot _v-9d36f8a4=\"\"></span> </div> <div class=slide-menu v-show=\"showDropdownMenu == 'date'\" _v-9d36f8a4=\"\"> <ul class=date-menu @click=\"hideDropdown(), setCnzz('[Mobile]-信披搜索', '点击日期筛选下拉框', '')\" _v-9d36f8a4=\"\"> <li @click=sortByDate(1) _v-9d36f8a4=\"\">一个月</li> <li @click=sortByDate(2) _v-9d36f8a4=\"\">一个季度</li> <li @click=sortByDate(3) _v-9d36f8a4=\"\">半年</li> <li @click=sortByDate(4) _v-9d36f8a4=\"\">去年</li> <li @click=sortByDate(5) _v-9d36f8a4=\"\">今年</li> <li @click=sortByDate(6) _v-9d36f8a4=\"\">一年</li> <li @click=sortByDate(7) _v-9d36f8a4=\"\">两年</li> <li @click=sortByDate(8) _v-9d36f8a4=\"\">三年</li> <li @click=sortByDate(9) _v-9d36f8a4=\"\">五年</li> <li @click=sortByDate(10) _v-9d36f8a4=\"\">十年</li> <li @click=sortByDate(98) _v-9d36f8a4=\"\">全部</li> <li @click=sortByDate(99) _v-9d36f8a4=\"\">自定义</li> </ul> </div> </div> <span class=release-line _v-9d36f8a4=\"\"></span> <div class=release-date _v-9d36f8a4=\"\"> <div @click.stop=\"slideToggle('sort')\" _v-9d36f8a4=\"\"> {{ sort==1?'按相关性排序':'按时间排序' }} <span class=close-bot _v-9d36f8a4=\"\"></span> </div> <ul class=date-menu v-show=\"showDropdownMenu == 'sort'\" @click=hideDropdown _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\"><a href=javascript:; @click=\"selSort(1), setCnzz('[Mobile]-信披搜索', '点击按相关性排序按钮', '')\" _v-9d36f8a4=\"\">按相关性排序</a></li> <li _v-9d36f8a4=\"\"><a href=javascript:; @click=\"selSort(2),  setCnzz('[Mobile]-信披搜索', '点击按时间排序按钮', '')\" _v-9d36f8a4=\"\">按时间排序</a></li> </ul> </div> </div> <div class=search-date-custom v-show=\"datetype_name !== '全部'\" _v-9d36f8a4=\"\"> <p class=time _v-9d36f8a4=\"\"> <span class=l _v-9d36f8a4=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-9d36f8a4=\"\"></date-picker> </span>~ <span class=r _v-9d36f8a4=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-9d36f8a4=\"\"></date-picker> </span> </p> </div> <div class=Screen-criteria v-if=\"tagLists.length > 0\" _v-9d36f8a4=\"\"> <div class=Screen-criteria-head @click=\"showtag = !showtag, slideToggleTag()\" _v-9d36f8a4=\"\"> <span class=fl _v-9d36f8a4=\"\">我的标签</span> <span class=fr v-if=showtag _v-9d36f8a4=\"\"></span> <span class=f3 v-if=!showtag _v-9d36f8a4=\"\"></span> </div> <div class=\"Screen-criteria-box cpwtag\" style=display:none _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <li v-for=\"item in tagLists\" @click=\"searchByTag(item.id), showtag = false, slideToggleTag()\" _v-9d36f8a4=\"\"> <span class=notice-left _v-9d36f8a4=\"\">{{item.name}}</span> <span class=notice-right @click.stop=delTag(item.id) _v-9d36f8a4=\"\"></span> </li> </ul> </div> </div> <div class=search-criteria @click=\"switchPage(1), setCnzz('[Mobile]-信披搜索', '查看搜索条件', '')\" _v-9d36f8a4=\"\"> <span class=fl _v-9d36f8a4=\"\">搜索条件</span> <span class=fr _v-9d36f8a4=\"\"></span> </div> <template v-if=havelabels> <div class=Screen-criteria _v-9d36f8a4=\"\"> <div class=Screen-criteria-head @click.stop=slideDropdownMenu($event) _v-9d36f8a4=\"\"> <span class=fl _v-9d36f8a4=\"\">筛选条件</span> <span class=\"f3 close\" _v-9d36f8a4=\"\"></span> </div> <div class=\"Screen-criteria-box sxtj\" style=\"display: none\" _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <template v-for=\"(type, obj) in conditions\"> <li v-if=\"!isEmptyObj(obj) &amp;&amp; type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\" _v-9d36f8a4=\"\"> <span class=selected-icon _v-9d36f8a4=\"\"></span> <a class=blue _v-9d36f8a4=\"\">{{ cond_type[type] }}</a> </li> <template v-for=\"(code, name) in obj\" v-if=\"type !== 'industry' &amp;&amp; type !== 'industrysecond' &amp;&amp; type !=='layer' &amp;&amp; type !== 'plate'\"> <li _v-9d36f8a4=\"\"> <span class=notice-left _v-9d36f8a4=\"\">{{ name }} </span> <span aria-hidden=true class=notice-right @click=\"rmvCondition(type, code), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> </template> </template> <li v-if=showPla _v-9d36f8a4=\"\"> <span class=selected-icon _v-9d36f8a4=\"\"></span> <a class=blue _v-9d36f8a4=\"\">{{cond_type['plate']}}</a> </li> <li v-for=\"(idx, item) in pageshowConditions['plate']\" v-if=\"idx !== '挂牌公司' &amp;&amp; item\" _v-9d36f8a4=\"\"> <span class=notice-left _v-9d36f8a4=\"\">{{item}}</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('plate', idx), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> <li class=active v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\" _v-9d36f8a4=\"\"> <span class=selected-icon _v-9d36f8a4=\"\"></span> <span class=notice-left _v-9d36f8a4=\"\">挂牌公司</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('N3BGP', 'N3BGP'), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> <li v-for=\"i in pageshowConditions['plate']['挂牌公司']\" v-if=\"pageshowConditions['plate']['挂牌公司'].length > 0\" _v-9d36f8a4=\"\"> <span class=notice-left _v-9d36f8a4=\"\">{{i}}</span> <span aria-hidden=true class=notice-right @click=\"rmvCondition('layer', i), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> <li v-if=showInd _v-9d36f8a4=\"\"> <span class=selected-icon _v-9d36f8a4=\"\"></span> <a class=blue _v-9d36f8a4=\"\">{{cond_type['industry']}}</a> </li> <template v-for=\"(type, obj) in pageshowConditions['industry']\"> <template v-if=\"obj.length > 0 || type == 'S综合'\"> <li class=active _v-9d36f8a4=\"\"> <span class=selected-icon _v-9d36f8a4=\"\"></span> <span class=notice-left _v-9d36f8a4=\"\">{{type}}</span> <span class=notice-right @click=\"rmvCondition('industry', type.substr(0,1)), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> <li v-for=\"item in obj\" v-if=\"obj.length !== industry\" _v-9d36f8a4=\"\"> <span class=notice-left _v-9d36f8a4=\"\">{{item}}</span> <span class=notice-right @click=\"rmvCondition('industrysecond', item.substr(0, 3)), this.setCnzz('[Mobile]-信披搜索', '删除指定筛选条件', '')\" _v-9d36f8a4=\"\"></span> </li> </template> </template> </ul> </div> </div> </template> <div class=intelligent-search-main _v-9d36f8a4=\"\"> <div class=intelligent-search v-if=\"smartComInfo.shortname &amp;&amp; smartComInfo.code\" _v-9d36f8a4=\"\"> <div class=intelligent-heading style=cursor:pointer _v-9d36f8a4=\"\"> <span class=big-h @click=goCompanyInfo(smartComInfo.code) _v-9d36f8a4=\"\">{{smartComInfo.shortname}}【{{smartComInfo.code}}】</span> </div> <div class=op-stockdynamic v-if=smartComInfo.price _v-9d36f8a4=\"\"> <div class=op-stockdynamic-top :class=\"{'plus': upanddown.indexOf('+') === 0, 'reduce': upanddown.indexOf('-') === 0}\" _v-9d36f8a4=\"\"> <span class=op-cur-num _v-9d36f8a4=\"\">{{prices.trade}}元</span> <span class=op-cur-info _v-9d36f8a4=\"\">{{upanddown}}({{Amplitude}}%)</span> </div> <div class=op-stockdynamic-bot _v-9d36f8a4=\"\"> <ul _v-9d36f8a4=\"\"> <ul class=op-clear _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\">昨收：{{prices.settlement}}</li> <li _v-9d36f8a4=\"\">今开：{{prices.open}}</li> <li _v-9d36f8a4=\"\">最高：{{prices.high}}</li> <li _v-9d36f8a4=\"\">最低：{{prices.low}}</li> </ul> <ul class=op-clear _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\">成交量：<template v-if=\"prices.volume < 10000000\">{{prices.volume}}手</template> <template v-if=\"prices.volume > 10000000 || prices.volume == 10000000\">{{(prices.volume/ 1000000).toFixed(2) | thousands}}万手</template></li> <li _v-9d36f8a4=\"\">成交额：{{(prices.amount/ 100000000).toFixed(2) | thousands}}亿</li> <li _v-9d36f8a4=\"\">总市值：{{(prices.mktcap/10000).toFixed(2) | thousands}}亿</li> <li _v-9d36f8a4=\"\">流通市值：{{(prices.nmc/10000).toFixed(2) | thousands}}亿</li> </ul> <ul class=op-clear _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\">换手率：{{prices.turnoverratio.toFixed(2)}}%</li> <li _v-9d36f8a4=\"\">市净率：{{prices.pb.toFixed(2)}}</li> <li _v-9d36f8a4=\"\">振 幅：{{prices.changepercent.toFixed(2)}}%</li> <li _v-9d36f8a4=\"\">市盈率：{{prices.per.toFixed(2)}}</li> </ul> </ul> </div> </div> </div> <div class=intelligent-search v-if=\"smartComInfo.finance &amp;&amp; smartComInfo.finance.length > 0\" _v-9d36f8a4=\"\"> <div class=intelligent-heading _v-9d36f8a4=\"\"> {{smartComInfo.shortname}}【{{smartComInfo.code}}】财务信息 </div> <div class=table-result-outter _v-9d36f8a4=\"\"> <ul class=personnel _v-9d36f8a4=\"\"> <li :class=\"{'active': timetyp === 1}\" @click=\"timetyp = 1\" _v-9d36f8a4=\"\">按季度</li> <li :class=\"{'active': timetyp === 2}\" @click=\"timetyp = 2\" _v-9d36f8a4=\"\">按年度</li> </ul> <div style=\"margin-bottom: 20px\" _v-9d36f8a4=\"\"> <table class=table-result cellpadding=0 _v-9d36f8a4=\"\"> <tbody v-if=\"timetyp === 1\" _v-9d36f8a4=\"\"> <tr class=title _v-9d36f8a4=\"\"> <td _v-9d36f8a4=\"\">按报告期</td> <td _v-9d36f8a4=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in finance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-9d36f8a4=\"\"> <td v-for=\"(k,i) in item\" _v-9d36f8a4=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i[smartComInfo.financeCols[0].name] | thousands}}</template> </td> </tr> </tbody> <tbody v-if=\"timetyp === 2\" _v-9d36f8a4=\"\"> <tr class=title _v-9d36f8a4=\"\"> <td _v-9d36f8a4=\"\">按报告期</td> <td _v-9d36f8a4=\"\">{{smartComInfo.financeCols[0].name}}（{{smartComInfo.financeCols[0].unit}}）</td> </tr> <tr v-if=\"$index > 0 &amp;&amp; $index < 6\" v-for=\"item in yearfinance\" track-by=$index :class=\"{'evencom': $index % 2 > 0, 'oldcom': $index % 2 === 0 }\" _v-9d36f8a4=\"\"> <td v-for=\"(k,i) in item\" _v-9d36f8a4=\"\"> <template v-if=\"k === 0\">{{i}}</template> <template v-if=\"k !== 0\">{{i[smartComInfo.financeCols[0].name] | thousands}}</template> </td> </tr> </tbody> </table> </div> </div> </div> </div> </template> <div v-if=\"stype == 100\" style=margin-bottom:25px _v-9d36f8a4=\"\"> <div class=index-colligate-main v-if=complex_hk _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">新闻</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['12']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=12 :items=complex_news :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 12,searchMore(12)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_knowledge _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">知识库</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['4']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=4 :items=complex_knowledge :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 4,searchMore(4)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_reportdata _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">研报数据</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['13']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=13 :items=complex_reportdata :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 13,searchMore(13)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_yb _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">研报</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['11']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=11 :items=complex_yb :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 11,searchMore(11)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_agu _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">A股</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['1']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=1 :items=complex_agu :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 1,searchMore(1)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_n3b _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">新三板</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['2']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=2 :items=complex_n3b :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 2,searchMore(2)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_qa _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">问题库</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['5']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=5 :items=complex_qa :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 5,searchMore(5)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_hk _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">港股</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['6']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=6 :items=complex_hk :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 6,searchMore(6)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> <div class=index-colligate-main v-if=complex_bond _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">债券</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{stypesTotal['3']}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=3 :items=complex_bond :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> <div class=compre-more _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"stype = 3,searchMore(3)\" _v-9d36f8a4=\"\">查看更多</a> </div> </div> </div> </div> </div> </div> <div v-if=\"stype == 13\" class=report-data _v-9d36f8a4=\"\"> <div class=index-colligate-main style=margin-bottom:45px _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">研报数据</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{reportDataTotal}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=13 :items=reportDataList :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> </div> </div> </div> </div> </div> <div v-if=\"stype == 17\" class=report-data _v-9d36f8a4=\"\"> <div class=index-colligate-main _v-9d36f8a4=\"\"> <div class=index_box _v-9d36f8a4=\"\"> <div class=intelligent-search-notice _v-9d36f8a4=\"\"> <div class=intelligent-heading style=\"width:100%;border-left:none;background:#fff;padding:0 -2px;height:33px;line-height:33px\" _v-9d36f8a4=\"\"> <span class=jddAul style=display:inline-block;color:black;font-weight:bold _v-9d36f8a4=\"\">English</span> <div class=indicator-filter style=display:inline-block;float:right;margin-right:20px;font-size:12px _v-9d36f8a4=\"\"> <span class=count-wrapper _v-9d36f8a4=\"\">共有<span class=blue style=cursor:pointer _v-9d36f8a4=\"\">{{reportDataTotal}}</span>条搜索结果</span> </div> </div> <div class=intelligent-list _v-9d36f8a4=\"\"> <resfrag :currentuser=currentuser :stype=13 :items=reportDataList :onlytitle=parseInt(onlyTitle) _v-9d36f8a4=\"\"></resfrag> </div> </div> </div> </div> </div> <div class=search-result-box _v-9d36f8a4=\"\"> <div class=anwer-cont v-show=\"searched==stype &amp;&amp; items.length==0\" _v-9d36f8a4=\"\"> <div class=no _v-9d36f8a4=\"\">很抱歉，没有找到相关的结果!</div> </div> <div class=more_top v-show=\"!loading &amp;&amp; topPage !== 1 &amp;&amp; total !== 0\" style=\"margin-bottom: -0.4rem\" _v-9d36f8a4=\"\"> <i class=\"pull_icon_top loading\" _v-9d36f8a4=\"\"></i> <span style=\"font-size: 15px\" _v-9d36f8a4=\"\">加载中...</span> </div> <div v-show=\"searched==stype &amp;&amp; detailLists.length>0\" id=my-result-wrap style=margin-bottom:5px _v-9d36f8a4=\"\"> <template v-if=\"stype!=5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-9d36f8a4=\"\"> <p class=head _v-9d36f8a4=\"\"> <span class=\"{{ fileIcon(item.fileext) }}\" _v-9d36f8a4=\"\"></span> <a v-if=\"stype!=5&amp;&amp;stype != 10\" style=cursor:pointer @click=\"checkLogin(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')\" class=green _v-9d36f8a4=\"\">{{{ item.fulltitle }}}</a> <a v-if=\"stype == 10\" style=cursor:pointer @click=\"openAbsAnn(item), setCnzz('[Mobile]-信披搜索页', '查看公告详情', '')\" class=green _v-9d36f8a4=\"\">{{{ item.fulltitle }}}</a> <a v-if=\"stype==5\" style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看公告详情', '')\" class=green _v-9d36f8a4=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-9d36f8a4=\"\"> {{ item.publishDate ? item.publishDate: item.uploadTime }} <span class=marginlf-10 _v-9d36f8a4=\"\">{{ item.companyCode }}</span> <span class=marginlf-10 v-if=item.author _v-9d36f8a4=\"\">作者: {{ item.author }}</span> <span class=marginlf-10 v-if=item.nickname _v-9d36f8a4=\"\">公众号: {{ item.nickname }}</span> </p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent' &amp;&amp; onlyTitle == 0\" _v-9d36f8a4=\"\"> {{{ item.content.join('...... ') }}} </p> <template v-if=\"item.child &amp;&amp; onlyTitle == 0\"> <template v-for=\"child in item.child\"> <p class=\"blak font-weight lien child-title\" :style=indentChild(child.code) @click=\"viewChildTitle(item, child.code)\" style=cursor:pointer _v-9d36f8a4=\"\"> {{{ child.title }}} </p> <p class=lien :style=indentChild(child.code) v-if=child.content _v-9d36f8a4=\"\"> {{{ child.content.join('...... ') }}} </p> <template v-if=child.contents> <template v-for=\"c in child.contents\"> <p class=lien :style=indentChild(child.code) v-if=\"c.htmltag=='p'\" _v-9d36f8a4=\"\"> {{{ c.content }}}<br _v-9d36f8a4=\"\"> </p> <template v-if=\"c.htmltag=='table'\"> <div class=table-result-outter _v-9d36f8a4=\"\"> <table cellpadding=0 class=table-result _v-9d36f8a4=\"\"> <tbody _v-9d36f8a4=\"\"> <tr v-for=\"(rowidx, row) in c.table\" track-by=$index :class=\"{'oldcom': !(rowidx%2), 'evencom': rowidx%2}\" _v-9d36f8a4=\"\"> <td v-for=\"(colidx, col) in row\" rowspan=\"{{ col.row }}\" colspan=\"{{ col.col }}\" track-by=$index _v-9d36f8a4=\"\"> {{{col.value}}} </td> </tr> </tbody> </table> </div> <div class=table-whole _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"viewTable(item, child.code, c.offset), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')\" _v-9d36f8a4=\"\"> <span class=table-see-icon _v-9d36f8a4=\"\"></span>查看表格全部内容 </a> </div> </template> </template> </template> <div class=intelligent-fsearch-cont v-if=child.imgs _v-9d36f8a4=\"\"> <template v-for=\"c in child.imgs\"> <div class=fsearch-a _v-9d36f8a4=\"\"> <div class=more-img style=cursor:pointer title=点击查看更多 @click=\"setBigImgObj(c, item)\" _v-9d36f8a4=\"\"> <img :src=c.imgurl _v-9d36f8a4=\"\"> </div> <div class=text-a _v-9d36f8a4=\"\">{{{child.title}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-9d36f8a4=\"\">{{{c.imghead}}}</div> <div class=text-b style=cursor:pointer @click=\"viewImg(item, child.code, c.offset)\" _v-9d36f8a4=\"\">{{{c.imgfoot}}}</div> </div> </template> </div> </template> </template> </div> </template> <template v-if=\"stype==5\"> <div class=search-result-list v-for=\"item in detailLists\" track-by=$index _v-9d36f8a4=\"\"> <p class=head _v-9d36f8a4=\"\"> <a class=green style=cursor:pointer @click=\"checkLoginQa(item), setCnzz('[Mobile]-信披搜索', '查看表格全部内容', '')\" _v-9d36f8a4=\"\">{{{ item.fulltitle }}}</a> </p> <p class=Subtitle _v-9d36f8a4=\"\">{{ item.publishDate ? item.publishDate: item.uploadTime }}</p> <p class=lien v-if=\"item.content &amp;&amp; item.content!='NoContent'\" _v-9d36f8a4=\"\">{{{ item.content.join('...... ') }}}</p> <template v-if=item.child> <template v-for=\"child in item.child\"> <div v-if=child.content class=\"rb odd res-qa-title-wrap\" style=\"overflow: hidden\" _v-9d36f8a4=\"\"> <p class=\"blak font-weight lien\" _v-9d36f8a4=\"\">{{{ child.title }}}</p> <p class=lien v-if=child.content _v-9d36f8a4=\"\"> {{{ child.content.join('...... ') }}} </p> </div> <div v-if=child.que class=\"rb odd res-qa-middle-wrap\" _v-9d36f8a4=\"\"> <div class=res-qa-item-l _v-9d36f8a4=\"\"> <div class=ques-l _v-9d36f8a4=\"\"><span class=\"qicon ques_1\" style=\"margin: 0.1rem 5px 2px 0px\" _v-9d36f8a4=\"\"></span></div> </div> <div class=res-qa-item-r style=\"width: 91%\" _v-9d36f8a4=\"\"> <p class=lien v-if=!child.showque _v-9d36f8a4=\"\"> {{{ child.shortque?child.shortque:child.que | maxlen 100 }}} <span class=\"qust-more blue\" @click=\"child.showque=true\" v-if=\"child.que.length>100\" _v-9d36f8a4=\"\"> 展开更多<span class=triangle-bottom _v-9d36f8a4=\"\"></span></span> </p> <p class=lien v-if=child.showque _v-9d36f8a4=\"\"> {{{ child.que }}} <span class=\"qust-stop red\" @click=\"child.showque=false\" _v-9d36f8a4=\"\"> 收起<span class=triangle-head _v-9d36f8a4=\"\"></span></span> </p> <div class=quest-blue _v-9d36f8a4=\"\"> <li v-for=\"t in child.tag\" _v-9d36f8a4=\"\"><a href=javascript:; _v-9d36f8a4=\"\">{{ t }}</a></li> </div> </div> </div> <div v-if=child.answers v-for=\"ans in child.answers\" class=res-qa-ans-wrap _v-9d36f8a4=\"\"> <div class=res-qa-item-l _v-9d36f8a4=\"\"> <div class=ques-l _v-9d36f8a4=\"\"> <span class=\"qicon ques_2\" style=\"margin: 0.12rem 5px 2px 0px\" _v-9d36f8a4=\"\"></span> </div> </div> <div class=res-qa-item-r style=\"width: 91%\" _v-9d36f8a4=\"\"> <p class=quest-p _v-9d36f8a4=\"\"> <span class=font-weight v-if=\"trim(ans.rername) !== ''\" _v-9d36f8a4=\"\">【{{ ans.rertitle }}: {{ ans.rername }}】</span> <span class=ques-lt v-if=!ans.showans _v-9d36f8a4=\"\"> {{{ ans.shortans?ans.shortans:ans.ans | maxlen 100 }}}</span> <span class=ques-lt v-show=ans.showans _v-9d36f8a4=\"\"> {{{ ans.ans }}}</span> <span class=\"qust-more blue\" v-if=\"!ans.showans &amp;&amp; ans.ans.length>100\" @click=\"ans.showans=true\" _v-9d36f8a4=\"\"> 展开更多<span class=triangle-bottom _v-9d36f8a4=\"\"></span> </span> <span class=\"qust-stop red\" v-if=ans.showans @click=\"ans.showans=false\" _v-9d36f8a4=\"\"> 收起<span class=triangle-head _v-9d36f8a4=\"\"></span></span> </p> </div> </div> </template> </template> </div> </template> </div> <div class=more v-show=\"!loading &amp;&amp; bottomPage < totalPage &amp;&amp; total !== 0 &amp;&amp; searched === stype\" style=\"margin-bottom: 2rem\" _v-9d36f8a4=\"\"> <i class=\"pull_icon loading\" _v-9d36f8a4=\"\"></i> <span style=\"font-size: 15px\" _v-9d36f8a4=\"\">加载中...</span> </div> <div class=more v-show=\"bottomPage >= totalPage &amp;&amp; total !== 0 &amp;&amp; searched === stype &amp;&amp; bottomTip\" style=\"margin-bottom: 2rem\" _v-9d36f8a4=\"\"> <span style=\"font-size: 15px\" _v-9d36f8a4=\"\">已加载全部内容</span> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-9d36f8a4=\"\"> <div class=binding-content _v-9d36f8a4=\"\"> <a class=binding-logo _v-9d36f8a4=\"\"></a> <div class=binding-text _v-9d36f8a4=\"\"> 立即绑定IBDATA账号<br _v-9d36f8a4=\"\">成为金融分析高手 </div> <div class=binding-bot _v-9d36f8a4=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-9d36f8a4=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-9d36f8a4=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-9d36f8a4=\"\"></div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-if=showModalTag _v-9d36f8a4=\"\"> <div class=comment-content-tag _v-9d36f8a4=\"\"> <div class=login-close @click=\"showModalTag = false\" _v-9d36f8a4=\"\"> <a class=delete-icon _v-9d36f8a4=\"\"></a> </div> <div class=comment-reply _v-9d36f8a4=\"\"> <input class=input-search-c type=text placeholder=输入标签名称 v-model=tagname _v-9d36f8a4=\"\"> <a class=btn-Publish @click=saveTag() _v-9d36f8a4=\"\">确定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-if=showModalTag _v-9d36f8a4=\"\"></div> <div class=wrapper v-show=smartEngine.open _v-9d36f8a4=\"\"> <div class=company-details-title _v-9d36f8a4=\"\"> <span class=cancle-btn @click.stop=\"smartEngine.open = false, setCnzz('[Mobile]信披搜索', '收起公司详情', '')\" _v-9d36f8a4=\"\"></span> <span class=\"menu-options blue\" style=\"font-size: 16px\" _v-9d36f8a4=\"\">{{smartEngine.companyInfo.shortname}}({{smartComInfo.code}})</span> </div> <div class=company-details-head _v-9d36f8a4=\"\"> <div class=search-company-list _v-9d36f8a4=\"\"> <p _v-9d36f8a4=\"\"><span class=title _v-9d36f8a4=\"\">法人</span> <span class=mar _v-9d36f8a4=\"\">{{smartEngine.companyInfo.legalRepresentative}}</span></p> <p _v-9d36f8a4=\"\"><span class=title _v-9d36f8a4=\"\">成立日期</span> <span class=mar _v-9d36f8a4=\"\">{{smartEngine.companyInfo.founddate}}</span> <span class=title _v-9d36f8a4=\"\">所属地域</span> <span class=mar _v-9d36f8a4=\"\">{{smartEngine.companyInfo.area}}</span></p> </div> <div class=\"search-company-list last-child\" _v-9d36f8a4=\"\"> <p _v-9d36f8a4=\"\"><span class=title _v-9d36f8a4=\"\">行业</span> <span class=mar _v-9d36f8a4=\"\">{{smartEngine.companyInfo.industry}}</span></p> </div> </div> <div class=company-details-box _v-9d36f8a4=\"\"> <ul class=one-row-box _v-9d36f8a4=\"\"> <li _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 公司名称 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.name}} </p> </li> <li v-if=smartEngine.companyInfo.name_en _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 英文名称 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.name_en}} </p> </li> <li v-if=smartEngine.companyInfo.regcode _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 统一社会信用代码 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.regcode}} </p> </li> <li v-if=smartEngine.companyInfo.regmoney _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\">注册资本</p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.regmoney | formatNumber}}（万元） </p> </li> <li v-if=smartEngine.companyInfo.secretaries _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 董 秘 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.secretaries}} </p> </li> <li v-if=smartEngine.companyInfo.address _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 注册地址 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.address}} </p> </li> <li v-if=smartEngine.companyInfo.website _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 公司网址 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.website}} </p> </li> <li v-if=smartEngine.companyInfo.phone _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 电 话 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.phone}} </p> </li> <li v-if=smartEngine.companyInfo.fax _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 传 真 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.fax}} </p> </li> <li v-if=smartEngine.companyInfo.postcode _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 邮 编 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.postcode}} </p> </li> <li v-if=smartEngine.companyInfo.companytyp _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 企业类型 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.companytyp}} </p> </li> <li v-if=smartEngine.companyInfo.businessscope _v-9d36f8a4=\"\"> <p class=date _v-9d36f8a4=\"\"> 经营范围 </p> <p class=time _v-9d36f8a4=\"\"> {{smartEngine.companyInfo.businessscope}} </p> </li> </ul> </div> </div> </div> <div class=footer-comment style=bottom:0px _v-9d36f8a4=\"\"> <span class=footer-text _v-9d36f8a4=\"\"><a href=javascript:; @click=\"commentinput = true, content= '',pid = 0\" _v-9d36f8a4=\"\"><i class=comment-icon _v-9d36f8a4=\"\"></i>评论一下</a></span> <span class=footer-zan v-show=!showComments _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"showComments = true,loadcomment()\" _v-9d36f8a4=\"\"><span class=qinp _v-9d36f8a4=\"\"><i _v-9d36f8a4=\"\"></i>{{cpwtotal}}</span></a> </span> <span class=footer-zan v-show=showComments _v-9d36f8a4=\"\"> <a href=javascript:; @click=\"showComments = false\" _v-9d36f8a4=\"\"><span class=text _v-9d36f8a4=\"\"><i _v-9d36f8a4=\"\"></i>返回搜索</span></a> </span> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=\"display: block\" v-show=commentinput @click.self=\"commentinput = false\" _v-9d36f8a4=\"\"> <div class=comment-content _v-9d36f8a4=\"\"> <div class=comment-content-tag _v-9d36f8a4=\"\"> <div class=login-close _v-9d36f8a4=\"\"> <a class=delete-icon href=javascript:; @click=\"commentinput = false\" _v-9d36f8a4=\"\"></a> </div> <div class=comment-reply _v-9d36f8a4=\"\"> <textarea cols=\"\" rows=2 class=input-a placeholder=输入发表内容 v-model=content _v-9d36f8a4=\"\"></textarea> <span class=anonymous @click=\"anonym == 1 ? anonym = 0:anonym = 1\" _v-9d36f8a4=\"\"> <label class=\"el-checkbox mar\" _v-9d36f8a4=\"\"> <span class=el-checkbox-input :class=\"{'is-checked':anonym === 1}\" _v-9d36f8a4=\"\"><span class=el-checkbox-inner _v-9d36f8a4=\"\"></span> </span> <span class=el-checkbox-label _v-9d36f8a4=\"\">匿名评论</span> </label> </span> <a class=btn-Publish href=javascript:; @click=\"commentinput = false,addComment(2, params.sid)\" _v-9d36f8a4=\"\">发表</a> </div> </div> </div> </div> <div v-if=commentinput class=\"ui-datepicker ui-widget ui-widget-content ui-helper-clearfix ui-corner-all\" id=ui-datepicker-div _v-9d36f8a4=\"\"></div> <div v-if=commentinput class=\"modal-backdrop fade in\" _v-9d36f8a4=\"\"></div> <bigimg :bigimgobj=bigImgObj _v-9d36f8a4=\"\"></bigimg> </div>";

/***/ },
/* 800 */
/***/ function(module, exports) {

	module.exports = "<div class=wrapper _v-a88993c4=\"\"> <div class=beta_record _v-a88993c4=\"\"> <div class=photo_img _v-a88993c4=\"\"><img :src=headUrl _v-a88993c4=\"\"></div> <div class=wx_content _v-a88993c4=\"\"> <p class=p1 _v-a88993c4=\"\">{{wxName}}邀您阅读</p> <p class=p2 _v-a88993c4=\"\">{{company}} | {{position}}</p> </div> </div> <div class=mobile-page-content v-if=!loading _v-a88993c4=\"\"> <h2 class=rich-media-title _v-a88993c4=\"\">{{ articleInfo.title }}</h2> <div id=meta-content class=rich-media-meta-list _v-a88993c4=\"\"> <span class=\"rich-media-meta rich-media-meta-text\" _v-a88993c4=\"\">{{ addtime }}</span> <template v-if=\"articleInfo.author &amp;&amp; articleInfo.author.length>0\"> <span class=\"rich-media-meta rich-media-meta-text\" _v-a88993c4=\"\">{{ articleInfo.author }}</span> </template> <a class=\"rich-media-meta rich-media-meta-link rich-media-meta-nickname\" href=javascript:; @click=\"showPublisherCode=true\" _v-a88993c4=\"\">{{ articleInfo.publisher.name }}</a> </div> <div class=rich-media-content _v-a88993c4=\"\"> <div class=rich-blue-border v-if=\"articleInfo.brief.length>0\" _v-a88993c4=\"\"> <p class=rich-blue-title _v-a88993c4=\"\">导读<br _v-a88993c4=\"\"></p> <h1 _v-a88993c4=\"\">测试</h1> <p class=rich-detail-indent _v-a88993c4=\"\">{{ articleInfo.brief }}</p> </div> <div class=rich-media-detail _v-a88993c4=\"\"> {{{ articleInfo.content }}} </div> <div class=footer-Read _v-a88993c4=\"\"> <span class=footer-text _v-a88993c4=\"\"> 阅读 {{ articleInfo.uv }}</span> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" style=display:block v-show=showPublisherCode @click=hideDialog($event) _v-a88993c4=\"\"> <div class=binding-content style=\"text-align:center;width: 56%; margin:45% 15%\" _v-a88993c4=\"\"> <img src={{articleInfo.publisher.imgurl}} alt=\"\" width=200px height=200px _v-a88993c4=\"\"> </div> </div> <div class=\"modal-backdrop fade in\" v-show=showPublisherCode _v-a88993c4=\"\"></div> </div>";

/***/ },
/* 801 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-b271812c=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-b271812c=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-b271812c=\"\"> <div class=loading-img _v-b271812c=\"\"></div> </div> </div> <div class=search-company-box _v-b271812c=\"\"> <div class=pledge-box1 _v-b271812c=\"\"> <div class=pledge-box1-top _v-b271812c=\"\"> <div class=Quarterly-Report style=\"float: left\" v-if=\"allCustomerDate.length > 0\" _v-b271812c=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-b271812c=\"\"> {{ curCustomerDate }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-b271812c=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-b271812c=\"\"> <li v-for=\"h in allCustomerDate\" _v-b271812c=\"\"> <a href=javascript:; v-if=\"curCustomerDate != h\" @click=\"clickDropmenu(), curCustomerDate = h, customerFilter()\" _v-b271812c=\"\">{{ h }}</a> </li> </ul> </div> <div class=Single-list-main v-if=\"customerList.length > 0\" _v-b271812c=\"\"> <ul class=Single-list-box v-for=\"(index, h) in customerList\" track-by=$index _v-b271812c=\"\"> <li class=list-w _v-b271812c=\"\"> <p class=date _v-b271812c=\"\">客户名称</p> <p class=time _v-b271812c=\"\">{{ h.name }}</p></li> <li class=list-w _v-b271812c=\"\"> <p class=date _v-b271812c=\"\">销售额</p> <p class=time _v-b271812c=\"\">{{ h.money | money }}</p> </li> <li class=list-w _v-b271812c=\"\"> <p class=date _v-b271812c=\"\">销售占比</p> <p class=time _v-b271812c=\"\">{{ h.ratio }}</p> </li> <li class=list-w _v-b271812c=\"\"> <p class=date _v-b271812c=\"\">排名</p> <p class=time _v-b271812c=\"\">{{ h.rank }}</p> </li> </ul> </div> <div class=Single-list-main v-if=\"!customerList.length &amp;&amp; !loading\" _v-b271812c=\"\"> <div class=Block-trade-no _v-b271812c=\"\">暂无数据</div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-b271812c=\"\"> <div class=binding-content _v-b271812c=\"\"> <a class=binding-logo _v-b271812c=\"\"></a> <div class=binding-text _v-b271812c=\"\"> 立即绑定IBDATA账号<br _v-b271812c=\"\">成为金融分析高手 </div> <div class=binding-bot _v-b271812c=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-b271812c=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-b271812c=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-b271812c=\"\"></div>";

/***/ },
/* 802 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-c7bf5880=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-c7bf5880=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-c7bf5880=\"\"> <div class=loading-img _v-c7bf5880=\"\"></div> </div> </div> <div class=search-company-box _v-c7bf5880=\"\"> <div class=pledge-box1-top _v-c7bf5880=\"\"> <label class=el-radio _v-c7bf5880=\"\"> <span class=\"el-radio-input is-checked\" :class=\"{'is-checked': reporting}\" @click=\"reporting=true, curDateType = finance[0][0]\" _v-c7bf5880=\"\"> <span class=el-radio-inner _v-c7bf5880=\"\"></span> <input class=el-radio-original value=按报告期 type=radio _v-c7bf5880=\"\"> </span> <span class=el-radio-label _v-c7bf5880=\"\">按报告期</span> </label> <label class=el-radio _v-c7bf5880=\"\"> <span class=el-radio-input :class=\"{'is-checked': !reporting}\" @click=\"reporting=false, curDateType = yearList[0][0]\" _v-c7bf5880=\"\"> <span class=el-radio-inner _v-c7bf5880=\"\"></span> <input class=el-radio-original value=按年度 type=radio _v-c7bf5880=\"\"> </span> <span class=el-radio-label _v-c7bf5880=\"\">按年度</span> </label> <div class=Quarterly-Report _v-c7bf5880=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-c7bf5880=\"\"> {{ curDateType }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-c7bf5880=\"\"></span> </div> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; reporting\" _v-c7bf5880=\"\"> <li v-for=\"h in finance\" _v-c7bf5880=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-c7bf5880=\"\">{{ h[0] }}</a> </li> </ul> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; !reporting\" _v-c7bf5880=\"\"> <li v-for=\"h in yearList\" _v-c7bf5880=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-c7bf5880=\"\">{{ h[0] }}</a> </li> </ul> </div> </div> <div class=Single-list-main v-if=reporting _v-c7bf5880=\"\"> <ul class=Single-list-box _v-c7bf5880=\"\"> <li v-for=\"(key, val) in lrb\" track-by=$index _v-c7bf5880=\"\"> <p class=date _v-c7bf5880=\"\">{{ key }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-c7bf5880=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> <div class=Single-list-main v-if=!reporting _v-c7bf5880=\"\"> <ul class=Single-list-box _v-c7bf5880=\"\"> <li v-for=\"(key, val) in lrb\" track-by=$index _v-c7bf5880=\"\"> <p class=date _v-c7bf5880=\"\">{{ key }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-c7bf5880=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-c7bf5880=\"\"> <div class=binding-content _v-c7bf5880=\"\"> <a class=binding-logo _v-c7bf5880=\"\"></a> <div class=binding-text _v-c7bf5880=\"\"> 立即绑定IBDATA账号<br _v-c7bf5880=\"\">成为金融分析高手 </div> <div class=binding-bot _v-c7bf5880=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-c7bf5880=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-c7bf5880=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-c7bf5880=\"\"></div>";

/***/ },
/* 803 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-cbae14da=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-cbae14da=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-cbae14da=\"\"> <div class=loading-img _v-cbae14da=\"\"></div> </div> </div> <div class=search-company-box _v-cbae14da=\"\"> <div class=pledge-box1 _v-cbae14da=\"\"> <div class=pledge-box1-top _v-cbae14da=\"\"> <div class=Quarterly-Report style=\"float: left\" v-if=\"allDateTyp.length > 0\" _v-cbae14da=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-cbae14da=\"\"> <template v-if=\"curDateTyp == 'ALL'\">全部</template> <template v-if=\"curDateTyp != 'ALL'\">{{ curDateTyp }}</template> <span class=close-bot @click.stop=showDateDropmemu($event) _v-cbae14da=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-cbae14da=\"\"> <li v-for=\"h in allDateTyp\" _v-cbae14da=\"\"> <a href=javascript:; v-if=\"curDateTyp != h\" @click=\"clickDropmenu(), curDateTyp = h, filter()\" _v-cbae14da=\"\">{{ h }}</a> </li> </ul> </div> </div> <div class=pledge-box1 v-if=\"productList.length > 0\" _v-cbae14da=\"\"> <template v-if=showYysr> <div class=pledge-box1-top _v-cbae14da=\"\"> <h3 _v-cbae14da=\"\">营业收入(元)</h3> </div> <div class=Single-list-main _v-cbae14da=\"\"> <ul class=Single-list-box _v-cbae14da=\"\"> <template v-for=\"h in productList\" track-by=$index> <li v-if=h.yysr _v-cbae14da=\"\"> <p class=date _v-cbae14da=\"\">{{ h.name }}</p> <p class=time _v-cbae14da=\"\">{{ h.yysr | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYycb> <div class=pledge-box1-top _v-cbae14da=\"\"> <h3 _v-cbae14da=\"\">营业成本(元)</h3> </div> <div class=Single-list-main _v-cbae14da=\"\"> <ul class=Single-list-box _v-cbae14da=\"\"> <template v-for=\"h in productList\" track-by=$index> <li v-if=h.yycb _v-cbae14da=\"\"> <p class=date _v-cbae14da=\"\">{{ h.name }}</p> <p class=time _v-cbae14da=\"\">{{ h.yycb | money }}</p> </li> </template> </ul> </div> </template> <template v-if=showYylr> <div class=pledge-box1-top _v-cbae14da=\"\"> <h3 _v-cbae14da=\"\">营业利润(元)</h3> </div> <div class=Single-list-main _v-cbae14da=\"\"> <ul class=Single-list-box _v-cbae14da=\"\"> <template v-for=\"h in productList\" track-by=$index> <li v-if=h.yylr _v-cbae14da=\"\"> <p class=date _v-cbae14da=\"\">{{ h.name }}</p> <p class=time _v-cbae14da=\"\">{{ h.yylr | money }}</p> </li> </template> </ul> </div> </template> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-cbae14da=\"\"> <div class=binding-content _v-cbae14da=\"\"> <a class=binding-logo _v-cbae14da=\"\"></a> <div class=binding-text _v-cbae14da=\"\"> 立即绑定IBDATA账号<br _v-cbae14da=\"\">成为金融分析高手 </div> <div class=binding-bot _v-cbae14da=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-cbae14da=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-cbae14da=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-cbae14da=\"\"></div>";

/***/ },
/* 804 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-cc15446a=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-cc15446a=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-cc15446a=\"\"> <div class=loading-img _v-cc15446a=\"\"></div> </div> </div> <div class=search-company-box _v-cc15446a=\"\"> <div class=pledge-box1 _v-cc15446a=\"\"> <div class=Single-list-main _v-cc15446a=\"\"> <ul class=Single-list-box _v-cc15446a=\"\"> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">所属行业</p><p class=time _v-cc15446a=\"\">{{ company.industry | nullVal }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">所属地域</p><p class=time _v-cc15446a=\"\">{{ company.area | nullVal }}</p></li> </ul> </div> <div class=pledge-box1-top _v-cc15446a=\"\"> <label class=el-radio @click.stop.prevent=changeTab(1) _v-cc15446a=\"\"> <span class=el-radio-input :class=\"{ 'is-checked': tab==1 }\" _v-cc15446a=\"\"> <span class=el-radio-inner _v-cc15446a=\"\"></span> <input class=el-radio-original value=估值比较 type=radio _v-cc15446a=\"\"> </span> <span class=el-radio-label _v-cc15446a=\"\">估值比较</span> </label> <label class=el-radio @click.stop.prevent=changeTab(2) _v-cc15446a=\"\"> <span class=el-radio-input :class=\"{ 'is-checked': tab==2 }\" _v-cc15446a=\"\"> <span class=el-radio-inner _v-cc15446a=\"\"></span> <input class=el-radio-original value=成长性比较 type=radio _v-cc15446a=\"\"> </span> <span class=el-radio-label _v-cc15446a=\"\">成长性比较</span> </label> <label class=el-radio @click.stop.prevent=changeTab(3) _v-cc15446a=\"\"> <span class=el-radio-input :class=\"{ 'is-checked': tab==3 }\" _v-cc15446a=\"\"> <span class=el-radio-inner _v-cc15446a=\"\"></span> <input class=el-radio-original value=盈利比较 type=radio _v-cc15446a=\"\"> </span> <span class=el-radio-label _v-cc15446a=\"\">盈利比较</span> </label> <label class=el-radio @click.stop.prevent=changeTab(4) _v-cc15446a=\"\"> <span class=el-radio-input :class=\"{ 'is-checked': tab==4 }\" _v-cc15446a=\"\"> <span class=el-radio-inner _v-cc15446a=\"\"></span> <input class=el-radio-original value=资产比较 type=radio _v-cc15446a=\"\"> </span> <span class=el-radio-label _v-cc15446a=\"\">资产比较</span> </label> <label class=el-radio @click.stop.prevent=changeTab(5) _v-cc15446a=\"\"> <span class=el-radio-input :class=\"{ 'is-checked': tab==5 }\" _v-cc15446a=\"\"> <span class=el-radio-inner _v-cc15446a=\"\"></span> <input class=el-radio-original value=资产比较 type=radio _v-cc15446a=\"\"> </span> <span class=el-radio-label _v-cc15446a=\"\">现金比较</span> </label> </div> <template v-if=\"tab == 1\"> <div class=rate-chart _v-cc15446a=\"\"> <div class=echart-wrap _v-cc15446a=\"\"> <div class=chart-canvas style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=Single-list-main _v-cc15446a=\"\"> <template v-for=\"h in gzbj.dataTable\" track-by=$index> <ul class=Single-list-box :class=\"{ 'Single-hover': h.name == this.company.shortname}\" _v-cc15446a=\"\"> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">排名</p><p class=time _v-cc15446a=\"\">{{ h.rank }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">简称</p><p class=time _v-cc15446a=\"\">{{ h.name }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">市盈率</p><p class=time _v-cc15446a=\"\">{{ h.per | two | money}}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">市净率 </p> <p class=time _v-cc15446a=\"\">{{ h.pb | two | money }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">总市值 </p> <p class=time _v-cc15446a=\"\">{{ h.mktcap | two | money }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">流通市值</p> <p class=time _v-cc15446a=\"\">{{ h.nmc | two | money }}</p></li> </ul> </template> </div> </template> <template v-if=\"tab == 2\"> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">营业收入增长率(%)</h3> <div class=echart-wrap _v-cc15446a=\"\"> <div class=chart-canvas style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">净利润增长率(%)</h3> <div class=echart-wrap2 _v-cc15446a=\"\"> <div class=chart-canvas2 style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=Single-list-main _v-cc15446a=\"\"> <template v-for=\"(index, h) in czxbj.dataTable\" track-by=$index> <ul class=Single-list-box :class=\"{ 'Single-hover': h.name == this.company.shortname}\" _v-cc15446a=\"\"> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">排名</p><p class=time _v-cc15446a=\"\">{{ h.rank }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">代码</p><p class=time _v-cc15446a=\"\">{{ h.code }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">简称</p><p class=time _v-cc15446a=\"\">{{ h.name }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">营业收入增长率(%)</p><p class=time _v-cc15446a=\"\">{{ h.yysrtbzzl | two | money }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">净利润增长率(%)</p><p class=time _v-cc15446a=\"\">{{ h.jlrtbzzl | two | money }}</p></li> </ul> </template> </div> </template> <template v-if=\"tab == 3\"> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">净资产收益率(%)</h3> <div class=echart-wrap _v-cc15446a=\"\"> <div class=chart-canvas style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">每股收益</h3> <div class=echart-wrap2 _v-cc15446a=\"\"> <div class=chart-canvas2 style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=Single-list-main _v-cc15446a=\"\"> <template v-for=\"(index, h) in ylbj.dataTable\" track-by=$index> <ul class=Single-list-box :class=\"{'Single-hover': h.name == company.shortname}\" _v-cc15446a=\"\"> <li _v-cc15446a=\"\"> <p class=date _v-cc15446a=\"\">排名</p> <p class=time _v-cc15446a=\"\">{{ h.rank }}</p> </li> <li _v-cc15446a=\"\"> <p class=date _v-cc15446a=\"\">代码</p> <p class=time _v-cc15446a=\"\">{{ h.name }}</p> </li> <li _v-cc15446a=\"\"> <p class=date _v-cc15446a=\"\">净资产收益率% </p> <p class=time _v-cc15446a=\"\">{{ h.jzcsyl | two | money }}</p> </li> <li _v-cc15446a=\"\"> <p class=date _v-cc15446a=\"\">每股收益</p> <p class=time _v-cc15446a=\"\">{{ h.basicearningspershare | two | money }}</p> </li> </ul> </template> </div> </template> <template v-if=\"tab == 4\"> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">总资产</h3> <div class=echart-wrap _v-cc15446a=\"\"> <div class=chart-canvas style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">资产负债率(%)</h3> <div class=echart-wrap2 _v-cc15446a=\"\"> <div class=chart-canvas2 style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=Single-list-main _v-cc15446a=\"\"> <template v-for=\"(index, h) in zcbj.dataTable\" track-by=$index> <ul class=Single-list-box :class=\"{'Single-hover': h.name == company.shortname}\" _v-cc15446a=\"\"> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">排名</p><p class=time _v-cc15446a=\"\">{{ h.rank }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">代码</p><p class=time _v-cc15446a=\"\">{{ h.name }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">总资产</p><p class=time _v-cc15446a=\"\">{{ h.assettotal | two | money }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">资产负债率%</p><p class=time _v-cc15446a=\"\">{{ h.zcfzl | two | money }}</p></li> </ul> </template> </div> </template> <template v-if=\"tab == 5\"> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">经营活动现金金额</h3> <div class=echart-wrap _v-cc15446a=\"\"> <div class=chart-canvas style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=rate-chart _v-cc15446a=\"\"> <h3 _v-cc15446a=\"\">每股现金流净值</h3> <div class=echart-wrap2 _v-cc15446a=\"\"> <div class=chart-canvas2 style=\"width:100%; height: 200px\" _v-cc15446a=\"\"></div> </div> </div> <div class=Single-list-main _v-cc15446a=\"\"> <template v-for=\"(index, h) in xjbj.dataTable\" track-by=$index> <ul class=Single-list-box :class=\"{'Single-hover': h.name == company.shortname}\" _v-cc15446a=\"\"> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">排名</p> <p class=time _v-cc15446a=\"\">{{ h.rank }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">代码</p> <p class=time _v-cc15446a=\"\">{{ h.name }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">经营活动现金金额</p><p class=time _v-cc15446a=\"\">{{ h.cashoperatingactivites | two | money }}</p></li> <li _v-cc15446a=\"\"><p class=date _v-cc15446a=\"\">每股现金流净值</p><p class=time _v-cc15446a=\"\">{{ h.mgjyxjllje | two | money }}</p></li> </ul> </template> </div> </template> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-cc15446a=\"\"> <div class=binding-content _v-cc15446a=\"\"> <a class=binding-logo _v-cc15446a=\"\"></a> <div class=binding-text _v-cc15446a=\"\"> 立即绑定IBDATA账号<br _v-cc15446a=\"\">成为金融分析高手 </div> <div class=binding-bot _v-cc15446a=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-cc15446a=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-cc15446a=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-cc15446a=\"\"></div>";

/***/ },
/* 805 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-cc63d754=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-cc63d754=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-cc63d754=\"\"> <div class=loading-img _v-cc63d754=\"\"></div> </div> </div> <div class=search-company-box _v-cc63d754=\"\"> <div class=pledge-box1 _v-cc63d754=\"\"> <div class=pledge-box1-top _v-cc63d754=\"\"> <div class=Quarterly-Report style=\"float: left\" _v-cc63d754=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-cc63d754=\"\"> {{ datetype_name }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-cc63d754=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-cc63d754=\"\"> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(1)\" _v-cc63d754=\"\">一个月</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(2)\" _v-cc63d754=\"\">一个季度</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(3)\" _v-cc63d754=\"\">半年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(4)\" _v-cc63d754=\"\">去年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(5)\" _v-cc63d754=\"\">今年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(6)\" _v-cc63d754=\"\">一年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(7)\" _v-cc63d754=\"\">两年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(8)\" _v-cc63d754=\"\">三年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(9)\" _v-cc63d754=\"\">五年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(10)\" _v-cc63d754=\"\">十年</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(98)\" _v-cc63d754=\"\">全部</a></li> <li _v-cc63d754=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(99)\" _v-cc63d754=\"\">自定义</a></li> </ul> </div> <a class=cop-search-bot href=javascript:; @click=getQuotesChangeList() _v-cc63d754=\"\">查询</a> <div class=cop-date v-if=\"datetype == 99\" _v-cc63d754=\"\"> <p class=time _v-cc63d754=\"\"> <span class=l _v-cc63d754=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-cc63d754=\"\"></date-picker> </span> 至 <span class=r _v-cc63d754=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-cc63d754=\"\"></date-picker> </span> </p> </div> </div> <div class=pledge-box1 _v-cc63d754=\"\"> <div class=Single-list-main _v-cc63d754=\"\"> <div class=\"relation-chart gujia-chart-wrap\" _v-cc63d754=\"\"> <div class=gujia-chart style=\"width:100%; height:400px\" _v-cc63d754=\"\"></div> </div> </div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-cc63d754=\"\"> <div class=binding-content _v-cc63d754=\"\"> <a class=binding-logo _v-cc63d754=\"\"></a> <div class=binding-text _v-cc63d754=\"\"> 立即绑定IBDATA账号<br _v-cc63d754=\"\">成为金融分析高手 </div> <div class=binding-bot _v-cc63d754=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-cc63d754=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-cc63d754=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-cc63d754=\"\"></div>";

/***/ },
/* 806 */
/***/ function(module, exports) {

	module.exports = "<div class=wrapper _v-d8437206=\"\"> <div v-show=loading class=page-loading style=width:100%;height:100%;position:fixed;top:0;left:0;background:#000000;z-index:10000;opacity:0.8 _v-d8437206=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-d8437206=\"\"> <img src=/static/images/loading.gif width=150 _v-d8437206=\"\"> </div> </div> <div class=search-header _v-d8437206=\"\"> <div class=search-header-text _v-d8437206=\"\">融资信息</div> </div> <div class=\"company-details-box dhy-box\" _v-d8437206=\"\"> <ul class=one-row-box _v-d8437206=\"\"> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\">证券简称</p> <p class=time _v-d8437206=\"\">{{ articleInfo.company.shortname | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\">证券代码</p> <p class=time _v-d8437206=\"\">{{ articleInfo.companycode | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\">融资人</p> <p class=time _v-d8437206=\"\">{{ articleInfo.name_of_shareholder | nullVal }}</p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\">融资期限</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.timelimit }} <template v-if=\"articleInfo.timelimit_unit == '月'\">个{{ articleInfo.timelimit_unit }}</template> <template v-if=\"articleInfo.timelimit_unit == '年'\">{{ articleInfo.timelimit_unit }}</template> </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 股份性质 </p> <p class=time _v-d8437206=\"\"> {{ articleInfo.nature | nullVal }} </p> </li> <li v-if=\"articleInfo.nature == '限售'\" _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 限售解禁期</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.restriction_end_date | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 股价（元）</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.stockprice | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 质押率（%）</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.pledgee_ratio | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 质押股数（万股） </p> <p class=time _v-d8437206=\"\"> {{ articleInfo.pledgee_nums | formatMoney | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 融资金额（万）</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.financing_amount | formatMoney | nullVal}} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 资金用途</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.use | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 还款来源</p> <p class=time _v-d8437206=\"\"> {{ articleInfo.repayment_source | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 添加日期 </p> <p class=time _v-d8437206=\"\"> {{ articleInfo.addtime | formatTime | nullVal }} </p> </li> <li _v-d8437206=\"\"> <p class=date _v-d8437206=\"\"> 更新日期 </p> <p class=time _v-d8437206=\"\"> {{ articleInfo.updtime | formatTime | nullVal }} </p> </li> </ul> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-d8437206=\"\"> <div class=binding-content _v-d8437206=\"\"> <a class=binding-logo _v-d8437206=\"\"></a> <div class=binding-text _v-d8437206=\"\"> 立即绑定IBDATA账号<br _v-d8437206=\"\">成为金融分析高手 </div> <div class=binding-bot _v-d8437206=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-d8437206=\"\">暂不绑定</a> <a class=binding-btn @click=\"goBindPage('x')\" _v-d8437206=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-d8437206=\"\"></div> </div>";

/***/ },
/* 807 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-dc397ff4=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-dc397ff4=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-dc397ff4=\"\"> <div class=loading-img _v-dc397ff4=\"\"></div> </div> </div> <div class=search-company-box _v-dc397ff4=\"\"> <div class=pledge-box1-top _v-dc397ff4=\"\"> <label class=el-radio _v-dc397ff4=\"\"> <span class=\"el-radio-input is-checked\" :class=\"{'is-checked': reporting}\" @click=\"reporting=true, curDateType = finance[0][0]\" _v-dc397ff4=\"\"> <span class=el-radio-inner _v-dc397ff4=\"\"></span> <input class=el-radio-original value=按报告期 type=radio _v-dc397ff4=\"\"> </span> <span class=el-radio-label _v-dc397ff4=\"\">按报告期</span> </label> <label class=el-radio _v-dc397ff4=\"\"> <span class=el-radio-input :class=\"{'is-checked': !reporting}\" @click=\"reporting=false, curDateType = yearList[0][0]\" _v-dc397ff4=\"\"> <span class=el-radio-inner _v-dc397ff4=\"\"></span> <input class=el-radio-original value=按年度 type=radio _v-dc397ff4=\"\"> </span> <span class=el-radio-label _v-dc397ff4=\"\">按年度</span> </label> <div class=Quarterly-Report _v-dc397ff4=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-dc397ff4=\"\"> {{ curDateType }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-dc397ff4=\"\"></span> </div> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; reporting\" _v-dc397ff4=\"\"> <li v-for=\"h in finance\" _v-dc397ff4=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-dc397ff4=\"\">{{ h[0] }}</a> </li> </ul> <ul class=menu-lanmu v-show=\"dateDropmenu &amp;&amp; !reporting\" _v-dc397ff4=\"\"> <li v-for=\"h in yearList\" _v-dc397ff4=\"\"> <a href=javascript:; v-if=\"curDateType != h[0]\" @click=\"clickDropmenu(), curDateType = h[0]\" _v-dc397ff4=\"\">{{ h[0] }}</a> </li> </ul> </div> </div> <div class=Single-list-main v-if=reporting _v-dc397ff4=\"\"> <ul class=Single-list-box _v-dc397ff4=\"\"> <li v-for=\"(key, val) in llb\" track-by=$index _v-dc397ff4=\"\"> <p class=date _v-dc397ff4=\"\">{{ key }}</p> <template v-for=\"v in finance\"> <p class=time v-if=\"v[0] == curDateType\" _v-dc397ff4=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> <div class=Single-list-main v-if=!reporting _v-dc397ff4=\"\"> <ul class=Single-list-box _v-dc397ff4=\"\"> <li v-for=\"(key, val) in llb\" track-by=$index _v-dc397ff4=\"\"> <p class=date _v-dc397ff4=\"\">{{ key }}</p> <template v-for=\"v in yearList\"> <p class=time v-if=\"v[0] == curDateType\" _v-dc397ff4=\"\"> {{ v[1][val] ? v[1][val] : '--' | money }} </p> </template> </li> </ul> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-dc397ff4=\"\"> <div class=binding-content _v-dc397ff4=\"\"> <a class=binding-logo _v-dc397ff4=\"\"></a> <div class=binding-text _v-dc397ff4=\"\"> 立即绑定IBDATA账号<br _v-dc397ff4=\"\">成为金融分析高手 </div> <div class=binding-bot _v-dc397ff4=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-dc397ff4=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-dc397ff4=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-dc397ff4=\"\"></div>";

/***/ },
/* 808 */
/***/ function(module, exports) {

	module.exports = "<div class=company-contain _v-e33d21da=\"\"> <div v-show=loading class=page-loading style=\"width:100%;height:100%;position:fixed;top:0;;background:#000000;z-index:10000;opacity:0.8; max-width: 640px\" _v-e33d21da=\"\"> <div class=loading-box style=\"box-sizing: content-box !important;position: absolute;z-index: 10001;margin: 0px; padding: 0px;top: 50%;left: 50%;text-align: center;transform: translate(-50%, -50%)\" _v-e33d21da=\"\"> <div class=loading-img _v-e33d21da=\"\"></div> </div> </div> <div class=search-company-box _v-e33d21da=\"\"> <div _v-e33d21da=\"\"> <div class=Quarterly-Report _v-e33d21da=\"\"> <div class=head-title @click.stop=showDateDropmemu($event) _v-e33d21da=\"\"> {{ datetype_name }} <span class=close-bot @click.stop=showDateDropmemu($event) _v-e33d21da=\"\"></span> </div> <ul class=menu-lanmu v-show=dateDropmenu _v-e33d21da=\"\"> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(1)\" _v-e33d21da=\"\">一个月</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(2)\" _v-e33d21da=\"\">一个季度</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(3)\" _v-e33d21da=\"\">半年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(4)\" _v-e33d21da=\"\">去年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(5)\" _v-e33d21da=\"\">今年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(6)\" _v-e33d21da=\"\">一年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(7)\" _v-e33d21da=\"\">两年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(8)\" _v-e33d21da=\"\">三年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(9)\" _v-e33d21da=\"\">五年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(10)\" _v-e33d21da=\"\">十年</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(98)\" _v-e33d21da=\"\">全部</a></li> <li _v-e33d21da=\"\"><a href=javascript:; @click=\"clickDropmenu(), changeDateType(99)\" _v-e33d21da=\"\">自定义</a></li> </ul> </div> <a class=cop-search-bot href=javascript:; @click=sharesChangeFilter() _v-e33d21da=\"\">查询</a> <div class=cop-date v-if=\"datetype == 99\" _v-e33d21da=\"\"> <p class=time _v-e33d21da=\"\"> <span class=l _v-e33d21da=\"\"> <date-picker :time.sync=startdate :option=datepicker.option :datetype.sync=datetype _v-e33d21da=\"\"></date-picker> </span> 至 <span class=r _v-e33d21da=\"\"> <date-picker :time.sync=enddate :option=datepicker.option :datetype.sync=datetype _v-e33d21da=\"\"></date-picker> </span> </p> </div> </div> <div class=Single-list-main style=\"display: block\" v-if=\"sharesChangeLists.length > 0\" _v-e33d21da=\"\"> <div class=swiper-container _v-e33d21da=\"\"> <div class=swiper-wrapper _v-e33d21da=\"\"> <div class=\"Single-list-box swiper-slide\" style=\"padding-bottom: 30px\" v-for=\"(index, h) in sharesChangeLists\" track-by=$index _v-e33d21da=\"\"> <ul _v-e33d21da=\"\"> <li class=list-w _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动股数</p> <p class=time _v-e33d21da=\"\">{{ h.change_the_number_of_shares | money}}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动前持股数</p> <p class=time _v-e33d21da=\"\">{{ h.the_number_of_shares_before_change | money}}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动后持股数</p> <p class=time _v-e33d21da=\"\">{{ h.the_number_of_shares_on_the_day | money}}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动比例(%)</p> <p class=time _v-e33d21da=\"\">{{ h.change_ratio }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">成交均价(元)</p> <p class=time _v-e33d21da=\"\">{{ h.average_transaction_price }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">币种</p> <p class=time _v-e33d21da=\"\">{{ h.currency_type }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">股份变动人姓名(默认为董监高姓名)</p> <p class=time _v-e33d21da=\"\">{{ h.change_in_name_of_person }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">职位</p> <p class=time _v-e33d21da=\"\">{{ h.position }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">董监高姓名</p> <p class=time _v-e33d21da=\"\">{{ h.dong_supervisor_high_name }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动人与董监高的关系</p> <p class=time _v-e33d21da=\"\">{{ h.relationship_between_changed_person_and_dong_supervisor_high }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动原因</p> <p class=time _v-e33d21da=\"\">{{ h.reason_for_change }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">股票类型</p> <p class=time _v-e33d21da=\"\">{{ h.stock_type | formatStockTyp}}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">填表日期</p> <p class=time _v-e33d21da=\"\">{{ h.form_date }}</p> </li> <li _v-e33d21da=\"\"> <p class=date _v-e33d21da=\"\">变动日期</p> <p class=time _v-e33d21da=\"\">{{ h.change_date }}</p> </li> </ul> </div> </div> <div class=swiper-pagination _v-e33d21da=\"\"></div> </div> </div> <div class=Single-list-main v-if=\"!sharesChangeLists.length &amp;&amp; !loading\" _v-e33d21da=\"\"> <div class=Block-trade-no _v-e33d21da=\"\">暂无数据</div> </div> </div> <div class=search-company-box v-if=\"sharesChangeLists.length > 0\" _v-e33d21da=\"\"> <h3 class=title _v-e33d21da=\"\">股权变动历史图</h3> <div class=Single-list-main _v-e33d21da=\"\"> <div class=relation-chart id=gqbd-chart-wrap style=\"padding: 10px 0\" _v-e33d21da=\"\"> <div id=gqbd-chart style=\"width:100%; height: 180px\" _v-e33d21da=\"\"></div> </div> </div> </div> </div> <div aria-hidden=false aria-labelledby=myModalLabel role=dialog tabindex=-1 id=dialog class=\"modal fade in\" v-show=tipGoBind _v-e33d21da=\"\"> <div class=binding-content _v-e33d21da=\"\"> <a class=binding-logo _v-e33d21da=\"\"></a> <div class=binding-text _v-e33d21da=\"\"> 立即绑定IBDATA账号<br _v-e33d21da=\"\">成为金融分析高手 </div> <div class=binding-bot _v-e33d21da=\"\"> <a class=binding-no-btn @click=\"tipGoBind = false\" _v-e33d21da=\"\">暂不绑定</a> <a class=binding-btn @click=goBindPage _v-e33d21da=\"\">立即绑定</a> </div> </div> </div> <div class=\"modal-backdrop fade in\" v-show=tipGoBind _v-e33d21da=\"\"></div>";

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_template__ = __webpack_require__(767)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(727)
	__vue_script__ = __webpack_require__(346)
	__vue_template__ = __webpack_require__(777)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(750)
	__vue_script__ = __webpack_require__(348)
	__vue_template__ = __webpack_require__(800)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(349)
	__vue_template__ = __webpack_require__(769)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(725)
	__vue_script__ = __webpack_require__(350)
	__vue_template__ = __webpack_require__(770)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(732)
	__vue_script__ = __webpack_require__(351)
	__vue_template__ = __webpack_require__(782)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(726)
	__vue_script__ = __webpack_require__(352)
	__vue_template__ = __webpack_require__(776)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(749)
	__vue_script__ = __webpack_require__(353)
	__vue_template__ = __webpack_require__(799)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(737)
	__vue_script__ = __webpack_require__(354)
	__vue_template__ = __webpack_require__(787)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(355)
	__vue_template__ = __webpack_require__(771)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(728)
	__vue_script__ = __webpack_require__(357)
	__vue_template__ = __webpack_require__(778)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(741)
	__vue_script__ = __webpack_require__(358)
	__vue_template__ = __webpack_require__(791)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(729)
	__vue_script__ = __webpack_require__(359)
	__vue_template__ = __webpack_require__(779)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(751)
	__vue_script__ = __webpack_require__(360)
	__vue_template__ = __webpack_require__(801)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(730)
	__vue_script__ = __webpack_require__(361)
	__vue_template__ = __webpack_require__(780)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(746)
	__vue_script__ = __webpack_require__(362)
	__vue_template__ = __webpack_require__(796)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(742)
	__vue_script__ = __webpack_require__(363)
	__vue_template__ = __webpack_require__(792)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(748)
	__vue_script__ = __webpack_require__(364)
	__vue_template__ = __webpack_require__(798)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(735)
	__vue_script__ = __webpack_require__(365)
	__vue_template__ = __webpack_require__(785)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(754)
	__vue_script__ = __webpack_require__(366)
	__vue_template__ = __webpack_require__(804)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(739)
	__vue_script__ = __webpack_require__(367)
	__vue_template__ = __webpack_require__(789)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(744)
	__vue_script__ = __webpack_require__(368)
	__vue_template__ = __webpack_require__(794)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(757)
	__vue_script__ = __webpack_require__(369)
	__vue_template__ = __webpack_require__(807)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(747)
	__vue_script__ = __webpack_require__(370)
	__vue_template__ = __webpack_require__(797)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(752)
	__vue_script__ = __webpack_require__(371)
	__vue_template__ = __webpack_require__(802)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(738)
	__vue_script__ = __webpack_require__(372)
	__vue_template__ = __webpack_require__(788)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(753)
	__vue_script__ = __webpack_require__(373)
	__vue_template__ = __webpack_require__(803)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(758)
	__vue_script__ = __webpack_require__(374)
	__vue_template__ = __webpack_require__(808)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(731)
	__vue_script__ = __webpack_require__(375)
	__vue_template__ = __webpack_require__(781)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(734)
	__vue_script__ = __webpack_require__(376)
	__vue_template__ = __webpack_require__(784)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(755)
	__vue_script__ = __webpack_require__(377)
	__vue_template__ = __webpack_require__(805)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(736)
	__vue_script__ = __webpack_require__(378)
	__vue_template__ = __webpack_require__(786)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(379)
	__vue_template__ = __webpack_require__(773)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(756)
	__vue_script__ = __webpack_require__(380)
	__vue_template__ = __webpack_require__(806)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(381)
	__vue_template__ = __webpack_require__(774)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(740)
	__vue_script__ = __webpack_require__(382)
	__vue_template__ = __webpack_require__(790)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(743)
	__vue_script__ = __webpack_require__(383)
	__vue_template__ = __webpack_require__(793)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__webpack_require__(745)
	__vue_script__ = __webpack_require__(384)
	__vue_template__ = __webpack_require__(795)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_script__, __vue_template__
	__vue_script__ = __webpack_require__(385)
	__vue_template__ = __webpack_require__(775)
	module.exports = __vue_script__ || {}
	if (module.exports.__esModule) module.exports = module.exports.default
	if (__vue_template__) {
	(typeof module.exports === "function" ? (module.exports.options || (module.exports.options = {})) : module.exports).template = __vue_template__
	}


/***/ }
]);


/** WEBPACK FOOTER **
 ** static/js/app.3f12991435bdd9c6b8e3.js
 **/